export const QUESTIONS = [
  {
    "id": 1,
    "question": "Which network architecture defines a strict access method for various hosts?",
    "choice_a": "Peer-to-peer",
    "choice_b": "Client-server",
    "choice_c": "LAN",
    "choice_d": "Hybrid topology",
    "correct_answer": "B",
    "explanation": "The client-server network architecture strictly defines hosts; clients access the information, and servers share the information. Peer-to-peer is a network architecture that allows the same host to both access and share resources in a network. Local area network (LAN) is a network type and not related to sharing information. Hybrid topology describes a topology that incorporates two or more topologies.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      5,
      2,
      3,
      1,
      15
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 2,
    "question": "You need to select a topology to connect two office locations, and you do not expect to add locations in the future. Which topology should you select?",
    "choice_a": "Point-to-point",
    "choice_b": "Point-to-multipoint",
    "choice_c": "Ring",
    "choice_d": "Bus",
    "correct_answer": "A",
    "explanation": "A point-to-point connection is typically used to connect two offices where expansion of locations is not a concern. A point-to-multipoint topology should be selected if an office needs to connect with several other office locations. Ring and bus are topologies and not used to describe WAN connectivity methods.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      9,
      11,
      4,
      15,
      8
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 3,
    "question": "Which protocol data unit (PDU) is used to describe the type of data being transmitted at the Presentation layer?",
    "choice_a": "Bits",
    "choice_b": "User datagrams",
    "choice_c": "Frames",
    "choice_d": "Segments",
    "correct_answer": "B",
    "explanation": "User datagrams are the protocol data units (PDUs) that describe data at the Presentation layer. Bits describe the data at the Physical layer. Frames describe the data at the Data Link layer. Segments describe the data at the Transport layer.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      81,
      82,
      18,
      23,
      72
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 4,
    "question": "Which layer is responsible for encryption and decryption?",
    "choice_a": "Application layer",
    "choice_b": "Physical layer",
    "choice_c": "Session layer",
    "choice_d": "Presentation layer",
    "correct_answer": "D",
    "explanation": "The Presentation layer is responsible for encryption and decryption, as well as compression and decompression. The Application layer is responsible for application programming interface (API) access and beginning the network communication process. The Physical layer is responsible for transmitting data over light, electricity, and air waves. The Session layer is responsible for setting up the dialogue between two hosts.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      18,
      82,
      81,
      19,
      72
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 5,
    "question": "You need to run a UTP cable for 10 Gbps speeds with a distance of 40 meters. Which minimum cable category rating should you use?",
    "choice_a": "Category 5",
    "choice_b": "Category 5e",
    "choice_c": "Category 6",
    "choice_d": "Category 3",
    "correct_answer": "C",
    "explanation": "Category 6 is capable of 10 Gbps up to a maximum distance of 55 meters. Category 5 is capable of speeds of 100 Mbps at a distance of 100 meters. Category 5e is capable of 1 Gbps at a distance of 100 meters. Category 3 is only capable of a maximum speed of 10 Mbps.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      26,
      46,
      31,
      47,
      44
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 6,
    "question": "Which term describes the path of signaling on a network cable?",
    "choice_a": "Attenuation",
    "choice_b": "Duplex",
    "choice_c": "Demarcation",
    "choice_d": "EMI",
    "correct_answer": "B",
    "explanation": "Duplex refers to the path of signaling on a network cable. Attenuation is the degrading of signal as the cable length increased. Demarcation, or demarc, refers to the point of responsibility for a network provider. Electromagnetic interference (EMI) is interference that is induced into a network cable from an external source.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      31,
      26,
      25,
      33,
      44
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 7,
    "question": "You are working with a contractor as they are pulling and terminating fiber-optic lines. The fiber-optic lines will be located in the center of your production line. Which cable ends should you recommend that will reduce the chances of cables becoming loose from vibration on the production floor?",
    "choice_a": "SC connectors",
    "choice_b": "ST connectors",
    "choice_c": "LC connectors",
    "choice_d": "MTRJ connectors",
    "correct_answer": "B",
    "explanation": "The straight-tip (ST) connector is the best choice for an installation near vibration sources. The SC connector is a square connector often used for multimode cable. The ST connector has a spring-loaded detent that resists vibrations and positively locks. Although LC and MTRJ connectors have detent mechanisms, the ST has a spring-loaded detent to ensure that it does not come loose.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      310,
      361,
      358,
      307,
      323
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 8,
    "question": "Which is NOT a common cause for LAN congestion?",
    "choice_a": "Broadcasts",
    "choice_b": "Multicasts",
    "choice_c": "Adding switches for connectivity",
    "choice_d": "Multiple hubs for connectivity",
    "correct_answer": "C",
    "explanation": "Broadcasts, multicasts, and multiple hubs for connectivity are all common causes of LAN congestion. Adding switches for connectivity has no direct relationship to LAN congestion, since switches create collision domains and raise effective bandwidth.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      355,
      317,
      353,
      313,
      176
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 9,
    "question": "The receiving computer checked the checksum of a frame. It had been damaged during transfer, so it is discarded. At which layer of the OSI did this occur?",
    "choice_a": "Physical",
    "choice_b": "Data Link",
    "choice_c": "Network",
    "choice_d": "Session",
    "correct_answer": "B",
    "explanation": "The Data Link layer is responsible for checking the frame check sequence (FCS), which is a checksum of the frame. The Physical layer is responsible for transmitting data through electricity, light, or air. The Network layer is responsible for logical addressing and routing of data. The Session layer is responsible for dialogue control.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      22,
      43,
      81,
      82,
      23
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 10,
    "question": "What is a reason a network administrator would segment a network with a switch?",
    "choice_a": "Create more broadcast domains",
    "choice_b": "Create isolation of ARP messages",
    "choice_c": "Create fewer collision domains",
    "choice_d": "Isolate traffic between segments",
    "correct_answer": "D",
    "explanation": "A switch creates micro-segmentation, which in turn isolates traffic between two talking computers from other computers that are not part of the communications. This in turn increases bandwidth for the computers that are not part of the communications between the two talking computers. The creation of broadcast domains can only be achieved with the addition of VLANs and a router. The isolation of address resolution protocol (ARP) messages can be achieved only by the creation of broadcast domains. Segmentation with a switch will create more collision domains, not fewer collision domains.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      53,
      66,
      150,
      71,
      155
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 11,
    "question": "According to best practices, what is the proper placement of a firewall?",
    "choice_a": "Only between the internal network and the Internet",
    "choice_b": "At key security boundaries",
    "choice_c": "In the DMZ",
    "choice_d": "Only between the DMZ and the Internet",
    "correct_answer": "B",
    "explanation": "Firewalls should always be placed at key security boundaries, which can be the Internet and your internal network. However, proper placement is not exclusive to the boundaries of the Internet and internal networks. For example, it could be placed between two internal networks, such as R&D and guest networks. The demilitarized zone (DMZ), now also referred to as a screened subnet, is a segment of a firewall where Internet-facing services are placed. Firewalls are normally not placed only between the DMZ and the Internet because most networks have an internal network.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      396,
      395,
      400,
      401,
      393
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 12,
    "question": "Which is the contention method 802.11 wireless uses?",
    "choice_a": "CSMA/CA",
    "choice_b": "CSMA/CD",
    "choice_c": "DSSS",
    "choice_d": "OFDM",
    "correct_answer": "A",
    "explanation": "802.11 uses a contention method of Carrier Sense Multiple Access/Collision Avoidance (CSMA/CA). 802.11 implements a Request-to-Send/Clear-to-Send mechanism that avoids collisions. Ethernet uses a contention method of Carrier Sense Multiple Access/Collision Detection (CSMA/CD). Both Direct-Sequence Spread Spectrum (DSSS) and Orthogonal Frequency Division Multiplexing (OFDM) are wireless modulations used to transmit data.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      57,
      183,
      186,
      207,
      187
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 13,
    "question": "What form of communication does a DHCP client use to initially acquire an IP address?",
    "choice_a": "Layer 3 broadcast",
    "choice_b": "Layer 3 multicast",
    "choice_c": "Layer 3 802.1Q",
    "choice_d": "Layer 3 unicast",
    "correct_answer": "A",
    "explanation": "DHCP uses layer 3 broadcasts by sending packets to 255.255.255.255 for initial DHCP discovery. Layer 3 multicast is not used for DHCP clients. Layer 3 802.1Q is an incorrect answer because 802.1Q is used for switch trunks. Layer 3 unicasts are the form of communication clients use after obtaining an IP address.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      75,
      88,
      83,
      21,
      79
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 14,
    "question": "Which management access method should be configured on network devices for encryption of a session?",
    "choice_a": "RADIUS",
    "choice_b": "HTTP",
    "choice_c": "SSH",
    "choice_d": "SFTP",
    "correct_answer": "C",
    "explanation": "Secure Shell (SSH) is a secure console emulation method for the administration of network devices. It allows for both the sender and receiver to create an encrypted session so data cannot be intercepted. Remote Authentication Dial-In User Service (RADIUS) is a protocol that authenticates users, and it does not provide encryption. Hypertext Transfer Protocol (HTTP) is a method for relaying Hypertext Markup Language (HTML) from a server to a requesting host; it does not provide encryption. SSH File Transfer Protocol (SFTP) is a protocol that provides encryption for file transfers, but it does not provide management access.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      214,
      217,
      213,
      210,
      228
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 15,
    "question": "Which Microsoft remote access protocol allows for local drives to be presented to the remote system?",
    "choice_a": "VNC",
    "choice_b": "RDP",
    "choice_c": "SSH",
    "choice_d": "Telnet",
    "correct_answer": "B",
    "explanation": "Remote Desktop Protocol (RDP) allows for local drives to be available to the remote machine when an RDP session is initiated. Virtual Network Computing (VNC), Secure Shell (SSH), and Telnet are not capable of redirecting drives.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      74,
      73,
      18,
      77,
      83
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 16,
    "question": "Which protocol and port number does Syslog use?",
    "choice_a": "UDP/161",
    "choice_b": "TCP/162",
    "choice_c": "UDP/162",
    "choice_d": "UDP/514",
    "correct_answer": "D",
    "explanation": "The router or switch sends Syslog messages to the Syslog server on port 514 with UDP. SNMP agents listen on UDP/161. SNMP does not use TCP for messaging. SNMP sends traps on UDP/162.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      78,
      77,
      75,
      76,
      82
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 17,
    "question": "Which of the following is the Class B network IP range?",
    "choice_a": "1\u2013126",
    "choice_b": "1\u2013127",
    "choice_c": "128\u2013191",
    "choice_d": "192\u2013224",
    "correct_answer": "C",
    "explanation": "The IP range for a Class B network is 128\u2013191. Class B addressing provides 16 bits of network addressing and 16 bits of host addressing by default.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      85,
      103,
      99,
      84,
      86
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 18,
    "question": "Which is true of the IP address 135.20.255.255?",
    "choice_a": "It is a Class A address.",
    "choice_b": "It is a broadcast address.",
    "choice_c": "It is the default gateway address.",
    "choice_d": "It has a default mask of 255.0.0.0.",
    "correct_answer": "B",
    "explanation": "The IP address 135.20.255.255 is a Class B broadcast address. It is not a Class A address, nor is it the default gateway address. The default mask of a Class B address is 255.255.0.0.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      85,
      103,
      87,
      99,
      113
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 19,
    "question": "What is a major reason to use private IP addressing?",
    "choice_a": "It allows for the conservation of public IP addresses.",
    "choice_b": "Since private IP addresses are non-routable on the Internet, they are secure.",
    "choice_c": "It keeps communications private.",
    "choice_d": "It allows easier setup than public IP addresses.",
    "correct_answer": "A",
    "explanation": "The private IP address space was created to preserve the number of public IP addresses. Private IP addresses are non-routable on the Internet, but this does not make them secure. Private IP addresses do not keep communications private, as their name implies. Private IP addresses are not publicly addressable for communications. Private IP addresses do not allow for an easier setup than public IP addresses.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      86,
      116,
      99,
      85,
      103
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 20,
    "question": "What is required when using private IP addresses to communicate with Internet hosts?",
    "choice_a": "Internet router",
    "choice_b": "IPv4 tunnel",
    "choice_c": "VPN tunnel",
    "choice_d": "Network Address Translation",
    "correct_answer": "D",
    "explanation": "Network Address Translation (NAT) is required to communicate over the public Internet with private IP addresses. Although Internet routers are required for routing, by default they will not route private IP addresses to public IP addresses. An IPv4 tunnel or VPN tunnel is not required for communications on the Internet with private IP addresses.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      116,
      86,
      287,
      99,
      79
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 21,
    "question": "Which routing protocol is a true link-state protocol?",
    "choice_a": "RIP",
    "choice_b": "OSPF",
    "choice_c": "RIPv2",
    "choice_d": "EIGRP",
    "correct_answer": "B",
    "explanation": "Open Shortest Path First (OSPF) is a true link-state protocol. Routing Information Protocol (RIP) and RIPv2 are both distance vector protocols. Enhanced Interior Gateway Routing Protocol (EIGRP) is a hybrid routing protocol that combines the best of distance vector and link-state attributes.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      143,
      142,
      131,
      140,
      144
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 22,
    "question": "Why are there dashes in the age field of the following output?<br><img src=\"/question_assets/Network+/assessment_test1.png\"/><br>",
    "choice_a": "The ARP entry is stale.",
    "choice_b": "The ARP entry is invalid.",
    "choice_c": "These are physical interfaces.",
    "choice_d": "There are virtual interfaces.",
    "correct_answer": "C",
    "explanation": "Each Address Resolution Protocol (ARP) entry has a defined time-to-live in the ARP cache. However, physical interfaces are permanently added to the ARP cache, and they are signified with a dash under the age column. When ARP entries are stale, the entry will be removed from the ARP cache. If an ARP entry is invalid, it will be removed from the ARP cache.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      79,
      112,
      36,
      22,
      81
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 23,
    "question": "What is the definition of route statement AD?",
    "choice_a": "The AD is a metric that routing protocols use to select the best route.",
    "choice_b": "The AD is a value assigned by network administrators for route selection.",
    "choice_c": "The AD is a rating of trust when multiple routes exist to the same destination.",
    "choice_d": "The AD is a value associated with the cost to the destination.",
    "correct_answer": "C",
    "explanation": "The administrative distance (AD) is a rating of trust between different routing protocols and route methods. This trust scale is important when multiple routes exist to the same destination. Directly connected routes have administrative distances (ADs) with the highest level of trust. Route statements populated by the same dynamic routing protocol will be calculated for the best route upon their metric and not their administrative distance. The administrative distance is not assigned by the administrator for route selection. The administrative distance value is not associated with the cost to the destination, only the trust of a route statement.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      133,
      137,
      131,
      120,
      142
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 24,
    "question": "You perform a <code>show ip route</code> on the router and see several routes with an AD of 90. Which routing protocol has generated these route statements?",
    "choice_a": "IGRP",
    "choice_b": "OSPF",
    "choice_c": "EIGRP",
    "choice_d": "RIP",
    "correct_answer": "C",
    "explanation": "The administrative distance (AD) of Enhanced Interior Gateway Routing Protocol (EIGRP) is 90. The most common ADs are 90 for EIGRP, 100 for IGRP, 110 for OSPF, and 120 for RIP. The mnemonic of 90 Exotic Indian Oval Rubies will help you remember the order; then starting with EIGRP with a value of 90, increment the following values by 10.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      133,
      140,
      137,
      119,
      142
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 25,
    "question": "Which routing protocol uses path-vector metrics?",
    "choice_a": "BGP",
    "choice_b": "RIP",
    "choice_c": "OSPF",
    "choice_d": "EIGRP",
    "correct_answer": "A",
    "explanation": "Border Gateway Protocol (BGP) is a path-vector routing protocol. Routing Information Protocol (RIP) is a distance-vector routing protocol. Open Shortest First Path (OSPF) is a link-state protocol. Enhanced Interior Gateway Routing Protocol (EIGRP) is considered a hybrid protocol, incorporating both distance-vector and link-state mechanisms.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      141,
      131,
      140,
      137,
      138
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 26,
    "question": "Which protocol replaces ARP in IPv6?",
    "choice_a": "NDP",
    "choice_b": "ARPv6",
    "choice_c": "GRE",
    "choice_d": "RA",
    "correct_answer": "A",
    "explanation": "The Address Resolution Protocol (ARP) in IPv6 has been replaced with Network Discovery Protocol (NDP). The NDP protocol uses neighbor solicitation (NS) and neighbor advertisements (NA) to learn neighbors in lieu of ARP broadcasts. ARPv6 is not a real protocol and therefore an invalid answer. Generic Router Encapsulation (GRE) is a tunneling protocol for other network protocols. A router advertisement (RA) packet is returned from the gateway so the host learns the gateway address.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      94,
      98,
      95,
      58,
      224
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 27,
    "question": "Which VTP mode will not allow the switch to participate in VTP traffic but will forward VTP traffic?",
    "choice_a": "Server mode",
    "choice_b": "Transparent mode",
    "choice_c": "Proxy mode",
    "choice_d": "Client mode",
    "correct_answer": "B",
    "explanation": "A switch in VTP transparent mode will not participate in VTP. However, if the VTP is v2, the switch will forward and receive VTP advertisements. The VTP server mode allows the switch to act as a master for the VTP domain. VTP proxy mode is not a real mode; therefore, it is incorrect. The VTP client mode allows the switch to act as a slave to the master server.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      167,
      162,
      157,
      168,
      153
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 28,
    "question": "Which protocol is a Cisco proprietary protocol used for trunking switches?",
    "choice_a": "ISL",
    "choice_b": "802.1Q",
    "choice_c": "VTP",
    "choice_d": "CDP",
    "correct_answer": "A",
    "explanation": "Inter-Switch Link (ISL) is a proprietary protocol used for the trunking of switches. If you need to connect non-Cisco switches to a Cisco switch, you must use 802.1Q, the IEEE standard. VTP is not a trunking protocol; it assists in populating VLANs across Cisco switches for conformity and ease of configuration. Cisco Discovery Protocol (CDP) is not a trunking protocol either; it negotiates power by communicating its capabilities with neighboring devices. It also allows for neighbor discovery, but CDP is proprietary to Cisco, so only Cisco devices can communicate.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      173,
      167,
      157,
      179,
      53
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 29,
    "question": "Which technology will give selective access to the network based upon authentication?",
    "choice_a": "802.1Q",
    "choice_b": "ACLs",
    "choice_c": "802.1X",
    "choice_d": "Firewall",
    "correct_answer": "C",
    "explanation": "802.1X allows selective access to a network at layer 2. It allows this on the switch because the switch acts as an authenticator to an AAA server, only allowing access after the user or device has been authenticated. 802.1Q is a trunking protocol used for transporting multiple VLANs over a layer 2 connection, and it does not provide authentication. An access control list (ACL) is a condition and action statement used to allow, deny, or log traffic. Firewalls contain ACLs and policies to allow, deny, and log traffic, but normally firewalls will not authenticate traffic.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      211,
      55,
      244,
      242,
      209
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 30,
    "question": "How many non-overlapping channels are available with 802.11a?",
    "choice_a": "3",
    "choice_b": "12",
    "choice_c": "23",
    "choice_d": "40",
    "correct_answer": "B",
    "explanation": "The IEEE 802.11a standard provides up to 12 non-overlapping channels, or up to 23 if you add the 802.11h standard. All other answers are incorrect.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      184,
      183,
      207,
      186,
      196
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 31,
    "question": "What is the maximum data rate for the 802.11a standard?",
    "choice_a": "6 Mbps",
    "choice_b": "11 Mbps",
    "choice_c": "22 Mbps",
    "choice_d": "54 Mbps",
    "correct_answer": "D",
    "explanation": "The IEEE 802.11a standard provides a maximum data rate of up to 54 Mbps. All other answers are incorrect.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      186,
      184,
      207,
      183,
      187
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 32,
    "question": "What is a benefit of site-to-site IPsec VPNs?",
    "choice_a": "Lower bandwidth requirements",
    "choice_b": "Lower latency",
    "choice_c": "Scalability",
    "choice_d": "Support for multicast",
    "correct_answer": "C",
    "explanation": "Site-to-site IPsec VPNs offer scalability as a benefit. This is because each remote office only needs an Internet connection to create a VPN tunnel back to the main office. There is a certain overhead when using a VPN; therefore, higher bandwidth requirements may exist after deploying site-to-site IPsec VPNs. Latency is affected and will be higher due to the level of encryption each packet must undergo as it passes through the site-to-site VPN. Support for multicast is not a common benefit of site-to-site IPsec VPNs.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      368,
      381,
      374,
      367,
      396
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 33,
    "question": "Which cable should you use to connect to a serial port on a router?",
    "choice_a": "Cat 5e",
    "choice_b": "Rolled cable",
    "choice_c": "PuTTY cable",
    "choice_d": "SMF",
    "correct_answer": "B",
    "explanation": "A rolled cable is used to create a serial connection from the PC to the router for configuration. A Cat 5e cable is used for Ethernet connectivity. There is no such thing as a PuTTY cable, but PuTTY is a terminal emulation program used with a serial cable. Single-mode fiber (SMF) is a type of fiber-optic cable that can span long distances.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      34,
      30,
      31,
      28,
      74
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 34,
    "question": "What type of SNMP message is sent from the NMS to the agent to request information?",
    "choice_a": "Get-request message",
    "choice_b": "Get-response message",
    "choice_c": "Set-request message",
    "choice_d": "Trap message",
    "correct_answer": "A",
    "explanation": "The get-request message is used by a network management station (NMS) to request information from an SNMP agent. The get-response message is the message sent back from the client to the NMS after a get-request message is received. The set-request message is sent by the NMS to the SNMP client requesting a specific writable counter be set to the specified value. Trap messages are sent from the network device to the SNMP network management station when an event has triggered over a set threshold on the device.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      227,
      226,
      228,
      229,
      224
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 35,
    "question": "What protocol provides detailed information on traffic flows between endpoints?",
    "choice_a": "Syslog",
    "choice_b": "SNMP",
    "choice_c": "NetFlow",
    "choice_d": "SPAN",
    "correct_answer": "C",
    "explanation": "The NetFlow standard provides session information including the source and destination addresses, applications, and traffic volume. Syslog is a method of collecting system messages to identify problems or it can be used for post-mortem analysis. Simple Network Management Protocol (SNMP) is a protocol used to capture performance statistics of servers, applications, and network devices. Switched Port Analyzer (SPAN) is used to mirror port traffic.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      231,
      226,
      227,
      225,
      230
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 36,
    "question": "You are contracting with a new service provider and are reviewing their service level agreement (SLA). The SLA states that their commitment to uptime is 99%. What is the expected downtime per year?",
    "choice_a": "3.65 days",
    "choice_b": "8.76 hours",
    "choice_c": "52.56 minutes",
    "choice_d": "5.29 minutes",
    "correct_answer": "A",
    "explanation": "An SLA of two nines is 3.65 days per year of expected downtime. This equates to 7.2 hours per month that the service can be down. All other answers are incorrect.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      258,
      225,
      255,
      269,
      272
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 37,
    "question": "You need to make sure that users do not reuse passwords when their password expires and they are required to change it? In which of the following would you require the change?",
    "choice_a": "BYOD",
    "choice_b": "Password policy",
    "choice_c": "DLP",
    "choice_d": "AUP",
    "correct_answer": "B",
    "explanation": "A password policy defines the life, complexity, history, and complexity of passwords in the organization. A bring-your-own-device (BYOD) policy defines how personal devices can be used in the organization. Data loss prevention (DLP) software attempts to prevent data leakage. It does this by maintaining awareness of actions that can and cannot be taken with respect to a document. An acceptable use policy (AUP) defines the acceptable use of organizational resources.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      243,
      242,
      247,
      250,
      237
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 38,
    "question": "Which of the following is a measure of how long it will take to restore your data before the deletion or failure?",
    "choice_a": "RTO",
    "choice_b": "MTBF",
    "choice_c": "RPO",
    "choice_d": "MTTR",
    "correct_answer": "A",
    "explanation": "The recovery time objective (RTO) is how long it takes to recover your data back to the recovery point objective (RPO). The RPO is a measurement of time from a failure, disaster, or comparable loss-causing event. RPOs measure back in time to when your data was preserved in a usable format, usually to the most recent backup. The mean time between failures (MTBF) is an average time between failures. The mean time to repair (MTTR) is the average time it takes for a vendor to repair a failure.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      278,
      277,
      272,
      258,
      268
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 39,
    "question": "A recovery from tape will take 4 hours; what is this an example of?",
    "choice_a": "The recovery point objective (RPO)",
    "choice_b": "The recovery time objective (RTO)",
    "choice_c": "GFS rotation",
    "choice_d": "Backup window",
    "correct_answer": "B",
    "explanation": "The recovery time objective (RTO) is a measurement of how quickly you can recover from data loss using backup. The recovery point objective (RPO) is the point in time to which you can recover in the event of a disaster. The grandfather, father, son (GFS) rotation is a systematic way to archive backup media. The backup window is the window of time in which a backup can be performed.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      278,
      277,
      272,
      239,
      268
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 40,
    "question": "Which cloud service is likely to be used for software development?",
    "choice_a": "SaaS",
    "choice_b": "IaaS",
    "choice_c": "PaaS",
    "choice_d": "DRaaS",
    "correct_answer": "C",
    "explanation": "Platform as a service (PaaS) is commonly used by software developers. It provides a development platform that the software developer can use to create applications. An example of this is a web server with PHP and MySQL, which is hosted in the cloud. Software as a service (SaaS) is a software product similar to email or social networking software in which you use the software provided as a service. Infrastructure as a service (IaaS) allows you to rent infrastructure such as virtual machines (VMs), virtual networks, or even DNS, just to name a few. Disaster recovery as a service (DRaaS) is another popular service; you can rent storage and compute power to facilitate a disaster recovery site.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      284,
      281,
      302,
      291,
      288
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 41,
    "question": "On which network plane would a routing protocol perform?",
    "choice_a": "Data plane",
    "choice_b": "Control plane",
    "choice_c": "Management plane",
    "choice_d": "Routing plane",
    "correct_answer": "B",
    "explanation": "Routing protocols such as OSPF and EIGRP would perform their function on the control plane since they are controlling the routing of the data plane. The data plane is responsible for switching and routing data. Any data that is destined for endpoints is switched or routed on the data plane. The management plane is any mechanism that helps in the management of a router or switch. <i>Routing plane</i> is not a term normally used to describe data types; therefore, option D is an invalid answer.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      142,
      143,
      131,
      68,
      119
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 42,
    "question": "What is the next step in problem solving once a theory is confirmed?",
    "choice_a": "Create a hypothesis.",
    "choice_b": "Consider multiple approaches.",
    "choice_c": "Establish a plan of action.",
    "choice_d": "Approach multiple problems individually.",
    "correct_answer": "C",
    "explanation": "After a theory or hypothesis is confirmed, you should establish a plan of action to resolve the problem. The creation of a hypothesis is a step in the establishment of a probable cause. Considering multiple approaches is done during the establishment of a theory. Approaching multiple problems individually is done in the initial identification of the problem in the troubleshooting methodology.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      322,
      311,
      318,
      319,
      305
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 43,
    "question": "What is the final step in resolving a problem in the troubleshooting methodology?",
    "choice_a": "Implement a solution.",
    "choice_b": "Validate a theory.",
    "choice_c": "Establish a plan of action.",
    "choice_d": "Document.",
    "correct_answer": "D",
    "explanation": "The documentation of the finding, actions, and outcomes, and lessons learned throughout the process is the final step in the resolution of a problem in the troubleshooting methodology. It allows us to solve future problems more quickly. Implementing a solution, validating a theory, and establishing a plan of action all precede the final steps in resolving a problem.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      322,
      311,
      318,
      312,
      319
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 44,
    "question": "Which software tool will allow you to check if a web application running on a server is online?",
    "choice_a": "<code>ping</code>",
    "choice_b": "<code>nslookup</code>",
    "choice_c": "<code>tracert/traceroute</code>",
    "choice_d": "Port scanner",
    "correct_answer": "D",
    "explanation": "A port scanner, such as the Nmap utility, will allow you to check if an application is accepting connections. The port will return an open status, and most port scanners will check for an HTTP response. The <code>ping</code> utility will check only if the server is online. The <code>nslookup</code> utility will allow you to resolve a domain name to an IP address and vice versa. The <code>tracert</code>/<code>traceroute</code> command will allow you to watch a packet as it traverses a network path to its destination.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      325,
      342,
      328,
      335,
      329
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 45,
    "question": "You need to check the configured maximum transmission unit (MTU) on the interface of a Linux host; which command should you use?",
    "choice_a": "<code>ipconfig</code>",
    "choice_b": "<code>ifconfig</code>",
    "choice_c": "<code>mtuconfig</code>",
    "choice_d": "<code>iptables</code>",
    "correct_answer": "B",
    "explanation": "The <code>ifconfig</code> command will allow you to inspect the MTU on the interface of a Linux host. It will also allow you to change the MTU temporarily. The <code>ipconfig</code> command is a Windows operating system command. The command of <code>mtuconfig</code> is not a real command. The <code>iptables</code> command is an incorrect answer for this question.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      332,
      333,
      331,
      353,
      362
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 46,
    "question": "Which tool allows examination at the packet level for traffic from an application?",
    "choice_a": "Protocol analyzer",
    "choice_b": "<code>dig</code>",
    "choice_c": "Spectrum analyzer",
    "choice_d": "<code>nslookup</code>",
    "correct_answer": "A",
    "explanation": "A protocol analyzer will allow us to inspect packet levels of traffic that is captured from an application. The <code>dig</code> and <code>nslookup</code> commands are used to perform DNS name resolution. A spectrum analyzer is used to view the radio frequency (RF) spectrum and is not a valid answer.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      230,
      231,
      225,
      228,
      226
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 47,
    "question": "Which protocol combines both the authentication and accounting into one TCP packet on port 49?",
    "choice_a": "TACACS+",
    "choice_b": "RADIUS",
    "choice_c": "TLS",
    "choice_d": "LDAP",
    "correct_answer": "A",
    "explanation": "TACACS+ combines both authentication and accounting into one TCP packet on port 49. RADIUS uses UDP port 1812 for authentication and port 1813 for accounting. Transport Layer Security (TLS) uses TCP port 443 but does not provide authentication or authorization. LDAP queries Active Directory on TCP port 389, but Kerberos is what authenticates users.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      203,
      78,
      77,
      19,
      82
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 48,
    "question": "Which factor of authentication requires you to present something that you have?",
    "choice_a": "Password",
    "choice_b": "Signature",
    "choice_c": "Fingerprint",
    "choice_d": "Token",
    "correct_answer": "D",
    "explanation": "Token-based authentication requires you to have a hardware or software token to authenticate. A password is something that you know. A signature is something that you do. Your fingerprint is an example of something that you are, because it is unique to you.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      371,
      372,
      374,
      370,
      377
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 49,
    "question": "A junior administrator comes to you in a panic. After looking at the log files, he has become convinced that an attacker is attempting to use a legitimate IP address to disrupt access elsewhere on the network. Which type of attack is this?",
    "choice_a": "Spoofing",
    "choice_b": "Social engineering",
    "choice_c": "Worm",
    "choice_d": "Password",
    "correct_answer": "A",
    "explanation": "A spoofing attack is an attempt by someone or something to masquerade as someone else (IP address) and is often used to disrupt access. Social engineering is a process in which an attacker attempts to acquire information about your network and system by social means, such as talking to people in the organization. Worms reproduce and move throughout the network to infect other systems. Password attacks are used in an attempt to guess passwords.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      383,
      384,
      405,
      388,
      382
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 50,
    "question": "You\u2019re the administrator for a large bottling company. At the end of each month, you routinely view all logs and look for discrepancies. This month, your email system error log reports a large number of unsuccessful attempts to log in. It\u2019s apparent that the email server is being targeted. Which type of attack is most likely occurring?",
    "choice_a": "Brute-force",
    "choice_b": "Backdoor",
    "choice_c": "Worm",
    "choice_d": "IP spoofing",
    "correct_answer": "A",
    "explanation": "A brute-force attack is a type of password attack in which a password is guessed over and over until the right password is guessed. A backdoor attack is an embedded account that allows unauthorized access through an unpatched coding hole. A worm is different from a virus in that it can reproduce itself, is self-contained, and doesn\u2019t need a host application to be transported. IP spoofing is an attack where the threat actor impersonates an IP address to attack a victim.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      386,
      363,
      392,
      370,
      365
    ],
    "source": "235605_AssessmentTest"
  },
  {
    "id": 51,
    "question": "Which is a benefit to using a mesh topology?",
    "choice_a": "Equal access",
    "choice_b": "Simplicity",
    "choice_c": "Easy to troubleshoot",
    "choice_d": "Redundancy",
    "correct_answer": "C",
    "explanation": "A benefit to the start topology is that it is easy to troubleshoot, since each host has their own connection. Equal access is typically a benefit of ring topologies. Bus topologies are typically the simplest network in terms of design; star networks can have redundancy, loops, and many other complex design considerations. Redundancy is not found in star topologies; it is typically in mesh networks.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      11,
      7,
      10,
      15
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 52,
    "question": "Which network topology is a combination of two or more network topologies?",
    "choice_a": "Bus",
    "choice_b": "Star",
    "choice_c": "Mesh",
    "choice_d": "Hybrid",
    "correct_answer": "D",
    "explanation": "A hybrid topology is a popular topology that combines two or more network topologies. Bus, star, and mesh topologies employ a single topology. Mesh is common to find integrated into hybrid topologies for redundancy, but it is considered a single topology on its own.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      10,
      7,
      8,
      11,
      15
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 53,
    "question": "Virtualized routers, switches, and firewalls are all examples of?",
    "choice_a": "VM",
    "choice_b": "vNIC",
    "choice_c": "NFV",
    "choice_d": "vSwitch",
    "correct_answer": "C",
    "explanation": "Routers, switches, and firewalls are all examples of network function virtualization (NFV). Although firewalls and routers may be deployed as virtual machines (VMs), virtual switches (vSwitches) are typically built into the hypervisor. A virtual NIC (vNIC) is a piece of software in the hypervisor that emulates a physical NIC in the VM.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      285,
      14,
      16,
      282,
      301
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 54,
    "question": "Which OSI layer is responsible for connection-oriented communication?",
    "choice_a": "Transport layer",
    "choice_b": "Presentation layer",
    "choice_c": "Data Link layer",
    "choice_d": "Application layer",
    "correct_answer": "A",
    "explanation": "Connection-oriented communication happens at the Transport layer with TCP. TCP uses a three-way handshake to establish a connection. The Presentation layer is responsible for compression and decompression, as well as encryption and decryption. The Data Link layer is responsible for the framing of data and the physical addressing of local nodes. The Application layer is responsible for API access and beginning the network communication process.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      19,
      77,
      17,
      20,
      83
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 55,
    "question": "Which protocol data unit (PDU) is used to describe the type of data being transmitted at the Session layer?",
    "choice_a": "Bits",
    "choice_b": "User datagrams",
    "choice_c": "Frames",
    "choice_d": "Segments",
    "correct_answer": "B",
    "explanation": "User datagrams are the protocol data units (PDUs) that describe data at the Session layer. Bits describe the data at the Physical layer. Frames describe the data at the Data Link layer. Segments describe the data at the Transport layer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      81,
      82,
      18,
      19,
      72
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 56,
    "question": "Which can be found at the Data Link layer?",
    "choice_a": "ICMP",
    "choice_b": "802.2",
    "choice_c": "TCP",
    "choice_d": "IP",
    "correct_answer": "B",
    "explanation": "The Data Link layer consists of two sublayers: 802.2 Logical Link Control (LLC) and the 802.3 MAC layer. The Internet Control Message Protocol (ICMP) operates at the Network layer. The Transmission Control Protocol (TCP) operates at the Transport layer. The Internet Protocol (IP) operates at the Network layer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      43,
      81,
      38,
      40
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 57,
    "question": "You need to connect a computer to a switch. Which type of cable should you use to properly create the connection?",
    "choice_a": "Straight-through cable",
    "choice_b": "Rolled cable",
    "choice_c": "Crossover cable",
    "choice_d": "T1 crossover cable",
    "correct_answer": "A",
    "explanation": "A straight-through cable is the proper cable to connect a computer to a switch. A rolled cable is used for serial connectivity to the switch. A crossover cable is used to connect a switch to a switch, or router to another router. A T1 crossover cable is used to connect a router to a router via T1 serial lines.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      33,
      26,
      31,
      30,
      45
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 58,
    "question": "You need to design a network in an area that could have some EMI. Which cable type should be used?",
    "choice_a": "Category 5e",
    "choice_b": "UTP",
    "choice_c": "STP",
    "choice_d": "Category 6A",
    "correct_answer": "C",
    "explanation": "Shielded twisted-pair (STP) has a metallic shielding that will mitigate some electromagnetic interference (EMI) or external interference. The best choice for areas with high amounts of EMI and radio frequency interference (RFI) is fiber-optic cable. Category 5e and 6A are types of unshielded twisted-pair (UTP), and they will not prevent EMI.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      31,
      28,
      26,
      25,
      29
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 59,
    "question": "You need to install Ethernet to a network-attached camera more than 500 feet away from your switching. What is the best and least expensive option?",
    "choice_a": "Install Category 5e from the switch to the camera.",
    "choice_b": "Install Category 7 from the switch to the camera.",
    "choice_c": "Install MMF from the switch to the camera and media converters on both ends.",
    "choice_d": "Install SMF from the switch to the camera and media converters on both ends.",
    "correct_answer": "C",
    "explanation": "Since the distance is more than 500 feet, fiber-optic cable is your only option. Multimode fiber (MMF) should be installed between the switch and the camera and then converted on both ends with media converters back to Ethernet. MMF is cheaper than single-mode fiber (SMF), so MMF is preferred based on the pricing consideration. Both Category 5e and Category 7 have a distance limitation of 100 meters (328 feet).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      29,
      26,
      31,
      47
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 60,
    "question": "You are working with a contractor that is renovating an office space. You are required to specify the cabling to be installed for the computers in this new office; all wiring is within 100 meters from the switching equipment. You require 1 Gbps to the desktop and want to minimize expense but future-proof the installation for 10 Gbps. Costs should be kept as low as possible. Which specification should you recommend?",
    "choice_a": "Category 5 cable",
    "choice_b": "Category 5e cable",
    "choice_c": "Category 6 cable",
    "choice_d": "Category 6a cable",
    "correct_answer": "D",
    "explanation": "Category 6a is one of the more expensive options, but it is the only specification of cable that will provide speeds of 10 Gbps in the future while keeping the costs low. Category 5 and 5e will not deliver 10 Gbps, only 100 Mbps and 1 Gbps, respectively. Category 6 will supply 10 Gbps, but only at a maximum length of 55 meters.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      26,
      46,
      31,
      33,
      44
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 61,
    "question": "You need to connect a fiber-optic line between two buildings that are about 2,000 feet apart. Which Ethernet technology should you use?",
    "choice_a": "10GBaseSW",
    "choice_b": "10GBaseT",
    "choice_c": "10GBaseSR",
    "choice_d": "10GBaseLR",
    "correct_answer": "D",
    "explanation": "10GBaseLR will support 10 Gbps up to 10 kilometers and will provide ample connectivity between buildings. 10GBaseSW will operate at 10 Gbps for a total of 300 meters and is typically used for SONET equipment. 10GBaseT will support 10 Gbps over copper UTP cables for a maximum distance of 100 meters. 10GBaseSR will support 10 Gbps for a maximum distance of 300 meters.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      46,
      29,
      12,
      31,
      44
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 62,
    "question": "You need to provide Ethernet connectivity to an IP camera that is 5,000 feet away. The solution should be cost effective. What should you recommend?",
    "choice_a": "Wireless range extender",
    "choice_b": "Media converters with fiber-optic cable",
    "choice_c": "Media converter with coaxial cable",
    "choice_d": "Wireless mesh network with a bridge",
    "correct_answer": "B",
    "explanation": "Installation of a fiber-optic cable with media converters on both ends is the recommended solution because of the distance. The length of the cable run is too far for coaxial cable. Although a wireless mesh network with a bridge might work, it would be too expensive.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      29,
      28,
      25,
      47,
      9
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 63,
    "question": "Which is a correct statement about sliding windows used with TCP?",
    "choice_a": "The window size is established during the three-way handshake.",
    "choice_b": "Sliding windows allow for data of different lengths to be padded.",
    "choice_c": "It allows TCP to indicate which upper-layer protocol created the request.",
    "choice_d": "It allows the router to see the segment as urgent data.",
    "correct_answer": "A",
    "explanation": "The window size, which is a buffer, is established and agreed upon by the sender and receiver during the TCP three-way handshake. Sliding windows do not allow for data of different lengths to be padded; they are used for fixed-length data segments. Port binding is used by TCP and UDP to indicate which upper-layer protocol (application) created the request. Routers only examine layer 3 information by default, so they can make decisive routing decisions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      20,
      19,
      77,
      23,
      82
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 64,
    "question": "Which statement describes the micro-segmentation that a switch provides?",
    "choice_a": "All of the ports on the switch create a single collision domain.",
    "choice_b": "Each port on the switch segments broadcasts.",
    "choice_c": "Each port on the switch creates its own collision domain.",
    "choice_d": "Each port on the switch creates an isolation for layer 2 broadcasts.",
    "correct_answer": "C",
    "explanation": "Each port on a switch creates its own collision domain. An increase in collision domains raises bandwidth since each port creates its own segment (micro-segmentation) and isolates possible collisions on other ports. All the ports on a hub will create a single collision domain, in which a signal from one computer can and will collide with another. Each port on the switch will not segment broadcasts unless each port is assigned a different VLAN, which is not common practice. Although each port on a switch will create a collision domain, it does not stop layer 2 broadcasts from being forwarded to all ports.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      53,
      150,
      69,
      71,
      66
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 65,
    "question": "What limits the amount of time that a DNS entry is available in the DNS cache?",
    "choice_a": "An A record",
    "choice_b": "TTL",
    "choice_c": "SOA",
    "choice_d": "Default of 5 minutes",
    "correct_answer": "B",
    "explanation": "The time to live (TTL) limits the amount of time a DNS entry will be available in the DNS cache. The TTL can be defined by the DNS administrator on the entry, or it can be defined in the start of authority (SOA) record as the default TTL. An A record is used to look up an IP address for a given hostname with DNS name resolution. The SOA is the first record in a DNS zone that explains where to find other servers and parameters for zone operation. The TTL does not default to 5 minutes; the default TTL is defined in the SOA record.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      76,
      78,
      72,
      82,
      18
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 66,
    "question": "Which message is sent from the DHCP client to the DHCP server to confirm the offer of an IP address?",
    "choice_a": "Acknowledgment",
    "choice_b": "Discover",
    "choice_c": "Offer",
    "choice_d": "Request",
    "correct_answer": "A",
    "explanation": "The DHCP acknowledgment message is sent from the DHCP client to the DHCP server to acknowledge that the IP address offered will be used by the client. The Discover message is the first message that is sent by the client to discover a DHCP server on the local network. The Offer message is sent by the DHCP server to offer an IP address lease to the client. The Request message is sent from the client to the DHCP server to formally request the offered IP address lease.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      75,
      76,
      78,
      83,
      72
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 67,
    "question": "What is a benefit of a multilayer switch (MLS) over a layer 2 switch?",
    "choice_a": "Less bandwidth",
    "choice_b": "Routing functions",
    "choice_c": "Fewer features",
    "choice_d": "Fewer ports",
    "correct_answer": "C",
    "explanation": "Multilayer switches (also called layer 3 switches) don\u2019t have fewer features, less bandwidth, or fewer ports than a normal switch; they just allow routing functions between subnets.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      62,
      164,
      68,
      71,
      155
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 68,
    "question": "Which DNS record would you use to create a reverse DNS record?",
    "choice_a": "A record",
    "choice_b": "TXT record",
    "choice_c": "PTR record",
    "choice_d": "MX record",
    "correct_answer": "C",
    "explanation": "A pointer record (PTR) is used by DNS to resolve an IP address to fully qualified domain name (FQDN). An alias record, also known as a DNS A record, is used to resolve an FQDN to IP address. A TXT record is used by various services to store text in a DNS record; the most notable service is Sender Policy Framework (SPF). The mail exchanger (MX) record is used in DNS to resolve the mail units serving the domain.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      76,
      78,
      72,
      17,
      82
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 69,
    "question": "You are looking at network traffic and see a large amount of traffic on UDP port 53. What type of traffic is this?",
    "choice_a": "SSH",
    "choice_b": "DNS",
    "choice_c": "FTP",
    "choice_d": "SMTP",
    "correct_answer": "B",
    "explanation": "DNS query traffic uses the UDP protocol and port 53. SSH traffic utilizes TCP port 22. FTP traffic utilizes TCP port 20 and 21. SMTP traffic utilizes TCP port 25.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      78,
      76,
      77,
      83,
      73
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 70,
    "question": "You are deploying a Microsoft RemoteApp terminal server. You need to configure a rule on the firewall to allow connections. What is the protocol and port you will need to permit?",
    "choice_a": "TCP/389",
    "choice_b": "TCP/3389",
    "choice_c": "UDP/3389",
    "choice_d": "UDP/389",
    "correct_answer": "B",
    "explanation": "You will need to permit TCP port 3389 through the firewall so that clients can reach the RemoteApp server.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      78,
      83,
      77,
      72,
      17
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 71,
    "question": "The GRE protocol operates at which layer of the OSI?",
    "choice_a": "Session layer",
    "choice_b": "Application layer",
    "choice_c": "Network layer",
    "choice_d": "Data Link layer",
    "correct_answer": "C",
    "explanation": "The Generic Router Encapsulation (GRE) protocol operates at the Network layer. All other answers are incorrect.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      80,
      21,
      82,
      81,
      72
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 72,
    "question": "You captured network traffic with a network capture utility. Several of the MAC addresses are ff:ff:ff:ff:ff:ff:ff:ff. What could these packets be?",
    "choice_a": "ICMP traffic",
    "choice_b": "Broadcast traffic",
    "choice_c": "Multicast traffic",
    "choice_d": "IGMP traffic",
    "correct_answer": "B",
    "explanation": "When a broadcast is sent, the destination MAC address will be ff:ff:ff:ff:ff:ff:ff:ff. This destination MAC address tells the switch to forward the traffic to all active ports. Internet Control Message Protocol (ICMP) traffic will not contain a destination MAC address of ff:ff:ff:ff:ff:ff:ff:ff. Multicast traffic will have a destination MAC address that is calculated for the multicast group. Internet Group Management Protocol (IGMP) is a protocol used to create multicast groups.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      88,
      36,
      22,
      43,
      79
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 73,
    "question": "Which address could be used to address a group of computers?",
    "choice_a": "127.0.0.1",
    "choice_b": "192.0.0.2",
    "choice_c": "239.0.0.15",
    "choice_d": "172.16.2.3",
    "correct_answer": "C",
    "explanation": "When addressing a group of computers, you need to use either a broadcast address or a multicast address. The IP address of 239.0.0.15 is a multicast address, because it falls within the range of 224.0.0.0 through 239.255.255.255. The IP address of 127.0.0.1 is a loopback address. The IP addresses of 192.0.0.2 and 172.16.2.3 are both private IP addresses.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      88,
      99,
      87,
      84,
      111
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 74,
    "question": "Why is there a need for IPv6 in the world today?",
    "choice_a": "It does not require NAT to operate.",
    "choice_b": "The IPv4 address space is exhausted.",
    "choice_c": "IPv4 is considered legacy, and IPv6 is the replacement.",
    "choice_d": "IPv6 does not require subnetting.",
    "correct_answer": "B",
    "explanation": "IPv4 allows for 2<sup>32</sup> = 4.3 billion addresses. However, only 3.7 billion are usable because of reservations and classful addressing. The current IPv4 address space is exhausted, and IPv6 allows for 2<sup>128</sup> = 3.4 \u00d7 10<sup>38</sup> addresses. IPv6 still requires NAT for backward compatibility with IPv4. Although IPv4 is slowly being replaced with IPv6, IPv4 is still dominant in networks and the Internet. IPv6 does not need to be subnetted like IPv4 by borrowing bits from the network mask; there are 16 bits dedicated for subnets. However, that functionality does not create the need for an entirely new address scheme.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      95,
      94,
      98,
      60,
      56
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 75,
    "question": "You have 700 computers in your network and are experiencing performance issues. You have run a packet capture to analyze the traffic. You find that a tremendous amount of traffic is directed to 255.255.255.255. What should be done to resolve the performance problem?",
    "choice_a": "Increase the DHCP lease time.",
    "choice_b": "Statically assign IP addresses.",
    "choice_c": "Segment the network.",
    "choice_d": "Install managed layer 2 switches.",
    "correct_answer": "C",
    "explanation": "The destination address of 255.255.255.255 is broadcast traffic. Broadcast traffic can come from many different sources, and assigning static IPs and increasing lease time might help reduce DHCP broadcasts. However, ARP broadcasts will still plague the network; therefore, network segmentation is the best step to remediate the problem.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      154,
      315,
      324,
      322,
      311
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 76,
    "question": "Which NAT type maps local addresses to global addresses on a one-to-one basis automatically?",
    "choice_a": "SNAT",
    "choice_b": "DNAT",
    "choice_c": "PAT",
    "choice_d": "NAT overloading",
    "correct_answer": "B",
    "explanation": "Dynamic NAT (DNAT) automatically maps local addresses to global addresses on a one-to-one basis. Static NAT (SNAT) is assigned manually on a one-to-one basis. Port Address Translation (PAT) and NAT (overloading) are the same technique of utilizing one or more IP addresses by mapping the IP address and port number of the local address to the global address.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      60,
      98,
      94,
      95
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 77,
    "question": "Which IP address can communicate with a host that has an address of 172.16.234.18/28?",
    "choice_a": "172.16.234.15/28",
    "choice_b": "172.16.234.29/28",
    "choice_c": "172.16.234.34/28",
    "choice_d": "172.16.234.38/28",
    "correct_answer": "B",
    "explanation": "The subnet of /28 (255.255.240.0) dictates that the network IDs are in multiples of 16. The address of 172.16.234.18/28 is in the 172.16.234.16/28 network of 172.16.234.16 through 172.16.234.31 (minus the network address of 172.16.234.16 and the broadcast address of 172.16.234.31). Therefore, 172.16.234.29/28 is within the same network. 172.16.234.15 is in the 172.16.234.16/28 network. 172.16.234.34 and 172.16.234.38 are both within the 172.16.234.32/28 network.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      87,
      104,
      101,
      103,
      114
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 78,
    "question": "Which protocol is used on the Internet for routing?",
    "choice_a": "OSPF",
    "choice_b": "RIP",
    "choice_c": "AS",
    "choice_d": "BGP",
    "correct_answer": "D",
    "explanation": "The Border Gateway Protocol (BGP) is the main protocol for Internet routing. Open Shortest Path First (OSPF) is a scalable routing protocol for internal networks. Routing Information Protocol (RIP) is an interior routing protocol normally used in small networks with fewer than 15 hops. An autonomous system (AS) is a collection of networks or subnets that are in the same administrative domain.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      131,
      137,
      143,
      140
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 79,
    "question": "Which does <i>not</i> scale well with large networks that have many different subnets?",
    "choice_a": "Static routing",
    "choice_b": "Dynamic routing",
    "choice_c": "DHCP",
    "choice_d": "ARP",
    "correct_answer": "A",
    "explanation": "Static routing does not scale well because it requires manual configuration by the administrator as new subnets are added. Dynamic routing will ensure that routing in the network is automated as new subnets are added to the network. Dynamic Host Configuration Protocol (DHCP) supports scalability because it automatically addresses hosts in each subnet. Address Resolution Protocol (ARP) is required for communication between hosts and has no effect on scalability.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      120,
      137,
      131,
      138
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 80,
    "question": "What are both RIP and OSPF considered?",
    "choice_a": "Static routing",
    "choice_b": "Default routing",
    "choice_c": "Stub routing",
    "choice_d": "Dynamic routing protocols",
    "correct_answer": "D",
    "explanation": "Both Routing Information Protocol (RIP) and Open Shortest Path First (OSPF) are both dynamic routing protocols. Static routing requires route entries to manually be entered into the route table. Default routing is the action a packet takes if no route is known for the packet. Stub routing is similar in design to default routing, as a stub network\u2019s only way to communicate with the rest of the network is through the default route.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      131,
      138,
      143,
      130,
      137
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 81,
    "question": "What is the AD of a directly connected network?",
    "choice_a": "The AD is 0.",
    "choice_b": "The AD is 1.",
    "choice_c": "The AD is 5.",
    "choice_d": "Directly connected networks do not have an AD.",
    "correct_answer": "A",
    "explanation": "A directly connected network has an administrative distance (AD) of 0 and is the most highly reliable. The administrative distance of 1 is used for static entries. The administrative distance of 5 is used for Enhanced Interior Gateway Routing Protocol (EIGRP) summary routes. Directly connected networks have an AD of 0 that is trusted over all other router sources.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      133,
      119,
      120,
      131,
      121
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 82,
    "question": "What is the AD of internal EIGRP?",
    "choice_a": "90",
    "choice_b": "100",
    "choice_c": "110",
    "choice_d": "120",
    "correct_answer": "A",
    "explanation": "Internal Enhanced Interior Gateway Routing Protocol (EIGRP) has an administrative distance (AD) of 90. The AD of 100 is used for Interior Gateway Routing Protocol (IGRP). The administrative distance of 110 is used for Open Shortest Path First (OSPF). The administrative distance of the Routing Information Protocol (RIP) is 120.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      133,
      140,
      131,
      137,
      138
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 83,
    "question": "Which statement is true when there are multiple route statements from different routing protocols for the same destination network?",
    "choice_a": "The route is chosen with the highest AD.",
    "choice_b": "The route chosen has the lowest metric.",
    "choice_c": "The route is chosen with the lowest AD.",
    "choice_d": "The route chosen has the highest metric.",
    "correct_answer": "C",
    "explanation": "The routing protocol with the lowest administrative distance (AD) is always chosen. Within that protocol, if there are multiple routes to the same network, then the lowest metric is chosen. The route is chosen with the lowest administrative distance, not the highest administrative distance. The route with the lowest metric will be selected as the best route, but only when within the same routing protocol. The route with the highest metric will not be selected as the best route.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      133,
      131,
      119,
      140,
      143
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 84,
    "question": "You are obtaining another Internet provider for your company\u2019s connectivity to the Internet. You want to make sure that if there is a failure, the routing protocol will advertise your company\u2019s IP addresses and fail over. Which routing protocol should you use?",
    "choice_a": "RIPv2",
    "choice_b": "EIGRP",
    "choice_c": "OSPF",
    "choice_d": "BGP",
    "correct_answer": "D",
    "explanation": "Border Gateway Protocol (BGP) is used as an external routing protocol for the Internet. When two providers are connected to a single site using BGP, the connection can fail over in the case of one provider suffering an outage. Routing Information Protocol version 2 (RIPv2) is an interior routing protocol normally used in small networks with fewer than 15 hops. Enhanced Interior Gateway Routing Protocol (EIGRP) is an interior routing protocol that is proprietary to Cisco. Open Shortest Path First (OSPF) is an interior routing protocol that has the ability to scale.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      131,
      273,
      140,
      143
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 85,
    "question": "Which technique can be used as an overlay for tunneling IPv6 over an IPv4 network?",
    "choice_a": "NAT",
    "choice_b": "GRE",
    "choice_c": "Dual stack",
    "choice_d": "RIPng",
    "correct_answer": "B",
    "explanation": "Generic Router Encapsulation (GRE) is an overlay technique in which GRE will encapsulate an IPv6 packet with an IPv4 address, for the packet to be routed across an IPv4 network. Network Address Translation (NAT) is not an overlay technique; it translates an IPv6 address to a routable IPv4 address. Dual stack is the technique of having two independent IP protocol stacks on the same device. Routing Information Protocol next generation (RIPng) is a dynamic routing protocol used with IPv6.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      95,
      58,
      59,
      60,
      61
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 86,
    "question": "Why is it recommended that you do not use VLAN 1?",
    "choice_a": "It is not a production VLAN.",
    "choice_b": "It cannot be routed via an SVI.",
    "choice_c": "It cannot participate in VTP transfers.",
    "choice_d": "It shouldn\u2019t be used for security reasons.",
    "correct_answer": "D",
    "explanation": "For security concerns, it should not be used in production. It is the default VLAN configured on all switches. Potentially, a computer can be plugged into an interface defaulted to VLAN 1 and expose resources such as the switch management network. VLAN 1 can be used as a production VLAN, and by default, all switches are configured to use VLAN 1 right out of the box. VLAN 1 can also be routed the same as any other VLAN via an SVI. VLAN 1 can also participate in VTP transfers, although its name cannot be modified.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      168,
      160,
      167,
      169,
      162
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 87,
    "question": "What is the default VLAN Trunk Protocol (VTP) mode all switches are configured as by default?",
    "choice_a": "Server",
    "choice_b": "Client",
    "choice_c": "Transparent",
    "choice_d": "Master",
    "correct_answer": "A",
    "explanation": "All switches are configured by default as a VTP server. A switch configured as a client will receive and process VTP packets from a VTP server. A switch configured as transparent will not participate in VTP but will allow VTP to be forwarded to other switches. There is no such mode as master with VTP.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      167,
      162,
      163,
      168,
      164
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 88,
    "question": "Which technique can be used to prevent an on-path attack?",
    "choice_a": "DAI",
    "choice_b": "DHCP snooping",
    "choice_c": "Port security",
    "choice_d": "Port bonding",
    "correct_answer": "A",
    "explanation": "Dynamic ARP inspection (DAI) is a feature that prevents fraudulent mappings of IP addresses to MAC addresses in an attempt to execute an on-path attack. DHCP snooping is a prerequisite to turning on DAI, since DAI relies on the DHCP snooping tables. However, DHCP snooping alone cannot prevent on-path attacks. Port security is a feature that secures a switchport to either a specific MAC address or number of MAC addresses. Port bonding is a technique of bonding two or more ports on a switch to aggregate bandwidth.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      384,
      383,
      385,
      395,
      392
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 89,
    "question": "Which function of switching prevents broadcast storms?",
    "choice_a": "Forward/filter",
    "choice_b": "Address learning",
    "choice_c": "Loop avoidance",
    "choice_d": "Distributed switching",
    "correct_answer": "C",
    "explanation": "Loop avoidance prevents broadcast storms when there are redundant links between two or more switches. Forward/filter decisions allow frames to be forwarded only to the respective port/path that contains the destination host. Address learning is a function of switches in which the source address is mapped to the port it was observed on. Distributed switching is a function of a virtual environment where many software switches work together to forward frames efficiently.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      157,
      155,
      152,
      153,
      71
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 90,
    "question": "Which STP state is responsible for detecting redundant links?",
    "choice_a": "Blocking",
    "choice_b": "Listening",
    "choice_c": "Disabled",
    "choice_d": "Convergence",
    "correct_answer": "B",
    "explanation": "Redundant links are detected by using the listening state of STP to view redundant bridging protocol data units (BPDUs). Blocking is a state in which the port does not forward traffic. Disabled is a state a port enters if it has been administratively disabled. Convergence is the process of transitioning from blocking to forwarding mode when a device is plugged in. All switches in the network must be updated with any new redundant links back to the elected root bridge.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      159,
      157,
      179,
      158,
      171
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 91,
    "question": "What is the typical MTU of a Jumbo frame?",
    "choice_a": "1,500 bytes",
    "choice_b": "1,500 bits",
    "choice_c": "9,000 bytes",
    "choice_d": "9,000 bits",
    "correct_answer": "C",
    "explanation": "The maximum transmission unit (MTU) of a Jumbo frame is 9,000 bytes of information. A normal Ethernet frame is 1,500 bytes big. The reference of bits is not used to describe MTU; it is typically used when referring to bandwidth.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      43,
      22,
      44,
      46,
      82
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 92,
    "question": "What is the end device that sends credentials for 802.1X called?",
    "choice_a": "Authenticator",
    "choice_b": "Supplicant",
    "choice_c": "AAA server",
    "choice_d": "RADIUS server",
    "correct_answer": "B",
    "explanation": "The end device that sends credentials is called the supplicant. The supplicant is a piece of software in the operating system that supplies the credentials for AAA authentication. The authenticator is the wireless access point (WAP) or switch configured for 802.1X. The AAA server is normally a RADIUS server or TACACS+ server that is configured for 802.1X.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      214,
      244,
      217,
      208,
      237
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 93,
    "question": "Which of the following uses a certificate on both the server and client to provide the best wireless security with 802.1X (and is hardest to implement)?",
    "choice_a": "AES",
    "choice_b": "TTLS",
    "choice_c": "TLS",
    "choice_d": "TKIP",
    "correct_answer": "C",
    "explanation": "Transport Layer Security (TLS) provides really good wireless security, but it\u2019s hard to implement because you need to install a certificate on your server and also on all your clients. TTLS only uses a server-side certificate. Advanced Encryption Standard (AES) and Temporal Key Integrity Protocol (TKIP) are encryption standards.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      206,
      196,
      201,
      204,
      185
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 94,
    "question": "Which of the following is used to create a PAN?",
    "choice_a": "AES",
    "choice_b": "BSS",
    "choice_c": "SSID",
    "choice_d": "Bluetooth",
    "correct_answer": "D",
    "explanation": "Bluetooth works wirelessly to connect our phones, keyboards, and so on in small areas, also known as personal area networks (PANs). Advanced Encryption Standard (AES) is an encryption standard used with Wi-Fi Protected Access (WPA). Basic service set (BSS) is the wireless area managed by the access point (AP). The service set identifier (SSID) is the unique identifier used by the AP to manage client associations.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      196,
      57,
      185,
      183,
      184
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 95,
    "question": "Which terminal-based management protocol has built-in security?",
    "choice_a": "SSH",
    "choice_b": "SCP",
    "choice_c": "HTTPS",
    "choice_d": "FTP",
    "correct_answer": "A",
    "explanation": "Secure Shell (SSH) negotiates encryption when a connection is made. SSH is used as a replacement for the unencrypted Telnet protocol. Secure Copy (SCP) is used to securely copy files. Hypertext Transfer Protocol Secure (HTTPS) uses TLS encryption to securely transmit web-based content. File Transfer Protocol (FTP) is an unencrypted file transfer protocol.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      74,
      73,
      80,
      205,
      97
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 96,
    "question": "You have several remote workers who enter patient information and require a high level of security. Which technology would best suit the connectivity for these workers?",
    "choice_a": "GRE tunnel",
    "choice_b": "Wireless WAN",
    "choice_c": "Client-to-site VPN",
    "choice_d": "Site-to-site VPN",
    "correct_answer": "C",
    "explanation": "Since you have several remote workers who telecommute, the best connectivity option is a client-to-site VPN. A GRE tunnel is unencrypted and will not provide any security. A wireless WAN can be used to connect clients to the Internet, but the client-to-site connection would be the private connection to the organization\u2019s network. Site-to-site VPN connections are intended for connecting sites to each other via an encrypted tunnel over the Internet.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      209,
      208,
      211,
      217,
      244
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 97,
    "question": "Which version of SNMP supports plaintext authentication with MD5 and SHA?",
    "choice_a": "SNMP version 1",
    "choice_b": "SNMP version 2e",
    "choice_c": "SNMP version 2c",
    "choice_d": "SNMP version 3",
    "correct_answer": "C",
    "explanation": "SNMP version 2c is an amendment of SNMP version 2 that added plaintext authentication with MD5 and SHA. SNMP version 1 was the first release of SNMP and supported only plaintext authentication. SNMP version 2e is not a valid version of SNMP. SNMP version 3 introduced message integrity, authentication, and encryption to the SNMP suite.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      381,
      368,
      367,
      370,
      374
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 98,
    "question": "What networking protocol uses OIDs and MIBs for data collection?",
    "choice_a": "SPAN",
    "choice_b": "NetFlow",
    "choice_c": "Syslog",
    "choice_d": "SNMP",
    "correct_answer": "D",
    "explanation": "The Simple Network Management Protocol (SNMP) uses organizational identifiers (OIDs) and management information bases (MIBs) for the collection and organization of data. Switched Port Analyzer (SPAN) is a Cisco proprietary method used to mirror port traffic on a switch. The NetFlow protocol provides session information including the source and destination addresses, applications, and traffic volume. Syslog is a method of collecting system messages to identify problems or it can be used for post-mortem analysis.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      226,
      229,
      227,
      231,
      232
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 99,
    "question": "Which protocol is used to mirror traffic from one switch to another in a network?",
    "choice_a": "SPAN",
    "choice_b": "RSPAN",
    "choice_c": "NetFlow",
    "choice_d": "SNMP",
    "correct_answer": "B",
    "explanation": "Remote Switched Port Analyzer (RSPAN) is used to mirror traffic from one port on a switch to a port on a different switch. Switched Port Analyzer (SPAN) is used within the same switch to mirror traffic. NetFlow is used on routers to statically analyze the traffic flow of packets. Simple Network Management Protocol (SNMP) is used to monitor and collect counters for servers and network devices.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      162,
      160,
      178,
      53,
      150
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 100,
    "question": "Which syslog severity level is used to obtain debugging information?",
    "choice_a": "Level 3",
    "choice_b": "Level 4",
    "choice_c": "Level 0",
    "choice_d": "Level 7",
    "correct_answer": "D",
    "explanation": "The severity levels are from 0 to 7, where 0 is an emergency and 7 is debugging. Debugging would be categorized as a level 7 (debug). All other answers are incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      233,
      236,
      223,
      224,
      235
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 101,
    "question": "Which document will hold a provider responsible for their service to you?",
    "choice_a": "SLA",
    "choice_b": "MOU",
    "choice_c": "NDA",
    "choice_d": "EOL",
    "correct_answer": "A",
    "explanation": "The service level agreement (SLA) is an agreement that defines the expected service from a provider. A memorandum of understanding (MOU) is a mutual agreement between two or more parties. A nondisclosure agreement (NDA) is an agreement in which you agree not to disclose organizational information. The end-of-life (EOL) is the date that a vendor no longer sells the device or deems the end of its marketable life.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      258,
      259,
      268,
      237,
      240
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 102,
    "question": "In which document would you find how a device is wired?",
    "choice_a": "Floor plan",
    "choice_b": "Rack diagram",
    "choice_c": "Logical diagram",
    "choice_d": "Cable map",
    "correct_answer": "D",
    "explanation": "The cable map is a type of wiring diagram that details the exact placement and connection for cabling for a device. A floor plan is used to detail how a floor is laid out in your data center and extremely useful when selecting AP locations. A rack diagram is used to detail where equipment is inside of a rack. A logical diagram is used to detail the flow of information between systems.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      197,
      198,
      199,
      67,
      54
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 103,
    "question": "You need to review the contract for an ISP provider, and you want to make sure their uptime meets the needs of your organization. Which should you look at in the contract?",
    "choice_a": "SLA",
    "choice_b": "NDA",
    "choice_c": "MOU",
    "choice_d": "BYOD",
    "correct_answer": "A",
    "explanation": "The ISP provider\u2019s service level agreement (SLA) will explain the provider\u2019s uptime in a number of 9s. For example, 99.9% (3 nines) is equivalent to 8.76 hours per year of downtime, whereas four nines is equivalent to 52.56 minutes per year of downtime. A nondisclosure agreement (NDA) is an agreement between two parties that defines what information is considered confidential and cannot be shared outside the two parties. A memorandum of understanding (MOU) is a mutual agreement between two or more parties. A bring your own device (BYOD) policy is used to define the terms of using personal devices for work-related purposes.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      258,
      268,
      259,
      225,
      237
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 104,
    "question": "Which of the following defines the interval in which the Active router is considered offline with HSRP?",
    "choice_a": "Hold timer",
    "choice_b": "Hello timer",
    "choice_c": "Active timer",
    "choice_d": "Standby timer",
    "correct_answer": "A",
    "explanation": "The Hold timer is the amount of time before the Active router is considered offline. The Hello timer is the defined interval during which each of the routers send out Hello messages. The Active timer monitors the state of the Active router and resets each time a Hello packet is seen from the Active router. The Standby timer is used to monitor the state of the Standby router and resets each time a Hello packet is seen from the Standby router.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      274,
      264,
      142,
      119,
      122
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 105,
    "question": "Which site type mimics your on-premises network and requires zero intervention?",
    "choice_a": "Cold site",
    "choice_b": "Cloud site",
    "choice_c": "Warm site",
    "choice_d": "Hot site",
    "correct_answer": "D",
    "explanation": "A hot site mimics your on-premises network and requires minimal intervention. Cold sites require equipment to be installed and configured. Warm sites are between cold and hot sites and require some intervention. A cloud recovery site is an extension of the cloud backup services that have developed over the years. These are sites that while mimicking your on-premises network are totally virtual.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      272,
      268,
      278,
      277,
      255
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 106,
    "question": "At what temperature does damage typically occur to computers and peripherals?",
    "choice_a": "125 degrees Fahrenheit",
    "choice_b": "150 degrees Fahrenheit",
    "choice_c": "175 degrees Fahrenheit",
    "choice_d": "200 degrees Fahrenheit",
    "correct_answer": "C",
    "explanation": "At 175 degrees Fahrenheit, damage starts occurring to computers and peripherals. At 350 degrees Fahrenheit, damage starts occurring to paper products. All other answers are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      67,
      196,
      188,
      192,
      198
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 107,
    "question": "Which fire suppression system is constantly charged with a supply of water from a tank or city water supply?",
    "choice_a": "Wet pipe",
    "choice_b": "Clean agent",
    "choice_c": "Preaction",
    "choice_d": "Dry pipe",
    "correct_answer": "A",
    "explanation": "A wet pipe system is constantly charged with a supply of water from a holding tank or city water supply. Clean agent systems are normally found in data centers because the suppression agent is in the form of a gas and will not hurt electronics. A preaction system requires a detector to pre-charge the system before water is released. A dry pipe system doesn\u2019t contain water in the pipes. When the pressure drops, the water will be released from the nozzles.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      71,
      52,
      70,
      150
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 108,
    "question": "You are looking to create a fault tolerant colocation site for your servers at a cloud provider. Which type of cloud provider would you be searching for?",
    "choice_a": "PaaS",
    "choice_b": "IaaS",
    "choice_c": "SaaS",
    "choice_d": "BaaS",
    "correct_answer": "B",
    "explanation": "If you were looking to create a fault-tolerant colocation site as a cloud provider, you would be searching for an infrastructure-as-a-service (IaaS) provider. This would allow you to install your own operating system and applications. A platform as a service (PaaS) is a platform in which you program or design against and would not satisfy fault tolerance for your location. Software as a service (SaaS) is a service like email or Salesforce and would not satisfy fault tolerance for your location. Backup as a service (BaaS) is a disaster recovery component, but it will not create fault tolerance for your location.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      284,
      283,
      301,
      281,
      302
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 109,
    "question": "When a network frame is forwarded in a switch, which plane is facilitating the traffic?",
    "choice_a": "Data plane",
    "choice_b": "Control plane",
    "choice_c": "Management plane",
    "choice_d": "Switch plane",
    "correct_answer": "A",
    "explanation": "The data plane is responsible for switching and routing data. Any data that is destined for endpoints is switched or routed on the data plane. The control plane refers to any mechanism that controls the data plane. The management plane is any mechanism that helps in the management of a router or switch. <i>Switch plane</i> is not a term normally used to describe data types; therefore, option D is an invalid answer.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      21,
      22,
      43,
      81,
      23
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 110,
    "question": "Which one of these is <i>not</i> a component of an SDN model?",
    "choice_a": "Management plane",
    "choice_b": "Configuration plane",
    "choice_c": "Control plane",
    "choice_d": "Data plane",
    "correct_answer": "B",
    "explanation": "There is no such component called the configuration plane. Configuration is performed over the management plane. Traffic is moved on the data plane, and the control plane manages the data plane flow with protocol, such as routing protocols.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      295,
      297,
      296,
      291,
      293
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 111,
    "question": "Which type of NIST cloud service is Gmail?",
    "choice_a": "SaaS",
    "choice_b": "IaaS",
    "choice_c": "PaaS",
    "choice_d": "DaaS",
    "correct_answer": "A",
    "explanation": "Gmail, Facebook, Twitter, and other cloud-based email services are classified as software as a service (SaaS). Infrastructure as a service (IaaS) is similar to Azure or Amazon Web Services (AWS) where infrastructure can be rented as a service. Web hosting providers are examples of platform as a service (PaaS). Microsoft and VMware virtual desktop infrastructure (VDI) are examples of desktop as a service (DaaS).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      284,
      281,
      282,
      283,
      301
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 112,
    "question": "Which should you do during the process of identifying a problem? (Choose all answers that apply.)",
    "choice_a": "Question users",
    "choice_b": "Establish a plan of action",
    "choice_c": "Duplicate the problem",
    "choice_d": "Create a hypothesis",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "During the identification of a problem, you should question users and try to duplicate the problem. Establishing a plan of action is done after you have created a hypothesis, both of which happen after you identify the problem in the troubleshooting methodology.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      311,
      322,
      312,
      304,
      318
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 113,
    "question": "Which technique used to determine the root cause of a problem involves splitting a system into smaller subprocesses for examination?",
    "choice_a": "Top-to-bottom OSI analysis",
    "choice_b": "Divide-and-conquer analysis",
    "choice_c": "Bottom-to-top OSI analysis",
    "choice_d": "Process analysis",
    "correct_answer": "B",
    "explanation": "The divide-and-conquer analysis technique is used to divide complex processes into small subprocesses that are easier to analyze. The top-to-bottom OSI analysis is a method of understanding what happens from the application down to the physical layer to identify the problem. The bottom-to-top OSI analysis method is similar to the top-to-bottom, except it is from the physical to the application layers. Process analysis is not a valid answer.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      318,
      311,
      322,
      312,
      320
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 114,
    "question": "Which would you do when identifying the problem?",
    "choice_a": "Determine if anything has changed",
    "choice_b": "Question the obvious",
    "choice_c": "Consider multiple approaches",
    "choice_d": "Reestablish a new theory",
    "correct_answer": "A",
    "explanation": "When identifying the problem, you will determine if anything has changed, in addition to gathering information. Questioning the obvious is something you would perform as a troubleshooting step. Considering multiple approaches and reestablishing a new theory are done later in the diagnostic process.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      311,
      322,
      312,
      303,
      320
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 115,
    "question": "You are troubleshooting a break in a fiber-optic cable. Which tool should you use?",
    "choice_a": "Tap",
    "choice_b": "Cable tester",
    "choice_c": "Toner and toner probe",
    "choice_d": "Visual fault locator",
    "correct_answer": "D",
    "explanation": "A visual fault locator is a high-powered visible laser that can show breaks in cabling and help find faults. A tap is a device you insert between two pieces of network equipment to capture traffic for analysis. A cable tester will test each wire in a network cable. A toner and toner probe are used to find wired cabling.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      361,
      358,
      357,
      310,
      323
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 116,
    "question": "Which utility is installed on Windows that is similar to the Linux/UNIX <code>mtr</code> command?",
    "choice_a": "<code>tracert</code>",
    "choice_b": "<code>ping</code>",
    "choice_c": "<code>pathping</code>",
    "choice_d": "<code>traceroute</code>",
    "correct_answer": "C",
    "explanation": "The Windows equivalent of the Linux/UNIX <code>mtr</code> command is <code>pathping</code>. The command incorporates the functions of <code>tracert</code> and <code>ping</code> to provide an analysis of the path of a packet and its expected packet loss along the way. The command <code>traceroute</code> is the Linux/UNIX equivalent of the Windows command <code>tracert</code>.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      222,
      230,
      231,
      225,
      255
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 117,
    "question": "Which command-line tool will allow you to resolve an IP address from a FQDN?",
    "choice_a": "<code>nslookup</code>",
    "choice_b": "<code>ping</code>",
    "choice_c": "<code>ipconfig</code>",
    "choice_d": "<code>netstat</code>",
    "correct_answer": "A",
    "explanation": "The <code>nslookup</code> command-line tool is used to resolve IP addresses from FQDNs; it will also reverse lookup DNS names, among other queries. The <code>ping</code> command-line tool is used to test connectivity at layer 3. The <code>ipconfig</code> command-line tool is used to check and obtain the IP address configuration of the host. The <code>netstat</code> command-line tool is used to examine active network connection on the operating system.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      339,
      338,
      331,
      362,
      313
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 118,
    "question": "Which principle describes the process of recording a user\u2019s actions based upon the AAA security model?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Accounting",
    "choice_d": "Auditing",
    "correct_answer": "C",
    "explanation": "Accounting is a principle that describes the process of recording a user\u2019s action based upon the AAA security model of authentication, authorization, and accounting. Authorization is the process of limiting a person\u2019s access or permission to a resource based upon their identity. Authentication is the process of verification of a user\u2019s identity. Auditing is typically performed for compliance or review of log files.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      370,
      374,
      377,
      373,
      380
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 119,
    "question": "Which protocol is used to query for objects in Active Directory?",
    "choice_a": "LDAP",
    "choice_b": "SAML",
    "choice_c": "AD",
    "choice_d": "Kerberos",
    "correct_answer": "A",
    "explanation": "Lightweight Directory Access Protocol (LDAP) is a protocol that is exclusively used by Microsoft for lookup of objects in Active Directory. Security Assertion Markup Language (SAML) is an open-standard XML-based framework used for transmitting authentication and authorization information of users and computers. Active Directory (AD) is Microsoft\u2019s directory services product. Kerberos is exclusively used by Microsoft for authentication of users with Active Directory.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      72,
      74,
      80,
      97,
      300
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 120,
    "question": "Which element of PKI allows retrieval of the public certificate?",
    "choice_a": "CA",
    "choice_b": "Enrollment policy",
    "choice_c": "Root CA",
    "choice_d": "CRL",
    "correct_answer": "A",
    "explanation": "The certificate authority (CA) is the element of the Public Key Infrastructure (PKI) that is used to retrieve the public certificate for a key pair. The enrollment policy is the policy that the enrollee must adhere to for successful enrollment by the issuing CA for a key pair. The root CA has mutual trust between the issuing CA and the trusting server. The certificate revocation list (CRL) is the list of certificates that have been revoked.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      368,
      369,
      381,
      367,
      393
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 121,
    "question": "Which regulation is enforced by the FTC and affects the provider of financial services?",
    "choice_a": "HIPAA",
    "choice_b": "SOX",
    "choice_c": "GDPR",
    "choice_d": "GLBA",
    "correct_answer": "D",
    "explanation": "The Gramm\u2013Leach\u2013Bliley Act (GLBA) affects providers of financial services and is enforced by the Federal Trade Commission (FTC). The Health Insurance Portability and Accountability Act (HIPAA) is a regulation that protects health records. The Sarbanes\u2013Oxley Act (SOX) affects publicly traded companies and regulates how financial records are maintained. The General Data Protection Regulation (GDPR) is a European Union (EU) law governing how consumer data can be used and protected.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      247,
      256,
      236,
      234,
      249
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 122,
    "question": "Which type of attack denies authorized users access to network resources?",
    "choice_a": "DoS",
    "choice_b": "Worm",
    "choice_c": "Trojans",
    "choice_d": "Social engineering",
    "correct_answer": "A",
    "explanation": "Although the end result of any of these attacks may be denying authorized users access to network resources, a denial-of-service (DoS) attack is specifically intended to prevent access to network resources by overwhelming or flooding a service or network. Worms reproduce and move throughout the network to infect other systems. Trojans are programs that enter a system or network under the guise of another program. Social engineering is a process in which an attacker attempts to acquire information about your network and system by social means, such as talking to people in the organization.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      382,
      366,
      363,
      405,
      388
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 123,
    "question": "As the security administrator for your organization, you must be aware of all types of attacks that can occur and plan for them. Which type of attack uses more than one computer to attack the victim?",
    "choice_a": "DoS",
    "choice_b": "DDoS",
    "choice_c": "Worm",
    "choice_d": "Rootkits",
    "correct_answer": "B",
    "explanation": "A distributed denial-of-service (DDoS) attack uses multiple computer systems to attack a server or host in the network. A denial-of-service (DoS) is a one-on-one attack to disrupt service. Worms reproduce and move throughout the network to infect other systems and therefore do not attack one victim. Rootkits are software programs that have the ability to hide themselves from the operating system.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      382,
      405,
      387,
      363,
      364
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 124,
    "question": "Your help desk has informed you that they received an urgent call from the vice president last night requesting her login ID and password. When you talk with the VP today, she says she never made that call. What type of attack is this?",
    "choice_a": "Spoofing",
    "choice_b": "Replay",
    "choice_c": "Social engineering",
    "choice_d": "Trojan horse",
    "correct_answer": "C",
    "explanation": "Spear phishing is a type of social engineering, where someone is trying to con your organization into revealing account and password information by pretending to be a high-level person. A spoofing attack is an attempt by someone or something to masquerade as someone else, with the intent of disrupting access. A replay attack is a form of an on-path attack, where packets are replayed at a critical time. Trojan horses are programs that enter a system or network under the guise of another program.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      388,
      391,
      387,
      385,
      384
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 125,
    "question": "What method is used to redirect users to an AUP when they connect to the network?",
    "choice_a": "Port security",
    "choice_b": "MAC filtering",
    "choice_c": "Captive portal",
    "choice_d": "802.1X",
    "correct_answer": "C",
    "explanation": "A captive portal is a method used to redirect users to an acceptable use policy (AUP) when they connect to the network. Port security is used to control a switchport on a switch. MAC filtering is used to filter only the MAC addresses that should be connecting to a device. 802.1X is a method of securing a port by using RADIUS authentication.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      242,
      244,
      245,
      237,
      236
    ],
    "source": "235605_PracticeExam1"
  },
  {
    "id": 126,
    "question": "Which term describes a network link that connects your organization to the Internet?",
    "choice_a": "MAN",
    "choice_b": "WAN",
    "choice_c": "PAN",
    "choice_d": "LAN",
    "correct_answer": "B",
    "explanation": "A wide area network (WAN) can describe the network link that connects your organization to the Internet. A metropolitan area network (MAN) is a network that covers a metropolitan area to connection branches of an organization. A personal area network (PAN) is a network created typically via Bluetooth that has a limited distance. A local area network (LAN) is a network that is local to the organization and connects all of the hosts locally.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      2,
      6,
      12,
      10
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 127,
    "question": "Which topology has complete redundancy?",
    "choice_a": "Mesh",
    "choice_b": "Ring",
    "choice_c": "Bus",
    "choice_d": "Hybrid",
    "correct_answer": "A",
    "explanation": "A mesh network has redundant links throughout the network connecting hosts and other switches. A ring network does not have redundancy; if one node goes down, the ring is broken. A bus network does not have redundancy; if the bus is broken, then the other hosts on the bus will be isolated. A hybrid network can be built to have redundancy, but it does not have complete redundancy.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      11,
      7,
      10,
      9
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 128,
    "question": "On which tier of the three-tier model can you employ QoS, PoE, and security?",
    "choice_a": "Core layer",
    "choice_b": "Distribution layer",
    "choice_c": "Access layer",
    "choice_d": "Leaf",
    "correct_answer": "C",
    "explanation": "The access layer is where you can employ quality of service (QoS), power over Ethernet (PoE), and security. The core layer is considered the backbone of the network and should be designed for speed. The distribution layer is where the control plane exists and VLANs are routed. The leaf of a spine-and-leaf network is where you would find servers connected to the spine-and-leaf structure.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      13,
      16,
      17,
      21,
      22
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 129,
    "question": "Which is an advantage of the OSI model?",
    "choice_a": "It consolidates network communications into larger layers.",
    "choice_b": "The OSI model creates an API for vendors to write custom software.",
    "choice_c": "It allows changes in a specific layer to expedite the design process for a vendor.",
    "choice_d": "It encourages industry standardization by defining the specific functions that occur at each layer of the model.",
    "correct_answer": "D",
    "explanation": "The OSI model encourages industry standardization because each layer defines functionality. Therefore, a vendor can design hardware or applications to interconnect with the functionality above and below in the OSI model. The OSI model divides network communication processes into smaller and simpler components, known as layers. APIs can be found in layer 7 of the OSI, but the OSI model is not responsible for creating them. The OSI model does not allow changes in a specific layer to expedite the design process for vendors.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      17,
      81,
      23,
      82,
      22
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 130,
    "question": "Which OSI layer is responsible for dialogue control of applications?",
    "choice_a": "Transport layer",
    "choice_b": "Session layer",
    "choice_c": "Physical layer",
    "choice_d": "Presentation layer",
    "correct_answer": "B",
    "explanation": "The Session layer is responsible for the dialogue control of an application. The Transport layer establishes a logical connection between two hosts communicating and moving segments of data. The Physical layer is responsible for sending communication via radio waves, electrical encoding, or light. The Presentation layer is responsible for presenting data to the Application layer, such as encryption/decryption and compression/decompression.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      18,
      17,
      81,
      23,
      82
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 131,
    "question": "Which networking concept allows you to describe the data at each layer of the OSI model?",
    "choice_a": "DTE",
    "choice_b": "DCE",
    "choice_c": "PDU",
    "choice_d": "CSU/DSU",
    "correct_answer": "C",
    "explanation": "The networking concept of protocol data units (PDUs) describes the data found at each layer of the OSI model. Data terminal equipment (DTE) and data communication equipment (DCE) are terms used to describe physical interfaces. The network concept of channel service unit/data service unit (CSU/DSU) is used at the physical layer by modems.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      81,
      23,
      82,
      17,
      43
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 132,
    "question": "Which type of cable is acceptable for use in walls and ceilings and often mandated by local or municipal fire code? (Choose all that apply.)",
    "choice_a": "PVC",
    "choice_b": "FEP",
    "choice_c": "Teflon",
    "choice_d": "NFPA",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Fluoroethylene propylene (FEP) and Teflon-type cabling are acceptable for use in walls and ceilings and often mandated by local or municipal fire code. Polyvinyl chloride (PVC) is not acceptable for use in wall and ceilings. The National Fire Protection Association (NFPA) is an association that mandates fire code.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      273
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 133,
    "question": "You are asked to select a fiber-optic cable connector for a high-density installation. Which fiber-optic cable connector is best suitable for extremely dense installations?",
    "choice_a": "SC",
    "choice_b": "ST",
    "choice_c": "MT-RJ",
    "choice_d": "MMF",
    "correct_answer": "C",
    "explanation": "The mechanical transfer registered jack (MT-RJ or MTRJ) is one third the size of SC and ST connectors and is used for high-density installations. Multimode fiber (MMF) is a type of fiber-optic cable.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      28,
      31,
      46,
      29,
      33
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 134,
    "question": "Which cable should you choose to connect to a router via an EIA-TIA 232 interface?",
    "choice_a": "Rolled cable",
    "choice_b": "T1 crossover cable",
    "choice_c": "Straight-through cable",
    "choice_d": "Crossover cable",
    "correct_answer": "A",
    "explanation": "A rolled cable is used to connect to a router or switch via an EIA-TIA 232 interface. A T1 crossover cable is used to connect a router to a router via the T1 interface. A straight-through cable is used to connect hosts to a switch. A crossover cable is used to connect a host to a host or a switch to a switch.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      54,
      168,
      53,
      124,
      122
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 135,
    "question": "How many bits in an octet?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "4",
    "choice_d": "8",
    "correct_answer": "D",
    "explanation": "An octet consists of 8 bits of information; it is also considered a byte of information. A single bit is 1 bit, and it can have a value of 0 or 1 for a total of two combinations. Two bits can have either a 0 or a 1 in both of their places, for a total of up to four different combinations. A nibble is 4 bits of information.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      41,
      102,
      82,
      1,
      103
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 136,
    "question": "What is the relevance of the preamble in a frame?",
    "choice_a": "Signifies the start of the frame",
    "choice_b": "Provides clocking for the receiving node",
    "choice_c": "Specifies the length of a frame",
    "choice_d": "Calculates a CRC value for the frame",
    "correct_answer": "B",
    "explanation": "The preamble is used to provide clocking for the receiving node to decode the rest of the frame. The start-of-frame delimiter is a 1-byte value of 1s signaling the receiving computer that data is to follow. The length field specifies the length of a frame. The frame checking sequence (FCS) is a calculation on a frame using a cyclical redundancy check (CRC) algorithm.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      43,
      22,
      81,
      82,
      40
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 137,
    "question": "You need to purchase a transceiver for a server that will be connected via Category 7 cable. Which transceiver should you select?",
    "choice_a": "10GBaseSR",
    "choice_b": "10GBaseLR",
    "choice_c": "10GBaseT",
    "choice_d": "10GBaseER",
    "correct_answer": "C",
    "explanation": "The 10GBaseT Ethernet specification provides for 10 Gbps connections over conventual UTP cables of Category 5e, 6, 6A, or 7. The 10GBaseSR Ethernet specification supports 10 Gbps over multimode fiber (MMF). The 10GBaseLR and 10GBaseER Ethernet specifications support 10 Gbps over single-mode fiber (SMF) at varying distances.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      46,
      26,
      28,
      29,
      31
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 138,
    "question": "How many bytes is the destination address in an Ethernet frame?",
    "choice_a": "16 bits",
    "choice_b": "32 bits",
    "choice_c": "48 bits",
    "choice_d": "64 bits",
    "correct_answer": "C",
    "explanation": "The destination address of an Ethernet frame is 48 bits to accommodate the destination MAC address. The source address of an Ethernet fame is also 48 bits long, because all MAC addresses are 48 bits in length. All other answers are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      43,
      42,
      22,
      82,
      41
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 139,
    "question": "You need to create an SPF record. Which DNS record should you use to create the record?",
    "choice_a": "A record",
    "choice_b": "TXT record",
    "choice_c": "PTR record",
    "choice_d": "MX record",
    "correct_answer": "B",
    "explanation": "A TXT record is used by various services to store text in a DNS record; the most notable text is the Sender Policy Framework (SPF). An alias record, also known as a DNS A record, is used to resolve an FQDN to IP address. A pointer record (PTR) is used by DNS to resolve an IP address to a fully qualified domain name (FQDN). The mail exchanger (MX) record is used in DNS to resolve the mail units serving the domain.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      58,
      60,
      56,
      98,
      232
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 140,
    "question": "Which element of NTP provides a hierarchical system of clock sources?",
    "choice_a": "Clients",
    "choice_b": "Servers",
    "choice_c": "NTS",
    "choice_d": "Stratum",
    "correct_answer": "D",
    "explanation": "The element of NTP that provides a hierarchical system of clock sources is the stratum. A nuclear clock is a stratum level 0; anyone referencing that clock and serving to others is a stratum level 1, and so on. NTP clients connect to NTP servers that provide the varying stratum levels, depending on where they sourced their time from. The Network Time Security (NTS) protocol provides cryptographic security for the client-server mode of NTP.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      72,
      5,
      3,
      1,
      135
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 141,
    "question": "Which IETF standard provides authentication and authenticity of records for DNS?",
    "choice_a": "DNSSEC",
    "choice_b": "DoH",
    "choice_c": "DoT",
    "choice_d": "EDNS",
    "correct_answer": "A",
    "explanation": "Domain Name System Security Extensions (DNSSEC) was created by the Internet Engineering Task Force (IETF) to provide authentication and authenticity of records for DNS. DNS over HTTP (DoH) and DNS over TLS (DoT) are two standards for encrypting DNS traffic over HTTPS and TLS connections. Although they both provide encryption, they do not guarantee authenticity of DNS records. The Extension Mechanisms for DNS (EDNS) is used by DNSSEC to expand its capabilities so the DNSSEC protocol can provide the authentication and authenticity of DNS records.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      368,
      367,
      381,
      383,
      405
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 142,
    "question": "Which element of CSMA/CD will trigger the hosts to wait a random amount of time and not transmit during that period?",
    "choice_a": "Carrier sense",
    "choice_b": "Count-down timer",
    "choice_c": "Jamming signal",
    "choice_d": "Random back-off algorithm",
    "correct_answer": "C",
    "explanation": "The jamming signal will trigger the hosts to stop transmitting and instate the random back-off algorithm to wait a random amount of time before transmitting again. Hosts must sense a clear carrier before trying to transmit any data on the wire. A countdown timer is used with CSMA/CA when a wireless channel is not clear for sending information. The random back-off algorithm is used by both CSMA/CD and CSMA/CA to provide a random amount of time between the host trying to send information on the media.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      338,
      340,
      311,
      322,
      343
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 143,
    "question": "Which protocol provides acknowledgment for segments received?",
    "choice_a": "UDP",
    "choice_b": "TCP",
    "choice_c": "ICMP",
    "choice_d": "ARP",
    "correct_answer": "B",
    "explanation": "The Transmission Control Protocol (TCP) provides sequenced sand acknowledgment for segments received at the Transport layer. TCP is considered reliable for data transfer and connection-oriented. The User Datagram Protocol (UDP) does not provide sequence and acknowledgment for segments received at the Transport layer. It is the application\u2019s responsibility to reassemble segments and request missing segments. The Internet Control Message Protocol (ICMP) is used to test Network layer connectivity and does not provide acknowledgment for packets. The Address Resolution Protocol (ARP) is used at the Network layer to resolve a MAC address for a known IP address.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      77,
      20,
      79,
      83
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 144,
    "question": "Which protocol operates on TCP/1433?",
    "choice_a": "TFTP",
    "choice_b": "SQL",
    "choice_c": "HTTPS",
    "choice_d": "DNS",
    "correct_answer": "B",
    "explanation": "The Structured Query Language (SQL) protocol operates on port 1433 with the TCP protocol. The Trivial File Transfer Protocol (TFTP) operates on the UDP protocol, port 69. The Hypertext Transfer Protocol Secure (HTTPS) operates on the TCP protocol, port 443. The Domain Name System protocol operates on UDP or TCP, port 53.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      78,
      77,
      83,
      19,
      82
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 145,
    "question": "Which protocol is used to negotiate security associations?",
    "choice_a": "ESP",
    "choice_b": "AH",
    "choice_c": "IKE",
    "choice_d": "GRE",
    "correct_answer": "C",
    "explanation": "The Internet Key Exchange (IKE) is a management protocol that is used to negotiate security associations (SAs) between endpoints. Encapsulating Security Payload (ESP) is used to encrypt data with the IPSec protocol. The Authentication Header (AH) is used with the IPSec protocol to provide authentication for the data and the IP header of a network packet. Generic Routing Encapsulation (GRE) is a protocol used in conjunction with IPSec to encapsulate an encrypted packet inside other packets for transit over a network.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      368,
      393,
      367,
      397,
      392
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 146,
    "question": "Which IP address is defined within the RCF 1918 specification?",
    "choice_a": "172.31.2.3",
    "choice_b": "192.169.3.4",
    "choice_c": "172.32.4.3",
    "choice_d": "11.20.30.40",
    "correct_answer": "A",
    "explanation": "The IP address of 172.31.2.3 is within the private Class B range of 172.16.0.1 to 172.21.255.254 for the RFC 1918 specification. The IP address of 192.169.3.4 is a Class C address, but it is not in the RFC 1918 range of 192.168.0.0/16. The IP address of 172.32.4.3 is a Class B, but it is not in the RFC 1918 range of 172.16.0.0/12. The IP address of 11.20.30.40 is a Class A address, but it is not in the RFC 1918 range of 10.0.0.0/8.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      85,
      99,
      103,
      84
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 147,
    "question": "When implementing IPv6 EUI-64 addressing, which statement is true?",
    "choice_a": "The frame is padded with ff:ff in the middle of the address.",
    "choice_b": "The seventh bit of the MAC address is inverted.",
    "choice_c": "The IPv6 address will always begin with 2001:0db8.",
    "choice_d": "The seventh bit of IPv6 address is inverted.",
    "correct_answer": "B",
    "explanation": "The seventh bit of the MAC address is inverted before appending it to the network ID. Therefore, a MAC address of 0090:2716:fd0f will appear as 2001:0db8:0:1:0 <b>2</b>90:27ff:fe16:fd0f. The frame is always padded with ff:fe, not ff:ff. The IPv6 address will not start with 2001:0db8. This is a special network ID for network documentation purposes. The seventh bit of the MAC address is inverted, not the IPv6 address.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      94,
      95,
      58,
      60,
      227
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 148,
    "question": "What type of IPv6 address is fe80::1234?",
    "choice_a": "Multicast",
    "choice_b": "Global unicast",
    "choice_c": "Unique local",
    "choice_d": "Link-local unicast",
    "correct_answer": "D",
    "explanation": "IPv6 addresses starting with fe80 are link-local unicast addresses. The link-local address range is fe80::/10. The multicast address range is ff00::/8. The global unicast address range is 2000::/3. The unique local address range is fc00::/7.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      94,
      98,
      95,
      58,
      60
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 149,
    "question": "Which NAT types can be used to map multiple local addresses to a handful of global addresses? (Choose all that apply.)",
    "choice_a": "SNAT",
    "choice_b": "DNAT",
    "choice_c": "PAT",
    "choice_d": "NAT overloading",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Port Address Translation (PAT) and NAT (overloading) are the same technique of utilizing one or more IP addresses by mapping the IP address and port number of the local address to the global address. Static NAT (SNAT) is assigned manually on a one-to-one basis. Dynamic NAT (DNAT) automatically maps local addresses to global addresses on a one-to-one basis.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      56,
      60,
      94,
      98,
      95
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 150,
    "question": "Which IP address can communicate with a host that has an address of 172.16.45.18/27?",
    "choice_a": "172.16.45.30/27",
    "choice_b": "172.16.45.31/27",
    "choice_c": "172.16.45.32/27",
    "choice_d": "172.16.45.33/27",
    "correct_answer": "A",
    "explanation": "The subnet of /27 (255.255.240.0) dictates that the network IDs are in multiples of 32. The address of 172.16.45.30/27 is in the 172.16.45.0/27 network of 172.16.45.0 through 172.16.45.31 (minus the network address of 172.16.45.0 and the broadcast address of 172.16.45.31) Therefore, 172.16.45.30/27 is within the same network. 172.16.234.31 is the broadcast address for the 172.16.45.0/27 network. 172.16.45.32/27 is the next network in the series of subnets. 172.16.45.33/27 is the first host in the 172.16.45.32/27 network.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      87,
      114,
      104,
      103,
      102
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 151,
    "question": "What type of address is 230.22.3.4?",
    "choice_a": "Unicast",
    "choice_b": "Broadcast",
    "choice_c": "Multicast",
    "choice_d": "Anycast",
    "correct_answer": "C",
    "explanation": "Multicast addresses are in the range of 224.0.0.0 through 239.255.255.255 and is a one-to-many connection. Unicast addresses are used to communicate between two hosts in a one-to-one connection. Broadcasts are one-to-many connection and include everyone in the broadcast domain. Anycast allows duplication of a service over many different public IP addresses.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      88,
      100,
      99,
      93,
      84
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 152,
    "question": "You are having network issues and cannot communicate with other computers. On further inspection, you find that 169.254.40.9 is configured on the network connection. What is the most probable cause of the communication issues?",
    "choice_a": "The computer is configured with a static IP address.",
    "choice_b": "The computer is part of an RFC 1918 network.",
    "choice_c": "The DHCP server is not functioning.",
    "choice_d": "The computer is configured with a loopback address.",
    "correct_answer": "C",
    "explanation": "The address of 169.254.40.9 is an Automatic Private IP Addressing (APIPA) address. When a host is automatically configured with this IP address, it typically means that the DHCP server is not reachable. If the computer was configured with a static IP address, it would most likely not be within the 169.254.0.0/16 network. If the computer was configured with an RFC 1918 address, the address would be one of the three standard IP networks. If the computer was configured with a loopback address, the IP would start with 127.0.0.0/8.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      75,
      86,
      113,
      99,
      111
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 153,
    "question": "You have 15 different routers with several connected routes. Which is the best option for routing?",
    "choice_a": "Dynamic",
    "choice_b": "Static",
    "choice_c": "Default",
    "choice_d": "Stub",
    "correct_answer": "A",
    "explanation": "With 15 routers, you would need to add 15 routes on each of the 15 routers, if you used static routing. It would be double or triple, or more, if there were several routes on each router. Therefore, dynamic routing is the best option. Default and stub routing would not work because you have individual routes on each router.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      130,
      131,
      119,
      136
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 154,
    "question": "What is the term used to describe a collection of networks or subnets that are in the same administrative domain?",
    "choice_a": "EGP",
    "choice_b": "AS",
    "choice_c": "IGP",
    "choice_d": "BGP",
    "correct_answer": "B",
    "explanation": "An autonomous system (AS) is a collection of networks or subnets that are in the same administrative domain. The administrative domain is the grouping of networks that the organization has control over. An exterior gateway protocol (EGP) is a dynamic routing protocol used on the exterior of your network. An interior gateway protocol (IGP) is a dynamic routing protocol used on the interior of your network. Border Gateway Protocol (BGP) is a dynamic routing protocol typically found on the exterior of your network.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      131,
      140,
      142,
      143
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 155,
    "question": "Which dynamic routing protocol supports IPv6?",
    "choice_a": "RIPv2",
    "choice_b": "OSPF",
    "choice_c": "EIGRP",
    "choice_d": "OSPF3",
    "correct_answer": "D",
    "explanation": "The Open Shortest Path First v3 (OSPFv3) protocol supports IPv6 dynamic routing. Routing Information Protocol v2 (RIPv2), Open Shortest Path First (OSPF), and Enhanced Interior Gateway Routing Protocol (EIGRP) support only IPv4.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      149,
      143,
      140,
      131,
      142
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 156,
    "question": "Which dynamic routing protocol supports a maximum of 15 hops?",
    "choice_a": "RIPv2",
    "choice_b": "OSPF",
    "choice_c": "BGP",
    "choice_d": "EIGRP",
    "correct_answer": "A",
    "explanation": "The Routing Information Protocol v2 (RIPv2) dynamic routing protocol supports a maximum of 15 hops. Open Shortest Path First (OSPF) and Border Gateway Protocol (BGP) have an unlimited hop count. Enhanced Interior Gateway Routing Protocol (EIGRP) can support a maximum of 255 hops.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      137,
      131,
      140,
      143
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 157,
    "question": "Which dynamic routing protocol uses the metric of bandwidth for calculating the best route?",
    "choice_a": "BGP",
    "choice_b": "RIPv1",
    "choice_c": "OSPF",
    "choice_d": "RIPv2",
    "correct_answer": "C",
    "explanation": "The Open Shortest Path First (OSPF) dynamic routing protocol calculates the best route based upon the metric of bandwidth. The Border Gateway Protocol (BGP) dynamic routing protocol uses path selection as a metric. The Routing Information Protocol v1 (RIPv1) and Routing Information Protocol v2 (RIPv2) use hop count as a metric.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      142,
      131,
      137,
      138
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 158,
    "question": "You are using two different dynamic routing protocols on the same router, and the destination matches both routes. Which routing protocol will be selected?",
    "choice_a": "The route with the fastest time between source and destination",
    "choice_b": "The route that appears first in the routing table",
    "choice_c": "The route with the highest administrative distance",
    "choice_d": "The route with the lowest administrative distance",
    "correct_answer": "D",
    "explanation": "The packet with take the route with the lowest administrative distance (AD). The speed between the source and destination might be attributed to the best path within the routing protocol, but between routing protocols the lowest AD will always be the preferred route. The appearance of the route in the route table will not have an influence on the route selection process.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      133,
      136,
      131,
      137,
      142
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 159,
    "question": "Which is a benefit of using RIPv2 versus RIPv1?",
    "choice_a": "Hop count",
    "choice_b": "Broadcast based",
    "choice_c": "Support for VLSM",
    "choice_d": "Distance vector",
    "correct_answer": "C",
    "explanation": "The support for variable-length subnet mask (VLSM) is a major benefit to Router Information Protocol v2 (RIPv2) over RIPv1. The hop count on both RIPv1 and RIPv2 is a maximum of 15 hops. RIPv2 supports multicasts for the exchange of route information. Both RIPv1 and RIPv2 are both distance-vector routing protocols.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      131,
      137,
      149,
      142
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 160,
    "question": "Which switchport type uses tagged frames so they can travel between switches?",
    "choice_a": "Access",
    "choice_b": "Trunk",
    "choice_c": "Dynamic VLAN",
    "choice_d": "Static VLAN",
    "correct_answer": "B",
    "explanation": "A trunk port is a type of switchport that tags frames so that they can travel between switches. Access ports are a type of switchport that is a member of a VLAN and removes tagging. Dynamic VLAN is a technique in which VLANs are assigned by a VLAN Management Policy Server (VMPS) to a switchport, based upon the host\u2019s MAC address. A static VLAN is assigned to an access switchport.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      162,
      163,
      161,
      160,
      167
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 161,
    "question": "Which protocol allows for the fastest convergence of STP?",
    "choice_a": "802.1D",
    "choice_b": "802.1X",
    "choice_c": "802.1w",
    "choice_d": "802.3ad",
    "correct_answer": "C",
    "explanation": "Rapid Spanning Tree Protocol (RSTP), which is IEEE 802.1w, has the fastest convergence for the Spanning Tree Protocol (STP), with a five-second convergence. The original STP is 802.1D and has a convergence of 50 seconds. The 802.1X protocol is an authentication protocol used with switchports. The 802.3ad protocol, also known as Link Aggregation Control Protocol (LACP), is used to bond ports together.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      158,
      157,
      159,
      179,
      155
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 162,
    "question": "Which statement is true about a root bridge?",
    "choice_a": "All ports on a root bridge are root ports.",
    "choice_b": "All ports on a nonroot bridge are root ports.",
    "choice_c": "All nondesignated root ports are in a forwarding state.",
    "choice_d": "All root ports are in a forwarding state.",
    "correct_answer": "D",
    "explanation": "The root port is the port on a switch leading to the root bridge. The root bridge will never contain a root port, only designated ports that forward frames or nondesignated ports that block frames. Nondesignated ports are typically in a blocking or discarding state.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      157,
      159,
      171,
      179,
      158
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 163,
    "question": "Which trunking protocol is a Cisco proprietary protocol?",
    "choice_a": "ISL",
    "choice_b": "802.1D",
    "choice_c": "802.1Q",
    "choice_d": "802.1w",
    "correct_answer": "A",
    "explanation": "Inter-Switch Link (ISL) is a Cisco proprietary trunking protocol that can be used only on Cisco devices. The 802.1D protocol is Spanning Tree Protocol (STP), used to prevent loops in networks. The 802.1Q protocol is an open standard trunking protocol. The 802.1w protocol is Rapid Spanning Tree Protocol (RSTP), which is also used to prevent loops in networks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      163,
      162,
      167,
      159,
      155
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 164,
    "question": "Which method of routing between VLANs routes on the backplane of the switch?",
    "choice_a": "ROAS",
    "choice_b": "IVR with SVI",
    "choice_c": "ISL",
    "choice_d": "DTP",
    "correct_answer": "B",
    "explanation": "Inter-VLAN routing (IVR) with a switched virtual interface (SVI) is a method of routing on the backplane of the switch. Routing on a stick (ROAS) is a method of routing between VLANs via a single interface connected between the router and the switch. Inter-Switch Link (ISL) is a Cisco proprietary trunking protocol. The Dynamic Trunking Protocol (DTP) is a Cisco proprietary protocol that automatically creates a trunk between two Cisco switches.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      164,
      162,
      168,
      71,
      53
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 165,
    "question": "Which is a limitation of implementing layer 2 switches?",
    "choice_a": "Creation of collision domains",
    "choice_b": "Creation of broadcast domains",
    "choice_c": "Forwarding and filtering decisions",
    "choice_d": "Loop avoidance",
    "correct_answer": "B",
    "explanation": "Implementing layer 2 switches does not create broadcast domains, so this is a limitation of implementing layer 2 switches. Implementing layer 2 switches does create multiple collision domains for each port connected to a host or device. Layer 2 switches also make forward/filter decisions based on address learning. Layer 2 switches also perform loop avoidance by implementing the Spanning Tree Protocol (STP) or the Rapid Spanning Tree Protocol (RSTP).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      155,
      160,
      66,
      153,
      157
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 166,
    "question": "Which VLAN is the default management VLAN on all switches?",
    "choice_a": "VLAN 0",
    "choice_b": "VLAN 1",
    "choice_c": "VLAN 255",
    "choice_d": "VLAN 1024",
    "correct_answer": "B",
    "explanation": "VLAN 1 is the default VLAN configured on all switches; it is also used for the management interface. Both VLAN 0 and VLAN 255 are incorrect. There is no such VLAN as VLAN 0. VLAN 1024 is the last VLAN in the configurable VLAN range, before you must use extended VLANs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      168,
      160,
      162,
      167,
      163
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 167,
    "question": "Which wireless protocol will provide you with the maximum distance?",
    "choice_a": "802.11b",
    "choice_b": "802.11a",
    "choice_c": "802.11n",
    "choice_d": "802.11g",
    "correct_answer": "C",
    "explanation": "The 802.11n wireless protocol will provide you with the maximum distance of the listed wireless protocols. The 802.11n wireless protocol will provide you with a nominal distance of 230 feet. The 802.11b wireless protocol provides a nominal distance of 100 to 150 feet The 802.11a wireless protocol provides a nominal distance of 25 to 75 feet. The 802.11g wireless protocol provides a nominal distance of 100 to 150 feet.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      186,
      185,
      183,
      184,
      193
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 168,
    "question": "Which wireless protocol operates exclusively on 2.4 GHz?",
    "choice_a": "802.11g",
    "choice_b": "802.11a",
    "choice_c": "802.11ac",
    "choice_d": "802.11ax",
    "correct_answer": "A",
    "explanation": "The 802.11g wireless protocol operates exclusively on 2.4 GHz with a maximum speed of 54 Mbps. The 802.11a wireless protocol operates exclusively on 5 GHz with a maximum speed of 54 Mbps. The 802.11ac wireless protocol operates exclusively on 5 GHz with a maximum speed of 1 Gbps. The 802.11ax wireless protocol operates on 2.4, 5, and 6 GHz with a maximum speed of 3.5 Gbps and higher.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      183,
      186,
      185,
      188,
      193
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 169,
    "question": "Which protocol is an open-source GUI-based remote assistance tool?",
    "choice_a": "SSH",
    "choice_b": "HTTPS",
    "choice_c": "VNC",
    "choice_d": "RDP",
    "correct_answer": "C",
    "explanation": "The Virtual Network Computing (VNC) protocol is an open-source GUI-based remote assistance tool. The Secure Shell (SSH) protocol is an open-source, console-based remote-control tool. The Hypertext Transfer Protocol Secure (HTTPS) is an open-source GUI-based protocol used for configuration, not remote assistance. The Remote Desktop Protocol (RDP) is a Microsoft GUI-based remote-control protocol.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      74,
      73,
      80,
      14,
      297
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 170,
    "question": "Which method of configuration uses JSON?",
    "choice_a": "VPN",
    "choice_b": "SSH",
    "choice_c": "VNC",
    "choice_d": "API",
    "correct_answer": "D",
    "explanation": "The application programming interface (API) typically uses JavaScript Object Notation (JSON) or Extensible Markup Language (XML) to configure applications. Virtual Private Network (VPN) is a remote-access technology that provides a secure tunnel over the Internet. Secure Shell (SSH) is a console-based remote access protocol. Virtual Network Computing (VNC) is a GUI-based remote assistance protocol.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      215,
      214,
      210,
      211,
      212
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 171,
    "question": "If a host has a network interface queue length of 2, what can you conclude?",
    "choice_a": "The network interface is performing optimally.",
    "choice_b": "The network interface is keeping up with the workload.",
    "choice_c": "The network interface is not keeping up with the workload.",
    "choice_d": "The network interface is down.",
    "correct_answer": "C",
    "explanation": "A network interface with a queue length of 2 or more means that two packets are in the output queue. This suggests that the network interface is not keeping up with the workload. If the network interface queue length was 1 or less, it would suggest the network interface is performing optimally or was keeping up with the workload. If the queue length was incrementally increasing, it would mean the interface is down.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      221,
      255,
      226,
      268,
      227
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 172,
    "question": "Which protocol and port number does SNMP use for get and set messages to the SNMP agent?",
    "choice_a": "UDP/161",
    "choice_b": "TCP/162",
    "choice_c": "UDP/162",
    "choice_d": "UDP/514",
    "correct_answer": "A",
    "explanation": "The SNMP agents listen on UDP/161 for get and set messages. SNMP uses UDP port 162 for communication from an SNMP agent to the network management station (NMS) for trap and inform messages. SNMP does not use TCP for messaging. UDP/514 is used for Syslog messaging.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      78,
      77,
      83,
      72,
      19
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 173,
    "question": "Which metric measures the time it takes for a packet or frame to travel from source to destination?",
    "choice_a": "Latency",
    "choice_b": "Jitter",
    "choice_c": "Bandwidth",
    "choice_d": "Throughput",
    "correct_answer": "A",
    "explanation": "Latency is the time it takes for a packet or frame to travel from source to destination. Jitter is the variation of latency (delay) between the source and destination, and it is measured in milliseconds. Bandwidth is the speed of a connection, and throughput is the utilization of the connection.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      341,
      329,
      335,
      324,
      347
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 174,
    "question": "Which SNMP component is used with SNMP 2c to restrict communications for reading or writing to SNMP counters?",
    "choice_a": "Object identifiers (OIDs)",
    "choice_b": "Management information base",
    "choice_c": "SNMP agent",
    "choice_d": "SNMP community string",
    "correct_answer": "D",
    "explanation": "The SNMP community string is used to restrict communications to only the clients or servers that have a matching SNMP community string. The management information base (MIB) is a database of variables in which SNMP allows retrieval of information. The SNMP agent is the software on the client (network device) that allows SNMP to collect, respond, or pass information to the network management station (NMS). Object identifiers (OIDs) are the addressable counters that are arranged in a hierarchical fashion.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      228,
      226,
      229,
      227,
      234
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 175,
    "question": "What are procedures typically derived from in an organization?",
    "choice_a": "Plan",
    "choice_b": "Policy",
    "choice_c": "Regulation",
    "choice_d": "Code",
    "correct_answer": "B",
    "explanation": "Procedures are typically derived from policies in the organization. For every policy on your network, there should be a credible related procedure that clearly dictates the steps to take in order to fulfill it. All other answers are incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      237,
      238,
      245,
      250,
      246
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 176,
    "question": "You need to draft a document that defines a mutual agreement with a new software vendor. What are you drafting?",
    "choice_a": "IPAM",
    "choice_b": "SLA",
    "choice_c": "MOU",
    "choice_d": "NDA",
    "correct_answer": "C",
    "explanation": "A memorandum of understanding (MOU) is a mutual agreement between two or more parties. IP address management (IPAM) is a tool that helps you plan the allocation of IP addressing for your organization. A service-level agreement (SLA) is used to establish a level of service expected from a provider. A nondisclosure agreement (NDA) is an agreement in which you agree not to disclose organizational information.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      259,
      258,
      268,
      237,
      240
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 177,
    "question": "Which policy would dictate you get access to VPN?",
    "choice_a": "BYOD policy",
    "choice_b": "Security policy",
    "choice_c": "Remote-access policy",
    "choice_d": "Onboarding policy",
    "correct_answer": "C",
    "explanation": "A remote-access policy will dictate who gets access to the organization\u2019s virtual private network (VPN). The bring-your-own-device (BYOD) policy defines the use of personal devices at work. The security policy defines security-related requirements, such as password changes and cipher strengths. The onboarding policy defines how a person starting in the organization is acclimated to the technology.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      245,
      237,
      208,
      242,
      247
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 178,
    "question": "Which site type requires you to set up equipment in the event of a disaster?",
    "choice_a": "Cold site",
    "choice_b": "Cloud site",
    "choice_c": "Warm site",
    "choice_d": "Hot site",
    "correct_answer": "A",
    "explanation": "Cold sites require equipment to be installed and configured in the event of a disaster, and they are the least expensive disaster recovery sites. A cloud recovery site is an extension of the cloud backup services that have developed over the years. Warm sites are between cold and hot sites and require some intervention. Hot sites typically do not require any intervention, except for organizational data restoration.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      272,
      239,
      280,
      268,
      269
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 179,
    "question": "You are recovering a directory that was deleted by accident. You can only restore it from a backup last night at 11 p.m. What is this an example of?",
    "choice_a": "The recovery point objective (RPO)",
    "choice_b": "The recovery time objective (RTO)",
    "choice_c": "GFS rotation",
    "choice_d": "Backup window",
    "correct_answer": "A",
    "explanation": "The recovery point objective (RPO) is the point in time to which you can recover in the event of a disaster. The recovery time objective (RTO) is a measurement of how quickly you can recover from data loss using backup. The grandfather, father, son (GFS) rotation is a systematic way to archive backup media. The backup window is the window of time in which a backup can be performed.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      277,
      268,
      272,
      279,
      239
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 180,
    "question": "You need to purchase a power backup system for a desktop computer. Which backup systems will provide power backup at the lowest cost?",
    "choice_a": "Standby UPS",
    "choice_b": "Line interactive UPS",
    "choice_c": "Online UPS",
    "choice_d": "Generator",
    "correct_answer": "A",
    "explanation": "A standby UPS is the least expensive option for battery backup for devices such as desktop computers. A line-interactive UPS and online UPS are more expensive options and typically used for network or server equipment. A generator will supply long-term AC power in the event of a power outage.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      269,
      271,
      268,
      258,
      272
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 181,
    "question": "Which disk RAID creates a mirror image of your drive and protects you in the event of disk failure?",
    "choice_a": "RAID 1",
    "choice_b": "RAID 5",
    "choice_c": "RAID 6",
    "choice_d": "RAID 0",
    "correct_answer": "A",
    "explanation": "RAID level 1 creates a mirror image of your drive and protects you in the event of a disk failure. RAID level 5 requires three or more disks and protects you in the event of disk failure by calculating a parity block to rebuild the missing disk. RAID level 6 protects you by creating two parity blocks so there is less disk stress during the rebuild. RAID level 0 is not a fault-tolerant disk protection scheme; it is used for performance by striping data.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      266,
      267,
      268,
      276,
      258
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 182,
    "question": "You are building a hypervisor data-center system for your organization. What type of cloud are you creating?",
    "choice_a": "Public",
    "choice_b": "Private",
    "choice_c": "Hybrid",
    "choice_d": "Community",
    "correct_answer": "B",
    "explanation": "A private cloud is a cloud that your organization owns and maintains. A public cloud is a cloud where you can rent computing. A hybrid cloud is both a private and public cloud model that uses both a computing you own and public compute. A community cloud is a rare cloud model in which several organizations join together to share a compute model.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      283,
      301,
      281,
      282,
      285
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 183,
    "question": "Which technique allows you to use tools such as Ansible and Puppet to automate the creation of cloud services?",
    "choice_a": "IaC",
    "choice_b": "SaaS",
    "choice_c": "Version control",
    "choice_d": "Branching",
    "correct_answer": "A",
    "explanation": "Infrastructure as code (IaC) is the technique of using tools such as Ansible or Puppet to automate the creation of cloud services. Software as a service (SaaS) refers to systems like Gmail or Facebook, where the software you use on the Web is a service. Version control is a function of source control. Branching is a function of source control, where you branch code to modify it without disturbing the original source code.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      291,
      302,
      284,
      293,
      294
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 184,
    "question": "Which protocol is used to connect data centers across a layer 3 network?",
    "choice_a": "VLAN",
    "choice_b": "ZTA",
    "choice_c": "VXLAN",
    "choice_d": "ABAC",
    "correct_answer": "C",
    "explanation": "The protocol of a virtual extensible local area network (VXLAN) is used to connect layer 2 data centers together over a layer 3 network. The process of using a VXLAN as an overlay to the underlay of the routing on the Internet. Virtual local area networks (VLANs) are used to segment traffic within a data center. Zero trust architecture (ZTA) is a concept that states no user or device is trusted even if they have been previously authenticated. Attribute-based access control (ABAC) is a method of implementing policy-based authentication.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      298,
      16,
      4,
      81,
      82
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 185,
    "question": "A routing protocol is an example of which SDN plane?",
    "choice_a": "Management",
    "choice_b": "Control",
    "choice_c": "Data",
    "choice_d": "Configuration",
    "correct_answer": "B",
    "explanation": "A routing protocol is an example of the control plane of software-defined networking (SDN). The management plane allows for the administrator to manage the SDN model. The data plane is the data that the SDN serves to control and manage, such as application data. The configuration plane is really the management place and is typically called the management plane.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      295,
      297,
      135,
      134,
      21
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 186,
    "question": "You are setting up a WordPress website on a hosting provider. What type of cloud service is this?",
    "choice_a": "PaaS",
    "choice_b": "IaaS",
    "choice_c": "SaaS",
    "choice_d": "DaaS",
    "correct_answer": "A",
    "explanation": "Platform as a service (PaaS) is a cloud service type where you obtain a platform that can run a WordPress site with MySQL and PHP. Infrastructure as a service (IaaS) is a cloud service type where you can purchase cloud-hosted infrastructure, such as virtual machines and virtual networking. Software as a service (SaaS) is a cloud service where you can rent an application, such as email or CRM apps, just to name a few. Desktop as a service (DaaS) is a cloud service where you can rent a desktop operating system that runs in the cloud.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      284,
      281,
      288,
      301,
      283
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 187,
    "question": "You connect a switch to a switch and realize that the cable in place is a simple patch cable. What is the most likely scenario as to why it worked?",
    "choice_a": "It is a rolled cable.",
    "choice_b": "568B is crimped on both ends of the cable.",
    "choice_c": "The switch supports MDI-X.",
    "choice_d": "The second switch has routing capability.",
    "correct_answer": "C",
    "explanation": "The most likely scenario is that the switch supports Medium Dependent Interface Crossover (MDI-X), which allows you to connect a switch to a switch with a patch cable. A rolled cable is used for connecting a computer to the console port of the switch or router. The wiring code crimped on each end of the cable doesn\u2019t matter for the link of the connection. The switch having routing capabilities does not matter for the link.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      308,
      358,
      323,
      320,
      303
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 188,
    "question": "Which step in the diagnostic process involves gathering information from the user having the issue?",
    "choice_a": "Establish a theory of probable cause.",
    "choice_b": "Identify the problem.",
    "choice_c": "Test the theory to determine the cause.",
    "choice_d": "Implement the solution or escalate as necessary.",
    "correct_answer": "B",
    "explanation": "The step of identifying the problem includes gathering information by questioning users. Establishing a theory of probable cause is the second step. Testing the theory to determine the cause is the third step. Implementing the solution or escalating as necessary is the fifth step in troubleshooting.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      311,
      322,
      312,
      318,
      319
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 189,
    "question": "Which utility can use TCP/IP to find open ports on a host?",
    "choice_a": "<code>nmap</code>",
    "choice_b": "<code>telnet</code>",
    "choice_c": "<code>ping</code>",
    "choice_d": "<code>netstat</code>",
    "correct_answer": "A",
    "explanation": "The Nmap utility (<code>nmap</code>) is used to scan a host for open TCP and UDP ports. Telnet (<code>telnet</code>) is an unencrypted terminal-based emulator that operates across TCP/IP. The program Packet Internet Groper (<code>ping</code>) is used to find out if a host has the IP stack initialized. The <code>netstat</code> command will detail all of the connections to the operating system.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      342,
      325,
      346,
      335,
      328
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 190,
    "question": "Which Linux utility will allow you to capture packets for use with a protocol analyzer?",
    "choice_a": "<code>tcpdump</code>",
    "choice_b": "<code>ifconfig</code>",
    "choice_c": "<code>tracert</code>",
    "choice_d": "<code>netstat</code>",
    "correct_answer": "A",
    "explanation": "The Linux utility <code>tcpdump</code> is used to capture packets for use with a protocol analyzer. The <code>ifconfig</code> utility is similar to the <code>ip</code> command; both are used to view and configure IP address information on Linux. The <code>tracert</code> command will display the path a packet will take through the network to the destination. The <code>netstat</code> command will detail all of the connections to the operating system.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      230,
      226,
      227,
      234,
      223
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 191,
    "question": "Which tool allows you to find the other end of a cable in a wiring closet?",
    "choice_a": "Visual fault locator",
    "choice_b": "Cable tester",
    "choice_c": "Taps",
    "choice_d": "Toner/toner probe kit",
    "correct_answer": "D",
    "explanation": "A toner/toner probe kit is used to locate the other end of a wire in a wiring closet. The toner is connected to one end of the wire, and the toner probe is used to locate the wire end in the closet. A visual fault locator is used to find breaks in a fiber-optic cable. A cable tester is used to test a network cable for continuity and proper wiring. A tap is used to passively insert test equipment in the traffic flow between two devices.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      53,
      71,
      54,
      68,
      151
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 192,
    "question": "Which tool allows you to troubleshoot name resolution problems?",
    "choice_a": "CDP",
    "choice_b": "<code>tracert</code>",
    "choice_c": "<code>ipconfig</code>",
    "choice_d": "<code>nslookup</code>",
    "correct_answer": "D",
    "explanation": "The <code>nslookup</code> command-line utility is used to troubleshoot name resolution problems, similar to the <code>dig</code> command. The Cisco Discovery Protocol (CDP) is a layer 2 Cisco proprietary protocol that helps identify devices. The <code>tracert</code> command-line utility helps you determine the path a packet will take. The <code>ipconfig</code> command is used to view and configure IP address information on Windows.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      338,
      339,
      313,
      362,
      329
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 193,
    "question": "Which element of the CIA triad ensures that information has not been tampered with?",
    "choice_a": "Accessibility",
    "choice_b": "Integrity",
    "choice_c": "Confidentiality",
    "choice_d": "Availability",
    "correct_answer": "B",
    "explanation": "The integrity element ensures that information has not been tampered with. The availability element of the CIA triad ensures that information can be accessible. The confidentiality element ensures that information is kept confidential and can\u2019t be viewed by others, only its intended audience. Accessibility is not an element of the CIA triad.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      366,
      367,
      368,
      370,
      377
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 194,
    "question": "Data is being encrypted with TLS for access via a web browser. Which encryption concept is being exercised?",
    "choice_a": "Data in use",
    "choice_b": "Data in transit",
    "choice_c": "Data at rest",
    "choice_d": "Data on tape",
    "correct_answer": "B",
    "explanation": "Data in transit is protection for data being encrypted with TLS via a web browser. Data in use is protection for data in memory. Data at rest is the encryption concept being exercised when you implement an encryption key for storage. Data on tape is not an encryption concept and falls under data at rest.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      367,
      368,
      369,
      381,
      393
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 195,
    "question": "What is the term for an exploit that has no patch and was recently released?",
    "choice_a": "CVE",
    "choice_b": "Zero day",
    "choice_c": "IAM",
    "choice_d": "MFA",
    "correct_answer": "B",
    "explanation": "A zero day is an exploit in which no patch is available because the exploit was recently released. The common vulnerabilities and exposures (CVE) system is used by all major software vendors to create a common naming scheme for vulnerabilities. Identity and access management (IAM) is a security framework adopted by service providers. Multifactor authentication (MFA) is the use of multiple factors to authenticate a user.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      364,
      365,
      363,
      368,
      382
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 196,
    "question": "Which security concept requires users and computer to be authenticated before accessing information, regardless of whether they have been previously authenticated?",
    "choice_a": "Zero trust",
    "choice_b": "Role-based access",
    "choice_c": "Least privilege",
    "choice_d": "Defense in depth",
    "correct_answer": "A",
    "explanation": "Zero trust is a method of requiring the user to authenticate for each resource they access, regardless of where the asset is located or whether it has previously been authenticated. Role-based access is a method of granting permissions based upon a role in the organization. The principle of least privilege dictates that a user be given the least permission to perform their job. The defense-in-depth security concept is a layered approach to security, where several layers are used to protect the organization.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      377,
      370,
      376,
      397,
      392
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 197,
    "question": "Which is a social engineering tactic involving someone watching you type your password?",
    "choice_a": "Tailgating",
    "choice_b": "Piggybacking",
    "choice_c": "Dumpster diving",
    "choice_d": "Shoulder surfing",
    "correct_answer": "D",
    "explanation": "Shoulder surfing is a social engineering tactic in which someone watches you type your password. Tailgating and piggybacking are social engineering tactics in which someone follows you past a secure area. Dumpster diving is a social engineering tactic in which someone searches trash for information.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      390,
      388,
      389,
      392,
      391
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 198,
    "question": "Which attack involved a threat actor duplicating an SSID so that a threat actor can listen on a victim?",
    "choice_a": "VLAN hopping",
    "choice_b": "MAC spoofing",
    "choice_c": "IP spoofing",
    "choice_d": "Evil twin",
    "correct_answer": "D",
    "explanation": "An evil twin attack involves the threat actor duplicating an SSID so that the threat actor can listen on a victim. VLAN hopping is a tactic in which a VLAN is double tagged so it can hop VLANs. MAC spoofing is a tactic where the source MAC address is spoofed to gain access or be allowed through a MAC filter. IP spoofing involves a threat actor spoofing a source IP address to impersonate an identity.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      385,
      405,
      384,
      400,
      383
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 199,
    "question": "You want to protect yourself from brute-force password attacks. What should you implement?",
    "choice_a": "Multifactor authentication",
    "choice_b": "Software firewalls",
    "choice_c": "Anti-malware",
    "choice_d": "Antivirus",
    "correct_answer": "A",
    "explanation": "Multifactor authentication (MFA) combines two or more single-factor authentication methods to create very secure authentication for users. Anti-malware covers a wide array of security threats to users, including Trojans, viruses, and phishing emails. Software firewalls will protect you from network access. Antivirus software protects you only from viruses and Trojans, not phishing emails.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      371,
      372,
      386,
      392,
      397
    ],
    "source": "235605_PracticeExam2"
  },
  {
    "id": 200,
    "question": "Which network type is locally owned and managed by an organization and used to connect the organization\u2019s LAN together?",
    "choice_a": "MAN",
    "choice_b": "CAN",
    "choice_c": "WAN",
    "choice_d": "PAN",
    "correct_answer": "B",
    "explanation": "A campus area network (CAN) is a connectivity method that is locally owned and managed by an organization to connect multiple LANs together. A metropolitan area network (MAN) is a connectivity method used in a metropolitan area, but it is owned and managed by someone other than the organization. A wide area network (WAN) is a connectivity method that is used for connectivity in a wide area, and it is owned and managed by someone other than the organization. A personal area network (PAN) is a network that connects personal devices within an extremely close vicinity.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      4,
      15,
      2,
      9
    ],
    "source": "235605_ch01"
  },
  {
    "id": 201,
    "question": "Which network topology design has a centralized switch connecting all of the devices?",
    "choice_a": "Star topology",
    "choice_b": "Full mesh topology",
    "choice_c": "Partial mesh topology",
    "choice_d": "Hybrid topology",
    "correct_answer": "A",
    "explanation": "A star topology, also known as hub-and-spoke topology, has a centralized switch connecting all of the devices outward like a star. A full mesh topology allows for a decentralized switching design, where any link failure will not affect switching. A partial mesh topology is normally performed between the layers of core, distribution, and access to allow for a single link failure while maintaining switching services. A hybrid topology is where several different topologies are employed, such as star and mesh.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      7,
      11,
      8,
      15,
      10
    ],
    "source": "235605_ch01"
  },
  {
    "id": 202,
    "question": "Which protocol can be typically found inside a PAN?",
    "choice_a": "Bluetooth",
    "choice_b": "MPLS",
    "choice_c": "SDWAN",
    "choice_d": "vNIC",
    "correct_answer": "A",
    "explanation": "Bluetooth is a common networking protocol found inside a personal area network (PAN) connecting personal devices. Multiprotocol label switching (MPLS) is a technology that uses labels to switch packets. A software-defined wide area network (SDWAN) is a virtual WAN architecture that uses software to manage connectivity, devices, and services. A virtual NIC (vNIC) is used to connect a virtual machine (VM) to a virtual switch (vSwitch).",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      194,
      6,
      2,
      14,
      17
    ],
    "source": "235605_ch01"
  },
  {
    "id": 203,
    "question": "When computers are logically grouped on a LAN based upon a functional department in the organization, what is the group called?",
    "choice_a": "Backbone",
    "choice_b": "CAN",
    "choice_c": "PAN",
    "choice_d": "Workgroup",
    "correct_answer": "D",
    "explanation": "A workgroup is a logical grouping of computers on a local area network (LAN) based upon a department\u2019s function. A backbone is the connectivity method that connects multiple network segments together. A campus area network (CAN) is a network that connects multiple buildings together in close proximity. A personal area network (PAN) is a network that connects personal devices together in close proximity often using Bluetooth technology.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      2,
      6,
      4,
      12,
      10
    ],
    "source": "235605_ch01"
  },
  {
    "id": 204,
    "question": "Which is the primary benefit to using a star topology?",
    "choice_a": "Equal access",
    "choice_b": "Simplicity",
    "choice_c": "Easy to troubleshoot",
    "choice_d": "Redundancy",
    "correct_answer": "C",
    "explanation": "A benefit to the star topology is that it is easy to troubleshoot since each host has its own connection. Equal access is typically a benefit of ring topologies. Bus topologies are typically the simplest network in terms of design, whereas star networks can have redundancy, loops, and many other complex design considerations. Redundancy is not found in star topologies; it is typically in mesh networks.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      7,
      11,
      8,
      10,
      15
    ],
    "source": "235605_ch01"
  },
  {
    "id": 205,
    "question": "What type of logical connection does MPLS create to connect networks together?",
    "choice_a": "Peer-to-peer",
    "choice_b": "Client-server",
    "choice_c": "East-west",
    "choice_d": "Circuit",
    "correct_answer": "D",
    "explanation": "A circuit is the logical connection that MPLS creates to connect networks together. A peer-to-peer connection is a bidirectional logical connection for sharing files and accessing files. A client-server connection is another logical connection created for accessing information in one direction from client to server. East-west is a term used to describe traffic within the same network or data center.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      16,
      83,
      5,
      8
    ],
    "source": "235605_ch01"
  },
  {
    "id": 206,
    "question": "Which type of network is used exclusively for storage traffic?",
    "choice_a": "CAN",
    "choice_b": "SAN",
    "choice_c": "MAN",
    "choice_d": "LAN",
    "correct_answer": "B",
    "explanation": "A storage area network (SAN) is a network that is used exclusively for storage traffic. A campus area network (CAN) is a network that connects buildings together in close proximity. A metropolitan area network (MAN) is a network that connects clients within a metropolitan area, such as a city, together. A local area network (LAN) is a network within a building or residence that connects hosts together.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      16,
      4,
      2,
      12
    ],
    "source": "235605_ch01"
  },
  {
    "id": 207,
    "question": "Which type of traffic flow is routed from your internal network to the Internet?",
    "choice_a": "North-south",
    "choice_b": "East-west",
    "choice_c": "WAN",
    "choice_d": "MAN",
    "correct_answer": "A",
    "explanation": "North-south traffic flow describes the flow of information from an internal network to the Internet or other routed destination. East-west traffic is kept within the internal network or data center and not routed. Wide area network (WAN) and metropolitan area (MAN) network describe a general network type, not traffic flow or a specific connection.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      14,
      287,
      21,
      4,
      2
    ],
    "source": "235605_ch01"
  },
  {
    "id": 208,
    "question": "Which topology incorporates some redundancy of equipment and connections to provide fault tolerance but is not completely fault-tolerant?",
    "choice_a": "Bus",
    "choice_b": "Mesh",
    "choice_c": "Ring",
    "choice_d": "Hybrid",
    "correct_answer": "D",
    "explanation": "A mesh topology incorporates redundancy in the form of switches and redundant connections to provide complete fault tolerance to the network design. When a mesh topology is combined with the star (hub-and-spoke) topology, it creates a hybrid topology that allows for fault-tolerant design at a lower cost than a full mesh topology. Ring and bus topology are susceptible to total network failure if there is a failure anywhere in the network.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      10,
      8,
      11,
      7,
      15
    ],
    "source": "235605_ch01"
  },
  {
    "id": 209,
    "question": "Which topology should be selected if you have a central office that needs to communicate with several branch offices for WAN connectivity?",
    "choice_a": "Point-to-point",
    "choice_b": "Point-to-multipoint",
    "choice_c": "Mesh",
    "choice_d": "Bus",
    "correct_answer": "B",
    "explanation": "A point-to-multipoint topology should be selected if a central office needs to connect with several branch offices. Popular point-to-multipoint connection technologies are frame relay and MPLS, to name a few. A point-to-point connection is typically used to connect two offices together. Mesh and bus topologies are not used for WAN connectivity.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      9,
      15,
      4,
      11,
      8
    ],
    "source": "235605_ch01"
  },
  {
    "id": 210,
    "question": "Which network architecture allows for access or sharing of resources in a network by the same host?",
    "choice_a": "Peer-to-peer",
    "choice_b": "Client-server",
    "choice_c": "LAN",
    "choice_d": "Hybrid topology",
    "correct_answer": "A",
    "explanation": "Peer-to-peer is a network architecture that allows the same host to both access and share resources in a network. Client-server network architecture strictly defines the client that will access the information and the server that shares the information. Local area network (LAN) is a network type and not related to sharing information. Hybrid topology describes a topology that incorporates two or more topologies.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      1,
      2,
      3,
      15
    ],
    "source": "235605_ch01"
  },
  {
    "id": 211,
    "question": "Which is the major advantage of client-server network architecture?",
    "choice_a": "Distributed security",
    "choice_b": "Centralized management",
    "choice_c": "Flexibility",
    "choice_d": "Equal access",
    "correct_answer": "B",
    "explanation": "The major advantage to a client-server network architecture is the ability to have centralized management. Distributed security is not applicable to client-server network architecture and is found in a peer-to-peer network architecture. The client-server relationship is rigid and not very flexible. Equal access is an attribute of peer-to-peer network architecture.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      13,
      296,
      10,
      11
    ],
    "source": "235605_ch01"
  },
  {
    "id": 212,
    "question": "You are setting up a network connection that requires redundancy in the event a switch or single link fails. Which topology should you select?",
    "choice_a": "Bus",
    "choice_b": "Ring",
    "choice_c": "Star",
    "choice_d": "Mesh",
    "correct_answer": "D",
    "explanation": "A mesh topology is used for redundancy and protects a network in the event of a switch or link failure. Bus and ring topologies are very susceptible to failure and require a fully functioning network. A star topology by itself does not offer redundancy in the event of failure.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      11,
      7,
      10,
      15
    ],
    "source": "235605_ch01"
  },
  {
    "id": 213,
    "question": "Where is the full mesh topology commonly seen in the three-tier design model?",
    "choice_a": "Core layer",
    "choice_b": "Distribution layer",
    "choice_c": "Access layer",
    "choice_d": "Routing layer",
    "correct_answer": "B",
    "explanation": "Distribution layer switches are fully meshed for redundancy. The core layer is normally implemented with a star topology. The access layer is normally implemented with a partial mesh topology or hybrid topology. <i>Routing layer</i> is not a valid term in the three-tier design model.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      13,
      8,
      11,
      10,
      9
    ],
    "source": "235605_ch01"
  },
  {
    "id": 214,
    "question": "Which connectivity method is used within a small geographic area to connect an organization together?",
    "choice_a": "MAN",
    "choice_b": "LAN",
    "choice_c": "SAN",
    "choice_d": "PAN",
    "correct_answer": "A",
    "explanation": "A metropolitan area network (MAN) is a network type used in a metropolitan area to connect an organization together. A local area network (LAN) is a connectivity method that connects the immediate network together. A storage area network (SAN) is used exclusively for storage connectivity. A personal area network (PAN) is a network that connects personal devices within an extremely close vicinity.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      2,
      6,
      4,
      194,
      12
    ],
    "source": "235605_ch01"
  },
  {
    "id": 215,
    "question": "Which virtual network element connects multiple VMs together?",
    "choice_a": "Hypervisor",
    "choice_b": "vSwitch",
    "choice_c": "Load balancer",
    "choice_d": "NFV",
    "correct_answer": "B",
    "explanation": "A virtual switch (vSwitch) is used to connect multiple VMs together. A hypervisor is software that allows the sharing of the compute, network, and storage of a physical host or group of hosts that have direct access to these resources. A load balancer is used to distribute the load for a network service. A network function virtualization (NFV) is a function that is virtualized, such as a router or firewall, to name a few.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      14,
      285,
      16,
      282,
      288
    ],
    "source": "235605_ch01"
  },
  {
    "id": 216,
    "question": "When you tether a cell phone to your laptops using wireless, what is this an example of?",
    "choice_a": "SAN",
    "choice_b": "MAN",
    "choice_c": "CAN",
    "choice_d": "PAN",
    "correct_answer": "D",
    "explanation": "A personal area network (PAN) is a network that connects personal devices within an extremely close vicinity, such as a cell phone to a laptop. A storage area network (SAN) is used exclusively for storage connectivity. A metropolitan area network (MAN) is a network type used in a metropolitan area to connect an organization together. A campus area network (CAN) is a connectivity method that connects several LANs together in a small geographic area.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      194,
      2,
      4,
      9
    ],
    "source": "235605_ch01"
  },
  {
    "id": 217,
    "question": "What is the term used to describe the common network used to connect multiple network segments at high speed?",
    "choice_a": "Backbone",
    "choice_b": "WAN",
    "choice_c": "PAN",
    "choice_d": "Workgroup",
    "correct_answer": "A",
    "explanation": "A backbone is the connectivity method that connects multiple network segments at high speed. A wide area network (WAN) is typically used for Internet connectivity. A personal area network (PAN) is a network that connects personal devices in close proximity. A workgroup is a logical grouping of computers on a local area network (LAN) based upon a department\u2019s function.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      12,
      4,
      2,
      6,
      194
    ],
    "source": "235605_ch01"
  },
  {
    "id": 218,
    "question": "What is a smart jack as it relates to WAN connectivity?",
    "choice_a": "Demarc",
    "choice_b": "NFV",
    "choice_c": "Load balancer",
    "choice_d": "Router",
    "correct_answer": "A",
    "explanation": "The demarc, also known as the demarcation point, is a term used to describe a smart jack for a service provider. A network function virtualization (NFV) is a function that is virtualized, such as a router or firewall, to name a few. A load balancer is used to distribute the load for a network service. A router will typically connect to the smart jack for WAN connectivity.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      12,
      35,
      4,
      15,
      285
    ],
    "source": "235605_ch01"
  },
  {
    "id": 219,
    "question": "Which protocol is used with dynamic multipoint VPN deployments?",
    "choice_a": "mGRE",
    "choice_b": "MPLS",
    "choice_c": "SDWAN",
    "choice_d": "vNIC",
    "correct_answer": "A",
    "explanation": "Multipoint Generic Routing Encapsulation (mGRE) is used in conjunction with dynamic multipoint VPN to facilitate connections. Multiprotocol Label Switching (MPLS) is a technology that uses labels to switch packets and is an alternative to dynamic multipoint VPN. Software-defined wide area network (SDWAN) is a virtual WAN architecture that uses software to manage connectivity, devices, and services. A virtual NIC (vNIC) is used to connect a virtual machine to a virtual switch (vSwitch).",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      80,
      4,
      6,
      14,
      298
    ],
    "source": "235605_ch01"
  },
  {
    "id": 220,
    "question": "Flow control can be found at which layer of the OSI?",
    "choice_a": "Transport layer",
    "choice_b": "Network layer",
    "choice_c": "Data Link layer",
    "choice_d": "Session layer",
    "correct_answer": "A",
    "explanation": "The Transport layer is responsible for flow control via the TCP/IP protocols of TCP and UDP. The Network layer is responsible for the logical addressing of network nodes. The Data Link layer is responsible for the framing of data and the physical addressing of local nodes. The Session layer is responsible for setting up the dialogue between two hosts.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      20,
      77,
      81,
      82
    ],
    "source": "235605_ch02"
  },
  {
    "id": 221,
    "question": "What is required before TCP can begin sending segments?",
    "choice_a": "Three-way handshake",
    "choice_b": "Port agreement",
    "choice_c": "Sequencing of segments",
    "choice_d": "Acknowledgment of segments",
    "correct_answer": "A",
    "explanation": "A three-way handshake is required between the sender and receiver before TCP can begin sending segments. During this three-way handshake, the sender\u2019s window buffer size is synchronized with the receiver\u2019s window buffer size. Ports are not agreed upon; they are used to address traffic at the Transport layer. The sequencing and acknowledgment of segments are functions of the TCP protocol.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      20,
      77,
      81,
      82
    ],
    "source": "235605_ch02"
  },
  {
    "id": 222,
    "question": "Which layer of the OSI is responsible for dialogue control of applications?",
    "choice_a": "Application layer",
    "choice_b": "Physical layer",
    "choice_c": "Session layer",
    "choice_d": "Network layer",
    "correct_answer": "C",
    "explanation": "The Session layer is responsible for offsetting up the dialogue between two hosts. The Application layer is responsible for API access and beginning the network communication process. The Physical layer is responsible for transmitting data over light, electricity, and air waves. The Network layer is responsible for the logical addressing of IP addresses.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      17,
      19,
      81,
      23
    ],
    "source": "235605_ch02"
  },
  {
    "id": 223,
    "question": "Which layer is responsible for compression and decompression?",
    "choice_a": "Application layer",
    "choice_b": "Physical layer",
    "choice_c": "Session layer",
    "choice_d": "Presentation layer",
    "correct_answer": "D",
    "explanation": "The Presentation layer is responsible for compression and decompression, as well as encryption and decryption. The Application layer is responsible for API access and beginning the network communication process. The Physical layer is responsible for transmitting data over light, electricity, and air waves. The Session layer is responsible for setting up the dialogue between two hosts.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      81,
      82,
      72,
      19
    ],
    "source": "235605_ch02"
  },
  {
    "id": 224,
    "question": "Which OSI layer is responsible for logical addressing?",
    "choice_a": "Transport layer",
    "choice_b": "Network layer",
    "choice_c": "Application layer",
    "choice_d": "Data Link layer",
    "correct_answer": "B",
    "explanation": "The Network layer is responsible for logical addressing. Routers use logical addressing to determine the path to remote networks. The Transport layer is responsible for flow control and creating virtual circuits. The Application layer is responsible for API access and beginning the network communication process. The Data Link layer is responsible for the framing of data and the physical addressing of local nodes.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      21,
      17,
      22,
      19,
      23
    ],
    "source": "235605_ch02"
  },
  {
    "id": 225,
    "question": "As information travels down the network stack from the Application layer to the Physical layer, what happens?",
    "choice_a": "Datagrams",
    "choice_b": "PDUs",
    "choice_c": "Encapsulation",
    "choice_d": "Decapsulation",
    "correct_answer": "C",
    "explanation": "As information travels down the network stack from the Application later to the Physical layer, the information is encapsulated by each layer. The information at the upper layers is referred to as datagrams. The terminology of each type of data as it pertains to the OSI layers is protocol data units (PDUs). Decapsulation is the action of removing the encapsulated information as it goes up the network stack from the Physical layer to the Application layer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      81,
      82,
      23,
      17,
      22
    ],
    "source": "235605_ch02"
  },
  {
    "id": 226,
    "question": "Which sublayer of the Data Link OSI layer is responsible for identifying Network layer protocols and encapsulating them?",
    "choice_a": "MAC",
    "choice_b": "LLC",
    "choice_c": "Data Link",
    "choice_d": "Session",
    "correct_answer": "B",
    "explanation": "The logical link control (LLC) sublayer is responsible for managing access to Network layer protocols. The media access control (MAC) sublayer is responsible for physical addressing and framing data for the transmission media. The Data Link layer is responsible for framing data and contains the LLC and MAC sublayers. The Session layer is responsible for dialogue control.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      17,
      23,
      81,
      82,
      43
    ],
    "source": "235605_ch02"
  },
  {
    "id": 227,
    "question": "Which is <i>not</i> a benefit to the OSI model?",
    "choice_a": "Multivendor development with a standardized model",
    "choice_b": "Prevents a change in one layer from affecting other layers",
    "choice_c": "Allows various network hardware and software to communicate",
    "choice_d": "Allows software to run at network speeds",
    "correct_answer": "D",
    "explanation": "The OSI reference model will not aid in allowing software to run at network speeds; this will be up to the developer. The OSI reference standardized model will allow for multivendor development. The OSI reference model will prevent a change in one layer from affecting other layers. The OSI reference model will also allow various network hardware and software to communicate.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      17,
      23,
      81,
      82,
      22
    ],
    "source": "235605_ch02"
  },
  {
    "id": 228,
    "question": "Which three upper layers operate together?",
    "choice_a": "Application, Presentation, and Session",
    "choice_b": "Presentation, Session, and Transport",
    "choice_c": "Transport, Session, and Application",
    "choice_d": "Network, Data Link, and Physical",
    "correct_answer": "A",
    "explanation": "The Application, Presentation, and Session layers operate together to process datagrams. All other answers are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      17,
      82,
      81,
      72
    ],
    "source": "235605_ch02"
  },
  {
    "id": 229,
    "question": "Which 802 working group defines the LLC sublayer of the Data Link layer?",
    "choice_a": "802.2",
    "choice_b": "802.3",
    "choice_c": "802.15",
    "choice_d": "802.11",
    "correct_answer": "A",
    "explanation": "The IEEE 802.2 working group defines the Logic Link Control (LLC) sublayer of the Data Link layer. The IEEE 802.3 and 802.11 working groups define the Media Access Control (MAC) sublayer of the Data Link layer. The IEEE 802.15 working group defines wireless personal area networks (WPANs).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      43,
      81,
      82,
      72
    ],
    "source": "235605_ch02"
  },
  {
    "id": 230,
    "question": "Which concept describes transmitting multiple segments before the receiving host acknowledges the data?",
    "choice_a": "Sequencing",
    "choice_b": "Compression",
    "choice_c": "Windowing",
    "choice_d": "Encryption",
    "correct_answer": "C",
    "explanation": "The concept of transmitting multiple segments before the receiving host acknowledges the data is windowing. Sequencing is done with each segment so they can be combined back together at the Transport layer. Compression and encryption are found at the Presentation layer, and neither is the correct answer.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      20,
      19,
      82,
      23,
      81
    ],
    "source": "235605_ch02"
  },
  {
    "id": 231,
    "question": "Which device will stop broadcasts from propagating the network?",
    "choice_a": "Router",
    "choice_b": "Switch",
    "choice_c": "Hub",
    "choice_d": "WAP",
    "correct_answer": "A",
    "explanation": "By default, a router will stop broadcasts from propagating the network. A switch, hub, and wireless access point (WAP) will not stop broadcasts from propagating the network.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      40,
      7,
      12,
      15,
      33
    ],
    "source": "235605_ch02"
  },
  {
    "id": 232,
    "question": "Which is used to determine the best path to a destination network?",
    "choice_a": "Acknowledgment",
    "choice_b": "Network address",
    "choice_c": "Interface",
    "choice_d": "Metric",
    "correct_answer": "D",
    "explanation": "The route table is checked for a destination packet, but the metric associated with the destination network is how the best path is determined. Acknowledgments are used by the receiving computer to acknowledge the receipt of segments. The network address is the logical addressing of hosts. The interface is the physical connection to the network.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      21,
      17,
      23,
      82,
      72
    ],
    "source": "235605_ch02"
  },
  {
    "id": 233,
    "question": "Which protocol data unit (PDU) is used to describe data at the Physical layer?",
    "choice_a": "Datagrams",
    "choice_b": "Bits",
    "choice_c": "Frames",
    "choice_d": "Segments",
    "correct_answer": "B",
    "explanation": "The PDU that describes data at the Physical layer is bits. The PDU of datagrams is used to describe data at the upper layers. The PDU of frames is used to describe data at the Data Link layer. The PDU of segments is used to describe data at the Transport layer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      81,
      82,
      22,
      43,
      44
    ],
    "source": "235605_ch02"
  },
  {
    "id": 234,
    "question": "Which OSI layers are responsible for framing data and transmitting the data?",
    "choice_a": "LLC and Physical layers",
    "choice_b": "Data Link and Physical layers",
    "choice_c": "Network and Transport layers",
    "choice_d": "Session and Transport layers",
    "correct_answer": "B",
    "explanation": "The Data Link and Physical layers are responsible for framing data and transmitting it on the media. The LLC is a sublayer that is responsible for encapsulating Network layer protocols. All other answer are incorrect.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      22,
      43,
      82,
      23,
      17
    ],
    "source": "235605_ch02"
  },
  {
    "id": 235,
    "question": "Which layer is responsible for creating a virtual circuit?",
    "choice_a": "Presentation",
    "choice_b": "Session",
    "choice_c": "Transport",
    "choice_d": "Network",
    "correct_answer": "C",
    "explanation": "The Transport layer is responsible for flow control and creating virtual circuits. The Presentation layer is responsible for compression/decompression and encryption/decryption. The Session layer is responsible for dialogue control. The Network layer is responsible for logical addressing.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      83,
      20,
      77,
      18
    ],
    "source": "235605_ch02"
  },
  {
    "id": 236,
    "question": "TCP and UDP reside at which layer of the OSI model?",
    "choice_a": "Physical",
    "choice_b": "Session",
    "choice_c": "Network",
    "choice_d": "Transport",
    "correct_answer": "D",
    "explanation": "Both TCP and UDP reside at the Transport layer. All other answers are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      77,
      19,
      17,
      82,
      72
    ],
    "source": "235605_ch02"
  },
  {
    "id": 237,
    "question": "What is the proper order of data encapsulation?",
    "choice_a": "Datagram, segment, packet, frame, bits",
    "choice_b": "Bits, frame, packet, segment, datagram",
    "choice_c": "Segment, datagram, packet, frame, bits",
    "choice_d": "Datagram, packet, segment, frame, bits",
    "correct_answer": "A",
    "explanation": "The correct order for data encapsulation is datagram, segment, packet, frame, bits. All other answers are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      82,
      81,
      23,
      22,
      43
    ],
    "source": "235605_ch02"
  },
  {
    "id": 238,
    "question": "Which layer is responsible for routing data packets?",
    "choice_a": "Physical",
    "choice_b": "Data Link",
    "choice_c": "Transport",
    "choice_d": "Network",
    "correct_answer": "D",
    "explanation": "The Network layer is responsible for routing network packets. The Physical layer is responsible for physical connectivity and transmitting bits. The Data Link layer is responsible for framing bits. The Transport layer is responsible for creating virtual circuits and flow control.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      21,
      79,
      81,
      82,
      72
    ],
    "source": "235605_ch02"
  },
  {
    "id": 239,
    "question": "Which IEEE standard specifies the protocol for CSMA/CD?",
    "choice_a": "802.2",
    "choice_b": "802.3",
    "choice_c": "802.5",
    "choice_d": "802.11",
    "correct_answer": "B",
    "explanation": "The IEEE standard of 802.3 specifies the carrier sense multiple access/collision detection (CSMA/CD) contention method. The IEEE standard of 802.2 specifies how the network layer should be encapsulated for multiprotocol operation. The IEEE standard for 802.5 details the disbanded Token Ring specification. The 802.11 details the wireless specifications.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      38,
      44,
      43,
      22,
      82
    ],
    "source": "235605_ch02"
  },
  {
    "id": 240,
    "question": "You are planning to run fiber-optic cable between two buildings that are 6,000 feet apart. Which is the best solution to complete this project?",
    "choice_a": "SMF",
    "choice_b": "MMF",
    "choice_c": "MDF",
    "choice_d": "IDF",
    "correct_answer": "A",
    "explanation": "A single-mode fiber (SMF) cable can carry signals up to 80 km before the signal needs to be repeated. Multimode fiber (MMF) has a maximum distance of 3,000 feet. A main distribution frame (MDF) is a wiring point that\u2019s generally used as a main reference point for telephone lines. An intermediate distribution frame (IDF) is a remote point of reference typically located in an equipment or telecommunications room.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      35,
      31,
      46,
      29
    ],
    "source": "235605_ch03"
  },
  {
    "id": 241,
    "question": "You need to connect a switch to another switch. Which type of cable should you use to properly create the connection between the two switches?",
    "choice_a": "Straight-through cable",
    "choice_b": "Rolled cable",
    "choice_c": "Crossover cable",
    "choice_d": "T1 crossover cable",
    "correct_answer": "C",
    "explanation": "A crossover cable is the proper cable to connect a switch to a switch. A straight-through cable is not the proper cable to connect a switch to a switch and is typically used to connect hosts to a switch. A rolled cable is used for serial connectivity to the switch. A T1 crossover cable is used to connect a router to a router via T1 serial lines.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      33,
      34,
      31,
      26,
      45
    ],
    "source": "235605_ch03"
  },
  {
    "id": 242,
    "question": "You are designing a network in a building that has arc welders. Which cable should be used to eliminate EMI?",
    "choice_a": "Category 5e",
    "choice_b": "UTP",
    "choice_c": "Twinaxial",
    "choice_d": "Fiber optic",
    "correct_answer": "D",
    "explanation": "Fiber-optic cable should be used to eliminate electromagnetic interference (EMI) and radio frequency interference (RFI). Category 5e is a type of unshielded twisted-pair (UTP); it will not prevent EMI. Twinaxial cable is a type of coaxial cable used to connect network equipment at high speeds for short distances.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      28,
      31,
      26,
      30,
      25
    ],
    "source": "235605_ch03"
  },
  {
    "id": 243,
    "question": "Which connector type is typically found on a Category 6 cable?",
    "choice_a": "RJ-45",
    "choice_b": "RJ-11",
    "choice_c": "BNC",
    "choice_d": "APC",
    "correct_answer": "A",
    "explanation": "An RJ-45, also known as a registered jack 45, is used for terminating networking cabling, such as Category 5/6/7/8 cable. An RJ-11 registered jack is used to terminate phone cabling. A Bayonet Neill\u2013Concelman (BNC) connector is used to terminate coaxial cable. An angled physical contact (APC) is used to terminate fiber-optic cable.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      27,
      26,
      28,
      25,
      35
    ],
    "source": "235605_ch03"
  },
  {
    "id": 244,
    "question": "You need to make a Category 5e crossover cable. Which wiring standard will you use on both ends?",
    "choice_a": "568A-to-568A",
    "choice_b": "568B-to-568A",
    "choice_c": "568B-to-568B",
    "choice_d": "APC-to-UPC",
    "correct_answer": "B",
    "explanation": "When making a crossover cable for any network cable, the 568B wiring standard should be used on one end, and the 568A wiring standard should be used on the other end. A straight-through cable is created when you crimp the 568A-to-568A or 568B-to-568B wiring standard on both ends of a network cable. The terms <i>angled physical contact</i> (<i>APC</i>) and <i>ultra physical contact</i> (<i>UPC</i>) are used to describe the finish on a fiber-optic cable end.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      27,
      33,
      26,
      31
    ],
    "source": "235605_ch03"
  },
  {
    "id": 245,
    "question": "You need to install cabling in an office space and want to be assured that toxic vapors will not be created in the event of a fire. Which cable type should you choose?",
    "choice_a": "PVC",
    "choice_b": "FEP",
    "choice_c": "Non-plenum",
    "choice_d": "Plenum",
    "correct_answer": "D",
    "explanation": "You should always use plenum-rated cable in office spaces to avoid toxic vapors released in the event of a fire. Polyvinyl chloride (PVC) and fluoroethylene propylene (FEP) are plastics that can create poisonous vapers in the event of a fire. Non-plenum rated cables are typically made from plastics.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      25,
      26,
      30,
      34,
      35
    ],
    "source": "235605_ch03"
  },
  {
    "id": 246,
    "question": "Which serial connection method is typically used for connecting peripherals to a PC?",
    "choice_a": "DB-9",
    "choice_b": "USB",
    "choice_c": "Category 3",
    "choice_d": "Rolled cable",
    "correct_answer": "B",
    "explanation": "A Universal Serial Bus (USB) connection method is typically used for connecting peripherals to a PC. A DB-9 connector is typically used to connect serial connections for router or switch configuration. A Category 3 cable is a network cable specification. A rolled cable is used to connect a router or switch to a PC for configuration.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      30,
      34,
      33,
      26,
      25
    ],
    "source": "235605_ch03"
  },
  {
    "id": 247,
    "question": "You need to run a UTP cable for 10 Gbps speeds with a distance of 100 meters. Which minimum cable category rating should you use?",
    "choice_a": "Category 5",
    "choice_b": "Category 5e",
    "choice_c": "Category 6",
    "choice_d": "Category 6A",
    "correct_answer": "D",
    "explanation": "Category 6A (augmented) will handle speeds of 10 Gbps at a distance of 100 meters. Category 5 is capable of speeds of 100 Mbps at a distance of 100 meters. Category 5e is capable of 1 Gbps at a distance of 100 meters. Category 6 is capable of 10 Gbps up to a maximum distance of 55 meters.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      26,
      31,
      46,
      47,
      44
    ],
    "source": "235605_ch03"
  },
  {
    "id": 248,
    "question": "Which is an incorrect statement about smart jacks?",
    "choice_a": "A smart jack is a demarcation point.",
    "choice_b": "A smart jack can be remotely put into a loopback mode.",
    "choice_c": "A smart jack can report trouble in a circuit.",
    "choice_d": "A smart jack is also called a network interface device (NID).",
    "correct_answer": "C",
    "explanation": "A smart jack cannot report trouble in a circuit. The smart jack is typically the demarcation point for a provider. A smart jack can remotely be put into a loopback mode to verify operations. A smart jack is also known as a network interface device (NID) or network interface unit (NIU).",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      322,
      311,
      320,
      324,
      327
    ],
    "source": "235605_ch03"
  },
  {
    "id": 249,
    "question": "Which term describes what happens to the signal in a network cable as you make the cable\u2019s distance greater?",
    "choice_a": "Attenuation",
    "choice_b": "Duplex",
    "choice_c": "Demarcation",
    "choice_d": "EMI",
    "correct_answer": "A",
    "explanation": "The signal on a cable will attenuate as the distance of the cable lengthens. Duplex refers to the path of signaling on a network cable. Demarcation or demarc refers to the point of responsibility for a network provider. Electromagnetic interference (EMI) is interference that is induced into a network cable from an external source.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      31,
      26,
      25,
      35,
      33
    ],
    "source": "235605_ch03"
  },
  {
    "id": 250,
    "question": "Which cable has no metallic shielding?",
    "choice_a": "STP",
    "choice_b": "UTP",
    "choice_c": "Coaxial",
    "choice_d": "Twinaxial",
    "correct_answer": "B",
    "explanation": "Unshielded twisted-pair (UTP), as its name implies, is unshielded cabling. Shielded twisted-pair (STP), coaxial, and twinaxial have metallic shielding around the outside of the cabling.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      26,
      25,
      28,
      31,
      33
    ],
    "source": "235605_ch03"
  },
  {
    "id": 251,
    "question": "Which connector is typically used on the end of a coaxial cable?",
    "choice_a": "RJ-45",
    "choice_b": "RJ-11",
    "choice_c": "SC",
    "choice_d": "F-type",
    "correct_answer": "D",
    "explanation": "An F-type or BNC connector is typically found on the end of a coaxial cable. RJ-45 connectors are typically found on the ends of network cable. RJ-11 connectors are typically used for phone connection. A subscriber (or square) connector (SC) is used with fiber-optic cables.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      25,
      27,
      28,
      32,
      42
    ],
    "source": "235605_ch03"
  },
  {
    "id": 252,
    "question": "Which fiber-optic connector uses a BNC style mechanism to lock the cable in place?",
    "choice_a": "ST",
    "choice_b": "SC",
    "choice_c": "LC",
    "choice_d": "MT-RJ",
    "correct_answer": "A",
    "explanation": "The straight tip (ST) connector uses a BNC style mechanism to lock the fiber-optic cable in place. The subscriber (or square) connector (SC) is a square plastic connector. The local connector (LC) is a square style connector that is made for high-density applications. The mechanical transfer registered jack (MT-RJ or MTRJ) is another small form factor connector.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      25,
      29,
      33,
      35
    ],
    "source": "235605_ch03"
  },
  {
    "id": 253,
    "question": "Which technique is used to prevent crosstalk on network cables?",
    "choice_a": "T-568A/B wiring standard",
    "choice_b": "Use of STP cables",
    "choice_c": "Rolling the cable",
    "choice_d": "Short distance installations",
    "correct_answer": "A",
    "explanation": "The Telecommunications Industry Association/Electronic Industries Alliance (TIA/EIA) T-568A/B wiring standard is used to prevent crosstalk. The use of shield twisted-pair (STP) cabling will prevent electromagnetic interference (EMI). A rolled cable is a type of wiring used with console ports on switches and routers for configuration; it does not prevent crosstalk. Short distance installations will not prevent crosstalk on cables.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      32,
      27,
      31,
      26,
      33
    ],
    "source": "235605_ch03"
  },
  {
    "id": 254,
    "question": "Which transceiver will support up to 40 Gbps links?",
    "choice_a": "SFP+",
    "choice_b": "QSFP",
    "choice_c": "QSFP+",
    "choice_d": "QSFP28",
    "correct_answer": "C",
    "explanation": "The quad small form-factor pluggable+ (QSFP+) transceiver will support 4x10 Gbps for a total of 40 Gbps. The enhanced small form-factor pluggable (SFP+) transceiver will support up to 16 Gbps. The QSFP transceiver will support up 4x1 Gbps for a total of 4 Gbps. The QSFP28 will support 4x28 Gbps for a total of 100 Gbps.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      29,
      44,
      40,
      82,
      26
    ],
    "source": "235605_ch03"
  },
  {
    "id": 255,
    "question": "Which connector will you find on a rolled cable?",
    "choice_a": "RJ-11",
    "choice_b": "RJ-45",
    "choice_c": "BNC",
    "choice_d": "SC",
    "correct_answer": "B",
    "explanation": "An RJ-45 connector also known as a registered jack 45 is used for terminating a rolled cable that is used to connect to a switch or router for configuration. An RJ-11 connector is used to terminate phone cabling. A Bayonet Neill\u2013Concelman (BNC) connector is used to terminate coaxial cable. The subscriber (or square) connector (SC) is a square plastic fiber-optic connector.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      27,
      34,
      25,
      28,
      35
    ],
    "source": "235605_ch03"
  },
  {
    "id": 256,
    "question": "What is the main difference between single-mode fiber (SMF) and multimode fiber (MMF)?",
    "choice_a": "Electrical signals.",
    "choice_b": "Number of light rays.",
    "choice_c": "Category rating.",
    "choice_d": "That signal-mode can be run a shorter distance.",
    "correct_answer": "B",
    "explanation": "The main difference between single-mode fibers and multimode fibers is in the number of light rays (and thus the number of signals) they can carry. Fiber-optic cables carry light waves and not electrical signals. Category ratings are used for copper Ethernet Twisted-pair cables. Single-mode fiber can run very far distances up to 80 kilometers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      46,
      29,
      31,
      44
    ],
    "source": "235605_ch03"
  },
  {
    "id": 257,
    "question": "Which fiber-optic connector has a very small footprint for high-density installations?",
    "choice_a": "SC",
    "choice_b": "ST",
    "choice_c": "LC",
    "choice_d": "FC",
    "correct_answer": "C",
    "explanation": "The local connector (LC) is a small form factor (SFF) connector used for high-density installations. The subscriber (or square) connector (SC) is a square plastic connector. The straight tip (ST) connector uses a BNC-style mechanism to lock the fiber-optic cable in place. Fibre Channel (FC) is a SAN technology that can use any of fiber-optic connector, but typically the connector is an LC connector for high-density installation.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      29,
      16,
      6,
      40
    ],
    "source": "235605_ch03"
  },
  {
    "id": 258,
    "question": "You need to connect a switch that only supports multimode fiber to an existing single-mode fiber-optic line. What should you use to create a connection?",
    "choice_a": "APC connector",
    "choice_b": "UPC connector",
    "choice_c": "SFP+ transceiver",
    "choice_d": "Media converter",
    "correct_answer": "D",
    "explanation": "A media converter that converts single-mode fiber (SMF) to multimode fiber (MMF) is required to create a solid connection. The angled physical contact (APC) cable end is slightly angled to reduce decibel loss. The ultra physical contact (UPC) cable end is domed to reduce decibel loss. The enhanced small form-factor pluggable (SFP+) transceiver supports data rates up to 16 Gbps.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      29,
      28,
      46,
      31,
      22
    ],
    "source": "235605_ch03"
  },
  {
    "id": 259,
    "question": "Which cable type is considered a patch cable?",
    "choice_a": "Straight-through cable",
    "choice_b": "Rolled cable",
    "choice_c": "Crossover cable",
    "choice_d": "STP",
    "correct_answer": "A",
    "explanation": "A straight-through cable is used to patch hosts to a network switch; therefore, it is known as a patch cable. A rolled cable is used for serial connectivity to the switch. A crossover cable is typically used to connect a switch to a switch. Shielded twisted-pair (STP) cable is a type of cable that has metallic shielding to resist electromagnetic interference (EMI) and radio frequency interference (RFI).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      33,
      34,
      31,
      26,
      25
    ],
    "source": "235605_ch03"
  },
  {
    "id": 260,
    "question": "Which contention method does 802.3 Ethernet use for collisions?",
    "choice_a": "CSMA/CD",
    "choice_b": "CSMA/CA",
    "choice_c": "Half-duplex",
    "choice_d": "Full-duplex",
    "correct_answer": "A",
    "explanation": "Ethernet uses carrier sense multiple access with collision detection (CSMA/CD) as the main contention method for collisions with half-duplex communications. Carrier sense multiple access with collision avoidance (CSMA/CA) is used with 802.11 wireless communications as the main contention method for collisions. Half-duplex mode requires a contention method since the same pair is used for transmitting and receiving bits. Full-duplex mode does not require a contention method for collisions since there is a dedicated pair of wires for transmitting and a dedicated pair of wire for receiving bits.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      38,
      40,
      39,
      37,
      43
    ],
    "source": "235605_ch04"
  },
  {
    "id": 261,
    "question": "Which field in an Ethernet frame is used to check the integrity of the frame?",
    "choice_a": "SOF",
    "choice_b": "Preamble",
    "choice_c": "DA",
    "choice_d": "FCS",
    "correct_answer": "D",
    "explanation": "The frame checking sequence (FCS) is a cyclical redundancy check (CRC) calculation used to check the integrity of the frame. The start of frame (SOF) delimiter is a one-byte field of alternating 1s and 0s that signifies the start of the frame. The preamble allows the other physical connection to synchronize its clocks for the data that follows. The destination address (DA) is the destination MAC address the frame is destined for.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      43,
      22,
      81,
      40,
      82
    ],
    "source": "235605_ch04"
  },
  {
    "id": 262,
    "question": "What is the significance of the preamble?",
    "choice_a": "The preamble allows the switch to allocate a buffer.",
    "choice_b": "The preamble allows the switch to sense collisions before data is transmitted.",
    "choice_c": "The preamble allows the switch to sync timing for the receipt of information to follow.",
    "choice_d": "The preamble allows the switch to read the sequence and acknowledge receipt of the frame.",
    "correct_answer": "C",
    "explanation": "The preamble allows for the source computer to sync its timing of the physical media\u2013independent interface with the destination computer. It achieves this via an alternating 1 and 0 pattern at a specific frequency depending on data transfer speed. The SFD has an extra bit to let the destination computer know anything that follows is data.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      22,
      44,
      81,
      82,
      37
    ],
    "source": "235605_ch04"
  },
  {
    "id": 263,
    "question": "In a layer 2 frame, where is the destination MAC address?",
    "choice_a": "The destination MAC address is the first 6 bytes after the preamble.",
    "choice_b": "The destination MAC address is the second 6 bytes after the preamble.",
    "choice_c": "The destination MAC address is the payload data.",
    "choice_d": "The destination MAC address is found in the preamble.",
    "correct_answer": "A",
    "explanation": "The 6-byte destination MAC address is after the preamble/SFD so that it can be read by the switch for forwarding. All other answers are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      43,
      22,
      42,
      40,
      82
    ],
    "source": "235605_ch04"
  },
  {
    "id": 264,
    "question": "How many bits is the OUI assigned by the IEEE?",
    "choice_a": "6 bits",
    "choice_b": "22 bits",
    "choice_c": "24 bits",
    "choice_d": "48 bits",
    "correct_answer": "C",
    "explanation": "The organizationally unique identifier (OUI) is 24 bits or the first 3 bytes of the MAC address.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      42,
      22,
      36,
      41,
      44
    ],
    "source": "235605_ch04"
  },
  {
    "id": 265,
    "question": "If the I/G or Individual/Group bit is set to 1 in the OUI portion of the MAC address, which statement is true?",
    "choice_a": "The MAC address is a unique individual computer by the IEEE.",
    "choice_b": "The MAC address is locally governed.",
    "choice_c": "The MAC address is a broadcast or multicast.",
    "choice_d": "The MAC address should always be broadcast.",
    "correct_answer": "C",
    "explanation": "When the I/G bit is set, it means that the MAC address is intended to be a broadcast or multicast for a group of recipients. All other answers are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      42,
      36,
      88,
      43,
      37
    ],
    "source": "235605_ch04"
  },
  {
    "id": 266,
    "question": "If the L/G or Local/Group bit is set to 1 in the OUI portion of the MAC address, which statement is true?",
    "choice_a": "The MAC address is a unique individual computer by the IEEE.",
    "choice_b": "The MAC address is locally governed.",
    "choice_c": "The MAC address is a broadcast or multicast.",
    "choice_d": "The MAC address should always be broadcast.",
    "correct_answer": "B",
    "explanation": "When the L/G bit (sometimes referred to as the U/L bit) is set, it means the MAC address is locally governed. This means the user has manually set the MAC address. All other answers are incorrect.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      42,
      43,
      22,
      36,
      40
    ],
    "source": "235605_ch04"
  },
  {
    "id": 267,
    "question": "Which is a reason that the Ethernet protocol uses physical addresses?",
    "choice_a": "It creates a differentiation between layer 2 and layer 3 communications.",
    "choice_b": "It defines a logical address scheme for devices.",
    "choice_c": "It uniquely identifies devices at layer 2.",
    "choice_d": "It allows the node to decide if the device is remote or local.",
    "correct_answer": "C",
    "explanation": "MAC addresses are physical addresses that are burnt into every NIC card and network device. It is unique at the data link layer from direct communication purposes. All other answers are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      42,
      22,
      36,
      43,
      81
    ],
    "source": "235605_ch04"
  },
  {
    "id": 268,
    "question": "What is the 2-byte type field used for in an Ethernet frame?",
    "choice_a": "It defines the data type contained within the frame.",
    "choice_b": "It identifies the upper-layer protocol for the data contained within the frame.",
    "choice_c": "It is a calculation with the FCS to provide error detection.",
    "choice_d": "It describes the length of data contained within the frame.",
    "correct_answer": "B",
    "explanation": "The Ethernet type field is 2 bytes, and it identifies at layer 2 which upper-layer protocol to send the data to. When IPv4 is used, the type field is 0x0800. When IPv6 is used, the type field is 0x86dd. All other answers are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      43,
      23,
      81,
      22,
      99
    ],
    "source": "235605_ch04"
  },
  {
    "id": 269,
    "question": "What is the purpose of the State of Frame delimiter byte in a frame?",
    "choice_a": "It provides physical timing for the frame that follows.",
    "choice_b": "It divides the data and the physical timing portion of the frame.",
    "choice_c": "It provides a means for the receiving node to know when data begins.",
    "choice_d": "It delimits the destination and source MAC address.",
    "correct_answer": "C",
    "explanation": "The preamble is 7 bytes of alternating 1s and 0s at a frequency that matches the bandwidth of the link. It is important to note that the 1s and 0s pattern starts with a 1 and ends with a 0 for 7 bytes (10101010). The SFD has an extra lower bit signaling the end of timing and the start of data (10101011). All other answers are incorrect.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      43,
      22,
      44,
      82,
      81
    ],
    "source": "235605_ch04"
  },
  {
    "id": 270,
    "question": "How many bits are in a nibble?",
    "choice_a": "1",
    "choice_b": "4",
    "choice_c": "8",
    "choice_d": "16",
    "correct_answer": "B",
    "explanation": "There are 4 bits in a nibble. A single bit is the lowest value in the binary system, with a potential value of 0 or 1. There are 8 bits in a byte or octet, depending on the base value. 16 bits is a double byte, also called a word.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      41,
      84,
      102,
      82,
      1
    ],
    "source": "235605_ch04"
  },
  {
    "id": 271,
    "question": "How many bits are in a MAC address?",
    "choice_a": "8",
    "choice_b": "24",
    "choice_c": "48",
    "choice_d": "64",
    "correct_answer": "C",
    "explanation": "There are 48 bits that compose a MAC address. 24 bits are assigned by the Electrical and Electronics Engineers (IEEE) to the organization. The other 24 bits are assigned by the organization for uniqueness. All other answers are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      42,
      22,
      36,
      41,
      43
    ],
    "source": "235605_ch04"
  },
  {
    "id": 272,
    "question": "You need to connect a fiber-optic line between two floors of a building that are 200 meters apart. Which Ethernet technology is the most cost effective that will accomplish the task?",
    "choice_a": "10GBaseER",
    "choice_b": "10GBaseT",
    "choice_c": "10GBaseSR",
    "choice_d": "10GBaseLR",
    "correct_answer": "C",
    "explanation": "10GBaseSR will support 10 Gb/s for a maximum distance of 300 meters. 10GBaseLR will support 10 Gb/s up to 10 kilometers and will provide ample connectivity between buildings. 10GBaseER will operate at 10 Gb/s for a total of 40 kilometers. 10GBaseT will support 10 Gb/s over copper UTP cables for a maximum distance of 100 meters. Although 10GBaseER and 10GBaseLR can accomplish the task, these technologies are much more expensive than 10GBaseSR.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      46,
      29,
      47,
      12,
      26
    ],
    "source": "235605_ch04"
  },
  {
    "id": 273,
    "question": "Which technology provides Internet connectivity over power lines?",
    "choice_a": "BPL",
    "choice_b": "MoCA",
    "choice_c": "HDMI",
    "choice_d": "HomePlug",
    "correct_answer": "A",
    "explanation": "Broadband over Power Line (BPL) called IEEE 1901 is a technology that provides Internet connectivity over power lines. Multimedia over Coax (MoCA) is a technology that provides network connectivity over coaxial lines. HDMI Ethernet Channel technology consolidates video, audio, and data streams into a single HDMI cable. HomePlug is a technology that allows you to run local area network (LAN) traffic in your home, over your home\u2019s power line.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      48,
      25,
      2,
      24,
      40
    ],
    "source": "235605_ch04"
  },
  {
    "id": 274,
    "question": "Which statement is true when a collision is detected on the network?",
    "choice_a": "The sender on the segment has the right of way.",
    "choice_b": "A jam signal is sent to all hosts on the segment.",
    "choice_c": "The receiver on the segment acknowledges the collision.",
    "choice_d": "Once the collision clears, all hosts have equal access on the segment.",
    "correct_answer": "B",
    "explanation": "When a collision occurs, a jam signal is sent to all hosts on the segment to notify them of the collision. A random backoff algorithm will take effect, after which all hosts will have equal priority to transmit again. All other answers are incorrect.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      38,
      40,
      39,
      37,
      36
    ],
    "source": "235605_ch04"
  },
  {
    "id": 275,
    "question": "How many bits are used to represent the hexadecimal value of 0x0020?",
    "choice_a": "2",
    "choice_b": "4",
    "choice_c": "8",
    "choice_d": "16",
    "correct_answer": "D",
    "explanation": "The hexadecimal value of 0x0020 contains 16 bits. Each digit is a hexadecimal value, and there are 4 digits that trail the 0x hex identifier. Each digit has 4 bits and 4 digits \u00d7 4 bits = 16 bits. All other answers are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      41,
      50,
      102,
      92,
      1
    ],
    "source": "235605_ch04"
  },
  {
    "id": 276,
    "question": "Which 3 bytes of the Media Access Control (MAC) address F3-B2-CD-E4-F4-42 designate the unique station identifier?",
    "choice_a": "F3-B2-CD",
    "choice_b": "B2-CD-E4",
    "choice_c": "E4-F4-42",
    "choice_d": "CD-E4-F4",
    "correct_answer": "C",
    "explanation": "The last 3 bytes, E4-F4-42, of the Media Access Control (MAC) address designate the unique station identifier. The first 3 bytes, F3-B2-CD, are the organizationally unique identifier (OUI). All other answers are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      42,
      22,
      81,
      84,
      44
    ],
    "source": "235605_ch04"
  },
  {
    "id": 277,
    "question": "Which protocol does a host use to find the hardware address of a neighbor host by using the destination IP address?",
    "choice_a": "TCP",
    "choice_b": "UDP",
    "choice_c": "ARP",
    "choice_d": "DNS",
    "correct_answer": "C",
    "explanation": "Address Resolution Protocol (ARP) is used to find the MAC address of another host on the same LAN. On an Ethernet network, the MAC address (hardware address) is used for one host to communicate with another. The Transmission Control Protocol (TCP) and User Datagram Protocol (UDP) are both Transport layer protocols used to transmit segments. The Domain Name System (DNS) protocol is used for name resolution.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      79,
      36,
      22,
      42,
      43
    ],
    "source": "235605_ch04"
  },
  {
    "id": 278,
    "question": "What are the speed, maximum distance, and media of 10GBaseT?",
    "choice_a": "10 Mb/s, 100 meters, and fiber optic",
    "choice_b": "10 Gb/s, 100 meters, and fiber optic",
    "choice_c": "10 Gb/s, 100 meters, and copper",
    "choice_d": "10 Gb/s, 300 meters, and copper",
    "correct_answer": "C",
    "explanation": "The Ethernet specification of 10GBaseT is 10 Gb/s with a maximum distance of 100 meters over copper. All other answers are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      46,
      26,
      47,
      44,
      29
    ],
    "source": "235605_ch04"
  },
  {
    "id": 279,
    "question": "How many wire pairs are used with 1000BaseTX?",
    "choice_a": "Two",
    "choice_b": "One",
    "choice_c": "Four",
    "choice_d": "Eight",
    "correct_answer": "A",
    "explanation": "1000BaseTX uses two pairs of wires, one pair for transmitting and one pair for receiving. All other answers are incorrect.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      26,
      39,
      32,
      27,
      12
    ],
    "source": "235605_ch04"
  },
  {
    "id": 280,
    "question": "You have been asked to change the IP address in external DNS for a mail server in your organization. Which record can be changed with the least amount of effort?",
    "choice_a": "A record",
    "choice_b": "MX record",
    "choice_c": "PTR record",
    "choice_d": "TXT record",
    "correct_answer": "A",
    "explanation": "The alias, or A, record that matches the MX record configured for the mail server should be changed. If you were to change the MX record, a new alias record would need to be created as well, since every MX record contains the FQDN that maps to an alias record. A PTR record is used for reverse DNS and will not solve the problem. A TXT record is used to resolve plaintext and does not solve the problem.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      58,
      60,
      238,
      59,
      237
    ],
    "source": "235605_ch05"
  },
  {
    "id": 281,
    "question": "Which is a valid reason to implement a wireless LAN controller?",
    "choice_a": "Centralized provisioning",
    "choice_b": "The use of autonomous WAPs",
    "choice_c": "Multiple SSIDs",
    "choice_d": "Multiple VLANs",
    "correct_answer": "A",
    "explanation": "Centralized provisioning of lightweight wireless access points (LWAPs) is a valid reason to implement a WLAN controller. Although a wireless LAN controller makes it easier to implement multiple SSIDs and VLANs, this task can be performed with autonomous WAPs, each performing its own authentication. The use of autonomous WAPs negates the reasons you would use a WLAN controller because each WAP would be independently managed and no coordination would exist between the autonomous WAPs. The use of multiple SSIDs can be achieved with an autonomous WAP without a WLAN controller. Multiple VLANs can also be used with an autonomous WAP without a WLAN controller.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      191,
      57,
      200,
      196,
      192
    ],
    "source": "235605_ch05"
  },
  {
    "id": 282,
    "question": "What is the benefit of network segmentation?",
    "choice_a": "Decreased broadcast domains",
    "choice_b": "Increased broadcast domains",
    "choice_c": "Decreased collision domains",
    "choice_d": "Increased collision domains",
    "correct_answer": "B",
    "explanation": "Network segmentation increases the number of broadcast domains. This effectively decreases the number of broadcasts seen on a network segment and effectively increases bandwidth. All other answers are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      66,
      160,
      155,
      70,
      53
    ],
    "source": "235605_ch05"
  },
  {
    "id": 283,
    "question": "Which protocol and port do you need to configure on the inbound host-based firewall for a DHCP server?",
    "choice_a": "UDP/67",
    "choice_b": "TCP/67",
    "choice_c": "UDP/68",
    "choice_d": "TCP/68",
    "correct_answer": "A",
    "explanation": "The DHCP server waits for connection from clients on UDP/67; the clients will send the requests from UDP/68. Therefore, the inbound host-based firewall should be configured to accept traffic from UDP/67.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      56,
      55,
      214,
      217,
      238
    ],
    "source": "235605_ch05"
  },
  {
    "id": 284,
    "question": "Which type of device will detect but not prevent unauthorized access?",
    "choice_a": "Firewall",
    "choice_b": "IPS",
    "choice_c": "IDS",
    "choice_d": "Honeypots",
    "correct_answer": "C",
    "explanation": "An IDS, or intrusion detection system, will detect unauthorized access. However, it will not prevent unauthorized access. It is a form of audit control in a network. A firewall will protect your network from attack by placing rules defining how people can connect as well as which traffic can pass. An intrusion protection system (IPS) will detect the presence of an intrusion and alert an administrator. A honeypot will attract a malicious user so that their tactics can be observed. It performs this function by diverting the malicious user from production systems to the honeypot, which is a sacrificial system.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      55,
      236,
      234,
      232,
      241
    ],
    "source": "235605_ch05"
  },
  {
    "id": 285,
    "question": "Your organization expects a considerable amount of traffic to your web server, so you plan to install several web servers. How can you maintain one FQDN and allow customers to be directed to the next free web servers?",
    "choice_a": "Router",
    "choice_b": "Firewall",
    "choice_c": "Load balancer",
    "choice_d": "Proxy",
    "correct_answer": "C",
    "explanation": "A load balancer will direct a user\u2019s request to the next free web server. A router will only route traffic to a destination network. A firewall would not accomplish the requirement of distribution of the load. A proxy is something that might fetch the web page on the web server, but it will not provide load balancing.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      260,
      58,
      266,
      258,
      225
    ],
    "source": "235605_ch05"
  },
  {
    "id": 286,
    "question": "Your organization has deployed several autonomous WAPs. Users complain that they consistently drop the wireless connection when roaming. What should you recommend to resolve this issue?",
    "choice_a": "Wireless range extenders",
    "choice_b": "More autonomous WAPs",
    "choice_c": "Switching the channels the WAPs are using",
    "choice_d": "Wireless LAN controller",
    "correct_answer": "D",
    "explanation": "Autonomous WAPs do not have any coordination between them for roaming clients. When a client roams from one WAP to another, they must reauthenticate, and this causes a drop. Implementing a wireless LAN controller will coordinate roaming clients and not require reauthentication.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      191,
      57,
      190,
      198,
      193
    ],
    "source": "235605_ch05"
  },
  {
    "id": 287,
    "question": "You need to make sure that a printer is configured with the same IP address every time it is turned on. However, the printer is too troublesome to configure a static IP address. What can be done to achieve the goal?",
    "choice_a": "Configure an A record for the printer in DNS.",
    "choice_b": "Configure a DHCP exclusion for the printer.",
    "choice_c": "Configure a DHCP reservation for the printer.",
    "choice_d": "Configure a PTR record for the printer in DNS.",
    "correct_answer": "C",
    "explanation": "A DHCP reservation will allow for the printer to obtain the same IP address every time it is turned on. The DHCP server will serve the same IP address to the printer based on the printer\u2019s MAC address in the reservation. Configuring an A record will not achieve the goal. Configuring a DHCP exclusion for the printer would work only if you had already set it to a static IP address and didn\u2019t want that IP address assigned to another host. Configuring an PTR record will not achieve the goal.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      60,
      58,
      98,
      61
    ],
    "source": "235605_ch05"
  },
  {
    "id": 288,
    "question": "Which record type is used for an IPv4 address mapping to FQDN for DNS queries?",
    "choice_a": "The A record",
    "choice_b": "The CName record",
    "choice_c": "The PTR record",
    "choice_d": "The AAAA record",
    "correct_answer": "C",
    "explanation": "The PTR, or pointer record, is used to look up IP addresses and return FQDNs that are mapped to them. This is helpful to identify an IP address, and in the case of SSH, it is used to positively identify the host you are connecting to. The A record is used to look up an IP address for a given hostname. The CName record is used to look up the alias for a given hostname. The AAAA record is used to look up an IPv6 address for a given hostname.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      58,
      59,
      214,
      56,
      98
    ],
    "source": "235605_ch05"
  },
  {
    "id": 289,
    "question": "Which device will act as a multiport repeater in the network?",
    "choice_a": "Hub",
    "choice_b": "Switch",
    "choice_c": "Bridge",
    "choice_d": "WAP",
    "correct_answer": "A",
    "explanation": "A hub will act as a multiport repeater by repeating the physical bits on an incoming port to all the other connected ports. A switch or bridge will forward the frame only to the port it is destined for. Even when broadcasts are received, the frame is still processed and not blindly repeated. A WAP acts similarly to a switch and will forward frames only to the connected wireless or wired network.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      70,
      52,
      53,
      152,
      187
    ],
    "source": "235605_ch05"
  },
  {
    "id": 290,
    "question": "Which is a correct statement when hubs are replaced with switches?",
    "choice_a": "The replacement increases collision domains.",
    "choice_b": "The replacement decreases collision domains.",
    "choice_c": "The replacement increases broadcast domains.",
    "choice_d": "The replacement decreases broadcast domains.",
    "correct_answer": "A",
    "explanation": "The replacement of hubs with switches increases collision domains and effectively increases bandwidth. The replacement of switches with hubs can decrease the number of collision domains, creating a much larger collision domain. The replacement of hubs with switches has no effect on broadcast domains. Broadcast domains would be affected only if a router was introduced.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      150,
      71,
      70,
      53,
      155
    ],
    "source": "235605_ch05"
  },
  {
    "id": 291,
    "question": "When firewalls are placed in a network, which zone contains Internet-facing services?",
    "choice_a": "Outside zone",
    "choice_b": "Enterprise network zone",
    "choice_c": "Demilitarized zone",
    "choice_d": "Inside zone",
    "correct_answer": "C",
    "explanation": "The demilitarized zone (DMZ) or screen subnet is where Internet-facing servers/services are placed. The outside zone is where the public Internet connection is connected, and it is the least trusted. The enterprise network zone is considered the inside zone. The inside zone is considered to be the highest trusted network because it is the internal network that you control.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      55,
      217,
      60,
      208,
      254
    ],
    "source": "235605_ch05"
  },
  {
    "id": 292,
    "question": "Which is a false statement about firewalls?",
    "choice_a": "Firewalls can protect a network from external attacks.",
    "choice_b": "Firewalls are commonly deployed to protect a network from internal attacks.",
    "choice_c": "Firewalls can provide stateful packet inspection.",
    "choice_d": "Firewalls can control application traffic.",
    "correct_answer": "B",
    "explanation": "Firewalls are not commonly deployed to provide protection from internal attacks on internal resources. They are designed to protect networks from external attacks or attacks emanating from the outside or directed toward the Internet. Firewalls normally provide stateful packet inspection. Firewalls can also control application traffic by port number and higher-layer attributes.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      55,
      265,
      241,
      249,
      217
    ],
    "source": "235605_ch05"
  },
  {
    "id": 293,
    "question": "Which statement is correct about reverse lookups?",
    "choice_a": "A reverse lookup is when the request needs to be reversed to another DNS server.",
    "choice_b": "A reverse lookup is the resolution of an IP address to FQDN.",
    "choice_c": "A reverse lookup is when the DNS queried can answer the request without asking another DNS server.",
    "choice_d": "A reverse lookup is the resolution of an FQDN to an IP address.",
    "correct_answer": "B",
    "explanation": "A reverse lookup is when the fully qualified domain name (FQDN) is resolved from an IP address. This is useful when you want to identify an IP address. From the IP address, you can derive the FQDN. A reverse lookup is not when the request needs to be reversed to another DNS server. A reverse lookup is not when the DNS queried can answer the request without asking another DNS server. A reverse lookup is not the resolution of an FQDN to an IP address; it is the resolution of an IP address to an FQDN.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      58,
      59,
      60,
      226,
      228
    ],
    "source": "235605_ch05"
  },
  {
    "id": 294,
    "question": "What gets appended to hostname queries for DNS resolution?",
    "choice_a": "The DNS suffix",
    "choice_b": "The DNS zone",
    "choice_c": "The host header",
    "choice_d": "The hostname PTR record",
    "correct_answer": "A",
    "explanation": "The configured DNS suffix is appended to the hostname query. As an example, if you query a hostname of hosta and the configured domain name is <code>network.local</code>, the DNS server will see a query for <code>hosta.network.local</code>. The DNS zone is the database of records contained in DNS. <i>Host header</i> is a term used with web servers and therefore not relevant to DNS resolution. The hostname PTR record is the reverse DNS record for a given IP address.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      58,
      56,
      98,
      60,
      59
    ],
    "source": "235605_ch05"
  },
  {
    "id": 295,
    "question": "Which type of DNS record holds the IPv4 IP address for a hostname?",
    "choice_a": "The A record",
    "choice_b": "The CName record",
    "choice_c": "The PTR record",
    "choice_d": "The AAAA record",
    "correct_answer": "A",
    "explanation": "The A record is the DNS record that is queried when you want to resolve a hostname to an IP address. The CName record is used to look up the alias for a given hostname. The PTR, or pointer record, is used to look up IP addresses and return FQDNs that are mapped to them. The AAAA record is used to look up an IPv6 address for a given hostname.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      58,
      59,
      60,
      98,
      95
    ],
    "source": "235605_ch05"
  },
  {
    "id": 296,
    "question": "Which of the following devices can work at both layers 2 and 3 of the OSI model?",
    "choice_a": "Hub",
    "choice_b": "Switch",
    "choice_c": "Multilayer switch",
    "choice_d": "Bridge",
    "correct_answer": "C",
    "explanation": "A multilayer switch can provide both routing and switching capabilities since it operates on layers 2 and 3. A hub is a device that operates only on layer 1. A switch or bridge is a layer 2 device that segments the network.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      62,
      68,
      71,
      53,
      54
    ],
    "source": "235605_ch05"
  },
  {
    "id": 297,
    "question": "What is an advantage of using DHCP in a network environment?",
    "choice_a": "More difficult administration of the network",
    "choice_b": "Static IP addressing",
    "choice_c": "Can send an operating system for the PC to boot from",
    "choice_d": "Automatically assigns IP addresses to hosts",
    "correct_answer": "D",
    "explanation": "An advantage to DHCP in a network environment is that it automatically assigns IP addresses to hosts. There is minimal difficulty to administrate DHCP, and this is not considered a benefit. Static IP addressing is used in lieu of a DHCP. DHCP does not send an operating system to a PC, but it can direct it to do so with DHCP options.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      60,
      58,
      255,
      223
    ],
    "source": "235605_ch05"
  },
  {
    "id": 298,
    "question": "What is a benefit to installing a proxy server?",
    "choice_a": "Web caching",
    "choice_b": "Throughput increase",
    "choice_c": "DHCP services",
    "choice_d": "Support for user authentication",
    "correct_answer": "A",
    "explanation": "Web caching is a tremendous benefit to employing a proxy server. Commonly accessed web pages will be cached, and subsequent requests will be returned locally from the proxy server. The throughput for the network will not increase. DHCP services will not be provided with a proxy server, only the proxying of web pages. Support for user authentication is not a benefit of employing a proxy server.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      217,
      56,
      221,
      231,
      255
    ],
    "source": "235605_ch05"
  },
  {
    "id": 299,
    "question": "Which protocol and port number does DNS use for direct queries?",
    "choice_a": "UDP/53",
    "choice_b": "TCP/53",
    "choice_c": "UDP/55",
    "choice_d": "UDP/68",
    "correct_answer": "A",
    "explanation": "Domain Name System (DNS) direct queries are performed over the UDP protocol to port 53. The queries do not require the TCP setup and teardown because the queries are simple request and reply messages, so UDP is used for direct queries. TCP port 53 is used for DNS zone transfers between DNS servers. UDP port 55 is not used for any popular protocols. UDP port 68 is used with the Dynamic Host Configuration Protocol (DHCP).",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      58,
      59,
      60,
      226,
      227
    ],
    "source": "235605_ch05"
  },
  {
    "id": 300,
    "question": "Which is a correct statement about the Transmission Control Protocol (TCP)?",
    "choice_a": "TCP is a connectionless protocol.",
    "choice_b": "TCP allows for error correction.",
    "choice_c": "TCP is faster than UDP.",
    "choice_d": "TCP allows for retransmission of lost segments.",
    "correct_answer": "D",
    "explanation": "TCP is a connection-based protocol via the three-way handshake. It is not faster than UDP. However, it allows for the retransmission of lost segments because of sequences and acknowledgments. TCP does not allow or account for error correction, only the detection of errors and lost or missing segments.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      77,
      20,
      83,
      81
    ],
    "source": "235605_ch06"
  },
  {
    "id": 301,
    "question": "How does TCP guarantee delivery of segments to the receiver?",
    "choice_a": "Via the destination port",
    "choice_b": "TCP checksums",
    "choice_c": "Window size",
    "choice_d": "Sequence and acknowledgment numbers",
    "correct_answer": "D",
    "explanation": "TCP guarantees delivery of segments with sequence and acknowledgment numbers. At the Transport layer, each segment is given a sequence number that is acknowledged by the receiver. The source and destination ports are used for the delivery of segments, but they do not guarantee delivery. TCP checksums are used to detect errors in segments but do not guarantee delivery. Window size is used to adjust buffer size on the sending and receiving hosts.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      20,
      19,
      77,
      81,
      82
    ],
    "source": "235605_ch06"
  },
  {
    "id": 302,
    "question": "When a programmer decides to use UDP as a transport protocol, what is a decision factor?",
    "choice_a": "Redundancy of acknowledgment is not needed.",
    "choice_b": "Guaranteed delivery of segments is required.",
    "choice_c": "Windowing flow control is required.",
    "choice_d": "A virtual circuit is required.",
    "correct_answer": "A",
    "explanation": "When a programmer decides to use UDP, it is normally because the programmer is sequencing and acknowledging datagrams already. The redundancy of acknowledgments at the Transport layer is not needed. Guaranteed delivery of segments is not a function of UDP. UDP does not provide windowing flow control because acknowledgment is not a function of UDP. A virtual circuit can be created only with a setup and teardown of communications, such as TCP offers.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      77,
      19,
      20,
      83,
      72
    ],
    "source": "235605_ch06"
  },
  {
    "id": 303,
    "question": "Which mechanism allows for the Transport layer to communicate with the Session layer?",
    "choice_a": "Headers",
    "choice_b": "Port numbers",
    "choice_c": "MAC address",
    "choice_d": "Checksums",
    "correct_answer": "B",
    "explanation": "Port numbers allow the Transport layer to communicate with the Session layer. An example is a web server binding to the port number of TCP/80. A port is communicated in the header of TCP and UDP segments, but the header does not listen for requests or bind. MAC addresses are physical locations on a local area network (LAN) that are used to transmit framed data. Checksums are used to verify that data are not erroneously modified in transit.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      83,
      18,
      19,
      17,
      82
    ],
    "source": "235605_ch06"
  },
  {
    "id": 304,
    "question": "Why does DNS use UDP for queries?",
    "choice_a": "DNS requires acknowledgment of the request for auditing.",
    "choice_b": "The requests require flow control of UDP.",
    "choice_c": "DNS requests are usually small and do not require connections setup.",
    "choice_d": "DNS requires a temporary virtual circuit.",
    "correct_answer": "C",
    "explanation": "DNS requests are usually small and do not require the overhead of sequence and acknowledgment of TCP. If a segment is dropped, the DNS protocol will ask again. Acknowledgment of data is not a function of UDP. Flow control is not a function of UDP since UDP does not offer flow control of data other than a stop/go action. UDP does not build temporary virtual circuits; this is a function of TCP.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      77,
      76,
      19,
      20,
      83
    ],
    "source": "235605_ch06"
  },
  {
    "id": 305,
    "question": "Which protocol requires the programmer to deal with lost segments?",
    "choice_a": "SSL",
    "choice_b": "TCP",
    "choice_c": "UDP",
    "choice_d": "NMS",
    "correct_answer": "C",
    "explanation": "User Datagram Protocol (UDP) does not guarantee segments are delivered. Therefore, the programmer must account for segments that are never received or out of order. Secure Sockets Layer (SSL) is a protocol used to encrypt a network transmission. SSL is the predecessor to the modern TLS encryption used today. Transmission allows for the network to automatically deal with lost segments because TCP guarantees segments are delivered. <i>Network management station (NMS)</i> is a term used with Simple Network Management Protocol (SNMP) to describe the collecting host for SNMP messages.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      77,
      81,
      83,
      23,
      82
    ],
    "source": "235605_ch06"
  },
  {
    "id": 306,
    "question": "Which protocol can encapsulate many different protocols inside an IP tunnel?",
    "choice_a": "GRE",
    "choice_b": "RARP",
    "choice_c": "ARP",
    "choice_d": "ICMP",
    "correct_answer": "A",
    "explanation": "Generic Routing Encapsulation (GRE) is a tunneling protocol that can encapsulate many protocols inside an IP tunnel. Reverse Address Resolution Protocol (RARP) is used to obtain an IP address from a MAC address. Address Resolution Protocol (ARP) is used by the Network layer to obtain a MAC address from an IP address. Internet Control Message Protocol (ICMP) is used by the Network layer to communicate network information such as Ping, Traceroute, and many other information services.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      80,
      79,
      23,
      81,
      82
    ],
    "source": "235605_ch06"
  },
  {
    "id": 307,
    "question": "Which protocol provides confidentiality?",
    "choice_a": "AH",
    "choice_b": "ESP",
    "choice_c": "GRE",
    "choice_d": "PDU",
    "correct_answer": "B",
    "explanation": "Encapsulating Security Payload (ESP) is used by IP Security Protocol (IPSec) for the confidentiality of the payload. The AH protocol provides authentication for the data and the IP header of a packet using a one-way hash for packet authentication. Generic Routing Encapsulation (GRE) is a tunneling protocol that can encapsulate many protocols inside an IP tunnel. The protocol data unit (PDU) is a way to describe the data at each layer of the OSI model.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      80,
      97,
      79,
      81,
      82
    ],
    "source": "235605_ch06"
  },
  {
    "id": 308,
    "question": "Which protocol is used for configuration access to network appliances but is <i>not</i> encrypted?",
    "choice_a": "SSH",
    "choice_b": "HTTPS",
    "choice_c": "Telnet",
    "choice_d": "RDP",
    "correct_answer": "C",
    "explanation": "Telnet is used for configuration access to network appliances, but it is not encrypted. Secure Shell (SSH) has become the successor of Telnet, since it is encrypted and provides configuration access. Hypertext Transfer Protocol Secure (HTTPS) is a secure method to transfer web pages. The Remote Desktop Protocol (RDP) is a Microsoft protocol that provides a secure method to access a server desktop.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      74,
      78,
      73,
      80,
      77
    ],
    "source": "235605_ch06"
  },
  {
    "id": 309,
    "question": "Which protocol is used by applications that need low overhead at the Transport layer?",
    "choice_a": "TCP",
    "choice_b": "IP",
    "choice_c": "ARP",
    "choice_d": "UDP",
    "correct_answer": "D",
    "explanation": "The User Datagram Protocol (UDP) is a Transport layer protocol that provides applications with low overhead. The Transmission Control Protocol (TCP) is a connection-oriented protocol and has higher overhead. The Internet Protocol (IP) is a Network layer protocol. The Address Resolution Protocol (ARP) is Network layer helper protocol that resolves MAC addresses from a known IP address.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      77,
      19,
      83,
      79,
      72
    ],
    "source": "235605_ch06"
  },
  {
    "id": 310,
    "question": "Which layer in the DoD model is directly related to the Transport layer of the OSI model?",
    "choice_a": "Process/Application layer",
    "choice_b": "Host-to-Host layer",
    "choice_c": "Internet layer",
    "choice_d": "Network Access layer",
    "correct_answer": "B",
    "explanation": "The Host-to-Host DoD layer is directly related to the Transport layer of the OSI model. The Process/Application DoD layer is related to the Application, Presentation, and Session layers of the OSI model. The Internet DoD layer is related to the Network layer of the OSI model. The Network Access DoD layer is related to the Data Link and Physical layers of the OSI model.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      72,
      19,
      83,
      17,
      23
    ],
    "source": "235605_ch06"
  },
  {
    "id": 311,
    "question": "Which element is used with TCP to provide a virtual circuit?",
    "choice_a": "Sequence numbers",
    "choice_b": "Acknowledgment numbers",
    "choice_c": "Protocol numbers",
    "choice_d": "Port numbers",
    "correct_answer": "D",
    "explanation": "Port numbers are used to create a virtual circuit with TCP. The port numbers are open and in use during the entire TCP conversation. Sequence and acknowledgment numbers are used to assure data is delivered. Protocol numbers are used to direct communications to the next respective upper layer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      83,
      19,
      77,
      20,
      81
    ],
    "source": "235605_ch06"
  },
  {
    "id": 312,
    "question": "Which protocol uses UDP/123?",
    "choice_a": "TFTP",
    "choice_b": "NTP",
    "choice_c": "HTTPS",
    "choice_d": "DNS",
    "correct_answer": "B",
    "explanation": "The Network Time Protocol (NTP) operates on the UDP protocol, port 123. The Trivial File Transfer Protocol operates on the UDP protocol, port 69. The Hypertext Transfer Protocol Secure (HTTPS) operates on the TCP protocol, port 443. The Domain Name Service protocol operates on UDP or TCP, port 53.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      78,
      77,
      83,
      75,
      76
    ],
    "source": "235605_ch06"
  },
  {
    "id": 313,
    "question": "Which DoD layer allows for the logical addressing of hosts?",
    "choice_a": "Process/Application layer",
    "choice_b": "Host-to-Host layer",
    "choice_c": "Internet layer",
    "choice_d": "Network Access layer",
    "correct_answer": "C",
    "explanation": "The Internet DoD layer is directly related to the Network layer in the OSI model, which is responsible for the logical addressing of hosts. The Process/Application layer is where most networked applications will operate on the Application, Presentation, and Session layers in the OSI model. The Host-to-Host DoD layer is directly related to the Transport layer in the OSI model, which is responsible for segmenting data and transporting it. The Network Access DoD layer is directly related to the Data Link and Physical OSI layers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      72,
      21,
      17,
      79,
      88
    ],
    "source": "235605_ch06"
  },
  {
    "id": 314,
    "question": "What is the process called when data moves up the OSI model?",
    "choice_a": "Encapsulation",
    "choice_b": "Decapsulation",
    "choice_c": "FCS",
    "choice_d": "PDU",
    "correct_answer": "B",
    "explanation": "Data decapsulation is the process of moving data up the OSI model back up to the receiving application. Data encapsulation is the process of moving data down the OSI model to be transmitted on the network. The Frame Checking Sequence (FCS) is a cyclical redundancy check (CRC0) that is processed on the data at the Data Link layer to validate a frame of data. The protocol data unit (PDU) is the reference to the type of data as it passes up and down the OSI layers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      81,
      82,
      23,
      17,
      18
    ],
    "source": "235605_ch06"
  },
  {
    "id": 315,
    "question": "Which protocol provides an IP address from a physical address?",
    "choice_a": "ICMP",
    "choice_b": "TCP",
    "choice_c": "ARP",
    "choice_d": "RARP",
    "correct_answer": "D",
    "explanation": "The Reverse Address Resolution Protocol (RARP) provides an IP address from a physical MAC address. Internet Control Message Protocol (ICMP) works at the Network layer and is used by IP for many different services. The Transmission Control Protocol (TCP) is a Transport layer protocol for segmenting and transporting data. The Address Resolution Protocol (ARP) provides a MAC address from an IP address.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      79,
      36,
      82,
      81,
      22
    ],
    "source": "235605_ch06"
  },
  {
    "id": 316,
    "question": "What protocol from the Internet Protocol (IP) stack is used for diagnostics and error messages?",
    "choice_a": "TCP",
    "choice_b": "ICMP",
    "choice_c": "ARP",
    "choice_d": "UDP",
    "correct_answer": "B",
    "explanation": "Internet Control Message Protocol (ICMP) is used for diagnostics (<code>ping</code> and <code>traceroute</code>) and for sending error messages through the network. The Transmission Control Protocol (TCP) is a Transport layer protocol for segmenting and transporting data. The Address Resolution Protocol (ARP) provides a MAC address from an IP address. The User Datagram Protocol (UDP) is a Transport layer protocol used to send segments of data.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      79,
      112,
      19,
      72,
      81
    ],
    "source": "235605_ch06"
  },
  {
    "id": 317,
    "question": "Which IP service uses the UDP protocol?",
    "choice_a": "DHCP",
    "choice_b": "SMTP",
    "choice_c": "FTP",
    "choice_d": "HTTP",
    "correct_answer": "A",
    "explanation": "The Dynamic Host Configuration Protocol (DHCP) operates on UDP port 67 and UDP port 68. The Simple Mail Transport Protocol (SMTP) operates on TCP port 25. The File Transport Protocol (FTP) operates on TCP ports 20 and 21. The Hypertext Transfer Protocol (HTTP) operates on TCP port 80.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      75,
      77,
      78,
      76,
      19
    ],
    "source": "235605_ch06"
  },
  {
    "id": 318,
    "question": "You need to make sure that the time is consistent across all your network devices. What protocol do you need to run on your network?",
    "choice_a": "FTP",
    "choice_b": "SFTP",
    "choice_c": "NTP",
    "choice_d": "SSH",
    "correct_answer": "C",
    "explanation": "The Network Time Protocol (NTP) helps synchronize your computer clock over the Internet with the help of an NTP server. The File Transfer Protocol (FTP) allows you to transfer files across the network. The Secure File Transfer Protocol (SFTP) is used when transferring files over an encrypted connection. The Secure Shell (SSH) protocol sets up a secure console session over a standard TCP/IP connection.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      74,
      73,
      18,
      72,
      77
    ],
    "source": "235605_ch06"
  },
  {
    "id": 319,
    "question": "Which of the following allows a server to distinguish among different simultaneous requests from the same host?",
    "choice_a": "They use different port numbers.",
    "choice_b": "The IP address that the request originates from.",
    "choice_c": "A server is unable to accept multiple simultaneous sessions from the same host. One session must end before another can begin.",
    "choice_d": "Each request uses a different sequence and acknowledgment number.",
    "correct_answer": "A",
    "explanation": "Through the use of port numbers, TCP and UDP can establish multiple sessions between the same two hosts without creating any confusion. The sessions can be between the same or different applications, such as multiple web-browsing sessions or a web-browsing session and an FTP session. The IP address that the request originates from does not distinguish among different simultaneous requests. Servers are able to accept multiple simultaneous sessions from the same host. The sequence and acknowledgment numbers do not distinguish among different simultaneous requests from the same host.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      83,
      78,
      20,
      72,
      17
    ],
    "source": "235605_ch06"
  },
  {
    "id": 320,
    "question": "Which of the following addresses is not allowed on the Internet?",
    "choice_a": "191.192.168.1",
    "choice_b": "191.168.169.254",
    "choice_c": "172.32.255.0",
    "choice_d": "172.31.12.251",
    "correct_answer": "D",
    "explanation": "The addresses in the range 172.16.0.0 through 172.31.255.255 are all considered private, based on RFC 1918. Use of these addresses on the Internet is prohibited so that they can be used simultaneously in different administrative domains without concern for conflict. These addresses are not and should not be routable on the public Internet.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      84,
      101,
      114,
      102
    ],
    "source": "235605_ch07"
  },
  {
    "id": 321,
    "question": "A host automatically configured with an address from which of the following ranges indicates an inability to contact a DHCP server?",
    "choice_a": "169.254.0.<i>x</i> with a mask of 255.255.255.0",
    "choice_b": "169.254.<i>x.x</i> with a mask of 255.255.0.0",
    "choice_c": "169.254.<i>x.x</i> with a mask of 255.255.255.0",
    "choice_d": "169.255.<i>x.x</i> with a mask of 255.255.0.0",
    "correct_answer": "B",
    "explanation": "The Automatic Private IP Addressing (APIPA) uses the link-local private address range of 169.254.0.0 through 169.254.255.255 and a subnet mask of 255.255.0.0. APIPA addresses are used by DHCP clients that cannot contact a DHCP server and have no static alternate configuration. These addresses are not Internet routable and cannot, by default, be used across routers on an internetwork.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      75,
      86,
      99,
      113,
      101
    ],
    "source": "235605_ch07"
  },
  {
    "id": 322,
    "question": "Which statement regarding private IP addresses is most accurate?",
    "choice_a": "Private addresses cannot be used in intranets that require routing.",
    "choice_b": "Private addresses must be assigned by a registrar or ISP.",
    "choice_c": "A remote host across the Internet cannot ping your host if it has a private address.",
    "choice_d": "Private addresses can be used only by a single administrative domain.",
    "correct_answer": "C",
    "explanation": "Private IP addresses are not routable over the Internet, as either source or destination addresses. Therefore, any entity that wants to use such addresses internally can do so without causing conflicts with other entities and without asking permission of any registrar or service provider. Despite not being allowed on the Internet, private IP addresses are fully routable on private intranets.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      99,
      116,
      85,
      84
    ],
    "source": "235605_ch07"
  },
  {
    "id": 323,
    "question": "Which of the following is a valid Class A address?",
    "choice_a": "191.10.0.1",
    "choice_b": "127.10.0.1",
    "choice_c": "128.10.0.1",
    "choice_d": "126.10.0.1",
    "correct_answer": "D",
    "explanation": "The Class A range is 1 through 126 for the first octet/byte. The Class B range is 127 through 191 for the first octet/byte. Class C range is 192 through 223 for the first octet/byte.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      85,
      99,
      87,
      114,
      101
    ],
    "source": "235605_ch07"
  },
  {
    "id": 324,
    "question": "Which of the following is a valid Class B address?",
    "choice_a": "10.1.1.1",
    "choice_b": "126.1.1.1",
    "choice_c": "129.1.1.1",
    "choice_d": "192.168.1.1",
    "correct_answer": "C",
    "explanation": "The Class B range is 128 through 191 in the first octet/byte. The Class A range is 1 through 126 for the first octet/byte. Class C range is 192 through 223 for the first octet/byte.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      85,
      99,
      108,
      109,
      102
    ],
    "source": "235605_ch07"
  },
  {
    "id": 325,
    "question": "Which of the following describes a broadcast address?",
    "choice_a": "All network bits are on (1s).",
    "choice_b": "All host bits are on (1s).",
    "choice_c": "All network bits are off (0s).",
    "choice_d": "All host bits are off (0s).",
    "correct_answer": "B",
    "explanation": "If you turned on all host bits (all of the host bits are 1s), this would be a broadcast address for that network. Turning all the network bits to 1s would define a different network address. Turning all the network bits to 0s would make the network address invalid. Turning all the host bits to 0s would make the address invalid, as well, since this is how the network is defined.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      87,
      84,
      104,
      88,
      101
    ],
    "source": "235605_ch07"
  },
  {
    "id": 326,
    "question": "Which of the following is a layer 2 broadcast?",
    "choice_a": "FF.FF.FF.EE.EE.EE",
    "choice_b": "FF.FF.FF.FF.FF.FF",
    "choice_c": "255.255.255.255",
    "choice_d": "255.0.0.0",
    "correct_answer": "B",
    "explanation": "A layer 2 broadcast is also referred to as a MAC address broadcast, which is in hexadecimal and is FF.FF.FF.FF.FF.FF. A layer 3 broadcast would have a destination address of 255.255.255.255.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      88,
      42,
      22,
      36,
      37
    ],
    "source": "235605_ch07"
  },
  {
    "id": 327,
    "question": "In a Class C IP address, how long is the network address?",
    "choice_a": "8 bits",
    "choice_b": "16 bits",
    "choice_c": "24 bits",
    "choice_d": "32 bits",
    "correct_answer": "C",
    "explanation": "A default Class C subnet mask is 255.255.255.0, which means that the first three octets, or first 24 bits, are the network number.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      103,
      85,
      101,
      84,
      102
    ],
    "source": "235605_ch07"
  },
  {
    "id": 328,
    "question": "Which of the following is true when describing a unicast address?",
    "choice_a": "Packets addressed to a unicast address are delivered to a single interface.",
    "choice_b": "These are your typical publicly routable addresses, just like regular publicly routable addresses in IPv4.",
    "choice_c": "These are like private addresses in IPv4 in that they are not meant to be routed.",
    "choice_d": "These addresses are meant for nonrouting purposes, but they are almost globally unique, so it is unlikely they will have an address overlap.",
    "correct_answer": "A",
    "explanation": "Packets addressed to a unicast address are delivered to a single interface. For load balancing, multiple interfaces can use the same address.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      93,
      100,
      88,
      99,
      36
    ],
    "source": "235605_ch07"
  },
  {
    "id": 329,
    "question": "A host is rebooted, and you view the IP address that it was assigned. The address is 169.123.13.34. Which of the following happened?",
    "choice_a": "The host received an APIPA address.",
    "choice_b": "The host received a multicast address.",
    "choice_c": "The host received a public address.",
    "choice_d": "The host received a private address.",
    "correct_answer": "C",
    "explanation": "I wonder how many of you picked APIPA address as your answer? An APIPA address is 169.254.x.x. The host address in this question is a public address. This was somewhat of a tricky question if you did not read carefully.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      75,
      86,
      99,
      85,
      113
    ],
    "source": "235605_ch07"
  },
  {
    "id": 330,
    "question": "An IPv4 address uses 32 bits. How many bits is an IPv6 address?",
    "choice_a": "64",
    "choice_b": "128",
    "choice_c": "192",
    "choice_d": "255",
    "correct_answer": "B",
    "explanation": "An IPv6 address is 128 bits in size.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      58,
      60,
      59,
      98,
      94
    ],
    "source": "235605_ch07"
  },
  {
    "id": 331,
    "question": "Which of the following is true when describing a multicast address?",
    "choice_a": "Packets addressed to a unicast address from a multicast address are delivered to a single interface.",
    "choice_b": "Packets are delivered to all interfaces identified by the address. This is also called a one-to-many address.",
    "choice_c": "It identifies multiple interfaces and is delivered to only one address. This address can also be called one-to-one-of-many.",
    "choice_d": "These addresses are meant for nonrouting purposes, but they are almost globally unique so it is unlikely they will have an address overlap.",
    "correct_answer": "B",
    "explanation": "Packets addressed to a multicast address are delivered to all interfaces identified by the multicast address, the same as in IPv4. A multicast address is also called a one-to-many address. You can tell multicast addresses in IPv6 because they always start with FF.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      95,
      94,
      98,
      60,
      226
    ],
    "source": "235605_ch07"
  },
  {
    "id": 332,
    "question": "Which of the following is true when describing an anycast address?",
    "choice_a": "Packets addressed to a unicast address from an anycast address are delivered to a single interface.",
    "choice_b": "Packets are delivered to all interfaces identified by the address. This is also called a one-to-many address.",
    "choice_c": "This address identifies multiple interfaces, and the anycast packet is delivered to only one address: the closest one. This address can also be called one-to-nearest.",
    "choice_d": "These addresses are meant for nonrouting purposes, but they are almost globally unique so it is unlikely they will have an address overlap.",
    "correct_answer": "C",
    "explanation": "Anycast addresses identify multiple interfaces, which is the same as multicast; however, the big difference is that the anycast packet is delivered to only one address: the first one it finds defined in terms of routing distance. This address can also be called one-to-one-of-many or one-to-nearest.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      98,
      94,
      228,
      226,
      231
    ],
    "source": "235605_ch07"
  },
  {
    "id": 333,
    "question": "You want to ping the loopback address of your local host. Which two options could you type? (Choose two.)",
    "choice_a": "<code>ping 127.0.0.1</code>",
    "choice_b": "<code>ping 0.0.0.0</code>",
    "choice_c": "<code>ping ::1</code>",
    "choice_d": "<code>trace 0.0.::1</code>",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "The loopback address with IPv4 is 127.0.0.1. With IPv6, that address is ::1.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      99,
      92,
      111,
      79,
      84
    ],
    "source": "235605_ch07"
  },
  {
    "id": 334,
    "question": "What two statements about IPv6 addresses are true? (Choose two.)",
    "choice_a": "Leading zeros are required.",
    "choice_b": "Two colons (::) are used to represent successive hexadecimal fields of zeros.",
    "choice_c": "Two colons (::) are used to separate fields.",
    "choice_d": "A single interface will have multiple IPv6 addresses of different types.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "To shorten the written length of an IPv6 address, successive fields of zeros may be replaced by double colons. In trying to shorten the address further, leading zeros may also be removed. Just as with IPv4, a single device\u2019s interface can have more than one address; with IPv6, there are more types of addresses, and the same rule applies. There can be link-local, global unicast, and multicast addresses all assigned to the same interface.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      94,
      95,
      98,
      58,
      56
    ],
    "source": "235605_ch07"
  },
  {
    "id": 335,
    "question": "What two statements about IPv4 and IPv6 addresses are true? (Choose two.)",
    "choice_a": "An IPv6 address is 32 bits long, represented in hexadecimal.",
    "choice_b": "An IPv6 address is 128 bits long, represented in decimal.",
    "choice_c": "An IPv4 address is 32 bits long, represented in decimal.",
    "choice_d": "An IPv6 address is 128 bits long, represented in hexadecimal.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "IPv4 addresses are 32 bits long and are represented in decimal format. IPv6 addresses are 128 bits long and represented in hexadecimal format.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      94,
      98,
      58,
      60,
      59
    ],
    "source": "235605_ch07"
  },
  {
    "id": 336,
    "question": "Which of the following is a Class C network address?",
    "choice_a": "10.10.10.0",
    "choice_b": "127.0.0.1",
    "choice_c": "128.0.0.0",
    "choice_d": "192.255.254.0",
    "correct_answer": "D",
    "explanation": "Only option D is in the Class C range of 192 through 224. It might look wrong because there is a 255 in the address, but this is not wrong\u2014you can have a 255 in a network address, just not in the first octet.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      85,
      103,
      99,
      88,
      104
    ],
    "source": "235605_ch07"
  },
  {
    "id": 337,
    "question": "Which of the following are private IP addresses? (Choose two.)",
    "choice_a": "12.0.0.1",
    "choice_b": "168.172.19.39",
    "choice_c": "172.20.14.36",
    "choice_d": "172.33.194.30",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "The Class A private address range is 10.0.0.0 through 10.255.255.255. The Class B private address range is 172.16.0.0 through 172.31.255.255, and the Class C private address range is 192.168.0.0 through 192.168.255.255.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      85,
      99,
      84,
      116
    ],
    "source": "235605_ch07",
    "choice_e": "192.168.24.43"
  },
  {
    "id": 338,
    "question": "IPv6 unicast routing is running on the Corp router. Which of the following addresses would be used as the EUI-64 address?<br>Corp <b>#sh int f0/0</b><br>FastEthernet0/0 is up, line protocol is up <br>Hardware is AmdFE, address is 000d.bd3b.0d80 (bia 000d.bd3b.0d80)<br>[output cut]",
    "choice_a": "FF02::3c3d:0d:bdff:fe3b:0d80",
    "choice_b": "FE80::3c3d:2d:bdff:fe3b:0d80",
    "choice_c": "FE80::3c3d:0d:bdff:fe3b:0d80",
    "choice_d": "FE80::3c3d:2d:ffbd:3bfe:0d80",
    "correct_answer": "B",
    "explanation": "This can be a hard question if you don\u2019t remember to invert the 7th bit! Always look for the 7th bit when studying for the exam. The EUI-64 autoconfiguration inserts an FF:FE in the middle of the 48-bit MAC address to create a unique IPv6 address.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      94,
      95,
      98,
      58,
      61
    ],
    "source": "235605_ch07"
  },
  {
    "id": 339,
    "question": "Which of the following is an invalid IP address for a host?",
    "choice_a": "10.0.0.1",
    "choice_b": "128.0.0.1",
    "choice_c": "224.0.0.1",
    "choice_d": "172.0.0.1",
    "correct_answer": "C",
    "explanation": "The IP address of 224.0.0.1 is a multicast address and cannot be used to address hosts. The IP address of 10.0.0.1 is a valid IP address for a private host. The IP address of 128.0.0.1 is a valid IP address for a public host. The IP address of 172.0.01 is a valid IP address for a public host.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      88,
      99,
      85,
      87,
      113
    ],
    "source": "235605_ch07"
  },
  {
    "id": 340,
    "question": "You have been given an IP address network of 203.23.23.0. You are asked to subnet it for two hosts per network. What is the subnet mask you will need to use to maximize networks?",
    "choice_a": "255.255.255.252",
    "choice_b": "255.255.255.248",
    "choice_c": "255.255.255.240",
    "choice_d": "255.255.255.224",
    "correct_answer": "A",
    "explanation": "The mask you will need to use is 255.255.255.252. This will allow for two hosts per network for a total of 64 networks. The formula for solving for hosts is 2<sup>X</sup> \u2013 2 is equal to or greater than 2(hosts), which in this case is (2<sup>2</sup> \u2013 2) = (4 \u2013 2) = 2. So 2 bits are used for the host side, leaving 6 bits for the subnet side. 6 bits + 24 bits (original subnet mask) = /30, or 255.255.255.252. All of the other answer options are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      102,
      107,
      104,
      115,
      106
    ],
    "source": "235605_ch08"
  },
  {
    "id": 341,
    "question": "You require the subnetting of the network address 192.168.1.0 to allow for 10 hosts per subnet while maintaining the maximum number of subnets. What should the subnet mask be?",
    "choice_a": "255.255.255.192",
    "choice_b": "255.255.255.224",
    "choice_c": "255.255.255.240",
    "choice_d": "255.255.255.248",
    "correct_answer": "C",
    "explanation": "The subnet mask of 255.255.255.240 will allow for 14 hosts per subnet and a maximum of 16 subnets. No other answer options are correct.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      106,
      104,
      102,
      115,
      87
    ],
    "source": "235605_ch08"
  },
  {
    "id": 342,
    "question": "You have been assigned a network ID of 131.44.0.0/16 by your ISP. Your organization needs to use this network ID over four campuses. What mask should be used to subnet it to achieve the goal while maximizing host IP addresses?",
    "choice_a": "255.255.128.0",
    "choice_b": "255.255.192.0",
    "choice_c": "255.255.252.0",
    "choice_d": "255.255.255.0",
    "correct_answer": "B",
    "explanation": "The network ID granted to your organization is a Class B address, in which the last 16 bits can be subnetted. Using the formula of 2 to the power of 2 gives you a perfect result of 4. Using 2 bits for the subnet mask would make the subnet mask 255.255.192.0 (128 + 64 = 192). This would leave you with 14 bits for further subnetting or host IDs.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      108,
      102,
      115,
      109,
      104
    ],
    "source": "235605_ch08"
  },
  {
    "id": 343,
    "question": "What is the CIDR notation for a subnet mask of 255.255.240.0?",
    "choice_a": "/19",
    "choice_b": "/20",
    "choice_c": "/22",
    "choice_d": "/28",
    "correct_answer": "B",
    "explanation": "The CIDR notation for 255.255.240.0 is /20. The first two subnets are 8 bits (8 \u00d7 2 = 16), and the 240 is 4 more bits (16 + 4 = 20). All of the other options are incorrect.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      103,
      102,
      104,
      114,
      101
    ],
    "source": "235605_ch08"
  },
  {
    "id": 344,
    "question": "You have been given an IP address network of 213.43.53.0. You are asked to subnet it for 22 hosts per network. What is the subnet mask you will need to use to maximize networks?",
    "choice_a": "255.255.255.252",
    "choice_b": "255.255.255.248",
    "choice_c": "255.255.255.240",
    "choice_d": "255.255.255.224",
    "correct_answer": "D",
    "explanation": "The mask you will need to use is 255.255.255.224. This will allow for 30 hosts per network for a total of 8 networks. The formula for solving for hosts is 2<sup>X</sup> \u2013 2 is equal to or greater than 2 hosts, which in this case is (2<sup>5</sup> \u2013 2) = (32 \u2013 2) = 30. So 5 bits are used for the host side, leaving 3 bits for the subnet side. 3 bits + 24 bits (original subnet mask) = /27, or 255.255.255.224. All of the other answer options are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      115,
      104,
      102,
      106,
      101
    ],
    "source": "235605_ch08"
  },
  {
    "id": 345,
    "question": "Which valid IP is in the same network as 192.168.32.61/26?",
    "choice_a": "192.168.32.59",
    "choice_b": "192.168.32.63",
    "choice_c": "192.168.32.64",
    "choice_d": "192.168.32.72",
    "correct_answer": "A",
    "explanation": "The valid IP address range for the 192.168.32.0/26 network is 192.168.32.1 to 192.168.32.62, 192.168.32.65 to 192.168.32.126, etc. Therefore, 192.168.32.59 is within the valid IP range of 192.168.32.61/26. 192.168.32.63 is the broadcast address for the 192.168.32.0/26 network. 192.168.32.64 is the network ID for the 192.168.32.64/26 network. 192.168.32.72 is a valid IP address in the 192.168.32.64/26 network.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      87,
      104,
      102,
      114,
      101
    ],
    "source": "235605_ch08"
  },
  {
    "id": 346,
    "question": "You are setting up a network in which you need 15 subnetworks. You have been given a network address of 153.20.0.0, and you need to maximize the number of hosts in each network. Which subnet mask will you use?",
    "choice_a": "255.255.224.0",
    "choice_b": "255.255.240.0",
    "choice_c": "255.255.248.0",
    "choice_d": "255.255.252.0",
    "correct_answer": "B",
    "explanation": "The subnet mask will be 255.255.240.0. Since you need to solve for the number of networks, the equation is as follows: 2<sup>X</sup> is equal to or greater than 15 networks. 2<sup>4</sup> = 16 completed the equation; the 4 bits represent the subnet side; you add the 4 bits to the 16 bits of the class B subnet mandated by the IETF. 16 + 4 = /20 = 255.255.240.0. All of the other answer options are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      109,
      102,
      108,
      103,
      115
    ],
    "source": "235605_ch08"
  },
  {
    "id": 347,
    "question": "An ISP gives you an IP address of 209.183.160.45/30 to configure your end of the serial connection. Which IP address will be on the ISP side?",
    "choice_a": "209.183.160.43/30",
    "choice_b": "209.183.160.44/30",
    "choice_c": "209.183.160.46/30",
    "choice_d": "209.183.160.47/30",
    "correct_answer": "C",
    "explanation": "The valid IP address range for 209.183.160.45/30 is 209.183.160.45\u2013209.183.160.46. Both IP addresses are part of the 209.183.160.44/30 network. The IP address 209.183.160.47/30 is the broadcast address for the 209.182.160.44/30 network. The IP address 209.183.160.43/30 is the broadcast IP address for the 209.183.160.40/30 network.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      87,
      104,
      102,
      103,
      113
    ],
    "source": "235605_ch08"
  },
  {
    "id": 348,
    "question": "In the following exhibit, what needs to be changed for Computer A to successfully communicate with Computer B (assume the least amount of effort to fix the problem)?<br><img src=\"/question_assets/Network+/235605_c08uf001.png\"/>",
    "choice_a": "Computer A needs to have its IP address changed.",
    "choice_b": "Computer B needs to have its IP address changed.",
    "choice_c": "The default gateway IP address for Computer A needs to be changed.",
    "choice_d": "The default gateway IP address for Computer B needs to be changed.",
    "correct_answer": "C",
    "explanation": "The default gateway address for Computer A is 192.168.1.63. The IP address on the router (default gateway) is the broadcast address for the 192.168.1.0/26 network and cannot be used as that network\u2019s gateway. If you were to change Computer A\u2019s IP address, it would still not be able to communicate with Computer B because of the incorrect gateway address. Computer B\u2019s IP address and default gateway are fine, and both will function properly.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      113,
      87,
      110,
      103,
      84
    ],
    "source": "235605_ch08"
  },
  {
    "id": 349,
    "question": "In the following exhibit, what needs to be changed for Computer A to successfully communicate with Computer B (assume the least amount of effort to fix the problem)?<br><img src=\"/question_assets/Network+/235605_c08uf002.png\"/>",
    "choice_a": "Computer A needs to have its IP address changed.",
    "choice_b": "Computer B needs to have its IP address changed.",
    "choice_c": "The default gateway IP address for Computer A needs to be changed.",
    "choice_d": "The default gateway IP address for Computer B needs to be changed.",
    "correct_answer": "A",
    "explanation": "Computer A needs to have its IP address changed to align with the network that its gateway is in. Computer A is in the 192.168.1.32/27 network, while its gateway address is in the 192.168.1.0/27 network. Although changing the gateway address would work, the solution needs to be the one with the least amount of effort. Changing the gateway address, which is a valid IP address, would create more work for other clients. Computer B\u2019s IP address and default gateway are fine, and both will function properly.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      113,
      114,
      87,
      101,
      102
    ],
    "source": "235605_ch08"
  },
  {
    "id": 350,
    "question": "Which subnet does host 131.50.39.23/21 belong to?",
    "choice_a": "131.50.39.0/21",
    "choice_b": "131.50.32.0/21",
    "choice_c": "131.50.16.0/21",
    "choice_d": "131.50.8.0/21",
    "correct_answer": "B",
    "explanation": "The /21 subnet mask has subnets in multiples of 8. So the networks would be 131.50.8.0/21, 131.50.16.0/21, 131.50.24.0/21, 131.50.32.0/21, and 131.50.40.0/21. The IP address of 131.50.39.23/21 would belong to the 131.50.32.0/21 network with a valid range of 131.50.32.1 to 131.50.39.254. Therefore, the network 131.50.39.0/21 cannot be a network ID because it belongs to the 131.50.32.0/21 network. Both the 131.50.16.0/21 and 131.50.8.0/21 network IDs are outside of the range for the host used in this question.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      102,
      104,
      87,
      103,
      114
    ],
    "source": "235605_ch08"
  },
  {
    "id": 351,
    "question": "A computer has an IP address of 145.50.23.1/22. What is the broadcast address for that computer?",
    "choice_a": "145.50.254.255",
    "choice_b": "145.50.255.255",
    "choice_c": "145.50.22.255",
    "choice_d": "145.50.23.255",
    "correct_answer": "D",
    "explanation": "The network for the computer with an IP address of 145.50.23.1/22 is 145.50.20.0/22. Its valid range is 145.50.20.1 to 145.50.23.254; the broadcast address for the range is 145.50.23.255. All of the other answer options are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      87,
      104,
      103,
      84,
      102
    ],
    "source": "235605_ch08"
  },
  {
    "id": 352,
    "question": "Which method will allow you to use RFC 1918 addresses for Internet requests?",
    "choice_a": "CIDR",
    "choice_b": "Classful addressing",
    "choice_c": "NAT",
    "choice_d": "VPN",
    "correct_answer": "C",
    "explanation": "Network address translation (NAT) was created to slow the depletion of Internet addresses. It does this by translating RFC 1918 privatized addresses to one or many public IP addresses. It allows the packets to masquerade as the public IP address on the Internet until it is translated back to the private IP address. Classless Inter-Domain Routing (CIDR) is a notation used to express the network for a host. Classful addressing is the original addressing scheme for the Internet. Virtual private networks (VPNs) are used for remote access.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      116,
      287,
      86,
      99,
      21
    ],
    "source": "235605_ch08"
  },
  {
    "id": 353,
    "question": "In the following exhibit, what is the inside local IP address?<br><img src=\"/question_assets/Network+/235605_c08uf003.png\"/>",
    "choice_a": "192.168.1.2 Host A",
    "choice_b": "192.168.1.1 Router A Gi0/0",
    "choice_c": "179.43.44.1 Router A S0/0",
    "choice_d": "198.23.53.3 web server",
    "correct_answer": "A",
    "explanation": "The inside local address is the address local to the enterprise (private), and the address is inside the enterprise. The inside local address will almost always be an RCF 1918 address, unless NAT is being used for purposes other than enterprise Internet access. If NAT is used for Internet access, then the inside local address is any host address destined for the Internet through NAT. 192.168.1.1 is the router\u2019s interface address used to communicate with inside local hosts during the NAT process. 179.43.44.1 is the inside global address for the NAT process. 198.23.53.3 is the outside global address for the NAT process.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      118,
      116,
      86,
      117,
      287
    ],
    "source": "235605_ch08"
  },
  {
    "id": 354,
    "question": "In the following exhibit, what is the inside global IP address?<br><img src=\"/question_assets/Network+/235605_c08uf004.png\"/>",
    "choice_a": "192.168.1.2 Host A",
    "choice_b": "192.168.1.1 Router A Gi0/0",
    "choice_c": "179.43.44.1 Router A S0/0",
    "choice_d": "198.23.53.3 web server",
    "correct_answer": "C",
    "explanation": "The inside global address is the address public to the enterprise. The address is inside of or controlled by the enterprise. The inside global address in this case is the public side of the NAT, which is Router A\u2019s S0/0 IP address. 192.168.1.2 is the inside local address of the host computer. 192.168.1.1 is the router\u2019s interface address used to communicate with inside local hosts during the NAT process. 198.23.53.3 is the outside global address for the NAT process.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      54,
      68,
      119,
      129,
      132
    ],
    "source": "235605_ch08"
  },
  {
    "id": 355,
    "question": "In the following exhibit, what is the outside global IP address?<br><img src=\"/question_assets/Network+/235605_c08uf005.png\"/>",
    "choice_a": "192.168.1.2 Host A",
    "choice_b": "192.168.1.1 Router A Gi0/0",
    "choice_c": "179.43.44.1 Router A S0/0",
    "choice_d": "198.23.53.3 web server",
    "correct_answer": "D",
    "explanation": "The outside global address is the address public to the enterprise. The address is outside of the enterprise or outside of its control. When using NAT for Internet access, the outside global address is the destination host on the Internet. The outside global address in this exhibit is the web server. 192.168.1.2 is the inside local address of the host computer. 192.168.1.1 is the router\u2019s interface address used to communicate with inside local hosts during the NAT process. 179.43.44.1 is the inside global address for the NAT process.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      118,
      116,
      86,
      117,
      287
    ],
    "source": "235605_ch08"
  },
  {
    "id": 356,
    "question": "What is the maximum number of IP addresses that can be assigned to hosts on a local subnet that uses the 255.255.255.248 subnet mask?",
    "choice_a": "6",
    "choice_b": "15",
    "choice_c": "16",
    "choice_d": "30",
    "correct_answer": "A",
    "explanation": "A /29 (255.255.255.248) is 5 bits for the network mask and 3 bits for the hosts. This provides 32 subnets, each with 6 hosts. Does it matter if this mask is used with a Class A, B, or C network address? Not at all. The number of host bits would never change.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      106,
      104,
      102,
      114,
      87
    ],
    "source": "235605_ch08",
    "choice_e": "31",
    "choice_f": "62"
  },
  {
    "id": 357,
    "question": "If a host on a network has the address 172.16.45.14/30, what is the subnetwork this host belongs to?",
    "choice_a": "172.16.45.0",
    "choice_b": "172.16.45.4",
    "choice_c": "172.16.45.8",
    "choice_d": "172.16.45.12",
    "correct_answer": "D",
    "explanation": "A /30, regardless of the class of address, has a 252 in the fourth octet. This means we have a block size of 4, and our subnets are 0, 4, 8, 12, 16, and so on. Address 14 is obviously in the 12 subnet.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      102,
      103,
      114,
      101
    ],
    "source": "235605_ch08",
    "choice_e": "172.16.45.16"
  },
  {
    "id": 358,
    "question": "On which of the following devices are you typically able to implement NAT?",
    "choice_a": "Hub",
    "choice_b": "Ethernet switch",
    "choice_c": "Router",
    "choice_d": "Bridge",
    "correct_answer": "C",
    "explanation": "Devices with layer 3 awareness, such as routers and firewalls, are the only ones that can manipulate the IP header in support of NAT. A hub operates at the physical layer and cannot perform NAT. Ethernet switches and bridges operate at the Data Link layer and cannot perform NAT.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      21,
      22,
      117,
      2,
      81
    ],
    "source": "235605_ch08"
  },
  {
    "id": 359,
    "question": "Which is required for the successful routing of a packet through a router?",
    "choice_a": "Originating network of a packet",
    "choice_b": "Return path for the network packet",
    "choice_c": "Destination network of a packet",
    "choice_d": "Destination host of a packet",
    "correct_answer": "C",
    "explanation": "Routing decisions are based upon the route table contained in the router\u2019s memory and knowledge of the destination network of a packet. The originating network of a packet is not needed throughout the entire routing process. The return path of the network packet is not needed on its journey but will be needed when a packet is sent back from the destination host. The destination of the specific host is not required as long as the destination network is known; routing is typically done by network.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      119,
      122,
      68,
      121,
      133
    ],
    "source": "235605_ch09"
  },
  {
    "id": 360,
    "question": "Which Cisco IOS command will display the route table?",
    "choice_a": "<code>show ip route</code>",
    "choice_b": "<code>show route</code>",
    "choice_c": "<code>display route</code>",
    "choice_d": "<code>show routing</code>",
    "correct_answer": "A",
    "explanation": "The command <code>show ip route</code> will display the route table contained in the router\u2019s memory. All other commands are incorrect.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      119,
      120,
      133,
      124,
      68
    ],
    "source": "235605_ch09"
  },
  {
    "id": 361,
    "question": "Which is true about static routes?",
    "choice_a": "Routes are automatically updated.",
    "choice_b": "New routes are learned periodically.",
    "choice_c": "Static routes are the best for traffic flow.",
    "choice_d": "All routes must be manually configured.",
    "correct_answer": "D",
    "explanation": "All routes must be manually configured when you use static routes. Routes are not automatically updated because they are statically assigned. The learning of new routes and updating of existing routes is a function of dynamic routing protocols. Static routes are not the best for network traffic since a packet will always take the same route regardless of network status.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      120,
      130,
      137,
      140,
      119
    ],
    "source": "235605_ch09"
  },
  {
    "id": 362,
    "question": "Using the following example, what does the <code>C</code> in the route statement mean?<br>Gateway of last resort is not set <br>C      192.168.1.0/24 is directly connected, FastEthernet0/0 <br>C      192.168.2.0/24 is directly connected, FastEthernet0/1",
    "choice_a": "The gateway of last resort is not set.",
    "choice_b": "The route is statically configured.",
    "choice_c": "The network is configured on the interface.",
    "choice_d": "The network is a continuation of another route.",
    "correct_answer": "C",
    "explanation": "The <code>C</code> in the route statement means that the network is directly connected on the interface because it is configured on the interface. The gateway of last resort is the default gateway and has no influence on the individual route statement. If the route was statically configured, the letter would be an <code>S</code>. A network that is a continuation of another network is called a summary route and not depicted as another route entry.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      119,
      122,
      54,
      131,
      133
    ],
    "source": "235605_ch09"
  },
  {
    "id": 363,
    "question": "What happens when the destination IP address of a packet is not in the same network as the host?",
    "choice_a": "The destination IP address is set to the default gateway.",
    "choice_b": "The destination MAC address is set to the default gateway.",
    "choice_c": "The source IP address is set to the default gateway.",
    "choice_d": "The source MAC address is set to the default gateway.",
    "correct_answer": "B",
    "explanation": "When the destination IP address of a packet is not in the same network as the host, the host will set the destination MAC address to the default gateway. The destination IP address will never change throughout the IP routing process. The source IP address and MAC address have no influence over the routing process.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      121,
      129,
      126,
      132,
      119
    ],
    "source": "235605_ch09"
  },
  {
    "id": 364,
    "question": "Which command can be used on a Cisco router to view the ARP cache?",
    "choice_a": "<code>show arp</code>",
    "choice_b": "<code>show arp-cache</code>",
    "choice_c": "<code>arp -g</code>",
    "choice_d": "<code>show ip arp</code>",
    "correct_answer": "D",
    "explanation": "The command <code>show ip arp</code> can be used on a Cisco router to view the ARP cache. The commands <code>show arp</code> and <code>show arp-cache</code> are invalid commands. The command <code>arp -g</code> can be used on a Windows computer to view the ARP cache.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      122,
      119,
      121,
      126
    ],
    "source": "235605_ch09"
  },
  {
    "id": 365,
    "question": "What is the term used to describe the map of the internetwork inside a router?",
    "choice_a": "Route map",
    "choice_b": "Route table",
    "choice_c": "Dynamic route",
    "choice_d": "Static route",
    "correct_answer": "B",
    "explanation": "The route table is the term used to describe the map of the internetwork inside a router. The route table is used to make routing decisions based upon the destination network address of the packet. A route map is not a valid answer for this question. A dynamic route is a route derived from a dynamic routing protocol. A static route is a route that has been explicitly configured.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      119,
      122,
      124,
      120,
      68
    ],
    "source": "235605_ch09"
  },
  {
    "id": 366,
    "question": "Which protocol is used to derive the MAC address of the default gateway?",
    "choice_a": "ARP",
    "choice_b": "ICMP",
    "choice_c": "RARP",
    "choice_d": "Dynamic routing",
    "correct_answer": "A",
    "explanation": "Address Resolution Protocol (ARP) is used to derive the MAC address of the default gateway, in the event that a packet must be routed. The Internet Control Message Protocol (ICMP) is used to convey messages about layer 3 connectivity. Reverse Address Resolution Protocol (RARP) is used to derive an IP address from a known MAC address, similar to DHCP.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      121,
      126,
      129,
      128
    ],
    "source": "235605_ch09"
  },
  {
    "id": 367,
    "question": "What is the Ether-Type field set to for the IPv4 protocol?",
    "choice_a": "0x0806",
    "choice_b": "0x86dd",
    "choice_c": "0x0800",
    "choice_d": "0x8035",
    "correct_answer": "C",
    "explanation": "The Ether-Type field will always be set to 0x800 for the IPv4 protocol. When data is destined for the ARP protocol, the Ether-Type field will contain 0x806. These are the two common Ether-Types you will commonly see. All other answers are incorrect.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      129,
      121,
      123,
      126,
      128
    ],
    "source": "235605_ch09"
  },
  {
    "id": 368,
    "question": "You are the network administrator for a small network that has multiple locations. You expect to add more in the future and want to ensure that routing is not troublesome and will be automated. Which should you employ?",
    "choice_a": "Static routing",
    "choice_b": "Dynamic routing",
    "choice_c": "Dynamic Host Configuration Protocol",
    "choice_d": "Reverse Address Resolution Protocol",
    "correct_answer": "B",
    "explanation": "Dynamic routing will ensure that routing in the network is automated as new locations are added to the network. Static routing will require manual intervention by the administrator updating all routing tables. Dynamic Host Configuration Protocol (DHCP) will automate the serving of IP addresses to hosts, but it will not update route tables. Reverse Address Resolution Protocol (RARP) is like DHCP in its utility, but it will not update routing tables.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      120,
      130,
      131,
      137,
      140
    ],
    "source": "235605_ch09"
  },
  {
    "id": 369,
    "question": "What will happen if the router does not have a route to the destination network for a ping packet? (Choose two.)",
    "choice_a": "The packet will be returned to the sender.",
    "choice_b": "The packet will be logged.",
    "choice_c": "The packet will be dropped.",
    "choice_d": "An ICMP packet is sent to the sender.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "If a route is not present for the destination network, the packet will be dropped. An Internet Control Message Protocol (ICMP) destination unreachable packet will be sent back to the sender to notify them the route is unreachable. The original packet is never sent back to the sender; it is just dropped. Packet logging happens only when it is appropriately configured. Routers will not request dynamic routing updates upon an unknown destination network.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      127,
      119,
      124,
      121,
      68
    ],
    "source": "235605_ch09",
    "choice_e": "The router will request a dynamic update."
  },
  {
    "id": 370,
    "question": "What is at the end of a frame that allows the destination to verify that the frame was transmitted intact?",
    "choice_a": "Source MAC address",
    "choice_b": "Destination MAC address",
    "choice_c": "Ether-Type",
    "choice_d": "FCS",
    "correct_answer": "D",
    "explanation": "The frame checking sequence (FCS) is a cyclical redundancy check (CRC) at the end of the frame that is 4 bytes long. The FCS allows the destination to verify that the frame has been received intact. The source MAC address, destination MAC address, and Ether-Type have no significance to the validity of the frame other than they are included in the CRC when it is calculated.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      123,
      122,
      124,
      69,
      153
    ],
    "source": "235605_ch09"
  },
  {
    "id": 371,
    "question": "What is the message if an ICMP ping packet is lost along the way en route to the destination?",
    "choice_a": "Request timed out",
    "choice_b": "Unknown error",
    "choice_c": "Destination unreachable",
    "choice_d": "Problem occurred",
    "correct_answer": "A",
    "explanation": "When an ICMP ping packet or any packet is lost along its route, the result will be \u201cRequest timed out.\u201d A <code>ping</code> or <code>tracert</code> to the destination will return the message, where normal application will just result in a timeout. The request timeout is an unknown error, but the message \u201cUnknown error\u201d will not be returned for the <code>ping</code> command. \u201cDestination unreachable\u201d will be returned as an error if a router does not have the route in its route table. \u201cProblem occurred\u201d is not an error message returned.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      127,
      124,
      122,
      119,
      123
    ],
    "source": "235605_ch09"
  },
  {
    "id": 372,
    "question": "Which interface will the router switch the packet to for a destination of 172.16.20.94?<br>Gateway of last resort is not set <br>C       172.16.20.0/27  is directly connected, FastEthernet 0/0 <br>C       172.16.20.32/27 is directly connected, FastEthernet 0/1 <br>C       172.16.20.64/27 is directly connected, FastEthernet 0/2 <br>C       172.16.20.128/27 is directly connected, FastEthernet 0/3",
    "choice_a": "FastEthernet 0/0",
    "choice_b": "FastEthernet 0/1",
    "choice_c": "FastEthernet 0/2",
    "choice_d": "FastEthernet 0/3",
    "correct_answer": "C",
    "explanation": "The destination IP address of 172.16.20.94 is within the 172.16.20.64/27 network; the exit interface will be FastEthernet 0/2. All other answers are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      119,
      121,
      68,
      129,
      122
    ],
    "source": "235605_ch09"
  },
  {
    "id": 373,
    "question": "Which of these statements best describes dynamic routing?",
    "choice_a": "All network IDs must be manually entered into the routing table.",
    "choice_b": "All host IDs must be manually entered into the routing table.",
    "choice_c": "Routing tables are updated automatically when changes occur in the network.",
    "choice_d": "Dynamic routing is the default for all routers.",
    "correct_answer": "C",
    "explanation": "In dynamic routing, routers update each other about all the networks they know about and place this information into the routing table. This is possible because a protocol on one router communicates with the same protocol running on neighbor routers. If changes occur in the network, a dynamic routing protocol automatically informs all routers about the event. The network and host IDs do not need to be manually entered unless you are static routing. Dynamic routing is not the default for all routers static routing is the default.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      131,
      137,
      119,
      142
    ],
    "source": "235605_ch09"
  },
  {
    "id": 374,
    "question": "Which of these statement regarding MAC addresses is true correct?",
    "choice_a": "The destination MAC address does not change through the routing process.",
    "choice_b": "MAC addresses are always local on the LAN and never routed.",
    "choice_c": "The default gateway MAC address is always the same on all interfaces.",
    "choice_d": "Route decisions are based on the destination MAC address.",
    "correct_answer": "B",
    "explanation": "MAC addresses are always local to the LAN, since they are used for physical addressing. IP addresses are routed through the router and not MAC addresses. During the routing process the MAC address is changed to the next physical address of the next device accepting the frame. The default gateway MAC address will always be unique on all the interfaces. Route decisions are made based only upon the destination IP address.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      126,
      129,
      132,
      121,
      128
    ],
    "source": "235605_ch09"
  },
  {
    "id": 375,
    "question": "What is the term used to describe the result of all routes being updated in the routing table via a dynamic routing protocol?",
    "choice_a": "Dynamic updates",
    "choice_b": "Route updates",
    "choice_c": "DNS resolution",
    "choice_d": "Convergence",
    "correct_answer": "D",
    "explanation": "Convergence is the term used to describe the result of all routes updated in a routing table via a dynamic routing protocol. The fastest convergence is always desirable to keep packets routing properly. Convergence is achieved by dynamic route updates from other routers. DNS resolution is not a component of routing.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      130,
      137,
      119,
      131,
      140
    ],
    "source": "235605_ch09"
  },
  {
    "id": 376,
    "question": "What command would be used to view the ARP cache on your host?",
    "choice_a": "<code>show ip route</code>",
    "choice_b": "<code>show ip arp</code>",
    "choice_c": "<code>show protocols</code>",
    "choice_d": "<code>arp -a</code>",
    "correct_answer": "D",
    "explanation": "The command <code>arp -a</code> will show the ARP cache on your host. The command <code>show ip route</code> will display the route table on a router. The command <code>show ip arp</code> will display the ARP cache on a router or switch. The <code>command show protocols</code> will display all the configured layer 3 protocols on the router.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      122,
      124,
      121,
      132
    ],
    "source": "235605_ch09"
  },
  {
    "id": 377,
    "question": "Where along the IP routing process does a packet get changed?",
    "choice_a": "Router",
    "choice_b": "Source host",
    "choice_c": "Destination host",
    "choice_d": "All of the above",
    "correct_answer": "C",
    "explanation": "A frame changes at each hop, but the packet is never changed in any way until it reaches the destination host. Once it reaches the destination host, the packet is moved up the network stack and to the respective application. This is where the packet is modified and sent back to the originating host.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      121,
      129,
      123,
      125
    ],
    "source": "235605_ch09"
  },
  {
    "id": 378,
    "question": "What is the term used to describe a collection of networks or subnets that are in the same administrative domain?",
    "choice_a": "Autonomous system",
    "choice_b": "IGP",
    "choice_c": "Administrative distance",
    "choice_d": "EGP",
    "correct_answer": "A",
    "explanation": "An autonomous system is the term used to describe a collection of networks or subnets that are in the same administrative domain. An interior gateway protocol (IGP) is a dynamic routing protocol that is used inside of a network. The administrative distance (AD) is used to decide the most trusted route when two or more routes to the same network exist. An exterior gateway protocol (EGP) is a dynamic routing protocol used outside of the network.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      141,
      131,
      140,
      142,
      143
    ],
    "source": "235605_ch09"
  },
  {
    "id": 379,
    "question": "Which high-availability protocol is an open standard?",
    "choice_a": "NLB",
    "choice_b": "HSRP",
    "choice_c": "OSPF",
    "choice_d": "VRRP",
    "correct_answer": "D",
    "explanation": "Virtual Router Redundancy Protocol (VRRP) is an open standard protocol that is used for high availability of default gateways. Network Load Balancing (NLB) is a Windows service that allows for load balancing of network services. Hot Standby Router Protocol (HSRP) is a Cisco proprietary high availability protocol. Open Shortest Path First (OSPF) is a dynamic routing protocol.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      275,
      145,
      274,
      264,
      131
    ],
    "source": "235605_ch10"
  },
  {
    "id": 380,
    "question": "How are routers managed with interior gateway protocols?",
    "choice_a": "Routers are grouped into autonomous systems.",
    "choice_b": "Routing protocols are redistributed between ASs.",
    "choice_c": "All routers use the same interior routing protocol.",
    "choice_d": "All network IDs are advertised with the same autonomous system number.",
    "correct_answer": "A",
    "explanation": "Routers are grouped into the same autonomous system (AS). When they are within the same AS, they can exchange information such as routes to destination networks and converge their routing tables. Routing protocols are not normally redistributed between ASs because the network is usually managed as one AS. All routers do not necessarily use the same routing protocols; many different portions of the network can use different protocols. All network IDs are not advertised with the same autonomous system number. Routers are normally grouped into one AS logically, such as an organization. Inside that organization (AS), many different autonomous system numbers can be used.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      137,
      142,
      119,
      136
    ],
    "source": "235605_ch10"
  },
  {
    "id": 381,
    "question": "What is the maximum hop count for RIP?",
    "choice_a": "15 hops",
    "choice_b": "100 hops",
    "choice_c": "255 hops",
    "choice_d": "16 hops",
    "correct_answer": "A",
    "explanation": "The maximum hop count for RIP is 15. A hop count over 15 hops is considered non-routable or unreachable, so the other options are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      137,
      131,
      140,
      142
    ],
    "source": "235605_ch10"
  },
  {
    "id": 382,
    "question": "Which statement is true about RIPv2 advertisements?",
    "choice_a": "RIPv2 allows for neighborship through hello packets.",
    "choice_b": "RIPv2 broadcasts only updates on all active interfaces.",
    "choice_c": "RIPv2 multicasts the full routing table every 30 seconds.",
    "choice_d": "RIPv2 multicasts the full routing table every 60 seconds.",
    "correct_answer": "C",
    "explanation": "By default, RIPv2 multicasts the full routing table on all active interfaces every 30 seconds. RIPv2 does not allow for neighborship through hello packets, such as link-state and hybrid dynamic routing protocols. RIPv2 uses multicasts, not broadcasts. RIPv2 multicasts the full routing table every 30 seconds, not every 60 seconds.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      138,
      137,
      131,
      142,
      140
    ],
    "source": "235605_ch10"
  },
  {
    "id": 383,
    "question": "Which multicast address does RIPv2 use for advertising routes?",
    "choice_a": "224.0.0.5",
    "choice_b": "224.0.0.9",
    "choice_c": "224.0.0.6",
    "choice_d": "224.0.0.2",
    "correct_answer": "B",
    "explanation": "RIPv2 uses the multicast address 224.0.0.9 to advertise routes. The multicast address 224.0.0.5 is used by OSPF for hello messages. The multicast address 224.0.0.6 is also used by OSPF for hello messages for designated routers (DRs) and backup designated routers (BDRs). The multicast address 224.0.0.2 is a special multicast group for all routers, and it is not used by any particular routing protocol.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      131,
      142,
      137,
      143
    ],
    "source": "235605_ch10"
  },
  {
    "id": 384,
    "question": "Which routing protocol will not contain a topology of the network?",
    "choice_a": "EIGRP",
    "choice_b": "RIP",
    "choice_c": "OSPF",
    "choice_d": "BGP",
    "correct_answer": "B",
    "explanation": "Routing Information Protocol (RIP) does not contain a topology table. RIP compiles its table from multiple broadcasts or multicasts in the network from which it learns routes. However, it never has a full topological diagram of the network like OSPF, EIGRP, and BGP.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      137,
      142,
      140,
      143
    ],
    "source": "235605_ch10"
  },
  {
    "id": 385,
    "question": "When a static route is made, what is the default AD?",
    "choice_a": "AD of 1",
    "choice_b": "AD of 0",
    "choice_c": "AD of 2",
    "choice_d": "AD of 255",
    "correct_answer": "A",
    "explanation": "Static routes are highly trusted routes, since an administrator created them. Therefore, they have the lowest administrative distance (AD) with a number of 1. The administrative of 0 is used for connected interfaces. The administrative distance of 2 is a wrong answer and does not map to a route source. The administrative distance of 255 is reserved for unknown sources and is entered into the route process.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      133,
      120,
      130,
      131,
      140
    ],
    "source": "235605_ch10"
  },
  {
    "id": 386,
    "question": "Why are ADs used with routing tables?",
    "choice_a": "ADs define protocol standards.",
    "choice_b": "ADs define reliability of routing protocols.",
    "choice_c": "ADs allow for the shortest distance between routes.",
    "choice_d": "ADs are programmed by the administrator for path selection.",
    "correct_answer": "B",
    "explanation": "Administrative distance (AD) is an order of reliability between dynamic routing protocols and static routes. Administrative distances do not define protocol standards; they only reference them. Administrative distances do not allow for the shortest distance between routers; they allow the router to choose the best path to the destination network. Although administrative distances are programmed into route statements by administrators, they do not calculate path selection.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      133,
      119,
      120,
      137,
      140
    ],
    "source": "235605_ch10"
  },
  {
    "id": 387,
    "question": "What is the metric for OSPF?",
    "choice_a": "Link",
    "choice_b": "Delay, bandwidth, reliability, load",
    "choice_c": "K metrics",
    "choice_d": "Bandwidth",
    "correct_answer": "D",
    "explanation": "Cisco uses a metric for OSPF that is calculated as 10 to the power of 8/bandwidth. This cost value is of 100 Mbps (reference bandwidth) divided by the interface bandwidth. Delay, bandwidth, reliability, and load are used as a composite metric with EIGRP. K metrics are used to weight the calculation of the composite metric used with EIGRP. Link is not used as a metric; if the link is not present, the route will not populate.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      131,
      133,
      119,
      136
    ],
    "source": "235605_ch10"
  },
  {
    "id": 388,
    "question": "You are examining a router and discover that there is a static default route configured for a next hop of 192.168.1.2. You also notice that there is a default route being populated from RIP for a next hop of 192.168.2.2. Which default route will be selected?",
    "choice_a": "The route with the lowest AD",
    "choice_b": "The route with the highest AD",
    "choice_c": "The route with the lowest metric",
    "choice_d": "The route being populated from RIP",
    "correct_answer": "A",
    "explanation": "Since both routes are default routes, the route with the lowest administrative distance (AD) will be selected. The route with the highest administrative distance will never be selected first. The route with the lowest metric will be used only if two routes exist to the same destination network and have equal administrative distances. The RIP routing protocol has an administrative distance of 120; therefore, it has a higher administrative distance over a statically defined default route and will not be selected.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      133,
      138,
      120,
      137,
      131
    ],
    "source": "235605_ch10"
  },
  {
    "id": 389,
    "question": "Which routing protocol is a distance-vector routing protocol?",
    "choice_a": "OSPF",
    "choice_b": "RIP",
    "choice_c": "EIGRP",
    "choice_d": "BGP",
    "correct_answer": "B",
    "explanation": "The Routing Information Protocol (RIP) is a distance-vector protocol. Open Shortest Path First (OSPF) is a link-state protocol. Enhanced Interior Gateway Routing Protocol is a hybrid protocol that more closely resembles a link-state protocol. Border Gate-way Protocol (BGP) is a path-vector protocol used for Internet routing.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      131,
      137,
      138,
      140,
      142
    ],
    "source": "235605_ch10"
  },
  {
    "id": 390,
    "question": "Which statement accurately describes a routing loop?",
    "choice_a": "Packets are routed out one interface but come back on a different interface.",
    "choice_b": "Packets are transmitted within a series of routers and never reach the destination.",
    "choice_c": "Packets reach the expiry TTL before reaching the destination network.",
    "choice_d": "Packets are routed via an inefficient path.",
    "correct_answer": "B",
    "explanation": "A routing loop occurs when packets are routed between two or more routers and never make it to their destination. Routing loops can occur with more than two routers; it is in effect making the packet travel in a loop till its TTL expires. When packets are routed out one interface and come back in on a different interface, this is considered asynchronous routing and not typical of a routing loop. Packets reaching the expiry TTL could mean that there are too many hops to the destination network, but not that a routing loop is occurring. Packets being routed via an inefficient path is not a symptom of a routing loop.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      119,
      137,
      127,
      124,
      122
    ],
    "source": "235605_ch10"
  },
  {
    "id": 391,
    "question": "What is the AD of RIP?",
    "choice_a": "AD of 90",
    "choice_b": "AD of 100",
    "choice_c": "AD of 110",
    "choice_d": "AD of 120",
    "correct_answer": "D",
    "explanation": "The administrative distance of the Routing Information Protocol (RIP) is 120. The administrative distance of 90 is used for internal Enhanced Interior Gateway Routing Protocol (EIGRP). The administrative distance of 100 is used for Interior Gateway Routing Protocol (IGR). The administrative distance of 110 is used for Open Shortest.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      133,
      138,
      137,
      140,
      131
    ],
    "source": "235605_ch10"
  },
  {
    "id": 392,
    "question": "Which routing protocol is a link-state routing protocol?",
    "choice_a": "OSPF",
    "choice_b": "RIP",
    "choice_c": "EIGRP",
    "choice_d": "IGRP",
    "correct_answer": "A",
    "explanation": "Open Shortest Path First (OSPF) is a link-state protocol. A link-state protocol tracks the state of a link between two routers and chooses the most efficient routes based upon the shortest path. Routing Information Protocol (RIP) is a distance-vector protocol. Enhanced Interior Gateway Routing Protocol (EIGRP) is considered a hybrid protocol. Interior Gateway Routing Protocol (IGRP) is a distance-vector protocol.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      131,
      142,
      143,
      140,
      137
    ],
    "source": "235605_ch10"
  },
  {
    "id": 393,
    "question": "Which routing technique requires no administrator intervention when a route goes down?",
    "choice_a": "Dynamic routing",
    "choice_b": "Directly connected routes",
    "choice_c": "Default routing",
    "choice_d": "Static routing",
    "correct_answer": "A",
    "explanation": "Dynamic routing does not require any administrator intervention when routes go down. This is because dynamic routes send route notifications and recalculate the routing tables of all participating routers. Directly connected routes will require administrator intervention if the admin is relying upon the connected route as the route source and an interface goes down. Default routing requires administrator intervention if the default route goes down; the admin will need to pick a new default route and configure it. Static routing always requires an amount of administrator intervention for setup and maintenance of the routes since they are all done manually.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      130,
      137,
      140,
      131
    ],
    "source": "235605_ch10"
  },
  {
    "id": 394,
    "question": "Which is an advantage of dynamic routing protocols?",
    "choice_a": "Resiliency when routes become unavailable",
    "choice_b": "Lower router RAM usage",
    "choice_c": "Lower router CPU usage",
    "choice_d": "Less bandwidth usage",
    "correct_answer": "A",
    "explanation": "The benefit of a dynamic routing protocol is that it creates resiliency when routes become unavailable. It does this by recalculating the best route in the network around the outage. When using dynamic routing protocols, there is a higher RAM usage because of the route tables collected. CPU usage is also higher with dynamic routing protocols because of calculations. Bandwidth usage is also higher with dynamic routing protocols because of the traffic involved learning the various routes.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      120,
      130,
      137,
      140,
      142
    ],
    "source": "235605_ch10"
  },
  {
    "id": 395,
    "question": "Which routing protocol broadcasts updates for routes?",
    "choice_a": "RIPv1",
    "choice_b": "OSPF",
    "choice_c": "EIGRP",
    "choice_d": "BGP",
    "correct_answer": "A",
    "explanation": "The Routing Information Protocol version 1 (RIPv1) broadcasts updates for routing tables. Open Shortest Path First (OSPF) exclusively uses multicast to send updates. EIGRP uses multicast to send updates as well and has a backup of direct unicast. BGP uses unicast to retrieve updates on network paths.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      138,
      131,
      137,
      140,
      142
    ],
    "source": "235605_ch10"
  },
  {
    "id": 396,
    "question": "What is an advantage of dynamic routing protocols?",
    "choice_a": "Centralized routing tables",
    "choice_b": "Optimized route selection",
    "choice_c": "Ease of configuration",
    "choice_d": "Lower bandwidth utilization",
    "correct_answer": "B",
    "explanation": "Optimized route selection is a direct advantage of using dynamic routing protocols. A protocol such as OSPF uses the shortest path first algorithm for route selection. Routing tables will not be centralized since all routers participating in dynamic routing will contain their own routing tables. Dynamic routing is not easier to configure due to the up-front planning and configuration. A portion of the available bandwidth will also be consumed for the dynamic routing protocol.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      142,
      143,
      131,
      137,
      136
    ],
    "source": "235605_ch10"
  },
  {
    "id": 397,
    "question": "Which protocol is considered a hybrid protocol?",
    "choice_a": "RIP",
    "choice_b": "OSPF",
    "choice_c": "EIGRP",
    "choice_d": "BGP",
    "correct_answer": "C",
    "explanation": "The Enhanced Interior Gateway Routing Protocol (EIGRP) is a hybrid protocol. It has features of a vector-based protocol and a link-state protocol; hence, it is considered a hybrid protocol. RIP is a distance-vector routing protocol that is used for small networks. OSPF is an extremely scalable link-state protocol. Border Gateway Protocol (BGP) is the routing protocol that is used to route packets on the Internet, and it is considered a path-vector protocol.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      131,
      140,
      137,
      142,
      143
    ],
    "source": "235605_ch10"
  },
  {
    "id": 398,
    "question": "What is a characteristic of distance-vector protocols?",
    "choice_a": "They track the status of routes learned.",
    "choice_b": "They re-advertise routes learned.",
    "choice_c": "Each router keeps its own topology database.",
    "choice_d": "Each router checks the routes it learns.",
    "correct_answer": "B",
    "explanation": "Protocols such as Routing Information Protocol (RIP) re-advertise routes learned. This can be problematic since it is the equivalent of gossiping about what they have heard. Routes learned through this method are never tracked for status or double-checked for validity. Distance-vector protocols do not keep a topology database; they just feed routes to the route table. Distance-vector protocols never check the routes they learn because of the method of routing through rumor.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      137,
      131,
      142,
      140,
      119
    ],
    "source": "235605_ch10"
  },
  {
    "id": 399,
    "question": "Which devices provide the lowest latency and highest bandwidth for connectivity?",
    "choice_a": "Hubs",
    "choice_b": "Switches",
    "choice_c": "Bridges",
    "choice_d": "Routers",
    "correct_answer": "B",
    "explanation": "Switches provide the lowest latency with the use of application-specific integrated circuits (ASICs). Hubs are multiport repeaters and diminish usable bandwidth. Bridges are software-based switches and provide higher latency than switches. Routers introduce latency because of decapsulation, routing, and encapsulation of the packets.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      151,
      69,
      71,
      70,
      153
    ],
    "source": "235605_ch11"
  },
  {
    "id": 400,
    "question": "Which is a function of a layer 2 switch?",
    "choice_a": "Forwarding the data based upon logical addressing",
    "choice_b": "Repeating the electrical signal to all ports",
    "choice_c": "Learning the MAC address by examining the destination MAC addresses",
    "choice_d": "Determining the forwarding interfaces based upon the destination MAC address and tables",
    "correct_answer": "D",
    "explanation": "Switches learn MAC addresses based upon incoming ports and examination of the source MAC address. It will build a MAC address table for future lookups. It then determines forwarding interfaces based upon the destination MAC address contained in the frame. Forwarding of data is based upon physical addresses \u201cburned\u201d into the network interface card (NIC) called MAC addresses. Repeating electrical signals to all ports describes how a dumb hub would operate. MAC addresses are learned by the source MAC address on incoming frames to the switch, not the destination frames.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      178,
      152,
      153,
      70,
      150
    ],
    "source": "235605_ch11"
  },
  {
    "id": 401,
    "question": "Which quality of service (QoS) method is used at layer 2 of the OSI?",
    "choice_a": "802.1Q",
    "choice_b": "ToS",
    "choice_c": "Diffserv",
    "choice_d": "CoS",
    "correct_answer": "D",
    "explanation": "The Class of Service (CoS) marking is a 3-bit field in the 802.1Q trunk frame. This 3-bit field contains eight possible queues for QoS at layer 2. Although the 802.1Q protocol supports quality of service (QoS) via the CoS field, 802.1Q is a trunking protocol. Type of Services (ToS) and Diffserv are layer 3 methods for QoS.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      165,
      163,
      162,
      69,
      151
    ],
    "source": "235605_ch11"
  },
  {
    "id": 402,
    "question": "You need to trunk two switches from two different vendors together. Which trunking protocol should you use?",
    "choice_a": "ISL",
    "choice_b": "802.1D",
    "choice_c": "802.1Q",
    "choice_d": "802.1w",
    "correct_answer": "C",
    "explanation": "The 802.1Q protocol is an open standard trunking protocol. Inter-Switch Link (ISL) is another trunking protocol, but it can be used only on Cisco devices. Because your switches are from two different vendors, they are not both Cisco devices; therefore, 802.1Q must be used. The 802.1D protocol is Spanning Tree Protocol (STP), used to prevent loops in networks. The 802.1w protocol is Rapid Spanning Tree Protocol (RSTP), which is also used to prevent loops in networks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      163,
      162,
      167,
      157,
      158
    ],
    "source": "235605_ch11"
  },
  {
    "id": 403,
    "question": "When calculating Spanning Tree Protocol (STP), which switch will always become the root bridge?",
    "choice_a": "The switch with the highest priority",
    "choice_b": "The switch with the highest MAC address",
    "choice_c": "The switch with the lowest MAC address",
    "choice_d": "The switch with the lowest priority",
    "correct_answer": "D",
    "explanation": "When calculating Spanning Tree Protocol (STP), the switch with the lowest MAC address will become the root bridge if all of the priorities are set to the default. However, if the priority on a particular switch is lower than the others, it will always become the root bridge. All other answers are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      159,
      157,
      179,
      171,
      178
    ],
    "source": "235605_ch11"
  },
  {
    "id": 404,
    "question": "You need to restrict a switch port to a maximum of two devices. What should you implement to guarantee only two devices can communicate on the switch port?",
    "choice_a": "Jumbo frames",
    "choice_b": "802.1X",
    "choice_c": "ACLs",
    "choice_d": "Port security",
    "correct_answer": "D",
    "explanation": "Port security can restrict a switch port to a specific number of ports configured by the administrator. The specific MAC addresses can be preconfigured or learned dynamically. The use of jumbo frames will allow 9000 bytes to be framed, in lieu of 1500 bytes normally in a frame. The use of 802.1X will restrict users from communicating on a switch, but it does not limit the number of devices communicating on a switchport. Access control lists are used to restrict traffic based upon IP address and destination port, among other attributes.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      169,
      177,
      153,
      170,
      71
    ],
    "source": "235605_ch11"
  },
  {
    "id": 405,
    "question": "Which is a benefit to converting a network from a flat layer 2 network to a routed layer 3 VLAN-enabled network?",
    "choice_a": "Increased collision domains for increased bandwidth",
    "choice_b": "Reduced complexity of design and operations",
    "choice_c": "Flexibility of user management and design",
    "choice_d": "Decreased number of broadcast domains for increased bandwidth",
    "correct_answer": "C",
    "explanation": "The flexibility of design for workgroups of clients, servers, services, etc., and the ongoing management of moving and adding people is a benefit of a routed VLAN-enabled network. Migrating from a flat layer 2 network to a routed layer 3 network will not increase collision domains for increased bandwidth. When you add a layer 3 routed infrastructure to your flat layer 2 network, the network complexity of design and operation will increase. You will increase the number of broadcast domains for increased bandwidth when you add multiple routed VLANs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      160,
      164,
      66,
      155,
      68
    ],
    "source": "235605_ch11"
  },
  {
    "id": 406,
    "question": "Which is a correct statement about frames and VLANs?",
    "choice_a": "Broadcast frames are sent to ports that are configured in different VLANs.",
    "choice_b": "Unicast frames that are not in the MAC address table are flooded to all ports in all VLANs.",
    "choice_c": "The ports that link switches together must be access links.",
    "choice_d": "Frames with a destination MAC that are not in the MAC address table are flooded to only ports in the respective VLAN.",
    "correct_answer": "D",
    "explanation": "Frames with MAC addresses that are not in the MAC address table are flooded only to the ports in the respective VLAN. Broadcast frames will not be sent outside of the VLAN they originate from because they cannot traverse a router. Unicast frames are not flooded to all ports in all VLANs; they are only flooded to all ports in the VLAN the frame has originated from. The ports that link switches together are usually trunk links so that multiple VLANs can traverse the connection.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      160,
      162,
      163,
      152,
      71
    ],
    "source": "235605_ch11"
  },
  {
    "id": 407,
    "question": "Static VLANs are being used on a switch\u2019s interface. Which of the following statements is correct?",
    "choice_a": "Nodes use a VLAN policy server.",
    "choice_b": "Nodes are assigned VLANs based on their MAC address.",
    "choice_c": "Nodes are unaware of the VLAN in which they are configured.",
    "choice_d": "All nodes are in the same VLAN.",
    "correct_answer": "C",
    "explanation": "Static VLANs are VLANs that have been manually configured versus dynamic VLANs, which are configured via a VLAN Membership Policy Server (VMPS). A node will not know which VLAN it is assigned to when it is statically set via the command <code>switchport access vlan 3</code>. Nodes use a VLAN Membership Policy Server (VMPS) if the VLAN is dynamically configured. Nodes are not assigned VLANs based on their MAC addresses when they are statically configured. All nodes are not necessarily in the same VLAN when static VLANs are being used.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      161,
      162,
      160,
      163,
      169
    ],
    "source": "235605_ch11"
  },
  {
    "id": 408,
    "question": "What is a direct benefit of adding VLANs?",
    "choice_a": "An increase of broadcast domains while decreasing collision domains",
    "choice_b": "An increase of broadcast domains while increasing collision domains",
    "choice_c": "A decrease of broadcast domains while decreasing collision domains",
    "choice_d": "A decrease of broadcast domains while increasing collisions domains",
    "correct_answer": "B",
    "explanation": "When adding VLANs, you immediately increase the number of broadcast domains. At the same time, you increase collision domains. If a switch had 12 ports and they all negotiated at 100 Mb/s half-duplex (one collision domain), when a VLAN is added, you will automatically create two collision domains while adding an additional broadcast domain.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      160,
      166,
      162,
      167,
      155
    ],
    "source": "235605_ch11"
  },
  {
    "id": 409,
    "question": "Which statement describes dynamic VLANs?",
    "choice_a": "The access port is switched into the respective VLAN based upon user credentials.",
    "choice_b": "The access port is switched into the respective VLAN based upon the computer\u2019s IP address.",
    "choice_c": "The access port is switched into the respective VLAN based upon the computer\u2019s MAC address.",
    "choice_d": "The access port is switched into the respective VLAN based upon security ACLs.",
    "correct_answer": "C",
    "explanation": "Dynamic VLANs are deprecated, but you may still see them in operations. A switch configured with dynamic VLANs checks a VLAN Management Policy Server (VMPS) when clients plug in. The VMPS has a list of MAC addresses to their respective VLANs. It is now recommended that dynamic VLAN installations are converted to 802.1X. The access port cannot be controlled with a VMPS based upon user credentials. The access port is also not switched into the respective VLAN based upon the computer\u2019s IP address, because the IP address is normally associated based upon the VLAN. The access port cannot be switched into a respective VLAN based upon ACLs since ACLs are used to restrict layer 3 traffic and not layer 2 traffic.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      161,
      160,
      169,
      178,
      167
    ],
    "source": "235605_ch11"
  },
  {
    "id": 410,
    "question": "Which type of port removes the VLAN ID from the frame before it egresses the interface?",
    "choice_a": "Access port",
    "choice_b": "Trunk port",
    "choice_c": "Voice port",
    "choice_d": "Native port",
    "correct_answer": "A",
    "explanation": "All VLAN tagging is removed from the frame before it egresses an access port to the end device. Trunk ports carry the VLAN tagging from end to end. Voice ports tag packets only when the CoS value is modified from the default. Native ports are used when frames arrive on a trunk and do not contain any tagging information.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      162,
      163,
      165,
      167,
      166
    ],
    "source": "235605_ch11"
  },
  {
    "id": 411,
    "question": "When you are protecting an interface with port security, to which mode should you set the switch port?",
    "choice_a": "Access mode",
    "choice_b": "Dynamic mode",
    "choice_c": "Trunk mode",
    "choice_d": "Voice mode",
    "correct_answer": "A",
    "explanation": "When you are configuring port security on an interface, the switch port should have a mode of access configured. This will also protect the switch from transitioning into a trunk if another switch is connected. There is no such mode as dynamic mode. If the interface is configured in trunk mode, port security will not be effective since many different MAC addresses can traverse the link. Voice mode is not a mode; it is a function of an access port that tags traffic when a CoS value is detected.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      169,
      162,
      165,
      172,
      174
    ],
    "source": "235605_ch11"
  },
  {
    "id": 412,
    "question": "Which VLAN is the default VLAN used to configure all switches from the factory?",
    "choice_a": "VLAN 999",
    "choice_b": "VLAN 1002",
    "choice_c": "VLAN 1005",
    "choice_d": "VLAN 1",
    "correct_answer": "D",
    "explanation": "All switches are configured by default with all interfaces in VLAN 1. This simplifies configuration if the switch is to be used as a direct replacement for a hub since nothing needs to be configured. All of the other options are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      160,
      162,
      167,
      168,
      150
    ],
    "source": "235605_ch11"
  },
  {
    "id": 413,
    "question": "You have been asked to segment the network for an R&D workgroup. The requirement is to allow the R&D group access to the existing servers, but no other VLANs should be able to access R&D. How can this be achieved with maximum flexibility?",
    "choice_a": "Create a new VLAN, configure a routed SVI interface, and apply ACLs to the VLAN.",
    "choice_b": "Create a new VLAN, configure a routed SVI interface, and apply extended ACLs to the R&D switch ports.",
    "choice_c": "Create a new VLAN, and install a new R&D server in the new VLAN.",
    "choice_d": "Create a new VLAN, and trunk the existing file server for both the production and R&D networks.",
    "correct_answer": "A",
    "explanation": "Creating the new VLAN will logically segment this work group. Creating a Switched Virtual Interface (SVI) will allow routing on the layer 3 switch. The ACLs should be applied only to VLAN interfaces. Although the other solutions achieve a similar goal, they do not provide flexibility. Extended ACLs cannot be applied to the R&D switch ports since they are layer 2 ports and extended ACLs are layer 3 entries. Creating a new VLAN for R&D and placing the R&D server in the VLAN will not accomplish the goal of restricting the server. Creating a new VLAN and using a trunk to connect the production and R&D network will not accomplish the task.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      164,
      160,
      162,
      68,
      54
    ],
    "source": "235605_ch11"
  },
  {
    "id": 414,
    "question": "How does IEEE 802.1Q tag frames?",
    "choice_a": "802.1Q adds a 32-bit header to the frame with the VLAN tagging information.",
    "choice_b": "802.1Q adds a 32-bit header to the packet with the VLAN tagging information.",
    "choice_c": "802.1Q inserts a 32-bit field between the source MAC address and the type field.",
    "choice_d": "802.1Q inserts a 32-bit field between the destination MAC address and the type field.",
    "correct_answer": "C",
    "explanation": "802.1Q inserts a field containing the 16-bit Tag Protocol ID of 0x8100, a 3-bit COS field, a 1-bit drop-eligible indicator (used with COS), and the 12-bit VLAN ID, which equals 32 bits, or 4 bytes. All of the other options are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      163,
      162,
      167,
      165,
      53
    ],
    "source": "235605_ch11"
  },
  {
    "id": 415,
    "question": "Which of the following is a true statement about static access ports?",
    "choice_a": "An access port can carry VLANs via tagging.",
    "choice_b": "A client computer can request the VLAN to be placed in.",
    "choice_c": "A client computer cannot see any VLAN tagging information.",
    "choice_d": "A client computer can see the VLAN tagging information.",
    "correct_answer": "C",
    "explanation": "The client computer connected to an access port cannot see any VLAN tagging information. It is removed before the frame egresses the interface. An access port cannot carry VLAN tagging information because it is stripped. The client computer cannot request the VLAN that it wants to operate in. The administrator must manually configure the VLAN. A client computer cannot see the VLAN tagging information because it is stripped out as it egresses an access port.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      162,
      160,
      163,
      161,
      169
    ],
    "source": "235605_ch11"
  },
  {
    "id": 416,
    "question": "You want to delete VLAN 1 for security reasons. However, the switch will not let you. What is the reason you cannot delete VLAN 1?",
    "choice_a": "The VLAN is still configured on a port.",
    "choice_b": "The VLAN serves as the switch\u2019s main management IP.",
    "choice_c": "The VLAN is protected from deletion.",
    "choice_d": "The VLAN is still configured as a native VLAN on a trunk.",
    "correct_answer": "C",
    "explanation": "VLANs 1 and 1002 through 1005 are protected by the IOS and cannot be changed, renamed, or deleted. VLAN 1 cannot be deleted, regardless of whether it is still configured on a port. The VLAN that serves as the switch\u2019s main management IP can be changed to any other VLAN; it only defaults to VLAN 1 from the factory. VLAN 1 cannot be deleted regardless of whether it is configured as a native VLAN on a trunk.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      160,
      167,
      168,
      162,
      163
    ],
    "source": "235605_ch11"
  },
  {
    "id": 417,
    "question": "Which statement is correct about native VLANs?",
    "choice_a": "Any traffic tagged will be placed on the native VLAN.",
    "choice_b": "Any traffic that is not allowed over the trunk will be placed on the native VLAN.",
    "choice_c": "Any traffic not tagged will be placed on the native VLAN.",
    "choice_d": "Any traffic that is tagged with ISL on an 802.1Q trunk will be placed on the native VLAN.",
    "correct_answer": "C",
    "explanation": "Native VLANs are used only for traffic that is not tagged, in which untagged frames are placed on a trunk link. A common use for native VLANs is management traffic between switches, before both sides are configured as a trunk. Traffic that is tagged will traverse the trunk link and not use the native VLAN. Native VLANs are not used for disallowed VLANs on a trunk link. Any traffic that is tagged with ISL on an 802.1Q trunk will not be distinguishable on either side since the frame will be mismatched.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      163,
      162,
      160,
      166,
      167
    ],
    "source": "235605_ch11"
  },
  {
    "id": 418,
    "question": "What is the function of the VTP?",
    "choice_a": "VTP allows for dynamic trunking between links.",
    "choice_b": "VTP allows for propagation of the VLAN database.",
    "choice_c": "VTP detects trunk encapsulation and negotiates trunks.",
    "choice_d": "VTP allows for propagation of the trunking database.",
    "correct_answer": "B",
    "explanation": "VLAN Trunking Protocol, or VTP, propagates the VLAN database from an initial master copy on the \u201cserver\u201d to all of the \u201cclients.\u201d VTP does not help facilitate the dynamic trunking between links. VTP does not detect trunk encapsulation and negotiate trunks. VTP allows for the propagation of the VLAN database, not the trunking database.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      167,
      162,
      163,
      166,
      155
    ],
    "source": "235605_ch11"
  },
  {
    "id": 419,
    "question": "Which wireless standard first introduced channel bonding?",
    "choice_a": "802.11n",
    "choice_b": "802.11ac",
    "choice_c": "802.11g",
    "choice_d": "802.11a",
    "correct_answer": "A",
    "explanation": "The 802.11n wireless standard introduced channel bonding. The 802.11n standard allows for the bonding of up to two channels to provide a 40 MHz channel. All other answers are incorrect.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      185,
      186,
      184,
      183,
      207
    ],
    "source": "235605_ch12"
  },
  {
    "id": 420,
    "question": "Which three wireless channels on 2.4 GHz wireless are nonoverlapping?",
    "choice_a": "1, 3, and 9",
    "choice_b": "1, 9, and 11",
    "choice_c": "1, 6, and 11",
    "choice_d": "1, 6, and 12",
    "correct_answer": "C",
    "explanation": "The 2.4 GHz wireless band has three nonoverlapping channels: 1, 6, and 11. Although they overlap with other channels, these three channels do not overlap between themselves. All other answers are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      183,
      198,
      186,
      207,
      196
    ],
    "source": "235605_ch12"
  },
  {
    "id": 421,
    "question": "You are setting up a wireless network for a client. Their requirements are to minimize the infrastructure and support the highest security. Which wireless encryption standard should be configured to satisfy the requirements?",
    "choice_a": "WPA-Enterprise",
    "choice_b": "WPA2-Personal",
    "choice_c": "WPA3-Enterprise",
    "choice_d": "WPA-Personal",
    "correct_answer": "B",
    "explanation": "To satisfy the requirements of the client, WPA2-Personal should be configured for the wireless network. WPA2-Personal will allow for 128-bit AES-CCMP encryption and work with a pre-shared key (PSK) to minimize infrastructure. WPA-Enterprise and WPA3-Enterprise require certificate services and an AAA server. WPA-Personal is weaker encryption than WPA2-Personal.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      204,
      206,
      196,
      192,
      67
    ],
    "source": "235605_ch12"
  },
  {
    "id": 422,
    "question": "You are configuring a WPA2 WLAN. Which security configuration should you use for the highest level of security?",
    "choice_a": "WPA-AES",
    "choice_b": "WPA2-TKIP",
    "choice_c": "WPA2-RC4",
    "choice_d": "WPA2-AES",
    "correct_answer": "D",
    "explanation": "The Wi-Fi Protected Access 2 (WPA2) protocol can be configured with Advanced Encryption Standard (AES) encryption to provide the highest level of security. Wi-Fi Protected Access (WPA) cannot be configured with AES encryption; therefore, this is a wrong answer. WPA2 cannot be configured with Temporal Key Integrity Protocol (TKIP); only WPA uses the RC4 encryption algorithm and TKIP.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      204,
      196,
      201,
      186,
      187
    ],
    "source": "235605_ch12"
  },
  {
    "id": 423,
    "question": "How many pre-shared keys can be configured for a specific WPA2 WLAN?",
    "choice_a": "One PSK (one hex or one ASCII)",
    "choice_b": "Two PSKs (one hex and one ASCII)",
    "choice_c": "Four PSKs (two hex and two ASCII)",
    "choice_d": "Unlimited number of PSKs",
    "correct_answer": "A",
    "explanation": "A single pre-shared key (PSK) is configured for a WPA2 WLAN. The PSK can be either one hex or one ASCII key, but it cannot be both. If you need multiple keys, then WPA2-Enterprise should be used. Keep in mind that a PSK is symmetrical encryption, whereas WPA2-Enterprise uses certificates and asymmetrical encryption. All of the other options are incorrect.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      192,
      204,
      206,
      201,
      183
    ],
    "source": "235605_ch12"
  },
  {
    "id": 424,
    "question": "After configuring a WLAN, your users complain that they do not see the SSID. What could be wrong?",
    "choice_a": "SSID beaconing is enabled.",
    "choice_b": "Multicast support is disabled.",
    "choice_c": "Radio Policy is configured to all.",
    "choice_d": "SSID beaconing is disabled.",
    "correct_answer": "D",
    "explanation": "SSID beaconing is enabled by default; if it were disabled, the clients would not see the SSID. Multicast support is used for multimedia applications and would not prevent the SSID from being seen by clients. The Radio Policy could possibly restrict clients from seeing the SSID depending on what it is set to. However, when it is set to all, there are no restrictions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      196,
      206,
      57,
      187,
      190
    ],
    "source": "235605_ch12"
  },
  {
    "id": 425,
    "question": "What is the mechanism that allows for authentication using a symmetrical key with WPA2?",
    "choice_a": "PSK",
    "choice_b": "AES",
    "choice_c": "Certificates",
    "choice_d": "TKIP",
    "correct_answer": "A",
    "explanation": "A pre-shared key (PSK) is the mechanism used for configuring authentication with WPA2 using a symmetrical key. Advanced Encryption Standard (AES) is an encryption protocol that is used in conjunction with WPA2. AES is not used for authentication of hosts. Certificates are used with WPA2-Enterprise; they are asymmetrical keys used for authentication. The Temporal Key Integrity Protocol (TKIP) is used alongside the RC4 protocol to provide encryption for WPA; it is not used for authentication.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      192,
      196,
      204,
      206,
      201
    ],
    "source": "235605_ch12"
  },
  {
    "id": 426,
    "question": "When configuring WPA2, you want to ensure that it does not fall back to the older WPA specification. What parameter should you disable?",
    "choice_a": "802.1X",
    "choice_b": "AES",
    "choice_c": "TKIP",
    "choice_d": "MAC filtering",
    "correct_answer": "C",
    "explanation": "You should disable the Temporal Key Integrity Protocol (TKIP) when configuring WPA. Since WPA relies on TKIP and WPA2 requires AES-Counter Mode CBC-MAC Protocol (AES-CCMP). This will ensure that the WAP and client do not fall back to the older WPA protocol. 802.1X will operate independently from the WPA2 and WPA fallback mechanism. Advanced Encryption Standard (AES) is an encryption protocol that is used in conjunction with WPA2; therefore, it should not be disabled. MAC filtering is not related to WPA or WPA2 and works independently as a security mechanism.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      204,
      196,
      206,
      187,
      201
    ],
    "source": "235605_ch12"
  },
  {
    "id": 427,
    "question": "Which mode of encryption does 802.11i (WPA2) introduce?",
    "choice_a": "RC4",
    "choice_b": "MD5",
    "choice_c": "AES-CCMP",
    "choice_d": "SHA1",
    "correct_answer": "C",
    "explanation": "The 802.11i (WPA2) specification introduced a specific mode of Advanced Encryption Standard (AES) encryption called Counter Mode with Cipher Block Chaining Message Authentication Code Protocol (CCMP). The Rivest Cipher 4 (RC4) algorithm is used by Wired Equivalent Privacy (WEP) and Wi-Fi Protected Access (WPA) as an encryption protocol. Message-Digest algorithm 5 (MD5) and Secure Hash Algorithm 1 (SHA1) are popular hashing algorithms but not related to wireless communications.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      204,
      206,
      196,
      185,
      186
    ],
    "source": "235605_ch12"
  },
  {
    "id": 428,
    "question": "Which statement is correct about WPA?",
    "choice_a": "WPA was released at the same time as WEP.",
    "choice_b": "WPA was released as a fix for poor coverage.",
    "choice_c": "WPA was released as a fix for poor encryption.",
    "choice_d": "The Wi-Fi Alliance wanted to rebrand WEP with WPA.",
    "correct_answer": "C",
    "explanation": "After the weaknesses in WEP encryption were discovered, the Wi-Fi Alliance rushed the release of the WPA security protocol. The WPA security protocol incorporated the 802.11i standard of TKIP, which allowed for better integrity of 802.11 transmissions. The WPA security protocol was released after the WEP security protocol. The WPA security protocol did not address any problems related to coverage. It was not a rebranding of the WEP security protocol; it was intended to be a replacement.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      204,
      206,
      196,
      187,
      186
    ],
    "source": "235605_ch12"
  },
  {
    "id": 429,
    "question": "Matilda is interested in securing her SOHO wireless network. What should she do to be assured that only her devices can join her wireless network?",
    "choice_a": "Enable WPA2",
    "choice_b": "Enable MAC filtering",
    "choice_c": "Enable port security",
    "choice_d": "Disable SSID broadcasts",
    "correct_answer": "B",
    "explanation": "Enabling MAC filtering on the access point will allow the devices that she specifies. Enabling WPA2 encryption will not prevent unauthorized access to the SOHO network. Port security is enabled on wired network switches to prevent unauthorized access. Disabling the SSID from broadcasting will not prevent unauthorized access.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      203,
      205,
      180,
      36,
      2
    ],
    "source": "235605_ch12"
  },
  {
    "id": 430,
    "question": "Which device is the supplicant during the 802.1X authentication process?",
    "choice_a": "The device requesting access",
    "choice_b": "The server that is providing authentication",
    "choice_c": "The device that is controlling access via 802.1X",
    "choice_d": "The device connecting the layer 3 network",
    "correct_answer": "A",
    "explanation": "The device requesting access is the supplicant. The supplicant is built into the operating system in which it is authenticating. The server that is providing authentication is the authentication server, which is commonly the AAA RADIUS server. The device that is controlling the access via the 802.1X protocol is the authenticator. The device connecting the layer 3 network is normally a router or layer 3 switch.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      161,
      187,
      174,
      190,
      57
    ],
    "source": "235605_ch12"
  },
  {
    "id": 431,
    "question": "What is the access point called in an 802.1X configuration?",
    "choice_a": "Authenticator",
    "choice_b": "Supplicant",
    "choice_c": "AAA server",
    "choice_d": "RADIUS server",
    "correct_answer": "A",
    "explanation": "The access point is responsible for communicating with the supplicant and sending information to the authenticating server. This device is called the authenticator. The end device that sends credentials is called the supplicant. The supplicant is a piece of software in the operating system that supplies the credentials for AAA authentication. The AAA server is normally a RADIUS server or TACACS+ server that is configured for 802.1X.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      161,
      196,
      206,
      201,
      57
    ],
    "source": "235605_ch12"
  },
  {
    "id": 432,
    "question": "You need to install wireless Internet access in an open warehouse environment. After installing the equipment, the technician notices varying signal strengths throughout the warehouse. How do you make sure there is full coverage?",
    "choice_a": "Turn on broadcast key rotation.",
    "choice_b": "Change the encryption method used on all the APs.",
    "choice_c": "Change the antenna placement.",
    "choice_d": "Use channel bonding.",
    "correct_answer": "C",
    "explanation": "It is imperative that a good site survey is completed before you install your wireless network. Trying various types of antennas and their placements is the key to covering the whole wireless area. Turning on broadcast key rotation is a security-related setting and will not affect signal strength. Changing the encryption method used at all the APs will change only the level of encryption and not signal strength. The use of channel bonding and traffic shaping will help increase throughput, but not signal strength.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      197,
      189,
      193,
      187,
      199
    ],
    "source": "235605_ch12",
    "choice_e": "Use traffic shaping."
  },
  {
    "id": 433,
    "question": "What is the frequency range of the IEEE 802.11g standard?",
    "choice_a": "2.4 Gbps",
    "choice_b": "5 Gbps",
    "choice_c": "2.4 GHz",
    "choice_d": "5 GHz",
    "correct_answer": "C",
    "explanation": "The IEEE 802.11b and IEEE 802.11g both run in the 2.4 GHz RF range. 2.4 Gbps and 5 Gbps describe a bandwidth speed and not a frequency range. 5 GHz is a wrong answer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      183,
      186,
      207,
      184,
      57
    ],
    "source": "235605_ch12"
  },
  {
    "id": 434,
    "question": "Which devices can interfere with the operation of a wireless network because they operate on similar frequencies? (Choose two.)",
    "choice_a": "Copier",
    "choice_b": "Microwave oven",
    "choice_c": "Toaster",
    "choice_d": "Cordless phone",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "If you are running 802.11b/g frequency, then you can receive interference from microwave ovens and cordless phones. Copiers, toasters, and IP phones will not interfere with wireless because they are typically wired. An AM radio receives radio waves and will not interfere with wireless.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      193,
      183,
      196,
      57,
      206
    ],
    "source": "235605_ch12",
    "choice_e": "IP phone",
    "choice_f": "AM radio"
  },
  {
    "id": 435,
    "question": "Which wireless standard allows you to channel-bond to increase bandwidth and uses both the 2.4 GHz and 5 GHz frequencies?",
    "choice_a": "802.11b",
    "choice_b": "802.11g",
    "choice_c": "802.11a",
    "choice_d": "802.11n",
    "correct_answer": "D",
    "explanation": "802.11n uses channel bonding of both the 2.4 GHz range and the 5 GHz range to get increased bandwidth of over 100 Mbps. All other answers are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      185,
      186,
      183,
      184,
      198
    ],
    "source": "235605_ch12",
    "choice_e": "802.11ac"
  },
  {
    "id": 436,
    "question": "You have installed a point-to-point connection using wireless bridges and Omni directional antennas between two buildings. The throughput is low. What can you do to improve the link?",
    "choice_a": "Replace the bridges with APs.",
    "choice_b": "Replace the Omni directional antennas with Yagis.",
    "choice_c": "Configure 802.11a on the links.",
    "choice_d": "Install amps to boost the signal.",
    "correct_answer": "B",
    "explanation": "You need to use directional antennas, like a Yagi, to get the best signal between antennas. Replacing bridges with APs will have no difference on a point-to-point connection. Configuring 802.11a on the links will require more power than 2.4GHz. Installing amps to boost the signal could violate wireless regulations.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      189,
      193,
      184,
      183,
      197
    ],
    "source": "235605_ch12"
  },
  {
    "id": 437,
    "question": "Which wireless LAN design ensures that a mobile wireless client will not lose connectivity when moving from one access point to another (roaming)?",
    "choice_a": "Using adapters and access points manufactured by the same company",
    "choice_b": "Overlapping the wireless cell coverage by at least 10 percent",
    "choice_c": "Configuring all access points to use the same channel",
    "choice_d": "Utilizing MAC address filtering to allow the client MAC address to authenticate with the surrounding APs",
    "correct_answer": "B",
    "explanation": "If you are running an extended service set (meaning more than one AP with the same SSID), you need to overlap the cell coverage by 10% or more so clients will not drop out while roaming. Using adapters and access points manufactured by the same vendor is not required, since the adapters and APs are manufactured with standards. Configuring all access points to use the same channel is not recommended when using multiple access points. Utilizing MAC address filtering is a security method and is not attributed to coverage.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      198,
      190,
      197,
      193,
      196
    ],
    "source": "235605_ch12"
  },
  {
    "id": 438,
    "question": "Which spread-spectrum technology does the 802.11b standard define for operation?",
    "choice_a": "IR",
    "choice_b": "DSSS",
    "choice_c": "FHSS",
    "choice_d": "DSSS and FHSS",
    "correct_answer": "B",
    "explanation": "The IEEE 802.11b standard uses direct-sequence spread spectrum (DSSS). If you are running 802.11g, it uses orthogonal frequency-division multiplexing (OFDM). All other answers are incorrect.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      183,
      186,
      207,
      185,
      184
    ],
    "source": "235605_ch12",
    "choice_e": "IR, FHSS, and DSSS"
  },
  {
    "id": 439,
    "question": "A serial console cable is an example of which of the following technologies?",
    "choice_a": "Captive portal",
    "choice_b": "Out-of-band management",
    "choice_c": "Clientless VPN",
    "choice_d": "AAA",
    "correct_answer": "B",
    "explanation": "Out-of-band management refers to any method of managing the server that does use the network. An example of out-of-band management is the use of a console port to configure a switch or router. A captive portal is used to verify credentials or assert a policy, before access is given to the network for a client. A clientless VPN is a VPN connection that does not require a client, only a web browser, for a secure connection. An AAA server is used to authenticate, authorize, and account for connections.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      216,
      217,
      214,
      226,
      232
    ],
    "source": "235605_ch13"
  },
  {
    "id": 440,
    "question": "You need to implement a secure connection for your users to access sensitive sites internally for your organization. Which technology should you select?",
    "choice_a": "Captive portal",
    "choice_b": "Clientless VPN",
    "choice_c": "LDAP",
    "choice_d": "RDP",
    "correct_answer": "B",
    "explanation": "A clientless VPN allows users to access internal sensitive sites via a secure tunnel. A captive portal is used to verify credentials or assert a policy, before access is given to the network for a client. The Lightweight Directory Access Protocol (LDAP) is used by Active Directory to look up objects. The Remote Directory Protocol (RDP) is used by Microsoft for remote access.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      209,
      211,
      210,
      213,
      217
    ],
    "source": "235605_ch13"
  },
  {
    "id": 441,
    "question": "Which of the following is an operating system image delivered over the network at each startup?",
    "choice_a": "VNC",
    "choice_b": "Virtual desktop",
    "choice_c": "Remote desktop",
    "choice_d": "RDP",
    "correct_answer": "B",
    "explanation": "A virtual desktop requires less computing power, especially if the applications are also delivered virtually and those applications are running in a VM in the cloud rather than in the local desktop eating up local resources. Virtual Network Computing (VNC) is a protocol used for remote access. Remote desktop is a method of remote access, and it is provided by the Remote Desktop Protocol (RDP).",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      213,
      212,
      210,
      211,
      209
    ],
    "source": "235605_ch13"
  },
  {
    "id": 442,
    "question": "Which of the following is <i>not</i> a component of Virtual Network Computing (VNC)?",
    "choice_a": "VNC server",
    "choice_b": "VNC client",
    "choice_c": "VNC desktop",
    "choice_d": "VNC protocol",
    "correct_answer": "C",
    "explanation": "VNC includes the following components: VNC server, VNC client (or viewer), and VNC protocol. The VNC server allows the VNC client to connect and provide the VNC desktop over the VNC protocol.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      213,
      212,
      210,
      211,
      217
    ],
    "source": "235605_ch13"
  },
  {
    "id": 443,
    "question": "Which of the following is a network protocol that is designed as an alternative to command-based utilities such as Telnet?",
    "choice_a": "SSL",
    "choice_b": "SSH",
    "choice_c": "STP",
    "choice_d": "STFP",
    "correct_answer": "B",
    "explanation": "Secure Shell (SSH) creates a secure channel between the devices and provides confidentiality and integrity of the data transmission. It uses public-key cryptography to authenticate the remote computer and allow the remote computer to authenticate the user, if necessary. Secure Sockets Layer (SSL) is a suite of encryption protocols that includes Transport Layer Security (TLS). Spanning Tree Protocol (STP) is a protocol used to prevent loops in networks with redundant links. Secure File Transfer Protocol (SFTP) is a file transfer protocol that uses encryption.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      214,
      213,
      210,
      209,
      217
    ],
    "source": "235605_ch13"
  },
  {
    "id": 444,
    "question": "Which of the following allows you to tunnel directly to the remote server with no VPN?",
    "choice_a": "Split tunnel",
    "choice_b": "RDP Gateway",
    "choice_c": "Full tunnel",
    "choice_d": "VNC",
    "correct_answer": "B",
    "explanation": "Using a TLS channel, the RDP Gateway can tunnel directly to the remote server to increase the security of Remote Desktop Services (RDS). Split tunnel is a type of VPN connection that allows Internet traffic to flow around the VPN connection. A full tunnel is a type of VPN connection, in which all traffic is sent through the VPN connection. Virtual Network Computing (VNC) is an open-source protocol that supports a remote desktop connection.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      211,
      210,
      209,
      213,
      214
    ],
    "source": "235605_ch13"
  },
  {
    "id": 445,
    "question": "Which of the following was formerly called Terminal Services Client?",
    "choice_a": "Virtual desktop",
    "choice_b": "Remote Desktop Connection",
    "choice_c": "VNC",
    "choice_d": "RDP Gateway",
    "correct_answer": "B",
    "explanation": "Microsoft began calling all terminal services products Remote Desktop Connection with Windows Server 2008 R2. Virtual desktop is a type of remote access. Virtual Network Computing (VNC) is an open-source protocol that supports a remote desktop connection. The RDP Gateway provides secure access for an RDP client to allow access to RDP applications and desktops.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      212,
      210,
      211,
      213,
      214
    ],
    "source": "235605_ch13"
  },
  {
    "id": 446,
    "question": "Which of the following operates somewhat like Telnet, except instead of getting a command-line prompt as you do with Telnet, you get the actual graphical user interface (GUI) of the remote computer?",
    "choice_a": "RBAC",
    "choice_b": "SSH",
    "choice_c": "RDP",
    "choice_d": "SSL",
    "correct_answer": "C",
    "explanation": "The Remote Desktop Protocol (RDP) is a proprietary protocol developed by Microsoft. It allows you to connect to another computer and run programs. RDP operates somewhat like Telnet, except instead of getting a command-line prompt as you do with Telnet, you get the actual graphical user interface (GUI) of the remote computer. Role-based access control (RBAC) is a method of assigning permissions to users based upon their role. Secure Shell Protocol (SSH) is an encrypted alternative to the insecure Telnet protocol. Secure Sockets Layer (SSL) is a suite of encryption protocols that includes Transport Layer Security (TLS).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      210,
      213,
      214,
      212,
      211
    ],
    "source": "235605_ch13"
  },
  {
    "id": 447,
    "question": "Which of the following is <i>not</i> an example of a remote desktop connection?",
    "choice_a": "RDP",
    "choice_b": "LogMeIn",
    "choice_c": "GoToMyPC",
    "choice_d": "SSH",
    "correct_answer": "D",
    "explanation": "Secure Shell (SSH) is a terminal-based remote access method. Remote Desktop Protocol (RDP) is a Microsoft protocol used for remote desktop connections. LogMeIn and GoToMyPC are proprietary third-party remote desktop assistance tools.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      214,
      212,
      210,
      213,
      217
    ],
    "source": "235605_ch13"
  },
  {
    "id": 448,
    "question": "Split tunnel and full tunnel are examples of which type of VPN?",
    "choice_a": "Client-to-site",
    "choice_b": "Site-to-site",
    "choice_c": "RDP VPN",
    "choice_d": "Clientless VPN",
    "correct_answer": "A",
    "explanation": "When a client-to-site VPN is created, it is possible to do so in two ways, split tunnel and full tunnel. The difference is whether the user uses the VPN for connecting to the Internet as well as for connecting to the office. A site-to-site VPN is used to connect branch offices together over an encrypted tunnel via the Internet. There is no such thing as a Remote Desktop Protocol (RDP) VPN. A clientless VPN allows access to specific services behind the VPN server.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      209,
      208,
      210,
      213,
      211
    ],
    "source": "235605_ch13"
  },
  {
    "id": 449,
    "question": "You have several remote offices that you need to connect securely over the Internet. Which technology would best suit the connectivity for this requirement?",
    "choice_a": "GRE tunnel",
    "choice_b": "Wireless WAN",
    "choice_c": "Client-to-site VPN",
    "choice_d": "Site-to-site VPN",
    "correct_answer": "D",
    "explanation": "Site-to-site VPN connections are intended for connecting sites or remote offices to each other via an encrypted tunnel over the Internet. A GRE tunnel is unencrypted and will not provide any security. A wireless WAN can be used to connect VPN clients to the Internet. A client-to-site VPN allows remote workers to telecommute securely over the Internet.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      208,
      209,
      210,
      211,
      212
    ],
    "source": "235605_ch13"
  },
  {
    "id": 450,
    "question": "Why should Telnet be replaced with SSH?",
    "choice_a": "Telnet has weak encryption.",
    "choice_b": "SSH allows for file copy.",
    "choice_c": "SSH makes it easier to create ACLs for access.",
    "choice_d": "SSH is encrypted.",
    "correct_answer": "D",
    "explanation": "SSH is encrypted, and Telnet is in clear text. To keep passwords and configuration safe, SSH should always be used. Telnet contains no encryption whatsoever, and all usernames, passwords, and commands are sent in clear text. SSH allows for file copy if it is turned on in the IOS, but it is not a main reason to replace Telnet. Telnet and SSH make it equally easy to create ACLs for access.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      214,
      216,
      209,
      279,
      228
    ],
    "source": "235605_ch13"
  },
  {
    "id": 451,
    "question": "What type of encryption does a clientless VPN use?",
    "choice_a": "SSH",
    "choice_b": "SSL/TLS",
    "choice_c": "RDP",
    "choice_d": "ACLs",
    "correct_answer": "B",
    "explanation": "Secure Sockets Layer/Transport Layer Security (SSL/TLS) encryption is used for encryption of clientless VPNs. Secure Shell (SSH) is a type of remote access that provides encrypted terminal-based access. Remote Desktop Protocol (RDP) is a Microsoft GUI-based remote access technology. Access control lists (ACLs) are permissions rules that protect network and file access.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      209,
      214,
      210,
      213,
      211
    ],
    "source": "235605_ch13"
  },
  {
    "id": 452,
    "question": "What are the terminal parameters that are the most common for serial configuration of a Cisco router or switch?",
    "choice_a": "9600 baud, 8 data bits, parity none, no stop bits",
    "choice_b": "9600 baud, 8 parity bits, no data bits, 1 stop bit",
    "choice_c": "9600 baud, 7 data bits, parity none, 1 stop bit",
    "choice_d": "9600 baud, 8 data bits, parity none, 1 stop bit",
    "correct_answer": "D",
    "explanation": "Most network equipment that uses serial connection, such as Cisco routers and switches, will connect with 9600 baud, 8 data bits, no parity, and 1 stop bit. All other answers are incorrect.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      216,
      214,
      232,
      226,
      218
    ],
    "source": "235605_ch13"
  },
  {
    "id": 453,
    "question": "You are connecting to a network switch with the SSH protocol. Which type of connection is this considered?",
    "choice_a": "Out-of-band management",
    "choice_b": "In-band management",
    "choice_c": "GUI-based management",
    "choice_d": "API-based management",
    "correct_answer": "B",
    "explanation": "Connecting to a network switch with the Secure Shell (SSH) protocol is an example of in-band management. An example of out-of-band management is connecting to a router or switch with a serial connection. An example of GUI-based management is Remote Desktop Protocol (RDP). An example of API-based management is configuration through the REST protocol.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      214,
      216,
      217,
      211,
      212
    ],
    "source": "235605_ch13"
  },
  {
    "id": 454,
    "question": "Which of the following is an operating system image delivered over the network?",
    "choice_a": "VNC",
    "choice_b": "Virtual desktop",
    "choice_c": "VPN",
    "choice_d": "RDP",
    "correct_answer": "B",
    "explanation": "A virtual desktop requires less computing power, especially if the applications are also delivered virtually and those applications are running in a VM in the cloud rather than in the local desktop eating up local resources. Virtual Network Computing (VNC) is a protocol that is used for remote desktop access. A VPN is used to create an encrypted tunnel over the insecure public Internet. Remote Desktop Protocol (RDP) is a Microsoft protocol used for remote desktop access.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      213,
      210,
      212,
      211,
      214
    ],
    "source": "235605_ch13"
  },
  {
    "id": 455,
    "question": "Which port and protocol does the VNC protocol operate on?",
    "choice_a": "443/TCP",
    "choice_b": "5900/TCP",
    "choice_c": "5900/UDP",
    "choice_d": "3389/TCP",
    "correct_answer": "B",
    "explanation": "The VNC protocol operates on 5900/TCP. Port 443 protocol TCP is used for HTTPS communications. Port 5900 protocol UDP is a wrong answer. Port 3389 protocol TCP is used for Remote Desktop Protocol (RDP).",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      213,
      214,
      210,
      212,
      211
    ],
    "source": "235605_ch13"
  },
  {
    "id": 456,
    "question": "What is the most common way to access resource-based APIs?",
    "choice_a": "RDP",
    "choice_b": "Terminal-based",
    "choice_c": "REST",
    "choice_d": "GUI-based",
    "correct_answer": "C",
    "explanation": "Representational State Transfer (REST) is the most common way to access resource-based APIs. Remote Desktop Protocol (RDP) is a Microsoft protocol used to deliver remote access to desktops and applications. Terminal-based access is used by terminal emulation programs to access routers and switches. GUI-based remote access allows remote control of servers and workstation.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      215,
      210,
      213,
      214,
      216
    ],
    "source": "235605_ch13"
  },
  {
    "id": 457,
    "question": "Which out-of-band management connectivity method provides for up to 115,200 Kbps?",
    "choice_a": "USB",
    "choice_b": "EIA-TIA 232",
    "choice_c": "COM",
    "choice_d": "SSH",
    "correct_answer": "A",
    "explanation": "A USB connection is an out-of-band management connectivity method that provides for up to 115,200 Kbps speeds. EIA-TIA 232 connections are typically low-speed connections. COM is short for the communications port that the EIA-TIA 232 connection would connect to. Secure Shell (SSH) is an in-band management protocol used to connect to routers and switches over the network.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      216,
      217,
      213,
      210,
      211
    ],
    "source": "235605_ch13"
  },
  {
    "id": 458,
    "question": "Which port and protocol are used for the Remote Desktop Gateway connection?",
    "choice_a": "3389/TCP",
    "choice_b": "5900/TCP",
    "choice_c": "443/TCP",
    "choice_d": "80/TCP",
    "correct_answer": "C",
    "explanation": "The Remote Desktop Gateway provides security via TLS and operates on port 443 with protocol TCP. Port 3389 and TCP are used for the Remote Desktop Protocol (RDP). Port 5900 and TCP are used for the Virtual Network Computing (VNC) protocol. Port 80 and TCP are used for HTTP communications.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      211,
      210,
      213,
      214,
      209
    ],
    "source": "235605_ch13"
  },
  {
    "id": 459,
    "question": "Which measurement describes the delay a packet incurs from source to destination?",
    "choice_a": "Bandwidth",
    "choice_b": "Latency",
    "choice_c": "Jitter",
    "choice_d": "Loss",
    "correct_answer": "B",
    "explanation": "Latency is the delay typically incurred in the processing of network data from source to destination. Bandwidth is the measured maximum of throughput for a connection. Jitter is the difference between the delay of packets. Loss is the measurement of packets lost in the transfer of data.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      222,
      221,
      255,
      231,
      268
    ],
    "source": "235605_ch14"
  },
  {
    "id": 460,
    "question": "You are using a network management station (NMS) to collect data for network devices. What must be loaded before you can capture data from the network devices via the Simple Network Management Protocol (SNMP)?",
    "choice_a": "OID",
    "choice_b": "MIB",
    "choice_c": "Traps",
    "choice_d": "Gets",
    "correct_answer": "B",
    "explanation": "Before an NMS can collect SNMP statistics, the management information base (MIB) from the manufacturer must be loaded. The object ID (OID) is the hierarchal notation of the counter. An SNMP trap command is a message from the SNMP agent to the NMS when a threshold for a counter is exceeded. A SNMP get command is a request message from the NMS to the SNMP agent for the value of a counter.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      226,
      229,
      228,
      227,
      230
    ],
    "source": "235605_ch14"
  },
  {
    "id": 461,
    "question": "Which service can identify major users of the network, meaning top talkers?",
    "choice_a": "Syslog",
    "choice_b": "SIEM",
    "choice_c": "NetFlow",
    "choice_d": "SNMP",
    "correct_answer": "C",
    "explanation": "NetFlow statistics can analyze the traffic on your network by showing the major users of the network, meaning top talkers, top listeners, top protocols, and so on. Syslog can identify problems or be used for post-mortem analysis. Security information and event management (SIEM) is used to capture security events for further analysis. The Simple Network Management Protocol (SNMP) is a protocol used to capture performance statistics of servers, applications, and network devices.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      231,
      236,
      226,
      225,
      233
    ],
    "source": "235605_ch14"
  },
  {
    "id": 462,
    "question": "Which of the following refers to the standard level of performance of a certain device or to the normal operating capacity for your whole network?",
    "choice_a": "Baseline",
    "choice_b": "Target",
    "choice_c": "Normal",
    "choice_d": "Utilization",
    "correct_answer": "A",
    "explanation": "In networking, a baseline can refer to the standard level of performance of a certain device or to the normal operating capacity for your whole network. All other answers are incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      255,
      235,
      223,
      221,
      219
    ],
    "source": "235605_ch14"
  },
  {
    "id": 463,
    "question": "Which version of SNMP supports authentication and encryption?",
    "choice_a": "SNMP version 1",
    "choice_b": "SNMP version 2e",
    "choice_c": "SNMP version 2c",
    "choice_d": "SNMP version 3",
    "correct_answer": "D",
    "explanation": "SNMP version 3 introduced message integrity, authentication, and encryption to the SNMP suite. SNMP version 1 was the first release of SNMP, and it is considered deprecated. SNMP version 2e is not a valid version of SNMP. SNMP version 2c is an amendment of SNMP version 2 that added the set command and other improvements.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      228,
      227,
      226,
      214,
      232
    ],
    "source": "235605_ch14"
  },
  {
    "id": 464,
    "question": "Which component receives information from an SNMP agent?",
    "choice_a": "Syslog",
    "choice_b": "Network management station",
    "choice_c": "Object identifier",
    "choice_d": "Management information base",
    "correct_answer": "B",
    "explanation": "The network management station (NMS) is a server to which SNMP is polled back or in which SNMP information is trapped (sent to). The NMS can escalate problems via email, text message, or even visual indicators. Examples of NMS systems are SolarWinds Orion and OpenNMS. The Syslog is a logging file where system messages are sent. The object identifier (OID) is used to describe the SNMP counter being requested. The management information base (MIB) is a sort of database of counters that SNMP can use for a specific device.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      226,
      227,
      229,
      232,
      234
    ],
    "source": "235605_ch14"
  },
  {
    "id": 465,
    "question": "Which metric is the variation from the delay between the source and destination?",
    "choice_a": "Latency",
    "choice_b": "Jitter",
    "choice_c": "Bandwidth",
    "choice_d": "Throughput",
    "correct_answer": "B",
    "explanation": "Jitter is the variation of latency (delay) between the source and destination, and it is measured in milliseconds. Latency is the time it takes for a packet or frame to travel from source to destination. Bandwidth is the speed of a connection, and throughput is the utilization of the connection.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      222,
      221,
      255,
      231,
      230
    ],
    "source": "235605_ch14"
  },
  {
    "id": 466,
    "question": "Which SNMP component is used to address a performance counter?",
    "choice_a": "Syslog",
    "choice_b": "Network management station",
    "choice_c": "Object identifier",
    "choice_d": "Management information base",
    "correct_answer": "C",
    "explanation": "The object identifier (OID) is used to describe the SNMP counter being requested. The Syslog is a logging file where system messages are sent. The network management station (NMS) is a server to which SNMP is polled back or in which SNMP information is trapped. The NMS can escalate problems via email, text message, or even visual indicators. The management information base (MIB) is a sort of database of counters that SNMP can use for a specific device.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      229,
      226,
      227,
      228,
      232
    ],
    "source": "235605_ch14"
  },
  {
    "id": 467,
    "question": "What type of SNMP message is sent to a network management station when an interface goes down?",
    "choice_a": "Get-request message",
    "choice_b": "Get-response message",
    "choice_c": "Set-request message",
    "choice_d": "Trap message",
    "correct_answer": "D",
    "explanation": "Trap messages are sent from the network device to the SNMP network management station when an event has triggered over a set threshold on the device. An example of an event to be trapped is an interface going down or a restriction by port security. The get-request message is used by an NMS to request information from an SNMP agent. The get-response message is the message sent back from the client to the NMS after a get-request message is received. The set-request message is sent by the NMS to the SNMP client requesting a specific writable counter be set to the specified value.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      227,
      226,
      228,
      233,
      236
    ],
    "source": "235605_ch14"
  },
  {
    "id": 468,
    "question": "Which security method does SNMP version 2c employ?",
    "choice_a": "Encryption",
    "choice_b": "User authentication",
    "choice_c": "Community strings",
    "choice_d": "Message integrity",
    "correct_answer": "C",
    "explanation": "SNMP version 2c is identical to SNMP version 1 with respect to security. Both transmit information in clear text and use the security of community strings to authenticate users for access to information. SNMP version 2c does not employ encryption. SNMP version 2c does not employ user authentication. SNMP version 2c does not employ message integrity.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      228,
      214,
      232,
      236,
      59
    ],
    "source": "235605_ch14"
  },
  {
    "id": 469,
    "question": "What is the database of variables that SNMP uses to allow for collection of data?",
    "choice_a": "Object identifiers (OIDs)",
    "choice_b": "Management information base",
    "choice_c": "SNMP agent",
    "choice_d": "SNMP community string",
    "correct_answer": "B",
    "explanation": "The management information base (MIB) is a database of variables in which SNMP allows retrieval of information. The attributes in the MIB are the description, variable type, and read-write status. Object identifiers (OIDs) are the addressable counters that are arranged in a hierarchical fashion. The SNMP agent is the software on the client that allows SNMP to collect or pass information. The SNMP community string is used to restrict communications to only the clients or servers that have a matching SNMP community string.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      226,
      229,
      227,
      228,
      234
    ],
    "source": "235605_ch14"
  },
  {
    "id": 470,
    "question": "Which of the following can be used in conjunction with an SNMP agent configuration for added security?",
    "choice_a": "Encrypted communities",
    "choice_b": "Access control lists",
    "choice_c": "SNMP callback security",
    "choice_d": "SHA-256",
    "correct_answer": "B",
    "explanation": "Standard access control lists (ACLs) can be used in conjunction with the SNMP agent configuration. There is no such thing as encrypted communities. There is no such thing as SNMP callback security; callback security is related to PPP. SNMP does not employ SHA-256 as its encryption protocol.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      228,
      226,
      227,
      234,
      232
    ],
    "source": "235605_ch14"
  },
  {
    "id": 471,
    "question": "Which protocol and port number does SNMP use for trap and inform messages to the NMS?",
    "choice_a": "UDP/161",
    "choice_b": "TCP/162",
    "choice_c": "UDP/162",
    "choice_d": "UDP/514",
    "correct_answer": "C",
    "explanation": "SNMP uses UDP port 162 for communication from an SNMP agent to the network management station (NMS) for trap and inform messages. SNMP agents listen on UDP/161. SNMP does not use TCP for messaging. UDP/514 is used for Syslog messaging.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      227,
      226,
      228,
      229,
      232
    ],
    "source": "235605_ch14"
  },
  {
    "id": 472,
    "question": "Which syslog severity level is used to convey a failure of a component?",
    "choice_a": "Level 3",
    "choice_b": "Level 4",
    "choice_c": "Level 0",
    "choice_d": "Level 7",
    "correct_answer": "C",
    "explanation": "The severity levels are from 0 to 7, where 0 is an emergency and 7 is debugging. A component failure would be categorized as a level 0 (emergency). All other answers are incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      233,
      236,
      223,
      226,
      227
    ],
    "source": "235605_ch14"
  },
  {
    "id": 473,
    "question": "Which SNMP component is installed on a network device that will respond to NMS queries?",
    "choice_a": "Object identifiers (OIDs)",
    "choice_b": "Management information base",
    "choice_c": "SNMP agent",
    "choice_d": "SNMP community string",
    "correct_answer": "C",
    "explanation": "The SNMP agent is the software on the client (network device) that allows SNMP to collect, respond, or pass information to the network management station (NMS). Object identifiers (OIDs) are the addressable counters that are arranged in a hierarchical fashion. The management information base (MIB) is a database of variables in which SNMP allows retrieval of information. The SNMP community string is used to restrict communications to only the clients or servers that have a matching SNMP community string.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      226,
      227,
      229,
      228,
      234
    ],
    "source": "235605_ch14"
  },
  {
    "id": 474,
    "question": "What type of SNMP message is sent from a network management station to an agent for retrieving information?",
    "choice_a": "Get-request message",
    "choice_b": "Get-response message",
    "choice_c": "Set-request message",
    "choice_d": "Trap message",
    "correct_answer": "A",
    "explanation": "The get-request message is used by a network management station (NMS) to request information from an SNMP agent. The get-response message is the message sent back from the client to the NMS, after a get-request message is received. The set-request message is sent by the NMS to the SNMP client requesting a specific writable counter be set to the specified value. Trap messages are sent from the network device to the SNMP network management station when an event has triggered over a set threshold on the device.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      227,
      226,
      228,
      229,
      231
    ],
    "source": "235605_ch14"
  },
  {
    "id": 475,
    "question": "Which of the following is <i>not</i> a commonly used NetFlow identifier?",
    "choice_a": "Source IP",
    "choice_b": "Destination port number",
    "choice_c": "Layer 2 protocol field",
    "choice_d": "Input logical interface",
    "correct_answer": "C",
    "explanation": "Commonly used NetFlow flows include the following identifiers: source IP address, destination IP address, source port number, destination port number, layer 3 protocol field, Type of Service (ToS) marking, and input logical interface.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      231,
      227,
      226,
      230,
      229
    ],
    "source": "235605_ch14"
  },
  {
    "id": 476,
    "question": "Which provides the ability to mirror port traffic on a switch?",
    "choice_a": "Syslog",
    "choice_b": "SNMP",
    "choice_c": "NetFlow",
    "choice_d": "SPAN",
    "correct_answer": "D",
    "explanation": "Switched Port Analyzer (SPAN) is a Cisco proprietary method used to mirror port traffic on a switch. Simple Network Management Protocol (SNMP) is a protocol used to capture performance statistics of servers, applications, and network devices. The NetFlow protocol provides session information including the source and destination addresses, applications, and traffic volume. Syslog is a method of collecting system messages to identify problems, or it can be used for post-mortem analysis.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      230,
      226,
      227,
      231,
      232
    ],
    "source": "235605_ch14"
  },
  {
    "id": 477,
    "question": "Which device components should never be allowed to reach full capacity? (Choose two.)",
    "choice_a": "Memory",
    "choice_b": "Voltage",
    "choice_c": "CPU",
    "choice_d": "Delay",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "When a system uses all available memory or CPU resources, it may become very unstable and fail. Devices must have available memory and CPU capacity available to be able to function. Voltage is not typically measured as a metric and should always remain at a certain voltage level. Delay is related to network functionality and not part of a component.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      219,
      220,
      223,
      255,
      218
    ],
    "source": "235605_ch14"
  },
  {
    "id": 478,
    "question": "Which network metric will describe the utilization for a connection?",
    "choice_a": "Latency",
    "choice_b": "Jitter",
    "choice_c": "Throughput",
    "choice_d": "Bandwidth",
    "correct_answer": "C",
    "explanation": "Throughput is the utilization for a given connection. Latency is the measurement of the time it takes for a packet or frame to traverse the network. Jitter is the variance of latency for packets and frames. Bandwidth is the total speed of a connection.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      221,
      255,
      235,
      222,
      231
    ],
    "source": "235605_ch14"
  },
  {
    "id": 479,
    "question": "The way to properly install or remove software on the servers is an example of which of the following?",
    "choice_a": "Plan",
    "choice_b": "Policy",
    "choice_c": "Procedure",
    "choice_d": "Code",
    "correct_answer": "C",
    "explanation": "For every policy on your network, there should be a credible related procedure that clearly dictates the steps to take in order to fulfill it. All other answers are incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      237,
      238,
      242,
      250,
      243
    ],
    "source": "235605_ch15"
  },
  {
    "id": 480,
    "question": "Which of the following is a plan for reversing changes and recovering from any adverse effects from the changes?",
    "choice_a": "Backup",
    "choice_b": "Secondary",
    "choice_c": "Rollback",
    "choice_d": "Failover",
    "correct_answer": "C",
    "explanation": "Those making the changes should be completely briefed in these rollback procedures, and they should exhibit a clear understanding of them prior to implementing the changes. All other answers are incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      238,
      237,
      268,
      280,
      272
    ],
    "source": "235605_ch15"
  },
  {
    "id": 481,
    "question": "Which of the following is the amount of time a system will be down or unavailable during the implementation of changes?",
    "choice_a": "Downtime",
    "choice_b": "Maintenance window",
    "choice_c": "MTBF",
    "choice_d": "Work factor",
    "correct_answer": "B",
    "explanation": "A maintenance window is an amount of time a system will be down or unavailable during the implementation of changes.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      238,
      268,
      258,
      237,
      271
    ],
    "source": "235605_ch15"
  },
  {
    "id": 482,
    "question": "Which of the following is <i>not</i> a device hardening technique?",
    "choice_a": "Remove unnecessary applications.",
    "choice_b": "Deploy an access control vestibule.",
    "choice_c": "Block unrequired ports.",
    "choice_d": "Disable unnecessary services.",
    "correct_answer": "B",
    "explanation": "An access control vestibule is a physical access control solution, not a device hardening technique. Removing unnecessary applications, blocking unrequired ports, and disabling unnecessary services are all device hardening techniques.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      241,
      247,
      242,
      245,
      244
    ],
    "source": "235605_ch15"
  },
  {
    "id": 483,
    "question": "Which policy automatically logs a user out after a specified period without activity?",
    "choice_a": "Password complexity",
    "choice_b": "Password history",
    "choice_c": "Password length",
    "choice_d": "Authentication period",
    "correct_answer": "D",
    "explanation": "Authentication period controls how long a user can remain logged in. If a user remains logged in for the specified period without activity, the user will be automatically logged out. The password complexity policy specifies how complex a password is required to be. A password history policy specifies how many passwords should be kept in cache, so the user does not reuse the password. The password length policy specifies how long a password is required to be in length.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      243,
      247,
      250,
      237,
      244
    ],
    "source": "235605_ch15"
  },
  {
    "id": 484,
    "question": "BYOD policies apply to what type of device?",
    "choice_a": "Mobile",
    "choice_b": "Router",
    "choice_c": "Server",
    "choice_d": "Firewall",
    "correct_answer": "A",
    "explanation": "Bring your own device (BYOD) initiatives can be successful if implemented correctly. The key is to implement control over these personal mobile devices that leave the safety of your network and return later after potentially being exposed to environments that are out of your control. BYOD initiatives do not apply to routers, servers, and firewalls.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      244,
      242,
      240,
      249,
      237
    ],
    "source": "235605_ch15"
  },
  {
    "id": 485,
    "question": "Which tool can prevent the emailing of a document to anyone other than Sales group members?",
    "choice_a": "BYOD",
    "choice_b": "Password policy",
    "choice_c": "DLP",
    "choice_d": "AUP",
    "correct_answer": "C",
    "explanation": "Data loss prevention (DLP) software attempts to prevent data leakage. It does this by maintaining awareness of actions that can and cannot be taken with respect to a document. A bring your own device (BYOD) policy defines how personal devices can be used in the organization. A password policy defines the life, history, and complexity of passwords in the organization. An acceptable use policy (AUP) defines the acceptable use of organizational resources.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      170,
      206,
      161,
      168,
      53
    ],
    "source": "235605_ch15"
  },
  {
    "id": 486,
    "question": "Which of the following connects equipment (inside plant) to cables and subscriber carrier equipment (outside plant)?",
    "choice_a": "IDF",
    "choice_b": "MDF",
    "choice_c": "Hardware rack",
    "choice_d": "Access control vestibule",
    "correct_answer": "B",
    "explanation": "The main distribution frame (MDF) connects equipment (inside plant) to cables and subscriber carrier equipment (outside plant). It also terminates cables that run to intermediate distribution frames (IDFs) distributed throughout the facility. The hardware rack houses equipment such as servers and equipment. An access control vestibule is used for physical security.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      53,
      54,
      168,
      67,
      248
    ],
    "source": "235605_ch15"
  },
  {
    "id": 487,
    "question": "Which of the following is <i>not</i> part of the information gathering step of a site survey?",
    "choice_a": "Determine the scope of the network with respect to applications in use.",
    "choice_b": "Verify optimal distances between prospective AP locations.",
    "choice_c": "Identify areas that must be covered.",
    "choice_d": "Assess types of wireless devices that will need to be supported.",
    "correct_answer": "B",
    "explanation": "Verifying optimal distances between prospective AP locations is part of the Predeployment Site Survey step.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      256,
      255,
      238,
      237,
      243
    ],
    "source": "235605_ch15"
  },
  {
    "id": 488,
    "question": "Device baselines include information about all but which of the following components?",
    "choice_a": "CPU",
    "choice_b": "Memory",
    "choice_c": "Hard disk",
    "choice_d": "Display",
    "correct_answer": "D",
    "explanation": "For networks and networked devices, baselines include information about four key components: processor, memory, hard-disk (or other storage) subsystem, and wired/wireless utilization.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      65,
      174,
      187,
      67,
      71
    ],
    "source": "235605_ch15"
  },
  {
    "id": 489,
    "question": "You just finished repairing a network connection, and in the process, you traced several network connections. Which type of documentation should you create so that another technician does not need to repeat the task of tracing connections?",
    "choice_a": "Logical diagram",
    "choice_b": "Knowledge base article",
    "choice_c": "Change management document",
    "choice_d": "Physical diagram",
    "correct_answer": "D",
    "explanation": "A physical network diagram details all connections so that the next technician does not need to trace connections. A logical network diagram shows the flow of information. A knowledge base article documents a symptom and solution for a problem but not the connections. A change management document is used to evaluate a potential change to a network.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      251,
      254,
      252,
      253,
      257
    ],
    "source": "235605_ch15"
  },
  {
    "id": 490,
    "question": "You just had an outage of Internet connectivity due to a denial-of-service attack. Which document should you follow during the outage?",
    "choice_a": "Change management plan",
    "choice_b": "Knowledge base article",
    "choice_c": "Acceptable use policy",
    "choice_d": "Incident response plan",
    "correct_answer": "D",
    "explanation": "The incident response plan should be followed during the event since the event is a security incident. A change management plan is used for proposed changes to the network. Knowledge base articles are used to document symptoms and solutions. An acceptable use policy (AUP) is used to protect an organization\u2019s resources from user abuse.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      239,
      238,
      242,
      237,
      280
    ],
    "source": "235605_ch15"
  },
  {
    "id": 491,
    "question": "You are currently troubleshooting a network issue. Which type of diagram allows you to view the flow of information from a high-level overview? (Choose the best answer.)",
    "choice_a": "Logical diagram",
    "choice_b": "Physical diagram",
    "choice_c": "Symbol diagram",
    "choice_d": "Knowledge base article",
    "correct_answer": "A",
    "explanation": "A logical diagram is a high-level overview of a system so that you can see the flow of information. A physical diagram shows specifics, and although it can be used to trace the flow of information, it is not used as a high-level overview. A symbol diagram is not a type of diagram. A knowledge base article details a solution for symptoms and is not used to view the flow of information.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      254,
      251,
      252,
      255,
      256
    ],
    "source": "235605_ch15"
  },
  {
    "id": 492,
    "question": "End users are abusing the email system by selling personal items. Which policy would detail the proper use of the email system for business purposes?",
    "choice_a": "BYOD",
    "choice_b": "Password policy",
    "choice_c": "AUP",
    "choice_d": "Incident response plan",
    "correct_answer": "C",
    "explanation": "The acceptable use policy (AUP) details the acceptable use of the email system for business purposes. The bring your own device (BYOD) policy defines the use of personal devices for organization business. A password policy details the appropriate handling and management of passwords. An incident response plan is how a network or security incident is handled.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      242,
      244,
      237,
      250,
      247
    ],
    "source": "235605_ch15"
  },
  {
    "id": 493,
    "question": "Why should performance baselines be captured over a long period of time?",
    "choice_a": "To define normal operations and activity",
    "choice_b": "To define a historical representation of activity",
    "choice_c": "To help validate when a problem is solved",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "Performance baselines gathered over time help create a historical representation of activity and normal operations. When a server is performing poorly, the baseline can validate both the problem and implemented solution.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      235,
      223,
      225,
      221,
      220
    ],
    "source": "235605_ch15"
  },
  {
    "id": 494,
    "question": "Which policy would you create to define the minimum specification if an employee wanted to use their own device for email?",
    "choice_a": "MDM",
    "choice_b": "AUP",
    "choice_c": "BYOD",
    "choice_d": "NDA",
    "correct_answer": "C",
    "explanation": "A bring your own device (BYOD) policy defines the minimum specifications for an employee\u2019s device used for work-related access. The mobile device management (MDM) software would usually dictate these specifications. The acceptable use policy (AUP) defines acceptable usage on the network. The network disclosure agreement (NDA) is an agreement that includes specifics that are not disclosed outside of an organization.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      244,
      242,
      243,
      247,
      250
    ],
    "source": "235605_ch15"
  },
  {
    "id": 495,
    "question": "You are contracting with a new service provider and are reviewing their service level agreement (SLA). The SLA states that their commitment to uptime is 99.99%. What is the expected downtime per year?",
    "choice_a": "3.65 days",
    "choice_b": "8.76 hours",
    "choice_c": "52.56 minutes",
    "choice_d": "5.29 minutes",
    "correct_answer": "C",
    "explanation": "An SLA of 4 nines is 52.56 minutes per year of expected downtime. This equates to 4.38 minutes per month that the service can be down. All other answers are incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      258,
      225,
      268,
      255,
      269
    ],
    "source": "235605_ch15"
  },
  {
    "id": 496,
    "question": "You have been informed that all material must be removed from your desk before you leave for the day. What type of policy is this?",
    "choice_a": "NDA",
    "choice_b": "Clean-desk policy",
    "choice_c": "Password policy",
    "choice_d": "BYOD",
    "correct_answer": "B",
    "explanation": "A clean-desk policy requires all materials to be removed from your desk before you leave for the day. A nondisclosure agreement (NDA) defines the confidentiality of the organization and what can\u2019t be disclosed. The password policy defines the length, complexity, history, and validity time of a user\u2019s password. A bring your own device (BYOD) policy defines the use of personal devices for organizational use.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      169,
      168,
      192,
      206,
      67
    ],
    "source": "235605_ch15"
  },
  {
    "id": 497,
    "question": "Which type of document will contain heat maps of wireless equipment after installation?",
    "choice_a": "Logical network diagram",
    "choice_b": "Physical network diagram",
    "choice_c": "Site survey report",
    "choice_d": "Baseline",
    "correct_answer": "C",
    "explanation": "The site survey report is the document that is prepared before equipment is purchased and deployed. The site survey is then used post-deployment to verify coverage and any adjustments for coverage, and will contain heat maps. Logical network diagrams define the flow of network traffic. Physical network diagrams define how everything is connected for the flow of information. A baseline is captured to establish normal operations, so it can be contrasted upon times of trouble to define the issue.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      256,
      254,
      251,
      255,
      252
    ],
    "source": "235605_ch15"
  },
  {
    "id": 498,
    "question": "You have been tasked with planning the IP addressing in your organization. Which tool should you employ to help you with this task?",
    "choice_a": "IPAM",
    "choice_b": "SLA",
    "choice_c": "MOU",
    "choice_d": "NDA",
    "correct_answer": "A",
    "explanation": "The tool you should employ is IP address management (IPAM). This tool will help you plan the allocation of IP addressing for your organization. A service level agreement (SLA) is used to establish a level of service expected from a provider. A memorandum of understanding (MOU) is a mutual agreement between two or more parties. A nondisclosure agreement (NDA) is an agreement in which you agree not to disclose organizational information.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      60,
      255,
      254,
      252
    ],
    "source": "235605_ch15"
  },
  {
    "id": 499,
    "question": "You have a high demand of normal requests on the company\u2019s web server. Which strategy should be implemented to avoid issues if demand becomes too high? (Choose the best answer.)",
    "choice_a": "Clustering",
    "choice_b": "Port aggregation",
    "choice_c": "Fault tolerance",
    "choice_d": "Load balancing",
    "correct_answer": "D",
    "explanation": "Load balancing should be implemented with two or more web servers to scale out the servers and lower demand on any one single web server. Clustering creates high availability for an application or operating system. Port aggregation combines two or more connections to aggregate their combined bandwidth. Fault tolerance is the ability of a system to remain running after a component failure.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      260,
      267,
      276,
      258,
      255
    ],
    "source": "235605_ch16"
  },
  {
    "id": 500,
    "question": "Which of the following is a measure back in time to when your data was preserved in a usable format, usually to the most recent backup?",
    "choice_a": "RTO",
    "choice_b": "MTBF",
    "choice_c": "RPO",
    "choice_d": "MTTR",
    "correct_answer": "C",
    "explanation": "The recovery point objective (RPO) is a measurement of time from a failure, disaster, or comparable loss-causing event. RPOs measure back in time to when your data was preserved in a usable format, usually to the most recent backup. The recovery time objective (RTO) is how long it takes to recover your data back to the RPO. The mean time between failures (MTBF) is an average time between failures. The mean time to repair (MTTR) is the average time it takes for a vendor to repair a failure.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      261,
      273,
      159,
      158,
      179
    ],
    "source": "235605_ch16"
  },
  {
    "id": 501,
    "question": "Which of the following is an IEEE standard (RFC 2338) for router redundancy?",
    "choice_a": "HSRP",
    "choice_b": "VRRP",
    "choice_c": "HDLC",
    "choice_d": "MLPS",
    "correct_answer": "B",
    "explanation": "Virtual Router Redundancy Protocol (VRRP) is an IEEE standard (RFC 2338) for router redundancy; Hot Standby Router Protocol (HSRP) is a Cisco proprietary protocol. All other answers are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      275,
      145,
      274,
      264,
      131
    ],
    "source": "235605_ch16"
  },
  {
    "id": 502,
    "question": "Which of the following is the defined interval during which each of the routers send out Hello messages in HSRP?",
    "choice_a": "Hold timer",
    "choice_b": "Hello timer",
    "choice_c": "Active timer",
    "choice_d": "Standby timer",
    "correct_answer": "B",
    "explanation": "The Hello timer is the defined interval during which each of the routers sends out Hello messages. Their default interval is 3 seconds, and they identify the state that each router is in. The Hold timer is the amount of time before the Active router is considered offline. The Active timer monitors the state of the Active router and resets each time a Hello packet is seen from the active router. The Standby timer is used to monitor the state of the Standby router and resets each time a Hello packet is seen from the Standby router.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      274,
      142,
      119,
      120,
      131
    ],
    "source": "235605_ch16"
  },
  {
    "id": 503,
    "question": "What is the HSRP group number of the group with the following HSRP MAC address?<br>0000.0c07.ac0a",
    "choice_a": "10",
    "choice_b": "17",
    "choice_c": "20",
    "choice_d": "25",
    "correct_answer": "A",
    "explanation": "The last 8 bits (0a) are the only variable bits and represent the HSRP group number that you assign. In this case, the group number is 10 and converted to hexadecimal when placed in the MAC address, where it becomes the 0a that you see. All other answers are incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      276,
      226,
      227,
      229,
      231
    ],
    "source": "235605_ch16"
  },
  {
    "id": 504,
    "question": "Which of the following provides only fault tolerance?",
    "choice_a": "Two servers in an active/active configuration",
    "choice_b": "Three servers in an active/passive configuration with one on standby",
    "choice_c": "Three servers in an active/passive configuration with two on standby",
    "choice_d": "Three servers in an active/active configuration",
    "correct_answer": "C",
    "explanation": "With three servers in an active/passive configuration with two on standby, only one is doing work. Therefore, it does not provide load balancing, only fault tolerance. Having two servers in an active/active configuration provides a scale-out of services. Having three servers in an active/passive configuration with one in standby does not provide fault tolerance because it requires two in standby to match the active count. Having three servers in an active/active configuration does not allow for any failure.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      276,
      260,
      267,
      265,
      266
    ],
    "source": "235605_ch16"
  },
  {
    "id": 505,
    "question": "Which site type mimics your on-premises network yet is totally virtual?",
    "choice_a": "Cold site",
    "choice_b": "Cloud site",
    "choice_c": "Warm site",
    "choice_d": "Hot site",
    "correct_answer": "B",
    "explanation": "A cloud recovery site is an extension of the cloud backup services that have developed over the years. These are sites that while mimicking your on-premises network are totally virtual. Cold sites require equipment to be installed and configured. Warm sites are between cold and hot sites and require some intervention. Hot sites typically do not require any intervention, except for organizational data restoration.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      248,
      67,
      54,
      274,
      275
    ],
    "source": "235605_ch16"
  },
  {
    "id": 506,
    "question": "Which of the following fire suppression systems is not a good choice where computing equipment will be located?",
    "choice_a": "Deluge",
    "choice_b": "CO2",
    "choice_c": "Argon",
    "choice_d": "NAF-S-III",
    "correct_answer": "A",
    "explanation": "Deluge systems allow large amounts of water to be released into the room, which obviously makes this not a good choice where computing equipment will be located. CO<sub>2</sub>, argon, and NAF-S-III systems use heavy gases to extinguish a fire.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      187,
      192,
      201,
      206
    ],
    "source": "235605_ch16"
  },
  {
    "id": 507,
    "question": "Which of the following protocols gives you a way to configure more than one physical router to appear as if they were only a single logical one?",
    "choice_a": "FHRP",
    "choice_b": "NAT",
    "choice_c": "NIC teaming",
    "choice_d": "STP",
    "correct_answer": "A",
    "explanation": "First-hop redundancy protocols (FHRPs) work by giving you a way to configure more than one physical router to appear as if they were only a single logical one. This makes client configuration and communication easier because you can simply configure a single default gateway, and the host machine can use its standard protocols to communicate. Network address translation (NAT) is used to route packets from a private network through the Internet. NIC teaming is not a protocol; it is a method of combining two or more network cards for load balancing or fault tolerance. Spanning Tree Protocol (STP) is switching the protocol used to prevent switching loops for redundant links.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      264,
      145,
      274,
      275,
      126
    ],
    "source": "235605_ch16"
  },
  {
    "id": 508,
    "question": "Which of the following provides a method to join multiple physical switches into a single logical switching unit?",
    "choice_a": "Stacking",
    "choice_b": "Daisy chaining",
    "choice_c": "Segmenting",
    "choice_d": "Federating",
    "correct_answer": "A",
    "explanation": "Switch stacking is the process of connecting multiple switches together (usually in a stack) that are managed as a single switch. All other answers are incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      260,
      254,
      251,
      238,
      255
    ],
    "source": "235605_ch16"
  },
  {
    "id": 509,
    "question": "Which type of recovery is the least expensive to maintain over time?",
    "choice_a": "Cold site recovery",
    "choice_b": "Warm site recovery",
    "choice_c": "Hot site recovery",
    "choice_d": "Cloud site recovery",
    "correct_answer": "A",
    "explanation": "A cold site is the least expensive to maintain over time because very little or no hardware is at the site. If a disaster occurs, it will take time to acquire hardware and configure it. A warm site contains equipment but requires intervention to bring it online. A host site or cloud site contains a replica of the organization\u2019s servers and is probably the most expensive. The difference between a hot and cloud site is where the servers are running.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      272,
      239,
      269,
      277,
      278
    ],
    "source": "235605_ch16"
  },
  {
    "id": 510,
    "question": "You need to purchase a power backup system for a mission critical data center. Which backup systems will ensure long-term power that has a flawless AC signal? (Choose two.)",
    "choice_a": "Standby UPS",
    "choice_b": "Line interactive UPS",
    "choice_c": "Online UPS",
    "choice_d": "Generator",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "An online UPS will supply a flawless AC signal since the DC power source is fed into the rectifier and the AC power only charges the DC batteries. A generator will supply long-term AC power to charge the DC batteries in the event of a power failure. A line interactive and standby UPS does not supply flawless power because the load is shifted during a power outage.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      269,
      270,
      268,
      276,
      271
    ],
    "source": "235605_ch16"
  },
  {
    "id": 511,
    "question": "Which allows for the feedback and revision of plans, procedures, and policies?",
    "choice_a": "Tabletop exercises",
    "choice_b": "SOP",
    "choice_c": "RTO",
    "choice_d": "Validation tests",
    "correct_answer": "D",
    "explanation": "During the validation tests, the team has the opportunity to give feedback and revise the plans, procedures, and policies. The tabletop exercise is when you should follow the plans, procedures, and policies for your organization. The standard operating procedures (SOPs) are defined by your organization as step-by-step directions. The recovery time objective (RTO) is how long it takes to recover from the failure or deletion of files.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      197,
      53,
      168,
      54,
      71
    ],
    "source": "235605_ch16"
  },
  {
    "id": 512,
    "question": "Which fire suppression system is normally found in data centers?",
    "choice_a": "Deluge",
    "choice_b": "Clean agent",
    "choice_c": "Preaction",
    "choice_d": "Dry pipe",
    "correct_answer": "B",
    "explanation": "Clean agent systems are normally found in data centers because the suppression agent is in the form of a gas and will not hurt electronics. A deluge system dumps water out of all the fire suppression nozzles. A preaction system requires a detector to pre-charge the system before water is released. A dry pipe system doesn\u2019t contain water in the pipes. When the pressure drops, the water will be released from the nozzles.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      156,
      68,
      54,
      71
    ],
    "source": "235605_ch16"
  },
  {
    "id": 513,
    "question": "Which environmental factor can cause the potential for electrostatic discharge?",
    "choice_a": "Temperature",
    "choice_b": "Electrical",
    "choice_c": "Humidity",
    "choice_d": "Flooding",
    "correct_answer": "C",
    "explanation": "When humidity falls below 20%, there is a huge potential for electrostatic discharge (ESD). Although lower temperatures create lower humidity levels, they do not directly attribute to ESD. Electrical factors are related to power surges, sags, and spikes. Flooding will not cause electrostatic discard, but it will cause electrical shorts.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      175,
      179,
      168,
      53,
      152
    ],
    "source": "235605_ch16"
  },
  {
    "id": 514,
    "question": "Which type of uninterruptable power supplies (UPS), often found in data centers, provides constant power from the battery-powered inverter circuit?",
    "choice_a": "Line interactive UPS",
    "choice_b": "Standby UPS",
    "choice_c": "Online UPS",
    "choice_d": "Failover UPS",
    "correct_answer": "C",
    "explanation": "An online UPS uses the AC power for the rectifier/charging circuit that maintains a charge for the batteries. The batteries then supply the inverter with a constant DC power source. The inverter converts the DC power source back into an AC power circuit again that supplies the load. A line interactive UPS starts inverting power when the power is lost. A standby UPS shifts the load to a separate inverter circuit. There is no such thing as a failover UPS.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      269,
      270,
      276,
      268,
      260
    ],
    "source": "235605_ch16"
  },
  {
    "id": 515,
    "question": "You need to choose a vendor based on their speed in fixing issues. Which metric should you evaluate?",
    "choice_a": "MTTR",
    "choice_b": "VRRP",
    "choice_c": "HSRP",
    "choice_d": "MTBF",
    "correct_answer": "A",
    "explanation": "The mean time to repair (MTTR) is the average time it takes to repair a component and get the system running. Virtual Router Redundancy Protocol (VRRP) is an open standard first hop redundancy protocol (FHRP). Host Standby Router Protocol (HSRP) is a Cisco proprietary FHRP. The mean time between failures (MTBF) is the average time between failures for a device.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      145,
      264,
      273,
      261,
      263
    ],
    "source": "235605_ch16"
  },
  {
    "id": 516,
    "question": "You need to supply power for a rack of servers. Which device should you use?",
    "choice_a": "Inverter",
    "choice_b": "HVAC",
    "choice_c": "UPS",
    "choice_d": "PDU",
    "correct_answer": "D",
    "explanation": "A power distribution unit (PDU) is a device used to supply power for servers and devices; it is similar to a power strip. An inverter is a component of an uninterruptable power supply (UPS). Heating, ventilation, and air conditioning (HVAC) units are used to cool data centers and office spaces. An uninterruptable power supply (UPS) is used to supply short-term power during a power outage.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      67,
      174,
      145,
      261,
      177
    ],
    "source": "235605_ch16"
  },
  {
    "id": 517,
    "question": "You have a server in a data center that has two interfaces. What should you employ to make sure that a switch failure will not impede network function of the server?",
    "choice_a": "HSRP",
    "choice_b": "VRRP",
    "choice_c": "NIC teaming",
    "choice_d": "STP",
    "correct_answer": "C",
    "explanation": "NIC teaming will allow you to use both network interfaces connected to independent switches. If one switch fails, the NIC team will allow failure of the NIC to the functioning switch. Hot Standby Router Protocol (HSRP) and Virtual Router Redundancy Protocol (VRRP) are First Hop Redundancy Protocols (FHRPs) used for redundancy of upstream routers. Spanning Tree Protocol (STP) is used to prevent loops in switching networks with redundant paths.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      262,
      264,
      145,
      273,
      261
    ],
    "source": "235605_ch16"
  },
  {
    "id": 518,
    "question": "Amazon Web Services (AWS) and Microsoft Azure are examples of what?",
    "choice_a": "Public cloud providers",
    "choice_b": "Private cloud providers",
    "choice_c": "Hybrid cloud providers",
    "choice_d": "Dynamic cloud providers",
    "correct_answer": "A",
    "explanation": "AWS and Microsoft Azure are examples of public cloud providers. Private clouds are internally created, and hybrid clouds are a combination of services between your private cloud and the public cloud. Private clouds are purchased and maintained by a private entity and not available for public use, usually on your internal network. Hybrid clouds are a mixture of private and public clouds, usually where your infrastructure exists partially in the public cloud and partially in your private cloud. There is no such thing as dynamic cloud providers since all cloud providers must have a level of elasticity for their clients.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      301,
      283,
      288,
      282,
      281
    ],
    "source": "235605_ch17"
  },
  {
    "id": 519,
    "question": "A hosted medical records service is an example of which cloud model?",
    "choice_a": "PaaS",
    "choice_b": "IaaS",
    "choice_c": "SaaS",
    "choice_d": "BaaS",
    "correct_answer": "C",
    "explanation": "A hosted medical records service is an example of the SaaS, or software as a service, model. The customer cannot choose variables such as vCPU or RAM. The cloud provider is responsible for the delivery of the software, maintenance of the OS, and maintenance of the hardware. An example of platform as a service (PaaS) would be Google App Engine or Microsoft Azure, where code could be executed on a virtual stack of equipment (programming platform).",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      284,
      288,
      301,
      302,
      287
    ],
    "source": "235605_ch17"
  },
  {
    "id": 520,
    "question": "Which is not a NIST criterion for cloud computing?",
    "choice_a": "Resource pooling",
    "choice_b": "Rapid elasticity",
    "choice_c": "Automated billing",
    "choice_d": "Measured service",
    "correct_answer": "C",
    "explanation": "Automated billing is not a NIST criterion for cloud computing. It is essential for the cloud computing vendor but is not relevant if you are hosting your own private cloud. The five NIST criteria for cloud computing are on-demand self-service, broad network access, resource pooling, rapid elasticity, and measured service.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      283,
      288,
      289,
      301
    ],
    "source": "235605_ch17"
  },
  {
    "id": 521,
    "question": "Which term describes the type of cloud an internal IT department hosting virtualization for a company would host?",
    "choice_a": "Public cloud",
    "choice_b": "Elastic cloud",
    "choice_c": "Private cloud",
    "choice_d": "Internal cloud",
    "correct_answer": "C",
    "explanation": "When an internal IT department hosts the virtualization for a company, it is hosting a private cloud. A public cloud is virtualization infrastructure that is open to the public. An elastic cloud is a cloud that has elasticity. Rapid elasticity is one of the five characteristics that NIST defines as a characteristic of cloud computing. <i>Internal cloud</i> is not a term that describes virtualization; therefore, it is an invalid answer.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      283,
      301,
      282,
      281,
      288
    ],
    "source": "235605_ch17"
  },
  {
    "id": 522,
    "question": "Hosting a disaster recovery (DR) site on Microsoft Azure is an example of which National Institute of Standards and Technology (NIST) type of cloud service?",
    "choice_a": "IaaS",
    "choice_b": "DRaaS",
    "choice_c": "PaaS",
    "choice_d": "SaaS",
    "correct_answer": "A",
    "explanation": "The National Institute of Standards and Technology (NIST) defines three cloud types: platform as a service (PaaS), software as a service (SaaS), and infrastructure as a service (IaaS). A DR site hosting at a cloud provider is an example of IaaS. Although DRaaS can be used as a term to advertise a type of cloud service, it is not defined by NIST as a type of service.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      284,
      283,
      281,
      282,
      301
    ],
    "source": "235605_ch17"
  },
  {
    "id": 523,
    "question": "A hosted environment that allows you to write and run programs is an example of which cloud model?",
    "choice_a": "PaaS",
    "choice_b": "IaaS",
    "choice_c": "SaaS",
    "choice_d": "BaaS",
    "correct_answer": "A",
    "explanation": "A hosted service that allows you to develop upon it is an example of the platform as a service (PaaS) model. The cloud provider is responsible for delivering APIs that developers can use to create programs. An example of infrastructure as a service (IaaS) is Amazon Web Services (AWS), where a VM can be started up with virtual network services with only a credit card and you are billed periodically. An example of software as a service (SaaS) is your email provider or a customer relation management (CRM) company such as Salesforce. An example of backup as a service is Microsoft Azure cloud backup or Google Drive, just to name a couple.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      284,
      281,
      285,
      288,
      302
    ],
    "source": "235605_ch17"
  },
  {
    "id": 524,
    "question": "You purchase a VM on a public cloud and plan to create a VPN tunnel to the cloud provider. Your IP network is 172.16.0.0/12, and the provider has assigned an IP address in the 10.0.0.0/8 network. What virtual network function (VNF) will you need from the provider to communicate with the VM?",
    "choice_a": "Virtual switch",
    "choice_b": "Virtual firewall",
    "choice_c": "Virtual router",
    "choice_d": "Another IP scheme at the provider",
    "correct_answer": "C",
    "explanation": "You will need a virtual router running static NAT to translate the two different IP networks. This type of service is called a virtual network function (VNF). A virtual switch is built into just about every virtualization platform, since layer 2 communications are normally required. A virtual firewall is a piece of software that allows you to protect your virtualization infrastructure, just like their hardware counterparts. Another IP scheme at the provider could help, but a router would still be required for connectivity.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      285,
      287,
      116,
      117,
      14
    ],
    "source": "235605_ch17"
  },
  {
    "id": 525,
    "question": "Where does the SDN controller interface with the switching fabric?",
    "choice_a": "Spine",
    "choice_b": "Control plane",
    "choice_c": "Forwarding plane",
    "choice_d": "Core",
    "correct_answer": "B",
    "explanation": "The software-defined networking controller provides the control plane for an SDN-based switching fabric.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      295,
      297,
      14,
      16,
      81
    ],
    "source": "235605_ch17"
  },
  {
    "id": 526,
    "question": "You are running several web servers in a cloud with a server load balancer. As demand increases, you add web servers. According to the NIST standard of cloud computing, which feature can you use to increase your compute capability for demand?",
    "choice_a": "Resource pooling",
    "choice_b": "Measured services",
    "choice_c": "Broad network access",
    "choice_d": "Rapid elasticity",
    "correct_answer": "D",
    "explanation": "Rapid elasticity is the ability to add and remove compute capability in the cloud. As demand increases, compute power can be increased by adding more CPUs or servers. As demand for compute power decreases, CPUs or servers can be removed. Resource pooling is the concept that all of the physical hosts the provider has are pooled together to provide a customer with resources. Measured services is the concept that the provider can determine the amount of computing, network, or storage a customer has used so that they can be billed or a report can be created. Broad network access is the concept that the resources can be accessed from anywhere on the Internet.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      289,
      302,
      281,
      288
    ],
    "source": "235605_ch17"
  },
  {
    "id": 527,
    "question": "Abstracting the cloud hardware into software objects for automated configuration is referred to as which of the following?",
    "choice_a": "Application programming interface",
    "choice_b": "Elasticity",
    "choice_c": "Infrastructure as code",
    "choice_d": "Software-defined networking",
    "correct_answer": "C",
    "explanation": "The practice of creating infrastructure definitions in software is called infrastructure as code (IaC).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      291,
      302,
      284,
      285,
      294
    ],
    "source": "235605_ch17"
  },
  {
    "id": 528,
    "question": "Which network plane is used by SSH for command-line configuration?",
    "choice_a": "Data plane",
    "choice_b": "Control plane",
    "choice_c": "Management plane",
    "choice_d": "Switch plane",
    "correct_answer": "C",
    "explanation": "The management plane is any mechanism that helps in the management of a router or switch. Some of the common mechanisms are SSH and Telnet. The control plane refers to any mechanism that controls the data plane. The data plane is responsible for switching and routing data. Any data that is destined for endpoints is switched or routed on the data plane. <i>Switch plane</i> is not a term normally used to describe data types; therefore, option D is an invalid answer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      74,
      72,
      21,
      19,
      81
    ],
    "source": "235605_ch17"
  },
  {
    "id": 529,
    "question": "Which is used for communicating directly to the SDN devices in the network?",
    "choice_a": "The northbound interface (NBI)",
    "choice_b": "The southbound interface (SBI)",
    "choice_c": "The core of the controller",
    "choice_d": "Applications hosted on the controller",
    "correct_answer": "B",
    "explanation": "The southbound interface (SBI) directly communicates with the SDN devices. This control is done via several different types of SBI protocols, such as OpenFlow, OpFlex, and CLI (Telnet/SSH). The northbound interface (NBI) is responsible for allowing communication between applications and the core of the controller. The core of the controller is the mechanism that connects the NBI to the SBI. Applications hosted on the controller interface with the NBI.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      297,
      295,
      296,
      17,
      82
    ],
    "source": "235605_ch17"
  },
  {
    "id": 530,
    "question": "When the vendor provides the hardware platform or data center and the company installs and manages its own operating systems and application systems, which service type is being used?",
    "choice_a": "Software as a service",
    "choice_b": "Infrastructure as a service",
    "choice_c": "Platform as a service",
    "choice_d": "Desktop as a service",
    "correct_answer": "B",
    "explanation": "There are many different service type offerings from the cloud providers. IaaS, or infrastructure as a service, is when the cloud vendor provides the hardware platform and the company installs and manages its own operating systems. An example of software as a service is an email provider or CRM application. An example of platform as a service is any platform in which you can develop and not maintain the underlying infrastructure. An example of desktop as a service is a platform that offers a virtual desktop login over the Internet.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      284,
      281,
      302,
      301,
      285
    ],
    "source": "235605_ch17"
  },
  {
    "id": 531,
    "question": "When an application communicates with an SDN controller, which mechanism does it use to communicate?",
    "choice_a": "The southbound interface (SBI)",
    "choice_b": "The core of the controller",
    "choice_c": "The northbound interface (NBI)",
    "choice_d": "Simple Network Management Protocol (SNMP)",
    "correct_answer": "C",
    "explanation": "The northbound interface (NBI) is responsible for allowing communication between applications and the core of the controller. Applications therefore directly communicate with the core through the northbound interface. The southbound interface (SBI) directly communicates with the SDN devices. The core of the controller is the mechanism that connects the NBI to the SBI. The Simple Network Management Protocol (SNMP) is used for the monitoring and collection of device metrics.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      297,
      295,
      296,
      17,
      82
    ],
    "source": "235605_ch17"
  },
  {
    "id": 532,
    "question": "What are machine-to-machine configuration interfaces called?",
    "choice_a": "Northbound interfaces",
    "choice_b": "Southbound interfaces",
    "choice_c": "APIs",
    "choice_d": "SDN",
    "correct_answer": "C",
    "explanation": "Machine-to-machine configuration interfaces are called application programming interfaces (APIs) and are used to communicate with each other instead of human-based interfaces such as a GUI or the command line. The northbound interface (NBI) is responsible for allowing communication between applications and the core of the controller. The southbound interface (SBI) directly communicates with the SDN devices. A software-defined network (SDN) is a network that is managed and controlled by a network controller.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      297,
      295,
      296,
      291,
      18
    ],
    "source": "235605_ch17"
  },
  {
    "id": 533,
    "question": "Public clouds are divided into logical groupings that allow many different customers to access a section as if it were their own private data center. What is this known as?",
    "choice_a": "Scalability",
    "choice_b": "Elasticity",
    "choice_c": "Multitenancy",
    "choice_d": "Platform as a service",
    "correct_answer": "C",
    "explanation": "Multitenancy or multitenant clouds offer isolated space in the data centers to run services such as compute, storage, and databases. Scalability is the strategic ability to scale network operations. Elasticity is the tactical ability to scale network operations by adding resources. Platform as a service (PaaS) is a cloud service development environment that allows code to be executed on.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      288,
      301,
      282,
      289,
      290
    ],
    "source": "235605_ch17"
  },
  {
    "id": 534,
    "question": "Which of the following are methods used to connect a private cloud to a public cloud? (Choose all that apply.)",
    "choice_a": "Internet",
    "choice_b": "SDN",
    "choice_c": "VPN",
    "choice_d": "Direct Connect",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Common cloud interconnect methods include Internet, VPN, and Direct Connect. A software-defined network (SDN) is a network that is managed and controlled by a network controller. A virtual switch is a network virtual function (NVF).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      286,
      301,
      283,
      287,
      14
    ],
    "source": "235605_ch17",
    "choice_e": "Virtual switches"
  },
  {
    "id": 535,
    "question": "Which protocol allows for the tunneling of layer 2 traffic over a layer 3 network?",
    "choice_a": "GRE",
    "choice_b": "VLAN",
    "choice_c": "VXLAN",
    "choice_d": "STP",
    "correct_answer": "C",
    "explanation": "The Virtual eXtensible LAN (VXLAN) protocol is used to create layer 2 tunnels over a layer 3 network. The VXLAN protocol functions by encapsulating layer 2 traffic inside of a layer 3 packet. Generic Router Encapsulation (GRE) is a protocol for encapsulation IP packets inside other IP packets. Virtual local area network (VLAN) is a switching technology that creates network segmentation by creating logical networks in a physical switch. Spanning Tree Protocol (STP) prevents loops in networks with redundant switch links.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      298,
      80,
      82,
      21,
      22
    ],
    "source": "235605_ch17"
  },
  {
    "id": 536,
    "question": "Which function does Ansible, Chef, and Puppet perform in the network?",
    "choice_a": "Network management station",
    "choice_b": "Automation and orchestration",
    "choice_c": "Software-defined networking",
    "choice_d": "Centralized logging",
    "correct_answer": "B",
    "explanation": "Ansible, Chef, and Puppet are configuration management tools that perform automation and orchestration. A network management station (NMS) is typically used with the Simple Network Management Protocol (SNMP) to centralize polling of SNMP counters and allow for devices to send alerts. Software-defined networking is a method of centralizing the control and management planes of a network so that the network device can focus on the data plane. Centralized logging is used with Syslog so that all logs can be sent to a centralized area for analysis.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      291,
      293,
      302,
      295,
      294
    ],
    "source": "235605_ch17"
  },
  {
    "id": 537,
    "question": "Which concept assumes a user or device is not trusted, regardless of whether it was previously authenticated?",
    "choice_a": "ZTA",
    "choice_b": "SDN",
    "choice_c": "IaC",
    "choice_d": "IaaS",
    "correct_answer": "A",
    "explanation": "Zero trust architecture (ZTA) assumes a user or device is not trusted, regardless of whether it was previously authenticated. Software-defined networking is a method of centralizing the control and management planes of a network so that the network device can focus on the data plane. Infrastructure as code (IaC) is a method of provisioning and configuring network resources via code. Infrastructure as a service (IaaS) is a cloud type that provides the underlying infrastructure to virtualize a network.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      299,
      300,
      295,
      296,
      302
    ],
    "source": "235605_ch17"
  },
  {
    "id": 538,
    "question": "Which of the following are not specific steps in the Network+ troubleshooting methodology model? (Choose all that apply.)",
    "choice_a": "Reboot the servers.",
    "choice_b": "Identify the problem.",
    "choice_c": "Test the theory to determine the cause.",
    "choice_d": "Implement the solution or escalate as necessary.",
    "correct_answer": [
      "A",
      "F"
    ],
    "explanation": "Rebooting servers and rebooting routers are not specifically part of the troubleshooting methodology model. All other answers are incorrect.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      311,
      322,
      320,
      319,
      304
    ],
    "source": "235605_ch18",
    "choice_e": "Document findings, actions, outcomes, and lessons learned",
    "choice_f": "Reboot all the routers."
  },
  {
    "id": 539,
    "question": "You have a user who cannot connect to the network. What is the first thing you could check to determine the source of the problem?",
    "choice_a": "Workstation configuration",
    "choice_b": "Connectivity",
    "choice_c": "Patch cable",
    "choice_d": "Server configuration",
    "correct_answer": "B",
    "explanation": "You need to check basic connectivity. The link light indicates that the network card is making a basic-level connection to the rest of the network. It is a very easy item to check, and if the link light is not lit, it is usually a very simple fix (like plugging in an unplugged cable). All other answers are incorrect.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      303,
      322,
      311,
      320,
      312
    ],
    "source": "235605_ch18"
  },
  {
    "id": 540,
    "question": "When wireless users complain that they are losing their connection to applications during a session, what is the source of the problem?",
    "choice_a": "Incorrect SSID",
    "choice_b": "Latency",
    "choice_c": "Incorrect encryption",
    "choice_d": "MAC address filter",
    "correct_answer": "B",
    "explanation": "When wireless users complain that the network is slow (latency) or that they are losing their connection to applications during a session, it is usually latency arising from a capacity issue. An incorrect SSID, encryption, or MAC address filter would prevent the user from ever connecting to the wireless network.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      310,
      311,
      312,
      314,
      319
    ],
    "source": "235605_ch18"
  },
  {
    "id": 541,
    "question": "Several users can\u2019t log in to the server. Which action would help you to narrow the problem down to the workstations, network, or server?",
    "choice_a": "Run <code>tracert</code> from a workstation.",
    "choice_b": "Check the server console for user connections.",
    "choice_c": "Run <code>netstat</code> on all workstations.",
    "choice_d": "Check the network diagnostics.",
    "correct_answer": "B",
    "explanation": "Although all of these are good tests for network connectivity, checking the server console for user connections will tell you whether other users are able to log into the server. If they can, the problem is most likely related to one of those users\u2019 workstations. If they can\u2019t, the problem is either the server or network connection. This helps narrow down the problem.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      306,
      318,
      312,
      322,
      311
    ],
    "source": "235605_ch18"
  },
  {
    "id": 542,
    "question": "A user can\u2019t log into the network. She can\u2019t even connect to the Internet over the LAN. Other users in the same area aren\u2019t experiencing any problems. You attempt to log in as this user from your workstation with her username and password and don\u2019t experience any problems. However, you cannot log in with either her username or yours from her workstation. What is a likely cause of the problem?",
    "choice_a": "Insufficient rights to access the server",
    "choice_b": "A bad patch cable",
    "choice_c": "Server down",
    "choice_d": "Wrong username and password",
    "correct_answer": "B",
    "explanation": "Because of all the tests given and their results, you can narrow the problem down to the network connectivity of that workstation. And because no other users in this user\u2019s area are having the same problem, it can\u2019t be the hub or server. You can log in as the user from your workstation, so you know it isn\u2019t a rights issue or username/password issue. The only possible answer listed is a bad patch cable.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      322,
      311,
      304,
      306,
      320
    ],
    "source": "235605_ch18"
  },
  {
    "id": 543,
    "question": "A user is experiencing problems logging into a Linux server. He can connect to the Internet over the LAN. Other users in the same area aren\u2019t experiencing any problems. You attempt logging in as this user from your workstation with his username and password and don\u2019t experience any problems. However, you cannot log in with either his username or yours from his workstation. What is a likely cause of the problem?",
    "choice_a": "The Caps Lock key is pressed.",
    "choice_b": "The network hub is malfunctioning.",
    "choice_c": "You have a downed server.",
    "choice_d": "You have a jabbering NIC.",
    "correct_answer": "A",
    "explanation": "Because other users in the same area aren't having a problem, it can\u2019t be a downed server, network hub, or jabbering NIC. And because both you and the user can\u2019t log in, more than likely it\u2019s a problem specific to that workstation. The only one that would affect your ability to log in from that station is the Caps Lock key being pressed. That will cause the password to be in all uppercase (which most server operating systems treat as a different password), and thus it will probably be rejected.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      303,
      304,
      306,
      320,
      312
    ],
    "source": "235605_ch18"
  },
  {
    "id": 544,
    "question": "You receive a call from a user who is having issues connecting to a new VPN. Which is the first step you should take?",
    "choice_a": "Test a theory.",
    "choice_b": "Reboot the workstation.",
    "choice_c": "Document the solution.",
    "choice_d": "Identify the symptoms and potential causes.",
    "correct_answer": "D",
    "explanation": "Since this is a new connection, you need to start by troubleshooting and identify the symptoms and potential causes. Testing a theory is done after you have established a theory and identified the symptoms and potential causes. Rebooting the workstation will probably not fix the issue. Documenting the solution is the last step.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      311,
      322,
      312,
      318,
      303
    ],
    "source": "235605_ch18"
  },
  {
    "id": 545,
    "question": "A workstation presents an error message to a user. The message states that a duplicate IP address has been detected on the network. After establishing what has changed in the network, what should be the next step using the standard troubleshooting model?",
    "choice_a": "Test the result.",
    "choice_b": "Select the most probable cause.",
    "choice_c": "Create an action plan.",
    "choice_d": "Identify the results and effects of the solution.",
    "correct_answer": "B",
    "explanation": "According to the Network+ troubleshooting model, the next step would be step 2, establishing the most probable cause.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      322,
      311,
      337,
      306,
      319
    ],
    "source": "235605_ch18"
  },
  {
    "id": 546,
    "question": "You have gathered information on a network issue and determined the affected areas of the network. What is your next step in resolving this issue?",
    "choice_a": "You should implement the best solution for the issue.",
    "choice_b": "You should test the best solution for the issue.",
    "choice_c": "You should check to see if there have been any recent changes to this affected part of the network.",
    "choice_d": "You should consider any negative impact to the network that might be caused by a solution.",
    "correct_answer": "C",
    "explanation": "After determining the affected area, you need to find out if any changes have taken place. All other answers are incorrect.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      322,
      311,
      319,
      312,
      320
    ],
    "source": "235605_ch18"
  },
  {
    "id": 547,
    "question": "A user calls you, reporting a problem logging in to the corporate intranet. You can access the website without problems using the user\u2019s username and password. At your request, the user has tried logging in from other workstations but has been unsuccessful. What is the most likely cause of the problem?",
    "choice_a": "The user is logging in incorrectly.",
    "choice_b": "The network is down.",
    "choice_c": "The intranet server is locked up.",
    "choice_d": "The server is not routing packets correctly to that user\u2019s workstation.",
    "correct_answer": "A",
    "explanation": "Because the user can\u2019t log in correctly from any machine, more than likely he is using the wrong procedure for logging in. Because no one else is having that problem (including yourself), the problem must be related to that user.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      303,
      304,
      312,
      311,
      306
    ],
    "source": "235605_ch18"
  },
  {
    "id": 548,
    "question": "You have just implemented a solution, and you want to celebrate your success. But what should you do next before you start your celebration?",
    "choice_a": "Gather more information about the issue.",
    "choice_b": "Document the issue and the solution that was implemented.",
    "choice_c": "Test the solution and identify other effects it may have.",
    "choice_d": "Escalate the issue.",
    "correct_answer": "C",
    "explanation": "After you have implemented a solution, you need to test if the solution works and identify other effects it may have. Gathering information about the issue is one of the first steps. Documenting the issue and the solution that was implemented is the very last step. Escalating the issue is usually done in the middle of troubleshooting when knowledge is exhausted or a fast answer can be derived.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      311,
      322,
      312,
      304,
      305
    ],
    "source": "235605_ch18"
  },
  {
    "id": 549,
    "question": "You can ping the local router and web server that a local user is trying to reach, but you cannot reach the web page that resides on that server. From step 2 of the troubleshooting model, what is a possible problem that would lead to this situation?",
    "choice_a": "Your network cable is unplugged.",
    "choice_b": "There is a problem with your browser.",
    "choice_c": "Your NIC has failed.",
    "choice_d": "The web server is unplugged.",
    "correct_answer": "B",
    "explanation": "Because you cannot reach the web page that resides on the server, the problem is most likely related to your browser. If your cable was unplugged or your NIC had failed, you would not get a ping back from the network. If the web server was unplugged, you would not get a ping back from the web server.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      322,
      311,
      318,
      312,
      305
    ],
    "source": "235605_ch18"
  },
  {
    "id": 550,
    "question": "When troubleshooting an obscure network problem, what physical conditions should be reviewed to make sure the network device is operating correctly? (Choose all that apply.)",
    "choice_a": "Excessive heat",
    "choice_b": "Low/excessive humidity",
    "choice_c": "ESD problems",
    "choice_d": "Time of day",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "From a design standpoint, the physical environment for a server should be optimized for items such as placement, temperature, and humidity. When troubleshooting, don\u2019t forget to check the physical conditions under which the network device is operating. Check for problems such as those mentioned here as well as EMI/RFI problems, power problems, and unplugged cables. The time of day typically does not have any effect on the problem or solution.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      320,
      303,
      309,
      323,
      318
    ],
    "source": "235605_ch18"
  },
  {
    "id": 551,
    "question": "Which of the following is not a basic physical issue that can occur on a network when a user is connected via cable?",
    "choice_a": "Crosstalk",
    "choice_b": "Shorts",
    "choice_c": "Open impedance mismatch",
    "choice_d": "DNS configurations",
    "correct_answer": "D",
    "explanation": "Because most of today\u2019s networks still consist of large amounts of copper cable, networks can suffer from the physical issues that have plagued all networks since the very beginning of networking (and the answers here are not a complete list). Newer technologies and protocols have lessened these issues but have not resolved them completely. Crosstalk, shorts, and open impedance mismatch are all basic physical issues that can occur.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      323,
      309,
      358,
      320,
      310
    ],
    "source": "235605_ch18"
  },
  {
    "id": 552,
    "question": "You are troubleshooting a LAN switch and have identified the problem is complex. What is the next step you should take?",
    "choice_a": "Escalate the issue.",
    "choice_b": "Create an action plan.",
    "choice_c": "Implement the solution.",
    "choice_d": "Determine the scope of the problem.",
    "correct_answer": "A",
    "explanation": "Once you have determined that the switch or the configuration of the switch is complex, you should escalate the issue. Creating an action plan and implementing a solution should be done after a possible solution is derived. Determining the scope of the problem is one of the first steps that should be accomplished.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      322,
      311,
      318,
      319,
      305
    ],
    "source": "235605_ch18"
  },
  {
    "id": 553,
    "question": "A user calls you complaining that he can\u2019t access the corporate intranet web server. You try the same address, and you receive a Host Not Found error. Several minutes later, another user reports the same problem. You can still send email and transfer files to another server. What is the most likely cause of the problem?",
    "choice_a": "The hub is unplugged.",
    "choice_b": "The server is not routing protocols to your workstation.",
    "choice_c": "The user\u2019s workstation is not connected to the network.",
    "choice_d": "The web server is down.",
    "correct_answer": "D",
    "explanation": "Because other people are experiencing the problem, most likely it is either network-or server-related. Because you can transfer files to and from another server, it can\u2019t be the network. Thus, the problem is related to the web server.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      322,
      311,
      306,
      338,
      312
    ],
    "source": "235605_ch18"
  },
  {
    "id": 554,
    "question": "You have implemented and tested a solution and identified any other effects the solution may have. What is your next step?",
    "choice_a": "Create an action plan.",
    "choice_b": "Close the case and head home for the day.",
    "choice_c": "Reboot the Windows server.",
    "choice_d": "Document the solution.",
    "correct_answer": "D",
    "explanation": "After investigating the problem thoroughly and successfully testing and resolving an issue, you need to document the solution. All other answers are incorrect.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      322,
      311,
      318,
      304,
      312
    ],
    "source": "235605_ch18"
  },
  {
    "id": 555,
    "question": "Users are reporting that they can access the Internet but not the internal company website. Which of the following is the most likely problem?",
    "choice_a": "The DNS entry for the server is non-authoritative.",
    "choice_b": "The intranet server is down.",
    "choice_c": "The DNS address handed out by DHCP is incorrect.",
    "choice_d": "The default gateway is incorrect.",
    "correct_answer": "B",
    "explanation": "Since users can get to the Internet, this means the DNS server is working, and they have the correct default gateway. The intranet server is probably down.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      312,
      311,
      306,
      321,
      338
    ],
    "source": "235605_ch18"
  },
  {
    "id": 556,
    "question": "Several users have complained about the server\u2019s poor performance as of late. You know that the memory installed in the server is sufficient. What could you use to determine the source of the problem?",
    "choice_a": "Server\u2019s NIC link light",
    "choice_b": "Protocol analyzer",
    "choice_c": "Performance-monitoring tools",
    "choice_d": "Server\u2019s system log file",
    "correct_answer": "C",
    "explanation": "Performance-monitoring tools can give you an idea of how busy the server and the rest of the network are. These tools use graphs to indicate how much traffic is going through the server. The server\u2019s NIC link light will only verify the physical connection. A protocol analyzer will allow you to diagnose applications problems at a very finite level. The server\u2019s system log file will only detail failures.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      324,
      327,
      311,
      312,
      320
    ],
    "source": "235605_ch18"
  },
  {
    "id": 557,
    "question": "You lose power to your computer room, and the switches in your network do not come back up when everything is brought online. After you have identified the affected areas, established the cause, and escalated this problem, what do you do next?",
    "choice_a": "Start to implement a solution to get those users back online ASAP.",
    "choice_b": "Create an action plan and solution.",
    "choice_c": "Meet with the emergency response team to determine the next step.",
    "choice_d": "Copy all the working routers\u2019 configurations to the nonworking switches.",
    "correct_answer": "C",
    "explanation": "Once you escalate the problem, you are done with the seven-step troubleshooting model. Meet with the escalation team to determine the next step. All other answers are incorrect.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      322,
      311,
      315,
      318,
      306
    ],
    "source": "235605_ch18"
  },
  {
    "id": 558,
    "question": "Which TCP/IP utility is most often used to test whether an IP host is up and functional?",
    "choice_a": "<code>ftp</code>",
    "choice_b": "<code>telnet</code>",
    "choice_c": "<code>ping</code>",
    "choice_d": "<code>netstat</code>",
    "correct_answer": "C",
    "explanation": "The program Packet Internet Groper (<code>ping</code>) is used to find out if a host has the IP stack initialized. File Transfer Protocol (FTP) is a protocol used to transfer files. Telnet is an unencrypted terminal-based emulator that operates across TCP/IP. The <code>netstat</code> command will detail all of the connections to the operating system.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      335,
      346,
      338,
      328,
      324
    ],
    "source": "235605_ch19"
  },
  {
    "id": 559,
    "question": "Which TCP/IP utility will produce the following result?<br>Interface: 199.102.30.152 <br>Internet Address   Physical Address   Type <br>199.102.30.152     A0\u2013ee\u201300\u20135b\u20130e\u2013ac   dynamic",
    "choice_a": "<code>arp</code>",
    "choice_b": "<code>netstat</code>",
    "choice_c": "<code>tracert</code>",
    "choice_d": "<code>tcpdump</code>",
    "correct_answer": "A",
    "explanation": "The <code>arp</code> utility is used to display the contents of the ARP cache, which tracks the resolution of IP addresses to physical (MAC) addresses and will produce the displayed output. The <code>netstat</code> command will detail all of the connections to the operating system. The <code>tracert</code> command will display the path a packet will take through the network to the destination. The <code>tcpdump</code> command will display all packets that are seen by the network interface card (NIC).",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      337,
      336,
      331,
      330,
      335
    ],
    "source": "235605_ch19"
  },
  {
    "id": 560,
    "question": "Which Windows utility can you use to connect to a machine 50 miles away to troubleshoot?",
    "choice_a": "Remote Desktop",
    "choice_b": "<code>netstat</code>",
    "choice_c": "<code>arp</code>",
    "choice_d": "Wireshark",
    "correct_answer": "A",
    "explanation": "The Microsoft operating system has a Remote Desktop software built in called Remote Desktop. Connections can be made from anywhere in the world, permitting that it is enabled on the destination computer. The <code>netstat</code> command will detail all of the connections to the operating system. The <code>arp</code> utility is used to display the contents of the ARP cache, which tracks the resolution of IP addresses to physical (MAC) addresses and will produce the displayed output. Wireshark is a packet capture and analyzer tool used to determine issues.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      326,
      324,
      346,
      347,
      311
    ],
    "source": "235605_ch19"
  },
  {
    "id": 561,
    "question": "Which TCP/IP utility might produce the following output?<br>Reply from 204.153.163.2: bytes=32 time=1ms TTL=128 <br>Reply from 204.153.163.2: bytes=32 time=1ms TTL=128 <br>Reply from 204.153.163.2: bytes=32 time=1ms TTL=128 <br>Reply from 204.153.163.2: bytes=32 time<10ms TTL=128",
    "choice_a": "<code>tracert</code>",
    "choice_b": "<code>ping</code>",
    "choice_c": "<code>arp</code>",
    "choice_d": "<code>ipconfig</code>",
    "correct_answer": "B",
    "explanation": "The purpose of the <code>ping</code> utility is to test the communications between two IP hosts as well as how long it takes the packets to get from one host to another. The <code>tracert</code> command will display the path a packet will take through the network to the destination. The <code>arp</code> utility is used to display the contents of the ARP cache, which tracks the resolution of IP addresses to physical (MAC) addresses and will produce the displayed output. The <code>ipconfig</code> command is used on Microsoft operating systems to display the IP address configuration.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      335,
      329,
      336,
      331,
      337
    ],
    "source": "235605_ch19"
  },
  {
    "id": 562,
    "question": "Which utility can you use to find the MAC and TCP/IP addresses of your Windows workstation?",
    "choice_a": "<code>ping</code>",
    "choice_b": "<code>ipconfig</code>",
    "choice_c": "<code>ipconfig /all</code>",
    "choice_d": "<code>tracert</code>",
    "correct_answer": "C",
    "explanation": "The <code>ipconfig /all</code> utility will display the current configuration of TCP/IP on a given workstation\u2014including the current IP address, DNS configuration, and default gateway. The purpose of the <code>ping</code> utility is to test the communications between two IP hosts as well as how long it takes the packets to get from one host to another. The <code>ipconfig</code> command alone will display basic IP configuration information, such as IP address, subnet mask, and default gateway. The <code>tracert</code> command will display the path a packet will take through the network to the destination.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      330,
      331,
      336,
      335,
      329
    ],
    "source": "235605_ch19"
  },
  {
    "id": 563,
    "question": "Which <code>ping</code> commands will verify that your local TCP/IP interface is working? (Choose all that apply.)",
    "choice_a": "<code>ping 204.153.163.2</code>",
    "choice_b": "<code>ping 127.0.0.1</code>",
    "choice_c": "<code>ping localif</code>",
    "choice_d": "<code>ping localhost</code>",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "The address 127.0.0.1 is the special IP address designated for the local TCP/IP interface. The hostname localhost is the hostname given to the local interface. Therefore, pinging either the IP address or the hostname for the local interface will tell you whether the local interface is working. All other answers are incorrect.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      335,
      331,
      340,
      303,
      322
    ],
    "source": "235605_ch19",
    "choice_e": "<code>ping iphost</code>"
  },
  {
    "id": 564,
    "question": "Which newer Linux command was added recently to configure IP and interface parameters?",
    "choice_a": "<code>netstat</code>",
    "choice_b": "<code>ipconfig</code>",
    "choice_c": "<code>ip</code>",
    "choice_d": "<code>ifconfig</code>",
    "correct_answer": "C",
    "explanation": "The command <code>ip</code> was added to most Linux distributions and is replacing the depreciated <code>ifconfig</code> command. The <code>netstat</code> command will detail all of the connections to the operating system. The <code>ipconfig</code> command is a Microsoft command-line tool that will display basic IP configuration information.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      333,
      331,
      332,
      330,
      362
    ],
    "source": "235605_ch19"
  },
  {
    "id": 565,
    "question": "You need to find a NIC\u2019s specific MAC address and IP address. Which command-line tool can you use to find this information without physically going to the computer?",
    "choice_a": "<code>ping</code>",
    "choice_b": "<code>ipconfig</code>",
    "choice_c": "<code>arp</code>",
    "choice_d": "<code>netstat</code>",
    "correct_answer": "C",
    "explanation": "The <code>arp</code> utility will show you the resolved MAC to IP address of all hosts on your network segment. Remember, this will work for only local hosts, not remote hosts. The <code>ping</code> command tests connectivity and round-trip time between two hosts. The <code>ipconfig</code> command is a Microsoft command-line tool that will display basic IP configuration information. The <code>netstat</code> command will detail all of the connections to the operating system. The <code>ftp</code> command will transfer files between two hosts.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      336,
      337,
      330,
      331,
      335
    ],
    "source": "235605_ch19",
    "choice_e": "<code>ftp</code>"
  },
  {
    "id": 566,
    "question": "Which <code>netstat</code> utility switch displays all connections and listening ports?",
    "choice_a": "<code>\u2013a</code>",
    "choice_b": "<code>\u2013f</code>",
    "choice_c": "<code>-p</code>",
    "choice_d": "<code>-t</code>",
    "correct_answer": "A",
    "explanation": "The <code>netstat -a</code> command will display all connections and listening ports on the host computer. Remember that the <code>-a</code> must be lowercase and that it will not work correctly without the hyphen before it. The lowercase <code>-p</code> switch selects the protocol for the output of the <code>netstat</code> command. The <code>-f</code> and <code>-t</code> are not valid switches for the <code>netstat</code> command.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      347,
      346,
      331,
      338,
      325
    ],
    "source": "235605_ch19"
  },
  {
    "id": 567,
    "question": "Wireshark is an example of which of the following?",
    "choice_a": "Throughput tester",
    "choice_b": "Protocol analyzer",
    "choice_c": "Remote connection tool",
    "choice_d": "IDS",
    "correct_answer": "B",
    "explanation": "Commercial sniffers like Wireshark and Omnipeek can capture any packets because they set the NIC to operate in promiscuous mode, which means the NIC processes all packets that it sees. All other answers are incorrect.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      324,
      176,
      359,
      325,
      348
    ],
    "source": "235605_ch19"
  },
  {
    "id": 568,
    "question": "Which utility produces output similar to the following?<br>1  110 ms  96 ms  107 ms fgo1.corpcomm.net [209.74.93.10]<br>2  96 ms  126 ms  95 ms someone.corpcomm.net [209.74.93.1]<br>3  113 ms  119 ms  112 ms Serial5\u20131\u20131.GW2.MSP1.alter.net     [157.130.100.185]<br>4  133 ms  123 ms  126 ms 152.ATM3\u20130.XR2.CHI6.ALTER.NET      [146.188.209.126]<br>5  176 ms  133 ms  129 ms 290.ATM2\u20130.TR2.CHI4.ALTER.NET   [146.188.209.10]<br>6  196 ms  184 ms  218 ms 106.ATM7\u20130.TR2.SCL1.ALTER.NET   [146.188.136.162]<br>7  182 ms  187 ms  187 ms 298.ATM7\u20130.XR2.SJC1.ALTER.NET   [146.188.146.61]<br>8  204 ms  176 ms  186 ms 192.ATM3\u20130\u20130.SAN\u2013JOSE9\u2013 GW.ALTER.NET [146.188.144.133]<br>9  202 ms  198 ms  212 ms atm3\u20130\u2013622M.cr1.sjc.globalcenter.net [206.57.16.17]<br>10 209 ms  202 ms  195 ms pos3\u20131\u2013155M.br4.SJC.globalcenter.net [206.132.150.98]<br>11 190 ms   *   191 ms pos0\u20130\u20130\u2013155M.hr3.SNV.globalcenter.net [206.221.5.93]<br>12 195 ms  188 ms  188 ms pos4\u20131\u20130\u2013   155M.hr2.SNV.globalcenter.net [206.132.150.206]<br>13 198 ms  202 ms  197 ms www10.yahoo.com [204.71.200.75]",
    "choice_a": "<code>arp</code>",
    "choice_b": "<code>tracert</code>",
    "choice_c": "<code>tcpdump</code>",
    "choice_d": "<code>netstat</code>",
    "correct_answer": "B",
    "explanation": "The <code>tracert</code> utility will give you that output. The <code>tracert</code> command (or <code>trace</code> for short) traces the route from the source IP host to the destination host. The <code>arp</code> utility is used to display the contents of the ARP cache, which tracks the resolution of IP addresses to physical (MAC) addresses and will produce the displayed output. The <code>tcpdump</code> command will display all packets that are seen by the network interface card (NIC).",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      362,
      335,
      338,
      339,
      331
    ],
    "source": "235605_ch19"
  },
  {
    "id": 569,
    "question": "You are the network administrator. A user calls you complaining that the performance of the intranet web server is sluggish. When you try to ping the server, it takes several seconds for the server to respond. You suspect that the problem is related to a router that is seriously overloaded. Which workstation utility could you use to find out which router is causing this problem?",
    "choice_a": "<code>netstat</code>",
    "choice_b": "<code>tracert</code>",
    "choice_c": "<code>ping</code>",
    "choice_d": "<code>arp</code>",
    "correct_answer": "B",
    "explanation": "The <code>tracert</code> utility will tell you which router is having the performance problem and how long it takes to move between each host. The <code>tracert</code> command can be used to locate problem areas in a network. The <code>netstat</code> command will detail all of the connections to the operating system.<code> </code>The purpose of the <code>ping</code> utility is to test the communications between two IP hosts as well as how long it takes the packets to get from one host to another. The <code>arp</code> utility is used to display the contents of the ARP cache, which tracks the resolution of IP addresses to physical (MAC) addresses and will produce the displayed output.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      335,
      348,
      322,
      311,
      312
    ],
    "source": "235605_ch19"
  },
  {
    "id": 570,
    "question": "Which <code>ipconfig</code> switch will display the most complete listing of IP configuration information for a station?",
    "choice_a": "<code>/all</code>",
    "choice_b": "<code>/renew</code>",
    "choice_c": "<code>/release</code>",
    "choice_d": "<code>/?</code>",
    "correct_answer": "A",
    "explanation": "The <code>ipconfig /all</code> switch will display the most complete listing of TCP/IP configuration information, also displaying the MAC address, DHCP lease times, and the DNS addresses. The <code>/renew</code> switch will renew the current DHCP lease. The <code>/release</code> switch will release the current DHCP lease. The <code>/?</code> switch will display the help for the <code>ipconfig</code> command.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      330,
      331,
      321,
      347,
      303
    ],
    "source": "235605_ch19"
  },
  {
    "id": 571,
    "question": "Which utility will display a list of all the routers that a packet passes through on the way to an IP destination?",
    "choice_a": "<code>netstat</code>",
    "choice_b": "<code>tracert</code>",
    "choice_c": "<code>ping</code>",
    "choice_d": "<code>arp</code>",
    "correct_answer": "B",
    "explanation": "The <code>tracert</code> utility returns the names and addresses of all routers through which a packet passes on its way to a destination host. The <code>netstat</code> command will detail all of the connections to the operating system.The purpose of the <code>ping</code> utility is to test the communications between two IP hosts as well as how long it takes the packets to get from one host to another. The <code>arp</code> utility is used to display the contents of the ARP cache, which tracks the resolution of IP addresses to physical (MAC) addresses and will produce the displayed output.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      329,
      341,
      335,
      347,
      348
    ],
    "source": "235605_ch19"
  },
  {
    "id": 572,
    "question": "You are inspecting traffic to and from your workstation. When you issue the <code>netstat</code> command, you don\u2019t see any UDP entries. What could be the reason for a lack of UDP entries?",
    "choice_a": "UDP is connectionless.",
    "choice_b": "UDP is connection-based.",
    "choice_c": "There are no UDP ports listening.",
    "choice_d": "There is no UDP traffic.",
    "correct_answer": "D",
    "explanation": "Although UDP traffic is connectionless and a state will not be shown in the <code>netstat</code> command output, traffic will still show if there is traffic. When you issue the command <code>netstat</code> without any switches, listening ports will not be shown. Only when you issue the command <code>netstat -n</code> will you see listening ports.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      346,
      330,
      324,
      335,
      327
    ],
    "source": "235605_ch19"
  },
  {
    "id": 573,
    "question": "Which <code>arp</code> command can you use to display the currently cached ARP entries?",
    "choice_a": "<code>arp</code>",
    "choice_b": "<code>arp \u2013all</code>",
    "choice_c": "<code>arp -a</code>",
    "choice_d": "<code>ipconfig -arp</code>",
    "correct_answer": "C",
    "explanation": "The <code>arp -a</code> command will display the current contents of the ARP cache on the local workstation. All other answers are incorrect.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      337,
      336,
      362,
      347,
      335
    ],
    "source": "235605_ch19",
    "choice_e": "<code>arp -ipconfig</code>"
  },
  {
    "id": 574,
    "question": "Which command-line tool would best be used to verify DNS functionality in Linux?",
    "choice_a": "<code>netstat</code>",
    "choice_b": "<code>dig</code>",
    "choice_c": "<code>icmp</code>",
    "choice_d": "<code>arp</code>",
    "correct_answer": "B",
    "explanation": "The <code>dig</code> command is a UNIX/Linux command that will show you DNS server information. The <code>netstat</code> command will detail all of the connections to the operating system. ICMP is the protocol that <code>ping</code> and <code>tracert</code> operate on. The <code>arp -a</code> command will display the current contents of the ARP cache on the local workstation.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      339,
      338,
      362,
      331,
      335
    ],
    "source": "235605_ch19"
  },
  {
    "id": 575,
    "question": "Which of the following <code>arp</code> utility switches perform the same function? (Choose all that apply.)",
    "choice_a": "<code>\u2013g</code>",
    "choice_b": "<code>\u2013A</code>",
    "choice_c": "<code>\u2013d</code>",
    "choice_d": "<code>\u2013a</code>",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "The <code>arp</code> command\u2019s <code>\u2013a</code> and <code>\u2013g</code> switches perform the same function. They both show the current ARP cache. All other answers are incorrect.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      337,
      336,
      347,
      338,
      311
    ],
    "source": "235605_ch19"
  },
  {
    "id": 576,
    "question": "Which of the following is <i>not</i> a chain type used by <code>iptables</code>?",
    "choice_a": "Forward",
    "choice_b": "Backward",
    "choice_c": "Input",
    "choice_d": "Output",
    "correct_answer": "B",
    "explanation": "There are three different chain types:<br>Input: Controls behavior for incoming connections <br>Forward: Used for incoming connections that aren't being delivered locally (like a router would receive)<br>Output: Used for outgoing connections.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      334,
      332,
      333,
      362,
      335
    ],
    "source": "235605_ch19"
  },
  {
    "id": 577,
    "question": "Which command captures traffic on all interfaces?",
    "choice_a": "<code>tcpdump -i any</code>",
    "choice_b": "<code>tcpdump -i eth0</code>",
    "choice_c": "<code>tcpdump host 192.168.5.5</code>",
    "choice_d": "<code>tcpdump host all</code>",
    "correct_answer": "A",
    "explanation": "To capture traffic on all interfaces, use the <code>any</code> keyword with the <code>-i</code> (interface) switch. All other answers are incorrect.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      324,
      176,
      359,
      327,
      342
    ],
    "source": "235605_ch19"
  },
  {
    "id": 578,
    "question": "Which element of the CIA triad ensures that information can always be accessed?",
    "choice_a": "Accessibility",
    "choice_b": "Integrity",
    "choice_c": "Confidentiality",
    "choice_d": "Availability",
    "correct_answer": "D",
    "explanation": "The availability element of the CIA triad ensures that information can be accessible. The integrity element ensures that information is not tampered with. The confidentiality element ensures that information is kept confidential and can\u2019t be viewed by others, only its intended audience. Accessibility is not an element of the CIA triad.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      366,
      363,
      367,
      370,
      377
    ],
    "source": "235605_ch20"
  },
  {
    "id": 579,
    "question": "You are implementing an encryption key for backups to tape. Which encryption concept is being exercised?",
    "choice_a": "Data in use",
    "choice_b": "Data in transit",
    "choice_c": "Data at rest",
    "choice_d": "Data on tape",
    "correct_answer": "C",
    "explanation": "Data at rest is the encryption concept being exercised when you implement an encryption key for backup to tape. The data is at rest on its storage device. Data in use is protection for data in memory. Data in transit is protection for data being transmitted. Data on tape is not an encryption concept and falls under data at rest.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      367,
      381,
      393,
      368,
      366
    ],
    "source": "235605_ch20"
  },
  {
    "id": 580,
    "question": "Which of the following is not an external threat?",
    "choice_a": "Ransomware via a threat actor",
    "choice_b": "Denial of service",
    "choice_c": "Virus via an unknown USB drive",
    "choice_d": "Exploitation of a web server",
    "correct_answer": "C",
    "explanation": "The introduction of a virus with an unknown USB drive is an inadvertent insider threat. It could be controlled with education and vigilance. Ransomware via a threat actor, a DoS, and the exploitation of a web server would all be considered external threats, out of your control.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      363,
      387,
      382,
      365,
      376
    ],
    "source": "235605_ch20"
  },
  {
    "id": 581,
    "question": "The system used to create a common naming scheme for vulnerabilities is called?",
    "choice_a": "CVE",
    "choice_b": "Zero day",
    "choice_c": "IAM",
    "choice_d": "MFA",
    "correct_answer": "A",
    "explanation": "The common vulnerabilities and exposures (CVE) system is used by all major software vendors to create a common naming scheme for vulnerabilities. A zeroday is an exploit in which no patch is available for. Identity and access management (IAM) is a security framework adopted by service providers. Multifactor authentication (MFA) is the use of multiple factors to authenticate a user.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      364,
      365,
      363,
      366,
      368
    ],
    "source": "235605_ch20"
  },
  {
    "id": 582,
    "question": "Which security concept dictates that a user be given only the permission to perform their job?",
    "choice_a": "Zero trust",
    "choice_b": "Role-based access",
    "choice_c": "Least privilege",
    "choice_d": "Defense in depth",
    "correct_answer": "C",
    "explanation": "The principle of least privilege dictates that a user be given the least permission to perform their job. Zero trust is a method of requiring the user to authenticate for each resource they access, regardless of where the asset is located. Role-based access is a method of granting permissions based upon a role in the organization. The defense-in-depth security concept is a layered approach to security, where several layers are used to protect the organization.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      376,
      377,
      370,
      394,
      395
    ],
    "source": "235605_ch20"
  },
  {
    "id": 583,
    "question": "Which principle describes the process of verification of a user\u2019s identity?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Accounting",
    "choice_d": "Auditing",
    "correct_answer": "A",
    "explanation": "Authentication is the process of verifying a user\u2019s identify. It can be performed with various factors such as something you know, something you are, or something you have, in addition to other factors. Authorization is the process of checking the permission of the authenticated user for the resource. Accounting is the principle that describes the process of recording a user\u2019s action based upon the AAA security model of authentication, authorization, and accounting. Auditing is typically performed for compliance or review of log files.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      370,
      371,
      377,
      374,
      373
    ],
    "source": "235605_ch20"
  },
  {
    "id": 584,
    "question": "Which authentication system is an open standard originally proposed by the Internet Engineering Task Force (IETF)?",
    "choice_a": "RADIUS",
    "choice_b": "TACACS+",
    "choice_c": "Kerberos",
    "choice_d": "LDAP",
    "correct_answer": "A",
    "explanation": "Remote Authentication Dial-In User Service (RADIUS) was originally proposed by the IETF and became an open standard for authentication, often used with wireless. TACACS+ is a Cisco technology that became an open standard. Kerberos is exclusively used by Microsoft for the authentication of users. Lightweight Directory Access Protocol (LDAP) is a protocol that is also exclusively used by Microsoft for looking up objects in Active Directory.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      374,
      370,
      375,
      377,
      397
    ],
    "source": "235605_ch20"
  },
  {
    "id": 585,
    "question": "Which protocol is used with single sign-on (SSO) to exchange credentials in the form of a claim?",
    "choice_a": "LDAP",
    "choice_b": "SAML",
    "choice_c": "AD",
    "choice_d": "Kerberos",
    "correct_answer": "B",
    "explanation": "Security Assertion Markup Language (SAML) is an open-standard XML-based framework used for transmitting authentication and authorization information of users and computers. Lightweight Directory Access Protocol (LDAP) is a protocol that is exclusively used by Microsoft for looking up objects in Active Directory. Active Directory (AD) is Microsoft\u2019s directory services product. Kerberos is exclusively used by Microsoft for authenticating users with Active Directory.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      373,
      377,
      371,
      375,
      374
    ],
    "source": "235605_ch20"
  },
  {
    "id": 586,
    "question": "Which principle describes the process of verifying a user\u2019s permissions?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Accounting",
    "choice_d": "Auditing",
    "correct_answer": "B",
    "explanation": "Authorization is the process of verifying whether a user has permission for a specific action; it is followed by the authentication of the user. Authentication is the process of verifying the user\u2019s identify. It can be performed with various factors such as something you know, are, or have, in addition to other factors. Accounting is the principle that describes the process of recording a user\u2019s action based upon the AAA security model of authentication, authorization, and accounting. Auditing is typically performed for the compliance or review of log files.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      370,
      374,
      376,
      377,
      371
    ],
    "source": "235605_ch20"
  },
  {
    "id": 587,
    "question": "What protocol and port number does LDAP use for directory lookups?",
    "choice_a": "TCP/389",
    "choice_b": "TCP/1812",
    "choice_c": "UDP/389",
    "choice_d": "UDP/1812",
    "correct_answer": "A",
    "explanation": "The protocol TCP and port number of 389 are used for LDAP lookups. All of the other answers are incorrect.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      375,
      370,
      374,
      392,
      397
    ],
    "source": "235605_ch20"
  },
  {
    "id": 588,
    "question": "Which option accurately describes an exploit?",
    "choice_a": "A known weakness in the operating system",
    "choice_b": "A configuration that weakens the security of the operating system",
    "choice_c": "A known operating system security flaw",
    "choice_d": "A technique used to gain unauthorized access",
    "correct_answer": "D",
    "explanation": "An exploit is a script, code, application, or technique used to gain unauthorized access to an operating system through a vulnerability. A weakness in the operating system and a known operating system security flaw are considered vulnerabilities. A configuration that weakens the security of the operating system is considered a threat.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      365,
      364,
      363,
      381,
      392
    ],
    "source": "235605_ch20"
  },
  {
    "id": 589,
    "question": "Which of the following occurs when a threat agent takes advantage of a weakness and uses it to advance an attack?",
    "choice_a": "Threat",
    "choice_b": "Risk",
    "choice_c": "Vulnerability",
    "choice_d": "Exploit",
    "correct_answer": "D",
    "explanation": "An exploit is an attack against a weakness, also known as a vulnerability. The threat is the potential for an exploit to be carried out. The risk is the potential for the threat to become exploited. The vulnerability is the weakness in the system.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      365,
      364,
      363,
      381,
      382
    ],
    "source": "235605_ch20"
  },
  {
    "id": 590,
    "question": "You are seeing a large number of packets for UDP port 1813 on the network. What is this traffic likely to be for?",
    "choice_a": "RADIUS authentication",
    "choice_b": "RADIUS accounting",
    "choice_c": "TACACS+ authentication",
    "choice_d": "LDAP queries",
    "correct_answer": "B",
    "explanation": "The protocol is most likely for RADIUS accounting, which uses UDP port 1813. RADIUS authentication uses UDP port 1812. TACACS+ authentication uses TCP port 49. LDAP queries Active Directory on TCP port 389.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      374,
      370,
      397,
      377,
      381
    ],
    "source": "235605_ch20"
  },
  {
    "id": 591,
    "question": "You receive an SSL error when you visit a network appliance that has a self-signed certificate in use. What can you do to fix the issue?",
    "choice_a": "Add the network appliance public certificate to the root CA CRL.",
    "choice_b": "Add the network appliance public certificate to the root CA AIA.",
    "choice_c": "Add the network appliance public certificate to the trusted root CA certificate store.",
    "choice_d": "Add the network appliance private certificate to the trusted root CA certificate store.",
    "correct_answer": "C",
    "explanation": "To fix the issue, you will need to add the network appliance public certificate to the trusted root CA certificate store on your computer. This will allow your computer to trust the self-signed certificate and validate the signing. Adding the public certificate for the network appliance to the root CA certificate revocation list (CRL) is incorrect. Adding the network appliance public certificate to the root CA AIA is incorrect. Adding the network appliance private certificate to the trusted root CA certificate store will not fix the issue.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      369,
      368,
      367,
      381,
      383
    ],
    "source": "235605_ch20"
  },
  {
    "id": 592,
    "question": "Which factor of authentication requires you to present something that is unique to you and can\u2019t be copied?",
    "choice_a": "Password",
    "choice_b": "Signature",
    "choice_c": "Fingerprint",
    "choice_d": "Location",
    "correct_answer": "C",
    "explanation": "Your fingerprint is an example of something that you are, because it is unique to you. A password is something that you know. A signature is something that you do, as it is unique to how you sign and can be forged. A location is somewhere you are, according to your GPS location.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      371,
      372,
      377,
      370,
      373
    ],
    "source": "235605_ch20"
  },
  {
    "id": 593,
    "question": "Which European law protects consumers?",
    "choice_a": "SOX",
    "choice_b": "HIPAA",
    "choice_c": "GLBA",
    "choice_d": "GDPR",
    "correct_answer": "D",
    "explanation": "The General Data Protection Regulation (GDPR) is a European law that protects consumers and regulates how their data can be used. The Sarbanes\u2013Oxley Act (SOX) is a federal law and regulates how financial records are kept. The Health Insurance Portability and Accountability Act is a law that regulates how patient information is protected. The Gramm\u2013Leach\u2013Bliley Act (GLBA) is a Federal Trade Commission (FTC) regulation that protects US consumers.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      379,
      378,
      380,
      368,
      377
    ],
    "source": "235605_ch20"
  },
  {
    "id": 594,
    "question": "You are asked to secure records and prevent them from being viewed off-site. Which authorization method would prevent someone from viewing records off-site?",
    "choice_a": "Least privilege",
    "choice_b": "Geofencing",
    "choice_c": "RBAC",
    "choice_d": "IAM",
    "correct_answer": "B",
    "explanation": "Geofencing is a technique to protect data, so it is viewed only within a geographic location. The principle of least privilege is a concept where you only grant the necessary permissions to do a task. Role-based access control (RBAC) is a system in which people are given roles and the roles contain the permissions to complete a task. Identity and access management (IAM) is a security framework for creating users and granting permissions.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      376,
      377,
      370,
      367,
      395
    ],
    "source": "235605_ch20"
  },
  {
    "id": 595,
    "question": "Which PKI element is used to check to see if a certificate has been revoked?",
    "choice_a": "CRL",
    "choice_b": "Root CA",
    "choice_c": "AIA",
    "choice_d": "Private key",
    "correct_answer": "A",
    "explanation": "The certificate revocation list (CRL), which is located in the public certificate, is checked to make sure that a certificate has not been revoked. The root certificate authority (CA) is the root of all trust for an issued certificate. The Authority Information Access (AIA) defines how the client can obtain the public certificate for a presented certificate. The private key is used to sign and decrypt.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      368,
      381,
      367,
      393,
      377
    ],
    "source": "235605_ch20"
  },
  {
    "id": 596,
    "question": "You are designing a security strategy for a cloud-based application. You want to make it simple for other administrators to grant permissions without complexity. Which security strategy should you implement?",
    "choice_a": "TACACS+",
    "choice_b": "PKI",
    "choice_c": "RBAC",
    "choice_d": "RADIUS",
    "correct_answer": "C",
    "explanation": "Role-based access control (RBAC) is a strategy where you grant roles to users that contain the various permissions. Another admin simply needs to place the user into the role to grant permissions. Terminal Access Controller Access-Control System + (TACACS+) and Remote Authentication Dial-In User Service (RADIUS) are authentication/authorization servers used for wired and wireless access. Public key infrastructure (PKI) is a system that is used for encryption and signing.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      376,
      377,
      370,
      374,
      373
    ],
    "source": "235605_ch20"
  },
  {
    "id": 597,
    "question": "Which protocol uses public/private keys for encryption?",
    "choice_a": "AIA",
    "choice_b": "TLS",
    "choice_c": "CRL",
    "choice_d": "IAM",
    "correct_answer": "B",
    "explanation": "The Transport Layer Security (TLS) protocol uses public/private key pairs for encryption. The Authority Information Access (AIA) defines how the client can obtain the public certificate for a presented certificate. The certificate revocation list (CRL) contains a location to check to make sure that a certificate has not been revoked. Identity and access management (IAM) is a security framework for creating users and granting permissions.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      368,
      367,
      369,
      371,
      393
    ],
    "source": "235605_ch20"
  },
  {
    "id": 598,
    "question": "Which of the following is <i>not</i> a technology-based attack?",
    "choice_a": "DoS",
    "choice_b": "Rogue DHCP",
    "choice_c": "Shoulder surfing",
    "choice_d": "Malware",
    "correct_answer": "C",
    "explanation": "Shoulder surfing is not a technology-based attack. It is a social engineering attack. Denial of service (DoS), rogue DHCP, and malware are all technology-based attacks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      390,
      388,
      382,
      385,
      387
    ],
    "source": "235605_ch21"
  },
  {
    "id": 599,
    "question": "A command-and-control server is a part of which of the following attacks?",
    "choice_a": "DDoS",
    "choice_b": "Password attacks",
    "choice_c": "Shoulder surfing",
    "choice_d": "Malware",
    "correct_answer": "A",
    "explanation": "The command-and-control server is used to control a botnet, which is part of a distributed denial-of-service (DDoS) attack. All other answers are incorrect.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      382,
      387,
      391,
      365,
      384
    ],
    "source": "235605_ch21"
  },
  {
    "id": 600,
    "question": "Which attack involves the attacker impersonating both sides of a conversation between two hosts?",
    "choice_a": "On-path attack",
    "choice_b": "Deauthentication",
    "choice_c": "DoS",
    "choice_d": "Spoofing",
    "correct_answer": "A",
    "explanation": "An on-path attack, also known as a man-in-the-middle (MiTM) attack, allows the attacker to impersonate both parties involved in a network conversation. A deauthentication attack is a method of deauthenticating all of the wireless users in an attempt to hijack the access point. A denial-of-service (DoS) attack attempts to run a service out of resources, thereby denying valid service requests. Spoofing is the act of impersonating a user or computer.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      383,
      405,
      384,
      385,
      388
    ],
    "source": "235605_ch21"
  },
  {
    "id": 601,
    "question": "Which type of attack will attempt to configure hosts with a malicious default gateway?",
    "choice_a": "DoS",
    "choice_b": "VLAN hopping",
    "choice_c": "Deauthentication",
    "choice_d": "Rogue DHCP",
    "correct_answer": "D",
    "explanation": "A rogue DHCP is an attack in which another DHCP serves out IP addresses along with a malicious default gateway. User traffic is then redirected through the malicious gateway in an attempt to steal information. A denial-of-service (DoS) attack is an attempt to deny legitimate service requests, by overutilizing resources. VLAN hopping is an attack in which malicious traffic is double-tagged in an attempt to hop to another VLAN. Deauthentication is an attack that attempts to deauthenticate 802.11 traffic and hijack a wireless SSID.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      385,
      382,
      384,
      405,
      383
    ],
    "source": "235605_ch21"
  },
  {
    "id": 602,
    "question": "In which of the following does the attacker (and his bots) send a UDP packet to vulnerable NTP servers that requests that a large amount of data (megabytes worth of traffic) be sent to the DDoS\u2019s target IP address?",
    "choice_a": "Distributed",
    "choice_b": "NTP amplification",
    "choice_c": "Reflective",
    "choice_d": "DNS amplification",
    "correct_answer": "B",
    "explanation": "An NTP amplification attack is carried out by sending a small UDP packet to a vulnerable NTP server. The server then sends a large amount of data to the victim, amplifying the attack. A distributed denial-of-service (DDoS) attack happens when many hosts attack a central host. A reflective attack happens when the threat actor requests data from a third party with a return address to the victim. DNS amplification attacks are similar in design to NTP amplification attacks, except they use a different protocol.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      382,
      405,
      383,
      384,
      364
    ],
    "source": "235605_ch21"
  },
  {
    "id": 603,
    "question": "Which of the following was previously known as a man-in-the-middle attack?",
    "choice_a": "VLAN hopping",
    "choice_b": "On-path attack",
    "choice_c": "DoS attack",
    "choice_d": "Deauthentication attack",
    "correct_answer": "B",
    "explanation": "A man-in-the-middle attack (also known as an on-path attack) happens when someone intercepts packets intended for one computer and reads the data. A VLAN hopping attack happens when frames are double tagged in an effort to hop VLANs. A denial-of-service (DoS) attack happens when a threat actor denies service to other users by attacking the intended victim. A deauthentication attack is carried out by sending deauthentication frames to wireless clients to disassociate them with the SSID they are connected to.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      383,
      405,
      382,
      385,
      384
    ],
    "source": "235605_ch21"
  },
  {
    "id": 604,
    "question": "Double tagging is a part of which of the following attacks?",
    "choice_a": "VLAN hopping",
    "choice_b": "On-path attack",
    "choice_c": "DDoS",
    "choice_d": "Malware",
    "correct_answer": "A",
    "explanation": "The threat actor can attack a VLAN they are not permitted to by a process called double tagging; this attack is called VLAN hopping. A man-in-the-middle attack (also known as an on-path attack) happens when someone intercepts packets intended for one computer and reads the data. A distributed denial-of-service (DDoS) attack is comprised of many hosts that attack a central victim. Malware is a generic term used to describe a number of infections, such as ransomware, Trojans, and key loggers, just to mention a few.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      384,
      405,
      395,
      363,
      364
    ],
    "source": "235605_ch21"
  },
  {
    "id": 605,
    "question": "Which of the following is the process of adopting another system\u2019s MAC address for the purpose of receiving data meant for that system?",
    "choice_a": "Rogue DHCP",
    "choice_b": "ARP spoofing",
    "choice_c": "IP spoofing",
    "choice_d": "DNS spoofing",
    "correct_answer": "B",
    "explanation": "ARP spoofing is the process of adopting another system\u2019s MAC address for the purpose of receiving data meant for that system. A rogue DHCP attack happens when a threat actor introduces a DHCP server to the network that populates the threat actor\u2019s IP address. IP spoofing is an attack when a threat actor imposters a legitimate IP address. DNS spoofing is an attack when the DNS answers are spoofed coming from the threat actor.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      384,
      405,
      382,
      383,
      385
    ],
    "source": "235605_ch21"
  },
  {
    "id": 606,
    "question": "Which of the following is connected to your wired infrastructure without your knowledge?",
    "choice_a": "Rogue AP",
    "choice_b": "Command-and-control server",
    "choice_c": "Malware",
    "choice_d": "Botnet",
    "correct_answer": "A",
    "explanation": "Rogue access points are access points (APs) that have been connected to your wired infrastructure without your knowledge. The rogue may have been placed there by a determined hacker who snuck into your facility and put it in an out-of-the-way location or, more innocently, by an employee who just wants wireless access and doesn\u2019t get just how dangerous doing this is. Command-and-control servers are used to control botnets. Malware is an infection that has malicious intent of the network or user. A botnet is a group of computers controlled by a command-and-control server for malicious purposes.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      385,
      397,
      395,
      389,
      392
    ],
    "source": "235605_ch21"
  },
  {
    "id": 607,
    "question": "Which of the following uses the same SSID as your AP?",
    "choice_a": "Rogue AP",
    "choice_b": "Rogue DHCP",
    "choice_c": "Evil twin",
    "choice_d": "DNS poisoning",
    "correct_answer": "C",
    "explanation": "This ugly trick is achieved by placing their AP on a different channel from your legitimate APs and then setting its SSID in accordance with your SSID. A rogue access point (AP) is wireless equipment that is connected to your network without your permission or knowledge. A rogue DHCP is used by a threat actor to populate malicious IP addresses to DHCP clients. DNS poisoning is an attack in which the victim\u2019s DNS cache is attacked with malicious answers.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      385,
      405,
      383,
      384,
      400
    ],
    "source": "235605_ch21"
  },
  {
    "id": 608,
    "question": "What attack vector can be used for an on-path attack?",
    "choice_a": "DHCP",
    "choice_b": "DNS",
    "choice_c": "Wireless",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "Any service that allows the user to create a connection or access to information can be used as an attack vector. In the case of DHCP, the attacker will set the gateway to their IP address. In the case of DNS, the attacker could spoof a request to redirect the traffic. In the case of wireless, the attacker can spoof the secure set identifier (SSID).",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      383,
      385,
      384,
      405,
      392
    ],
    "source": "235605_ch21"
  },
  {
    "id": 609,
    "question": "Which attack can be used on a native VLAN?",
    "choice_a": "Double tagging",
    "choice_b": "VLAN traversal",
    "choice_c": "Trunk popping",
    "choice_d": "Denial of service",
    "correct_answer": "A",
    "explanation": "Double tagging is an attack that can be used against the native VLAN. The attacker will tag the native VLAN on a frame and then tag another inside that frame for the VLAN that the attacker intends to compromise. When the switch receives the first frame, it removes the default VLAN tag and forwards it to other switches via a trunk port. When the other switch receives the frame with the second VLAN tag, it forwards it to the VLAN upon which the attacker is targeting the attack. VLAN traversal is not an attack; it is a term to describe a VLAN traversing a trunk link between two switches. Trunk popping is not a valid attack; it is not a term used in networking, and therefore, it is an invalid answer. A denial-of-service (DoS) attack is an attack in which an attempt to exhaust a service\u2019s resources is launched to knock the service offline.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      384,
      405,
      395,
      382,
      383
    ],
    "source": "235605_ch21"
  },
  {
    "id": 610,
    "question": "Which form of social engineering is nothing more than looking over someone\u2019s shoulder while they enter or view sensitive information?",
    "choice_a": "Shoulder surfing",
    "choice_b": "Phishing",
    "choice_c": "Tailgating",
    "choice_d": "Whaling",
    "correct_answer": "A",
    "explanation": "Shoulder surfing involves looking over someone\u2019s shoulder as they enter information. Phishing is the act of attempting to steal credentials by sending an email that takes the recipient to a fraudulent login. Tailgating is the act of following a person through an access control point using their credentials. Whaling is a form of phishing that targets high-profile individuals.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      390,
      388,
      391,
      389,
      363
    ],
    "source": "235605_ch21"
  },
  {
    "id": 611,
    "question": "You need to protect your users from Trojans, viruses, and phishing emails. What should you implement?",
    "choice_a": "Multifactor authentication",
    "choice_b": "Software firewalls",
    "choice_c": "Antimalware",
    "choice_d": "Antivirus",
    "correct_answer": "C",
    "explanation": "Antimalware covers a wide array of security threats to users, including Trojans, viruses, and phishing emails. Multifactor authentication combines two or more single-factor authentication methods to create very secure authentication for users. Software firewalls will not prevent threats such as Trojans, viruses, and phishing emails. Antivirus software protects you only from viruses and Trojans, not phishing emails.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      387,
      388,
      392,
      363,
      381
    ],
    "source": "235605_ch21"
  },
  {
    "id": 612,
    "question": "What can you use to protect against spoofing of internal IP addresses on the perimeter of your network?",
    "choice_a": "Access control lists",
    "choice_b": "Intrusion detection systems",
    "choice_c": "Transport Layer Security",
    "choice_d": "Host intrusion detection systems",
    "correct_answer": "A",
    "explanation": "Access control lists (ACLs) are an effective way to mitigate spoofing of internal IPs from outside the trusted network. ACLs are used to control traffic by allowing, denying, or logging traffic depending on specific conditions. An intrusion detection system (IDS) can be used to notify you if it detects an attack, but it will not prevent an attack. Transport Layer Security (TLS) communications offer both encryption and authentication of the data via certificate signing. This would prevent tampering of the data end to end, but it will not prevent spoofing. A host intrusion detection system (HIDS) is an application that runs on a host to detect intrusions. An HIDS is similar to an IDS, but it is all software-based and resides on the host it is to protect.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      394,
      395,
      383,
      401,
      396
    ],
    "source": "235605_ch21"
  },
  {
    "id": 613,
    "question": "You are implementing a public guest wireless network and require that users accept an acceptable use policy (AUP). What should you implement to accomplish the goal?",
    "choice_a": "ACLs",
    "choice_b": "MAC filtering",
    "choice_c": "Captive portal",
    "choice_d": "802.1X",
    "correct_answer": "C",
    "explanation": "A captive portal will capture the users\u2019 first web page request and redirect them to either a login page or an AUP. Access control lists (ACLs) and MAC filtering restrict specific traffic. The 802.1X protocol is used to authenticate users and devices to control a layer 2 switchport.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      400,
      397,
      398,
      394,
      370
    ],
    "source": "235605_ch21"
  },
  {
    "id": 614,
    "question": "You are implementing a wireless network and need to make sure that only hosts that have up-to-date antivirus protection can join. Which technology should you implement?",
    "choice_a": "NAC",
    "choice_b": "802.1X",
    "choice_c": "EAP-TLS",
    "choice_d": "ACLs",
    "correct_answer": "A",
    "explanation": "Network access control (NAC) is used in conjunction with 802.1X and can restrict clients if specific security policies are not met, such as current antivirus and software updates. The 802.1X protocol is used to authenticate users and devices to control a layer 2 switchport. EAP-TLS is a protocol used to authenticate users and computers. Access control lists (ACLs) are used to restrict specific traffic.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      397,
      394,
      398,
      400,
      370
    ],
    "source": "235605_ch21"
  },
  {
    "id": 615,
    "question": "Which statement is correct about applying ACLs to an interface?",
    "choice_a": "An access control list can be applied in only one direction.",
    "choice_b": "An access control list can be applied only to a single protocol.",
    "choice_c": "An access control list can be applied only to a single port.",
    "choice_d": "All of the above.",
    "correct_answer": "D",
    "explanation": "Access lists can be applied to a port, to a protocol, and in a direction. For example, you could apply only one ACL to the interface Fa0/1 to the protocol IP in the inbound direction.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      394,
      395,
      396,
      397,
      393
    ],
    "source": "235605_ch21"
  },
  {
    "id": 616,
    "question": "As part of your training program, you\u2019re trying to educate users on the importance of security. You explain to them that not every attack depends on implementing advanced technological methods. Some attacks, you explain, take advantage of human shortcomings to gain access that should otherwise be denied. Which term do you use to describe attacks of this type?",
    "choice_a": "Social engineering",
    "choice_b": "IDS",
    "choice_c": "Perimeter security",
    "choice_d": "Biometrics",
    "correct_answer": "A",
    "explanation": "Social engineering uses the inherent trust in the human species, as opposed to technology, to gain access to your environment. IDSs are network-based systems that detect intrusions. Perimeter security describes physical security. Biometrics describes an authentication method based on human physical traits.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      388,
      391,
      392,
      370,
      363
    ],
    "source": "235605_ch21"
  },
  {
    "id": 617,
    "question": "You\u2019ve discovered that credentials to a specific application have been stolen. The application is accessed from only one computer on the network. Which type of attack is this most likely to be?",
    "choice_a": "On-path attack",
    "choice_b": "Zero day",
    "choice_c": "Denial of service (DoS)",
    "choice_d": "ARP spoofing",
    "correct_answer": "A",
    "explanation": "An on-path attack intercepts data and then sends the information to the server as if nothing were wrong while collecting the information. Zero-day attacks are attacks in which a developer has not properly patched a hole yet and is unaware of the hole. A denial-of-service (DoS) attack is used to disrupt legitimate requests from being answered. An ARP spoofing attack occurs when the threat actor spoofs a legitimate MAC address.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      383,
      384,
      386,
      388,
      391
    ],
    "source": "235605_ch21"
  },
  {
    "id": 618,
    "question": "At which of the following layers of the Open Systems Interconnection (OSI) model do the protocols on a typical local area network (LAN) use media access control (MAC) addresses to identify other computers on the network?",
    "choice_a": "Physical",
    "choice_b": "Data link",
    "choice_c": "Network",
    "choice_d": "Transport",
    "correct_answer": "B",
    "explanation": "The Ethernet (or IEEE 802.3) protocol at the Data link layer uses MAC addresses to identify computers on the local network. MAC addresses are coded into the firmware of physical network interface adapters by the manufacturer. The Physical layer deals with signals and is not involved in addressing. The IP protocol at the Network layer has its own addressing system. The Transport layer protocols are not involved in addressing.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      42,
      17,
      43,
      36
    ],
    "source": "9781394239306"
  },
  {
    "id": 619,
    "question": "Which of the following organizations developed the Open Systems Interconnection (OSI) model?",
    "choice_a": "International Telecommunication Union (ITU-T)",
    "choice_b": "Comit\u00e9 Consultatif International T\u00e9l\u00e9graphique et T\u00e9l\u00e9phonique (CCITT)",
    "choice_c": "American National Standards Institute (ANSI)",
    "choice_d": "Institute of Electrical and Electronics Engineers (IEEE)",
    "correct_answer": "E",
    "explanation": "ISO developed and published the OSI model to serve as a conceptual model for software and hardware developers. The ITU-T, formerly known as the CCITT, coordinates the development and advancement of international telecommunication networks and services. ANSI is a private organization that administers and coordinates a United States\u2013based standardization and conformity assessment system. The IEEE publishes standards that define Data link and Physical layer standards. These standards are referred to collectively as the 802 series.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      17,
      72,
      81,
      82,
      18
    ],
    "source": "9781394239306",
    "choice_e": "International Organization for Standardization (ISO)"
  },
  {
    "id": 620,
    "question": "Which layer of the Open Systems Interconnection (OSI) model is responsible for the logical addressing of end systems and the routing of datagrams on a network?",
    "choice_a": "Physical",
    "choice_b": "Data link",
    "choice_c": "Network",
    "choice_d": "Transport",
    "correct_answer": "C",
    "explanation": "Network layer protocols (such as IP) contain headers that specify logical addresses for end system communication and route datagrams across a network. The Physical layer defines standards for physical and mechanical characteristics of a network. The Data link layer uses media access control (MAC) or hardware addresses, not logical addresses. The Transport layer uses port numbers, not logical addresses. Session layer protocols create and maintain a dialogue between end systems. Presentation layer protocols are responsible for the formatting, translation, and presentation of information. The Application layer provides an entry point for applications to access the protocol stack and prepare information for transmission across a network.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      21,
      17,
      79,
      22,
      81
    ],
    "source": "9781394239306",
    "choice_e": "Session",
    "choice_f": "Presentation",
    "choice_g": "Application"
  },
  {
    "id": 621,
    "question": "On a TCP/IP network, which layers of the Open Systems Interconnection (OSI) model contain protocols that are responsible for encapsulating the data generated by an application, creating the payload for a packet that will be transmitted over a network? (Choose all that apply.)",
    "choice_a": "Physical",
    "choice_b": "Data link",
    "choice_c": "Network",
    "choice_d": "Transport",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Before the payload data generated by an application can be transmitted over a TCP/IP network, the system must encapsulate it by applying protocol headers and footers at three layers of the OSI model. The Data link layer applies a header and footer to create an Ethernet frame. The Network layer applies a header to create an IP datagram. The Transport layer applies a TCP or UDP header to create a segment or datagram. The other model layers are involved in the payload transmission process, but they do not encapsulate the payload.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      82,
      81,
      23,
      19,
      22
    ],
    "source": "9781394239306",
    "choice_e": "Session",
    "choice_f": "Presentation",
    "choice_g": "Application"
  },
  {
    "id": 622,
    "question": "Which layer of the Open Systems Interconnection (OSI) model is responsible for translating and formatting information?",
    "choice_a": "Physical",
    "choice_b": "Data link",
    "choice_c": "Network",
    "choice_d": "Transport",
    "correct_answer": "F",
    "explanation": "The Presentation layer implements functions that provide formatting, translation, and presentation of information. No other layers of the OSI model translate and format application data.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      17,
      82,
      23,
      81
    ],
    "source": "9781394239306",
    "choice_e": "Session",
    "choice_f": "Presentation",
    "choice_g": "Application"
  },
  {
    "id": 623,
    "question": "Which of the following devices typically operates at the Network layer of the Open Systems Interconnection (OSI) model?",
    "choice_a": "Proxy server",
    "choice_b": "Network interface adapter",
    "choice_c": "Hub",
    "choice_d": "Router",
    "correct_answer": "D",
    "explanation": "A router connects networks at the Network layer of the OSI model. Proxy servers operate at the Application layer. Network interface adapters operate at both the Data link and the Physical layers. Hubs are Physical layer devices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      21,
      17,
      2,
      81,
      23
    ],
    "source": "9781394239306"
  },
  {
    "id": 624,
    "question": "Which layer of the Open Systems Interconnection (OSI) model provides an entrance point to the protocol stack for applications?",
    "choice_a": "Physical",
    "choice_b": "Data link",
    "choice_c": "Network",
    "choice_d": "Transport",
    "correct_answer": "G",
    "explanation": "The Application layer provides an entry point for applications to access the protocol stack and prepare information for transmission across a network. All other layers of the OSI model reside below this layer and rely on this entry point.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      17,
      19,
      21,
      82
    ],
    "source": "9781394239306",
    "choice_e": "Session",
    "choice_f": "Presentation",
    "choice_g": "Application"
  },
  {
    "id": 625,
    "question": "Which layer of the Open Systems Interconnection (OSI) model is responsible for dialogue control between two communicating end systems?",
    "choice_a": "Physical",
    "choice_b": "Data link",
    "choice_c": "Network",
    "choice_d": "Transport",
    "correct_answer": "E",
    "explanation": "The Session layer is responsible for creating and maintaining a dialogue between end systems. This dialogue can be a two-way alternate dialogue that requires end systems to take turns transmitting, or it can be a two-way simultaneous dialogue in which either end system can transmit at will. No other layers of the OSI model perform dialogue control between communicating end systems.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      17,
      82,
      81,
      19
    ],
    "source": "9781394239306",
    "choice_e": "Session",
    "choice_f": "Presentation",
    "choice_g": "Application"
  },
  {
    "id": 626,
    "question": "Some switches can perform functions associated with two layers of the Open Systems Interconnection (OSI) model. Which two of the following layers are often associated with network switching? (Choose all that apply.)",
    "choice_a": "Physical",
    "choice_b": "Data link",
    "choice_c": "Network",
    "choice_d": "Transport",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The primary function of a switch is to process packets based on their media access control (MAC) addresses, which makes it a Data link layer device. However, many switches can also perform routing functions based on IP addresses, which operate at the Network layer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      21,
      17,
      81,
      37
    ],
    "source": "9781394239306",
    "choice_e": "Session",
    "choice_f": "Presentation",
    "choice_g": "Application"
  },
  {
    "id": 627,
    "question": "At which layer of the Open Systems Interconnection (OSI) model are there TCP/IP protocols that can provide either connectionless or connection-oriented services to applications?",
    "choice_a": "Physical",
    "choice_b": "Data link",
    "choice_c": "Network",
    "choice_d": "Transport",
    "correct_answer": "D",
    "explanation": "There are two types of Transport layer protocols: connection-oriented and connectionless. Connection-oriented protocols guarantee the delivery of data from source to destination by creating a connection between the sender and the receiver before any data is transmitted. Connectionless protocols do not require a connection between end systems in order to pass data. The Physical layer does not use connectionless or connection-oriented protocols; it defines standards for transmitting and receiving information over a network. The Data link layer provides physical addressing and final packaging of data for transmission. The Network layer is responsible for logical addressing and routing. The Session layer is responsible for creating and maintaining a dialogue between end systems. The Presentation layer is responsible for the formatting, translation, and presentation of information. The Application layer provides an entry point for applications to access the protocol stack and prepare information for transmission across a network.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      19,
      77,
      17,
      83,
      81
    ],
    "source": "9781394239306",
    "choice_e": "Session",
    "choice_f": "Presentation",
    "choice_g": "Application"
  },
  {
    "id": 628,
    "question": "Which of the following layers of the Open Systems Interconnection (OSI) model typically have dedicated physical hardware devices associated with them? (Choose all that apply.)",
    "choice_a": "Physical",
    "choice_b": "Data link",
    "choice_c": "Network",
    "choice_d": "Transport",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "The Physical layer of the OSI model is associated with hubs, cables, and network interface adapters. The Data link layer is associated with bridges and switches. The Network layer is associated with routers. The Transport, Session, Presentation, and Application layers are typically not associated with dedicated hardware devices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      17,
      21,
      44,
      40
    ],
    "source": "9781394239306",
    "choice_e": "Session",
    "choice_f": "Presentation",
    "choice_g": "Application"
  },
  {
    "id": 629,
    "question": "At which layer of the Open Systems Interconnection (OSI) model is there a protocol that adds both a header and a footer to the information that is passed down from an upper layer, thus creating a frame?",
    "choice_a": "Physical",
    "choice_b": "Data link",
    "choice_c": "Network",
    "choice_d": "Transport",
    "correct_answer": "B",
    "explanation": "The only layer with a protocol (such as Ethernet) that adds both a header and a footer is the Data link layer. The process of adding the headers and footers is known as data encapsulation. All other protocol layers that encapsulate data add just a header.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      81,
      82,
      22,
      43,
      17
    ],
    "source": "9781394239306",
    "choice_e": "Session",
    "choice_f": "Presentation",
    "choice_g": "Application"
  },
  {
    "id": 630,
    "question": "Identify the layer of the Open Systems Interconnection (OSI) model that controls the addressing, transmission, and reception of Ethernet frames, and also identify the media access control method that Ethernet uses.",
    "choice_a": "Physical layer: Carrier Sense Multiple Access with Collision Detection (CSMA/CD)",
    "choice_b": "Physical layer: Carrier Sense Multiple Access with Collision Avoidance (CSMA/CA)",
    "choice_c": "Data link layer: CSMA/CD",
    "choice_d": "Data link layer: CSMA/CA",
    "correct_answer": "C",
    "explanation": "The Ethernet protocol that handles the addressing, transmission, and reception of frames operates at the Data link layer. Each frame includes hardware addresses that identify the sending and receiving systems on the local network. Ethernet uses the CSMA/CD media access control method. Physical layer specifications include the transmission of signals in the form of electrical or light pulses to represent binary code, not frames. CSMA/CA is a Data link layer media access control method used by wireless LAN protocols, but not Ethernet.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      38,
      43,
      81,
      40
    ],
    "source": "9781394239306"
  },
  {
    "id": 631,
    "question": "At which layer of the OSI model do you find the protocol responsible for the delivery of data to its ultimate destination on an internetwork?",
    "choice_a": "Data link",
    "choice_b": "Network",
    "choice_c": "Session",
    "choice_d": "Application",
    "correct_answer": "B",
    "explanation": "On a TCP/IP network, the Internet Protocol (IP) at the Network layer is the protocol responsible for the delivery of data to its final destination. Data link layer protocols are only concerned with communication between devices on a local area network (LAN) or between two points connected by a wide area network (WAN) link. The Session and Application layers are not involved in the actual delivery of data.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      21,
      17,
      79,
      22,
      19
    ],
    "source": "9781394239306"
  },
  {
    "id": 632,
    "question": "Which of the following is not a protocol operating at the Network layer of the OSI model?",
    "choice_a": "IP",
    "choice_b": "ICMP",
    "choice_c": "IGMP",
    "choice_d": "IMAP",
    "correct_answer": "D",
    "explanation": "Internet Protocol (IP), Internet Control Message Protocol (ICMP), and Internet Group Management Protocol (IGMP) are all Network layer protocols. Internet Message Access Protocol (IMAP) is a mail protocol that operates at the Application layer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      79,
      18,
      72,
      81,
      82
    ],
    "source": "9781394239306"
  },
  {
    "id": 633,
    "question": "Ed is a software developer who has been given the task of creating an application that requires guaranteed delivery of information between end systems. At which layer of the Open Systems Interconnection (OSI) model does the protocol that provides the guaranteed delivery run, and what type of protocol must Ed use?",
    "choice_a": "Data link layer; connectionless",
    "choice_b": "Network layer; connection-oriented",
    "choice_c": "Transport layer; connection-oriented",
    "choice_d": "Application layer; connectionless",
    "correct_answer": "C",
    "explanation": "A connection-oriented Transport layer protocol, such as Transmission Control Protocol (TCP), provides guaranteed delivery of data for upper layer applications. Connectionless protocols do not guarantee delivery of information and therefore are not a good choice. Guaranteed delivery of information between end systems is generally not a function of the Data link, Network, or Application layer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      77,
      17,
      20,
      83
    ],
    "source": "9781394239306"
  },
  {
    "id": 634,
    "question": "Alice is a network administrator designing a new local area network (LAN). She needs to determine the type of cabling and the network topology to implement. Which layers of the Open Systems Interconnection (OSI) model apply to cabling and topology elements?",
    "choice_a": "Physical and Data link layers",
    "choice_b": "Data link and Network layers",
    "choice_c": "Network and Transport layers",
    "choice_d": "Transport and Application layers",
    "correct_answer": "A",
    "explanation": "The Physical layer defines the mechanical and electrical characteristics of the cables used to build a network. The Data link layer defines specific network (LAN or WAN) topologies and their characteristics. The Physical layer standard that Alice will implement depends on the Data link layer protocol she selects. The Network, Transport, and Application layers are not concerned with cables and topologies.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      17,
      7,
      44,
      10
    ],
    "source": "9781394239306"
  },
  {
    "id": 635,
    "question": "Which layers of the Open Systems Interconnection (OSI) model do not have protocols in the TCP/IP suite exclusively dedicated to them? (Choose all that apply.)",
    "choice_a": "Physical",
    "choice_b": "Data link",
    "choice_c": "Network",
    "choice_d": "Transport",
    "correct_answer": [
      "E",
      "F"
    ],
    "explanation": "In the TCP/IP suite, the functions of the Session layer are primarily implemented in the Transport layer protocols: Transmission Control Protocol (TCP) and User Datagram Protocol (UDP). The Presentation layer functions are often implemented in Application layer protocols, although some functions, such as encryption, can also be performed by Transport or Network layer protocols.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      17,
      72,
      77,
      19
    ],
    "source": "9781394239306",
    "choice_e": "Session",
    "choice_f": "Presentation",
    "choice_g": "Application"
  },
  {
    "id": 636,
    "question": "The protocols at which layer of the Open Systems Interconnection (OSI) model use port numbers to identify the applications that are the source and the destination of the data in the packets?",
    "choice_a": "Application",
    "choice_b": "Presentation",
    "choice_c": "Transport",
    "choice_d": "Network",
    "correct_answer": "C",
    "explanation": "Transport layer protocols, such as Transmission Control Protocol (TCP) and User Datagram Protocol (UDP), have header fields that contain the port numbers of the applications that generated the data in the packet, and which will receive it. The Application, Presentation, and Network layers do not use port numbers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      83,
      19,
      77,
      17,
      78
    ],
    "source": "9781394239306"
  },
  {
    "id": 637,
    "question": "Which of the following is a correct listing of the Open Systems Interconnection (OSI) model layers, in order, from top to bottom?",
    "choice_a": "Physical, Data link, Transport, Network, Session, Presentation, Application",
    "choice_b": "Application, Session, Presentation, Transport, Network, Data link, physical",
    "choice_c": "Presentation, Application, Transport, Session, Network, Physical, Data link",
    "choice_d": "Session, Application, Presentation, Transport, Data link, Network, Physical",
    "correct_answer": "E",
    "explanation": "The correct order of the OSI model layers, from top to bottom, is Application, Presentation, Session, Transport, Network, Data link, Physical.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      17,
      18,
      82,
      81,
      23
    ],
    "source": "9781394239306",
    "choice_e": "Application, Presentation, Session, Transport, Network, Data link, Physical"
  },
  {
    "id": 638,
    "question": "At which of the Open Systems Interconnection (OSI) model layers do switches and bridges perform their basic functions?",
    "choice_a": "Physical",
    "choice_b": "Data link",
    "choice_c": "Network",
    "choice_d": "Transport",
    "correct_answer": "B",
    "explanation": "Switches and bridges are involved in local area network (LAN) communications only and therefore primarily at the Data link layer. They are not primarily associated with the Physical, Network, or Transport layers, although some switches include Network layer routing capabilities.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      17,
      37,
      40,
      81
    ],
    "source": "9781394239306"
  },
  {
    "id": 639,
    "question": "On a TCP/IP network, flow control is a function implemented in protocols operating at which layer of the Open Systems Interconnection (OSI) model?",
    "choice_a": "Presentation",
    "choice_b": "Session",
    "choice_c": "Transport",
    "choice_d": "Network",
    "correct_answer": "C",
    "explanation": "Flow control is a process that adjusts the transmission rate of a protocol based on the capability of the receiver. If the receiving system becomes overwhelmed by incoming data, the sender dynamically reduces the transmission rate. In the TCP/IP protocol suite, Transmission Control Protocol (TCP) is responsible for implementing flow control. TCP runs at the Transport layer. None of the other layers listed have TCP/IP protocols that provide flow control.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      77,
      20,
      72,
      81
    ],
    "source": "9781394239306"
  },
  {
    "id": 640,
    "question": "Which layer of the Open Systems Interconnection (OSI) model defines the medium, network interfaces, connecting hardware, and signaling methods used on a network?",
    "choice_a": "Physical",
    "choice_b": "Data link",
    "choice_c": "Network",
    "choice_d": "Transport",
    "correct_answer": "A",
    "explanation": "The Physical layer of the OSI model defines the standards for the physical and mechanical characteristics of a network, such as cabling (copper and fiber), connecting hardware (hubs and switches), and signaling methods (analog and digital). None of the other layers are involved in the mechanical characteristics of the network.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      17,
      22,
      44,
      82,
      26
    ],
    "source": "9781394239306",
    "choice_e": "Session",
    "choice_f": "Presentation",
    "choice_g": "Application"
  },
  {
    "id": 641,
    "question": "Which of the OSI model layers is responsible for syntax translation and compression or encryption?",
    "choice_a": "Data link",
    "choice_b": "Network",
    "choice_c": "Session",
    "choice_d": "Presentation",
    "correct_answer": "D",
    "explanation": "The Presentation layer provides a syntax translation service that enables two computers to communicate, despite their use of different bit-encoding methods. This translation service also enables systems using compressed or encrypted data to communicate with each other.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      17,
      23,
      82,
      81
    ],
    "source": "9781394239306",
    "choice_e": "Application"
  },
  {
    "id": 642,
    "question": "Which layer of the Open Systems Interconnection (OSI) model is responsible for transmitting signals over the network medium?",
    "choice_a": "Physical",
    "choice_b": "Data link",
    "choice_c": "Network",
    "choice_d": "Transport",
    "correct_answer": "A",
    "explanation": "The Physical layer of the OSI model defines the functions specific to the network medium and the transmission and reception of signals. All of the other layers are software components that do not physically send or receive signals.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      17,
      82,
      81,
      44
    ],
    "source": "9781394239306",
    "choice_e": "Session",
    "choice_f": "Presentation",
    "choice_g": "Application"
  },
  {
    "id": 643,
    "question": "Specify the layer of the Open Systems Interconnection (OSI) model at which the Internet Protocol (IP) operates and whether it is connection-oriented or connectionless.",
    "choice_a": "Network; connection-oriented",
    "choice_b": "Network; connectionless",
    "choice_c": "Transport; connection-oriented",
    "choice_d": "Transport; connectionless",
    "correct_answer": "B",
    "explanation": "IP is a connectionless protocol that operates at the Network layer of the OSI model. There are no connection-oriented protocols at this layer. The protocols at the Transport layer include Transmission Control Protocol (TCP), which is connection-oriented, and User Datagram Protocol (UDP), which is connectionless.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      79,
      21,
      17,
      77,
      82
    ],
    "source": "9781394239306"
  },
  {
    "id": 644,
    "question": "An Ethernet network interface adapter provides functions that span which two layers of the Open Systems Interconnection (OSI) model?",
    "choice_a": "Physical and Data link",
    "choice_b": "Data link and Network",
    "choice_c": "Network and Transport",
    "choice_d": "Transport and Application",
    "correct_answer": "A",
    "explanation": "An Ethernet network interface adapter functions at the Data link layer by encapsulating Network layer data for transmission over the network. It provides Physical layer functions by providing the connection to the network medium and generating the appropriate signals for transmission. Network interface adapters do not operate at the Network, Transport, or Application layers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      44,
      43,
      17,
      82
    ],
    "source": "9781394239306"
  },
  {
    "id": 645,
    "question": "Which of the following protocols operate at the Application layer of the Open Systems Interconnection (OSI) model? (Choose all that apply.)",
    "choice_a": "HTTP",
    "choice_b": "SNMP",
    "choice_c": "ICMP",
    "choice_d": "IGMP",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Hypertext Transfer Protocol (HTTP) and Simple Network Management Protocol (SNMP) operate at the Application layer. Internet Control Message Protocol (ICMP) and Internet Group Management Protocol (IGMP) both operate at the Network layer. User Datagram Protocol (UDP) operates at the Transport layer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      81,
      82,
      79,
      72
    ],
    "source": "9781394239306",
    "choice_e": "UDP"
  },
  {
    "id": 646,
    "question": "Which layer of the Open Systems Interconnection (OSI) model would be responsible for converting a text file encoded using EBCDIC on the sending system into ASCII code, when required by the receiving system?",
    "choice_a": "Application",
    "choice_b": "Presentation",
    "choice_c": "Session",
    "choice_d": "Physical",
    "correct_answer": "B",
    "explanation": "The Presentation layer of the OSI model is responsible for translating different kinds of syntax, including text-encoding systems, such as EBCDIC and ASCII. The Application, Session, and Physical layers do not perform this function.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      18,
      17,
      82,
      23,
      81
    ],
    "source": "9781394239306"
  },
  {
    "id": 647,
    "question": "Which of the following protocols operates at the Network layer of the OSI model but does not encapsulate data generated by an upper layer protocol for transmission over the network?",
    "choice_a": "IP",
    "choice_b": "UDP",
    "choice_c": "ARP",
    "choice_d": "ICMP",
    "correct_answer": "D",
    "explanation": "Internet Control Message Protocol (ICMP) operates at the Network layer by sending operational and error messages. It does not encapsulate upper layer protocol data. Internet Protocol (IP) operates at the Network layer, but it does encapsulate Transport layer protocol data. Transmission Control Protocol (TCP) and User Datagram Protocol (UDP) are Transport layer protocols that encapsulate upper layer protocol data. Address Resolution Protocol (ARP) does not encapsulate upper layer protocol data, but it is a Data link layer protocol.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      79,
      81,
      82,
      23,
      21
    ],
    "source": "9781394239306",
    "choice_e": "TCP"
  },
  {
    "id": 648,
    "question": "Which of the following devices run exclusively at the Physical layer of the Open Systems Interconnection (OSI) model? (Choose all that apply.)",
    "choice_a": "Routers",
    "choice_b": "Repeaters",
    "choice_c": "Hubs",
    "choice_d": "Switches",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "A repeater is a Physical layer device that amplifies the signals entering it and transmits them again. A hub is a Physical layer device that propagates incoming signals out through all of its ports. Switches and routers have Physical layer elements but are primarily Data link and Network layer devices, respectively.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      37,
      81,
      2,
      44
    ],
    "source": "9781394239306"
  },
  {
    "id": 649,
    "question": "Which of the following devices enables two computers to communicate when they are using different protocols at each layer of the Open Systems Interconnection (OSI) reference model?",
    "choice_a": "A router",
    "choice_b": "A hub",
    "choice_c": "A switch",
    "choice_d": "A gateway",
    "correct_answer": "D",
    "explanation": "A gateway enables two devices using different protocols to communicate by performing translation and conversion services for them. Routers, hubs, and switches all require the same protocol at some of the OSI model layers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      17,
      287,
      82,
      81,
      18
    ],
    "source": "9781394239306"
  },
  {
    "id": 650,
    "question": "Which of the following best describes the function of a firewall?",
    "choice_a": "A device located between two networks that enables administrators to restrict incoming and outgoing traffic",
    "choice_b": "A device that connects two networks together, forwarding traffic between them as needed",
    "choice_c": "A device that enables Internet network clients with private IP addresses to access the Internet",
    "choice_d": "A device that caches Internet data for subsequent use by internal network clients",
    "correct_answer": "A",
    "explanation": "A firewall is a filter that can prevent dangerous traffic originating on one network from passing through to another network. A device that connects two networks together and forwards traffic between them is a router, not a firewall. A device that enables Internet network clients with private IP addresses to access the Internet is a description of a network address translation (NAT) router or a proxy server, not a firewall. A device that caches Internet data is a proxy server or caching engine, not a firewall.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      285,
      116,
      287,
      300,
      14
    ],
    "source": "9781394239306"
  },
  {
    "id": 651,
    "question": "Which of the following terms is used to describe the method by which a firewall examines the port numbers in Transport layer protocol headers?",
    "choice_a": "IP address filtering",
    "choice_b": "Service-dependent filtering",
    "choice_c": "Deep packet inspection (DPI)",
    "choice_d": "Next-generation firewall (NGFW)",
    "correct_answer": "B",
    "explanation": "Service-dependent filtering blocks traffic based on the port numbers specified in the Transport layer header fields. Because port numbers represent specific applications, you can use them to prevent traffic generated by these applications from reaching a network. IP address filtering operates at the Network layer. DPI scans the contents of packets, rather than their headers. NGFW defines a device with advanced protection capabilities; port number scanning is a basic firewall function.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      83,
      78,
      19,
      77,
      23
    ],
    "source": "9781394239306"
  },
  {
    "id": 652,
    "question": "Which of the following physical network devices can conceivably be implemented as software in a computer's operating system? (Choose all that apply.)",
    "choice_a": "Hub",
    "choice_b": "Switch",
    "choice_c": "Router",
    "choice_d": "Firewall",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Most operating systems are capable of functioning as routers or firewalls. To route traffic, the system must have two network connections. A software firewall can be part of a computer's routing functionality, or it can be a stand-alone firewall that protects only the local system. Computers cannot function as hubs or switches because multiple ports would be required, and standard network adapters do not implement those functions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      285,
      2,
      21,
      3,
      5
    ],
    "source": "9781394239306"
  },
  {
    "id": 653,
    "question": "Which of the following criteria does a firewall capable of service-dependent filtering use to block traffic?",
    "choice_a": "Hardware addresses",
    "choice_b": "Protocol identifiers",
    "choice_c": "IP addresses",
    "choice_d": "Port numbers",
    "correct_answer": "D",
    "explanation": "Service-dependent filtering blocks traffic based on the port numbers specified in the Transport layer header fields. Because port numbers represent specific applications, you can use them to prevent traffic generated by these applications from reaching a network. IP address filtering enables you to limit network access to specific computers; it is not service dependent. Filtering based on hardware addresses provides the same basic functionality as IP address filtering, but it is more difficult to spoof hardware addresses than IP addresses. Filtering by protocol identifier enables you to block all traffic using TCP or UDP; it is not service dependent.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      83,
      78,
      36,
      40,
      23
    ],
    "source": "9781394239306"
  },
  {
    "id": 654,
    "question": "Ralph is a freelance network consultant installing a three-node small business network. The computers are all in the same room and use wired Ethernet to connect to the switched ports of a multifunction device. The device also functions as a network address translation (NAT) router for a cable modem connection to the Internet. NAT provides a measure of security, but Ralph wants to be sure that the network is protected from unauthorized Internet traffic and attacks against open ports. Which of the following solutions would enable Ralph to accomplish this goal with the minimum cost to the client?",
    "choice_a": "Install a hardware firewall between the multifunction device and the cable modem.",
    "choice_b": "Install an intrusion prevention system (IPS) between the multifunction device and the cable modem.",
    "choice_c": "Install a personal firewall on each of the computers.",
    "choice_d": "Connect an intrusion detection system (IDS) to one of the switched ports in the multifunction device.",
    "correct_answer": "C",
    "explanation": "A personal firewall is an inexpensive way to protect an individual computer from Internet incursions. Installing a hardware firewall is a complex and expensive solution, not suitable for a small network. An IPS is a relatively expensive solution, suitable for larger networks. An IDS is also expensive, and connecting it to a switched port would not enable it to protect the other computers on the network. A port scanner is a device that performs scans on demand. It does not continuously monitor ports, and it does nothing to protect them.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      202,
      116,
      287,
      11,
      47
    ],
    "source": "9781394239306",
    "choice_e": "Use a port scanner to monitor the traffic entering the open ports on the computers."
  },
  {
    "id": 655,
    "question": "Which of the following statements about hubs and switches are true? (Choose all that apply.)",
    "choice_a": "Hubs operate only at the Physical layer, whereas switches operate only at the Network layer.",
    "choice_b": "All of the devices connected to a hub are part of a single collision domain, whereas each device connected to a switch has its own collision domain.",
    "choice_c": "There are switches available with Network layer functionality, but there are no hubs with that capability.",
    "choice_d": "Switches create a separate broadcast domain for each connected device, whereas hubs create a single broadcast domain for all of the connected devices.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Hubs operate at the Physical layer, and switches operate at the Data link layer. Hubs and switches both create a single broadcast domain for all of the connected devices. Switches create a separate collision domain for each connected device, whereas hubs create a single collision domain. There are switches (but not hubs) with Network layer (layer 3) functionality.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      37,
      22,
      2,
      38,
      39
    ],
    "source": "9781394239306"
  },
  {
    "id": 656,
    "question": "Which of the following devices perform essentially the same function? (Choose two.)",
    "choice_a": "Hubs",
    "choice_b": "Bridges",
    "choice_c": "Switches",
    "choice_d": "Routers",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "A switch is essentially a multiport bridge. Both switches and bridges process incoming packets by scanning their Data link layer hardware addresses and forwarding the packets out the port connected to the destination system. The primary difference between them is that switches have many ports, whereas bridges have only two. Hubs and routers are Physical layer and Network layer devices, respectively, and perform different functions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      2,
      22,
      37,
      17,
      21
    ],
    "source": "9781394239306"
  },
  {
    "id": 657,
    "question": "Which of the following switch types immediately forwards frames after looking at only the destination address?",
    "choice_a": "Cut-through",
    "choice_b": "Source route",
    "choice_c": "Store-and-forward",
    "choice_d": "Destination",
    "correct_answer": "A",
    "explanation": "Cut-through switches are fast, because they look at only the first 6 bytes (the destination media access control, or MAC, address) when forwarding a frame. They do not perform a cyclical redundancy check (CRC) on the entire frame's contents prior to forwarding it out a port leading to the destination. Source route is a bridging technique in which the source host, not the switch, determines the path a frame will take through a network to reach a destination. Store-and-forward switches take in the entire frame and verify its contents by performing a CRC calculation before forwarding it. There is no switch called a destination switch.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      43,
      22,
      37,
      81,
      82
    ],
    "source": "9781394239306"
  },
  {
    "id": 658,
    "question": "Which of the following is something that only a firewall capable of stateful packet inspection can do?",
    "choice_a": "Filter traffic-based port numbers",
    "choice_b": "Block traffic destined for specific IP addresses",
    "choice_c": "Scan Transport layer header fields for evidence of SYN floods",
    "choice_d": "Block all TCP traffic from entering a network",
    "correct_answer": "C",
    "explanation": "A firewall that supports stateful packet inspection examines other network and Transport layer header fields, looking for patterns that indicate damaging behaviors, such as IP spoofing, SYN floods, and teardrop attacks. Port number filtering is the most commonly used form of packet filtering; it is not the same as stateful packet inspection. Blocking traffic based on IP addresses prevents specific systems from accessing a network; stateful packet inspection is a much more complicated operation. Packet filtering based on protocol identifiers enables you to block TCP traffic; this is not stateful packet inspection.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      19,
      77,
      81,
      21,
      82
    ],
    "source": "9781394239306"
  },
  {
    "id": 659,
    "question": "Which of the following are methods typically used by intrusion detection systems (IDSs) to analyze incoming network traffic? (Choose all that apply.)",
    "choice_a": "Anomaly-based detection",
    "choice_b": "Behavior-based detection",
    "choice_c": "Signature-based detection",
    "choice_d": "Statistic-based detection",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "IDSs can use anomaly-based detection to identify deviations from a known baseline of trustworthiness, or signature-based detection to locate specific malicious byte or instruction sequences. Behavior-based and statistic-based detection are not typical IDS methods.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      202,
      72,
      295,
      205,
      101
    ],
    "source": "9781394239306"
  },
  {
    "id": 660,
    "question": "Which of the following is another term for a multiport bridge?",
    "choice_a": "Router",
    "choice_b": "Switch",
    "choice_c": "Hub",
    "choice_d": "Gateway",
    "correct_answer": "B",
    "explanation": "A traditional switch is a Data link layer device that essentially performs the function of a bridge for each device connected to one of its ports. It can therefore be described as a multiport bridge. Some switches include layer 3 functionality, but they still function as bridges. Routers, hubs, and gateways are devices that operate at the Network, Physical, and Application layers, respectively, so they cannot be described as bridges.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      2,
      22,
      14,
      13,
      81
    ],
    "source": "9781394239306"
  },
  {
    "id": 661,
    "question": "Which of the following statements about switches and routers are true? (Choose all that apply.)",
    "choice_a": "Routers operate at the Network layer, whereas switches operate at the Data link layer.",
    "choice_b": "All of the devices connected to a switch are part of a single broadcast domain, whereas the networks connected to a router form separate broadcast domains.",
    "choice_c": "Routers can communicate with each other and share information, but switches cannot.",
    "choice_d": "Switches forward packets based on their hardware addresses, whereas routers forward packets based on their IP addresses.",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "Routers are Network layer devices that do not forward broadcast messages, so they create separate broadcast domains for each network. Switches do forward broadcasts, forming a single broadcast domain. Routers and switches can communicate using dedicated protocols. As Data link layer devices, switches read only hardware addresses from packet frames; routers forward traffic based on the IP addresses in packets' IP headers.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      37,
      21,
      22,
      4,
      101
    ],
    "source": "9781394239306"
  },
  {
    "id": 662,
    "question": "Which of the following types of systems are frequently used to collect information from intrusion detection systems (IDSs)?",
    "choice_a": "SIEM",
    "choice_b": "NAS",
    "choice_c": "RADIUS",
    "choice_d": "VoIP",
    "correct_answer": "A",
    "explanation": "Security information and event management (SIEM) systems can function as a central clearinghouse for information gathered by IDSs and other security processes. Network-attached storage (NAS), Remote Authentication Dial-In User Service (RADIUS), and Voice over IP (VoIP) are not systems that collect IDS information.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      300,
      299,
      202,
      203,
      285
    ],
    "source": "9781394239306"
  },
  {
    "id": 663,
    "question": "Which of the following explains why splitting a large, switched Ethernet LAN into two LANs by adding a router can help to alleviate traffic congestion and improve performance? (Choose all that apply.)",
    "choice_a": "Adding a router reduces the amount of broadcast traffic on each of the two LANs.",
    "choice_b": "Adding a router reduces the amount of unicast traffic on each of the two LANs.",
    "choice_c": "Adding a router diverts traffic to an alternate path through the network.",
    "choice_d": "Adding a router prevents computers on one LAN from communicating with computers on another LAN.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Adding a router splits the Ethernet LAN into two LANs, creating two separate broadcast domains. Each computer, therefore, has a smaller number of broadcast messages to process. Because the network is split by the router, the amount of unicast traffic on each subnet is reduced.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      37,
      101,
      2,
      88,
      40
    ],
    "source": "9781394239306"
  },
  {
    "id": 664,
    "question": "Which of the following statements about traditional bridges and switches is true?",
    "choice_a": "Bridges and switches are Network layer devices that use logical addressing to forward frames.",
    "choice_b": "Bridges and switches are Data link layer devices that use media access control (MAC) addresses to forward frames.",
    "choice_c": "Bridges and switches build their internal tables based on destination addresses and forward packets based on source addresses.",
    "choice_d": "Bridges and switches must support the Network layer protocol implemented on the local area network (LAN).",
    "correct_answer": "B",
    "explanation": "Traditional bridges and switches are Data link layer devices that forward frames based on the destination MAC address contained in the frame. They operate in promiscuous mode, listening and processing all frames on each segment, and they build forwarding tables with this information. Forwarding tables are built based on source MAC addresses. Some switches include layer 3 functionality, but their primary function is still based at the Data link layer. Bridges are protocol independent; they are not involved with the upper layer protocols being carried on the LAN. Broadcast domains are defined by Network layer devices, not Data link layer devices.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      22,
      42,
      36,
      37,
      21
    ],
    "source": "9781394239306",
    "choice_e": "Each port on a bridge or switch defines a separate broadcast domain."
  },
  {
    "id": 665,
    "question": "Which of the following is a correct term describing the function of a traditional switch?",
    "choice_a": "Layer 2 router",
    "choice_b": "Ethernet hub",
    "choice_c": "Multiport bridge",
    "choice_d": "Layer 3 repeater",
    "correct_answer": "C",
    "explanation": "A traditional switch is best described as a multiport bridge because it reads the hardware addresses of incoming packets and forwards them out through the port for the destination node. Although a traditional switch does function at layer 2 of the OSI model (the Data link layer), there are also switches with Network layer capabilities that can function as a router, which connects networks together at layer 3. Hubs and repeaters are Physical layer (layer 1) devices that are not capable of performing the functions of a switch.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      72,
      81,
      37,
      44
    ],
    "source": "9781394239306"
  },
  {
    "id": 666,
    "question": "Which of the following is the primary reason why replacing hubs with layer 2 switches on an Ethernet local area network (LAN) improves its performance?",
    "choice_a": "Layer 2 switches forward packets faster than hubs.",
    "choice_b": "Layer 2 switches do not forward broadcast transmissions.",
    "choice_c": "Layer 2 switches reduce the number of collisions on the network.",
    "choice_d": "Layer 2 switches read the IP addresses of packets, not the hardware addresses.",
    "correct_answer": "C",
    "explanation": "The main reason why traditional layer 2 switches improve the efficiency of an Ethernet LAN is that they create a separate collision domain for each switched port, eliminating most collisions. Collisions result in packets having to be retransmitted, so fewer collisions mean fewer retransmissions, which improves performance. Layer 2 switches do not forward packets faster than hubs, but they do forward broadcast transmissions. Layer 2 switches do read hardware addresses, not IP addresses, but there are switches with layer 3 capabilities that route data packets to their destinations using IP addresses and subnetting.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      37,
      38,
      2,
      39,
      40
    ],
    "source": "9781394239306"
  },
  {
    "id": 667,
    "question": "Which of the following statements about routers are true? (Choose all that apply.)",
    "choice_a": "Routers are Network layer devices that use IP addresses to forward frames.",
    "choice_b": "Routers are Data link layer devices that use media access control (MAC) addresses to forward frames.",
    "choice_c": "Routers build their internal tables based on destination MAC addresses and forward frames based on source MAC addresses.",
    "choice_d": "Routers must support the Network layer protocol implemented on the local area network (LAN).",
    "correct_answer": [
      "A",
      "D",
      "E"
    ],
    "explanation": "Routers are Network layer devices that use IP addresses to forward frames, not MAC addresses. Routers are protocol dependent. They must support the Network layer protocol being routed. As a Network layer device, a router defines networks (or LANs) that represent a separate broadcast domain. Routers do not build their routing tables or forward frames using MAC addresses.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      21,
      22,
      37,
      79,
      88
    ],
    "source": "9781394239306",
    "choice_e": "Each port on a router defines a separate broadcast domain."
  },
  {
    "id": 668,
    "question": "Which of the following statements about routers is not true?",
    "choice_a": "Routers can connect two or more networks with dissimilar Data link layer protocols and media.",
    "choice_b": "Routers can connect two or more networks with the same Data link layer protocols and media.",
    "choice_c": "Routers store and maintain route information in a local text file.",
    "choice_d": "Servers with multiple network interfaces can be configured to function as software routers.",
    "correct_answer": "C",
    "explanation": "Routers store and maintain route information in a routing table that is stored in memory, not in a local text file. All of the other statements about routers are true.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      21,
      134,
      135,
      2,
      4
    ],
    "source": "9781394239306",
    "choice_e": "Routers can learn and populate their routing tables through static and dynamic routing."
  },
  {
    "id": 669,
    "question": "The network administrator for a small business is installing a computer to function as a firewall protecting their internetwork from Internet intrusion. At which of the following locations should the administrator install the firewall system?",
    "choice_a": "Anywhere on the private internetwork, as long as the Internet is accessible",
    "choice_b": "Between the Internet access router and the Internet service provider's (ISP's) network",
    "choice_c": "At the ISP's network site",
    "choice_d": "Between the Internet access router and the rest of the private internetwork",
    "correct_answer": "D",
    "explanation": "The firewall is a conduit between the private network and the ISP's network (which provides access to the Internet), through which all traffic must pass. This ensures that the firewall has the opportunity to examine every packet that passes between the private network and the Internet and filter out those that are not authorized. If the firewall were located in the midst of the private internetwork, it would be possible for Internet computers to bypass the firewall and communicate directly with the private systems. Placing the firewall on the far side of the router would put it on the ISP's network, causing it to filter all of the ISP's traffic and not just that destined for the private network. Installing the firewall at the ISP's site would have the same effect as installing it on the far side of the router at the private network site.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      12,
      37,
      101,
      86,
      287
    ],
    "source": "9781394239306"
  },
  {
    "id": 670,
    "question": "Proxy servers operate at which layer of the OSI reference model?",
    "choice_a": "Data link",
    "choice_b": "Network",
    "choice_c": "Transport",
    "choice_d": "Application",
    "correct_answer": "D",
    "explanation": "A proxy server is an Application layer service because it receives Internet service requests from client computers, reads the Application layer protocol data in each request, and then generates its own request for the same service and transmits it to the Internet server the client specifies. Only an Application layer service can read and process the Application layer data in network packets. A proxy server cannot be a Data link layer device because it can provide Internet access to an entire internetwork, while the Data link layer is concerned with communications on a single subnet. Proxy servers cannot be Network layer devices because the Network layer handles all internetwork packets indiscriminately and is unaware of what application generated the data carried inside the packets. The Transport layer is not involved in processing application data, so proxy servers cannot be said to function at the Transport layer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      81,
      23,
      21,
      19
    ],
    "source": "9781394239306"
  },
  {
    "id": 671,
    "question": "Which of the following is a feature that is not found in a traditional firewall product, but which might be found in a next-generation firewall (NGFW)?",
    "choice_a": "Stateful packet inspection",
    "choice_b": "Deep packet inspection (DPI)",
    "choice_c": "Network address translation (NAT)",
    "choice_d": "Virtual private network (VPN) support",
    "correct_answer": "B",
    "explanation": "DPI is a firewall technique that examines the data carried in packets and not just the protocol headers. While traditional firewalls typically do not support DPI, NGFWs often do. Stateful packet inspection, NAT, and VPN support are all features that are commonly supported by traditional firewall products.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      297,
      285,
      80,
      300,
      203
    ],
    "source": "9781394239306"
  },
  {
    "id": 672,
    "question": "Which of the following statements about content filtering in firewalls is true?",
    "choice_a": "Content filters examine the source IP addresses of packets to locate potential threats.",
    "choice_b": "Content filters enable switches to direct packets out through the correct port.",
    "choice_c": "Content filters examine the data carried within packets for potentially objectionable materials.",
    "choice_d": "Content filters use frequently updated signatures to locate packets containing malware.",
    "correct_answer": "C",
    "explanation": "Content filters are a firewall feature that examine the data inside packets, rather than their origin, to locate objectionable material. They do not scan IP addresses, nor do they detect typical types of malware. Content filters are not implemented in switches.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      82,
      37,
      42,
      18,
      23
    ],
    "source": "9781394239306"
  },
  {
    "id": 673,
    "question": "Which of the following is not one of the criteria typically used by load balancers to direct incoming traffic to one of a group of servers?",
    "choice_a": "Which server has the lightest load",
    "choice_b": "Which server has the fastest response time",
    "choice_c": "Which server is next in an even rotation",
    "choice_d": "Which server has the fastest processor",
    "correct_answer": "D",
    "explanation": "In most cases, a load balancing router works by processing incoming traffic based on rules set by the administrator. The rules can distribute traffic among a group of servers using various criteria, such as each server's current load or response time, or which server is next in a given rotation. Load balancers typically do not use the hardware configuration of the servers to direct traffic since this is a factor that does not change.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      296,
      285,
      14,
      289,
      3
    ],
    "source": "9781394239306"
  },
  {
    "id": 674,
    "question": "Which of the following devices enables administrators of enterprise wireless networks to manage multiple access points (APs) from a central location?",
    "choice_a": "Hypervisor",
    "choice_b": "Wireless controller",
    "choice_c": "Wireless endpoint",
    "choice_d": "Demarcation point",
    "correct_answer": "B",
    "explanation": "In many enterprise wireless networks, the access points (APs) do not run a full operating system and are called thin or lightweight APs. The network also has a device called a wireless controller that performs some of the required tasks and manages the APs. A <i>wireless endpoint</i> is another term for a computer or other device that is a client on the wireless network. Hypervisors and demarcation points have nothing to do with wireless networking. A hypervisor creates and manages virtual machines (VMs) on a host server, and a demarcation point is the interface between a private network and an outside telecommunications service.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      180,
      203,
      205,
      11,
      3
    ],
    "source": "9781394239306"
  },
  {
    "id": 675,
    "question": "A load balancer is a type of which of the following devices?",
    "choice_a": "Switch",
    "choice_b": "Router",
    "choice_c": "Gateway",
    "choice_d": "Firewall",
    "correct_answer": "B",
    "explanation": "A load balancer is a type of router that forwards traffic with a single IP address to multiple servers in turn. In most cases, a load balancing router works by processing incoming traffic based on rules set by the administrator. Because a load balancer works with IP addresses, it is a Network layer device. Load balancers are not switches, gateways, or firewalls.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      285,
      2,
      116,
      14,
      82
    ],
    "source": "9781394239306"
  },
  {
    "id": 676,
    "question": "Which of the following devices expands on the capabilities of the traditional firewall by adding features like deep packet inspection (DPI) and an intrusion prevention system (IPS)?",
    "choice_a": "RADIUS server",
    "choice_b": "CSU/DSU",
    "choice_c": "NGFW",
    "choice_d": "Proxy server",
    "correct_answer": "C",
    "explanation": "Next-generation firewalls (NGFWs) expand on the packet filtering capabilities of traditional firewalls by adding features such as DPI and IPSs, as well as inspection of encrypted traffic and antivirus scanning. Remote Authentication Dial-In User Service (RADIUS) servers can provide centralized authentication, authorization, accounting, and auditing (AAAA) services. A CSU/DSU is a device that provides a router on a private network with access to a leased line. A proxy server is an Application layer service that receives Internet service requests from client computers, reads the Application layer protocol data in each request, and then generates its own request for the same service and transmits it to the Internet server the client specifies.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      202,
      203,
      300,
      18,
      21
    ],
    "source": "9781394239306"
  },
  {
    "id": 677,
    "question": "Which of the following statements about Internet access through a proxy server accounts for the security against outside intrusion that a proxy provides?",
    "choice_a": "The proxy server uses a public IP address, and the client computers use private addresses.",
    "choice_b": "The proxy server uses a private IP address, and the client computers use public addresses.",
    "choice_c": "Both the proxy server and the client computers use private IP addresses.",
    "choice_d": "Both the proxy server and the client computers use public IP addresses.",
    "correct_answer": "A",
    "explanation": "Because the client computers use private IP addresses, they are invisible to the Internet, so users outside the private network cannot see or access them. The proxy server has a public IP address so that it can participate in service transactions with Internet servers. If the proxy server used a private IP address, it would not be able to access the Internet directly. If the clients used public IP addresses, they would be visible to the Internet and vulnerable to intrusion.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      86,
      116,
      118,
      287,
      99
    ],
    "source": "9781394239306"
  },
  {
    "id": 678,
    "question": "Which of the following devices can an administrator use to monitor a network for abnormal or malicious traffic?",
    "choice_a": "IDS",
    "choice_b": "UPS",
    "choice_c": "RADIUS",
    "choice_d": "DoS",
    "correct_answer": "A",
    "explanation": "Intrusion detection systems (IDSs) are designed to monitor network traffic for anomalies and send notifications to administrators. Uninterruptible power supplies (UPSs), Remote Authentication Dial-In User Service (RADIUS) servers, denial-of-service (DoS) attacks, and Remote Access Service (RAS) servers all have nothing to do with network monitoring.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      202,
      299,
      300,
      111,
      17
    ],
    "source": "9781394239306",
    "choice_e": "RAS"
  },
  {
    "id": 679,
    "question": "Which of the following features enables an intrusion detection system (IDS) to monitor all of the traffic on a switched network?",
    "choice_a": "Stateful packet inspection",
    "choice_b": "Port mirroring",
    "choice_c": "Trunking",
    "choice_d": "Service-dependent filtering",
    "correct_answer": "B",
    "explanation": "Port mirroring is a feature found in some switches that takes the form of a special port that runs in promiscuous mode. This means that the switch copies all incoming traffic to that port, as well as to the dedicated destination ports. By connecting an IDS or protocol analyzer to this port, an administrator can access all of the network's traffic. Stateful packet inspection is a firewall feature that enables the device to examine network and Transport layer header fields, looking for patterns that indicate damaging behaviors, such as IP spoofing, SYN floods, and teardrop attacks. Trunking is a switch feature that enables administrators to create VLANs that span multiple switches. Service-dependent filtering is a firewall feature that blocks traffic based on Transport layer port numbers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      14,
      40,
      36,
      285,
      296
    ],
    "source": "9781394239306"
  },
  {
    "id": 680,
    "question": "Which of the following storage area network (SAN) protocols are capable of sharing a network medium with standard local area network (LAN) traffic? (Choose all that apply.)",
    "choice_a": "iSCSI",
    "choice_b": "Fibre Channel",
    "choice_c": "FCoE",
    "choice_d": "InfiniBand",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "iSCSI runs on a standard IP network, and Fibre Channel over Ethernet (FCoE) runs on a standard Ethernet network. Both of these protocols can share a network with LAN traffic, although the use of a quality of service (QoS) mechanism is usually recommended. Fibre Channel and InfiniBand both require a dedicated network medium that does not support LAN traffic.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      16,
      6,
      40,
      298,
      2
    ],
    "source": "9781394239306"
  },
  {
    "id": 681,
    "question": "Which of the following protocols is not used for storage area networks (SANs)?",
    "choice_a": "iSCSI",
    "choice_b": "FCoE",
    "choice_c": "VoIP",
    "choice_d": "Fibre Channel",
    "correct_answer": "C",
    "explanation": "Voice over Internet Protocol (VoIP) is a technology for the transmission of voice communications over IP networks; it is not a SAN protocol. Internet Small Computer Systems Interface (iSCSI), Fibre Channel over Ethernet (FCoE), and Fibre Channel are all SAN protocols.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      16,
      6,
      80,
      4,
      28
    ],
    "source": "9781394239306"
  },
  {
    "id": 682,
    "question": "Which of the following storage area network (SAN) technologies do iSCSI initiators use to locate iSCSI targets on the network?",
    "choice_a": "Active Directory",
    "choice_b": "ICMP",
    "choice_c": "DNS",
    "choice_d": "iWINS",
    "correct_answer": "E",
    "explanation": "The Internet Storage Name Service (iSNS) is an application that provides iSCSI initiators with automated discovery of targets located on the network. iSNS can also function as a discovery service for Fibre Channel devices. Active Directory, Internet Control Message Protocol (ICMP), and Domain Name System (DNS) are not capable of registering iSCSI targets. iWINS does not exist.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      16,
      76,
      79,
      18
    ],
    "source": "9781394239306",
    "choice_e": "iSNS"
  },
  {
    "id": 683,
    "question": "What is the highest possible data transfer rate on a storage area network (SAN) using Fibre Channel?",
    "choice_a": "8 Gbps",
    "choice_b": "16 Gbps",
    "choice_c": "32 Gbps",
    "choice_d": "128 Gbps",
    "correct_answer": "D",
    "explanation": "The current Fibre Channel standard calls for a maximum data transfer rate of 128 gigabits per second (Gbps), for a nominal throughput of 12,800 megabytes per second (MBps).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      16,
      6,
      28,
      40,
      39
    ],
    "source": "9781394239306"
  },
  {
    "id": 684,
    "question": "In its primary functionality, a network-attached storage (NAS) device is most closely associated with which of the following devices?",
    "choice_a": "Failover cluster",
    "choice_b": "File server",
    "choice_c": "JBOD",
    "choice_d": "RAID",
    "correct_answer": "B",
    "explanation": "A NAS device is essentially a file server that connects to a network and provides users with access to shared files. A NAS is a single computer, so it cannot be associated with failover clustering. Just a bunch of disks (JBOD) is a simple storage array that provides block-level access to data, whereas NAS devices provide file-level access. Redundant Array of Independent Disks (RAID) is a fault tolerance technology that might be implemented in NAS devices, but it is not the device's primary function.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      16,
      6,
      2,
      281,
      73
    ],
    "source": "9781394239306"
  },
  {
    "id": 685,
    "question": "Which of the following statements about the differences between network-attached storage (NAS) and storage area networks (SANs) are true? (Choose all that apply.)",
    "choice_a": "NAS provides file-level storage access, whereas SAN provides block-level storage access.",
    "choice_b": "NAS devices typically contain integrated iSCSI targets.",
    "choice_c": "SAN devices have an operating system, whereas NAS devices do not.",
    "choice_d": "NAS devices typically provide a filesystem, whereas SAN devices do not.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "NAS devices are self-contained file servers that connect directly to a standard IP network. A NAS device provides file-level access to its storage devices and includes an operating system and a filesystem. NAS devices are typically not iSCSI targets.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      16,
      6,
      3,
      281,
      282
    ],
    "source": "9781394239306"
  },
  {
    "id": 686,
    "question": "Which of the following statements specify advantages of FCoE over the original Fibre Channel standard? (Choose all that apply.)",
    "choice_a": "FCoE is less expensive to implement than Fibre Channel.",
    "choice_b": "FCoE can share a network with standard IP traffic, whereas Fibre Channel cannot.",
    "choice_c": "FCoE is routable over IP networks, whereas Fibre Channel is not.",
    "choice_d": "FCoE uses standard Ethernet networking hardware.",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "Because it uses standard Ethernet hardware, Fibre Channel over Ethernet (FCoE) is far less expensive to implement than Fibre Channel, which requires a dedicated fiber-optic network. Because Fibre Channel requires a dedicated network, it cannot coexist with standard IP traffic, whereas FCoE can. Because it is encapsulated in Ethernet frames, FCoE is not routable on IP networks.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      6,
      16,
      28,
      82,
      40
    ],
    "source": "9781394239306"
  },
  {
    "id": 687,
    "question": "Which of the following are Application layer protocols that network-attached storage (NAS) devices can use to serve shared files to clients on the network? (Choose all that apply.)",
    "choice_a": "CIFS",
    "choice_b": "NFS",
    "choice_c": "RDMA",
    "choice_d": "HTTP",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "Common Internet File System (CIFS), Network File System (NFS), and Hypertext Transfer Protocol (HTTP) are all file sharing protocols supported by many NAS devices. Remote Direct Memory Access (RDMA) provides high-speed network data transfers, but it is not an Application layer file sharing protocol.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      18,
      78,
      72,
      81,
      1
    ],
    "source": "9781394239306"
  },
  {
    "id": 688,
    "question": "Which of the following is not one of the advantages of iSCSI over Fibre Channel?",
    "choice_a": "iSCSI is routable, whereas Fibre Channel is not.",
    "choice_b": "iSCSI is less expensive to implement than Fibre Channel.",
    "choice_c": "iSCSI includes its own internal flow control mechanism, whereas Fibre Channel does not.",
    "choice_d": "iSCSI can share the same network as standard local area network traffic, whereas Fibre Channel cannot.",
    "correct_answer": "C",
    "explanation": "iSCSI does not include its own flow control mechanism. It runs over a TCP connection, which is the protocol responsible for flow control. Because it runs on any IP network, iSCSI traffic is routable, and it is less expensive to implement. Fibre Channel requires a dedicated network using fiber-optic cable. iSCSI traffic can coexist with standard LAN traffic on a single network, although some type of quality of service (QoS) mechanism is frequently recommended.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      6,
      16,
      28,
      296
    ],
    "source": "9781394239306"
  },
  {
    "id": 689,
    "question": "Which of the following is the term for the client that accesses an iSCSI device on a storage area network?",
    "choice_a": "Initiator",
    "choice_b": "Target",
    "choice_c": "Controller",
    "choice_d": "Adapter",
    "correct_answer": "A",
    "explanation": "The client side of an iSCSI implementation is called an initiator. The storage device to which the initiator connects is called a target. <i>Controller</i> and <i>adapter</i> are not terms used for iSCSI clients or servers.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      6,
      16,
      3,
      4,
      82
    ],
    "source": "9781394239306"
  },
  {
    "id": 690,
    "question": "Which of the following protocols are included in an iSCSI packet on a storage area network (SAN)? (Choose all that apply.)",
    "choice_a": "Ethernet",
    "choice_b": "IP",
    "choice_c": "TCP",
    "choice_d": "UDP",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "iSCSI runs on a standard IP network; therefore, iSCSI messages are encapsulated using Transmission Control Protocol (TCP) at the Transport layer, Internet Protocol (IP) at the Network layer, and Ethernet at the Data link layer. iSCSI does not use the User Datagram Protocol (UDP).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      82,
      81,
      77,
      22,
      43
    ],
    "source": "9781394239306",
    "choice_e": "None of the above"
  },
  {
    "id": 691,
    "question": "Which of the following protocols are included in a Fibre Channel packet?",
    "choice_a": "Ethernet",
    "choice_b": "IP",
    "choice_c": "TCP",
    "choice_d": "UDP",
    "correct_answer": "E",
    "explanation": "The Fibre Channel standard defines a unique, five-layer protocol stack that does not correspond to the OSI model layers. Therefore, Fibre Channel does not use Ethernet, nor does it use Transmission Control Protocol (TCP), Internet Protocol (IP), User Datagram Protocol (UDP), or any of the other TCP/IP protocols.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      16,
      17,
      6,
      72,
      82
    ],
    "source": "9781394239306",
    "choice_e": "None of the above"
  },
  {
    "id": 692,
    "question": "Which of the following protocol standards defines a layered implementation that does not correspond to the layers of the Open Systems Interconnection (OSI) model?",
    "choice_a": "iSCSI",
    "choice_b": "Fibre Channel",
    "choice_c": "PPP",
    "choice_d": "RDMA",
    "correct_answer": "B",
    "explanation": "The Fibre Channel standard defines a five-layer networking stack, with layers numbered FC-0 to FC-4, that does not correspond to the layers of the OSI model. Internet Small Computer System Interface (iSCSI), Point-to-Point Protocol (PPP), and Remote Direct Memory Access (RDMA) all function within the standard OSI model layers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      17,
      72,
      295,
      16,
      81
    ],
    "source": "9781394239306"
  },
  {
    "id": 693,
    "question": "Which of the following protocols are included in an FCoE packet?",
    "choice_a": "Ethernet",
    "choice_b": "IP",
    "choice_c": "TCP",
    "choice_d": "UDP",
    "correct_answer": "A",
    "explanation": "Fibre Channel over Ethernet (FCoE) uses Ethernet frames in place of the bottom two layers (FC0 and FC1) of the Fibre Channel protocol stack. The remaining layers (FC2, FC3, and FC4) use the standard Fibre Channel protocols. FCoE does not use Transmission Control Protocol (TCP), Internet Protocol (IP), User Datagram Protocol (UDP), or any of the other TCP/IP protocols.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      16,
      17,
      82,
      43,
      23
    ],
    "source": "9781394239306",
    "choice_e": "None of the above"
  },
  {
    "id": 694,
    "question": "Ralph, the administrator of a 500-node private internetwork, is devising a plan to connect the network to the Internet. The primary objective of the project is to provide all of the network users with access to web and email services while keeping the client computers safe from unauthorized users on the Internet. The secondary objectives of the project are to avoid having to manually configure IP addresses on each one of the client computers individually and to provide a means of monitoring and regulating the users' access to the Internet. Ralph submits a proposal calling for the use of private IP addresses on the client computers and a series of proxy servers with public, registered IP addresses, connected to the Internet using multiple T-1 lines. Which of the following statements about Ralph's proposed Internet access solution is true?",
    "choice_a": "The proposal fails to satisfy both the primary and secondary objectives.",
    "choice_b": "The proposal satisfies the primary objective but neither of the secondary objectives.",
    "choice_c": "The proposal satisfies the primary objective and one of the secondary objectives.",
    "choice_d": "The proposal satisfies the primary objective and both of the secondary objectives.",
    "correct_answer": "C",
    "explanation": "Proxy servers provide network users with access to Internet services, and the unregistered IP addresses on the client computers protect them from unauthorized access by users on the Internet, which satisfies the first objective. The proxy servers also make it possible for network administrators to regulate users' access to the Internet, which satisfies one of the two secondary objectives. However, the proxy servers cannot assign IP addresses to the client computers, and the plan makes no mention of DHCP or another automatic TCP/IP configuration mechanism. Therefore, the plan does not satisfy the other secondary objective.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      117,
      114,
      111,
      113
    ],
    "source": "9781394239306"
  },
  {
    "id": 695,
    "question": "Which of the following is not a mechanism for distributing incoming network traffic among multiple servers?",
    "choice_a": "Load balancer",
    "choice_b": "Round-robin DNS",
    "choice_c": "NLB cluster",
    "choice_d": "VPN headend",
    "correct_answer": "D",
    "explanation": "A virtual private network (VPN) headend is a type of router that enables multiple client systems to access a network from remote locations. It does not distribute traffic among servers. A load balancer is a type of router that forwards traffic with a single IP address to multiple servers in turn. Round-robin DNS is a technique in which a DNS server resolves a name into several IP addresses, each in turn. A network load balancing (NLB) cluster is a group of servers, all running the same application, that distribute incoming traffic among themselves.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      285,
      14,
      76,
      116,
      4
    ],
    "source": "9781394239306"
  },
  {
    "id": 696,
    "question": "Which of the following is not a function that is typically provided by a unified threat management (UTM) appliance?",
    "choice_a": "Virtual private networking",
    "choice_b": "Network firewall",
    "choice_c": "Network-attached storage",
    "choice_d": "Antivirus/antimalware protection",
    "correct_answer": "C",
    "explanation": "Network-attached storage (NAS) is a separate device that connects storage to the network; it is not a normal function of a UTM appliance. UTM appliances do typically perform VPN, firewall, and antivirus functions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      285,
      295,
      296,
      14,
      6
    ],
    "source": "9781394239306"
  },
  {
    "id": 697,
    "question": "A multilayer switch can operate at which layers of the Open Systems Interconnection (OSI) model? (Choose all that apply.)",
    "choice_a": "Physical",
    "choice_b": "Data link",
    "choice_c": "Network",
    "choice_d": "Transport",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "A multilayer switch typically operates at the Data link and Network layers, assuming the functions of a switch and a router by using media access control (MAC) addresses at the Data link layer (layer 2) and IP addresses at the Network layer (layer 3) to forward packets to their appropriate destinations. Some switches also function at the Transport layer (layer 4) by distinguishing between User Datagram Protocol (UDP) and Transmission Control Protocol (TCP) traffic and using port numbers to forward packets.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      81,
      82,
      22,
      19,
      77
    ],
    "source": "9781394239306",
    "choice_e": "Session",
    "choice_f": "Presentation",
    "choice_g": "Application"
  },
  {
    "id": 698,
    "question": "Control plane policing (CPP or CoPP) is a feature on some routers and switches that limits the rate of traffic on the device's processor to prevent denial-of-service (DoS) and reconnaissance attacks, using which of the following technologies?",
    "choice_a": "IPsec",
    "choice_b": "802.1X",
    "choice_c": "RA guard",
    "choice_d": "QoS",
    "correct_answer": "D",
    "explanation": "Control plane policing uses quality of service (QoS) policies to block, allow, or impose rate limits on the traffic processed by the router or switch. IPsec is a Network layer security mechanism that encrypts or authenticates traffic. 802.1X is a network authentication mechanism. Router Advertisement (RA) guard is a feature found on certain switches that prevents the misuse of RA messages to redirect traffic. VLAN hopping is a method for sending commands to switches to transfer a port from one VLAN to another.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      295,
      285,
      203,
      299,
      72
    ],
    "source": "9781394239306",
    "choice_e": "VLAN hopping"
  },
  {
    "id": 699,
    "question": "Which of the following is a device that switches calls between endpoints on the local IP network and provides access to external Internet lines?",
    "choice_a": "VoIP PBX",
    "choice_b": "VoIP gateway",
    "choice_c": "VoIP endpoint",
    "choice_d": "Multilayer switch",
    "correct_answer": "A",
    "explanation": "A private branch exchange (PBX) switches internal calls and provides access to external lines. A VoIP PBX performs the same tasks as a traditional PBX. A VoIP gateway is the device that provides the conduit between an IP network and the public switched telephone network (PSTN). A VoIP endpoint is a device that makes use of the VoIP system, such as a computer or handset. A multilayer switch is a data networking device that includes both switching and routing capabilities.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      285,
      2,
      47,
      79,
      17
    ],
    "source": "9781394239306"
  },
  {
    "id": 700,
    "question": "Which of the following is the true definition of the term <i>modem</i>?",
    "choice_a": "A device that connects a computer to the public switched telephone network (PSTN)",
    "choice_b": "A device that connects a local area network (LAN) to the Internet",
    "choice_c": "A device that converts analog signals to digital signals and back again",
    "choice_d": "A device that connects a local area network (LAN) to a wide area network (WAN)",
    "correct_answer": "C",
    "explanation": "A modem (modulator/demodulator) is any device that converts analog signals to digital signals and digital signals back to analog signals. The digital device does not have to be a computer, and the analog device does not have to be the PSTN. There are many devices that are incorrectly referred to as modems, such as devices that connect a digital LAN to a digital WAN or all-digital devices that connect computers to the Internet.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      24,
      82,
      17,
      40,
      44
    ],
    "source": "9781394239306"
  },
  {
    "id": 701,
    "question": "Which of the following terms are used to describe the device used to place calls on a Voice over Internet Protocol (VoIP) installation? (Choose all that apply.)",
    "choice_a": "Terminal",
    "choice_b": "Gateway",
    "choice_c": "Endpoint",
    "choice_d": "PBX",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "VoIP uses the terms <i>terminal</i> and <i>endpoint</i> to refer to the device with which users make calls, including computers and telephone handsets. A VoIP gateway is the device that provides the conduit between an IP network and the public switched telephone network (PSTN). A VoIP private branch exchange (PBX) is a device that switches calls between endpoints on the local IP network and provides access to external Internet lines.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      47,
      18,
      83,
      1,
      17
    ],
    "source": "9781394239306"
  },
  {
    "id": 702,
    "question": "Which of the following devices enables you to use a standard analog telephone to place calls using the Internet instead of the public switched telephone network (PSTN)?",
    "choice_a": "Proxy server",
    "choice_b": "VPN headend",
    "choice_c": "VoIP gateway",
    "choice_d": "UTM appliance",
    "correct_answer": "C",
    "explanation": "A VoIP gateway is a device that provides a conduit between an IP network and the public switched telephone network (PSTN). The gateway enables standard telephones connected to the PSTN to place calls using VoIP services on the Internet. A proxy server is an Application layer device that provides web browsers and other client programs to access the Internet. A virtual private network (VPN) headend enables multiple client systems to access a network from remote locations. A unified threat management (UTM) appliance typically performs VPN, firewall, and antivirus functions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      83,
      72,
      17,
      287
    ],
    "source": "9781394239306"
  },
  {
    "id": 703,
    "question": "Which of the following prevents packets on a TCP/IP internetwork from being transmitted endlessly from router to router?",
    "choice_a": "Open Shortest Path First (OSPF)",
    "choice_b": "Maximum transmission unit (MTU)",
    "choice_c": "Administrative distance",
    "choice_d": "Time to live (TTL)",
    "correct_answer": "D",
    "explanation": "TTL is a value included in the IPv4 header that specifies the maximum number of hops the packet is allowed on the network. Each router processing the packet reduces the TTL value by one and discards the packet when the value reaches zero. OSPF is a routing protocol. MTU specifies the maximum size of a frame. Administrative distance is a value that routers use to select the most efficient route to a destination.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      21,
      81,
      72,
      135,
      4
    ],
    "source": "9781394239306"
  },
  {
    "id": 704,
    "question": "Which of the following is the abbreviation for a network of Internet datacenters supplying end users with localized access to their data?",
    "choice_a": "CDN",
    "choice_b": "QoS",
    "choice_c": "NAS",
    "choice_d": "SAN",
    "correct_answer": "A",
    "explanation": "A content delivery network (CDN) is a geographically scattered array of datacenters that provides users with access to their data from a nearby site, thereby decreasing latency delays and reducing bandwidth utilization. Quality of service (QoS) is a technique for prioritizing traffic by tagging packets based on their content. Network-attached storage (NAS) refers to a device containing shared drives that is connected to a network. A storage area network (SAN) is a separate network dedicated to shared storage devices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      281,
      288,
      16,
      6,
      286
    ],
    "source": "9781394239306"
  },
  {
    "id": 705,
    "question": "Which of the following cloud service models enables you to perform a new installation of an operating system of your choice?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "DaaS",
    "correct_answer": "A",
    "explanation": "The infrastructure as a service (IaaS) model provides consumers with processing, storage, and networking resources that they can use to install and run operating systems and other software of their choice. Platform as a service (PaaS) provides consumers with the ability to install applications of their choice on a server installed by the provider. Software as a service (SaaS) provides consumers with access to specific applications running on the provider's servers. Desktop as a service (DaaS) provides remote virtualization of the entire workstation desktop, instead of a single application.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      284,
      302,
      291,
      301,
      288
    ],
    "source": "9781394239306",
    "choice_e": "All of the above"
  },
  {
    "id": 706,
    "question": "When you contract with a provider to obtain email services for your company using their servers in the public cloud, which of the following service models are you using?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "DaaS",
    "correct_answer": "C",
    "explanation": "The software as a service (SaaS) model provides consumers with access to a specific application running on the provider's servers. Infrastructure as a service (IaaS) provides the consumers with processing, storage, and networking resources that they can use to install and run operating systems and other software of their choice. Platform as a service (PaaS) provides consumers with the ability to install applications of their choice on a server installed by the provider. Desktop as a service (DaaS) provides remote virtualization of the entire workstation desktop, instead of a single application.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      284,
      301,
      302,
      282,
      291
    ],
    "source": "9781394239306",
    "choice_e": "None of the above"
  },
  {
    "id": 707,
    "question": "Which of the following cloud service models provides the consumer with the most control over the cloud resources?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "DaaS",
    "correct_answer": "A",
    "explanation": "The infrastructure as a service (IaaS) model provides consumers with the most control, as the provider furnishes processing, storage, and networking resources that the consumer can use as needed. Platform as a service (PaaS) provides consumers with the ability to install applications of their choice on a server furnished by the provider, but they have only limited control over the server and no control over the underlying resources. Software as a service (SaaS) and desktop as a service (DaaS) provide consumers with access to a specific application or an entire desktop environment running on the provider's servers, but the consumers have no control over the operating system, the servers, or the underlying resources.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      284,
      283,
      301,
      288,
      302
    ],
    "source": "9781394239306",
    "choice_e": "IaaS, PaaS, SaaS, and DaaS all provide the same degree of control."
  },
  {
    "id": 708,
    "question": "Alice has just created a new Windows Server virtual machine using remote controls provided by a cloud service provider on the Internet. Which of the following cloud architectures is she using? (Choose all that apply.)",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "Public cloud",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Infrastructure as a service (IaaS) provides consumers like Alice with processing, storage, and networking resources that they can use to install and run operating systems and other software of their choice. In the public cloud model, one organization or user functions as the provider, and another organization or user\u2014in this case, Alice\u2014consumes the services of the provider. <p>Platform as a service (PaaS) provides consumers with the ability to install applications of their choice on a server furnished by the provider. Software as a service (SaaS) provides consumers with access to a specific application running on the provider's servers. In a private cloud, the same organization that utilizes the cloud services is also the sole owner of the infrastructure that provides those services. A hybrid cloud is a combination of public and private infrastructure so that the consumer organization is only a partial owner of the infrastructure. A virtual private cloud (VPC) is a secured private cloud hosted within a public cloud.</p>",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      284,
      301,
      283,
      281,
      290
    ],
    "source": "9781394239306",
    "choice_e": "Private cloud",
    "choice_f": "Hybrid cloud",
    "choice_g": "Virtual private cloud"
  },
  {
    "id": 709,
    "question": "In which of the following cloud models can a single organization function as both the provider and the consumer of all cloud services?",
    "choice_a": "Public cloud",
    "choice_b": "Private cloud",
    "choice_c": "Hybrid cloud",
    "choice_d": "Multicloud",
    "correct_answer": "B",
    "explanation": "In a private cloud, the same organization that utilizes the cloud services can also be the sole owner of the infrastructure that provides those services. A private cloud can also be owned by a third party, all or in part. In the public cloud model, one organization functions as the provider, and another organization consumes the services of the provider. A hybrid cloud is a combination of public and private infrastructure so that the consumer organization is only a partial owner of the infrastructure. A multicloud is an integrated environment consisting of multiple cloud services from multiple providers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      283,
      301,
      288,
      281,
      282
    ],
    "source": "9781394239306"
  },
  {
    "id": 710,
    "question": "Ed is the overnight manager of his company's datacenter, and he is responsible for both private and public resources in the company's hybrid cloud. Due to a new TV commercial shown that night, the company's website experiences a massive upsurge in traffic. The web server farm on the private cloud is being overwhelmed, so Ed configures some virtual machines in the public cloud to take up the slack. Which of the following is a common term for what Ed has done?",
    "choice_a": "Cloud busting",
    "choice_b": "Cloud bursting",
    "choice_c": "Cloud splitting",
    "choice_d": "Cloud migrating",
    "correct_answer": "B",
    "explanation": "<i>Cloud bursting</i> is a common term for the offloading of excess traffic from private to public cloud resources when necessary to maintain satisfactory performance levels. Cloud busting, cloud splitting, and cloud migrating are not standard cloud computing terms.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      283,
      289,
      301,
      282,
      302
    ],
    "source": "9781394239306"
  },
  {
    "id": 711,
    "question": "Microsoft's <a href=\"http://www.Outlook.com\"><code>Outlook.com</code></a> email service is an example of which of the following cloud service models?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "DaaS",
    "correct_answer": "C",
    "explanation": "Software as a service (SaaS) provides consumers with access to a specific application running on the provider's servers (in this case, an email service). Consumers have control over some of their email functions, but they have no control over the operating system, the servers, or the underlying resources. The infrastructure as a service (IaaS) model provides the consumers with access to processing, storage, and networking resources that the consumer can use as needed. Platform as a service (PaaS) provides consumers with the ability to install applications of their choice on a server furnished by the provider. Desktop as a service (DaaS) provides remote virtualization of the entire workstation desktop, instead of a single application.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      284,
      301,
      288,
      302,
      299
    ],
    "source": "9781394239306",
    "choice_e": "None of the above"
  },
  {
    "id": 712,
    "question": "Which of the following statements about cloud delivery models is true?",
    "choice_a": "A public cloud is inherently insecure because anyone can access it.",
    "choice_b": "A private cloud consists of hardware that is all located in a single datacenter.",
    "choice_c": "A hybrid cloud enables administrators to migrate services between public and private resources.",
    "choice_d": "Public, private, and hybrid clouds all utilize the same hardware resources.",
    "correct_answer": "C",
    "explanation": "A hybrid cloud consists of both public and private resources. One of its main advantages is that administrators can move services from private to public cloud servers and back again as needed, depending on the current workload. Public cloud resources require authentication, so while they might be less secure than a private cloud, they are not inherently insecure. The term <i>private cloud</i> refers to hardware resources that are owned and operated by either a single organization or a third party, regardless of their location. The various cloud delivery models do not impose specific hardware resource requirements.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      283,
      301,
      288,
      281,
      282
    ],
    "source": "9781394239306"
  },
  {
    "id": 713,
    "question": "Ed has just created a new Windows application for his company and wants to deploy it in the public cloud. He is looking for a provider that will furnish his company with a fully installed and configured Windows server on which he can install and run his application. Which of the following service models is he seeking to use?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "DaaS",
    "correct_answer": "B",
    "explanation": "The platform as a service (PaaS) model provides consumers with the ability to install applications of their choice on a server furnished by the provider. Infrastructure as a service (IaaS) provides the consumers with processing, storage, and networking resources that they can use to install and run operating systems and other software of their choice. Software as a service (SaaS) provides consumers with access to a specific application running on the provider's servers. Desktop as a service (DaaS) provides remote virtualization of the entire workstation desktop, instead of a single application.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      284,
      301,
      302,
      288,
      291
    ],
    "source": "9781394239306",
    "choice_e": "None of the above"
  },
  {
    "id": 714,
    "question": "Which of the following are valid advantages or disadvantages of multitenancy in a public cloud datacenter? (Choose all that apply.)",
    "choice_a": "Multitenancy presents a potential security risk because other tenants are utilizing the same hardware.",
    "choice_b": "Multitenancy reduces the cost of utilities and other overhead.",
    "choice_c": "Multitenancy introduces the possibility of competition for bandwidth with other tenants.",
    "choice_d": "Multitenancy separates tenants by assigning each one its own virtual machine.",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Multitenancy is a software architecture in which multiple tenants share a single instance of an application running in the cloud. Because tenants share a single application, there is a chance that data could be compromised. Because a single application instance is running in the cloud, the operational overhead is reduced compared to the use of individual virtual machines. Tenants share a finite amount of bandwidth, so the possibility exists for competition to occur, such as when one tenant is the target of a denial-of-service (DoS) attack. Multitenancy does not call for tenants to have individual virtual machines.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      288,
      284,
      301,
      282,
      290
    ],
    "source": "9781394239306"
  },
  {
    "id": 715,
    "question": "Ralph is designing a hybrid deployment for a corporate client that will require a connection between the client's private network and a public cloud provider. The client is concerned about this connection becoming a speed bottleneck at times of heavy user traffic. Which of the following options can Ralph offer the client that will best address this potential problem?",
    "choice_a": "Use a different ISP for the cloud connection.",
    "choice_b": "Use a VPN for the cloud connection.",
    "choice_c": "Use a cloud direct connection for the hybrid link.",
    "choice_d": "Use a leased line connection to the ISP.",
    "correct_answer": "C",
    "explanation": "A cloud direct connection is a private link between the client's private network and the cloud service provider. This link is independent from any ISP connection used by the client organization for other traffic, so it ensures a consistent bandwidth for the hybrid cloud network. Using a different ISP or a leased line does not replace the entire connection; there are still potential bottlenecks. A VPN can provide better performance than a standard connection and greater security, but it is not as consistent (or as expensive) as a direct cloud connection.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      286,
      283,
      301,
      290,
      289
    ],
    "source": "9781394239306"
  },
  {
    "id": 716,
    "question": "Which of the following is not one of the primary components of the network functions virtualization (NFV) framework?",
    "choice_a": "VNF",
    "choice_b": "NFV ISG",
    "choice_c": "NFVI",
    "choice_d": "NFV-MANO",
    "correct_answer": "B",
    "explanation": "The NFV specification, published by the European Telecommunications Standards Institute (ETSI), calls for three main components: virtualized network functions (VNFs), which are software-based implementations of standard network services, such as firewalls and load balancers; a network functions virtualization infrastructure (NFVI), which is the hardware/software environment that hosts the VNFs; and a network functions virtualization-management and orchestration (NFV-MANO) framework, which includes the elements required to deploy and administer the NFVI and the VNFs. The Network Functions Virtualization Industry Specification Group (NFV ISG) is the group within ETSI that develops the NFV specifications; it is not one of the three components.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      285,
      14,
      302,
      291,
      295
    ],
    "source": "9781394239306"
  },
  {
    "id": 717,
    "question": "Ralph is designing the datacenter for his company's new branch office. He is considering various options, including building a new datacenter at the branch office facility, using a colocated datacenter, and creating a virtual datacenter using a public cloud provider. Which of the following statements about the differences between these options are true? (Choose all that apply.)",
    "choice_a": "A colocated datacenter would be less expensive to implement than a branch office or public cloud datacenter.",
    "choice_b": "In a branch office or colocated datacenter, Ralph's company would own the hardware.",
    "choice_c": "In all three datacenter options, the administrators in Ralph's company would be responsible for setting up and managing the hardware.",
    "choice_d": "In a branch office or colocated datacenter, Ralph's company would be responsible for all utility costs, including heating, cooling, and power.",
    "correct_answer": [
      "B",
      "F"
    ],
    "explanation": "In a colocated datacenter, a client houses its own servers and other hardware in a shared third-party facility. Therefore, Ralph's company would own the hardware in a branch office or colocated datacenter. A datacenter in a public cloud is easier to expand than the other options because it is simply a matter of creating additional virtual devices. A colocated datacenter would be less expensive to implement than a branch office datacenter, but the public cloud option would require the smallest initial outlay. The administrators would set up and manage the hardware in a branch office or colocated datacenter, but not in a public cloud datacenter. In a colocated datacenter, Ralph's company would share utility costs with other tenants. A public cloud facility is not necessarily more secure.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      283,
      301,
      281,
      289,
      288
    ],
    "source": "9781394239306",
    "choice_e": "A public cloud datacenter would have greater physical security than the other two options.",
    "choice_f": "A public cloud datacenter is easier to expand than a colocated or branch office datacenter."
  },
  {
    "id": 718,
    "question": "Alice's company regularly hires a large number of operators for its phone center. The operators require access to a customer database and an order entry system. Because this is a high-turnover position, Alice has streamlined the onboarding process by creating a security group with the appropriate permissions needed to access the necessary software. This way, she can simply add each new user to the group, rather than assigning the permissions individually. This is an example of which of the following security concepts?",
    "choice_a": "Least privilege",
    "choice_b": "Zero trust",
    "choice_c": "Role-based access control",
    "choice_d": "Defense in depth",
    "correct_answer": "C",
    "explanation": "Role-based access control (RBAC) works by assigning permissions to specific jobs or job roles. Each new user can then be associated with a role and receive the necessary permissions automatically. When a user leaves a job, removing them from their role revokes the permissions associated with it. Least privilege, zero trust, and defense in depth are all theoretical security concepts, but they are not descriptive of Alice's practice in this regard.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      299,
      203,
      205,
      5,
      290
    ],
    "source": "9781394239306"
  },
  {
    "id": 719,
    "question": "Which of the following statements about the differences between network security groups and security lists is true?",
    "choice_a": "Security lists contain ingress and egress rules that apply to all of the virtual network interface cards (VNICs) in a subnet.",
    "choice_b": "Network security groups can have no more than five member VNICs.",
    "choice_c": "A VNIC can be added to no more than five security lists.",
    "choice_d": "Network security groups can only contain members from their assigned subnet.",
    "correct_answer": "A",
    "explanation": "Security lists are virtual firewalls that contain rules that apply to all of the VNICs on a designated subnet. Network security groups are not limited to five member VNICs and can have members from any subnet in the virtual cloud network. A VNIC can be a member of no more than five network security groups, not security lists.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      290,
      285,
      14,
      16,
      288
    ],
    "source": "9781394239306"
  },
  {
    "id": 720,
    "question": "Which of the following statements about the differences between a NAT gateway and an Internet gateway in a virtual cloud network (VNC) are true? (Choose all that apply.)",
    "choice_a": "A NAT gateway allows traffic from the VNC to reach the Internet but does not allow Internet traffic into the VNC.",
    "choice_b": "A NAT gateway allows VNC traffic both to and from the Internet.",
    "choice_c": "An Internet gateway allows traffic from the VNC to reach the Internet but does not allow Internet traffic into the VNC.",
    "choice_d": "An Internet gateway allows VNC traffic both to and from the Internet.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "A network address translation (NAT) gateway enables elements on a virtual cloud network to connect to services on the Internet but allows no public Internet traffic onto the VNC. An Internet gateway allows traffic in both directions between the VNC and the Internet.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      287,
      116,
      117,
      286,
      290
    ],
    "source": "9781394239306"
  },
  {
    "id": 721,
    "question": "Which of the following pairs of well-known ports are the default values you would use to configure a POP3 email client?",
    "choice_a": "110 and 25",
    "choice_b": "143 and 25",
    "choice_c": "110 and 143",
    "choice_d": "80 and 110",
    "correct_answer": "A",
    "explanation": "The default port for the Post Office Protocol (POP3) is 110. The default port for the Simple Mail Transfer Protocol (SMTP), the other protocol used by email clients, is 25. Port 143 is the default for the Internet Message Access Protocol (IMAP), a different email mailbox protocol that clients never use with POP3. Port 80 is the default for the Hypertext Transfer Protocol (HTTP), which is not used by POP3 email clients.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      78,
      75,
      76,
      72,
      83
    ],
    "source": "9781394239306",
    "choice_e": "25 and 80"
  },
  {
    "id": 722,
    "question": "Which of the following server applications use two well-known port numbers during a typical transaction?",
    "choice_a": "NTP",
    "choice_b": "SNMP",
    "choice_c": "HTTP",
    "choice_d": "FTP",
    "correct_answer": "D",
    "explanation": "The File Transfer Protocol (FTP) uses two port numbers. It uses the first, port 21, for a control connection that remains open during the entire client/server session. The second port, 20, is for a data connection that opens only when the protocol is actually transferring a file between the client and the server. Network Time Protocol (NTP), Simple Network Management Protocol (SNMP), and Hypertext Transfer Protocol (HTTP) all use a single port on the server.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      78,
      73,
      83,
      75,
      18
    ],
    "source": "9781394239306"
  },
  {
    "id": 723,
    "question": "Which of the following protocols does the Ping utility use to exchange messages with another system?",
    "choice_a": "UDP",
    "choice_b": "TCP",
    "choice_c": "ICMP",
    "choice_d": "IGMP",
    "correct_answer": "C",
    "explanation": "Ping uses the Internet Control Message Protocol (ICMP) to exchange messages with other systems. ICMP is also used to return error messages to sending systems. The User Datagram Protocol (UDP) and the Transmission Control Protocol (TCP) are both Transport layer protocols that carry Application layer data; Ping does not use either one. The Internet Group Management Protocol (IGMP) is used to create multicast groups; Ping does not use it.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      79,
      112,
      77,
      72,
      81
    ],
    "source": "9781394239306"
  },
  {
    "id": 724,
    "question": "Which of the following components does the port number in a Transport layer protocol header identify?",
    "choice_a": "A Transport layer protocol",
    "choice_b": "An application",
    "choice_c": "A gateway",
    "choice_d": "A proxy server",
    "correct_answer": "B",
    "explanation": "The port numbers specified in a Transport layer protocol header identify the application that generated the data in the packet or the application that will receive the data. Port numbers do not identify Transport layer protocols, gateways, or proxy servers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      83,
      78,
      19,
      81,
      23
    ],
    "source": "9781394239306"
  },
  {
    "id": 725,
    "question": "Which of the following organizations is responsible for assigning the well-known port numbers used in Transport layer protocol headers?",
    "choice_a": "Institute for Electronic and Electrical Engineers (IEEE)",
    "choice_b": "Internet Assigned Numbers Authority (IANA)",
    "choice_c": "Internet Engineering Task Force (IETF)",
    "choice_d": "International Organization for Standardization (ISO)",
    "correct_answer": "B",
    "explanation": "The IANA assigns values for well-known port numbers. The IEEE publishes Ethernet standards, among many others. The IETF develops standards for Internet technologies. The ISO developed the Open Systems Interconnection (OSI) model.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      78,
      83,
      19,
      17,
      81
    ],
    "source": "9781394239306"
  },
  {
    "id": 726,
    "question": "Which of the following is the default well-known port number for the Hypertext Transfer Protocol (HTTP) used for web client/server communications?",
    "choice_a": "22",
    "choice_b": "20",
    "choice_c": "80",
    "choice_d": "443",
    "correct_answer": "C",
    "explanation": "Port 80 is the default well-known port for HTTP. Port 22 is for the Secure Shell (SSH) protocol, port 20 is for File Transfer Protocol (FTP), and port 443 is for secured HTTP.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      78,
      77,
      73,
      74,
      82
    ],
    "source": "9781394239306"
  },
  {
    "id": 727,
    "question": "The secured version of the Hypertext Transfer Protocol Secure (HTTPS) uses a different well-known port from the unsecured version. Which of the following ports is used by HTTPS by default?",
    "choice_a": "25",
    "choice_b": "80",
    "choice_c": "110",
    "choice_d": "443",
    "correct_answer": "D",
    "explanation": "The well-known port for HTTPS is 443. Port 25 is for the Simple Mail Transfer Protocol (SMTP), port 80 is for unsecured HTTP, and port 110 is for the Post Office Protocol (POP3).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      78,
      77,
      72,
      81,
      17
    ],
    "source": "9781394239306"
  },
  {
    "id": 728,
    "question": "What field in the Transmission Control Protocol (TCP) Option subheader specifies the size of the largest segment a system can receive?",
    "choice_a": "MSS",
    "choice_b": "Window",
    "choice_c": "MMS",
    "choice_d": "WinMS",
    "correct_answer": "A",
    "explanation": "The Maximum Segment Size (MSS) field in the TCP Options subheader specifies the size (in bytes) of the largest segment a system can receive. The Window field indicates the amount of data (in bytes) that the receiver can accept. There are no MMS or WinMS fields in a TCP header.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      82,
      77,
      83,
      23
    ],
    "source": "9781394239306"
  },
  {
    "id": 729,
    "question": "What is the term for the combination of an IPv4 address and a port number, as in the following example: 192.168.1.3:23?",
    "choice_a": "Socket",
    "choice_b": "OUI",
    "choice_c": "Well-known port",
    "choice_d": "Network address",
    "correct_answer": "A",
    "explanation": "The term for an IPv4 address and port number in combination is <i>socket</i>. An organizationally unique identifier (OUI) identifies a manufacturer of networking hardware. A well-known port is a port number assigned to a specific application. A network address is the network identifier part of an IP address. A domain is a group of computers and other resources.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      83,
      78,
      84,
      99,
      36
    ],
    "source": "9781394239306",
    "choice_e": "Domain"
  },
  {
    "id": 730,
    "question": "Which of the following protocols generate messages that are carried directly within Internet Protocol (IPv4) datagrams, with no intervening Transport layer protocol? (Choose all that apply.)",
    "choice_a": "ICMP",
    "choice_b": "IGMP",
    "choice_c": "SMTP",
    "choice_d": "SNMP",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Internet Control Message Protocol (ICMP) and Internet Group Management Protocol (IGMP) are unusual in that they generate messages that are encapsulated directly within IP datagrams. Nearly all of the other TCP/IP protocols, including Simple Mail Transfer Protocol (SMTP) and Simple Network Management Protocol (SNMP), are encapsulated within one of the Transport layer protocols\u2014User Datagram Protocol (UDP) or Transmission Control Protocol (TCP)\u2014which is encapsulated in turn within an IP datagram.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      79,
      81,
      23,
      19,
      72
    ],
    "source": "9781394239306"
  },
  {
    "id": 731,
    "question": "Which of the following protocols is used to exchange directory service information?",
    "choice_a": "RDP",
    "choice_b": "LDAP",
    "choice_c": "SNMP",
    "choice_d": "SMB",
    "correct_answer": "B",
    "explanation": "The Lightweight Directory Access Protocol (LDAP) is an Application layer protocol used for managing and accessing information stored in directory services. The Remote Desktop Protocol (RDP) is used to establish a graphical remote control session with another computer. The Simple Network Management Protocol (SNMP) is used to carry information gathered by management agents distributed around a network to a central management server. Server Message Block (SMB) is the primary file sharing protocol used by Windows systems.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      72,
      82,
      81,
      74
    ],
    "source": "9781394239306"
  },
  {
    "id": 732,
    "question": "Ralph is configuring a new email client on a workstation to use the Simple Mail Transfer Protocol (SMTP) and Post Office Protocol (POP3) email protocols. He wants SMTP to use encryption when communicating with the email server. Which of the following port numbers should Ralph use to create the POP3 connection and secure the SMTP connection with Transport Layer Security (TLS)? (Choose all that apply.)",
    "choice_a": "110",
    "choice_b": "25",
    "choice_c": "587",
    "choice_d": "443",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "SMTP Secure (SMTPS) uses port number 587. POP3 uses port number 110. Port number 25 is used for SMTP without encryption. Port number 443 is used for Hypertext Transfer Protocol Secure (HTTPS).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      78,
      72,
      81,
      75,
      76
    ],
    "source": "9781394239306"
  },
  {
    "id": 733,
    "question": "Which of the following is not a port number used for Structured Query Language (SQL) communications?",
    "choice_a": "1433",
    "choice_b": "1521",
    "choice_c": "3306",
    "choice_d": "3389",
    "correct_answer": "D",
    "explanation": "The port number 3389 is used by the Remote Desktop Protocol (RDP) and is not involved in SQL communication. Port 1433 is used by SQL Server; port 1521 is used by SQLnet; and port 3306 is used by MySQL.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      78,
      83,
      76,
      77,
      82
    ],
    "source": "9781394239306"
  },
  {
    "id": 734,
    "question": "Which of the following port numbers is assigned to a Unix/Linux logging services program?",
    "choice_a": "389",
    "choice_b": "514",
    "choice_c": "636",
    "choice_d": "993",
    "correct_answer": "B",
    "explanation": "Port number 514 is assigned to syslog, a Unix/Linux standard designed to facilitate the transmission of log entries generated by a device or process, such as the sendmail SMTP server, across an IP network to a message collector, called a syslog server. Port number 389 is assigned to the Lightweight Directory Access Protocol (LDAP). Port number 636 is assigned to LDAP over Secure Sockets Layer (SSL). Port number 993 is assigned to Internet Message Access Protocol (IMAP) over SSL.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      78,
      76,
      75,
      72,
      82
    ],
    "source": "9781394239306"
  },
  {
    "id": 735,
    "question": "Which of the following is the primary Application layer protocol used by web browsers to communicate with web servers?",
    "choice_a": "HTTPS",
    "choice_b": "HTML",
    "choice_c": "SMTP",
    "choice_d": "FTP",
    "correct_answer": "A",
    "explanation": "Hypertext Transfer Protocol Secure (HTTPS) is the primary protocol used for web client/server communications. Hypertext Markup Language (HTML) is a coding language used to create web content. Simple Mail Transfer Protocol (SMTP) and File Transfer Protocol (FTP) can both be used in web communications, but neither is the primary protocol.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      72,
      82,
      83,
      81
    ],
    "source": "9781394239306"
  },
  {
    "id": 736,
    "question": "Which of the following protocols appears on the network as a service that client computers use to resolve names into IP addresses?",
    "choice_a": "DHCP",
    "choice_b": "BOOTP",
    "choice_c": "DNS",
    "choice_d": "SNMP",
    "correct_answer": "C",
    "explanation": "The Domain Name System (DNS) is a protocol that computers on a TCP/IP use to resolve host and domain names into the IP addresses they need to communicate. Dynamic Host Configuration Protocol (DHCP) and Bootstrap Protocol (BOOTP) are both IP address allocation protocols, although BOOTP has largely been superseded by DHCP, and Simple Network Management Protocol (SNMP) carries information gathered by agents to a central management console.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      76,
      77,
      36,
      72,
      81
    ],
    "source": "9781394239306"
  },
  {
    "id": 737,
    "question": "Which of the following protocols use the term <i>datagram</i> to describe the data transfer unit they create? (Choose all that apply.)",
    "choice_a": "Ethernet",
    "choice_b": "IP",
    "choice_c": "TCP",
    "choice_d": "UDP",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "The term <i>datagram</i> is typically used by protocols offering connectionless delivery service. The two main connectionless protocols in the TCP/IP suite are the Internet Protocol (IP) and the User Datagram Protocol (UDP), both of which use the term <i>datagram</i>. Ethernet uses the term <i>frame</i>, and Transmission Control Protocol (TCP) uses <i>segment</i>.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      81,
      77,
      79,
      82,
      23
    ],
    "source": "9781394239306"
  },
  {
    "id": 738,
    "question": "What is the native file sharing protocol used on all Microsoft Windows operating systems?",
    "choice_a": "Hypertext Transfer Protocol Secure (HTTPS)",
    "choice_b": "Network File System (NFS)",
    "choice_c": "File Transfer Protocol (FTP)",
    "choice_d": "Server Message Block (SMB)",
    "correct_answer": "D",
    "explanation": "The default file sharing protocol used on all Windows operating systems is SMB. HTTPS is the native protocol used by web clients and servers. NFS is the native file sharing protocol used on Unix/Linux networks. FTP is a protocol used for transferring files from one system to another. LDAP is a protocol for transmitting directory service information.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      73,
      1,
      5,
      3,
      82
    ],
    "source": "9781394239306",
    "choice_e": "Lightweight Directory Access Protocol (LDAP)"
  },
  {
    "id": 739,
    "question": "When analyzing captured TCP/IP packets, which of the following control bits must you look for in the Transmission Control Protocol (TCP) header to determine whether the receiving host has successfully received the sending host's data?",
    "choice_a": "ACK",
    "choice_b": "FIN",
    "choice_c": "PSH",
    "choice_d": "SYN",
    "correct_answer": "A",
    "explanation": "The receiving host uses the ACK bit to notify the sending host that it has successfully received data. The other control bits are not used to acknowledge receipt of information.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      20,
      19,
      81,
      23,
      82
    ],
    "source": "9781394239306",
    "choice_e": "URG"
  },
  {
    "id": 740,
    "question": "Which of the following terms describes the Transmission Control Protocol (TCP) exchange that establishes a connection prior to the transmission of any data?",
    "choice_a": "Synchronization",
    "choice_b": "Initialization exchange",
    "choice_c": "Connection establishment",
    "choice_d": "Three-way handshake",
    "correct_answer": "D",
    "explanation": "Two systems establishing a TCP connection exchange three messages before they begin transmitting data. The exchange of these synchronization messages is referred to as a <i>three-way handshake</i>. The other terms listed are not formally used to describe this exchange.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      77,
      83,
      72,
      82
    ],
    "source": "9781394239306"
  },
  {
    "id": 741,
    "question": "Alice has been instructed to install 100 Windows workstations, and she is working on automating the process by configuring the workstations to use PXE boots. Each workstation therefore must obtain an IP address from a DHCP server and download a boot image file from a TFTP server. Which of the following well-known ports must Alice open on the firewall separating the workstations from the servers? (Choose all that apply.)",
    "choice_a": "65",
    "choice_b": "66",
    "choice_c": "67",
    "choice_d": "68",
    "correct_answer": [
      "C",
      "D",
      "E"
    ],
    "explanation": "Dynamic Host Configuration Protocol (DHCP) servers use port numbers 67 and 68. The Trivial File Transfer Protocol (TFTP) uses port number 69. Neither protocol uses port 65 or 66.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      78,
      75,
      73,
      83,
      77
    ],
    "source": "9781394239306",
    "choice_e": "69"
  },
  {
    "id": 742,
    "question": "Which of the following explanations best describes the function of a Transmission Control Protocol (TCP) or User Datagram Protocol (UDP) port number?",
    "choice_a": "The port number indicates to the receiver that the sender can activate a specific port only.",
    "choice_b": "The port number is used by both the sender and the receiver to identify the application that generated the information in the datagram.",
    "choice_c": "The port number is used only by the receiver, to indicate the application process running on the sender.",
    "choice_d": "The port number is used by both the sender and the receiver to negotiate a well-known server port for the communicating processes.",
    "correct_answer": "B",
    "explanation": "TCP ports and UDP ports identify the application protocol or process that generated the information in a datagram. Client ports are chosen randomly from the range 1024 through 65,535. Server ports are well known and are chosen from the range 1 through 1023.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      83,
      78,
      77,
      75,
      76
    ],
    "source": "9781394239306"
  },
  {
    "id": 743,
    "question": "What is the valid range of numbers for the ephemeral client ports used by the Transmission Control Protocol (TCP) and User Datagram Protocol (UDP)?",
    "choice_a": "1023 through 65,534",
    "choice_b": "0 through 1023",
    "choice_c": "49,152 through 65,535",
    "choice_d": "1024 through 49,151",
    "correct_answer": "C",
    "explanation": "Ephemeral client ports are in the range of 49,152 through 65,535. Well-known TCP and UDP server ports are in the range of 0 through 1023. Registered port numbers are in the range of 1024 through 49,151.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      83,
      77,
      78,
      81,
      20
    ],
    "source": "9781394239306"
  },
  {
    "id": 744,
    "question": "Which of the following statements about the User Datagram Protocol (UDP) are true? (Choose all that apply.)",
    "choice_a": "UDP does not use packet sequencing and acknowledgments.",
    "choice_b": "UDP uses packet sequencing and acknowledgments.",
    "choice_c": "UDP is a connection-oriented protocol.",
    "choice_d": "UDP is a connectionless protocol.",
    "correct_answer": [
      "A",
      "D",
      "E"
    ],
    "explanation": "UDP is a connectionless Transport layer protocol. It has a small, 8-byte header and does not use packet sequencing or acknowledgments.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      77,
      19,
      20,
      82,
      81
    ],
    "source": "9781394239306",
    "choice_e": "UDP has an 8-byte header.",
    "choice_f": "UDP has a 20-byte header."
  },
  {
    "id": 745,
    "question": "Which of the following port values are used by the File Transfer Protocol (FTP)? (Choose all that apply.)",
    "choice_a": "21",
    "choice_b": "23",
    "choice_c": "20",
    "choice_d": "53",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "FTP uses two ports: one for control messages (port 21) and one for data transfers (port 20). Port 23 is used by Telnet. Port 53 is used by the Domain Name System (DNS). Port 69 is used by the Trivial File Transfer Protocol (TFTP).",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      73,
      78,
      77,
      83,
      74
    ],
    "source": "9781394239306",
    "choice_e": "69"
  },
  {
    "id": 746,
    "question": "Which of the following protocols provides connectionless delivery service at the Transport layer of the Open Systems Interconnection (OSI) model?",
    "choice_a": "TCP",
    "choice_b": "HTTP",
    "choice_c": "UDP",
    "choice_d": "ARP",
    "correct_answer": "C",
    "explanation": "The User Datagram Protocol (UDP) provides connectionless service at the Transport layer. Transmission Control Protocol (TCP) provides connection-oriented service at the Transport layer. Hypertext Transfer Protocol (HTTP) is an Application layer protocol, and Address Resolution Protocol (ARP) is a Data link layer protocol.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      77,
      19,
      79,
      83,
      72
    ],
    "source": "9781394239306"
  },
  {
    "id": 747,
    "question": "What is the valid range of numbers for the well-known Transmission Control Protocol (TCP) and User Datagram Protocol (UDP) ports used by servers?",
    "choice_a": "1024 through 49151",
    "choice_b": "1 through 49151",
    "choice_c": "49152 through 65534",
    "choice_d": "1 through 1023",
    "correct_answer": "D",
    "explanation": "Well-known TCP and UDP server ports are in the range of 1 through 1023. Registered port numbers are in the range of 1024 to 49151. Ephemeral client ports are in the range of 49152 through 65535.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      78,
      77,
      83,
      76,
      73
    ],
    "source": "9781394239306"
  },
  {
    "id": 748,
    "question": "Ralph is a network administrator who has just installed a new open-source email server for the users at his company. The server is configured to send and receive Internet email and create a mailbox for each user that will permanently store the user's mail on the server. Ralph next uses a protocol analyzer to examine the network traffic resulting from the new server installation. Which of the following new protocols should Ralph expect to see in his network traffic analysis? (Choose all that apply.)",
    "choice_a": "SNMP",
    "choice_b": "SMTP",
    "choice_c": "POP3",
    "choice_d": "IMAP",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Ralph's traffic analysis should show the addition of the Simple Mail Transfer Protocol (SMTP), which handles incoming and outgoing Internet mail, and Internet Message Access Protocol (IMAP), which provides mailboxes for users that store their mail permanently on the server. POP3 is a mailbox protocol that enables users to download their messages and therefore should not be present on the network. SNMP is a network management protocol, and RIP is a routing protocol; neither of these carries email traffic.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      78,
      18,
      72,
      81,
      83
    ],
    "source": "9781394239306",
    "choice_e": "RIP"
  },
  {
    "id": 749,
    "question": "Which of the following values could a web client use as an ephemeral port number when communicating with a web server?",
    "choice_a": "1",
    "choice_b": "23",
    "choice_c": "80",
    "choice_d": "1024",
    "correct_answer": "F",
    "explanation": "An ephemeral port number is a temporary port supplied by a client to a server, for use during a single session or transaction. The allowed ephemeral port number values range from 49152 to 65535. The port values below 1024 are reserved for use as well-known ports, and the values from 1024 to 49151 are reserved for ports registered by specific manufacturers for their applications. Of these answers, 50134 is the only value that the client can use as an ephemeral port.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      83,
      78,
      117,
      287,
      75
    ],
    "source": "9781394239306",
    "choice_e": "1999",
    "choice_f": "50134"
  },
  {
    "id": 750,
    "question": "Which of the following protocols provides connection-oriented service with guaranteed delivery at the Transport layer of the OSI model?",
    "choice_a": "TCP",
    "choice_b": "UDP",
    "choice_c": "HTTP",
    "choice_d": "IP",
    "correct_answer": "A",
    "explanation": "The Transmission Control Protocol (TCP) provides connection-oriented service at the Transport layer, with guaranteed delivery. The User Datagram Protocol (UDP) provides connectionless service at the Transport layer. Hypertext Transfer Protocol (HTTP) operates at the Application layer, and Internet Protocol (IP) is a connectionless Network layer protocol.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      77,
      19,
      20,
      83,
      82
    ],
    "source": "9781394239306"
  },
  {
    "id": 751,
    "question": "Which of the following protocols is limited to use on the local subnet only?",
    "choice_a": "Address Resolution Protocol (ARP)",
    "choice_b": "Dynamic Host Configuration Protocol (DHCP)",
    "choice_c": "Domain Name System (DNS)",
    "choice_d": "Simple Mail Transfer Protocol (SMTP)",
    "correct_answer": "A",
    "explanation": "ARP relies on broadcast transmissions, which are not routable. It is therefore limited to use on the local subnet. DHCP also relies on broadcasts, but the ability to create DHCP relay agents makes it usable on an entire internetwork. DNS and SMTP do not rely on broadcasts and therefore are not limited to the local subnet. GRE is a tunneling protocol used to establish secure point-to-point links between devices on different networks.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      36,
      37,
      75,
      76,
      80
    ],
    "source": "9781394239306",
    "choice_e": "Generic Routing Encapsulation (GRE)"
  },
  {
    "id": 752,
    "question": "Which of the following prefixes must you use in the URL you type into a web browser when the website you want to access has been secured with Transport Layer Security (TLS)?",
    "choice_a": "TLS://",
    "choice_b": "HTTPS://",
    "choice_c": "HTTP://",
    "choice_d": "HTLS://",
    "correct_answer": "B",
    "explanation": "No matter what protocol is used to encrypt a website, you must use the HTTPS:// prefix to access it. HTTP:// is for unencrypted sites, and TLS:// and HTLS:// are nonexistent prefixes.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      74,
      73,
      72,
      83
    ],
    "source": "9781394239306"
  },
  {
    "id": 753,
    "question": "What is the difference when you specify the HTTPS:// prefix in a Uniform Resource Locator (URL) instead of HTTP://? (Choose all that apply.)",
    "choice_a": "The connection between the web browser and the server is encrypted.",
    "choice_b": "The browser uses a different port number to connect to the server.",
    "choice_c": "The connection uses SSL or TLS instead of HTTP.",
    "choice_d": "The browser uses a different IP address to connect to the server.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Using the prefix HTTPS:// causes a web browser to use a different port number to establish a secure connection to the web server. Security is provided by encrypting all data using Secure Sockets Layer (SSL) or Transport Layer Security (TLS). However, SSL and TLS do not replace HTTP; they just augment it. The HTTPS:// prefix does not affect the IP address used to connect to the server.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      83,
      18,
      80,
      74,
      19
    ],
    "source": "9781394239306"
  },
  {
    "id": 754,
    "question": "You are a consultant installing a web server application for a client called Adatum. The domain name <a href=\"http://www.Adatum.com\"><code>Adatum.com</code></a> has been registered in the DNS, and the server has one public IP address, so the new website will be accessible to users on the Internet. You want to be able to access the web server application's administrative site from your remote office, so you configure that site to be encrypted and to use the port number 12354 instead of the default. Which of the following URLs will you have to use to access the administrative website?",
    "choice_a": "www.adatum.com",
    "choice_b": "www.adatum.com:12354",
    "choice_c": "www.adatum.com:80",
    "choice_d": "www.adatum.com:12354",
    "correct_answer": "D",
    "explanation": "Because the administrative site is encrypted, you must use the HTTPS:// prefix to access it. Because the administrative site uses the nondefault port number 12354, you must append that number to the server name with a colon.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      78,
      18,
      76,
      83,
      74
    ],
    "source": "9781394239306"
  },
  {
    "id": 755,
    "question": "Which of the following protocols does IPsec use to digitally encrypt packets before transmitting them over the network?",
    "choice_a": "ESP",
    "choice_b": "SSL",
    "choice_c": "AH",
    "choice_d": "IKE",
    "correct_answer": "A",
    "explanation": "Encapsulating Security Protocol (ESP) is a protocol in the TCP/IP suite that is capable of providing encryption services for IPsec. Authentication Header (AH) provides digital integrity services for IPsec, in the form of a digital signature. Secure Sockets Layer (SSL) is a security protocol that provides encrypted communications between web browsers and servers. Internet Key Exchange (IKE) is a security protocol that IPsec uses to create security associations that specify agreed-upon policies between systems.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      80,
      97,
      81,
      23,
      82
    ],
    "source": "9781394239306"
  },
  {
    "id": 756,
    "question": "Which of the following are the protocols that IPsec uses to secure network traffic? (Choose all that apply.)",
    "choice_a": "SSH",
    "choice_b": "AH",
    "choice_c": "ESP",
    "choice_d": "SSL",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Authentication Header (AH) is an IPsec protocol that provides authentication and digital integrity services. Encapsulating Security Protocol (ESP) provides encryption services for IPsec. Secure Shell (SSH) is a remote administration tool, and Transport Layer Security (TLS) is a protocol that provides encrypted communications between web browsers and servers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      80,
      97,
      74,
      73,
      286
    ],
    "source": "9781394239306"
  },
  {
    "id": 757,
    "question": "What is the primary shortcoming of the File Transfer Protocol (FTP) that is addressed by FTPS and SFTP?",
    "choice_a": "Lack of security",
    "choice_b": "Slow file transfers",
    "choice_c": "File size limitations",
    "choice_d": "Lack of authentication",
    "correct_answer": "A",
    "explanation": "FTP does provide authentication capabilities, but passwords are transmitted over the network in cleartext, which is an unacceptable security condition. FTP Secure (FTPS) adds security in the form of the Transport Layer Security (TLS) protocol. SSH File Transfer Protocol (SFTP) uses Secure Shell (SSH) security. File transfer speed and size limitations are not an issue.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      73,
      74,
      80,
      18,
      19
    ],
    "source": "9781394239306"
  },
  {
    "id": 758,
    "question": "Which of the following File Transfer Protocol (FTP) variants do not transmit authentication passwords over the network in cleartext?",
    "choice_a": "FTP",
    "choice_b": "FTPS",
    "choice_c": "SFTP",
    "choice_d": "TFTP",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "FTPS adds security to FTP in the form of the Transport Layer Security (TLS) and Secure Sockets Layer (SSL) protocols. SFTP uses Secure Shell (SSH) for security. Both of these encrypt authentication passwords before transmitting them. FTP transmits passwords over the network in cleartext, which is an unacceptable security condition. Trivial File Transfer Protocol (TFTP) does not authenticate clients, so it does not transmit passwords at all.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      73,
      74,
      80,
      19,
      81
    ],
    "source": "9781394239306"
  },
  {
    "id": 759,
    "question": "Which of the following File Transfer Protocol (FTP) variants is typically used to download boot image files during Preboot Execution Environment (PXE) startup sequences?",
    "choice_a": "FTP",
    "choice_b": "FTPS",
    "choice_c": "SFTP",
    "choice_d": "TFTP",
    "correct_answer": "D",
    "explanation": "Trivial File Transfer Protocol (TFTP) is a simplified version of FTP that does not authenticate clients, so systems booting with PXE can download boot images invisibly after being directed to a TFTP server by the Dynamic Host Configuration Protocol (DHCP). FTP, FTPS, and SFTP all require authentication and other interaction, which would be impractical for use with PXE.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      73,
      78,
      72,
      77,
      23
    ],
    "source": "9781394239306"
  },
  {
    "id": 760,
    "question": "Which of the following protocols does IPsec use to digitally sign packets before transmitting them over the network?",
    "choice_a": "ESP",
    "choice_b": "SSL",
    "choice_c": "AH",
    "choice_d": "IKE",
    "correct_answer": "C",
    "explanation": "Authentication Header (AH) is a protocol in the TCP/IP suite that provides digital integrity services in the form of a digital signature, which ensures that an incoming packet actually originated from its stated source. Encapsulating Security Protocol (ESP) provides encryption services for IPsec. Secure Sockets Layer (SSL) is a security protocol that provides encrypted communications between web browsers and servers. Internet Key Exchange (IKE) is a security protocol that IPsec uses to create security associations that specify agreed-upon policies between systems.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      80,
      97,
      72,
      81,
      23
    ],
    "source": "9781394239306"
  },
  {
    "id": 761,
    "question": "Which of the following security protocols used to protect traffic exchanged by web browsers and servers was created first?",
    "choice_a": "SSL",
    "choice_b": "TLS",
    "choice_c": "SSH",
    "choice_d": "DTLS",
    "correct_answer": "A",
    "explanation": "Secure Sockets Layer (SSL) is the original security protocol for web servers and browsers and the predecessor of Transport Layer Security (TLS). Datagram Transport Layer Security (DTLS) is a protocol that provides the same encryption and other web server/browser security functions as TLS, but for User Datagram Protocol (UDP) traffic. Secure Shell (SSH) is a character-based tool that enables users to execute commands on remote computers. It does not provide web server or browser security.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      72,
      19,
      73,
      80
    ],
    "source": "9781394239306"
  },
  {
    "id": 762,
    "question": "Which of the following security protocols for web servers or browsers was deprecated in 2015 in favor of Transport Layer Security (TLS) and Datagram Transport Layer Security (DTLS)?",
    "choice_a": "SSH",
    "choice_b": "SSL",
    "choice_c": "RDP",
    "choice_d": "IPsec",
    "correct_answer": "B",
    "explanation": "Secure Sockets Layer (SSL) is the original security protocol for web servers and browsers and the predecessor of TLS. It was deprecated in 2015. Secure Shell (SSH) is a character-based tool that enables users to execute commands on remote computers. It does not provide web server or browser security like TLS and DTLS. IPsec is a set of security protocols that provide digital signing, encryption, and other services for network transmissions. It is not specifically designed for web security. Remote Desktop Protocol (RDP) is a component of Remote Desktop Services, a Windows mechanism that enables a client program to connect to a server and control it remotely. RDP is not a web security protocol.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      78,
      73,
      77,
      72,
      80
    ],
    "source": "9781394239306"
  },
  {
    "id": 763,
    "question": "What must you do to configure a firewall to admit File Transfer Protocol (FTP) traffic to the internal network using its default port settings? (Choose all that apply.)",
    "choice_a": "Open port 20",
    "choice_b": "Open port 21",
    "choice_c": "Open port 22",
    "choice_d": "Open port 23",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "The FTP protocol uses two well-known ports: 20 and 21. A firewall must have both of these ports open to admit FTP traffic. FTP does not require ports 22, 23, or 24.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      78,
      73,
      77,
      83,
      82
    ],
    "source": "9781394239306",
    "choice_e": "Open port 24"
  },
  {
    "id": 764,
    "question": "Which of the following protocols uses a form of flow control called the sliding window technique?",
    "choice_a": "UDP",
    "choice_b": "HTTP",
    "choice_c": "TCP",
    "choice_d": "SIP",
    "correct_answer": "C",
    "explanation": "The Transmission Control Protocol (TCP) uses a flow control technique in which the receiving system creates a window of a specific size and allows the transmitting system to send packets until that window is full. When the window is full, the sender stops transmitting. The receiver then sends back an acknowledgment packet that specifies the next packet it expects to receive from the sender. The User Datagram Protocol (UDP), Hypertext Transfer Protocol (HTTP), and Session Initiation Protocol (SIP) do not use the sliding window technique or any other form of flow control.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      20,
      19,
      77,
      23,
      72
    ],
    "source": "9781394239306"
  },
  {
    "id": 765,
    "question": "Which of the following Transmission Control Protocol (TCP) control bits is set to 1 to initiate the termination of a session?",
    "choice_a": "SYN",
    "choice_b": "URG",
    "choice_c": "FIN",
    "choice_d": "END",
    "correct_answer": "C",
    "explanation": "The termination phase of a TCP connection begins when either the client or the server sends a message containing the FIN control bit with a value of 1. The other control bits listed have nothing to do with the connection termination procedure, and there is no END bit.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      81,
      23,
      82,
      72
    ],
    "source": "9781394239306",
    "choice_e": "PSH"
  },
  {
    "id": 766,
    "question": "A client on a TCP/IP network is attempting to establish a session with a server. Which of the following correctly lists the order of the TCP flags raised in the Transmission Control Protocol (TCP) session establishment messages?",
    "choice_a": "SYN, ACK, SYN, ACK",
    "choice_b": "SYN, SYN, ACK, ACK",
    "choice_c": "SYN/ACK, SYN/ACK",
    "choice_d": "SYN, SYN/ACK, ACK",
    "correct_answer": "D",
    "explanation": "The TCP connection establishment exchange is a three-way handshake that uses TCP flags to specify the message type for each frame. The first frame contains a SYN flag from the client; the second frame contains the SYN and ACK flags from the server; and the last frame contains an ACK flag from the client.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      77,
      20,
      81,
      17
    ],
    "source": "9781394239306"
  },
  {
    "id": 767,
    "question": "Which of the following traffic types is used exclusively on IPv6 networks?",
    "choice_a": "Unicast",
    "choice_b": "Broadcast",
    "choice_c": "Multicast",
    "choice_d": "Anycast",
    "correct_answer": "D",
    "explanation": "Anycast addresses are IPv6-only addresses designed to transmit to any one host in a multicast group. Unicast, broadcast, and multicast addresses are all traffic types used by both IPv4 and IPv6 networks.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      100,
      93,
      99,
      97,
      88
    ],
    "source": "9781394239306"
  },
  {
    "id": 768,
    "question": "Which of the following best describes the function of the network medium?",
    "choice_a": "The network medium provides the physical connection between networked computers.",
    "choice_b": "The network medium provides the protocol used to transmit data between end systems.",
    "choice_c": "The network medium passes data packets between two routers.",
    "choice_d": "The network medium processes electrical or light signals and converts them to data.",
    "correct_answer": "A",
    "explanation": "The network medium provides the physical connection between networked computers. This connection can be made through a copper-based, fiber-optic, or wireless medium. The network medium is not a protocol, and it does not pass data packets; it only carries signals. The network medium does not process electrical or light pulses and convert them to data; it carries only the signals generated by transceivers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      17,
      44,
      82,
      37
    ],
    "source": "9781394239306"
  },
  {
    "id": 769,
    "question": "Which of the following signal types is carried by copper cable?",
    "choice_a": "Fiber-optic",
    "choice_b": "Microwave",
    "choice_c": "Infrared",
    "choice_d": "Electrical",
    "correct_answer": "D",
    "explanation": "Copper cables use electrical signals to transmit data. Fiber-optic is a cable type, not a signal type. Microwave signals cannot be transmitted over copper cable. Infrared signals are used only for wireless networks.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      82,
      26,
      30,
      24,
      25
    ],
    "source": "9781394239306"
  },
  {
    "id": 770,
    "question": "Identify the organizations that developed the general cable type standards for voice and data communications that are currently in use and identify their document names.",
    "choice_a": "ANSI/TVA, document C568",
    "choice_b": "TWA/ANSI/EIA, document T530-A",
    "choice_c": "EIA/ANSI/TWA, document 802.2",
    "choice_d": "TDA/EIA/TIA, document 802.11",
    "correct_answer": "E",
    "explanation": "The three organizations that collectively developed the T568b document, which defines the standard for a structured cabling system for voice and data communications, are the American National Standards Institute (ANSI), the Telecommunications Industry Association (TIA), and the Electronic Industries Association (EIA). None of the other options are standards organizations or cabling standards.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      27,
      32,
      26,
      44,
      25
    ],
    "source": "9781394239306",
    "choice_e": "ANSI/TIA/EIA, document T568b"
  },
  {
    "id": 771,
    "question": "Which of the following cable types and connectors are used to attach a television set to a cable television (CATV) network?",
    "choice_a": "A multimode fiber-optic cable and a Straight Tip (ST) connector",
    "choice_b": "A coaxial cable and a Bayonet-Neill-Concelman (BNC) connector",
    "choice_c": "A twisted-pair cable and an RJ-45 connector",
    "choice_d": "A coaxial cable and an F-type connector",
    "correct_answer": "D",
    "explanation": "The cable type and connector used to attach a television set to a CATV network is a coaxial cable with a screw-on F-type connector. Although CATV networks typically use fiber-optic cables and ST connectors for outdoor connections, they do not use fiber for internal connections to television sets. Coaxial cables with BNC connectors are most commonly used for Thin Ethernet LANs, not CATV network connections. Twisted-pair cables and RJ-45 connectors are used for Ethernet LANs and telephone networks, but not CATV networks. AUI cables and vampire tap connectors are used for Thick Ethernet networks. Twinaxial cables are used for SATA 3.0 devices and 100 Gbit Ethernet connections, but not for CATV connections.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      25,
      28,
      31,
      44,
      49
    ],
    "source": "9781394239306",
    "choice_e": "An AUI cable and a vampire tap connector",
    "choice_f": "A twinaxial cable and a Bayonet-Neill-Concelman (BNC) connector"
  },
  {
    "id": 772,
    "question": "Which of the following cable types is used for Thick Ethernet network segments?",
    "choice_a": "RG-8",
    "choice_b": "RG-58",
    "choice_c": "RJ-45",
    "choice_d": "RJ-11",
    "correct_answer": "A",
    "explanation": "The cable type used for Thick Ethernet segments is a coaxial cable called RG-8. RG-58 is used exclusively on Thin Ethernet segments. RJ-45 is a connector type used in twisted-pair cabling for data networks. RJ-11 is a connector type used in twisted-pair cabling for telecommunications networks.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      45,
      25,
      31,
      12,
      44
    ],
    "source": "9781394239306"
  },
  {
    "id": 773,
    "question": "Which of the following cable types is used for Thin Ethernet network segments?",
    "choice_a": "RG-8",
    "choice_b": "RG-58",
    "choice_c": "RJ-45",
    "choice_d": "RJ-11",
    "correct_answer": "B",
    "explanation": "RG-58 coaxial cable is used exclusively for Thin Ethernet segments. RG-8 cable is used for Thick Ethernet segments. RJ-45 is a connector type used in twisted-pair cabling for data networks. RJ-11 is a connector type used in twisted-pair cabling for telecommunications networks.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      45,
      25,
      31,
      12,
      44
    ],
    "source": "9781394239306"
  },
  {
    "id": 774,
    "question": "Which of the following coaxial cable types are still in general use? (Choose all that apply.)",
    "choice_a": "RG-6",
    "choice_b": "RG-8",
    "choice_c": "RG-58",
    "choice_d": "RG-59",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "RG-6 and RG-59 are 75-ohm cables that are still used for cable television and similar connections. RG-8 and RG-58 are 50-ohm cables that were formerly used for Thick Ethernet and Thin Ethernet, respectively, but are no longer in general use.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      25,
      28,
      31,
      45,
      46
    ],
    "source": "9781394239306"
  },
  {
    "id": 775,
    "question": "Which of the following statements about the differences between fiber-optic Angled Physical Contact (APC) and Ultra Physical Contact (UPC) connectors are true? (Choose all that apply.)",
    "choice_a": "APCs should only be joined to other APCs.",
    "choice_b": "APCs generate more insertion loss than UPCs.",
    "choice_c": "UPCs generate more return loss than APCs.",
    "choice_d": "UPCs use a green connector boot or body.",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Joining an APC to a UPC creates a mismatched connection that generates an extremely high rate of insertion loss (attenuation). APCs do generate more insertion loss than UPCs and less return loss (reflection). It is APCs, not UPCs, that use green boots or bodies on the connectors.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      29,
      22,
      44,
      82
    ],
    "source": "9781394239306"
  },
  {
    "id": 776,
    "question": "Which of the following is not a type of fiber-optic connector?",
    "choice_a": "SC",
    "choice_b": "MT-RJ",
    "choice_c": "ST",
    "choice_d": "BNC",
    "correct_answer": "D",
    "explanation": "Bayonet-Neill-Concelman (BNC) is a type of connector used with coaxial cable. Subscriber Connector (SC), Mechanical Transfer-Registered Jack (MT-RJ), Local Connector (LC), and Straight Tip (ST) are all types of fiber-optic connectors.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      28,
      25,
      29,
      43,
      44
    ],
    "source": "9781394239306",
    "choice_e": "LC"
  },
  {
    "id": 777,
    "question": "Which of the following Physical layer transceiver module standards is the oldest and therefore the most obsolete?",
    "choice_a": "SFP",
    "choice_b": "SFP+",
    "choice_c": "GBIC",
    "choice_d": "QSFP",
    "correct_answer": "C",
    "explanation": "The Gigabit Interface Converter (GBIC) transceiver standard was first published in 1995 and defines a maximum data transfer rate of 1.25 Gbps. It was rendered all but obsolete by the Small Form-factor Pluggable (SFP) standard, introduced in 2001, which ran at the same maximum speed but was smaller in size. Subsequent variations on the standard, such as SFP+, Quad Small Form-factor Pluggable (QSFP), and QSFP+, defined devices with faster transfer rates.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      29,
      46,
      22,
      44,
      81
    ],
    "source": "9781394239306",
    "choice_e": "QSFP+"
  },
  {
    "id": 778,
    "question": "Which of the following cable types is typically configured in a star/hub and spoke topology, uses eight copper conductors arranged in four pairs, and uses RJ-45 connectors?",
    "choice_a": "RG-8",
    "choice_b": "Twisted-pair",
    "choice_c": "RG-58",
    "choice_d": "Fiber-optic",
    "correct_answer": "B",
    "explanation": "There are two main types of twisted-pair wiring used for data communications: unshielded twisted-pair (UTP) and shielded twisted-pair (STP). Both types can be used in a star/hub and spoke topology. UTP and STP cables contain eight copper conductors twisted in four pairs. UTP and STP cables use RJ-45 connectors to connect end systems to switches, patch panels, and wall plates. RG-8 and RG-58 coaxial cable can only be used in a bus topology. Fiber-optic cable can be used in a star/hub and spoke topology, but it uses either glass or plastic conductors and does not use RJ-45 connectors.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      26,
      27,
      28,
      25,
      45
    ],
    "source": "9781394239306"
  },
  {
    "id": 779,
    "question": "Which of the following statements explains the purpose of the twists in twisted-pair cabling?",
    "choice_a": "The twists prevent collisions.",
    "choice_b": "The twists completely eliminate crosstalk and electromagnetic interference (EMI) in adjacent wire pairs.",
    "choice_c": "The twists prevent crosstalk in adjacent wire pairs and limit the effects of EMI on the signals carried over the cable.",
    "choice_d": "The twists extend the bend radius allowance of the cable.",
    "correct_answer": "C",
    "explanation": "The twists in a twisted-pair cable prevent the signals on the different wires from interfering with each other (which is called crosstalk) and also provide resistance to outside electromagnetic interference. The twists have no effect on collisions. The twists cannot completely eliminate the effects of EMI. Twists have nothing to do with the bend radius allowance for the cable.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      26,
      27,
      33,
      24,
      17
    ],
    "source": "9781394239306"
  },
  {
    "id": 780,
    "question": "Which of the following combinations of attributes describes the cable used for a Thin Ethernet network?",
    "choice_a": "RJ-45, 50-ohm, 0.270-inch, coaxial cable with BNC connectors",
    "choice_b": "RG-59, 75-ohm, 0.242-inch, coaxial cable with F connectors",
    "choice_c": "RG-58, 50-ohm, 0.195-inch, coaxial cable with BNC connectors",
    "choice_d": "RG-8, 50-ohm, 0.405-inch, coaxial cable with N connectors",
    "correct_answer": "C",
    "explanation": "Thin Ethernet networks use a type of 50-ohm coaxial cable called RG-58, which is 0.195 inches in diameter and uses BNC connectors. A 75-ohm coaxial cable with F-type connectors is used for cable television networks, and RG-8 coaxial is the cable that Thick Ethernet networks use.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      45,
      25,
      31,
      44,
      46
    ],
    "source": "9781394239306",
    "choice_e": "RJ-6, 75-ohm, 0.242-inch, coaxial cable with BNC connectors"
  },
  {
    "id": 781,
    "question": "Which of the following connector types are typically associated with Ethernet networks? (Choose all that apply.)",
    "choice_a": "F-type",
    "choice_b": "BNC",
    "choice_c": "DB-9",
    "choice_d": "RJ-45",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Thin Ethernet networks use coaxial cables with Bayonet Neill\u2013Concelman (BNC) connectors. All unshielded twisted-pair (UTP) Ethernet networks use RJ-45 connectors. F-type connectors are used with coaxial cable, typically for cable television installations, but not for Ethernet. DB-9 connectors are commonly used for serial communications ports.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      25,
      27,
      45,
      33,
      32
    ],
    "source": "9781394239306"
  },
  {
    "id": 782,
    "question": "Which of the following connector types was typically associated with a T-connector attached to the computer?",
    "choice_a": "RJ-45",
    "choice_b": "MT-RJ",
    "choice_c": "8P8C",
    "choice_d": "BNC",
    "correct_answer": "D",
    "explanation": "Thin Ethernet networks use a type of coaxial cable that runs from each computer to the next one, forming a bus topology. To connect the cable to the network computers, each network interface adapter has a T-connector attached to it, with two additional male Bayonet Neill\u2013Concelman (BNC) connectors, to which you connect two lengths of network cabling.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      25,
      45,
      44,
      40,
      33
    ],
    "source": "9781394239306",
    "choice_e": "F"
  },
  {
    "id": 783,
    "question": "Which of the following connector types are associated with fiber-optic cables? (Choose all that apply.)",
    "choice_a": "RJ-11",
    "choice_b": "ST",
    "choice_c": "F",
    "choice_d": "LC",
    "correct_answer": [
      "B",
      "D",
      "E",
      "F"
    ],
    "explanation": "Fiber-optic cable connectors all function on the same basic principles, but there are a variety of form factors from which to choose, including Straight Tip (ST), Local Connector (LC), and Mechanical Transfer\u2013Registered Jack (MT-RJ). Multi-fiber Push On (MPO) is a fiber array connector that gathers multiple optical fibers into a single connection. RJ-11 is a twisted-pair cable connector, and F connectors are for coaxial cable.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      27,
      25,
      29,
      33
    ],
    "source": "9781394239306",
    "choice_e": "MT-RJ",
    "choice_f": "MPO"
  },
  {
    "id": 784,
    "question": "Which of the following types of cable, when installed, sometimes employed a device called a vampire tap?",
    "choice_a": "Unshielded twisted-pair",
    "choice_b": "Shielded twisted-pair",
    "choice_c": "Multimode fiber-optic",
    "choice_d": "Single-mode fiber-optic",
    "correct_answer": "E",
    "explanation": "Thick Ethernet installations used a type of coaxial cable called RG-8. To connect a node to the network, installers ran a separate cable called an Attachment Unit Interface (AUI) cable from the computer to the RG-8 and connected it using a device called a vampire tap that pierced the sheathing to make contact with the conductors within. All of the other cable types listed use different types of connectors.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      44,
      45,
      25,
      28,
      40
    ],
    "source": "9781394239306",
    "choice_e": "Coaxial"
  },
  {
    "id": 785,
    "question": "Which of the following statements about single-mode and multimode fiber-optic cables are true? (Choose all that apply.)",
    "choice_a": "Single-mode cables can span longer distances than multimode cables.",
    "choice_b": "Single-mode cables are more resistant to electromagnetic interference than multimode cables.",
    "choice_c": "Single-mode cables are more difficult to install than multimode cables.",
    "choice_d": "Single-mode cables have a much larger core diameter than multimode cables.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Single-mode cables are capable of spanning longer distances than multimode because they have a narrower core diameter, reducing signal dispersion rates. Because the core consists of fewer (typically one or two) strands, single-mode cables are less flexible than multimode and cannot bend around corners as easily, making them more difficult to install. Because they use light impulses rather than electricity, all fiber-optic cables are completely immune to electromagnetic interference.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      28,
      29,
      46,
      45,
      44
    ],
    "source": "9781394239306"
  },
  {
    "id": 786,
    "question": "Which of the following components are typically used only for telephone cable installations, and not for data networking? (Choose all that apply.)",
    "choice_a": "66 blocks",
    "choice_b": "110 blocks",
    "choice_c": "25 pair UTP cables",
    "choice_d": "100 pair UTP cables",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Voice telephone networks do not have performance requirements as strict as those of data networks, so they are less liable to suffer from crosstalk and other types of interference. As a result, installers often use larger UTP cables for telephone connections. UTP cables are available in configurations containing 25 wire pairs and 100 wire pairs in a single sheath, which enables installers to service multiple users with a single cable. The punchdown blocks for UTP data networks with 8P8C connectors are called 110 blocks. The older standard for punchdown blocks is the 66 block. Rarely used for data networking, 66 blocks are still found in many telephone service installations.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      35,
      27,
      26,
      32,
      33
    ],
    "source": "9781394239306"
  },
  {
    "id": 787,
    "question": "Which of the following statements about single-mode fiber-optic cable are true? (Choose all that apply.)",
    "choice_a": "Single-mode cables use an LED light source, whereas multimode cables use a laser.",
    "choice_b": "Single-mode cables can span longer distances than multimode cables.",
    "choice_c": "Single-mode cables have a smaller core filament than multimode cables.",
    "choice_d": "Single-mode cables have a smaller bend radius than multimode cables, making them easier to install.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Single-mode cables have a smaller core filament and can span longer distances than multimode cables. Single-mode cables also use a laser light source, have a larger bend radius, and do not require a ground.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      29,
      46,
      45,
      26
    ],
    "source": "9781394239306",
    "choice_e": "Single-mode fiber-optic cables require a ground, whereas multimode cables do not."
  },
  {
    "id": 788,
    "question": "Which of the following tools do cable installers use to connect bulk cable runs to wall plates and patch panels?",
    "choice_a": "A crimper",
    "choice_b": "A splicer",
    "choice_c": "A pigtail",
    "choice_d": "A punchdown block tool",
    "correct_answer": "D",
    "explanation": "Installers use a punchdown block tool to connect the ends of bulk cable runs to jacks in wall plates and patch panels. A crimper or crimping tool is a jawed device that enables installers to squeeze the two halves of an RJ-45 or RJ-11 connector together, securing the connector to the cable. Installers use a splicing tool to splice two cable segments together. There is no tool called a pigtail.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      35,
      27,
      26,
      33,
      34
    ],
    "source": "9781394239306"
  },
  {
    "id": 789,
    "question": "Ralph has been hired by a client to install cabling to connect two existing networks. The two networks are in different buildings approximately 1,000 feet apart. The cable type must support Gigabit Ethernet data rates of 1,000 megabits per second (Mbps) and provide a high level of resistance to electromagnetic interference (EMI). Your client wants the most economical cabling solution that meets their needs. Which of the following cable types best meets the needs of this client?",
    "choice_a": "Multimode fiber-optic cable",
    "choice_b": "Shielded twisted-pair (STP) cable",
    "choice_c": "Unshielded twisted-pair (UTP) cable",
    "choice_d": "Thin coaxial cable",
    "correct_answer": "A",
    "explanation": "Multimode fiber-optic cable best meets the client's needs. Fiber-optic cable supports the required 1,000 Mbps data rate and can connect networks that are more than 1,000 feet apart. Fiber-optic cable is immune to EMI. Although both multimode and single-mode fiber would meet the corporation's general needs, multimode is best in this scenario because it is less expensive than single-mode fiber. Twisted-pair wiring (STP or UTP) meets the data rate and cost requirements but does not support connections longer than 100 meters. Thin coaxial cable does not support the data rate or distances longer than 185 meters.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      28,
      31,
      46,
      47,
      26
    ],
    "source": "9781394239306",
    "choice_e": "Single-mode fiber-optic cable"
  },
  {
    "id": 790,
    "question": "Which of the following are connector types used with coaxial cables? (Choose all that apply.)",
    "choice_a": "BNC",
    "choice_b": "F-type",
    "choice_c": "N-type",
    "choice_d": "ST",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Bayonet Neill\u2013Concelman (BNC) connectors are used for coaxial Thin Ethernet networks, and N-type connectors with Thick Ethernet. F-type connectors are used for coaxial cable television installations. Straight Tip (ST) connectors are used with fiber-optic cable, and RJ-11 connectors are used for telephone installations.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      25,
      28,
      45,
      44,
      27
    ],
    "source": "9781394239306",
    "choice_e": "RJ-11"
  },
  {
    "id": 791,
    "question": "In the punchdown process for unshielded twisted-pair (UTP) cable, which of the following is the last step that you perform when connecting bulk cables to jacks in wall plates and patch panels?",
    "choice_a": "Cut off the excess wire that protrudes past the contacts.",
    "choice_b": "Press the bare wire down between the two metal contacts that hold it in place.",
    "choice_c": "Strip some of the insulating sheath off the cable end to expose the wires.",
    "choice_d": "Insert the wires into the appropriate contacts in the jack.",
    "correct_answer": "A",
    "explanation": "You use a punchdown block tool to connect the ends of bulk cable runs to jacks in wall plates and patch panels. The steps of the process are as follows: <ol><li>Strip some of the sheath off the cable end to expose the wires.</li><li>Separate the twisted wire pairs at the ends.</li><li>Strip a small amount of insulation off each wire.</li><li>Insert the wires into the appropriate contacts in the jack.</li><li>Press the bare wire down between the two metal contacts that hold it in place.</li><li>Cut off the excess wire that protrudes past the contacts.</li></ol><p>You must repeat the process of punching down for both ends of your internal cable runs.</p>",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      27,
      26,
      35,
      32,
      33
    ],
    "source": "9781394239306",
    "choice_e": "Strip a small amount of insulation off each wire.",
    "choice_f": "Separate the twisted wire pairs at the ends."
  },
  {
    "id": 792,
    "question": "Which of the following cable connector types is not used with fiber-optic cable?",
    "choice_a": "Straight Tip (ST)",
    "choice_b": "Subscriber Connector (SC)",
    "choice_c": "Mechanical Transfer\u2013Registered Jack (MT-RJ)",
    "choice_d": "F-type",
    "correct_answer": "D",
    "explanation": "ST, SC, fiber LC, and MT-RJ are all connectors used with fiber-optic cables. F-type connectors are used with coaxial cables.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      28,
      25,
      31,
      46,
      26
    ],
    "source": "9781394239306",
    "choice_e": "Fiber Local Connector (LC)"
  },
  {
    "id": 793,
    "question": "Which of the following cable connector types have been rendered nearly obsolete by Universal Serial Bus (USB) connections? (Choose all that apply.)",
    "choice_a": "BNC",
    "choice_b": "RJ-11",
    "choice_c": "DB-9",
    "choice_d": "DB-25",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The DB-9 and DB-25 connectors were at one time ubiquitous on personal computers, providing peripheral connections to modems, printers, and other devices. They have since been largely eliminated in favor of USB. Bayonet Neill\u2013Concelman (BNC) connectors were used for Thin Ethernet networking, but they have been replaced by unshielded twisted-pair (UTP) cable with RJ-45 connectors. RJ-11 connectors are used for telephone connections.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      30,
      25,
      45,
      27,
      28
    ],
    "source": "9781394239306"
  },
  {
    "id": 794,
    "question": "Which of the following cable types are typically used in newly constructed local area network (LAN) installations? (Choose all that apply.)",
    "choice_a": "Single-mode fiber-optic",
    "choice_b": "Multimode fiber-optic",
    "choice_c": "Coaxial",
    "choice_d": "Unshielded twisted-pair",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "The main cable types used in LANs today are multimode fiber-optic and unshielded twisted-pair. Single-mode fiber-optic is used primarily for long-distance wide area network (WAN) connections, and coaxial cable is no longer used for LANs.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      26,
      28,
      25,
      45,
      2
    ],
    "source": "9781394239306"
  },
  {
    "id": 795,
    "question": "Which of the following statements are true about coaxial cable? (Choose all that apply.)",
    "choice_a": "Coaxial cable has three conductors within the same sheath.",
    "choice_b": "Coaxial cable has two conductors within the same sheath.",
    "choice_c": "Coaxial cable has a copper core that carries light pulse signals.",
    "choice_d": "Coaxial cable has a copper core that carries electrical signals.",
    "correct_answer": [
      "B",
      "D",
      "F"
    ],
    "explanation": "Coaxial cable has two conductors within the same sheath that share a common axis. These conductors are surrounded by an outer insulating sheath of either PVC or Teflon. Copper cables carry electrical signals. Only fiber-optic cables carry light pulse signals.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      25,
      26,
      28,
      30,
      82
    ],
    "source": "9781394239306",
    "choice_e": "Coaxial cable has an insulating outer sheath made of braided strands.",
    "choice_f": "Coaxial cable has an insulating sheath made of either PVC or Teflon."
  },
  {
    "id": 796,
    "question": "Which of the following statements about fiber-optic cabling are true? (Choose all that apply.)",
    "choice_a": "There are two main fiber-optic cable types: single-mode and multimode.",
    "choice_b": "Fiber-optic cable is typically used to span long distances.",
    "choice_c": "Fiber-optic cables use IBM Data Connector (IDC) connectors.",
    "choice_d": "Fiber-optic cables often use Straight Tip (ST) and Subscriber Connector (SC) connectors.",
    "correct_answer": [
      "A",
      "B",
      "D",
      "E",
      "F"
    ],
    "explanation": "Fiber-optic cable comes in two types: multimode and single-mode. Fiber-optic cables vary in light source (LED or laser), cable grade (glass or plastic), and size of the core conductor. Single-mode uses a higher-grade glass conductor with a laser light source. Multimode fiber uses an LED light source. Both types can use either ST or SC connectors to physically connect end devices to a fiber-optic network. Fiber-optic cable is used to extend networks over long distances. Fiber-optic cables do not use IDC connectors, which are intended for use with shielded twisted-pair (STP) cable.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      31,
      26,
      27,
      46
    ],
    "source": "9781394239306",
    "choice_e": "Single-mode fiber-optic cable uses a laser light source and a glass core.",
    "choice_f": "Multimode fiber-optic cable uses a light-emitting diode (LED) light source."
  },
  {
    "id": 797,
    "question": "Which of the following are characteristics of an internal cable installation? (Choose all that apply.)",
    "choice_a": "An internal cable installation uses bulk spools of cabling with no connectors attached for most cable runs.",
    "choice_b": "An internal cable installation uses only prefabricated cables with connectors attached for all cable runs.",
    "choice_c": "An internal cable installation uses solid wire conductors for all cable runs, regardless of distance.",
    "choice_d": "An internal cable installation uses stranded wire conductors for short cable runs and solid core for longer cable runs.",
    "correct_answer": [
      "A",
      "D",
      "F"
    ],
    "explanation": "The use of bulk cable with no connectors, wall plates, and rack-mounted patch panels are all characteristics of an internal wiring installation. Internal installations typically cover large geographic areas that require cabling through walls, ceilings, and around other obstacles, making the cabling difficult to move. Solid core wiring is used for longer cable runs, whereas shorter cable runs such as connections from node to wall plate use prefabricated stranded core cables with connectors attached.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      35,
      27,
      31,
      45,
      12
    ],
    "source": "9781394239306",
    "choice_e": "In an internal cable installation, cables are typically not run through walls or ceilings.",
    "choice_f": "In an internal cable installation, cables are typically run through walls or ceilings."
  },
  {
    "id": 798,
    "question": "Which of the following IEEE 802.3 specifications calls for CAT8 UTP cable exclusively?",
    "choice_a": "10GBase-T",
    "choice_b": "40GBase-T",
    "choice_c": "100Base-TX",
    "choice_d": "1000Base-SX",
    "correct_answer": "B",
    "explanation": "40GBase-T is a 40-gigabits-per-second (Gbps) Ethernet specification that calls for 4-pair CAT8 twisted-pair cabling for lengths up to 30 meters. 10GBase-T and 100Base-TX do not require CAT8 cable, and 1000Base-SX is a fiber-optic standard.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      26,
      46,
      47,
      44,
      31
    ],
    "source": "9781394239306"
  },
  {
    "id": 799,
    "question": "Ralph has been hired to connect three local area networks (LANs) together with redundant paths that form a fault-tolerant backbone. The LANs reside on different floors in the same building and are approximately 600 meters apart. Each LAN is currently configured in a star/hub and spoke topology using twisted-pair cabling. Each LAN includes wall plates and rack-mounted patch panels and switches. Building and fire codes allow cables to run through existing risers, ceilings, and walls, but a 50,000-watt radio station occupies one of the floors between the LANs. Which topology, cable type, and installation method are best suited for this network?",
    "choice_a": "Star/hub and spoke topology, fiber-optic cabling, and internal installation",
    "choice_b": "Star/hub and spoke topology, coaxial cabling, and external installation",
    "choice_c": "Mesh topology, fiber-optic cabling, and external installation",
    "choice_d": "Bus topology, twisted-pair cabling, and internal installation",
    "correct_answer": "E",
    "explanation": "Ralph should use a mesh topology with redundant fiber-optic cable runs and an internal installation method. This will meet the requirements for connecting the LANs and providing redundancy and fault tolerance. Fiber-optic cable is immune to electromagnetic interference (EMI) and can span long distances. The internal installation method is most often used in larger networks, where end systems are geographically distant. The star/hub and spoke topology will not fulfill the requirements since it provides no redundancy. Twisted-pair cable cannot span distances more than 100 meters, and it is susceptible to EMI. Coaxial cable cannot span distances more than 500 meters, and it is also susceptible to EMI. The bus topology cannot use twisted-pair cabling and does not support cable runs longer than 500 meters.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      28,
      11,
      12,
      31
    ],
    "source": "9781394239306",
    "choice_e": "Mesh topology, fiber-optic cabling, and internal installation",
    "choice_f": "Star/hub and spoke topology, twisted-pair cabling, and external installation"
  },
  {
    "id": 800,
    "question": "Alice is a network consultant who has been contracted to evaluate a network design created many years ago, to determine if the design is still viable. The network will support 20 workstations, scattered throughout the building, to run an inventory database application. The two most distant computers are 150 meters apart. The primary goal for the network design is to connect all 20 workstations to a single LAN running at 1 gigabit per second (Gbps). The two secondary goals are to provide sufficient fault tolerance for a single cable break to occur without affecting the entire network and to provide resistance to the electromagnetic interference (EMI) generated by machinery in the building. The earlier design calls for a CAT 6 UTP Ethernet LAN in a star/hub and spoke topology with all of the computers connected to a single switch. Which of the following statements about the old proposal is true?",
    "choice_a": "The solution achieves neither the primary goal nor either of the secondary goals.",
    "choice_b": "The solution achieves the primary goal but neither of the secondary goals.",
    "choice_c": "The solution achieves the primary goal and one of the secondary goals.",
    "choice_d": "The solution achieves the primary goal and both of the secondary goals.",
    "correct_answer": "C",
    "explanation": "The CAT 6 UTP network described in the old proposal is sufficient to connect the 20 workstations to a single LAN running at 1 Gbps, thus achieving the primary goal. The star/hub and spoke topology can tolerate a single cable break without affecting the entire network, but the UTP cable is susceptible to EMI, so one secondary goal could not be achieved.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      26,
      7,
      31,
      11,
      15
    ],
    "source": "9781394239306"
  },
  {
    "id": 801,
    "question": "Ed is a network consultant who has been contracted to design the network for a new manufacturing plant. The plant consists of two buildings 150 meters apart: an office with 20 computers and a manufacturing facility that has 30 computers. The two most distant computers at the site are 225 meters apart. Ed's design calls for a Gigabit Ethernet network using fiber-optic cable. On receiving the proposal, the client asks Ed to justify the additional labor and expense of installing fiber-optic cable instead of unshielded twisted-pair (UTP). Which of the following is not a valid reason for choosing fiber-optic over UTP for this project?",
    "choice_a": "The 225-meter distance between the two most distant computers exceeds Ethernet's maximum cable segment length for UTP.",
    "choice_b": "Only fiber-optic cable can keep the two buildings electrically isolated.",
    "choice_c": "Fiber-optic cable is completely resistant to any electromagnetic interference generated by the equipment in the manufacturing plant.",
    "choice_d": "Fiber-optic cable provides a greater degree of tolerance to cable breaks than UTP.",
    "correct_answer": "D",
    "explanation": "Fiber-optic cable is not more tolerant of cable breaks than UTP. Some fiber-optic networks are fault tolerant, but the Ethernet fiber-optic specifications are not. UTP cables connecting a computer to a switch can be no longer than 100 meters, making 200 meters the maximum distance between two computers. Connecting two buildings with a copper-based cable creates an electrical connection between them, which can be hazardous. Fiber-optic cable does not create an electrical connection. Fiber-optic cable is also unaffected by the EMI generated by manufacturing equipment.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      31,
      26,
      28,
      47,
      12
    ],
    "source": "9781394239306"
  },
  {
    "id": 802,
    "question": "Which of the following 802.3 10 Gigabit Ethernet specifications calls for the use of copper cable?",
    "choice_a": "10GBase-LR",
    "choice_b": "10GBase-CX4",
    "choice_c": "10GBase-ER",
    "choice_d": "10GBase-LX4",
    "correct_answer": "B",
    "explanation": "The 10GBase-CX4 specification calls for the use of a twinaxial copper cable with segments no longer than 15 meters. The10GBase-LR, 10GBase-ER, 10GBase-LX4, and 10GBase-SR specifications all call for fiber-optic cable.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      46,
      30,
      28,
      44,
      25
    ],
    "source": "9781394239306",
    "choice_e": "10GBase-SR"
  },
  {
    "id": 803,
    "question": "Alice is a network consultant who has been contracted to upgrade an existing Ethernet network to Gigabit Ethernet. The network consists of 20 workstations with integrated 100Base-TX/1000Base-T network interface adapters. The network cabling is Category 6 (CAT6) unshielded twisted-pair (UTP), installed when the building was constructed. All of the workstations are connected to a single 100Base-TX switch. Which of the following options would Alice find to be a valid upgrade path to Gigabit Ethernet?",
    "choice_a": "Replace the CAT6 cable with at least Category 6a (CAT6a) and leave the existing network interface adapters and switch in place.",
    "choice_b": "Install a 1000Base-T network interface card in each computer and leave the existing cables and switch in place.",
    "choice_c": "Replace the CAT6 cable with at least CAT6a and replace the 100Base-T switch with a 1000Base-T switch.",
    "choice_d": "Replace the 100Base-TX switch with a 1000Base-T switch and leave the existing cables and network interface adapters in place.",
    "correct_answer": "D",
    "explanation": "The multispeed network interface adapters in the computers can run at 1 Gbps speed using the existing CAT6 cable, but the 100Base-T switch must be replaced with a 1000Base-T switch. While the network might run better with a cable upgrade, it is not immediately necessary. Replacing the network interface adapters is not necessary because the existing multispeed adapters can run at 1 Gbps if they are connected to a 1000Base-T switch.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      26,
      33,
      3,
      40,
      12
    ],
    "source": "9781394239306"
  },
  {
    "id": 804,
    "question": "Ralph is a network consultant with a client who wants him to design the local area network (LAN) for his company's new branch office. The site consists of a building with unshielded twisted-pair (UTP) cable already installed, which the client considered a major selling point when selecting the property. He wants Ralph to install the fastest possible LAN using the existing cable. After examining the site, Ralph notes that the cable is Category 6 (CAT6), installed using a star/hub and spoke topology, and that the individual cable runs are all 90 to 100 meters long. Which of the following Ethernet Physical layer specifications can Ralph use for the new network to provide the fastest transmission speeds without replacing the cable?",
    "choice_a": "10GBase-T",
    "choice_b": "100Base-TX",
    "choice_c": "1000Base-T",
    "choice_d": "1000Base-LX",
    "correct_answer": "C",
    "explanation": "1000Base-T is the fastest 802.3 Ethernet specification that can run on 100-meter CAT6 UTP cables. 10GBase-T requires at least Category 6a (CAT6a) UTP cable for a 100-meter segment. 100Base-TX can use CAT6 cable, but it runs at one-tenth the speed of 1000Base-T. 1000Base-LX and 1000Base-SX are fiber-optic specifications that cannot run on CAT6 UTP or any copper cable.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      26,
      47,
      45,
      31,
      11
    ],
    "source": "9781394239306",
    "choice_e": "1000Base-SX"
  },
  {
    "id": 805,
    "question": "Which Institute of Electrical and Electronics Engineers (IEEE) 802.3 standards for Ethernet support 10-megabit-per-second (Mbps) communications, and what are the correct segment limitations for each standard? (Choose all that apply.)",
    "choice_a": "10Base2; segment maximum is 100 meters",
    "choice_b": "10Base2; segment maximum is 185 meters",
    "choice_c": "10Base5; segment maximum is 500 meters",
    "choice_d": "100Base5; segment maximum is 500 meters",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "The three IEEE 10 Mbps standards for Ethernet are 10Base2, 10Base5, and 10Base-T. 10Base2 is limited to 185-meter segments; 10Base5 is limited to 500-meter segments; and 10Base-T is limited to 100-meter segments. The other options are not valid.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      45,
      44,
      26,
      27,
      40
    ],
    "source": "9781394239306",
    "choice_e": "10Base-T; segment maximum is 100 meters",
    "choice_f": "10Base-T segment maximum is 328 meters"
  },
  {
    "id": 806,
    "question": "Which of the following are Ethernet cable types that must be configured in a bus topology? (Choose all that apply.)",
    "choice_a": "RG-8",
    "choice_b": "RG-10",
    "choice_c": "RG-14",
    "choice_d": "RG-58",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "The first version of DIX Ethernet (Version 1) supported RG-8 thick coaxial cable in a bus topology. Version 2 added support for thin coaxial cable (RG-58) but was still limited to a bus topology. RG-10 and RG-14 are not Ethernet cable types.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      45,
      44,
      25,
      7,
      12
    ],
    "source": "9781394239306"
  },
  {
    "id": 807,
    "question": "Wavelength-division multiplexing is a fiber-optic technique for carrying multiple signals on a single network medium. There are several types of this technique, including coarse wavelength-division multiplexing (CWDM), dense wavelength-division multiplexing (DWDM), and bidirectional wavelength-division multiplexing (BWDM, or just WDM). Which of the following is not one of the ways in which these types of multiplexing differ?",
    "choice_a": "They use different wavelength spacings.",
    "choice_b": "They carry different numbers of channels on a single medium.",
    "choice_c": "They provide different amounts of signal amplification.",
    "choice_d": "None of the above.",
    "correct_answer": "D",
    "explanation": "The types of wavelength division multiplexing use different spacing of the wavelengths they carry, which enables them to fit different numbers of channels on a single medium. WDM (or BWDM) carries two wavelengths for bidirectional communication. CWDM can carry up to 16 channels, and DWDM 40 or 80 (depending on the spacing used). Various amplification technologies (including EFDA and Raman) can expand the amount of usable wavelength in each type.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      29,
      44,
      37,
      12
    ],
    "source": "9781394239306"
  },
  {
    "id": 808,
    "question": "Ralph is installing an Ethernet local area network (LAN) for a small business with two offices on opposite sides of a courtyard. Ralph plans to run a multimode fiber-optic cable across the courtyard, but the budget is limited, and he cannot use fiber for the whole network. Therefore, he installs unshielded twisted-pair (UTP) cable in the two offices, which have 10 and 12 workstations, respectively. Which of the following devices should Ralph use to join the two UTP installations together into one LAN using the fiber-optic run across the courtyard, while keeping the cost to a minimum?",
    "choice_a": "Media converters",
    "choice_b": "Hubs",
    "choice_c": "Switches",
    "choice_d": "Routers",
    "correct_answer": "A",
    "explanation": "Media converters will enable Ralph to join the multimode fiber-optic run to the UTP at both sides of the courtyard while maintaining a single network at minimum cost. Inexpensive small-business hubs and switches cannot join different media together. Routers can join different media, but they are more expensive, and they would separate the installation into three separate networks.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      29,
      2,
      26,
      28,
      47
    ],
    "source": "9781394239306"
  },
  {
    "id": 809,
    "question": "Under which of the following conditions is a cable installer required to use plenum cable?",
    "choice_a": "When cables run close to sources of electromagnetic interference (EMI)",
    "choice_b": "When cables are running through building air flow spaces",
    "choice_c": "When data and voice traffic will be running over the same cable",
    "choice_d": "When cables are running through areas of low temperature",
    "correct_answer": "B",
    "explanation": "Plenum cable is a type of cable intended for use within building air spaces (called plenums) that has an outer sheath that is more resistant to high temperatures and does not produce toxic fumes when it burns. The use of plenum cable has no effect on EMI or the type of traffic on the cable, nor is it required for low temperature areas.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      25,
      31,
      28,
      35,
      45
    ],
    "source": "9781394239306"
  },
  {
    "id": 810,
    "question": "Which of the following wireless networking standards is capable of supporting speeds over 72 Mbps and is also backward compatible with IEEE 802.11b and 802.11g?",
    "choice_a": "IEEE 802.11",
    "choice_b": "IEEE 802.11a",
    "choice_c": "IEEE 802.11n",
    "choice_d": "IEEE 802.11ac",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "IEEE 802.11n and 802.11ax support transmission speeds over 72 Mbps, and they both run on the 2.4 GHz band, so they are backward compatible with 802.11b and 802.11g equipment. IEEE 802.11 and 802.11a cannot run at 72 Mbps, and 802.11a is not compatible with 802.11b and 802.11g because it only runs on the 5 GHz band. IEEE 802.1ac can run at speeds over 72 Mbps, but it only runs on the 5 GHz band, so it is not compatible with 802.11b and 802.11g.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      180,
      205,
      203,
      195,
      22
    ],
    "source": "9781394239306",
    "choice_e": "IEEE 802.11ax"
  },
  {
    "id": 811,
    "question": "Which of the following is a cellular communication technology that is virtually obsolete in the United States?",
    "choice_a": "GSM",
    "choice_b": "CDMA",
    "choice_c": "TDMA",
    "choice_d": "LTE",
    "correct_answer": "C",
    "explanation": "Time-division multiple access (TDMA) is a communication technique that splits a frequency into multiple time slots, enabling it to carry multiple data streams. Commonly used in 2G cellular systems, TDMA is no longer used by the major US carriers in their 3G systems. Code-division multiple access (CDMA), Global System for Mobile Communications (GSM), and Long-Term Evolution (LTE) are alternative communications techniques that are currently used by the major US cellular carriers.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      24,
      44,
      40,
      17,
      4
    ],
    "source": "9781394239306"
  },
  {
    "id": 812,
    "question": "Ralph is planning a wireless LAN installation for a warehouse with two offices, one at either end of the building, approximately 300 feet apart. If he installs a single access point (AP) in the center of the warehouse, equidistant from the two offices, which of the following standards should he look for when purchasing hardware so that workstations in both offices will be able to connect to the network at the best possible speed?",
    "choice_a": "IEEE 802.11a",
    "choice_b": "IEEE 802.11g",
    "choice_c": "IEEE 802.11n",
    "choice_d": "IEEE 802.11ac",
    "correct_answer": "E",
    "explanation": "Wireless networks using equipment based on the IEEE 802.11ax standard can span indoor distances of up to 820 feet at speeds up to 9.6 Gbps. An 802.11n network can span distances of up to 175 feet, which meets the requirement, but at much slower speeds of only 600 Mbps. An 802.11ac network can run at faster speeds\u2014up to 1.3 Gbps\u2014but it is limited to approximately 115-foot distances. Networks using 802.11g equipment can span 150 feet, but they run at a maximum of 54 Mbps. An 802.11a network cannot span more than 75 feet, and it runs at no more than 54 Mbps.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      195,
      203,
      205,
      11,
      10
    ],
    "source": "9781394239306",
    "choice_e": "IEEE 802.11ax"
  },
  {
    "id": 813,
    "question": "Which of the following broadband WAN services provides equal amounts of upstream and downstream bandwidth?",
    "choice_a": "ADSL",
    "choice_b": "SDSL",
    "choice_c": "Satellite",
    "choice_d": "Cable",
    "correct_answer": "B",
    "explanation": "The word <i>symmetric</i> in symmetric digital subscriber line (SDSL) means that the service provides equal amounts of bandwidth in both directions. The asymmetric in asymmetric digital subscriber line (ADSL) means that the service provides more downstream bandwidth than upstream. Cable and satellite services are also asymmetric, providing more bandwidth downstream than upstream.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      24,
      25,
      12,
      9,
      8
    ],
    "source": "9781394239306"
  },
  {
    "id": 814,
    "question": "Ralph's company has expanded to include an additional building on the far end of the corporate campus, approximately 4 kilometers away from the building housing the datacenter. A single-mode fiber-optic cable connection has been installed between the new building and the datacenter for a 1000Base-BX10 connection, but the cable is not yet connected to a transceiver at the datacenter end. Noticing that there is a 1000Base-SX Ethernet transceiver module in the datacenter storeroom, Ralph is wondering if he could use this on the new cable run. Which of the following are reasons why this might not work? (Choose all that apply.)",
    "choice_a": "Transceiver mismatch",
    "choice_b": "Incorrect cable type",
    "choice_c": "Excessive cable length",
    "choice_d": "Wavelength mismatch",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D"
    ],
    "explanation": "The 1000Base-SX standard calls for multimode cable with a maximum length of approximately 500 meters, whereas the new cable run is 4,000 meters and uses single-mode cable. The 1000Base-SX transceiver will also be incompatible with the 1000Base-BX10 transceiver at the other end. 1000Base-BX10 uses wavelengths from 1,300 to 1,600 nanometers (nm), whereas 1000Base-SX uses wavelengths of 770 to 860 nm.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      46,
      28,
      29,
      45,
      44
    ],
    "source": "9781394239306"
  },
  {
    "id": 815,
    "question": "A Small Form-factor Pluggable (SFP) Ethernet implementation uses direct-attach copper (DAC) connections for short distance runs within the datacenter. Which of the following cable types do the DAC connections use?",
    "choice_a": "Unshielded twisted-pair",
    "choice_b": "Shielded twisted-pair",
    "choice_c": "Fiber-optic",
    "choice_d": "Coaxial",
    "correct_answer": "E",
    "explanation": "Direct-attach copper (DAC) connections use twinaxial cable, which has two conductors instead of the one used in coaxial cables. DAC connections also do not use twisted-pair cables, either shielded or unshielded, or fiber-optic cables.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      30,
      29,
      25,
      26,
      28
    ],
    "source": "9781394239306",
    "choice_e": "Twinaxial"
  },
  {
    "id": 816,
    "question": "An electrician installing a new light fixture accidentally severs one of the LAN cables running through the dropped ceiling space. With which topology would the severed cable cause the greatest amount of disturbance to the network?",
    "choice_a": "Bus",
    "choice_b": "Star/hub and spoke",
    "choice_c": "Logical ring",
    "choice_d": "Mesh",
    "correct_answer": "A",
    "explanation": "A cable break in a bus topology would split the network into two halves, preventing the nodes on one side of the break from communicating with those on the other. In addition, both halves of the network would be left with one unterminated end, which would prevent the computers on each side of the break from communicating effectively. A cable break in a star/hub and spoke or logical ring topology would only interrupt the connection of a single computer to the network. The mesh topology is not often used for LANs, but redundant network connections are a characteristic of mesh networks, which means that a single cable break would have no effect on the network.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      7,
      8,
      11,
      15,
      37
    ],
    "source": "9781394239306"
  },
  {
    "id": 817,
    "question": "Which of the following statements about a wired local area network (LAN) is true?",
    "choice_a": "Wired LANs support only the star/hub and spoke topology.",
    "choice_b": "Wired LANs support only the star/hub and spoke and bus topologies.",
    "choice_c": "Wired LANs support only the star/hub and spoke and ring topologies.",
    "choice_d": "Wired LANs can support ring, bus, or star/hub and spoke topologies.",
    "correct_answer": "D",
    "explanation": "A wired LAN is a group of computers within a small area, connected by a common network medium. A wired LAN can be configured using a ring, bus, or star/hub and spoke topology.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      2,
      15,
      10,
      40,
      27
    ],
    "source": "9781394239306"
  },
  {
    "id": 818,
    "question": "Which of the following is an example of a hybrid LAN topology?",
    "choice_a": "A workstation with two network interface cards, one of which is connected to a star/hub and spoke network and one to a bus network",
    "choice_b": "Four Ethernet switches connected using a bus topology",
    "choice_c": "Four workstations, each with a separate network connection to each of the other three",
    "choice_d": "Four Ethernet switches, each with a separate network connection to each of the other three",
    "correct_answer": "B",
    "explanation": "A hybrid LAN topology is a network that uses two or more of the basic topologies, connected together so that each workstation can communicate with all of the other workstations. Connecting four switches to a bus topology combines four star/hub and spoke networks in such a way that the workstations are all interconnected. Connecting a single workstation to a star/hub and spoke and a bus network enables that workstation to access both networks, but it does not enable other workstations to access both topologies. Four workstations, each with a separate connection to the other three, is a mesh network topology, not a hybrid. Four connected switches expands the star/hub and spoke topology, but it does not create a hybrid topology.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      10,
      7,
      8,
      11,
      15
    ],
    "source": "9781394239306"
  },
  {
    "id": 819,
    "question": "Which type of network connects local area networks (LANs) in distant locations?",
    "choice_a": "WAN",
    "choice_b": "LAN",
    "choice_c": "MAN",
    "choice_d": "CAN",
    "correct_answer": "A",
    "explanation": "WANs (wide area networks) connect LANs that are geographically distant. A LAN (local area network), as the name implies, is a group of computers, not other LANs, and it is contained within a small area. MANs (metropolitan area networks) connect LANs in a single metropolitan area; they are not confined to a small area. A MAN is typically larger than a LAN but smaller than a WAN. A campus area network (CAN) typically includes a group of adjacent buildings, such as those of a corporation or university.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      15,
      2,
      6,
      101
    ],
    "source": "9781394239306"
  },
  {
    "id": 820,
    "question": "Which of the following topologies is used by the majority of new Ethernet networks installed today?",
    "choice_a": "Bus",
    "choice_b": "Point-to-point",
    "choice_c": "Mesh",
    "choice_d": "Star/hub and spoke",
    "correct_answer": "D",
    "explanation": "Virtually all of the new Ethernet networks installed today use the star/hub and spoke topology, with one or more switches functioning as a cabling nexus. Ethernet no longer uses the bus topology, and it does not support point-to-point or mesh topologies.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      7,
      10,
      45,
      38,
      39
    ],
    "source": "9781394239306"
  },
  {
    "id": 821,
    "question": "Alice has constructed a five-node failover cluster in which all five servers are connected to a hard disk array using a dedicated Fibre Channel network. Which of the following terms describes this network arrangement?",
    "choice_a": "SAN",
    "choice_b": "PAN",
    "choice_c": "WAN",
    "choice_d": "MAN",
    "correct_answer": "A",
    "explanation": "A storage area network (SAN) is a network that is dedicated to carrying traffic between servers and storage devices. A personal area network (PAN) provides communication among devices associated with a single person, such as smartphones. A wide area network (WAN) is a network that connects devices or networks at different geographic locations. A metropolitan area network (MAN) is a type of WAN that connects devices within a limited geographic area.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      16,
      4,
      2,
      8
    ],
    "source": "9781394239306"
  },
  {
    "id": 822,
    "question": "Which of the following network topologies are used by wireless local area networks (WLANs)? (Choose all that apply.)",
    "choice_a": "Ad hoc",
    "choice_b": "Bus",
    "choice_c": "Infrastructure",
    "choice_d": "Star/hub and spoke",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "WLANs can use the ad hoc topology, in which devices communicate directly with each other, or the infrastructure topology, in which the wireless devices connect to an access point. The bus and star/hub and spoke topologies are used by wired networks only.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      11,
      15,
      2,
      203,
      205
    ],
    "source": "9781394239306"
  },
  {
    "id": 823,
    "question": "On an Ethernet network using the star/hub and spoke topology, which of the following devices can function as the cabling nexus that forms the figurative center of the star?",
    "choice_a": "Firewall",
    "choice_b": "Router",
    "choice_c": "Switch",
    "choice_d": "Access point",
    "correct_answer": "C",
    "explanation": "A switch can function as the cabling nexus at the center of an Ethernet star/hub and spoke topology. Each of the devices on the network is connected by a cable to the switch. Routers are used to connect networks to each other; they cannot function as the center of a star/hub and spoke topology. Firewalls are not cabling devices, and access points are used on wireless networks.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      11,
      2,
      37,
      12,
      44
    ],
    "source": "9781394239306"
  },
  {
    "id": 824,
    "question": "Which of the following cabling topologies provides the greatest number of redundant paths through the network?",
    "choice_a": "Star/hub and spoke",
    "choice_b": "Ring",
    "choice_c": "Mesh",
    "choice_d": "Bus",
    "correct_answer": "C",
    "explanation": "A mesh topology is one in which every node is directly connected to every other node, thus providing complete redundancy through the network. In a star/hub and spoke topology, each node is connected to a central nexus, providing each with a single path to the rest of the network. In a ring topology, each node is connected to two other nodes, providing two possible paths through the network. In a bus topology, nodes are chained together in a line, providing no redundancy.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      11,
      7,
      10,
      9
    ],
    "source": "9781394239306"
  },
  {
    "id": 825,
    "question": "Which of the following Ethernet Physical layer options does not use the star/hub and spoke topology?",
    "choice_a": "10Base2",
    "choice_b": "10Base-T",
    "choice_c": "100Base-TX",
    "choice_d": "1000Base-T",
    "correct_answer": "A",
    "explanation": "10Base2 is the Physical layer specification for Thin Ethernet, which uses coaxial cable in a bus topology. 10Base-T, 100Base-TX, and 1000Base-T all use twisted-pair cable in a star/hub and spoke topology.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      45,
      44,
      7,
      25,
      26
    ],
    "source": "9781394239306"
  },
  {
    "id": 826,
    "question": "Which of the following statements is true about the differences between a peer-to-peer network and a client-server network?",
    "choice_a": "Peer-to-peer networks are inherently less secure than client-server networks.",
    "choice_b": "Peer-to-peer networks are illegal, while client-server networks are legal.",
    "choice_c": "On peer-to-peer networks, every workstation is capable of authenticating users.",
    "choice_d": "On a peer-to-peer network, all workstations must share their resources.",
    "correct_answer": "C",
    "explanation": "A peer-to-peer network calls for each workstation to maintain accounts for authenticating users that access their shared resources. On a client-server network, authentication is centralized. Peer-to-peer networks can be more difficult to administer than client-server networks, but they are not inherently less secure. Peer networks sharing copyrighted content on the Internet are illegal, but it is not illegal to share private resources on a peer-to-peer network. Workstations on a peer-to-peer network are not required to share their resources, but they are capable of it.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      3,
      1,
      11,
      10
    ],
    "source": "9781394239306"
  },
  {
    "id": 827,
    "question": "Ed has been hired by a private company to connect two remote sites with a wide area network (WAN). Each of these sites has more than 200 users, and they all need to constantly transfer files across the WAN. One of the sites has a customer database that is accessed by both sites at all hours of the day. Access to the database and other information is time sensitive and constant. The company estimates that their aggregate bandwidth needs to be approximately 40 Mbps. Management says that they need to guarantee access to this information and that money is not a factor in the WAN implementation. Which WAN technology should Ed recommend for this scenario?",
    "choice_a": "A standard modem-to-modem connection",
    "choice_b": "A T-3 dedicated leased line",
    "choice_c": "A cable television (CATV) connection",
    "choice_d": "An ADSL (asymmetrical digital subscriber line) connection",
    "correct_answer": "B",
    "explanation": "For this scenario, the best of the options given is a dedicated leased line connection. This is because the bandwidth requirements are constant and the data transfer rates are high. To support the 40 Mbps data rate, Ed should recommend a T-3 dedicated leased line, running at 44.735 Mbps. Standard modem connections, CATV, and ADSL connections are all too slow.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      12,
      286,
      73,
      11
    ],
    "source": "9781394239306"
  },
  {
    "id": 828,
    "question": "Ralph is an employee of a company that offers the option to telecommute from home. As a telecommuting employee, he needs to connect to the company network to access client information, transfer files, and send email through a virtual private network (VPN) connection. Ralph is investigating the different wide area network (WAN) services available for the remote connection before he implements one. His home is over 30 years old; the existing telephone wiring was not run through conduit, and the wiring seems to be deteriorating. Ralph has cable television (CATV) service, and his home is also approximately 20,000 feet from the nearest telephone central office. He wants to implement the fastest remote connection service possible, but cost is a factor in the decision. Which WAN technology should Ralph implement?",
    "choice_a": "A dedicated leased line (fractional T-1)",
    "choice_b": "A standard modem-to-modem connection",
    "choice_c": "A DSL (digital subscriber line) connection",
    "choice_d": "A broadband CATV connection",
    "correct_answer": "D",
    "explanation": "In this scenario, the best solution is for Ralph to use his existing CATV service for the remote connection. CATV offers faster data rates than standard modem-to-modem service and supports VPN connections. A dedicated fractional T-1 line is expensive and is not typically used for remote user connections. Since Ralph's telephone lines are not run through conduit and the distance to the central office is more than 18,000 feet, he probably cannot use DSL technology, because it requires good-quality lines and close proximity to a central office.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      4,
      286,
      9,
      26,
      35
    ],
    "source": "9781394239306"
  },
  {
    "id": 829,
    "question": "Which two of the following constructs provide roughly the same function? (Choose two that apply.)",
    "choice_a": "SIP trunk",
    "choice_b": "CSU/DSU",
    "choice_c": "VoIP gateway",
    "choice_d": "Smartjack",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "A Session Initiation Protocol (SIP) trunk provides a connection between the private and public domains of a unified communications network. A Voice over Internet Protocol (VoIP) gateway provides a connection between an IP network and the public switched telephone network (PSTN). Both of these provide a conduit between a subscriber's private network and the network furnished by a service provider. A channel service unit/data service unit (CSU/DSU) is a device that provides a router on a private network with access to a leased line. A smartjack provides signal conversion, diagnostic testing, and other capabilities to leased line subscribers. A virtual private network (VPN) concentrator is a type of router that enables multiple client systems to access a network from remote locations.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      12,
      286,
      287,
      116,
      82
    ],
    "source": "9781394239306",
    "choice_e": "VPN concentrator"
  },
  {
    "id": 830,
    "question": "Which of the following wide area network (WAN) services typically uses a switched fabric that was called a cloud long before the term came into general use?",
    "choice_a": "ATM",
    "choice_b": "Fractional T-1",
    "choice_c": "SONET",
    "choice_d": "Frame Relay",
    "correct_answer": "D",
    "explanation": "Frame Relay is a packet switching service that uses a single leased line to replace multiple leased lines by multiplexing traffic through a cloud. Asynchronous Transfer Mode (ATM) uses a switched fabric, but it is not referred to as a cloud. A fractional T-1 is part of a leased line that connects two points, so there is no switching involved and no cloud. SONET is a Physical layer standard that defines fiber-optic connections; it does not call for switching or use the term <i>cloud</i>.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      12,
      17,
      22,
      82
    ],
    "source": "9781394239306"
  },
  {
    "id": 831,
    "question": "Ralph has been contracted to consult for a company that wants to update its legacy Ethernet network to Gigabit Ethernet. When examining the site, he discovers that the network is still using coaxial-based Thin Ethernet. What change in network topology must occur to upgrade the existing network to Gigabit Ethernet using unshielded twisted-pair (UTP) cable?",
    "choice_a": "Bus to mesh",
    "choice_b": "Mesh to star/hub and spoke",
    "choice_c": "Star/hub and spoke to bus",
    "choice_d": "Bus to star/hub and spoke",
    "correct_answer": "D",
    "explanation": "All coaxial-based Ethernet networks, including Thin Ethernet, use a bus topology. All UTP-based Gigabit Ethernet networks use a star/hub and spoke topology. Therefore, an upgrade from coaxial to UTP cable must include a change in topology from bus to star/hub and spoke. Ethernet networks never use a mesh topology.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      7,
      11,
      45,
      25,
      46
    ],
    "source": "9781394239306",
    "choice_e": "Star/hub and spoke to mesh"
  },
  {
    "id": 832,
    "question": "Which of the following best describes the function of a vSwitch (or virtual switch)?",
    "choice_a": "A vSwitch is a software product that enables a computer with multiple network adapters to function as a switch.",
    "choice_b": "A vSwitch is a feature in layer 3 switches that enables VLANs on the same switch to communicate with each other.",
    "choice_c": "A vSwitch is a feature in layer 3 switches that enables VLANs on different switches to communicate with each other.",
    "choice_d": "A vSwitch enables virtual machines (VMs) running on the same hypervisor to communicate with each other internally.",
    "correct_answer": "D",
    "explanation": "In most virtualization products, when you create multiple virtual machines on one host computer, they can communicate with each other internally using a built-in virtual switching capability. A computer with multiple network adapters can function as a router, but not as a switch. Layer 3 switches can provide virtual routers that connect VLANs together, but not virtual switches. The function that enables VLANs on different switches to communicate is called trunking, not virtual switching.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      14,
      285,
      16,
      2,
      37
    ],
    "source": "9781394239306"
  },
  {
    "id": 833,
    "question": "On which of the following virtual networking components can you create VLANs?",
    "choice_a": "Virtual NIC",
    "choice_b": "Virtual switch",
    "choice_c": "Virtual router",
    "choice_d": "Virtual firewall",
    "correct_answer": "B",
    "explanation": "You can create virtual local area networks (VLANs) on a virtual switch, just as you can create them on many physical switches. In most cases, virtual components function just like their physical counterparts. Virtual NICs are components of virtual machines and therefore do not provide functions spanning entire networks. Virtual routers function at the Network layer and virtual firewalls at the Application layer, so neither of these can host VLANs, which operate at the Data link layer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      14,
      285,
      22,
      40,
      298
    ],
    "source": "9781394239306"
  },
  {
    "id": 834,
    "question": "Which of the following components is responsible for providing a virtualized hardware environment and running virtual machines?",
    "choice_a": "Hypervisor",
    "choice_b": "Virtual server",
    "choice_c": "vSwitch (virtual switch)",
    "choice_d": "VPN concentrator",
    "correct_answer": "A",
    "explanation": "The hypervisor is the hardware or software component responsible for managing virtual machines and providing the virtualized hardware environment on which they run. Virtual servers and virtual switches are components that are part of the virtual network infrastructure enabled by the hypervisor. A virtual private network (VPN) concentrator is a type of router that enables multiple remote clients to connect to a network; it has nothing to do with virtual networking.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      16,
      14,
      295,
      298,
      288
    ],
    "source": "9781394239306"
  },
  {
    "id": 835,
    "question": "Which of the following is the proper term for a computer with a hypervisor on which you can create virtual machines and other virtual components?",
    "choice_a": "Guest",
    "choice_b": "NAS",
    "choice_c": "Host",
    "choice_d": "SAN",
    "correct_answer": "C",
    "explanation": "A computer with a hypervisor, on which you can create virtual machines, is referred to as a host. The virtual machines themselves are called guests. Network-attached storage (NAS) refers to a device containing shared drives that is connected to a network. A storage area network (SAN) is a separate network dedicated to shared storage devices.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      16,
      14,
      285,
      6,
      3
    ],
    "source": "9781394239306"
  },
  {
    "id": 836,
    "question": "In which of the following components can a virtual firewall be implemented?",
    "choice_a": "On a host operating system",
    "choice_b": "On a guest operating system",
    "choice_c": "In a dedicated virtual machine",
    "choice_d": "In a virtual switch",
    "correct_answer": "E",
    "explanation": "A virtual firewall is a service or appliance that performs the same functions as a physical network firewall: packet filtering and monitoring. In a virtual environment, firewalls can take the form of software components installed on a guest virtual machine or a hypervisor host system. A firewall can also be incorporated into a virtual switch.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      285,
      14,
      295,
      290,
      16
    ],
    "source": "9781394239306",
    "choice_e": "All of the above"
  },
  {
    "id": 837,
    "question": "Which of the following is not a protocol that uses tunneling to establish secured links between TCP/IP systems?",
    "choice_a": "L2TP",
    "choice_b": "IPsec",
    "choice_c": "MGRE",
    "choice_d": "NAT",
    "correct_answer": "D",
    "explanation": "Network address translation (NAT) enables workstations on private networks to access the Internet by substituting a public IP address in packets generated with private addresses. Layer 2 Tunneling Protocol (L2TP), IPsec, and Multipoint Generic Routing Encapsulation (MGRE) are all protocols that encapsulate packets in an encrypted form within another protocol to secure the contents.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      80,
      116,
      23,
      81,
      82
    ],
    "source": "9781394239306"
  },
  {
    "id": 838,
    "question": "Which of the following is not the name of one of the layers in the three-tier datacenter architecture?",
    "choice_a": "Core",
    "choice_b": "Intermediate",
    "choice_c": "Distribution",
    "choice_d": "Access",
    "correct_answer": "B",
    "explanation": "The three-tier hierarchical architecture for datacenters consists of core, distribution, and access layers. The access layer in a datacenter contains servers; the distribution layer contains redundant switch connections; and the core layer provides high-speed transport between the switches. There is no intermediate layer in the architecture.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      13,
      16,
      17,
      295,
      81
    ],
    "source": "9781394239306"
  },
  {
    "id": 839,
    "question": "Which of the following is not a reason why the spine and leaf datacenter topology is superior to the standard three-tier topology?",
    "choice_a": "The spine and leaf arrangement uses a full mesh switching topology.",
    "choice_b": "In a spine and leaf topology, all data flows require the same number of hops.",
    "choice_c": "The spine and leaf topology is less expensive to implement than the three-tier topology.",
    "choice_d": "The spine and leaf topology uses software-defined networking to direct traffic, rather than blocking ports using the spanning tree protocol.",
    "correct_answer": "C",
    "explanation": "The spine and leaf topology uses a full mesh topology in its two layers of switches. This is more expensive than the three-tier topology, but it reduces latency by requiring the same number of hops in the path between any two routers. The use of software-defined networking provides adaptive path determination without the use of the Spanning Tree Protocol (STP) for layer 2 port blocking.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      13,
      16,
      295,
      296,
      8
    ],
    "source": "9781394239306"
  },
  {
    "id": 840,
    "question": "Which of the following best describes the difference between east-west and north-south traffic in a datacenter?",
    "choice_a": "East-west describes traffic between devices at the same layer of the OSI model, while north-south describes traffic between OSI model layers.",
    "choice_b": "East-west is switch-to-switch traffic, while north-south is switch-to-router traffic.",
    "choice_c": "East-west traffic stays within the datacenter, while north-south traffic does not.",
    "choice_d": "East-west is backbone traffic among switches and routers, while north-south is traffic to end systems, such as servers.",
    "correct_answer": "C",
    "explanation": "East-west traffic describes traffic flow within the datacenter, while north-south is traffic between devices inside the datacenter and outside devices. The terms <i>east-west</i> and <i>north-south</i> do not pertain to the OSI model layers or to specific devices used.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      14,
      295,
      298,
      2,
      10
    ],
    "source": "9781394239306"
  },
  {
    "id": 841,
    "question": "Top-of-rack switches most commonly form which layer of the datacenter topology?",
    "choice_a": "Leaf",
    "choice_b": "Backbone",
    "choice_c": "Spine",
    "choice_d": "Core",
    "correct_answer": "A",
    "explanation": "In a typical datacenter topology, racks contain servers that implement applications. A leaf switch at the top of the rack connects the servers in the rack together and also connects to a spine switch that links to the rest of the datacenter. The top-of-rack switches are not classified as backbone, spine, or core devices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      16,
      295,
      296,
      10,
      37
    ],
    "source": "9781394239306"
  },
  {
    "id": 842,
    "question": "Which of the following statements about switches is not true?",
    "choice_a": "Switches are Data link layer devices that connect network devices in a star/hub and spoke topology.",
    "choice_b": "Switches amplify and repeat signals received through one port out all other ports regardless of the destination.",
    "choice_c": "Switches use MAC addresses to identify the devices connected to specific ports.",
    "choice_d": "Switches provide internal crossover circuits and use uplink ports to form a hierarchical star/hub and spoke topology.",
    "correct_answer": "B",
    "explanation": "Switches are Data link layer devices that amplify and repeat incoming signals only through the port for which the data is destined, not through all ports. Switches are used to physically connect end systems to a star/hub and spoke topology. Switches typically provide an internal crossover circuit connection. Uplink ports are sometimes used to extend the distance of a star/hub and spoke network, forming a hierarchical star.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      2,
      37,
      22,
      40,
      81
    ],
    "source": "9781394239306"
  },
  {
    "id": 843,
    "question": "A collapsed core network is one in which the standard three-tier hierarchical model is compressed into two tiers. Which of the following two tiers are combined to form this architectural model?",
    "choice_a": "Core and distribution",
    "choice_b": "Distribution and access",
    "choice_c": "Core and access",
    "choice_d": "Distribution and intermediate",
    "correct_answer": "A",
    "explanation": "In a collapsed core network, the core and distribution layers are combined, creating a simpler design that is less expensive to implement. A collapsed core network does not combine the distribution and access tiers or the core and access tiers. There is no intermediate tier in the three-tier hierarchical model.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      13,
      11,
      10,
      17,
      295
    ],
    "source": "9781394239306"
  },
  {
    "id": 844,
    "question": "Which of the following services enables computers on a private IPv4 network to access the Internet using a registered IP address?",
    "choice_a": "DHCP",
    "choice_b": "NAT",
    "choice_c": "DNS",
    "choice_d": "NTP",
    "correct_answer": "B",
    "explanation": "Network address translation (NAT) is a service that enables computers with unregistered IP addresses to access the Internet by substituting a registered address in packets as they pass through a router. The Dynamic Host Configuration Protocol (DHCP) is an IP address allocation service. Domain Name System (DNS) resolves domain and hostnames into IP addresses, and Network Time Protocol (NTP) enables network devices to synchronize their time settings.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      116,
      117,
      86,
      287,
      99
    ],
    "source": "9781394239306"
  },
  {
    "id": 845,
    "question": "Which of the following is the most accurate description of the subnetting process on an IPv4 network?",
    "choice_a": "You extend the IP address by adding bits for a subnet identifier.",
    "choice_b": "You borrow bits from the network identifier to create a subnet identifier.",
    "choice_c": "You borrow bits from the host identifier to create a subnet identifier.",
    "choice_d": "You create a subnet identifier by borrowing half of the bits from the network identifier and half from the host identifier.",
    "correct_answer": "C",
    "explanation": "You cannot extend the IPv4 address beyond its 32-bit size, and you cannot remove bits from the network identifier, or the packets will not be routed properly. You must therefore create a subnet by borrowing bits from the host identifier.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      101,
      103,
      102,
      104,
      114
    ],
    "source": "9781394239306"
  },
  {
    "id": 846,
    "question": "Which of the following IPv4 addresses are you unable to assign to a network host? (Choose all that apply.)",
    "choice_a": "1.1.1.1",
    "choice_b": "229.6.87.3",
    "choice_c": "103.256.77.4",
    "choice_d": "9.34.0.1",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "IPv4 addresses with first byte values from 224 to 239 are Class D addresses, which are reserved for use as multicast addresses. Therefore, you cannot assign 229.6.87.3 to a host. Option C, 103.256.77.4, is an invalid address because the value 256 cannot be represented by an 8-bit binary value. The other options, 1.1.1.1 and 9.34.0.1, are both valid IPv4 addresses.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      85,
      99,
      88,
      84,
      41
    ],
    "source": "9781394239306"
  },
  {
    "id": 847,
    "question": "How many bits are allocated to the host identifier in an IPv4 address on the 10.72.0.0/17 network?",
    "choice_a": "8",
    "choice_b": "15",
    "choice_c": "16",
    "choice_d": "17",
    "correct_answer": "B",
    "explanation": "The value after the slash in a Classless Inter-Domain Routing (CIDR) address specifies the number of bits in the network identifier. An IPv4 address has 32 bits, so if 17 bits are allocated to the network identifier, 15 bits are left for the host identifier.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      103,
      102,
      114,
      84,
      101
    ],
    "source": "9781394239306"
  },
  {
    "id": 848,
    "question": "Which of the following are not valid IPv4 addresses in the private address space defined by RFC 1918? (Choose all that apply.)",
    "choice_a": "10.16.225.1",
    "choice_b": "172:33:19:7",
    "choice_c": "192.168.254.77",
    "choice_d": "10.255.255.255",
    "correct_answer": [
      "B",
      "E"
    ],
    "explanation": "RFC 1918 defines the private address space as the following ranges: <ul><li>10.0.0.0\u201310.255.255.255</li><li>172.16.0.0\u2013172.31.255.255</li><li>192.168.0.0\u2013192.168.255.255</li></ul><p>Option B, 172:33:19:7, and Option E, 172.15.2.9, both fall outside the specified private Class B range, and therefore are not valid private addresses.</p>",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      86,
      85,
      99,
      84,
      103
    ],
    "source": "9781394239306",
    "choice_e": "172.15.2.9"
  },
  {
    "id": 849,
    "question": "Alice has been instructed to create an IPv4 network with 8 subnets and 30 hosts per subnet. She has been assigned a Class C network address. Which of the following subnet masks will she have to use?",
    "choice_a": "255.255.255.128",
    "choice_b": "255.255.255.192",
    "choice_c": "255.255.255.224",
    "choice_d": "255.255.255.240",
    "correct_answer": "C",
    "explanation": "To create a network with 8 subnets and 30 hosts per subnet, Alice would have to allocate 3 of the 8 bits in the last octet for subnet identifiers. This would result in a binary value of 11100000 for the last octet in the subnet mask, which converts to a decimal value of 224.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      115,
      104,
      106,
      102,
      103
    ],
    "source": "9781394239306",
    "choice_e": "255.255.255.248",
    "choice_f": "255.255.255.252"
  },
  {
    "id": 850,
    "question": "Which of the following is the default subnet mask for an IPv4 Class A network?",
    "choice_a": "255.0.0.0",
    "choice_b": "255.255.0.0",
    "choice_c": "255.255.255.0",
    "choice_d": "255.255.255.255",
    "correct_answer": "A",
    "explanation": "A Class A address uses only the first octet as the network identifier, which yields a binary subnet mask of 11111111 00000000 00000000 00000000. In decimal form, the subnet mask is 255.0.0.0. The 255.255.0.0 mask is for Class B addresses, and 255.255.255.0 is for Class C addresses. Option D, 255.255.255.255, is the broadcast address for the current network.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      103,
      85,
      99,
      84,
      102
    ],
    "source": "9781394239306"
  },
  {
    "id": 851,
    "question": "Which of the following is the range of IPv4 addresses that Automatic Private IP Addressing (APIPA) assigns to DHCP clients that cannot access a DHCP server?",
    "choice_a": "10.0.0.0 to 10.0.255.255",
    "choice_b": "169.254.0.0 to 169.254.255.255",
    "choice_c": "192.168.0.0 to 192.168.0.255",
    "choice_d": "224.0.0.0 to 224.0.255.255",
    "correct_answer": "B",
    "explanation": "According to RFC 3927, when a DHCP client cannot access a DHCP server, APIPA assigns it an address on the 169.254/16 network, the range of addresses for which is 169.254.0.0 to 169.254.255.255.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      99,
      75,
      86,
      84,
      88
    ],
    "source": "9781394239306"
  },
  {
    "id": 852,
    "question": "In which IPv4 class is the address 127.0.0.1 found?",
    "choice_a": "Class A",
    "choice_b": "Class B",
    "choice_c": "Class C",
    "choice_d": "None of the above",
    "correct_answer": "D",
    "explanation": "Address 127.0.0.1 is the designated IPv4 local loopback address, and as such, it is reserved. It falls between Class A, which has first octet values from 1 to 126, and Class B, which has first octet values of 128 to 191.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      85,
      99,
      111,
      84,
      87
    ],
    "source": "9781394239306"
  },
  {
    "id": 853,
    "question": "To which class does the following IPv4 address belong: 190.126.14.251?",
    "choice_a": "Class A",
    "choice_b": "Class B",
    "choice_c": "Class C",
    "choice_d": "Class D",
    "correct_answer": "B",
    "explanation": "All Class B addresses have first octet values between 128 and 191. The first octet range of a Class A address is 1 to 126, and the Class C first octet range is 192 to 223. Class D addresses have a first octet range of 224 to 239. Class E addresses have a first octet range of 240 to 255.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      85,
      99,
      84,
      41,
      88
    ],
    "source": "9781394239306",
    "choice_e": "Class E"
  },
  {
    "id": 854,
    "question": "Classless Inter-Domain Routing (CIDR) is a standard for IPv4 addressing that includes the capability to create subnets using any number of IP address bits, rather than using 8-bit blocks. Which of the following terms describes this ability?",
    "choice_a": "VLSM",
    "choice_b": "APIPA",
    "choice_c": "VLAN",
    "choice_d": "EUI-64",
    "correct_answer": "A",
    "explanation": "Variable-length subnet masking (VLSM) describes the process of subnetting an IPv4 network address by assigning an arbitrary number of host bits as subnet bits, providing administrators with great flexibility over the number of subnets created and the number of hosts in each subnet. Automatic Private IP Addressing (APIPA) is the process by which a DHCP client assigns itself an IP address when no DHCP servers are accessible. Virtual local area networks (VLANs) are logical structures used to create separate broadcast domains on a large, switched network. Extended Unique Identifier-64 (EUI-64) is an addressing method used to create IPv6 link local addresses out of media access control (MAC) addresses.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      139,
      103,
      101,
      102,
      104
    ],
    "source": "9781394239306"
  },
  {
    "id": 855,
    "question": "Ralph has been instructed to use the network address 10.12.0.0/14 for the new network he is installing. What subnet mask value should he use when configuring his computers?",
    "choice_a": "255.248.0.0",
    "choice_b": "255.252.0.0",
    "choice_c": "255.254.0.0",
    "choice_d": "255.255.248.0",
    "correct_answer": "B",
    "explanation": "The 14-bit prefix indicated in the network address will result in a mask with 14 ones followed by 18 zeroes. Broken into 8-bit blocks, the binary mask value is as follows: 11111111 11111100 00000000 00000000. Converted into decimal values, this results in a subnet mask value of 255.252.0.0.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      102,
      103,
      104,
      41,
      105
    ],
    "source": "9781394239306",
    "choice_e": "255.255.252.0",
    "choice_f": "255.255.254.0"
  },
  {
    "id": 856,
    "question": "Ed has been hired to design a company's network. The company has an assigned Class C network address of 192.168.30.0. Ed's client wants the network to be configured with 10 subnets, each with 14 hosts. Is this configuration possible with the given address, and if so, how many subnets and hosts can Ed create on the network?",
    "choice_a": "Yes, this will work. By using 4 subnet bits, it is possible for Ed to create up to 16 subnets. He can then use the remaining 4 host bits to create 14 hosts on each subnet.",
    "choice_b": "No, this will not work. A Class C address cannot be subnetted to create 8 subnets.",
    "choice_c": "No, this will not work. Although there are sufficient bits available to create 10 subnets, there are not enough bits left over for Ed to create 14 hosts per subnet.",
    "choice_d": "Yes, this will work. Ed can create 10 subnets with 14 hosts per subnet. By using 3 subnet bits, he can create 10 subnets, which leaves 5 bits to create up to 30 hosts per subnet.",
    "correct_answer": "A",
    "explanation": "In this scenario, the company has a Class C Internet Protocol (IPv4) address, which consists of 24 network bits and 8 host bits. The company wants 10 subnets and 14 hosts per subnet, so Ed must subdivide the 8 host bits into subnet and host bits. He can allocate 4 of the 8 host bits for subnets, enabling him to create up to 16 subnets. This leaves 4 bits for host addresses, enabling Ed to create 14 hosts per subnet.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      106,
      102,
      85,
      115
    ],
    "source": "9781394239306"
  },
  {
    "id": 857,
    "question": "What is the greatest number of subnets you can create with a Class A IPv4 address if you use a 14-bit subnet identifier?",
    "choice_a": "256",
    "choice_b": "1,022",
    "choice_c": "1,024",
    "choice_d": "16,382",
    "correct_answer": "E",
    "explanation": "The formula for calculating the number of subnets you can create using a subnet identifier of a given length is 2<sup>x</sup>, where <i>x</i> is the number of bits in the subnet identifier. Therefore, with a 14-bit subnet, you can conceivably create 2<sup>14</sup>, or 16,384, subnets.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      102,
      101,
      103,
      85,
      108
    ],
    "source": "9781394239306",
    "choice_e": "16,384"
  },
  {
    "id": 858,
    "question": "Alice has been asked to design her company's Internet Protocol (IPv4) addressing scheme. The company has been assigned a Class C network address of 192.168.30.0. Alice's director wants 4 subnets with 28 hosts per subnet. How many bits are required for subnets? How many bits are required for hosts? What will the new subnet mask be for this network?",
    "choice_a": "3 subnet bits, 5 host bits, and subnet mask 255.255.255.240",
    "choice_b": "4 subnet bits, 3 host bits, and subnet mask 255.255.255.248",
    "choice_c": "3 subnet bits, 5 host bits, and subnet mask 255.255.255.224",
    "choice_d": "5 subnet bits, 3 host bits, and subnet mask 255.255.255.192",
    "correct_answer": "C",
    "explanation": "In this scenario, the last byte of the IP address assigned to the company must be subdivided into 3 subnet bits and 5 host bits. The 3 subnet bits will give Alice up to 8 subnets, with 5 host bits for up to 30 hosts per subnet. The new subnet mask is 255.255.255.224. The 224 is the decimal equivalent of the binary value 11100000, which represents the 3 subnet bits and the 5 host bits.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      106,
      102,
      101,
      115
    ],
    "source": "9781394239306"
  },
  {
    "id": 859,
    "question": "The default mask for an IPv4 Class B network is 255.255.0.0. How many subnet bits do you need to create 600 subnets with 55 hosts per subnet, and what is the new subnet mask for the network?",
    "choice_a": "10 subnet bits with a subnet mask of 255.255.255.192",
    "choice_b": "9 subnet bits with a subnet mask of 255.255.255.128",
    "choice_c": "10 subnet bits with a subnet mask of 255.255.224.0",
    "choice_d": "11 subnet bits with a subnet mask of 255.255.255.192",
    "correct_answer": "A",
    "explanation": "A standard Class B address with a mask of 255.255.0.0 has 16 bits that can be used for subnets and hosts. To get 600 subnets, you must use 10 of the available bits, which gives you up to 1024 subnets. This leaves 6 host bits, which gives you up to 62 hosts per subnet, which exceeds the requirement of 55 requested by the client. Using 9 bits would give you only 510 subnets, while 11 bits would give you 2046 subnets but leave you only 5 bits for a maximum of 30 hosts, which is not enough.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      108,
      109,
      102,
      115,
      101
    ],
    "source": "9781394239306"
  },
  {
    "id": 860,
    "question": "What is the greatest number of host addresses you can create on a single subnet of a network with the following address: 172.16.0.0/20?",
    "choice_a": "142",
    "choice_b": "144",
    "choice_c": "4,094",
    "choice_d": "4,096",
    "correct_answer": "C",
    "explanation": "The formula for calculating the number of hosts you can create using a host identifier of a given length is 2<sup>x</sup>\u20132, where <i>x</i> is the number of bits in the host identifier. You cannot create a host with an address of all zeroes or all ones, which is why you subtract 2. On a network that uses 20 bits for network identification, 12 bits are left for the host identifier. Using those 12 bits, you can create 2<sup>12</sup>\u20132 or 4,094 host addresses.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      102,
      87,
      103,
      114,
      101
    ],
    "source": "9781394239306"
  },
  {
    "id": 861,
    "question": "Ralph has an IPv4 Class B network with a subnet mask of 255.255.248.0. How many subnets can he create, and how many hosts can he create per subnet?",
    "choice_a": "64 subnets and 2,046 hosts",
    "choice_b": "32 subnets and 2,046 hosts",
    "choice_c": "30 subnets and 1,022 hosts",
    "choice_d": "62 subnets and 1,022 hosts",
    "correct_answer": "B",
    "explanation": "With a Class B subnet mask of 255.255.248.0, the binary form of the third and fourth bytes is 11111000 00000000. There are 5 subnet bits, providing up to 32 subnets and 11 host bits, providing up to 2,046 hosts.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      108,
      109,
      102,
      103,
      104
    ],
    "source": "9781394239306"
  },
  {
    "id": 862,
    "question": "Convert the binary mask 11111111.11111111.11100000.00000000 into its equivalent decimal value. What is the decimal representation of this mask?",
    "choice_a": "255.255.224.0",
    "choice_b": "255.255.240.0",
    "choice_c": "255.255.248.0",
    "choice_d": "255.255.252.0",
    "correct_answer": "A",
    "explanation": "The decimal value for 11111111 is 255, the value for 11100000 is 224, and the value for 00000000 is 0, so the mask is 255.255.224.0.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      41,
      50,
      102,
      103,
      104
    ],
    "source": "9781394239306"
  },
  {
    "id": 863,
    "question": "If you have an IPv4 network address of 192.168.1.32/27, what is the valid range of host addresses you can use for your workstations?",
    "choice_a": "192.168.1.33 through 192.168.1.63",
    "choice_b": "192.168.1.33 through 192.168.1.62",
    "choice_c": "192.168.1.34 through 192.168.1.62",
    "choice_d": "192.168.1.34 through 192.168.1.63",
    "correct_answer": "B",
    "explanation": "With a network address of 192.168.1.32 and 27 mask bits, the subnet mask value is 11111111.11111111.11111111.11100000 in binary form, or 255.255.255.224 in decimal form. This leaves 5 bits for the host identifier. The valid range of host bits is therefore 00001 (1) through 11110 (30). This gives you a range of 192.168.1.32 + 1 (33) through 192.168.1.32 + 30 (62).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      87,
      106,
      104,
      102,
      84
    ],
    "source": "9781394239306"
  },
  {
    "id": 864,
    "question": "Alice has been assigned the IPv4 network address 172.21.0.0/22 for the creation of a new department network in her company. How many host addresses does she have available to her?",
    "choice_a": "510",
    "choice_b": "512",
    "choice_c": "1,022",
    "choice_d": "1,024",
    "correct_answer": "C",
    "explanation": "To calculate the number of host addresses available, Alice must determine the number of host bits in the address, which is 10, raise 2 to that power, and subtract 2 for the network and broadcast addresses, which are unusable for hosts. The formula is therefore 2<sup>x</sup>\u20132. 2<sup>10</sup>\u20132 = 1,022.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      102,
      87,
      103,
      104,
      101
    ],
    "source": "9781394239306"
  },
  {
    "id": 865,
    "question": "Automatic Private IP Addressing (APIPA) assigns IPv4 addresses from which of the following classes to Dynamic Host Configuration Protocol (DHCP) clients that cannot contact a DHCP server?",
    "choice_a": "Class A",
    "choice_b": "Class B",
    "choice_c": "Class C",
    "choice_d": "Class D",
    "correct_answer": "B",
    "explanation": "When a DHCP client cannot access a DHCP server, APIPA assigns it a Class B address using the network address 169.254/16, which yields the address range 169.254.0.0 to 169.254.255.255.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      85,
      99,
      75,
      86,
      84
    ],
    "source": "9781394239306"
  },
  {
    "id": 866,
    "question": "Which of the following Internet Protocol (IPv4) address classes identifies multicast addresses?",
    "choice_a": "Class A",
    "choice_b": "Class B",
    "choice_c": "Class C",
    "choice_d": "Class D",
    "correct_answer": "D",
    "explanation": "Class D addresses are used for multicast transmissions. Class A, Class B, and Class C addresses are used for unicast transmissions. Class E is for experimental use only.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      88,
      85,
      99,
      100,
      97
    ],
    "source": "9781394239306",
    "choice_e": "Class E"
  },
  {
    "id": 867,
    "question": "Which of the following is an address that you can assign to a host on a private IPv4 network?",
    "choice_a": "192.167.9.46",
    "choice_b": "172.16.255.255",
    "choice_c": "10.1.0.253",
    "choice_d": "225.87.34.1",
    "correct_answer": "C",
    "explanation": "The address 10.1.0.253 is a proper address in the private address range 10.0.0.0 to 10.255.255.255. The address 192.167.9.46 falls outside the designated private IP address range, which is 192.168.0.0 to 192.168.255.255, and is therefore not a viable address on a private network. 172.16.255.255 is a broadcast address, which you cannot assign to a host. 225.87.34.1 falls in the Class D multicast address range and cannot be assigned to a single host.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      86,
      99,
      87,
      85,
      88
    ],
    "source": "9781394239306"
  },
  {
    "id": 868,
    "question": "Which of the following is the correct subnet mask for an IPv4 network with the address 172.16.0.0/20?",
    "choice_a": "255.255.224.0",
    "choice_b": "255.255.240.0",
    "choice_c": "255.255.248.0",
    "choice_d": "255.255.255.224",
    "correct_answer": "B",
    "explanation": "The address given uses 20 bits to identify the network, leaving 12 bits for the host identifier. In binary form, therefore, the subnet mask value would be 11111111 11111111 11110000 00000000. The decimal value for 11111111 is 255, and the decimal value for 11110000 is 240. Therefore, the subnet mask is 255.255.240.0.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      103,
      102,
      109,
      41,
      104
    ],
    "source": "9781394239306",
    "choice_e": "255.255.255.240"
  },
  {
    "id": 869,
    "question": "Ed has been assigned the IPv4 network address 192.168.2.32/28 for the computers in his department. Which of the following ranges of addresses can Ed use to configure the TCP/IP clients on his computers?",
    "choice_a": "192.168.2.32 to 192.168.2.55",
    "choice_b": "192.168.2.33 to 192.168.2.46",
    "choice_c": "192.168.2.33 to 192.168.2.40",
    "choice_d": "192.168.2.1 to 192.168.2.254",
    "correct_answer": "B",
    "explanation": "A /28 address leaves 4 bits for the host identifier. To calculate the number of hosts, Ed uses 2<sup>4</sup>\u20132=14. The first address on the subnet is therefore 192.168.2.33, and the fourteenth is 192.168.2.46.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      87,
      114,
      104,
      102,
      103
    ],
    "source": "9781394239306"
  },
  {
    "id": 870,
    "question": "Which of the following IPv4 addresses is available for use on a network device?",
    "choice_a": "1.0.0.1",
    "choice_b": "127.98.127.0",
    "choice_c": "234.9.76.32",
    "choice_d": "240.65.8.124",
    "correct_answer": "A",
    "explanation": "1.0.0.1 is a legitimate address that falls into Class A. Option B, 127.98.127.0, falls into the range of addresses reserved for use as loopback addresses (127.0.0.1 to 127.255.255.255). Option C, 234.9.76.32, falls into Class D, which is reserved for use as multicast addresses. Option D, 240.65.8.124, is a Class E address; that class is reserved for experimental use.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      85,
      88,
      84,
      99,
      114
    ],
    "source": "9781394239306"
  },
  {
    "id": 871,
    "question": "Which of the following are mechanisms by which IPv6 traffic can be transmitted on an IPv4 network through the use of tunneling? (Choose all that apply.)",
    "choice_a": "Teredo",
    "choice_b": "IPsec",
    "choice_c": "ICMPv6",
    "choice_d": "6to4",
    "correct_answer": [
      "A",
      "D",
      "E"
    ],
    "explanation": "Teredo and 6to4 are both tunneling protocols that were intended as transitional mechanisms, enabling the encapsulation of IPv6 datagrams within IPv4 packets. A NAT64 server functions as a gateway between IPv4and IPv6, using the basic network address translation mechanism to substitute an IPv6 address for an IPv4. IPsec uses tunneling, but it is not used for the encapsulation of IPv6 traffic. Internet Control Message Protocol v6, like its ICMPv4 equivalent, enables routers and hosts to transmit informational and error messages; it does not use tunneling.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      80,
      23,
      116,
      97,
      82
    ],
    "source": "9781394239306",
    "choice_e": "NAT64"
  },
  {
    "id": 872,
    "question": "Which of the following best describes why IPv6 hosts exchange ICMPv6 Router Solicitation and Router Advertisement messages with routers?",
    "choice_a": "To obtain the prefix needed to generate a link-local address",
    "choice_b": "To learn the IPv6 address of the nearest router",
    "choice_c": "To perform address conflict detection for its link-local address",
    "choice_d": "To encapsulate IPv4 packets and transmit them over the router",
    "correct_answer": "A",
    "explanation": "ICMPv6 hosts generate Router Solicitation messages and transmit them to the All Routers multicast address. Routers respond using Router Advertisement messages, which contain the prefix information that the host uses to generate a link-local address. Hosts do not have to learn the address of the nearest router, because they can use the All Routers multicast. Address conflict detection comes after the host has created a link-local address and does not use Router Solicitation and Router Advertisement messages. Hosts do not use Router Solicitation and Router Advertisement messages to encapsulate IPv4 packets.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      146,
      147,
      93,
      99,
      100
    ],
    "source": "9781394239306"
  },
  {
    "id": 873,
    "question": "Which of the following is the IPv6 equivalent of Automatic Private IP Addressing (APIPA)?",
    "choice_a": "EUI-64",
    "choice_b": "SLAAC",
    "choice_c": "APIPAv6",
    "choice_d": "DHCPv6",
    "correct_answer": "B",
    "explanation": "Stateless Address Auto-Configuration (SLAAC) is the means by which IPv6 systems self-generate link-local addresses with the prefix fe80::/64, much as IPv4 systems use APIPA to generate addresses. IPv6 systems can use DHCPv6 to obtain stateful (not stateless) addresses. An Extended Unique Identifier (such as EUI-64) is the format for a media access control (MAC) address.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      146,
      147,
      93,
      99,
      75
    ],
    "source": "9781394239306"
  },
  {
    "id": 874,
    "question": "Which of the following IPv6 address types is the functional equivalent of an IPv4 APIPA address?",
    "choice_a": "Link local",
    "choice_b": "Global unicast",
    "choice_c": "Site local",
    "choice_d": "Anycast",
    "correct_answer": "A",
    "explanation": "An IPv6 link local address is automatically assigned to each interface. Like Automatic Private IP Addressing (APIPA), it provides communication on the local network only. Global unicast addresses are routable; they are the functional equivalent of IPv4 registered addresses. Site local addresses are the equivalent of private IPv4 addresses. Anycast addresses are designed to transmit to any one host in a multicast group.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      93,
      100,
      147,
      75,
      86
    ],
    "source": "9781394239306"
  },
  {
    "id": 875,
    "question": "A network interface adapter in a workstation has a hexadecimal MAC address of 001F9EFC7AD0. Which of the following would be the adapter's IPv6 link local address based on its EUI-64 value?",
    "choice_a": "FE80::001F:9EFF:FEFC:7AD0",
    "choice_b": "FE80::FFFE:021F:9EFC:7AD0",
    "choice_c": "FE80::FF00:1F9E:FC7A:D0FE",
    "choice_d": "FE80::021F:9EFF:FEFC:7AD0",
    "correct_answer": "D",
    "explanation": "To convert a MAC address to an Extended Unique Identifier (EUI-64), you split the 6-byte MAC address into two 3-byte halves and insert the 2-byte value FFFE in between, as follows: <p>001F9E FFFE FC7AD0</p><p>Then, you change the seventh bit in the first byte, the universal/local bit, from 0 to 1, indicating that this is a locally created address. This results in a binary first byte value of 00000010, which converts to 02 in hexadecimal.</p><p>Finally, you add the IPv6 link local prefix FE80::/10, resulting in the following complete address:</p><p>FE80::021F:9EFF:FEFC:7AD0</p><p>All of the other answers either insert the FFFE bytes in the wrong place or fail to change the universal/local bit.</p>",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      92,
      99,
      41,
      100,
      42
    ],
    "source": "9781394239306"
  },
  {
    "id": 876,
    "question": "Which of the following is a valid IPv6 address?",
    "choice_a": "fe00::b491:cf79:p493:23ff",
    "choice_b": "2001:0:49e6:39ff:8cf5:6812:ef56",
    "choice_c": "fe00::c955:c944:acdd:3fcb",
    "choice_d": "2001:0:44ef68:23eb:99fe:72bec6:ea5f",
    "correct_answer": "C",
    "explanation": "The address fe00::c955:c944:acdd:3fcb is correctly formatted for IPv6, with the double colon replacing three blocks of zeroes. Uncompressed, the address would appear as follows: fe00:0000:0000:0000:c955:c944:acdd:3fcb. Option A contains a nonhexadecimal digit. Option B contains only seven 16-bit blocks (and no double colon) instead of the eight required for 128 bits. Option D contains blocks larger than 16 bits.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      92,
      99,
      100,
      93,
      147
    ],
    "source": "9781394239306"
  },
  {
    "id": 877,
    "question": "Which of the following best defines the concept of the dual stack?",
    "choice_a": "A computer with two network interface adapters",
    "choice_b": "A computer with two installed operating systems",
    "choice_c": "A computer with two sets of networking protocols",
    "choice_d": "A computer with connections to two different network segments",
    "correct_answer": "C",
    "explanation": "A dual stack is an IP implementation that includes both IPv4 and IPv6 protocol stacks, operating simultaneously. A computer with two network adapters or connections to two network segments is often called multihomed. A computer with two installed operating systems is called a dual-boot system.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      99,
      93,
      92,
      147,
      86
    ],
    "source": "9781394239306"
  },
  {
    "id": 878,
    "question": "In a software-defined network (SDN), as defined in the RFC 7426 specification, a plane is a set of resources related to a particular function. Which of the following is not one of the five planes defined in the SDN architecture?",
    "choice_a": "Forwarding",
    "choice_b": "Operational",
    "choice_c": "Control",
    "choice_d": "Management",
    "correct_answer": "E",
    "explanation": "The RFC 7426 document defines five planes in the SDN architecture: forwarding, operational, control, management, and application. Infrastructure is not one of the SDN planes.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      295,
      297,
      291,
      281,
      285
    ],
    "source": "9781394239306",
    "choice_e": "Infrastructure",
    "choice_f": "Application"
  },
  {
    "id": 879,
    "question": "Which of the following layers in a software-defined network (SDN) architecture consists of hardware devices?",
    "choice_a": "Application",
    "choice_b": "Control",
    "choice_c": "Infrastructure",
    "choice_d": "Core",
    "correct_answer": "C",
    "explanation": "In an SDN architecture, the Application layer is software, that is, the applications and services running on the network; the control layer is a centralized console through which administrators manage the applications; and the infrastructure layer consists of the switch and router hardware. Core is not one of the SDN layers.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      295,
      297,
      17,
      81,
      285
    ],
    "source": "9781394239306"
  },
  {
    "id": 880,
    "question": "Ralph is evaluating software products for potential deployment on his company's network. Which of the following types of searches can Ralph use to identify security issues that have been discovered in specific products?",
    "choice_a": "CIA",
    "choice_b": "CVE",
    "choice_c": "SKU",
    "choice_d": "SIEM",
    "correct_answer": "B",
    "explanation": "The Common Vulnerabilities and Exposures (CVE) database is a resource that assigns identifier numbers to known security issues found in software products. By searching the database, Ralph can learn about the vulnerabilities that have already been found in the products he is evaluating. The CIA triad lists important information security concepts (confidentiality, integrity, and availability), but it does not provide information about specific products. Stock-keeping units (SKUs) are product identifiers that do not involve security issues. Security information and event management (SIEM) is a solution that gathers and analyzes information about a network's security events, but it would not help Ralph discover vulnerabilities in the products he is evaluating.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      25
    ],
    "source": "9781394239306"
  },
  {
    "id": 881,
    "question": "When starting her new position as a network administrator, Alice was given two user accounts. One account is intended for standard user activities, and the other has the additional permissions needed for Alice to perform administrative tasks. This is an example of which of the following security concepts?",
    "choice_a": "Zero day",
    "choice_b": "Multifactor authentication",
    "choice_c": "Least privilege",
    "choice_d": "Defense in depth",
    "correct_answer": "C",
    "explanation": "Least privilege is the practice of only providing users with the permissions they need to perform their designated tasks and no more. For her standard activities, Alice is given an account that does not have administrative permissions because she does not need those permissions to perform standard tasks. The administrative account has the additional permissions needed for Alice to perform administrative tasks. The intention is for Alice to use that account only for those administrative tasks. Zero day is a type of vulnerability; multifactor authentication calls for users to supply two identifying factors; defense in depth refers to the use of multiple security mechanisms to provide additional protection. None of these three options refers to the use of multiple user accounts.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      299,
      203,
      205,
      282,
      288
    ],
    "source": "9781394239306"
  },
  {
    "id": 882,
    "question": "Which of the following is a practice that a zero trust architecture (ZTA) is designed to protect against?",
    "choice_a": "Zero day vulnerabilities",
    "choice_b": "External threats",
    "choice_c": "Deauthentication",
    "choice_d": "Lateral movement",
    "correct_answer": "D",
    "explanation": "Lateral movement is when a user gains basic access to a network by legitimate means and then uses it to gain unauthorized access to other resources inside the network. A zero trust architecture provides full protection for all sensitive resources, even from users already inside the network. A zero trust architecture does not protect against zero day vulnerabilities, which are exploits in software; external threats; or deauthentication, which is a type of denial-of-service attack.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      299,
      300,
      295,
      202,
      5
    ],
    "source": "9781394239306"
  },
  {
    "id": 883,
    "question": "Which of the following is not one of the advantages of infrastructure as code (IaC) deployment for cloud-based virtual machines?",
    "choice_a": "IaC provides rapid deployment of playbooks containing virtual machine configurations.",
    "choice_b": "IaC provides configuration drift protection for virtual machines.",
    "choice_c": "IaC provides cost savings by automating the virtual machine configuration process.",
    "choice_d": "IaC provides increased security by encrypting the virtual machine configuration.",
    "correct_answer": "D",
    "explanation": "Infrastructure as code (IaC) is a method of deploying and configuring cloud-based resources using script files. IaC deployment provides time and cost savings and improved elasticity and scalability by automating the virtual machine deployment process, providing a central repository for source control, and deploying upgrades and updates. IaC also ensures a consistent deployment, preventing configuration drift by using the same script for all newly deployed VMs. IaC does not encrypt the virtual machine configuration.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      302,
      291,
      293,
      289,
      290
    ],
    "source": "9781394239306",
    "choice_e": "IaC provides elasticity and scalability by simplifying the virtual machine deployment process.",
    "choice_f": "IaC can automate the deployment of operating system and application upgrades and updates."
  },
  {
    "id": 884,
    "question": "Which of the following is a benefit that the SD-WAN architecture brings when compared to a standard WAN architecture?",
    "choice_a": "The SD-WAN architecture routes traffic based on IP addresses and access control lists.",
    "choice_b": "The SD-WAN architecture provides routing and QoS based on the application producing the data.",
    "choice_c": "The SD-WAN architecture routes traffic through a central datacenter to the cloud.",
    "choice_d": "The SD-WAN architecture provides end-to-end performance guarantees.",
    "correct_answer": "B",
    "explanation": "The software-defined wide area network (SD-WAN) architecture is application aware and provides routing and quality of service (QoS) adjustments based on the data source. A standard WAN architecture routes traffic through a central datacenter based on IP addresses and ACLs, but an SD-WAN does not. The SD-WAN architecture calls for the creation of a virtual network that runs on top of the physical connections and is therefore uninvolved with the underlying technology. The SD-WAN architecture does not provide end-to-end performance guarantees.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      296,
      4,
      16,
      285,
      299
    ],
    "source": "9781394239306",
    "choice_e": "The SD-WAN architecture is implemented as a virtual overlay that is entirely transport agnostic."
  },
  {
    "id": 885,
    "question": "Which of the following is not one of the three core services that make up the security service edge (SSE) cloud security framework?",
    "choice_a": "CASB",
    "choice_b": "ZTNA",
    "choice_c": "SASE",
    "choice_d": "SWG",
    "correct_answer": "C",
    "explanation": "Secure access service edge (SASE) is not an element of the SSE framework. In fact, SSE is a subset of SASE. Cloud access security broker (CASB), zero trust network access (ZTNA), and secure web gateway (SWG) are all elements of the SSE framework.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      300,
      299,
      290,
      288,
      296
    ],
    "source": "9781394239306"
  },
  {
    "id": 886,
    "question": "Which of the following are the three fundamental principles of a zero trust architecture (ZTA)? (Choose three.)",
    "choice_a": "Use least privileges",
    "choice_b": "Always authenticate and authorize",
    "choice_c": "Assume a breach",
    "choice_d": "Use the three-tier hierarchical model",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "The zero trust architecture (ZTA) calls for least privileges, in which users start with no access to the network at all and then receive privileges only for the resources they require to perform their jobs, continual authentication and authorization whenever users access protected resources, and the assumption that every access request is a breach by an intruder attempting to move laterally within the network. The three-tiered hierarchical model describes a physical network architecture that is not part of a zero trust architecture.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      299,
      300,
      203,
      205,
      282
    ],
    "source": "9781394239306"
  },
  {
    "id": 887,
    "question": "Which of the following protocols are commonly used in zero touch provisioning (ZTP)? (Choose all that apply.)",
    "choice_a": "DHCP",
    "choice_b": "FTP",
    "choice_c": "TFTP",
    "choice_d": "HTTPS",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Zero trust provisioning is a means of automatically configuring routers, switches, or other network devices by having them download a configuration file from a Dynamic Host Configuration Protocol (DHCP) or Trivial File Transfer Protocol (TFTP) server. File Transfer Protocol (FTP) and Hypertext Transfer Protocol Secure (HTTPS) are not used in ZTP transactions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      296,
      73,
      114,
      293,
      302
    ],
    "source": "9781394239306"
  },
  {
    "id": 888,
    "question": "Which of the following are reasons why an overlay network using a virtual extensible LAN (VXLAN) might be preferable to one using VLANs? (Choose all that apply.)",
    "choice_a": "VXLANs can be used for Data Center Interconnect (DCI).",
    "choice_b": "VXLANs use a 24-bit network identifier.",
    "choice_c": "VXLANs run as an overlay network.",
    "choice_d": "VXLANs encapsulate layer 2 frames within TCP segments.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "VXLANs can function as an DCI overlay network connecting remote datacenters together. VLAN switches use a 12-bit identifier, which limits them to 4,096 VLANs. VXLANs use a 24-bit network identifier, which enables them to support up to 16 million networks. VXLANs use the same physical underlay network as VLANs, so they are no faster. VXLANs and VLANs both run as an overlay network, so neither is preferable for that reason. VXLANs encapsulate layer 2 Ethernet frames within UDP datagrams, not TCP segments.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      298,
      77,
      23,
      82,
      4
    ],
    "source": "9781394239306"
  },
  {
    "id": 889,
    "question": "Network address translation (NAT) operates at which layer of the Open Systems Interconnection (OSI) model?",
    "choice_a": "Data link",
    "choice_b": "Network",
    "choice_c": "Transport",
    "choice_d": "Application",
    "correct_answer": "B",
    "explanation": "NAT works by modifying IP addresses, which are a Network layer element. The Data link layer is concerned only with communications on the local subnet and is not involved with NAT processing. Because NAT modifies only the IP packet headers, it works with any Transport layer protocol. NAT also works with most TCP/IP applications because it operates below the Application layer of the OSI model.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      68,
      54,
      129,
      119,
      121
    ],
    "source": "9781394239306"
  },
  {
    "id": 890,
    "question": "Which of the following devices enable users on private networks to access the Internet by substituting a registered IP address for their private addresses? (Choose all that apply.)",
    "choice_a": "NAT router",
    "choice_b": "RADIUS server",
    "choice_c": "Proxy server",
    "choice_d": "UTM appliance",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Network address translation (NAT) is a Network layer device that converts the private IP addresses of all of a client's transmissions to a registered IP address. NAT therefore works for all applications. A proxy server is an Application layer device that performs the same type of conversion, but only for specific applications. A Remote Authentication Dial-In User Service (RADIUS) server can provide authentication, authorization, accounting, auditing (AAAA) services for remote access servers; it does not convert IP addresses. A unified threat management (UTM) appliance typically performs VPN, firewall, and antivirus functions. It too does not convert IP addresses.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      62,
      63,
      187,
      67,
      126
    ],
    "source": "9781394239306"
  },
  {
    "id": 891,
    "question": "Which of the following routing protocols uses the packet format shown in the figure? <img src=\"/question_assets/Network+/c02uf001.png\"/>",
    "choice_a": "RIPv1",
    "choice_b": "RIPv2",
    "choice_c": "OSPF",
    "choice_d": "EIGRP",
    "correct_answer": "B",
    "explanation": "The figure displays the format for a Routing Information Protocol (RIP) version 2 packet. The figure does not show the packet format for RIPv1, which lacks the Subnet Mask and Next Hop fields for the individual routes, making subnetting impossible. The figure also does not show the format of Open Shortest Path First (OSPF), Enhanced Interior Gateway Routing Protocol (EIGRP), or Border Gateway Protocol (BGP).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      131,
      142,
      143,
      149
    ],
    "source": "9781394239306",
    "choice_e": "BGP"
  },
  {
    "id": 892,
    "question": "Which of the following statements about the Enhanced Interior Gateway Routing Protocol (EIGRP) is not true?",
    "choice_a": "EIGRP does not support classless IPv4 addresses.",
    "choice_b": "EIGRP is a hybrid routing protocol.",
    "choice_c": "EIGRP can only transmit incremental routing table updates.",
    "choice_d": "EIGRP shares routes within an autonomous system.",
    "correct_answer": "A",
    "explanation": "EIGRP can support classless IPv4 addresses. It was designed to replace the Interior Gateway Routing Protocol (IGRP), which could not support classless addresses. All of the other options contain true statements.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      140,
      131,
      138,
      149,
      137
    ],
    "source": "9781394239306"
  },
  {
    "id": 893,
    "question": "Which of the following are techniques used in traffic shaping to prevent networks from being overwhelmed by data transmissions? (Choose all that apply.)",
    "choice_a": "Bandwidth throttling",
    "choice_b": "Rate limiting",
    "choice_c": "Broadcast storming",
    "choice_d": "Network address translation (NAT)",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Bandwidth throttling is a traffic shaping technique that prevents specified data streams from transmitting too many packets. Rate limiting is a traffic shaping technique that controls the transmission rate of sending systems. A broadcast storm is a type of network switching loop. NAT is a method by which private networks can share registered IP addresses. Neither of these last two is a traffic shaping technique.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      165,
      71,
      155,
      153,
      66
    ],
    "source": "9781394239306"
  },
  {
    "id": 894,
    "question": "Which of the following terms refers to methods by which network traffic is prioritized to prevent applications from suffering faults due to network congestion?",
    "choice_a": "Port forwarding",
    "choice_b": "Dynamic routing",
    "choice_c": "VLANs",
    "choice_d": "QoS",
    "correct_answer": "D",
    "explanation": "<i>Quality of service</i> (<i>QoS</i>) is a general term that refers to various mechanisms for prioritizing network traffic so that applications or data streams requiring a certain level of performance are not negatively affected by lower-priority transmissions. Port forwarding is a routing method that redirects traffic intended for one IP address and port number to another. Dynamic routing is a method by which routing tables are automatically updated with new information as the routing fabric of an internetwork changes. Virtual local area networks (VLANs) are a means for partitioning a broadcast domain into discrete units that are functionally equivalent to physical LANs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      165,
      162,
      161,
      66,
      71
    ],
    "source": "9781394239306"
  },
  {
    "id": 895,
    "question": "Which of the following mechanisms for prioritizing network traffic uses a 6-bit classification identifier in the Internet Protocol (IP) header?",
    "choice_a": "Diffserv",
    "choice_b": "CoS",
    "choice_c": "Traffic shaping",
    "choice_d": "QoS",
    "correct_answer": "A",
    "explanation": "Differentiated services (DiffServ) is a mechanism that provides quality of service (QoS) on a network by classifying traffic types using a 6-bit value in the Differentiated Services (DS) field of the IP header. Class of service (CoS) is a similar mechanism that operates at the Data link layer by adding a 3-bit Priority Code Point (PCP) value to the Ethernet frame. Traffic shaping is a means of prioritizing network traffic that typically works by delaying packets at the Application layer. <i>Quality of service</i> (<i>QoS</i>) is an umbrella term that encompasses a variety of network traffic prioritization mechanisms. Administrative distance is a value that routers use to select the most efficient routing protocol.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      165,
      65,
      162,
      71,
      66
    ],
    "source": "9781394239306",
    "choice_e": "Administrative distance"
  },
  {
    "id": 896,
    "question": "Which of the following elements enables routers to select the best path to a destination when there are multiple routing protocols running on the network?",
    "choice_a": "Metrics",
    "choice_b": "Administrative distance",
    "choice_c": "CoS",
    "choice_d": "MTU",
    "correct_answer": "B",
    "explanation": "Routing protocols typically have some mechanism for determining the best route to a destination, but those mechanisms are often incompatible with those of other routing protocols. Administrative distance is a value that enables routers to select the most reliable routing protocol to use when multiple protocols supply routes to the same destination. Metrics are values specifying the best route among those supplied by a single protocol. Class of service (CoS) is a mechanism that operates at the Data link layer by adding a 3-bit Priority Code Point (PCP) value to the Ethernet frame. The maximum transmission unit (MTU) specifies the size of the largest packet transmittable in a single Network layer transmission.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      133,
      131,
      137,
      140,
      68
    ],
    "source": "9781394239306"
  },
  {
    "id": 897,
    "question": "Which of the following statements about static routing are true? (Choose all that apply.)",
    "choice_a": "Static routes are manually configured routes that administrators must add, modify, or delete when a change in the network occurs.",
    "choice_b": "Static routes are automatically added to the routing table by routing protocols when a new network path becomes available.",
    "choice_c": "Static routes adapt to changes in the network infrastructure automatically.",
    "choice_d": "Static routes are a recommended solution for large internetworks with redundant paths to each destination network.",
    "correct_answer": [
      "A",
      "E"
    ],
    "explanation": "Administrators must manually add, modify, or delete static routes when a change in a network occurs. For this reason, static routes are not recommended for use in large internetworks where there are multiple paths to each destination network. Static routes are not automatically added by routing protocols and do not adapt to changes in a network.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      120,
      130,
      119,
      131,
      137
    ],
    "source": "9781394239306",
    "choice_e": "Static routes are a recommended solution for small internetworks with a single path to each destination network."
  },
  {
    "id": 898,
    "question": "Which of the following terms refers to a routing protocol that does not rely on hop counts to measure the efficiency of routes?",
    "choice_a": "Interior gateway protocol",
    "choice_b": "Edge gateway protocol",
    "choice_c": "Distance vector protocol",
    "choice_d": "Link state protocol",
    "correct_answer": "D",
    "explanation": "Distance vector protocols rely on hop counts to evaluate the efficiency of routes. Link state protocols use a different type of calculation, usually based on Dijkstra's algorithm. The terms <i>interior gateway protocol</i> and <i>edge gateway protocol</i> do not refer to the method of calculating routing efficiency.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      131,
      142,
      137,
      138,
      141
    ],
    "source": "9781394239306"
  },
  {
    "id": 899,
    "question": "What is the maximum number of routes that can be included in a single RIP broadcast packet?",
    "choice_a": "20",
    "choice_b": "25",
    "choice_c": "32",
    "choice_d": "Unlimited",
    "correct_answer": "B",
    "explanation": "A single RIP broadcast packet can include up to 25 routes. If there are more than 25 routes in the computer's routing table, then RIP must generate additional packets.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      130,
      119,
      131,
      132
    ],
    "source": "9781394239306"
  },
  {
    "id": 900,
    "question": "Which of the following routing protocols can you use on a TCP/IP internetwork with segments running at different speeds, making hop counts an inaccurate measure of route efficiency? (Choose all that apply.)",
    "choice_a": "Enhanced Interior Gateway Routing Protocol (EIGRP)",
    "choice_b": "Routing Information Protocol (RIP)",
    "choice_c": "Open Shortest Path First (OSPF)",
    "choice_d": "Border Gateway Protocol (BGP)",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "OSPF is a link state routing protocol, which means that it does not rely solely on hop counts to measure the relative efficiency of a route. EIGRP is a hybrid protocol that can use link state routing. RIP is a distance vector routing protocol, meaning that it uses hop counts to measure route efficiency. BGP is an exterior gateway protocol that exchanges routing information among autonomous systems using path vectors or distance vectors.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      131,
      142,
      140,
      138,
      143
    ],
    "source": "9781394239306"
  },
  {
    "id": 901,
    "question": "Which of the following statements about the Open Shortest Path First (OSPF) routing protocol is false?",
    "choice_a": "OSPF is an interior gateway protocol.",
    "choice_b": "OSPF is a link state routing protocol.",
    "choice_c": "OSPF does not support Classless Inter-Domain Routing (CIDR).",
    "choice_d": "OSPF shares routes within an autonomous system.",
    "correct_answer": "C",
    "explanation": "OSPF does support CIDR. All of the other options contain true statements.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      142,
      131,
      138,
      144
    ],
    "source": "9781394239306"
  },
  {
    "id": 902,
    "question": "What is the term for the process by which dynamic routing protocols update other routers with routing table information?",
    "choice_a": "Convergence",
    "choice_b": "Distance vectoring",
    "choice_c": "Redistribution",
    "choice_d": "Dissemination",
    "correct_answer": "A",
    "explanation": "<i>Convergence</i> is the term for the process by which routers propagate information from their routing tables to other routers on the network using dynamic routing protocols. Distance vectoring, redistribution, and dissemination do not describe this process.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      137,
      119,
      130,
      120,
      142
    ],
    "source": "9781394239306"
  },
  {
    "id": 903,
    "question": "Which of the following TCP/IP routing protocols measures the efficiency of routes by the number of hops between the source and the destination?",
    "choice_a": "Routing Internet Protocol (RIP)",
    "choice_b": "Open Shortest Path First (OSPF)",
    "choice_c": "Border Gateway Protocol (BGP)",
    "choice_d": "Intermediate System to Intermediate System (IS-IS)",
    "correct_answer": "A",
    "explanation": "RIP is a distance vector protocol, which uses hop counts to measure the efficiency of routes. OSPF, BGP, and IS-IS are all link state protocols, which do not rely on hop counts.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      137,
      138,
      131,
      142,
      120
    ],
    "source": "9781394239306"
  },
  {
    "id": 904,
    "question": "Which of the following types of routing protocols routes datagrams between autonomous systems?",
    "choice_a": "EGP",
    "choice_b": "RIP",
    "choice_c": "IGP",
    "choice_d": "OSPF",
    "correct_answer": "A",
    "explanation": "Exterior Gateway Protocol (EGP) routes datagrams between autonomous systems. Interior Gateway Protocol (IGP) routes datagrams within an autonomous system. Routing Information Protocol (RIP) and Open Shortest Path First (OSPF) are examples of interior gateway protocols. OSPF shares routes within an autonomous system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      131,
      142,
      140,
      143
    ],
    "source": "9781394239306"
  },
  {
    "id": 905,
    "question": "Which of the following command-line tools can you use to create and modify static routes on a Unix or Linux system? (Choose all that apply.)",
    "choice_a": "route",
    "choice_b": "ifconfig",
    "choice_c": "traceroute",
    "choice_d": "ip",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "The <code>route</code> command was originally created to display a Unix or Linux system's routing table and modify its contents by adding, changing, and deleting static routes. The <code>ip</code> command is part of the <code>iproute2</code> command-line utility package, which has replaced <code>route</code> in many Unix and Linux distributions. Running <code>ip</code> with the <code>route</code> parameter can manipulate the routing table. The <code>traceroute</code> and <code>ifconfig</code> tools are not commands for manipulating the routing table.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      119,
      120,
      54,
      122,
      124
    ],
    "source": "9781394239306"
  },
  {
    "id": 906,
    "question": "Routers that use the Open Shortest Path First (OSPF) routing protocol calculate the relative costs of routes through the network by exchanging which of the following specifications for each interface with other routers?",
    "choice_a": "Transmission speed",
    "choice_b": "Data link layer protocol",
    "choice_c": "Network medium",
    "choice_d": "IP address",
    "correct_answer": "A",
    "explanation": "Routers that use OSPF transmit the speed of each network interface with the other OSPF routers in the network. This enables the routers to evaluate the cost of various routes through the network and transmit packets using the route with the smallest cost value. The routers do not need to share information about the Data link layer protocols or network media they use, their IP addresses, their prefix length, or their metrics.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      142,
      131,
      137,
      136
    ],
    "source": "9781394239306",
    "choice_e": "Prefix length",
    "choice_f": "Metric"
  },
  {
    "id": 907,
    "question": "Which of the following statements about the Border Gateway Protocol (BGP) is not true?",
    "choice_a": "BGP is an exterior gateway protocol.",
    "choice_b": "BGP is a link state routing protocol.",
    "choice_c": "BGP supports Classless Inter-Domain Routing (CIDR).",
    "choice_d": "BGP shares routes among autonomous systems.",
    "correct_answer": "B",
    "explanation": "BGP is a path vector routing protocol, not a link state routing protocol. All of the other options contain true statements.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      131,
      137,
      142,
      140
    ],
    "source": "9781394239306"
  },
  {
    "id": 908,
    "question": "In an IPv4 routing table, what is the network destination address for the host system's default route?",
    "choice_a": "0.0.0.0",
    "choice_b": "127.0.0.0",
    "choice_c": "127.255.255.255",
    "choice_d": "255.255.255.255",
    "correct_answer": "A",
    "explanation": "The default route in an IPv4 routing table always has a destination address of 0.0.0.0. The other destinations are found in a routing table, but they are not the default route destination.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      119,
      120,
      130,
      54,
      128
    ],
    "source": "9781394239306"
  },
  {
    "id": 909,
    "question": "Which of the following routing protocols has both interior and exterior designations, based on whether it is used for routing within an autonomous system or on the Internet?",
    "choice_a": "RIP",
    "choice_b": "OSPF",
    "choice_c": "EIGRP",
    "choice_d": "BGP",
    "correct_answer": "D",
    "explanation": "The Border Gateway Protocol (BGP) is a highly scalable protocol used for routing both on private autonomous systems, where it is known as the Internal Border Gateway Protocol (iBGP) and maintains full mesh communication among all of the routers, and on the Internet, where it is known as the External Border Gateway Protocol (eBGP). Routing Information Protocol (RIP), Open Shortest Path First (OSPF), and Enhanced Interior Gateway Routing Protocol (EIGRP) do not have interior and exterior designations.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      141,
      131,
      137,
      140,
      143
    ],
    "source": "9781394239306"
  },
  {
    "id": 910,
    "question": "Which of the following Network layer protocols include a Time to Live (TTL) field? (Choose all that apply.)",
    "choice_a": "IPv4",
    "choice_b": "IPv6",
    "choice_c": "ICMP",
    "choice_d": "IGMP",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "The Internet Protocol (IP) in both of its versions (IPv4 and IPv6) includes a TTL field in its message header that limits the number of times a packet can be routed on a network. Each router processing the packet reduces the TTL value by one until it reaches zero, after which it is discarded. The Internet Control Message Protocol (ICMP) and the Internet Group Management Protocol (IGMP) do not have a TTL field.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      123,
      121,
      68,
      119
    ],
    "source": "9781394239306"
  },
  {
    "id": 911,
    "question": "Which of the following is not a method of traffic shaping?",
    "choice_a": "Rate limiting",
    "choice_b": "WAN optimization",
    "choice_c": "Bandwidth throttling",
    "choice_d": "Self-limiting",
    "correct_answer": "B",
    "explanation": "WAN optimization is not a form of traffic shaping, because it compresses data streams and transmits incremental file updates. Traffic shaping uses techniques like rate limiting, bandwidth throttling, and self-limiting to delay the transmission of specific types of data packets to optimize network performance.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      165,
      262,
      66,
      150,
      71
    ],
    "source": "9781394239306"
  },
  {
    "id": 912,
    "question": "Which of the following statements about proxy servers and NAT servers are true? (Choose all that apply.)",
    "choice_a": "NAT servers and proxy servers can both provide Internet access to clients running any application.",
    "choice_b": "NAT servers and proxy servers both use public IP addresses.",
    "choice_c": "NAT servers and proxy servers both access Internet servers and relay the responses to network clients.",
    "choice_d": "NAT servers and proxy servers both cache web data for later use.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "To provide clients with Internet access, a NAT or proxy server must have direct access to the Internet, which requires using a registered, or public, IP address. Both NAT and proxy servers function as the middleman in transactions between the client computers on a private network and Internet servers. The NAT or proxy server transmits the client's service request to the Internet server as though it was its own and, after receiving the reply, relays the response back to the client. Because NAT servers function at the Network layer, clients can use any application to access the Internet through the server. Proxy servers, however, operate at the Application layer and can provide Internet access only to certain types of client applications. Proxy servers are capable of caching web data for later use, because they are Application layer devices that read the Application layer protocol data in the message packets they receive. NAT servers are Network layer processes that forward packets with no knowledge of the Application layer information in their contents.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      62,
      68,
      54,
      187,
      129
    ],
    "source": "9781394239306"
  },
  {
    "id": 913,
    "question": "Which two of the following functions is the multifunction device on a small office, home office (SOHO) network known as a broadband router least likely to provide? (Choose two.)",
    "choice_a": "Wireless access point (WAP)",
    "choice_b": "Switch",
    "choice_c": "Proxy server",
    "choice_d": "DHCP server",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "Broadband routers generally do not function as proxy servers, which are Application layer devices used to regulate access to the Internet. They are also typically not virtual private network (VPN) headends, which enable multiple remote VPN clients to connect to the network. Many broadband routers are also WAPs, enabling users to construct a LAN without a complicated and expensive cable installation. Many broadband routers have switched ports for connections to wired devices, such as printers and computers. Most broadband routers use DHCP to assign IP addresses to devices on the private network.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      67,
      62,
      187,
      71,
      54
    ],
    "source": "9781394239306",
    "choice_e": "VPN headend"
  },
  {
    "id": 914,
    "question": "Small office, home office (SOHO) networks typically use a multifunction connectivity device that can perform all but which one of the following functions?",
    "choice_a": "DHCP",
    "choice_b": "DNS",
    "choice_c": "Switch",
    "choice_d": "Router",
    "correct_answer": "E",
    "explanation": "SOHO multifunction devices typically function as routers connecting the local network to an Internet service provider (ISP), switches providing wired connections to host devices, Dynamic Host Configuration Protocol (DHCP) servers assigning IP addresses, Domain Name System (DNS) servers resolving names into IP addresses, network address translation (NAT) routers providing hosts with private IP addresses access to the Internet, and APs providing wireless devices with access to the network. They do not function as hubs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      67,
      70,
      71,
      187,
      54
    ],
    "source": "9781394239306",
    "choice_e": "Hub",
    "choice_f": "NAT router",
    "choice_g": "Access point (AP)"
  },
  {
    "id": 915,
    "question": "Review the following figure. How many collision domains and broadcast domains exist in the network diagram? <img src=\"/question_assets/Network+/c02uf002.png\"/>",
    "choice_a": "There are three collision domains and three broadcast domains.",
    "choice_b": "There is one collision domain and three broadcast domains.",
    "choice_c": "There is one broadcast domain and three collision domains.",
    "choice_d": "There are no collision domains and only one broadcast domain.",
    "correct_answer": "A",
    "explanation": "Each port on a router defines a separate collision domain. Hubs forward all traffic to all of the connected nodes, so each network segment is a single-collision domain. Routers do not forward broadcasts, so each network segment is also a separate broadcast domain.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      66,
      71,
      53,
      68,
      70
    ],
    "source": "9781394239306",
    "choice_e": "There are nine collision domains and three broadcast domains."
  },
  {
    "id": 916,
    "question": "Which of the following is a correct definition of a collision domain?",
    "choice_a": "A group of local area networks (LANs) connected by routers, thus enabling any node to transmit to any other node",
    "choice_b": "A group of computers connected so that a broadcast transmission by any one device reaches all of the other devices",
    "choice_c": "A group of devices connected by cable segments that are longer than the maximum length stated in the physical layer specification",
    "choice_d": "A group of devices connected so that when two devices transmit at exactly the same time, a data collision occurs",
    "correct_answer": "D",
    "explanation": "A collision domain is a LAN with a shared network medium, so that two devices transmitting at the same time generate a signal quality error, also known as a collision. Ethernet LANs connected by hubs create a shared medium, whereas switched networks create a separate collision domain for each connected node. Routers create separate collision domains. A group of computers able to receive broadcasts is the definition of a broadcast domain, not a collision domain. Overlong cables can precipitate collisions but do not define a collision domain.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      52,
      71,
      66,
      53,
      150
    ],
    "source": "9781394239306"
  },
  {
    "id": 917,
    "question": "A VPN headend is an advanced type of which of the following devices?",
    "choice_a": "Switch",
    "choice_b": "Router",
    "choice_c": "Gateway",
    "choice_d": "Bridge",
    "correct_answer": "B",
    "explanation": "A virtual private network (VPN) headend is a type of router that enables multiple client systems to access a network from remote locations. Because the device provides an interface between networks, it is considered to be a type of router, not a switch, a gateway, or a bridge.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      63,
      54,
      71,
      145,
      264
    ],
    "source": "9781394239306"
  },
  {
    "id": 918,
    "question": "Routers using link states and Dijkstra's algorithm to calculate the lowest cost route to a specific destination can conceivably be running which of the following interior gateway routing protocols? (Choose all that apply.)",
    "choice_a": "OSPF",
    "choice_b": "RIP",
    "choice_c": "EIGRP",
    "choice_d": "BGP",
    "correct_answer": "A",
    "explanation": "Link states and Dijkstra's algorithm are used by link state routing protocols, such as Open Shortest Path First (OSPF). Routing Information Protocol (RIP) and Enhanced Interior Gateway Routing Protocol (EIGRP) are distance vector protocols, which do not use link states. Border Gateway Protocol (BGP) is a distance vector protocol and an exterior (not interior) gateway protocol.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      142,
      143,
      131,
      140,
      137
    ],
    "source": "9781394239306"
  },
  {
    "id": 919,
    "question": "Concurrent multipath routing (CMR) is a technique that provides which of the following benefits? (Choose all that apply.)",
    "choice_a": "Increased bandwidth",
    "choice_b": "Fault tolerance",
    "choice_c": "Data encapsulation",
    "choice_d": "Load balancing",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "CMR is a technique in which routers transmit data packets using multiple routes to the destination. This provides load balancing and improved performance by spreading the transmission among multiple paths and a measure of fault tolerance because a failure of one route only endangers part of the data. Data encapsulation is not involved in the CMR process.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      261,
      173,
      273,
      119,
      137
    ],
    "source": "9781394239306"
  },
  {
    "id": 920,
    "question": "A first hop redundancy protocol (FHRP) is designed to dynamically alter which one of the following Internet Protocol (IP) configuration settings on a network host?",
    "choice_a": "IP address",
    "choice_b": "Subnet mask",
    "choice_c": "Default gateway",
    "choice_d": "DNS server address",
    "correct_answer": "C",
    "explanation": "FHRPs provide a fault tolerant default gateway for network hosts by automatically failing over to an alternative router address in the event of a router failure. Protocols such as Virtual Router Redundancy Protocol (VRRP) and Hot Standby Router Protocol (HSRP) create a virtual router that hosts use for their default gateway. The virtual router contains the addresses of multiple physical routers, to which it sends packets transmitted by the hosts. This provides fault tolerance in the event that a router fails, and in some cases provides load balancing as well. FHRPs do not affect the hosts' IP addresses, subnet masks, or DNS server addresses.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      145,
      264,
      274,
      275,
      121
    ],
    "source": "9781394239306"
  },
  {
    "id": 921,
    "question": "Which of the following is not a first hop redundancy protocol (FHRP)?",
    "choice_a": "CARP",
    "choice_b": "VRRP",
    "choice_c": "HSRP",
    "choice_d": "RARP",
    "correct_answer": "D",
    "explanation": "FHRPs provide a fault tolerant default gateway for network hosts by automatically failing over to an alternative router address in the event of a router failure. The Reverse Address Resolution Protocol (RARP) is a deprecated Internet Protocol (IP) address assignment protocol; it is not an FHRP. Common Address Redundancy Protocol (CARP), Virtual Router Redundancy Protocol (VRRP), and Hot Standby Router Protocol (HSRP) are all FHRPs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      145,
      264,
      274,
      275,
      132
    ],
    "source": "9781394239306"
  },
  {
    "id": 922,
    "question": "When two workstations access the Internet using the same port address translation (PAT) router, which of the following does the router assign to each workstation? (Choose all that apply.)",
    "choice_a": "A common public IPv4 address",
    "choice_b": "A unique port number",
    "choice_c": "A common port number",
    "choice_d": "A unique public IPv4 address",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Unlike network address translation (NAT), port address translation (PAT) uses a single public IPv4 address for all of the client workstations. Instead of assigning each workstation a unique address, PAT assigns each workstation a unique port number.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      187,
      68,
      54,
      273,
      145
    ],
    "source": "9781394239306"
  },
  {
    "id": 923,
    "question": "Which of the following are examples of virtual IP (VIP) addresses? (Choose all that apply.)",
    "choice_a": "An IP address assigned to a host workstation by a DHCP server",
    "choice_b": "A public IP address substituted for a host's own private IP address by a NAT router",
    "choice_c": "An IP address assigned to a host workstation by APIPA",
    "choice_d": "An IP address assigned to a virtual NIC",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "A virtual IP address is an address that does not correspond to a physical network interface. Network address translation (NAT) uses virtual public IP addresses as substitutes for the private IP addresses associated with the client hosts. A network interface in a virtual machine is virtual as well, so the IP address associated with that interface must also be virtual. Dynamic Host Configuration Protocol (DHCP) and Automatic Private IP Addressing (APIPA) both can assign IP addresses to physical network interfaces; these addresses are therefore not virtual.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      274,
      275,
      264,
      145,
      156
    ],
    "source": "9781394239306"
  },
  {
    "id": 924,
    "question": "Which of the following is the best definition of a subinterface?",
    "choice_a": "A logical network interface created from a physical network interface",
    "choice_b": "One of the ports on a physical network interface adapter with multiple ports",
    "choice_c": "A physical network interface connected to a subnet",
    "choice_d": "One of the IP addresses associated with a network interface that has multiple IP addresses",
    "correct_answer": "A",
    "explanation": "A subinterface is a logical (or virtual) network interface associated with a specific physical network interface. Devices (such as routers) can use multiple subinterfaces to connect to different subnets using a single physical network interface adapter. A subinterface is a logical device, so it is not one port on a physical network interface adapter or a physical adapter connected to a subnet. A subinterface is a complete logical interface, not just an IP address.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      54,
      164,
      173,
      51,
      156
    ],
    "source": "9781394239306"
  },
  {
    "id": 925,
    "question": "When a router receives a packet destined for the address 192.168.14.73, which of the routing criteria will it use first to select from the following routing table entries? <table border=\"1\"> <thead> <tr> <th class=\"left\" scope=\"col\">Protocol</th> <th class=\"left\" scope=\"col\">Administrative Distance</th> <th class=\"left\" scope=\"col\">Prefix</th> <th class=\"left\" scope=\"col\">Next Hop</th> <th class=\"left\" scope=\"col\">Metric</th> </tr> </thead> <tbody> <tr> <td class=\"left\">RIP</td> <td class=\"left\">120</td> <td class=\"left\">192.168.14.64/26</td> <td class=\"left\">172.16.9.1</td> <td class=\"left\">6</td> </tr> <tr> <td class=\"left\">OSPF</td> <td class=\"left\">110</td> <td class=\"left\">192.168.14.0/25</td> <td class=\"left\">172.16.10.1</td> <td class=\"left\">240</td> </tr> <tr> <td class=\"left\">EIGRP</td> <td class=\"left\">90</td> <td class=\"left\">192.168.14.0/24</td> <td class=\"left\">172.16.11.1</td> <td class=\"left\">33789</td> </tr> </tbody> </table>",
    "choice_a": "Administrative distance",
    "choice_b": "Prefix length",
    "choice_c": "Next hop",
    "choice_d": "Metric",
    "correct_answer": "B",
    "explanation": "The route with the longest matching prefix is the most specific route, which the router always uses first when evaluating routing table entries. Routers use administrative distance to evaluate routes with the same prefix length. The next hop value is not used to evaluate preferred routes. Metrics are valid only in comparison to other routes generated by the same protocol.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      133,
      131,
      140,
      119,
      122
    ],
    "source": "9781394239306"
  },
  {
    "id": 926,
    "question": "The jumbo frame capability is associated with which layer of the Open Systems Interconnection (OSI) model?",
    "choice_a": "Application",
    "choice_b": "Transport",
    "choice_c": "Network",
    "choice_d": "Data link",
    "correct_answer": "D",
    "explanation": "Ethernet uses jumbo frames at the Data link layer to transfer large amounts of data more efficiently. Ethernet typically restricts frame size to 1,500 bytes, but jumbo frames enable Ethernet systems to create frames up to 9,000 bytes. Frames are protocol data units (PDUs) associated only with the Data link layer, so they do not apply to the Network, Transport, or Application layers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      177,
      53,
      69,
      152,
      129
    ],
    "source": "9781394239306"
  },
  {
    "id": 927,
    "question": "Port security on an Ethernet switch is implemented through the use of which of the following methods?",
    "choice_a": "Deny listed MAC addresses",
    "choice_b": "Allow listed MAC addresses",
    "choice_c": "Port-by-port MAC address filtering",
    "choice_d": "Spoofed MAC addresses",
    "correct_answer": "C",
    "explanation": "When implemented in an Ethernet switch, port security uses port-by-port MAC address filtering to allow only one MAC address to access each switch port. Deny listing blocks the MAC addresses on the list from using all of the ports on the switch. Allow listing allows the listed MAC addresses to use any port on the switch. MAC address spoofing is a method for defeating port security, deny lists, or allow lists.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      169,
      152,
      153,
      172,
      126
    ],
    "source": "9781394239306"
  },
  {
    "id": 928,
    "question": "Which of the following features helps to protect network switches from attacks related to the Spanning Tree Protocol (STP)? (Choose all that apply.)",
    "choice_a": "BPDU guard",
    "choice_b": "Root guard",
    "choice_c": "DHCP snooping",
    "choice_d": "Geofencing",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Bridge protocol data units (BPDUs) are messages that switches running the Spanning Tree Protocol exchange to learn about the available paths through a switched network and the states of other switches. Switches should only receive BPDUs through ports that are connected to other switches. BPDU guard is a feature that prevents BPDU messages from arriving through ports connected to end systems, such as computers, thus preventing an attacker from manipulating the STP topology. A root guard affects the behavior of the STP by enforcing the selection of root bridge ports on a switched network. Without root guards, there is no way for administrators to enforce the topology of a network with a redundant switching fabric. DHCP snooping is a security feature implemented on layer 2 network switches that prevents unauthorized DHCP servers from accessing the network. Geofencing is a wireless technology that uses radio frequency identification (RFID) or GPS coordinates to define a geographic perimeter.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      171,
      157,
      159,
      172,
      170
    ],
    "source": "9781394239306"
  },
  {
    "id": 929,
    "question": "An enterprise network has been designed with individual departmental switches because, in most cases, the devices in a specific department exchange network traffic with other devices in the same department. Each of the departmental switches is also connected to a host switch, which enables devices to communicate with other departments. Which of the following terms describes this switching architecture?",
    "choice_a": "Distributed switching",
    "choice_b": "Port forwarding",
    "choice_c": "Traffic shaping",
    "choice_d": "Neighbor discovery",
    "correct_answer": "A",
    "explanation": "Distributed switching describes a hierarchical switching architecture in which remote switches (departmental switches in this case) handle most of the network traffic, with a host switch used only for traffic between the remote locations. Port forwarding is a routing method that redirects traffic intended for one IP address and port number to another. Traffic shaping is a series of techniques that optimizes the allocation of network bandwidth. Neighbor discovery is an IPv6 technique used to find addresses of devices and services on the local network. Flow control is a technique for regulating a system's transmission speed.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      156,
      71,
      150,
      66,
      68
    ],
    "source": "9781394239306",
    "choice_e": "Flow control"
  },
  {
    "id": 930,
    "question": "Review the following figure. Note that each store-and-forward switch has three connected node ports and one port for switch-to-switch connections. All node ports and links are configured for half-duplex communication. The switch-to-switch links are configured for full-duplex communication. Which of the following statements about the switched network is true? <img src=\"/question_assets/Network+/c02uf003.png\"/>",
    "choice_a": "There are nine collision domains, one for each half-duplex connection.",
    "choice_b": "There are 12 collision domains, one for each switch connection.",
    "choice_c": "There are three collision domains, one for each switch-to-switch connection.",
    "choice_d": "There is one collision domain for this network.",
    "correct_answer": "A",
    "explanation": "All half-duplex port connections on a store-and-forward switch represent a different collision domain. Full-duplex connections are not subject to collisions, so they do not define separate collision domains.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      53,
      70,
      71,
      150,
      151
    ],
    "source": "9781394239306"
  },
  {
    "id": 931,
    "question": "Which of the following could be a valid MAC address for a network interface adapter?",
    "choice_a": "10.124.25.43",
    "choice_b": "FF:FF:FF:FF:FF:FF",
    "choice_c": "00:1A:6B:31:9A:4E",
    "choice_d": "03:AE:16:3H:5B:11",
    "correct_answer": "C",
    "explanation": "A media access control (MAC) address is a 6-byte hexadecimal value, with the bytes separated by colons, as in 00:1A:6B:31:9A:4E. Option A, 10.124.25.43, is all decimals and uses periods; this is an IPv4 address. Option B, FF:FF:FF:FF:FF:FF, is a valid MAC address, but this value is reserved for use as a broadcast address. Option D, 03:AE:16:3H:5B:11, is not a valid hexadecimal address, which should contain only numerals and the letters A to F. Option E, fe80::89a5:9e4d:a9d0:9ed7, is too long for a MAC address; this is a valid IPv6 address.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      51,
      126,
      53,
      152,
      178
    ],
    "source": "9781394239306",
    "choice_e": "fe80::89a5:9e4d:a9d0:9ed7"
  },
  {
    "id": 932,
    "question": "Which of the following protocols prevents network switching loops from occurring by shutting down redundant links until they are needed?",
    "choice_a": "RIP",
    "choice_b": "STP",
    "choice_c": "VLAN",
    "choice_d": "NAT",
    "correct_answer": "B",
    "explanation": "The Spanning Tree Protocol (STP) prevents packets from endlessly looping from switch to switch due to redundant links. Creating redundant links is a good preventive against switch failure, but packets transmitted over multiple links can circulate from switch to switch infinitely. STP creates a database of switching links and shuts down the redundant ones until they are needed. The Routing Information Protocol (RIP) propagates routing table information. A virtual local area network (VLAN) is an organizational tool that operates within switches by creating multiple broadcast domains. Network address translation (NAT) is a routing method that enables private networks to share registered IP addresses. Address Resolution Protocol (ARP) is a protocol that discovers a system's MAC address by broadcasting its IPv4 address.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      157,
      179,
      158,
      155,
      173
    ],
    "source": "9781394239306",
    "choice_e": "ARP"
  },
  {
    "id": 933,
    "question": "Which of the following cable types can be used to connect an MDI port on a workstation to an Auto-MDI-X port on an Ethernet switch? (Choose all that apply.)",
    "choice_a": "A crossover twisted-pair cable",
    "choice_b": "A straight-through twisted-pair cable",
    "choice_c": "A coaxial cable",
    "choice_d": "A single-mode fiber-optic cable",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "When connecting an MDI port to an Auto-MDI-X port, it is possible to use either a straight-through or a crossover cable because the Auto-MDI-X port can self-adjust to implement the necessary crossover circuit if it is needed. MDI and Auto-MDI-X ports are used only with twisted-pair cables, so there is no need for coaxial or fiber-optic cables.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      151,
      53,
      162,
      173,
      150
    ],
    "source": "9781394239306",
    "choice_e": "A multimode fiber-optic cable"
  },
  {
    "id": 934,
    "question": "Which of the following is a protocol that identifies VLANs by inserting a 32-bit field in the Ethernet frame?",
    "choice_a": "IEEE 802.1P",
    "choice_b": "IEEE 802.1Q",
    "choice_c": "IEEE 802.1X",
    "choice_d": "IEEE 802.1AB",
    "correct_answer": "B",
    "explanation": "IEEE 802.1Q is a standard defining a mechanism (called Ethernet trunking by some manufacturers) that identifies the virtual local area network (VLAN) to which a packet belongs by inserting an extra 32-bit field into its Ethernet frame. IEEE 802.1P is a standard that defines a mechanism for implementing quality of service (QoS) at the Data link layer by adding a 3-bit field into Ethernet frames. IEEE 802.1X is a standard defining an authentication mechanism called port-based network access control (PNAC). IEEE 802.1AB is a standard defining the Link Layer Discovery Protocol (LLDP). IEEE 802.1AX is a specification for the Link Aggregation Control Protocol (LACP), which is a mechanism for combining physical ports into a single logical channel.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      163,
      162,
      167,
      160,
      165
    ],
    "source": "9781394239306",
    "choice_e": "IEEE 802.1AX"
  },
  {
    "id": 935,
    "question": "Each of the following Carrier Sense Multiple Access with Collision Detection (CSMA/CD) events occurs on an Ethernet network when two stations transmit simultaneously, although not in the order listed. Which of the following events occurs immediately after the collision?",
    "choice_a": "The two stations observe a random backoff interval.",
    "choice_b": "The two stations transmit a jam signal.",
    "choice_c": "The two stations stop transmitting.",
    "choice_d": "The two stations listen to see if the channel is idle.",
    "correct_answer": "C",
    "explanation": "Stations on a CSMA/CD network first check the medium to see if it is idle. If they detect an idle medium, they begin transmitting. If two or more devices transmit at the same time, a collision occurs. Immediately after a collision occurs, the two stations involved stop transmitting. After that, they send out a jam signal. Then, the two stations back off for a random interval, and the transmission process begins again.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      52,
      70,
      66,
      150,
      71
    ],
    "source": "9781394239306",
    "choice_e": "The two stations begin retransmitting their frames."
  },
  {
    "id": 936,
    "question": "For the Carrier Sense Multiple Access with Collision Detection (CSMA/CD) mechanism to function properly on an Ethernet network, host systems must be able to detect when a collision occurs so they can react to it. Which of the following cabling errors can prevent the collision detection process from functioning properly?",
    "choice_a": "Excessively long cable segments",
    "choice_b": "Incorrect wiring pinouts",
    "choice_c": "Too many systems on a single network",
    "choice_d": "An excessive number of collisions",
    "correct_answer": "A",
    "explanation": "For CSMA/CD to function properly, a system must detect a packet collision while it is transmitting the packet. If cable segments are too long, the packet might leave the transmitting system before the collision is detected, resulting in a late collision, which cannot be retransmitted. Incorrect pinouts, too many systems, and excessive collisions typically will not prevent the collision detection system from occurring.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      52,
      70,
      57,
      151,
      69
    ],
    "source": "9781394239306"
  },
  {
    "id": 937,
    "question": "When a packet collision between two systems occurs on an Ethernet network, Carrier Sense Multiple Access with Collision Detection (CSMA/CD) causes the two systems to stop transmitting and generate a jam signal. After sending the jam signal, why do the two systems wait for a randomized backoff interval before retransmitting their packets?",
    "choice_a": "They need time to reassemble the packets.",
    "choice_b": "To prevent another collision from occurring.",
    "choice_c": "They need to rebuffer the packet.",
    "choice_d": "To recalculate the packets' checksum values.",
    "correct_answer": "B",
    "explanation": "After transmitting their jam signals, the two systems wait for a randomized interval. This is to prevent them from retransmitting their packets at the same time, resulting in another collision. It is not necessary for the systems to reassemble, rebuffer, or recalculate checksums for their packets.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      57,
      52,
      70,
      150,
      66
    ],
    "source": "9781394239306"
  },
  {
    "id": 938,
    "question": "Which of the following devices is used to physically connect computers in the same VLAN?",
    "choice_a": "A bridge",
    "choice_b": "A hub",
    "choice_c": "A switch",
    "choice_d": "A router",
    "correct_answer": "C",
    "explanation": "Replacing routers with switches turns an internetwork into a single large subnet, and virtual local area networks (VLANs) exist as logical elements on top of the switching fabric. Although VLANs are the functional equivalent of Network layer subnets, the systems in a single VLAN are still physically connected by switches, not routers. Bridges connect network segments at the Data link layer and selectively forward traffic between the segments. However, bridges do not provide a dedicated connection between two systems like a switch does, and they do not make it possible to convert a large, routed internetwork into a single switched network. Therefore, they have no role in implementing VLANs. Hubs are physical layer devices that propagate all incoming traffic out through all of their ports. Replacing the routers on an internetwork with hubs would create a single shared broadcast domain with huge amounts of traffic and many collisions. Hubs, therefore, do not connect the computers in a VLAN.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      160,
      71,
      150,
      53,
      66
    ],
    "source": "9781394239306"
  },
  {
    "id": 939,
    "question": "Which of the following statements is true about an Ethernet network that uses CSMA/CD?",
    "choice_a": "Collisions are a normal occurrence.",
    "choice_b": "Collisions never occur unless there is a network fault.",
    "choice_c": "Collisions cause data to be irretrievably lost.",
    "choice_d": "Collisions are the result of duplicate IP addresses.",
    "correct_answer": "A",
    "explanation": "Collisions are a normal occurrence on an Ethernet network; they occur when two nodes transmit at exactly the same time. There need not be a network fault for collisions to occur. When collisions occur, the nodes involved retransmit their packets so that no data is lost. Collisions are a phenomenon of Data link layer protocols; they have nothing to do with IP addresses, which are Network layer constructs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      52,
      70,
      150,
      71,
      51
    ],
    "source": "9781394239306"
  },
  {
    "id": 940,
    "question": "Which of the following is an abnormal occurrence on an Ethernet network?",
    "choice_a": "Packet retransmissions",
    "choice_b": "Collision detection",
    "choice_c": "Jam signals",
    "choice_d": "Late collisions",
    "correct_answer": "D",
    "explanation": "Collisions are a normal occurrence on an Ethernet network, but late collisions are not normal. Late collisions occur when two packets collide after one or more finishes transmitting. Packet retransmissions, collision detection, and jam signals are all normal occurrences on an Ethernet network.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      52,
      70,
      71,
      150,
      151
    ],
    "source": "9781394239306"
  },
  {
    "id": 941,
    "question": "VLANs create the administrative boundaries on a switched network that are otherwise provided by which of the following devices?",
    "choice_a": "Hubs",
    "choice_b": "Routers",
    "choice_c": "Domains",
    "choice_d": "Bridges",
    "correct_answer": "B",
    "explanation": "Connecting subnets with routers at the Network layer maintains the Data link layer administrative boundaries that prevent broadcast transmissions from being propagated throughout the entire internetwork. Switching eliminates those Data link layer boundaries, and administrators can use virtual local area networks (VLANs) to simulate them. Because hubs propagate all of the traffic they receive out through all of their ports indiscriminately, they create no administrative boundaries. Domains are logical groups of network devices defined by the Domain Name System (DNS). Their functions are not related to VLANs in any way. Switches are essentially multiport bridges that forward incoming traffic only to the device for which it is destined. Therefore, bridges are more closely related to eliminating administrative boundaries than to establishing them.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      160,
      66,
      155,
      68,
      71
    ],
    "source": "9781394239306"
  },
  {
    "id": 942,
    "question": "Which of the following statements about VLANs are true? (Choose all that apply.)",
    "choice_a": "All of the devices in a particular VLAN must be physically connected to the same switch.",
    "choice_b": "A VLAN creates a limited broadcast domain on a switched network.",
    "choice_c": "You must have VLANs on a switched network for communication between computers on different cable segments to occur.",
    "choice_d": "A router is required for communication between VLANs.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "The computers in a single virtual local area network (VLAN) can be located anywhere on a switched network, irrespective of the switches' physical configuration. A broadcast message generated by a computer in a VLAN is transmitted to all of the other computers in that VLAN only, just as if the systems were physically located on a separate LAN or subnet. Unicast transmissions between computers on a switched network do not require VLANs, because the switches create what amounts to a direct connection between the two systems. VLANs are needed only for communication processes that require the use of broadcasts, which if transmitted without VLANs, would flood the network. Even though they are a purely logical construction, VLANs function just like physical subnets and require routers for communication between them. Routing capabilities are often integrated into switches to enable communication between VLANs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      160,
      164,
      155,
      162,
      66
    ],
    "source": "9781394239306"
  },
  {
    "id": 943,
    "question": "Which of the following elements can be used to identify the devices in a particular VLAN? (Choose all that apply.)",
    "choice_a": "Hardware addresses",
    "choice_b": "IP addresses",
    "choice_c": "DNS names",
    "choice_d": "Switch port numbers",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Every network device has a unique hardware address coded into its network interface adapter, and administrators can use these addresses to select the devices that will be part of a specific virtual local area network (VLAN). When VLANs are implemented in the switch's VLAN database, selecting the ports to which specific computers are attached is a simple way to identify the computers in a particular VLAN. IP addresses are layer 3 (Network layer) constructs, so they do not apply to layer 2 (Data link layer) devices like switches. Although DNS names do uniquely identify computers on a network, DNS is an Application layer process and has nothing to do with the switching and routing processes, which occur at the Data link and Network layers. Therefore, you cannot use DNS names to identify the computers in a VLAN.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      161,
      162,
      160,
      126,
      153
    ],
    "source": "9781394239306"
  },
  {
    "id": 944,
    "question": "Alice has a network that consists of three virtual LANs (VLANs) defined on all of the network's switches. VLAN 10 is the Sales VLAN; VLAN 20 is the Marketing VLAN; and VLAN 30 is the Accounting VLAN. Users are reporting that they cannot communicate with anyone outside of their own VLANs. What is the problem, and what must Alice do?",
    "choice_a": "The problem is a faulty VLAN configuration on one of the switches. Alice needs to re-create the VLANs and configure each VLAN for routing.",
    "choice_b": "One of the VLANs is configured to filter all other VLAN traffic for security purposes. Alice needs to change the filter on this VLAN.",
    "choice_c": "VLANs are limited to Data link layer communication only. To allow communication between VLANs, Alice must add a router or a layer 3 switch to the network and configure it to route traffic between the VLANs.",
    "choice_d": "The VLANs are using different Data link layer protocols. VLANs must use the same Data link layer protocol in order to communicate.",
    "correct_answer": "C",
    "explanation": "VLANs are Data link layer local area networks (LANs) defined within switches. Only devices (and users) connected to ports belonging to the same VLAN can communicate with each other until a layer 3 device, such as a router or a layer 3 switch, is added to the network. Re-creating and reconfiguring the VLANs will not correct this problem. Traffic filters are usually implemented on routers. VLANs do not have to use the same Data link protocol.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      164,
      160,
      68,
      54,
      71
    ],
    "source": "9781394239306"
  },
  {
    "id": 945,
    "question": "Which of the following technologies would you be less likely to find on the average small office, home office (SOHO) network? (Choose all that apply.)",
    "choice_a": "NAT",
    "choice_b": "DHCP",
    "choice_c": "10GBase-T",
    "choice_d": "VLAN",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "SOHO networks typically consist of a single subnet and require only a basic switch without the advanced virtual local area network (VLAN) capabilities that enable administrators to create separate subnets. Most SOHO networks have a Dynamic Host Configuration Protocol (DHCP) server that assigns IP addresses and other TCP/IP configuration settings to clients. The DHCP server can be integrated into a broadband router or another Internet access sharing solution. Most SOHO networks support network address translation (NAT), enabling them to use private IP addresses and still access the Internet. 10GBase-T is the designation for UTP-based 10 Gigabit Ethernet, which is an advanced standard for network interface adapters often found in servers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      67,
      160,
      53,
      187,
      196
    ],
    "source": "9781394239306"
  },
  {
    "id": 946,
    "question": "Which of the following modifications occurs when you configure the native virtual local area network (VLAN) on your network switches to use 802.1Q tagging?",
    "choice_a": "Double-tagged packets are prevented.",
    "choice_b": "BPDU guards are applied.",
    "choice_c": "Root guards are applied.",
    "choice_d": "Trunk traffic is routed, not switched.",
    "correct_answer": "A",
    "explanation": "To join ports on different switches into one VLAN, you designate a trunk port on each switch for the traffic between switches. Initially, the native VLAN uses the default VLAN1 for trunk traffic, and that traffic is left untagged. Untagged traffic is susceptible to attacks using double-tagged packets. When you configure the native VLAN to use tagging, this makes it impervious to double-tagging. Changing the native VLAN does not create root guards or bridge protocol data unit (BPDU) guards, and all traffic continues to be switched, not routed.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      163,
      162,
      171,
      160,
      159
    ],
    "source": "9781394239306"
  },
  {
    "id": 947,
    "question": "Which of the following protocols is responsible for inserting the tags into frames that enable switches to forward them to the appropriate virtual local area network (VLAN)?",
    "choice_a": "IEEE 802.3x",
    "choice_b": "IEEE 802.1X",
    "choice_c": "IEEE 802.1Q",
    "choice_d": "IEEE 802.11ac",
    "correct_answer": "C",
    "explanation": "The IEEE 802.1Q protocol is responsible for VLAN tagging, a procedure that enables network switches to support VLANs. Through the insertion of VLAN identifier tags into frames, switches can determine which VLAN each packet is destined for and forward it to the correct ports. IEEE 802.3x is one of the standards for wired Ethernet networks. IEEE 802.1X is a standard that defines a port-based network access control (PNAC) mechanism used for authentication on wireless and other networks. IEEE 802.11ac is a standard defining the physical and Data link layer protocols for wireless networks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      163,
      162,
      160,
      166,
      165
    ],
    "source": "9781394239306"
  },
  {
    "id": 948,
    "question": "Which of the following best explains how tagging the native virtual local area network (VLAN) traffic can improve in-band switch management security?",
    "choice_a": "By renaming the default VLAN",
    "choice_b": "By preventing double-tagged packets",
    "choice_c": "By encrypting in-band management traffic",
    "choice_d": "By moving in-band management traffic off the native VLAN",
    "correct_answer": "B",
    "explanation": "When in-band switch management traffic, such as that generated by a Secure Shell (SSH) connection to a switch, uses the native VLAN, it is untagged by default. This is because the native VLAN is at first the default VLAN1, which is not tagged by the 802.1Q protocol, leaving it open to certain types of double-tagging attacks. When you tag the native VLAN traffic, it is rendered immune to double-tagging. The default VLAN cannot be renamed in the VLAN database, and SSH traffic is already encrypted by the sending workstation. Changing the native VLAN does not move the management traffic off that VLAN, although many authorities advocate the creation of a separate VLAN dedicated to in-band management traffic.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      163,
      162,
      168,
      169,
      160
    ],
    "source": "9781394239306"
  },
  {
    "id": 949,
    "question": "A switch with auto-medium-dependent interface crossover (MDI-X) ports eliminates the need for which of the following?",
    "choice_a": "8P8C connectors",
    "choice_b": "Switch-to-switch connections",
    "choice_c": "Straight-through cables",
    "choice_d": "Crossover cables",
    "correct_answer": "D",
    "explanation": "Ethernet implementations, such as 100Base-TX, which use separate wire pairs for transmitting and receiving data, require a crossover circuit to ensure that the transmit pins on each end of a connection are wired to the receive pins at the other end. This crossover circuit can be implemented in a patch cable\u2014called a crossover cable\u2014or by a switch port. Switches with auto-medium-dependent interface crossover (MDI-X) ports can detect the need for a crossover circuit and implement it automatically in the port. This eliminates the need for crossover cables. Auto-medium-dependent interface crossover (MDI-X) ports do not eliminate the need for 8P8C connectors, connections between switches, or straight-through cables.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      51,
      53,
      71,
      152,
      153
    ],
    "source": "9781394239306"
  },
  {
    "id": 950,
    "question": "Which of the following cable types is needed to connect an MDI port on a workstation to an MDI-X port on an Ethernet switch?",
    "choice_a": "A crossover twisted-pair cable",
    "choice_b": "A straight-through twisted-pair cable",
    "choice_c": "A coaxial cable",
    "choice_d": "A single-mode fiber-optic cable",
    "correct_answer": "B",
    "explanation": "When connecting an MDI port to an MDI-X port, the necessary crossover circuit is implemented in the MDI-X port. Therefore, the connection needs a straight-through cable and there is no need for a crossover cable. MDI and MDI-X ports are used only with twisted-pair cables, so there is no need for coaxial or fiber-optic cables.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      151,
      152,
      153,
      53,
      129
    ],
    "source": "9781394239306",
    "choice_e": "A multimode fiber-optic cable"
  },
  {
    "id": 951,
    "question": "Which of the following problems is the Spanning Tree Protocol (STP) intended to prevent? (Choose all that apply.)",
    "choice_a": "Broadcast storms",
    "choice_b": "Late collisions",
    "choice_c": "Bridging loops",
    "choice_d": "Crosstalk",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "STP disables redundant links between switches that can allow packets to circulate endlessly around the network. This is called a bridging loop. As a result of a bridging loop, the network can be flooded with broadcast traffic, which is called a broadcast storm. STP does nothing to prevent late collisions, which is an Ethernet timing problem, or crosstalk, which is a cabling fault.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      157,
      179,
      159,
      155,
      150
    ],
    "source": "9781394239306"
  },
  {
    "id": 952,
    "question": "Which of the following identifiers does a switch use to forward incoming packets out through the correct ports?",
    "choice_a": "IP addresses",
    "choice_b": "MAC addresses",
    "choice_c": "DNS names",
    "choice_d": "MTU values",
    "correct_answer": "B",
    "explanation": "Switches use media access control (MAC) addresses to identify the ports associated with specific hosts. The switch reads the destination MAC address from each incoming packet and forwards it out through the port associated with that address. Switches are Data link layer devices, so they do not use IP addresses or DNS names to forward packets. The maximum transmission unit (MTU) value specifies the maximum size of Data link layer frames; the switch does not use it to forward packets.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      153,
      178,
      152,
      126,
      69
    ],
    "source": "9781394239306"
  },
  {
    "id": 953,
    "question": "Which of the following statements about the Spanning Tree Protocol (STP) is not true?",
    "choice_a": "STP operates at the Data link layer of the OSI model.",
    "choice_b": "STP is implemented in switches.",
    "choice_c": "STP prevents traffic from circulating endlessly around a network.",
    "choice_d": "STP compiles a database containing the IP addresses of connected devices.",
    "correct_answer": "D",
    "explanation": "STP operates at the Data link layer of the OSI model, so it works with hardware addresses, not IP addresses. Switches use STP to prevent redundant links from causing traffic loops on the network.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      157,
      159,
      53,
      129,
      126
    ],
    "source": "9781394239306"
  },
  {
    "id": 954,
    "question": "Ralph has been hired by a company to redesign its local area network (LAN). Right now, it has a single 100 Mbps Ethernet LAN with 40 users and two shared servers, all connected through three hubs. The users on the network must be able to share files with one another and also access the shared servers. The users are complaining that the network is too slow. Management states that cost is a factor that must be considered. Which of the following upgrade scenarios should Ralph recommend in this situation?",
    "choice_a": "Split the network into smaller segments with dedicated hubs as opposed to shared hubs.",
    "choice_b": "Split the network into two routed LANs with 20 users each.",
    "choice_c": "Replace the hubs with switches to define separate collision domains and filter unnecessary traffic from each segment.",
    "choice_d": "Replace the hubs with a layer 3 switch and define two virtual LANs (VLANs) with 20 users each.",
    "correct_answer": "C",
    "explanation": "The best choice is to replace the hubs with switches, since the network is relatively small and cost is an issue. On the existing network, all users share the same 100 Mbps communication channel, and each computer must take turns transmitting. By replacing the hubs with switches, you provide each computer with a dedicated 100 Mbps connection to the switch, while reducing unnecessary traffic and collisions on the network. There is no such thing as a dedicated hub. Splitting the network into two routed LANs is not the best solution, because all users must share information on a constant basis. Also, cost is a factor, and routers are more expensive than switches. Replacing the hubs with a layer 3 switch and defining two VLANs with 20 users each is not a reasonable solution because layer 3 switches are very expensive.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      71,
      150,
      151,
      66,
      155
    ],
    "source": "9781394239306"
  },
  {
    "id": 955,
    "question": "Which of the following is the correct term for the process by which the Spanning Tree Protocol (STP) on a switch evaluates the paths through the network and places each port in the forwarding or blocking state?",
    "choice_a": "Assimilation",
    "choice_b": "Convergence",
    "choice_c": "Tree-building",
    "choice_d": "Listening",
    "correct_answer": "B",
    "explanation": "The process by which STP populates its database with information about each port in a switch and designates the ports as forwarding or blocking is called convergence. <i>Assimilation</i>, <i>tree-building</i>, and <i>listening</i> are not terms for STP path evaluation.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      157,
      179,
      158,
      159,
      171
    ],
    "source": "9781394239306"
  },
  {
    "id": 956,
    "question": "A multilayer switch typically functions at which layers of the OSI reference model? (Choose two.)",
    "choice_a": "Data link",
    "choice_b": "Network",
    "choice_c": "Transport",
    "choice_d": "Application",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "All switches operate at the Data link layer of the OSI model, but multilayer switches usually also function as routers, which are Network layer devices, through the use of a switch virtual interface (SVI). They are not usually transport or Application layer devices.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      62,
      164,
      68,
      53,
      71
    ],
    "source": "9781394239306"
  },
  {
    "id": 957,
    "question": "Five computers are connected to the same switch, but only four are able to communicate with each other. Assuming that all of the hardware is functioning properly, which of the following could be a reason for the fifth computer's communication problem?",
    "choice_a": "The switch has the fifth computer connected to a virtual local area network (VLAN) that is different from that of the other four.",
    "choice_b": "The network is experiencing a switching loop.",
    "choice_c": "The fifth computer is experiencing an MTU black hole, whereas the other four computers are not.",
    "choice_d": "There is a virtual router between the fifth computer and the other four.",
    "correct_answer": "A",
    "explanation": "If the fifth computer was in a different VLAN from the other four, it would be unable to communicate with them. A switching loop would affect communication between all of the computers, not just the fifth one. An MTU black hole is a condition in which a system is unable to complete the Path MTU Discovery process, due to an intervening firewall. Because these five computers are all on the same LAN, they all have the same MTU, and Path MTU Discovery is not necessary. A virtual router would enable switched computers on different subnets to communicate with each other; it would not prevent them from communicating.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      160,
      162,
      161,
      264,
      155
    ],
    "source": "9781394239306"
  },
  {
    "id": 958,
    "question": "A small business office currently has a 1000Base-T Ethernet network with a single eight-port switch. All of the switchports are populated, and the business owner wants to expand the network further. However, the switch does not have an uplink port. The owner has purchased a new switch, also with eight ports, that does have an uplink port, but he does not know how to connect them together. What must the owner do to install the new switch on the network?",
    "choice_a": "Use a standard patch cable to connect a standard port on the existing switch to a standard port on the new switch.",
    "choice_b": "Use a standard patch cable to connect a standard port on the existing switch to the uplink port on the new hub.",
    "choice_c": "Purchase a crossover cable and use it to connect a standard port on the existing switch to the uplink port on the new switch.",
    "choice_d": "Purchase a second new switch with an uplink port to replace the old one and use a standard patch cable to connect the two uplink ports together.",
    "correct_answer": "B",
    "explanation": "Standard switchports have a crossover circuit, which ensures that the transmit signals at one end of the connection arrive at the receive pins at the other end. The uplink port in a switch bypasses the crossover circuit, so that two connected switches do not have crossover circuits that cancel each other out. A connection between a standard port and an uplink port, using a standard cable, results in a single crossover, which is correct wiring. Each of the other solutions results in either two crossovers or no crossovers, both of which are incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      53,
      71,
      152,
      157,
      168
    ],
    "source": "9781394239306"
  },
  {
    "id": 959,
    "question": "Which of the following tasks can you perform to split a large, switched local area network (LAN) into multiple broadcast domains? (Choose all that apply.)",
    "choice_a": "Replace one or more switches with hubs.",
    "choice_b": "Install a firewall to filter broadcast traffic.",
    "choice_c": "Enable the Spanning Tree Protocol (STP) on the switches.",
    "choice_d": "Create virtual local area networks (VLANs) in the switches.",
    "correct_answer": [
      "D",
      "E"
    ],
    "explanation": "By default, a switched LAN consists of a single broadcast domain. To create multiple broadcast domains, you can install routers to split the installation into two or more networks, because routers do not forward broadcasts. The other possibility is to create VLANs in the switches. Each VLAN is a separate broadcast domain. All of the other options would have no effect on the number of broadcast domains on the network.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      160,
      66,
      155,
      68,
      71
    ],
    "source": "9781394239306",
    "choice_e": "Install routers on the network."
  },
  {
    "id": 960,
    "question": "Which of the following devices can administrators use to create multiple virtual local area networks (VLANs) and forward traffic between them?",
    "choice_a": "Virtual router",
    "choice_b": "Load balancer",
    "choice_c": "Broadband router",
    "choice_d": "Multilayer switch",
    "correct_answer": "D",
    "explanation": "A multilayer switch is a network connectivity device that functions at both layer 2 and layer 3 of the OSI model. At layer 2, the device functions like a normal switch, providing individual collision domains to each connected node and enabling administrators to create multiple VLANs. At layer 3, with the implementation of a switch virtual interface (SVI), the device also provides routing capabilities by forwarding packets between the VLANs. Virtual routers, load balancers, and broadband routers are strictly layer 3 devices that can route traffic but cannot create VLANs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      62,
      164,
      160,
      71,
      155
    ],
    "source": "9781394239306"
  },
  {
    "id": 961,
    "question": "Which of the following best explains why networks using Voice over IP (VoIP) often have separate voice and data virtual local area networks (VLANs)?",
    "choice_a": "To prevent voice and data packet conflicts",
    "choice_b": "To encrypt voice traffic",
    "choice_c": "To encrypt data traffic",
    "choice_d": "To prioritize voice traffic",
    "correct_answer": "D",
    "explanation": "When transmitting voice traffic on a network along with data traffic, the voice traffic should have priority, to ensure the quality of the stream. Separating data and voice traffic on separate VLANs enables switches to assign voice traffic a higher priority by applying appropriate tags to the voice packets. Separate VLANs are not needed to prevent packet conflicts or to encrypt either voice or data packets.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      165,
      162,
      66,
      155,
      71
    ],
    "source": "9781394239306"
  },
  {
    "id": 962,
    "question": "On a network carrying both voice and data traffic, separate virtual local area networks (VLANs) enable the voice traffic to be assigned a higher priority than the data traffic. Which of the following are methods for identifying the packets carrying voice traffic, so the switches can assign them to the voice VLAN? (Choose all that apply.)",
    "choice_a": "MAC addresses",
    "choice_b": "VLAN tags",
    "choice_c": "IP addresses",
    "choice_d": "DNS names",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "There are two methods for identifying packets carrying voice traffic: by recognizing the MAC address of the sending system as a voice device, and by recognizing packets that have already been tagged as voice VLAN traffic. It is not possible to identify voice traffic using IP addresses or DNS names.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      162,
      161,
      169,
      165,
      126
    ],
    "source": "9781394239306"
  },
  {
    "id": 963,
    "question": "Which of the following are equivalent terms for the process of combining the bandwidth of two or more network adapters to increase the overall speed of the connection and provide fault tolerance? (Choose all that apply.)",
    "choice_a": "Bonding",
    "choice_b": "Link aggregation",
    "choice_c": "Clustering",
    "choice_d": "Port aggregation",
    "correct_answer": [
      "A",
      "B",
      "D",
      "E"
    ],
    "explanation": "<i>Bonding</i>, <i>link aggregation</i>, <i>port aggregation</i>, and <i>network interface card</i> (NIC) teaming are all terms for the same basic technology, in which the bandwidth of multiple network adapter connections is joined to speed up transmissions. The technology also enables the network communication to continue if one of the adapters is disconnected. Clustering refers to combining servers into a single unit, not network adapters.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      262,
      173,
      263,
      71,
      150
    ],
    "source": "9781394239306",
    "choice_e": "NIC teaming"
  },
  {
    "id": 964,
    "question": "Which of the following statements about port aggregation is not true?",
    "choice_a": "All of the aggregated ports use the same MAC address.",
    "choice_b": "Port aggregation can be a fault tolerance mechanism.",
    "choice_c": "Aggregating ports increases network throughput.",
    "choice_d": "Port aggregation provides load balancing.",
    "correct_answer": "D",
    "explanation": "Load balancing refers to the distribution of traffic between two or more channels. Port aggregation combines ports into a single logical channel with a single media access control (MAC) address and provides greater throughput. Port aggregation also provides fault tolerance in the event of a port failure.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      173,
      262,
      261,
      133,
      165
    ],
    "source": "9781394239306"
  },
  {
    "id": 965,
    "question": "Ralph is designing a new network with the redundant switching arrangement shown in the accompanying figure. This redundancy enables every node on the network to communicate with any other node, even if one of the switches should fail. Which of the following is a potential drawback of this arrangement? <img src=\"/question_assets/Network+/c02uf004.png\"/>",
    "choice_a": "Runt frames",
    "choice_b": "Late collisions",
    "choice_c": "Broadcast storms",
    "choice_d": "Corrupted switch lookup tables",
    "correct_answer": "C",
    "explanation": "This redundant switch arrangement can result in broadcast storms, which are caused by packets being read by multiple switches as originating on different networks. The result is endless circulation of packets from switch to switch.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      155,
      153,
      263,
      70,
      178
    ],
    "source": "9781394239306"
  },
  {
    "id": 966,
    "question": "Which of the following mechanisms for load balancing web servers is able to read the incoming HTTP and HTTPS requests and perform advanced functions based on the information they contain?",
    "choice_a": "Content switches",
    "choice_b": "Multilayer switches",
    "choice_c": "Failover clustering",
    "choice_d": "Round-robin DNS",
    "correct_answer": "A",
    "explanation": "A content switch is an Application layer device, which is what renders it capable of reading the incoming Hypertext Transfer Protocol (HTTP) and Hypertext Transfer Protocol Secure (HTTPS) messages. HTTP is an Application layer protocol. Multilayer switches do not operate above the Transport layer. Failover clustering and (DNS) round-robin are both techniques for distributing incoming traffic without actually processing it.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      62,
      68,
      71,
      63,
      151
    ],
    "source": "9781394239306"
  },
  {
    "id": 967,
    "question": "Which of the following statements about a switch's default VLAN are true?",
    "choice_a": "Administrators must create a default VLAN when configuring a new switch.",
    "choice_b": "The default VLAN on a switch cannot be deleted.",
    "choice_c": "The default VLAN on most switches is designated as VLAN 0.",
    "choice_d": "The default VLAN on a switch cannot be renamed.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "The default VLAN in the VLAN database on most switches has the ID VLAN 1, not VLAN 0, and it cannot be deleted or renamed. The default VLAN does not have to be created by the administrator; it is the one to which all ports are assigned in the default configuration.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      160,
      167,
      163,
      161,
      168
    ],
    "source": "9781394239306"
  },
  {
    "id": 968,
    "question": "Which of the following bridging types has never been used on Ethernet local area networks (LANs)?",
    "choice_a": "Store and forward",
    "choice_b": "Transparent",
    "choice_c": "Source route",
    "choice_d": "Multiport",
    "correct_answer": "C",
    "explanation": "Source route bridging was a technique used on token ring (and not Ethernet) networks, in which a routing information field (RIF) in the packet header identified the network segments the packet should follow to reach its destination. Store and forward, transparent, and multiport bridges have all been used on Ethernet networks.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      53,
      69,
      151,
      71,
      179
    ],
    "source": "9781394239306"
  },
  {
    "id": 969,
    "question": "Which of the following is the maximum transmission unit (MTU) size for an Ethernet frame?",
    "choice_a": "512",
    "choice_b": "1,024",
    "choice_c": "1,500",
    "choice_d": "1,518",
    "correct_answer": "C",
    "explanation": "The MTU is the largest amount of data (in bytes) that a protocol operating at a given layer of the OSI model can transmit in one packet. The MTU does not include any header and footer fields supplied by that protocol. For Ethernet, the maximum frame size is 1,518 bytes, which includes 18 bytes of header and footer fields. Therefore, the MTU for Ethernet is 1,500 bytes. Protocols operating at other OSI model layers can have different MTUs. For example, the typical MTU for an Internet Protocol (IPv4) implementation is smaller than that of Ethernet.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      177,
      121,
      126,
      71,
      70
    ],
    "source": "9781394239306"
  },
  {
    "id": 970,
    "question": "Which of the following devices is used to physically connect computers in the same virtual local area network (VLAN)?",
    "choice_a": "A bridge",
    "choice_b": "A hub",
    "choice_c": "A switch",
    "choice_d": "A router",
    "correct_answer": "C",
    "explanation": "Replacing routers with switches turns an internetwork into a single large subnet, and VLANs exist as logical elements on top of the switching fabric. Although VLANs are the functional equivalent of Network layer subnets, the systems in a single VLAN are still connected by switches, not routers. Bridges connect network segments at the Data link layer and selectively forward traffic between the segments. However, bridges do not provide a dedicated connection between two systems like a switch does, and they do not make it possible to convert a large, routed internetwork into a single switched network. Therefore, they have no role in implementing VLANs. Hubs are physical layer devices that propagate all incoming traffic out through all of their ports. Replacing the routers on an internetwork with hubs would create a single shared network with huge amounts of traffic and collisions. Hubs, therefore, do not connect the computers in a VLAN.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      160,
      53,
      162,
      151,
      153
    ],
    "source": "9781394239306"
  },
  {
    "id": 971,
    "question": "Which of the following protocols uses jumbo frames to increase performance levels on storage area networks?",
    "choice_a": "Ethernet",
    "choice_b": "IP",
    "choice_c": "Fibre Channel",
    "choice_d": "iSCSI",
    "correct_answer": "A",
    "explanation": "Ethernet uses jumbo frames to transfer large amounts of data more efficiently. On a packet-switched network, each packet requires header data, which adds to the network's transmission overhead. Splitting large files into a great many small packets can lead to so much overhead that network efficiency is impaired. Ethernet typically restricts frame size to 1,500 bytes, but jumbo frames enable Ethernet systems to create frames up to 9,000 bytes. Frames are Data link layer protocol data units, so Internet Protocol (IP), operating at the Network layer, is not involved in creating them. Fibre Channel and iSCSI are specialized storage area networking protocols that do not use jumbo frames.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      177,
      129,
      151,
      178,
      66
    ],
    "source": "9781394239306"
  },
  {
    "id": 972,
    "question": "Which of the following IEEE standards calls for the use of the Carrier Sense Multiple Access with Collision Avoidance (CSMA/CA) Media Access Control (MAC) mechanism?",
    "choice_a": "802.11ac",
    "choice_b": "802.1X",
    "choice_c": "802.3",
    "choice_d": "All of the above",
    "correct_answer": "A",
    "explanation": "The IEEE 802.11ac standard, like all of the wireless LAN standards in the 802.11 working group, uses CSMA/CA for MAC. The 802.1X standard defines an authentication mechanism and does not require a MAC mechanism. The IEEE 802.3 (Ethernet) standard uses Carrier-Sense Multiple Access with Collision Detection (CSMA/CD).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      57,
      186,
      185,
      183,
      184
    ],
    "source": "9781394239306"
  },
  {
    "id": 973,
    "question": "Which of the following topologies enables wireless devices to access resources on a wired network?",
    "choice_a": "Ad hoc",
    "choice_b": "Star/hub and spoke",
    "choice_c": "Infrastructure",
    "choice_d": "Bus",
    "correct_answer": "C",
    "explanation": "An infrastructure topology uses a wireless access point (WAP) to connect wireless devices to a wired network. An ad hoc topology connects wireless devices to each other, without connecting to a wired network. A mesh topology calls for complete interconnection of wireless nodes, which need not provide access to wired resources. The star/hub and spoke and bus topologies do not support wireless devices.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      190,
      187,
      191,
      201,
      67
    ],
    "source": "9781394239306",
    "choice_e": "Mesh"
  },
  {
    "id": 974,
    "question": "Which of the following components is required for two computers to communicate using an IEEE 802.11 wireless LAN in an ad hoc topology?",
    "choice_a": "A router connected to the Internet",
    "choice_b": "A wireless access point (WAP)",
    "choice_c": "An external antenna",
    "choice_d": "None of the above",
    "correct_answer": "D",
    "explanation": "An ad hoc topology describes wireless computers that communicate directly with each other, without the need for any hardware other than their wireless network adapters. Therefore, the ad hoc topology does not require a router, an Internet connection, an access point (AP), or a special antenna.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      190,
      188,
      186,
      207,
      193
    ],
    "source": "9781394239306"
  },
  {
    "id": 975,
    "question": "Which of the following wireless networking technologies will never experience interference from a 2.4 GHz wireless phone? (Choose all that apply.)",
    "choice_a": "IEEE 802.11a",
    "choice_b": "IEEE 802.11b",
    "choice_c": "IEEE 802.11g",
    "choice_d": "IEEE 802.11n",
    "correct_answer": [
      "A",
      "E"
    ],
    "explanation": "IEEE 802.11b, 802.11g, 802.11n, and 802.11ax networks can use the 2.4 GHz frequency band for their transmissions, which can experience interference from a wireless phone using the same frequency. IEEE 802.11a and IEEE 802.11ac, however, use the 5 GHz band, which will not experience interference from a 2.4 GHz phone.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      184,
      185,
      183,
      207,
      186
    ],
    "source": "9781394239306",
    "choice_e": "IEEE 802.11ac",
    "choice_f": "IEEE 802.11ax"
  },
  {
    "id": 976,
    "question": "Which of the following wireless LAN standards include the ability to use multiple input, multiple output (MIMO) antennas? (Choose all that apply.)",
    "choice_a": "IEEE 802.11a",
    "choice_b": "IEEE 802.11b/g",
    "choice_c": "IEEE 802.11n",
    "choice_d": "IEEE 802.11ac",
    "correct_answer": [
      "C",
      "D",
      "E"
    ],
    "explanation": "The IEEE 802.11n, 802.11ac, and 802.11ax standards include MIMO, which enables them to effectively multiplex signals using multiple antennas. This capability was first introduced in the 802.11n standard, so the 802.11a and 802.11b/g standards do not support it.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      185,
      186,
      207,
      188,
      187
    ],
    "source": "9781394239306",
    "choice_e": "IEEE 802.11ax"
  },
  {
    "id": 977,
    "question": "Which of the following IEEE wireless LAN standards uses the direct-sequence spread spectrum (DSSS) signal modulation technique?",
    "choice_a": "802.11a",
    "choice_b": "802.11b",
    "choice_c": "802.11g",
    "choice_d": "802.11n",
    "correct_answer": "B",
    "explanation": "The IEEE 802.11b standard calls for DSSS signal modulation. All of the other standards listed call for orthogonal frequency-division multiplexing (OFDM) encoding.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      186,
      183,
      185,
      184,
      207
    ],
    "source": "9781394239306",
    "choice_e": "802.11ac"
  },
  {
    "id": 978,
    "question": "When designing a wireless LAN installation, which of the following are valid reasons to install a unidirectional antenna in an access point (AP), rather than an omnidirectional one? (Choose all that apply.)",
    "choice_a": "The AP will be located against an outside wall.",
    "choice_b": "There are many interior walls between the AP and the most distant workstation.",
    "choice_c": "A unidirectional antenna can be focused to a specific signal pattern width.",
    "choice_d": "All of the above.",
    "correct_answer": "D",
    "explanation": "By placing a unidirectional antenna against an outside wall, you can limit network access to users inside the structure. Unidirectional antennas provide greater signal strength than omnidirectional antennas, enabling their signals to penetrate more interior walls. It is possible to focus a unidirectional antenna to a wider or narrower signal pattern.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      189,
      187,
      193,
      196,
      67
    ],
    "source": "9781394239306"
  },
  {
    "id": 979,
    "question": "How do wireless networking devices conforming to the IEEE 802.11n and 802.11ac standards achieve transmission speeds greater than 72.2 Mbps?",
    "choice_a": "By using direct-sequence spread spectrum (DSSS) modulation",
    "choice_b": "By using multiple antennas to transmit several data streams simultaneously",
    "choice_c": "By using frequencies in the 5 GHz band",
    "choice_d": "By sacrificing transmission range for speed",
    "correct_answer": "B",
    "explanation": "The IEEE 802.11n and 802.11ac standards support a transmission technique called multiple input, multiple output (MIMO), which combines the bandwidth of multiple data streams to achieve greater throughput. IEEE 802.11n and 802.11ac do use the 5 GHz band, but this in itself does not yield greater transmission speeds. The specified standards do not call for the use of DSSS modulation, nor do they sacrifice range for speed. In fact, 802.11n and 802.11ac networks can achieve greater ranges than the previous technologies.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      185,
      186,
      207,
      188,
      198
    ],
    "source": "9781394239306"
  },
  {
    "id": 980,
    "question": "Which of the following are possible reasons why the 5 GHz frequency tends to perform better than the 2.4 GHz frequency on a wireless LAN? (Choose all that apply.)",
    "choice_a": "The 5 GHz frequency has more channels than the 2.4 GHz frequency.",
    "choice_b": "The 5 GHz frequency supports longer ranges than the 2.4 GHz frequency.",
    "choice_c": "The 5 GHz frequency conflicts with fewer common household devices than the 2.4 GHz frequency.",
    "choice_d": "The 5 GHz frequency transmits at faster speeds than the 2.4 GHz frequency.",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "The 5 GHz frequency has 23 channels available in the United States, while the 2.4 GHz frequency has only 11. Many household devices, such as cordless telephones, use the 2.4 GHz frequency band, but relatively few devices use the 5 GHz band. Higher frequencies typically support faster transmission speeds, because with all other conditions equal, they can carry more data in the same amount of time. The 5 GHz frequency typically has a shorter range than 2.4 GHz, because it is less able to penetrate barriers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      184,
      183,
      186,
      193,
      207
    ],
    "source": "9781394239306"
  },
  {
    "id": 981,
    "question": "Alice is attempting to deploy an IEEE 802.11b/g wireless LAN on the fifth floor of a 10-story office building that is surrounded on all sides by other office buildings, all of which seem to be running many wireless LANs. Scanning the 2.4 GHz band, she sees literally dozens of networks, spread across all of the available channels. As a result, her wireless devices have trouble connecting to their access point (AP), and when they do, they achieve only low speeds. Which of the following tasks should Alice perform to enable the wireless clients to connect to the network more reliably? (Choose two.)",
    "choice_a": "Upgrade all of the wireless network devices to IEEE 802.11n.",
    "choice_b": "Configure all of the network devices to use WPA2 encryption with AES.",
    "choice_c": "Configure the wireless devices to use the 5 GHz band.",
    "choice_d": "Configure the AP to suppress service set identifier (SSID) broadcasts.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Upgrading the devices to 802.11n will enable them to use the 5 GHz band and evade the traffic generated by the surrounding networks. Configuring the devices to use the 5 GHz band will provide many more channels to choose from and will avoid the interference from the surrounding 2.4 GHz networks. The type of encryption that a wireless network uses has no bearing on the ability of the devices to avoid the interference generated by surrounding networks. Suppressing SSID broadcasts will not help the devices to connect to the network. Upgrading the firmware on the devices is not likely to have any effect on the connection problems when they are the result of interference from other networks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      184,
      188,
      193,
      196,
      197
    ],
    "source": "9781394239306",
    "choice_e": "Upgrade all of the network devices to the latest firmware."
  },
  {
    "id": 982,
    "question": "What is the term for the technology implemented in the IEEE 802.11ac standard that enables a wireless device to transmit multiple frames to multiple clients simultaneously?",
    "choice_a": "MIMO",
    "choice_b": "Channel bonding",
    "choice_c": "CSMA/CA",
    "choice_d": "MU-MIMO",
    "correct_answer": "D",
    "explanation": "The multiple input, multiple output (MIMO) technology introduced in the IEEE 802.11n standard enables wireless devices to transmit and receive signals using multiple antennas simultaneously. The multiuser MIMO (MU-MIMO) variant defined in the 802.11ac standard advances this technique by enabling wireless devices to transmit multiple frames to different users simultaneously, using multiple antennas. Carrier-Sense Multiple Access with Collision Avoidance (CSMA/CA) is a Media Access Control (MAC) mechanism used by all 802.11 networks. Channel bonding is a wireless networking technique that combines channels to increase bandwidth.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      185,
      207,
      186,
      188,
      57
    ],
    "source": "9781394239306"
  },
  {
    "id": 983,
    "question": "On an IEEE 802.11b/g/n wireless network running at 2.4 GHz with multiple access points (APs), the traditional best practice is to use channels 1, 6, and 11, with no two adjacent APs configured to use the same channel. Which of the following is the real reason why this is a good plan?",
    "choice_a": "Channels 1, 6, and 11 are the only channels with frequencies that do not overlap.",
    "choice_b": "Channels 1, 6, and 11 have more bandwidth than the other channels.",
    "choice_c": "Channels 1, 6, and 11 have greater ranges than the other channels.",
    "choice_d": "Channels 1, 6, and 11 are the default settings on most wireless devices.",
    "correct_answer": "A",
    "explanation": "Wireless LAN regulations call for 22 MHz channels in the 2.4 GHz band that are spaced 5 MHz apart, which means that they overlap. Channels 1, 6, and 11 are the only three channels that are distant enough from each other not to overlap. Therefore, they do not interfere with each other. Channels 1, 6, and 11 do not differ from the other channels in their bandwidth or their transmission range. Each wireless device can be set to use only one channel. Therefore, channels 1, 6, and 11 cannot all be the default setting.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      183,
      198,
      197,
      187,
      57
    ],
    "source": "9781394239306"
  },
  {
    "id": 984,
    "question": "Which of the following terms defines a wireless LAN transmission technique in which devices use multiple antennas to increase transmission speeds?",
    "choice_a": "MIMO",
    "choice_b": "TDMA",
    "choice_c": "PAN",
    "choice_d": "Ant+",
    "correct_answer": "A",
    "explanation": "Multiple input, multiple output (MIMO) calls for the use of two or more antennas, enabling wireless devices to effectively multiplex signals, thereby increasing their transmission speeds. Time-division multiple access (TDMA) is a communication technique that splits a frequency into multiple time slots, enabling it to carry multiple data streams. A personal area network (PAN) provides communication among devices associated with a single person, such as smartphones. Ant+ is a wireless protocol that is typically used to monitor data gathered by sensors, such as those in cardiac pacemakers.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      186,
      188,
      187,
      198,
      193
    ],
    "source": "9781394239306"
  },
  {
    "id": 985,
    "question": "What is the maximum channel width possible using wireless networking equipment based on the ratified IEEE 802.11 regulatory standards?",
    "choice_a": "20 MHz",
    "choice_b": "40 MHz",
    "choice_c": "80 MHz",
    "choice_d": "160 MHz",
    "correct_answer": "D",
    "explanation": "Using a technique called channel bonding, the 802.11ax and 802.11ac standards define the combination of up to eight 20 MHz channels, for a total possible channel width of 160 MHz, in a single 160 MHz channel or a non-contiguous 80+80 configuration. The 802.11n standard can bond up to two channels, for a 40 MHz width. Earlier standards are limited to a single 20 MHz channel.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      185,
      186,
      207,
      188,
      196
    ],
    "source": "9781394239306"
  },
  {
    "id": 986,
    "question": "Which of the following wireless networking standards are capable of using only the 5 GHz frequency? (Choose all that apply.)",
    "choice_a": "IEEE 802.11a",
    "choice_b": "IEEE 802.11b",
    "choice_c": "IEEE 802.11g",
    "choice_d": "IEEE 802.11n",
    "correct_answer": [
      "A",
      "E"
    ],
    "explanation": "The IEEE 802.11a and IEEE 802.11ac standards can use the 5 GHz band only. IEEE 802.11b and IEEE 802.11g can use the 2.4 GHz band only. IEEE 802.11n and IEEE 802.11ax can use either the 2.4 or the 5 GHz band.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      184,
      185,
      183,
      207,
      186
    ],
    "source": "9781394239306",
    "choice_e": "IEEE 802.11ac",
    "choice_f": "IEEE 802.11ax"
  },
  {
    "id": 987,
    "question": "Which of the following IEEE 802.11 wireless LAN standards is capable of supporting the 6 GHz frequency band?",
    "choice_a": "802.11a",
    "choice_b": "802.11b",
    "choice_c": "802.11g",
    "choice_d": "802.11n",
    "correct_answer": "F",
    "explanation": "Only the 802.11ax standard defines wireless LAN devices that can support the 6 GHz frequency band. The 802.11a and 802.11ac standards use only 5 GHz, and the 802.11b and 802.11g standards use only 2.4 GHz. The 802.11n standard supports both the 2.4 and 5 GHz bands.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      185,
      186,
      184,
      183,
      188
    ],
    "source": "9781394239306",
    "choice_e": "802.11ac",
    "choice_f": "802.11ax"
  },
  {
    "id": 988,
    "question": "Which of the following IEEE wireless LAN standards provides the greatest possible throughput?",
    "choice_a": "802.11a",
    "choice_b": "802.11ac",
    "choice_c": "802.11ax",
    "choice_d": "802.11b",
    "correct_answer": "C",
    "explanation": "The IEEE 802.11ax standard provides the greatest possible throughput, up to a theoretical maximum of 9.6 Gbps. This is a 37% improvement over 802.11ac, at 7 Gbps. The 802.11n standard runs at speeds up to 600 Mbps. The 802.11a and 802.11g standards run at up to 54 Mbps. The 802.11b standard runs at up to 11 Mbps.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      185,
      186,
      207,
      183,
      184
    ],
    "source": "9781394239306",
    "choice_e": "802.11g",
    "choice_f": "802.11n"
  },
  {
    "id": 989,
    "question": "Which of the following IEEE 802.11 wireless LAN standards are capable of supporting both the 2.4 GHz and 5 GHz frequencies? (Choose all that apply.)",
    "choice_a": "802.11a",
    "choice_b": "802.11b",
    "choice_c": "802.11g",
    "choice_d": "802.11n",
    "correct_answer": [
      "D",
      "F"
    ],
    "explanation": "The 802.11n and 802.11ax standards define wireless LAN devices that can support both the 2.4 GHz and 5 GHz frequency bands. The 802.11a and 802.11ac standards use only 5 GHz, and the 802.11b and 802.11g standards use only 2.4 GHz.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      185,
      186,
      183,
      184,
      207
    ],
    "source": "9781394239306",
    "choice_e": "802.11ac",
    "choice_f": "802.11ax"
  },
  {
    "id": 990,
    "question": "What is the maximum number of transmit and receive antennas supported by the currently ratified IEEE 802.11 wireless LAN standards?",
    "choice_a": "2",
    "choice_b": "4",
    "choice_c": "8",
    "choice_d": "16",
    "correct_answer": "C",
    "explanation": "The 802.11ax and 802.11ac standards support multiple input, multiple output (MIMO) through the use of up to eight antennas on a single device. 802.11n is the only earlier 802.11 standard that supports MIMO, but it can only use a maximum of four antennas.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      185,
      186,
      207,
      188,
      197
    ],
    "source": "9781394239306"
  },
  {
    "id": 991,
    "question": "Which of the following is the term for the network name that you use to connect a client device to an access point (AP) on a wireless LAN?",
    "choice_a": "BSS",
    "choice_b": "ESS",
    "choice_c": "SSID",
    "choice_d": "BSSID",
    "correct_answer": "C",
    "explanation": "The service set identifier (SSID) is the name that you use when connecting to a wireless network. A basic service set (BSS) refers to the wireless network itself, consisting of a single AP and a number of clients. An extended service set (ESS) consists of two or more BSSs, using multiple APs. The basic service set identifier (BSSID) is the MAC address of the access point associated with a BSS. The extended service set identifier (ESSID) specifies the name of a network using multiple APs to support a single SSID.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      206,
      196,
      190,
      187,
      192
    ],
    "source": "9781394239306",
    "choice_e": "ESSID"
  },
  {
    "id": 992,
    "question": "Which of the following IEEE wireless LAN standards define devices with a maximum aggregate channel width of 20 MHz? (Choose all that apply.)",
    "choice_a": "802.11a",
    "choice_b": "802.11g",
    "choice_c": "802.11n",
    "choice_d": "802.11ac",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Devices conforming to the IEEE 802.11a and 802.11g standards can only use a single 20 MHz channel. IEEE 802.11n devices can use channel bonding to join two channels together and achieve an aggregate channel width of 40 MHz. IEEE 802.11ax and 802.11ac devices can bond up to eight channels, for an aggregate width of 160 MHz, in a single channel or a non-contiguous 80+80 configuration.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      185,
      186,
      184,
      183,
      207
    ],
    "source": "9781394239306"
  },
  {
    "id": 993,
    "question": "At which layer of the Open Systems Interconnection (OSI) model do wireless range extenders operate?",
    "choice_a": "Physical",
    "choice_b": "Data link",
    "choice_c": "Network",
    "choice_d": "Transport",
    "correct_answer": "A",
    "explanation": "Wireless range extenders are Physical layer devices that receive signals from wireless access points (WAPs) and network adapters and retransmit them, enabling devices to connect that are farther apart than the network would normally support. Because the extenders do not process the packets in any way, but just retransmit the signals, they do not operate at any layer above the Physical.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      70,
      52,
      187,
      193,
      186
    ],
    "source": "9781394239306",
    "choice_e": "Session",
    "choice_f": "Presentation",
    "choice_g": "Application"
  },
  {
    "id": 994,
    "question": "Which of the following wireless security protocols provides the greatest degree of network device hardening?",
    "choice_a": "WEP",
    "choice_b": "WPA",
    "choice_c": "WPA2",
    "choice_d": "WPA3",
    "correct_answer": "D",
    "explanation": "Wi-Fi Protected Access 3 (WPA3) is the most secure of the wireless protocols, providing the greatest degree of network device hardening. Wi-Fi Protected Access (WPA) was created to replace the insecure Wired Equivalent Privacy (WEP) protocol, and Wi-Fi Protected Access 2 (WPA2) was created to replace the Temporal Key Integrity Protocol (TKIP) used in the first version of WPA with Advanced Encryption Standard (AES). Extensible Authentication Protocol (EAP) is a framework for the encapsulation of authentication messages.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      204,
      206,
      196,
      201,
      192
    ],
    "source": "9781394239306",
    "choice_e": "EAP"
  },
  {
    "id": 995,
    "question": "Which of the following encryption protocols was introduced in the Wi-Fi Protected Access (WPA) wireless security standard?",
    "choice_a": "CCMP-AES",
    "choice_b": "TKIP-RC4",
    "choice_c": "EAP-TLS",
    "choice_d": "TACACS+",
    "correct_answer": "B",
    "explanation": "WPA was created to replace the insecure Wired Equivalent Privacy (WEP) protocol and used Temporal Key Integrity Protocol (TKIP) with the RC4 cipher for encryption. Counter Mode with Cipher Block Chaining Message Authentication Code Protocol (CCMP) with Advanced Encryption Standard (AES) is an encryption protocol that is used with the Wi-Fi Protected Access 2 (WPA2) security protocol. Extensible Authentication Protocol (EAP) is a framework for the encapsulation of authentication messages. EAP is used on wireless networks and point-to-point connections and supports dozens of different authentication methods, including Transport Layer Security (TLS). It is not the encryption protocol used with WPA. Terminal Access Controller Access Control System Plus (TACACS+) is a protocol designed to provide AAA services for networks with many routers and switches.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      204,
      206,
      196,
      200,
      201
    ],
    "source": "9781394239306"
  },
  {
    "id": 996,
    "question": "TKIP-RC4 is an encryption protocol used with which of the following wireless network security standards?",
    "choice_a": "WEP",
    "choice_b": "WPA",
    "choice_c": "WPA2",
    "choice_d": "WPA3",
    "correct_answer": "B",
    "explanation": "Wi-Fi Protected Access (WPA) was created to replace the insecure Wired Equivalent Privacy (WEP) protocol and used the Temporal Key Integrity Protocol (TKIP) with the RC4 cipher. WPA was replaced by WPA2 and later WPA3, both of which use Counter Mode with Cipher Block Chaining Message Authentication Code Protocol (CCMP) with Advanced Encryption Standard (AES) for encryption. Extensible Authentication Protocol (EAP) is a framework for the encapsulation of authentication messages.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      204,
      196,
      206,
      201,
      187
    ],
    "source": "9781394239306",
    "choice_e": "EAP"
  },
  {
    "id": 997,
    "question": "Which of the following protocols provides wireless networks with the strongest encryption?",
    "choice_a": "AES",
    "choice_b": "TKIP",
    "choice_c": "EAP",
    "choice_d": "802.1X",
    "correct_answer": "A",
    "explanation": "Wi-Fi Protected Access (WPA) is a wireless security protocol that was designed to replace the increasingly vulnerable Wired Equivalent Privacy (WEP). WPA added an encryption protocol called Temporal Key Integrity Protocol (TKIP). This too became vulnerable, and WPA2 was introduced, which replaced TKIP with the stronger CCMP-Advanced Encryption Standard (CCMP-AES). Extensible Authentication Protocol and 802.1X do not provide encryption.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      204,
      206,
      196,
      200,
      201
    ],
    "source": "9781394239306"
  },
  {
    "id": 998,
    "question": "To connect a wireless client to a wireless access point (WAP) using the Wi-Fi Protected Access 3-Personal (WPA3-Personal) security protocol, which of the following must you supply on both devices?",
    "choice_a": "Base key",
    "choice_b": "Passphrase",
    "choice_c": "Serial number",
    "choice_d": "MAC address",
    "correct_answer": "B",
    "explanation": "The WPA3 protocol replaces the pre-shared key of WPA2 with a Simultaneous Authentication of Equals (SAE) exchange that provides better security. SAE still requires the client and the access point (AP) to be configured with the same passphrase. The base key, the serial number, and the MAC address are all components that WPA3 uses to generate the encryption key for each packet.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      204,
      196,
      192,
      206,
      201
    ],
    "source": "9781394239306"
  },
  {
    "id": 999,
    "question": "Upgrading a wireless network to the WPA3-Personal security protocol provides clients with additional protection from replay attacks. Which of the following WPA3 elements accomplish this? (Choose all that apply.)",
    "choice_a": "PSK",
    "choice_b": "NFC",
    "choice_c": "SAE",
    "choice_d": "PFS",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "A replay attack is one in which an attacker utilizes the encryption key found in a previously captured packet to gain access to the network. Simultaneous Authentication of Equals (SAE) prevents replay attacks by including a mutual authentication process, as well as correlation of a shared passphrase. Perfect Forward Secrecy (PFS) prevents replay attacks by issuing a unique key for every session, so that data illicitly retained from previous sessions is rendered unusable. <p>Pre-shared key (PSK) is the passphrase mechanism from WPA2 that has been replaced by SAE in WPA3. Near field communication (NFC) is a contact-based short-range authentication method used by some wireless implementations. Neither prevents replay attacks.</p>",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      204,
      196,
      192,
      206,
      183
    ],
    "source": "9781394239306"
  },
  {
    "id": 1000,
    "question": "Which of the following wireless security protocols use CCMP-AES for encryption? (Choose all that apply.)",
    "choice_a": "WEP",
    "choice_b": "WPA",
    "choice_c": "WPA2",
    "choice_d": "WPA3",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Wi-Fi Protected Access (WPA) is a wireless security protocol that was designed to replace the increasingly vulnerable Wired Equivalent Privacy (WEP). WPA added an encryption protocol called Temporal Key Integrity Protocol (TKIP). This too became vulnerable, and WPA2 and later WPA3 were introduced, both of which replace TKIP with CCMP-Advanced Encryption Standard (CCMP-AES) encryption.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      204,
      196,
      206,
      200,
      185
    ],
    "source": "9781394239306",
    "choice_e": "TKIP"
  },
  {
    "id": 1001,
    "question": "Which of the following wireless LAN security protocols does not support the use of a pre-shared key (PSK) in its Personal configuration?",
    "choice_a": "WEP",
    "choice_b": "WPA",
    "choice_c": "WPA2",
    "choice_d": "WPA3",
    "correct_answer": "D",
    "explanation": "WPA3-Personal addresses WPA2's KRACK vulnerability with a more secure cryptographic handshake, replacing the PSK four-way handshake with Simultaneous Authentication of Equals (SAE), a version of the Internet Engineering Task Force's dragonfly handshake in which either client or AP can initiate contact. Each device then transmits its authentication credentials in a discrete, one-off message, instead of in a give-and-take, multipart conversation. Importantly, SAE also eliminates the reuse of encryption keys, requiring a new code with every interaction. Without open-ended communication between AP and client or encryption key reuse, cybercriminals can't as easily eavesdrop or insert themselves into an exchange. Wired Equivalent Privacy (WEP), Wi-Fi Protected Access (WPA), and Wi-Fi Protected Access 2 (WPA2) all support the use of a pre-shared key.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      204,
      196,
      206,
      201,
      192
    ],
    "source": "9781394239306"
  },
  {
    "id": 1002,
    "question": "Which of the following did the Wi-Fi Protected Access 2 (WPA2) security protocol add to the existing WPA standard?",
    "choice_a": "CCMP-AES",
    "choice_b": "MIMO",
    "choice_c": "WEP",
    "choice_d": "TKIP",
    "correct_answer": "A",
    "explanation": "WPA2 adds Counter Mode with Cipher Block Chaining Message Authentication Code Protocol - Advanced Encryption Standard (CCMP-AES), a new symmetric key encryption algorithm that strengthens the protocol's security. Multiple-input and multiple-output (MIMO) is a multiplexing technology added to the IEEE 802.11n standard, not to WPA2. Wired Equivalent Protocol (WEP) is the predecessor to WPA; it is not part of WPA2. Temporal Key Integrity Protocol (TKIP) is the encryption algorithm used in the first version of WPA; it was not added in the second version.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      204,
      206,
      185,
      196,
      187
    ],
    "source": "9781394239306"
  },
  {
    "id": 1003,
    "question": "Alice is setting up a wireless LAN in a friend's home, using an 802.11n wireless access point and three computers with 802.11n adapters. She has installed and successfully tested the devices on an open network, and now she is ready to add security. Which of the following protocols should Alice choose to provide maximum security for the wireless network?",
    "choice_a": "WPA3",
    "choice_b": "IPsec",
    "choice_c": "TLS",
    "choice_d": "L2TP",
    "correct_answer": "A",
    "explanation": "Of the options listed, Wi-Fi Protected Access 3 (WPA3) will provide the maximum security for the wireless network, in part because it uses long encryption keys that change frequently. IPsec is a Network layer security standard that does not provide the security needed for IEEE 802.11 wireless networks. Transport Layer Security (TLS) is a protocol that encrypts data exchanged by web servers and clients at the Application layer; it does not provide adequate security for wireless LANs. Layer 2 Tunneling Protocol (L2TP) is a virtual private networking protocol; it does not provide adequate security for wireless networks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      204,
      196,
      206,
      185,
      207
    ],
    "source": "9781394239306"
  },
  {
    "id": 1004,
    "question": "CCMP-AES is an encryption protocol used with which of the following wireless network security standards? (Choose two.)",
    "choice_a": "WEP",
    "choice_b": "WPA",
    "choice_c": "WPA2",
    "choice_d": "WPA3",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Counter Mode with Cipher Block Chaining Message Authentication Code Protocol (CCMP) with Advanced Encryption Standard (AES) is an encryption protocol that is used with the Wi-Fi Protected Access 2 (WPA2) and Wi-Fi Protected Access 3 (WPA3) security protocols. WPA was created to replace the insecure Wired Equivalent Privacy (WEP) protocol, and WPA2 was created to replace the Temporal Key Integrity Protocol (TKIP) used in the first version of WPA. Extensible Authentication Protocol (EAP) is a framework for the encapsulation of authentication messages.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      204,
      196,
      201,
      192,
      187
    ],
    "source": "9781394239306",
    "choice_e": "EAP"
  },
  {
    "id": 1005,
    "question": "Which of the following wireless security protocols can enable network users to authenticate using smart cards?",
    "choice_a": "WPA3",
    "choice_b": "WPA2",
    "choice_c": "EAP",
    "choice_d": "AES",
    "correct_answer": "C",
    "explanation": "Wi-Fi Protected Access 3 (WPA3) and Wi-Fi Protected Access 2 (WPA2) are both wireless security protocols that control access to the network and provide encryption, using protocols like Counter Mode with Cipher Block Chaining Message Authentication Code Protocol (CCMP) with Advanced Encryption Standard (AES). These protocols do not provide authentication services, however. Extensible Authentication Protocol (EAP) is a framework for the encapsulation of authentication messages. Its many variants provide support for the use of smart cards and other authentication factors, such as biometrics, in addition to traditional passwords.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      196,
      200,
      201,
      192,
      206
    ],
    "source": "9781394239306"
  },
  {
    "id": 1006,
    "question": "Which of the following forms of the Wi-Fi Protected Access (WPA), WPA2, and WPA3 protocols require a RADIUS server? (Choose all that apply.)",
    "choice_a": "WPA-Personal",
    "choice_b": "WPA-PSK",
    "choice_c": "WPA-Enterprise",
    "choice_d": "WPA-802.1X",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "WPA-Enterprise, also known as WPA-802.1X, can use the Extensible Authentication Protocol (EAP) to support various types of authentication factors and requires a Remote Authentication Dial-In User Service (RADIUS) server. WPA-Personal, also known as WPA-PSK (Pre-Shared Key), is intended for small networks and does not require RADIUS.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      161,
      192,
      201,
      206,
      187
    ],
    "source": "9781394239306"
  },
  {
    "id": 1007,
    "question": "Which of the following forms of the Wi-Fi Protected Access (WPA), WPA2, and WPA3 protocols call for the use of a pre-shared key (PSK)?",
    "choice_a": "WPA-Personal",
    "choice_b": "WPA-Enterprise",
    "choice_c": "WPA-EAP",
    "choice_d": "WPA-802.1X",
    "correct_answer": "A",
    "explanation": "WPA-Personal, also known as WPA-PSK, is intended for small networks and requires a PSK. WPA-Enterprise, also known as WPA-802.1X, uses the Extensible Authentication Protocol (EAP) to support various types of authentication factors and requires a Remote Authentication Dial-In User Service (RADIUS) server.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      204,
      192,
      206,
      190,
      197
    ],
    "source": "9781394239306"
  },
  {
    "id": 1008,
    "question": "Which of the following stream ciphers does the Temporal Key Integrity Protocol (TKIP) use for encryption on a wireless network?",
    "choice_a": "RC4",
    "choice_b": "AES",
    "choice_c": "CCMP",
    "choice_d": "SHA",
    "correct_answer": "A",
    "explanation": "TKIP uses the RC4 stream cipher for its encryption. Advanced Encryption Standard (AES) is used with CCMP on versions 2 and 3 of the Wi-Fi Protected Access (WPA2 and WPA3) security protocol, not version 1 (WPA), which uses TKIP. Secure Hash Algorithm (SHA) is a file hashing algorithm, not used for wireless network encryption.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      204,
      206,
      196,
      186,
      183
    ],
    "source": "9781394239306"
  },
  {
    "id": 1009,
    "question": "Which of the following wireless security protocols uses CCMP for encryption?",
    "choice_a": "WPA",
    "choice_b": "WPA2",
    "choice_c": "WPA3",
    "choice_d": "802.1X",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "CCMP (Counter Mode with Cipher Block Chaining Message Authentication Code Protocol) is based on the Advanced Encryption Standard (AES) and is the encryption protocol used with the Wi-Fi Protected Access 2 (WPA2) and Wi-Fi Protected Access 3 (WPA3) security protocols on wireless networks. CCMP is not used with version 1 of the WPA protocol. 802.1X is an authentication protocol and is not used for encryption.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      204,
      196,
      206,
      185,
      201
    ],
    "source": "9781394239306"
  },
  {
    "id": 1010,
    "question": "CCMP is based on which of the following encryption standards?",
    "choice_a": "TKIP",
    "choice_b": "RC4",
    "choice_c": "AES",
    "choice_d": "802.1X",
    "correct_answer": "C",
    "explanation": "CCMP (Counter Mode with Cipher Block Chaining Message Authentication Code Protocol) is based on the Advanced Encryption Standard (AES) and is the encryption protocol used with the Wi-Fi Protected Access 2 and 3 (WPA2 and 3) security protocols on wireless networks. CCMP is not based on the Temporal Key Integrity Protocol (TKIP), which uses RC4 as its stream cipher. 802.1X is an authentication protocol and is not used for encryption.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      204,
      196,
      192,
      201,
      185
    ],
    "source": "9781394239306"
  },
  {
    "id": 1011,
    "question": "Ralph has installed a new wireless access point (WAP) on his network and configured it to use WPA3 for security and an SSID that is not broadcast. Which of the following describes what Ralph must do to configure his wireless clients?",
    "choice_a": "Select the SSID from a list and allow the client to automatically detect the security protocol.",
    "choice_b": "Select the SSID from a list and then select WPA3 from the security protocol options provided.",
    "choice_c": "Type the SSID manually and allow the client to automatically detect the security protocol.",
    "choice_d": "Type the SSID manually and then select WPA3 from the security protocol options provided.",
    "correct_answer": "D",
    "explanation": "An SSID that is not broadcast is not detectable by clients, so Ralph must type it in manually. Security protocols are also not detectable, so Ralph must configure the clients to use the same protocol he selected on the WAP.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      196,
      206,
      204,
      190,
      188
    ],
    "source": "9781394239306"
  },
  {
    "id": 1012,
    "question": "Which of the following encryption protocols was introduced in the Wi-Fi Protected Access 2 (WPA2) wireless security standard?",
    "choice_a": "CCMP-AES",
    "choice_b": "TKIP-RC4",
    "choice_c": "EAP-TLS",
    "choice_d": "TACACS+",
    "correct_answer": "A",
    "explanation": "Counter Mode with Cipher Block Chaining Message Authentication Code Protocol (CCMP) with Advanced Encryption Standard (AES) is an encryption protocol that is used with the Wi-Fi Protected Access 2 (WPA2) security protocol, as well as the Wi-Fi Protected Access 3 (WPA3) protocol that followed it. WPA was created to replace the insecure Wired Equivalent Privacy (WEP) protocol, and WPA2 was created to replace the Temporal Key Integrity Protocol (TKIP) used in the first version of WPA. Extensible Authentication Protocol (EAP) is a framework for the encapsulation of authentication messages. EAP is used on wireless networks and point-to-point connections and supports dozens of different authentication methods, including Transport Layer Security (TLS). It is not the encryption protocol used with WPA2. Terminal Access Controller Access Control System Plus (TACACS+) is a protocol designed to provide AAA services for networks with many routers and switches.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      204,
      196,
      200,
      206,
      201
    ],
    "source": "9781394239306"
  },
  {
    "id": 1013,
    "question": "Which of the following wireless LAN security protocols were rendered obsolete after they were found to be extremely easy to penetrate? (Choose all that apply.)",
    "choice_a": "WEP",
    "choice_b": "WPA",
    "choice_c": "WPA2",
    "choice_d": "WPA3",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Wired Equivalent Privacy (WEP) was one of the first commercially available security protocols for wireless LANs, but it was soon found to be easily penetrated and was replaced by Wi-Fi Protected Access (WPA). WPA was also deprecated in 2015 due to multiple security weaknesses, leading to the introduction of Wi-Fi Protected Access 2 (WPA2) and then WPA3. Extensible Authentication Protocol (EAP) is a framework for the encapsulation of authentication messages.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      206,
      204,
      196,
      200,
      201
    ],
    "source": "9781394239306",
    "choice_e": "EAP"
  },
  {
    "id": 1014,
    "question": "Which of the following encryption ciphers was replaced by CCMP-AES when the WPA2 wireless security protocol was introduced?",
    "choice_a": "EAP",
    "choice_b": "WEP",
    "choice_c": "TKIP",
    "choice_d": "CCMP",
    "correct_answer": "C",
    "explanation": "WPA2 was introduced when the earlier version of Wi-Fi Protected Access (WPA) was determined to be increasingly vulnerable to attack. WPA used an encryption protocol called Temporal Key Integrity Protocol (TKIP). WPA2 replaced TKIP with an Advanced Encryption Standard (CCMP-AES) protocol.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      204,
      206,
      196,
      186,
      187
    ],
    "source": "9781394239306"
  },
  {
    "id": 1015,
    "question": "Ralph is installing a wireless LAN that includes three access points (APs) to provide coverage for a large building. Which of the following must Ralph do to ensure that users are able to roam without interruption from one AP to another using their portable devices? (Choose all that apply.)",
    "choice_a": "Configure each AP with the same IP address.",
    "choice_b": "Configure each AP with the same security passphrase.",
    "choice_c": "Configure each AP to use the same security protocol.",
    "choice_d": "Configure each AP with the same SSID.",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Roaming from one AP to another without interruption requires that the APs all use the same SSID, the same security protocol, and the same passphrase. The APs will not function properly if they have the same IP address.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      196,
      206,
      198,
      191,
      192
    ],
    "source": "9781394239306"
  },
  {
    "id": 1016,
    "question": "Which of the following is the maximum theoretical download speed for a 5G cellular network?",
    "choice_a": "42 Mbps",
    "choice_b": "150 Mbps",
    "choice_c": "1 Gbps",
    "choice_d": "10 Gbps",
    "correct_answer": "D",
    "explanation": "The 5G cellular network specification calls for maximum theoretical download speeds of 10 Gbps, although the actual speed realized will be less.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      207,
      181,
      183,
      184,
      65
    ],
    "source": "9781394239306",
    "choice_e": "100 Gbps"
  },
  {
    "id": 1017,
    "question": "Which of the following statements about 5G cellular networks are true? (Choose all that apply.)",
    "choice_a": "5G networks can operate on three frequency bands.",
    "choice_b": "5G networks with the highest speeds also have a more limited range.",
    "choice_c": "4G devices can connect to 5G networks at reduced speeds.",
    "choice_d": "On a 5G network, the lower frequency bands provide the highest speeds.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "5G networks can operate on three frequency bands\u2014low, medium, and high\u2014with the high frequencies having the fastest speeds and reduced range. 4G devices cannot function on 5G networks.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      181,
      207,
      186,
      188,
      183
    ],
    "source": "9781394239306"
  },
  {
    "id": 1018,
    "question": "Which of the following IEEE standards describes an implementation of port-based access control for wireless networks?",
    "choice_a": "802.11ac",
    "choice_b": "802.11h",
    "choice_c": "802.11n",
    "choice_d": "802.1X",
    "correct_answer": "D",
    "explanation": "IEEE 802.1X is a standard that defines a port-based network access control (PNAC) mechanism used for authentication on wireless and other networks. IEEE 802.11ac and 802.11n are standards defining the physical and Data link layer protocols for wireless networks. IEEE 802.11h is a standard that addresses the coexistence of wireless LANs with other services using the same frequencies. IEEE 802.3x is one of the standards for wired Ethernet networks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      163,
      162,
      191,
      206,
      196
    ],
    "source": "9781394239306",
    "choice_e": "802.3x"
  },
  {
    "id": 1019,
    "question": "Unauthorized users are connecting to Alice's wireless access point (WAP) and gaining access to the network. Which of the following are immediate steps Alice can take to prevent this from happening? (Choose all that apply.)",
    "choice_a": "Disable SSID broadcasting.",
    "choice_b": "Use Kerberos for authentication.",
    "choice_c": "Place the access point (AP) in a screened subnet.",
    "choice_d": "Implement MAC address filtering.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Disabling SSID broadcasting prevents a wireless network from appearing to clients. The clients must specify the SSID to which they want to connect. MAC address filtering is a form of access control list (ACL) that is maintained in the AP and contains the addresses of devices that are to be permitted to access the network. Both of these mechanisms make it more difficult for unauthorized devices to connect to the access point (AP). Kerberos is an authentication protocol used by Active Directory, and relocating the AP to a screened subnet will not resolve the problem.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      206,
      196,
      169,
      200,
      188
    ],
    "source": "9781394239306"
  },
  {
    "id": 1020,
    "question": "On a wireless access point (WAP) that uses an access control list (ACL) to specify which devices are permitted to connect to the network, which of the following is used to identify the authorized devices?",
    "choice_a": "Usernames",
    "choice_b": "IP addresses",
    "choice_c": "Device names",
    "choice_d": "MAC addresses",
    "correct_answer": "D",
    "explanation": "WAPs use the layer 2 MAC addresses coded into devices in their ACLs. Usernames, IP addresses, and device names can more easily be impersonated.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      206,
      169,
      126,
      51,
      196
    ],
    "source": "9781394239306"
  },
  {
    "id": 1021,
    "question": "Which of the following best describes the process of allow listing on a wireless network?",
    "choice_a": "Using an access control list (ACL) to specify the IP addresses that are permitted to access a wireless network",
    "choice_b": "Using port protection to specify the well-known port numbers of applications that users are permitted to run over a wireless network",
    "choice_c": "Using MAC filtering to create a list of devices that are permitted to access a wireless network",
    "choice_d": "Using an AAA server to create a list of users that are permitted to access a wireless network",
    "correct_answer": "C",
    "explanation": "Allow listing is the process of using MAC filtering to specify the hardware addresses of devices that are permitted to access a wireless network. Deny listing, by contrast, is making a list of addresses that are denied access to the network.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      206,
      169,
      126,
      196,
      200
    ],
    "source": "9781394239306"
  },
  {
    "id": 1022,
    "question": "Which of the following protocols can be used by wireless controllers to communicate with the access points (APs) on a wireless local area network (WLAN)? (Choose all that apply.)",
    "choice_a": "CAPWAP",
    "choice_b": "LWAPP",
    "choice_c": "LDAP",
    "choice_d": "PPTP",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "The Control and Provisioning of Wireless Access Points (CAPWAP) protocol and the Lightweight Access Point Protocol (LWAPP) both enable wireless controllers to manage and control access points (APs). Lightweight Directory Access Protocol (LDAP) is used by directory services, and Point-to-Point Tunneling Protocol (PPTP) is used for virtual private networking.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      191,
      200,
      57,
      190,
      197
    ],
    "source": "9781394239306"
  },
  {
    "id": 1023,
    "question": "On a wireless network, which of the following best describes an example of a captive portal?",
    "choice_a": "A switch port used to connect to other switches",
    "choice_b": "A web page with which a user must interact before being granted access to a wireless network",
    "choice_c": "A series of two doors through which people must pass before they can enter a secured space",
    "choice_d": "A web page stating that the user's computer has been locked and will only be unlocked after payment of a fee",
    "correct_answer": "B",
    "explanation": "A captive portal is a web page displayed to a user attempting to access a public wireless network. The user typically must supply credentials, provide payment, or accept a user agreement before access is granted. A captive portal does not refer to a switch port, a secured entryway to a room, or a type of extortionate computer attack.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      192,
      196,
      206,
      187,
      200
    ],
    "source": "9781394239306"
  },
  {
    "id": 1024,
    "question": "A user attempting to connect to a Wi-Fi hotspot in a coffee shop is taken to a web page that requires her to accept an end-user license agreement (EULA) before access to the network is granted. Which of the following is the term for such an arrangement?",
    "choice_a": "Captive portal",
    "choice_b": "Ransomware",
    "choice_c": "Port security",
    "choice_d": "Root guard",
    "correct_answer": "A",
    "explanation": "A web page that prompts users for payment, authentication, or acceptance of a EULA is a captive portal. Ransomware is a type of attack that extorts payment. Port security and root guards are methods for protecting access to switch ports.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      192,
      196,
      206,
      187,
      169
    ],
    "source": "9781394239306"
  },
  {
    "id": 1025,
    "question": "A wireless access point (WAP) enables computers equipped with wireless network interface adapters to function in which of the following topologies?",
    "choice_a": "Star/hub and spoke",
    "choice_b": "Ad hoc",
    "choice_c": "Bus",
    "choice_d": "Infrastructure",
    "correct_answer": "D",
    "explanation": "A WAP is a device with a wireless transceiver that also connects to a standard cabled network. Wireless computers communicate with the WAP, which forwards their transmissions over the network cable. This is called an infrastructure topology. A star/hub and spoke or bus network requires the computers to be physically connected to the network cable, and an ad hoc topology is one in which wireless computers communicate directly with one another.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      187,
      190,
      52,
      71,
      57
    ],
    "source": "9781394239306"
  },
  {
    "id": 1026,
    "question": "A wireless network adapter that automatically chooses the best available network frequency, 2.4 GHz or 5 GHz, based on signal strength and distance from the access point, is performing which of the following functions?",
    "choice_a": "Channel bonding",
    "choice_b": "Band steering",
    "choice_c": "Link aggregation",
    "choice_d": "Traffic shaping",
    "correct_answer": "B",
    "explanation": "Band steering is a wireless network adapter mechanism that evaluates the available wireless signals and automatically chooses the best frequency for the current conditions. Channel bonding is a wireless networking technique that combines channels to increase bandwidth. <i>Link aggregation</i> is a term for technology in which the bandwidth of multiple network adapter connections is joined to speed up transmissions. Traffic shaping is a means of prioritizing network traffic by delaying packets at the Application layer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      188,
      187,
      193,
      196,
      207
    ],
    "source": "9781394239306"
  },
  {
    "id": 1027,
    "question": "Which of the following types of wireless access point (WAP) requires the network to include a wireless LAN controller (WLC)?",
    "choice_a": "Lightweight access point",
    "choice_b": "Standalone access point",
    "choice_c": "Autonomous access point",
    "choice_d": "Traffic access point",
    "correct_answer": "A",
    "explanation": "Lightweight wireless access points are designed to facilitate the expansion of the network by using a single wireless LAN controller (WLC) to store and deploy the configuration parameters for multiple lightweight access points configured to use the same SSID. <i>Standalone</i> and <i>autonomous</i> are terms for the same type of combined switch and access point commonly used today. There is no such thing as a traffic access point.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      191,
      57,
      187,
      200,
      196
    ],
    "source": "9781394239306"
  },
  {
    "id": 1028,
    "question": "At what humidity level do electronic components become vulnerable to damage from electrostatic shock?",
    "choice_a": "Below 30 percent",
    "choice_b": "Below 50 percent",
    "choice_c": "Above 70 percent",
    "choice_d": "Above 90 percent",
    "correct_answer": "B",
    "explanation": "Humidity prevents the buildup of static electricity that can cause discharges that damage equipment. Humidity levels of 50 percent or lower can cause equipment to be susceptible to electrostatic shock.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      67,
      65,
      187,
      188,
      70
    ],
    "source": "9781394239306"
  },
  {
    "id": 1029,
    "question": "Ralph is designing the HVAC implementation for his company's new central datacenter, which will house all of the equipment for the corporate headquarters and the company's manufacturing facility. The datacenter must adhere to the Tier III standard defined by the Uptime Institute, which calls for at least 99.9 percent uptime. As part of the environmental infrastructure for the datacenter, Ralph plans to install sensors to monitor environmental factors that can affect computer equipment and generate alerts when conditions exceed accepted thresholds. Which of the following environmental factors is not one of those that Ralph should arrange to monitor to protect the equipment specific to a datacenter?",
    "choice_a": "Flood",
    "choice_b": "Humidity",
    "choice_c": "Radon",
    "choice_d": "Static electricity",
    "correct_answer": "C",
    "explanation": "Unless there is a specific known threat at the datacenter location, radon is not one of the environmental factors that typically can affect equipment uptime and that needs to be monitored. Temperature, humidity, flooding, and static electricity, however, are factors that should be monitored in a datacenter, as variations of these elements can result in equipment damage and downtime.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      197,
      67,
      201,
      206
    ],
    "source": "9781394239306",
    "choice_e": "Temperature"
  },
  {
    "id": 1030,
    "question": "Which of the following are places where network wiring connections are found? (Choose all that apply.)",
    "choice_a": "MDF",
    "choice_b": "MTBF",
    "choice_c": "IDF",
    "choice_d": "RDP",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "A large enterprise network will\u2014at minimum\u2014have demarcation points for telephone services and a connection to an Internet service provider's (ISP's) network. In many cases, these services will enter the building in the same equipment room that houses the backbone switch. This room is then called the main distribution frame (MDF). An intermediate distribution frame (IDF) is the location of localized telecommunications equipment such as the interface between the horizontal cabling and the backbone. Mean time between failure (MTBF) and Remote Desktop Protocol (RDP) are not locations of network wiring.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      64,
      273,
      168,
      71
    ],
    "source": "9781394239306"
  },
  {
    "id": 1031,
    "question": "Which of the following is the term used to describe a wiring nexus\u2014typically housed in a closet\u2014where horizontal networks meet the backbone?",
    "choice_a": "MDF",
    "choice_b": "MTBF",
    "choice_c": "IDF",
    "choice_d": "SLA",
    "correct_answer": "C",
    "explanation": "An intermediate distribution frame (IDF) is the location of localized telecommunications equipment such as the interface between a horizontal network, which connects to workstations and other user devices, and the network backbone. A large enterprise network will typically have demarcation points for telephone services and a connection to an Internet service provider's (ISP's) network. In many cases, these services will enter the building in the same equipment room that houses the backbone switch. This room is then called the main distribution frame (MDF). Mean time between failure (MTBF), service-level agreements (SLAs), and memoranda of understanding (MOUs) are not locations of network wiring.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      168,
      155,
      150,
      71,
      52
    ],
    "source": "9781394239306",
    "choice_e": "MOU"
  },
  {
    "id": 1032,
    "question": "Your company has been acquired by another firm and, as IT director, you will have to comply with the new firm's safety policies in your datacenter and other IT workspaces. One of the new requirements states that there must be a fail closed policy for the datacenter. Which of the following best describes what this policy dictates should occur in the event of an emergency?",
    "choice_a": "All computers that are logged on should automatically log off.",
    "choice_b": "All computers that are running should automatically shut down.",
    "choice_c": "All doors that are normally open should lock themselves.",
    "choice_d": "All doors that are normally locked should open themselves.",
    "correct_answer": "C",
    "explanation": "A fail closed policy for the datacenter specifies that any open doors should lock themselves in the event of an emergency. To support this policy, the datacenter will have to have a self-contained fire suppression system, which uses devices such as fire detectors and oxygen-displacing gas systems.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      67,
      197,
      201,
      206
    ],
    "source": "9781394239306"
  },
  {
    "id": 1033,
    "question": "Redundant power circuits can enable a server to continue running despite which of the following events?",
    "choice_a": "A citywide power outage",
    "choice_b": "A server power supply failure",
    "choice_c": "An uncorrected building circuit failure",
    "choice_d": "A failure of the server's uninterruptable power supply (UPS)",
    "correct_answer": "C",
    "explanation": "If a server is connected to two building circuits, it can continue to function if the breaker for one circuit trips and remains uncorrected. All of the other options will bring the server down unless additional redundancies are in place.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      261,
      175,
      65,
      54,
      71
    ],
    "source": "9781394239306"
  },
  {
    "id": 1034,
    "question": "A server with dual power supplies must be running in which of the following modes for the system to be fault tolerant?",
    "choice_a": "Combined mode",
    "choice_b": "Redundant mode",
    "choice_c": "Individual mode",
    "choice_d": "Hot backup mode",
    "correct_answer": "B",
    "explanation": "A server with dual power supplies can run in one of two modes: redundant or combined. In redundant mode, both power supplies are capable of providing 100 percent of the power needed by the server. Therefore, the server can continue to run if one power supply fails, making it fault tolerant. In combined mode, both power supplies are needed to provide the server's needs, so a failure of one power supply will bring the server down. <i>Individual mode</i> and <i>hot backup</i> mode are not terms used for this purpose.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      261,
      173,
      54,
      71,
      65
    ],
    "source": "9781394239306"
  },
  {
    "id": 1035,
    "question": "Which of the following statements about the differences between online and standby uninterruptible power supplies (UPSs) are correct? (Choose all that apply.)",
    "choice_a": "A standby UPS runs devices using battery power all the time.",
    "choice_b": "An online UPS provides no gap in the power supplied to the devices during a main power failure.",
    "choice_c": "An online UPS switches devices to battery power only during a main power failure.",
    "choice_d": "A standby UPS provides only enough power for an orderly shutdown of the devices.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "It is an online UPS that runs devices using battery power all the time so that there is no gap in the power supplied to devices during a failure. It is a standby UPS that switches devices to battery power during a main power failure. Both online and standby UPSs provide only enough power for an orderly shutdown of the devices.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      145,
      274,
      275,
      261,
      263
    ],
    "source": "9781394239306"
  },
  {
    "id": 1036,
    "question": "Which of the following are valid reasons why online uninterruptible power supplies (UPSs) are more expensive than standby UPSs?",
    "choice_a": "Online UPSs enable devices to run longer when a main power failure occurs.",
    "choice_b": "Online UPSs enable devices to run continuously when a main power failure occurs.",
    "choice_c": "Online UPSs are managed devices that can generate alerts.",
    "choice_d": "Online UPSs provide greater protection against power spikes and sags.",
    "correct_answer": "B",
    "explanation": "Online UPSs run devices from their battery all the time, while simultaneously keeping the battery charged. There is therefore no switchover gap when a power failure occurs. Online UPSs do not necessarily run longer than standby UPSs, nor do they provide more protection against power spikes and sags. Both online and standby UPSs can be managed devices.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      262,
      273,
      274,
      263,
      65
    ],
    "source": "9781394239306"
  },
  {
    "id": 1037,
    "question": "Which of the following is the primary function of an uninterruptible power supply (UPS) during a two-hour building power failure?",
    "choice_a": "To keep servers running until building power is restored",
    "choice_b": "To keep servers running until they can be powered down safely",
    "choice_c": "To keep servers from being damaged by power spikes",
    "choice_d": "To keep servers running in the event of a computer power supply failure",
    "correct_answer": "B",
    "explanation": "UPSs can provide servers with battery backup power, but usually only for a few minutes, so that the servers can be powered down safely, without the potential for data corruption or loss. UPSs typically cannot keep servers running for two hours. UPSs can protect against power spikes, but that is not their primary function. A computer power supply failure will bring a server down, regardless of the presence of a UPS.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      275,
      264,
      273,
      170
    ],
    "source": "9781394239306"
  },
  {
    "id": 1038,
    "question": "If you have a server with dual power supplies, one of which is plugged into a single uninterruptible power supply (UPS) and the other into a wall socket with a surge protector, and the building's power circuit is connected to a backup generator, which of the following failures can the server survive and keep running indefinitely? (Choose all that apply.)",
    "choice_a": "Failure of one server power supply",
    "choice_b": "Failure of the UPS",
    "choice_c": "Failure of the building power circuit",
    "choice_d": "Failure of the building backup generator",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "If one of the server's power supplies fails, the other will continue to function. If the UPS fails, the server will continue to use the power supply plugged into the wall socket. If the building's backup generator fails, the server will continue to run as long as the building still has outside power. If the breaker for the building power circuit trips, the server will run only as long as the UPS battery holds out.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      275,
      173,
      170,
      179,
      168
    ],
    "source": "9781394239306"
  },
  {
    "id": 1039,
    "question": "If you have a server with dual power supplies, each of which is connected to a separate uninterruptible power supply (UPS), with each UPS connected to a separate building power circuit connected to a backup generator, which of the following failures can the server survive and keep running indefinitely? (Choose all that apply.)",
    "choice_a": "Failure of one server power supply",
    "choice_b": "Failure of one UPS",
    "choice_c": "Failure of one building power circuit",
    "choice_d": "Failure of the building backup generator",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D"
    ],
    "explanation": "If one of the server's power supplies fails, the other will continue to function. If one of the UPSs fails, the server will continue to run using the other. If one of the building power circuit breakers trips, the server will continue to run using the other one. If the building's backup generator fails, the server will continue to run as long as the building still has outside power.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      275,
      173,
      170,
      65,
      122
    ],
    "source": "9781394239306"
  },
  {
    "id": 1040,
    "question": "Which of the following is the most commonly recommended fire suppression system for a datacenter?",
    "choice_a": "Carbon Dioxide",
    "choice_b": "Pre-action sprinklers",
    "choice_c": "Water mist",
    "choice_d": "Clean agents",
    "correct_answer": "D",
    "explanation": "Clean agents are non-conductive inert gases that extinguish flame by rapid cooling and oxygen displacement without leaving any residue behind to damage equipment. Both pre-action sprinklers and water mist systems spray water, which can damage electronic equipment. Carbon dioxide is a fire suppressant, but it is also too toxic to be used on a large scale.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      261,
      192,
      168,
      64
    ],
    "source": "9781394239306"
  },
  {
    "id": 1041,
    "question": "Which of the following is the primary difference between the power distribution units (PDUs) used in datacenters and the standard power strips used in offices and homes?",
    "choice_a": "More outlets",
    "choice_b": "Larger power input",
    "choice_c": "Larger voltage output",
    "choice_d": "All of the above",
    "correct_answer": "B",
    "explanation": "A PDU for a datacenter performs the same basic function as an office power strip, but it typically has a larger power input. It does not necessarily have more outlets or a larger voltage output.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      65,
      70,
      71,
      53,
      168
    ],
    "source": "9781394239306"
  },
  {
    "id": 1042,
    "question": "Which of the following types of physical security is most likely to detect an insider threat?",
    "choice_a": "Smart cards",
    "choice_b": "Motion detection",
    "choice_c": "Video surveillance",
    "choice_d": "Biometrics",
    "correct_answer": "C",
    "explanation": "An insider threat by definition originates with an authorized user. Smart cards, motion detection, and biometrics will only detect the presence of someone who is authorized to enter sensitive areas. Video surveillance, however, can track the activities of anyone, authorized or not.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      169,
      166,
      161,
      192
    ],
    "source": "9781394239306"
  },
  {
    "id": 1043,
    "question": "Which of the following is the term used to describe a wiring nexus that is typically the termination point for incoming telephone and wide area network (WAN) services?",
    "choice_a": "MDF",
    "choice_b": "MTBF",
    "choice_c": "IDF",
    "choice_d": "RDP",
    "correct_answer": "A",
    "explanation": "A large enterprise network will\u2014at minimum\u2014have demarcation points for telephone services and a connection to an Internet service provider's (ISP's) network. In many cases, these services will enter the building in the same equipment room that houses the backbone switch. This room is then called the main distribution frame (MDF). An intermediate distribution frame (IDF) is the location of localized telecommunications equipment such as the interface between the horizontal cabling and the backbone. Mean time between failure (MTBF), Remote Desktop Protocol (RDP), and memorandum of understanding (MOU) are not locations of network wiring.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      64,
      65,
      71,
      168,
      155
    ],
    "source": "9781394239306",
    "choice_e": "MOU"
  },
  {
    "id": 1044,
    "question": "Which of the following physical security mechanisms can either \u201cfail close\u201d or \u201cfail open\u201d?",
    "choice_a": "Motion detectors",
    "choice_b": "Video cameras",
    "choice_c": "Honeypots",
    "choice_d": "Door locks",
    "correct_answer": "D",
    "explanation": "The terms <i>fail close</i> and <i>fail open</i> refer to the default position of an electric or electronic door lock when there is a power failure. Security is often a trade-off with safety, and in the event that an emergency occurs that results in the power being cut off, whether secured doors are permanently locked or left permanently open is a critical factor. The terms <i>fail close</i> and <i>fail open</i> do not apply to motion detectors or video cameras. A honeypot is a computer configured to lure potential attackers; it is not a physical security mechanism.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      174
    ],
    "source": "9781394239306"
  },
  {
    "id": 1045,
    "question": "Smart lockers are storage devices that can provide users with access to supplies, deliveries, and other items using various security mechanisms. Which of the following are technologies that smart lockers can use to authenticate users and provide secure access to their contents?",
    "choice_a": "PIN",
    "choice_b": "NFC",
    "choice_c": "Bluetooth",
    "choice_d": "Biometrics",
    "correct_answer": "F",
    "explanation": "Smart lockers are available with a wide variety of authentication mechanisms, ranging from the relatively unsecure PIN to near field communication (NFC) and Bluetooth devices to high security biometric scans and radio-frequency identification (RFID) tags.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      65,
      174,
      175,
      196,
      67
    ],
    "source": "9781394239306",
    "choice_e": "RFID",
    "choice_f": "All of the above"
  },
  {
    "id": 1046,
    "question": "Which of the following are common types of cameras used for video surveillance of secured network installations? (Choose two.)",
    "choice_a": "IP",
    "choice_b": "LDAP",
    "choice_c": "CCTV",
    "choice_d": "NAC",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Closed circuit television (CCTV) cameras are part of a self-contained system in which the cameras feed their signals to dedicated monitors, usually located in a security center. IP cameras are standalone devices that transmit signals to a wireless access point. While CCTV cameras can only be monitored by users in the security center, or another designated location, IP cameras can be monitored by any authorized user with a web browser. LDAP is a directory services protocol and Network Access Control is a service; neither one is a type of video surveillance device.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      187,
      248,
      174,
      64
    ],
    "source": "9781394239306"
  },
  {
    "id": 1047,
    "question": "Which of the following statements describes what it means when the automated lock on the door to a datacenter is configured to fail open?",
    "choice_a": "The door remains in its current state in the event of an emergency.",
    "choice_b": "The door locks in the event of an emergency.",
    "choice_c": "The door unlocks in the event of an emergency.",
    "choice_d": "The door continues to function using battery power in the event of an emergency.",
    "correct_answer": "C",
    "explanation": "A door that is configured to fail open reverts to its unsecured state\u2014open\u2014when an emergency occurs. This must be a carefully considered decision, as it can be a potential security hazard. However, configuring the door to fail closed is a potential safety hazard in the event of a fire or other disaster.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      248,
      169,
      53,
      168
    ],
    "source": "9781394239306"
  },
  {
    "id": 1048,
    "question": "A high security installation that requires entrants to submit to a retinal scan before the door unlocks is using which of the following types of technology?",
    "choice_a": "Pattern recognition",
    "choice_b": "Hand geometry",
    "choice_c": "Biometrics",
    "choice_d": "Tamper detection",
    "correct_answer": "C",
    "explanation": "The technology that uses human physical characteristics to authenticate users is called biometrics. Biometric devices can identify users based on fingerprints, retinal pattern, voice prints, and other characteristics.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      174,
      206,
      248,
      161
    ],
    "source": "9781394239306"
  },
  {
    "id": 1049,
    "question": "Which of the following are means of preventing unauthorized individuals from entering a sensitive location, such as a datacenter? (Choose all that apply.)",
    "choice_a": "Biometric scans",
    "choice_b": "Identification badges",
    "choice_c": "Key fobs",
    "choice_d": "Motion detection",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Biometric scans, identification badges, and key fobs are all mean of distinguishing authorized from unauthorized personnel. Motion detection cannot make this distinction.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      65,
      192,
      206,
      169,
      161
    ],
    "source": "9781394239306"
  },
  {
    "id": 1050,
    "question": "Which of the following security measures can monitor the specific activities of authorized individuals within sensitive areas?",
    "choice_a": "Video surveillance",
    "choice_b": "Identification badges",
    "choice_c": "Key fobs",
    "choice_d": "Motion detection",
    "correct_answer": "A",
    "explanation": "Video surveillance can monitor all activities of users in a sensitive area. With properly placed equipment, event specific actions, such as commands entered in a computer, can be monitored. Identification badges, key fobs, motion detection, and locking cabinets can indicate the presence of individuals in a sensitive area, but they cannot monitor specific activities.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      187,
      192,
      197,
      206
    ],
    "source": "9781394239306",
    "choice_e": "Locking cabinets"
  },
  {
    "id": 1051,
    "question": "Which of the following physical security devices can use passive RFIDs to enable an authorized user to enter a secured area? (Choose all that apply.)",
    "choice_a": "Key fob",
    "choice_b": "Keycard lock",
    "choice_c": "Proximity card",
    "choice_d": "Cypher lock",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "A radio-frequency identification (RFID) device is a small chip that can be electronically detected by a nearby reader. The chip can contain small amounts of data, such as the authentication credentials needed to grant an individual access to a secured area. Key fobs, proximity cards (prox cards), and smart lockers can use RFIDs to enable users to unlock a door by waving the device near a reader. Keycard locks typically require the card to be inserted into a reader and typically use magnetic strips to store data. Cypher locks rely on data supplied by the user\u2014that is, the combination numbers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      174,
      206,
      196,
      161
    ],
    "source": "9781394239306",
    "choice_e": "Smart locker"
  },
  {
    "id": 1052,
    "question": "Some key fobs used for authenticated entrance to a secured area have a keypad that requires the user to enter a PIN before the device is activated. Which of the following authentication factors is this device using? (Choose all that apply.)",
    "choice_a": "Something you do",
    "choice_b": "Something you have",
    "choice_c": "Something you are",
    "choice_d": "Something you know",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Possession of the key fob is something you have, but the key fob could be lost or stolen, so its security is confirmed by the entrance of a PIN, something you know. Unless the user both loses the key fob and shares the PIN, the device remains secure.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      174,
      65,
      192,
      206,
      201
    ],
    "source": "9781394239306"
  },
  {
    "id": 1053,
    "question": "Which of the following physical security devices can enable an authorized user to enter a secured area without any physical contact with the device? (Choose all that apply.)",
    "choice_a": "Key fob",
    "choice_b": "Keycard lock",
    "choice_c": "Proximity card",
    "choice_d": "Cypher lock",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Key fobs and proximity cards (prox cards) often use RFIDs to enable users to unlock a door by waving the device near a reader. Keycard locks typically use magnetic strips to store data and require the card to be physically inserted into a reader. Cypher locks rely on data manually supplied by the user\u2014that is, the combination numbers.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      65,
      174,
      206,
      187,
      192
    ],
    "source": "9781394239306"
  },
  {
    "id": 1054,
    "question": "Video surveillance of sensitive areas, such as datacenters, can aid in the detection of which of the following types of attacks? (Choose all that apply.)",
    "choice_a": "Social engineering",
    "choice_b": "Evil twin",
    "choice_c": "Brute force",
    "choice_d": "Insider threats",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Video surveillance can conceivably prevent an evil twin attack, which takes the form of a rogue access point deliberately connected to the network for malicious purposes. Video surveillance can also help to prevent insider threats by monitoring the activities of authorized users. Video surveillance cannot prevent social engineering, which involves nothing more than communicating with people, or brute-force attacks, which are usually performed remotely.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      206,
      187,
      65,
      192,
      197
    ],
    "source": "9781394239306"
  },
  {
    "id": 1055,
    "question": "Which of the following statements is true when a biometric authentication procedure results in a false positive?",
    "choice_a": "A user who should be authorized is denied access.",
    "choice_b": "A user who should not be authorized is denied access.",
    "choice_c": "A user who should be authorized is granted access.",
    "choice_d": "A user who should not be authorized is granted access.",
    "correct_answer": "D",
    "explanation": "When a false positive occurs during a biometric authentication, a user who should not be granted access to the secured device or location is granted access. A false negative is when a user who should be granted access is denied access.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      54
    ],
    "source": "9781394239306"
  },
  {
    "id": 1056,
    "question": "In the datacenter of a company involved with sensitive government data, all servers have crimped metal tags holding the cases closed. All of the hardware racks are locked in clear-fronted cabinets. All cable runs are installed in transparent conduits. These are all examples of which of the following physical security measures?",
    "choice_a": "Tamper detection",
    "choice_b": "Asset tracking",
    "choice_c": "Geofencing",
    "choice_d": "Port security",
    "correct_answer": "A",
    "explanation": "All of the mechanisms listed are designed to make any attempts to tamper with or physically compromise the hardware devices immediately evident. This is therefore a form of tamper detection. Asset tracking is for locating and identifying hardware. Geofencing is a wireless networking technique for limiting access to a network. Port security refers to network switch ports.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      248,
      168,
      169,
      65,
      71
    ],
    "source": "9781394239306"
  },
  {
    "id": 1057,
    "question": "A secured government building that scans the faces of incoming people and compares them to a database of authorized entrants is using which of the following types of technology?",
    "choice_a": "Pattern recognition",
    "choice_b": "Hand geometry",
    "choice_c": "Biometrics",
    "choice_d": "Tamper detection",
    "correct_answer": "C",
    "explanation": "The technology that uses human physical characteristics to authenticate users is called biometrics. Biometric devices can identify users based on fingerprints, retinal pattern, voice prints, and other characteristics.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      65,
      169,
      206,
      187,
      192
    ],
    "source": "9781394239306"
  },
  {
    "id": 1058,
    "question": "Which of the following is not a means of preventing physical security breaches to a network datacenter?",
    "choice_a": "Badges",
    "choice_b": "Locks",
    "choice_c": "Key fobs",
    "choice_d": "Tailgaters",
    "correct_answer": "D",
    "explanation": "A tailgater is a type of intruder who enters a secure area by closely following an authorized user. Most people are polite enough to hold the door open for the next person without knowing if they are authorized to enter. A tailgater is therefore not an intrusion prevention mechanism. Identification badges, locks, and key fobs are methods of preventing intrusions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      248,
      169,
      172,
      187
    ],
    "source": "9781394239306"
  },
  {
    "id": 1059,
    "question": "Identification badges, key fobs, and access control vestibules all fall into which of the following categories of security devices?",
    "choice_a": "Physical security",
    "choice_b": "Data security",
    "choice_c": "Asset tracking",
    "choice_d": "Port security",
    "correct_answer": "A",
    "explanation": "Identification badges, key fobs, and access control vestibules (mantraps) are all physical security mechanisms, in that they prevent unauthorized personnel from entering sensitive areas, such as datacenters. These mechanisms are not used for data file security, asset tracking, or switch port security.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      174,
      169,
      187,
      191
    ],
    "source": "9781394239306"
  },
  {
    "id": 1060,
    "question": "Which of the following are not means of detecting intruders in a network datacenter? (Choose all that apply.)",
    "choice_a": "Motion detection",
    "choice_b": "Video surveillance",
    "choice_c": "Biometrics",
    "choice_d": "Smart cards",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Biometrics and smart cards are both means of preventing intrusions, whereas motion detection and video surveillance are mechanisms for detecting them.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      65,
      201,
      206,
      192,
      197
    ],
    "source": "9781394239306"
  },
  {
    "id": 1061,
    "question": "Which of the following statements describes what it means when the automated lock on the door to a datacenter is configured to fail closed?",
    "choice_a": "The door remains in its current state in the event of an emergency.",
    "choice_b": "The door locks in the event of an emergency.",
    "choice_c": "The door unlocks in the event of an emergency.",
    "choice_d": "The door continues to function using battery power in the event of an emergency.",
    "correct_answer": "B",
    "explanation": "A door that is configured to fail closed reverts to its secured state\u2014locked\u2014when an emergency occurs. This must be a carefully considered decision since it can be a potential safety hazard in the event of a fire or other disaster. However, configuring the door to fail open is a potential security hazard.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      248,
      169,
      53,
      71
    ],
    "source": "9781394239306"
  },
  {
    "id": 1062,
    "question": "After an incident in which your company's datacenter was penetrated by an intruder, the management has installed a double doorway at the entrance to the datacenter. The two doors have a small area in between them, and one door must be closed before the other one can open. Which of the following terms describes this arrangement?",
    "choice_a": "Server closet",
    "choice_b": "Access control vestibule",
    "choice_c": "Controlled entrance",
    "choice_d": "Honeypot",
    "correct_answer": "B",
    "explanation": "An entrance arrangement in which people must close one door before they can open the next one is called an access control vestibule. Security personnel can evaluate potential entrants while they are in the vestibule and detain attempted intruders there.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      248,
      168,
      187,
      192
    ],
    "source": "9781394239306"
  },
  {
    "id": 1063,
    "question": "In an internal UTP cable installation, each horizontal cable run connects a wall plate in the work area to a centralized cabling nexus in a telecommunications room. Which of the following is the correct term for this cabling nexus?",
    "choice_a": "Telepole",
    "choice_b": "Demarc",
    "choice_c": "Backbone",
    "choice_d": "Patch panel",
    "correct_answer": "D",
    "explanation": "The cabling nexus in a telecommunications room is called a patch panel. A telepole is a tool used for installing cables. A demarcation point, or demarc, is the location at which a telecommunication provider's service meets the customer's private network. A backbone is a network that connects other local area networks (LANs) together. A fiber distribution panel is used for fiber-optic cable, not unshielded twisted-pair (UTP), connections.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      150,
      71,
      152,
      54,
      68
    ],
    "source": "9781394239306",
    "choice_e": "Fiber distribution panel"
  },
  {
    "id": 1064,
    "question": "Datacenter equipment racks are typically ruled into vertical rack units, which are standard-sized divisions that hardware manufacturers use when manufacturing rack-mountable components. Which of the following is the standard vertical height of a single rack unit?",
    "choice_a": "1.721 inches",
    "choice_b": "1.75 inches",
    "choice_c": "40 mm",
    "choice_d": "3.5 inches",
    "correct_answer": "B",
    "explanation": "A single rack unit is 1.75 inches, or 44.5 mm. Option A, 1.721 inches, is the height used for many components that are one rack unit tall, leaving a small space between components for easy insertion and removal.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      64,
      65,
      54,
      168,
      71
    ],
    "source": "9781394239306"
  },
  {
    "id": 1065,
    "question": "Ralph is evaluating switches and, in the documentation for some of the switch models, he sees an option allowing the switch to be set for port-side intake or port-side exhaust. Ralph is not sure what this option does. Which of the following best describes the function of the port side intake/exhaust setting?",
    "choice_a": "The setting specifies the direction that incoming signals take through the row of switch ports: left to right or right to left.",
    "choice_b": "The setting specifies which set of cable ports should be active: front or back.",
    "choice_c": "The setting specifies the direction of the airflow through the switch: front to back or back to front.",
    "choice_d": "All of the above.",
    "correct_answer": "C",
    "explanation": "The port-side intake/exhaust option controls the flow of air through the switch. An administrator can specify whether the vents on the front of the switch take air in and exhaust it out the back or exhaust air taken in through the back. This enables administrators to designate specific aisles in the datacenter as warm or cold. The port-side intake/exhaust option has nothing to do with the signal propagation through the switch or which ports the switch should use.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      65,
      71,
      62,
      178,
      168
    ],
    "source": "9781394239306"
  },
  {
    "id": 1066,
    "question": "Alice is designing the datacenter for her company's new facility and is attempting to calculate the total power load for the entire datacenter. Which of the following functions should Alice include in her power load calculations? (Choose all that apply.)",
    "choice_a": "HVAC",
    "choice_b": "Servers",
    "choice_c": "Lighting",
    "choice_d": "IDF",
    "correct_answer": [
      "A",
      "B",
      "C",
      "E",
      "F"
    ],
    "explanation": "In addition to the actual networking equipment, such as servers, switches, and routers, the power load calculations for a datacenter must include HVAC (and particularly cooling and fire suppression), room lighting, and any other powered security equipment. The intermediate distribution frame (IDF) is not located in the datacenter and therefore does not factor in Alice's power load calculations.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      65,
      68,
      54,
      179,
      197
    ],
    "source": "9781394239306",
    "choice_e": "Security equipment",
    "choice_f": "Switches and routers"
  },
  {
    "id": 1067,
    "question": "Which of the following is the term usually applied to a representation of network devices, automatically compiled, and containing information such as IP addresses and connection speeds?",
    "choice_a": "Network map",
    "choice_b": "Network diagram",
    "choice_c": "Cable diagram",
    "choice_d": "Management information base",
    "correct_answer": "A",
    "explanation": "A network map is a depiction of network devices, not drawn to scale, with additional information added, such as IP addresses and link speeds. In most cases, network maps are automatically created by a software product that scans the network and creates a display from the information it discovers. The term <i>network diagram</i> is most often used to refer to a manually created document containing pictograms of network devices, with lines representing the connections between them, usually not drawn to scale. A cable diagram is a precise depiction of the cable runs installed at a site. Often drawn on an architect's floor plan or blueprint, cable diagrams enable network administrators to locate specific cables and troubleshoot connectivity problems. A management information base (MIB) is a component of a network management system that is based on the Simple Network Management Protocol (SNMP) and contains information about only one device; it does not depict all of the devices on the network.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      251,
      254,
      252,
      257,
      256
    ],
    "source": "9781394239306"
  },
  {
    "id": 1068,
    "question": "Which of the following types of network documentation is often overlaid on an architectural drawing or blueprint?",
    "choice_a": "Heat map",
    "choice_b": "Network map",
    "choice_c": "Cable diagram",
    "choice_d": "Network diagram",
    "correct_answer": "C",
    "explanation": "A cable diagram is a precise depiction of the cable runs installed at a site. Often drawn on an architect's floor plan or blueprint, cable diagrams enable network administrators to locate specific cables and troubleshoot connectivity problems. A wireless survey/heat map is a depiction of the wireless signal strengths found at various locations in a site, also overlaid on a floor plan or blueprint. A network map is a depiction of network devices, not drawn to scale, with additional information added, such as IP addresses and link speeds. In most cases, network maps are automatically created by a software product that scans the network and creates a display from the information it discovers. The term <i>network diagram</i> is most often used to refer to a manually created document containing pictograms of network devices, with lines representing the connections between them; the diagram is usually not drawn to scale. A management information base (MIB) is a component of a network management system that is based on the Simple Network Management Protocol (SNMP) and contains information about only one device; it does not depict all of the devices on the network.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      256,
      252,
      254,
      251,
      253
    ],
    "source": "9781394239306",
    "choice_e": "Management information base"
  },
  {
    "id": 1069,
    "question": "Which of the following is not one of the typical heights for devices mounted in IT equipment racks?",
    "choice_a": "1 unit",
    "choice_b": "2 units",
    "choice_c": "3 units",
    "choice_d": "4 units",
    "correct_answer": "C",
    "explanation": "Devices designed to fit into IT equipment racks typically have heights measured in units. One unit equals 1.75 inches. Most rack-mounted devices are one (1U), two (2U), or four units (4U) tall.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      252,
      240,
      271,
      218,
      247
    ],
    "source": "9781394239306"
  },
  {
    "id": 1070,
    "question": "The cable plant for Alice's company network was installed several years ago by an outside contractor. Now, some of the paper labels have fallen off the patch panels, and Alice does not know which wall plate is connected to each port. Assuming that she is working on a properly maintained and documented network installation, which of the following is the easiest way for Alice to determine which port is connected to which wall plate?",
    "choice_a": "Consult the cable diagram provided by the cabling contractor at the time of the installation.",
    "choice_b": "Call the cable installation contractor and see if they can remember which ports go with which wall plates.",
    "choice_c": "Attach a tone generator to a patch panel port and then test each wall plate with a locator until you find the correct one. Repeat this for each port that needs labeling.",
    "choice_d": "Use a cable certifier to locate the patch panel port associated with each wall plate port.",
    "correct_answer": "A",
    "explanation": "A reputable cable installer should supply a cable diagram that indicates the locations of all the cable runs on a plan or blueprint of the site. Alice should be able to use this to determine which ports go with which wall plates. A busy cable installer is unlikely to remember specific details about an installation performed years ago. Using a tone generator and locator is an effective way to associate ports and wall plates, but it can be incredibly time consuming and is certainly not the easiest method. A cable certifier can test the cable run for faults, measure its length, and perform other tests, but it cannot specify which wall plate goes with which port, unless the user entered that information earlier.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      253,
      251,
      254,
      252,
      257
    ],
    "source": "9781394239306"
  },
  {
    "id": 1071,
    "question": "Which of the following IT asset management documents published by the International Organization for Standardization (ISO) defines a standard for Software Identification Tags (SWIDs) containing asset inventory information about the software running on a computer or other device?",
    "choice_a": "ISO 19770-1",
    "choice_b": "ISO 19770-2",
    "choice_c": "ISO 19770-3",
    "choice_d": "ISO 19770-4",
    "correct_answer": "B",
    "explanation": "ISO 19770 is a family of IT asset management (ITAM) standards that defines procedures and technology for the inventory and management of software and related assets in a corporate infrastructure. ISO 19770-2 defines the creation and use of SWID tags, which are XML files containing management and identification information about a specific software product. The other standards define other ITAM elements, such as compliance with corporate governance (ISO 19770-1) and resource utilization measurement (ISO 19770-4).",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      240,
      237,
      238,
      246,
      245
    ],
    "source": "9781394239306",
    "choice_e": "ISO 19770-5"
  },
  {
    "id": 1072,
    "question": "A rack diagram is typically ruled vertically using which of the following measurements?",
    "choice_a": "Inches",
    "choice_b": "Centimeters",
    "choice_c": "Units",
    "choice_d": "Grids",
    "correct_answer": "C",
    "explanation": "Rack diagrams use vertical measurement called <i>units</i>, each of which is 1.75 inches. Most rack-mounted devices are one (1U), two (2U), or four units (4U) tall.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      252,
      251,
      256,
      257,
      255
    ],
    "source": "9781394239306"
  },
  {
    "id": 1073,
    "question": "Many network diagrams use Cisco symbols to illustrate the locations of and relationships between network components. Cisco symbols are standardized pictographs that illustrate the basic function of a network component. In a network diagram that uses Cisco symbols, what component does the symbol in the figure represent? <img src=\"/question_assets/Network+/c03uf001.png\"/>",
    "choice_a": "A router",
    "choice_b": "A switch",
    "choice_c": "A hub",
    "choice_d": "A gateway",
    "correct_answer": "A",
    "explanation": "The Cisco symbol shown in the figure is used in network diagrams to represent a router, as symbolized by the arrows pointing both in and out. This symbol is not used to represent a hub, a switch, or a gateway.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      251,
      254,
      252,
      257,
      255
    ],
    "source": "9781394239306"
  },
  {
    "id": 1074,
    "question": "Which of the following statements are true about the differences between a diagram of a patch panel installation organized physically and one that is organized logically? (Choose two.)",
    "choice_a": "A physical diagram is organized according to the floors and rooms where the cable drops are located.",
    "choice_b": "A physical diagram is precisely scaled to represent the actual patch panel hardware.",
    "choice_c": "A logical diagram is organized according to the divisions within the company, such as departments and workgroups.",
    "choice_d": "A logical diagram uses an organization that represents company divisions but does not physically resemble the actual patch panels.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "A physical diagram, in this case, represents the actual physical locations of the cable drops connected to the patch panels. A logical diagram uses artificial divisions that correspond to the organization of the company.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      254,
      251,
      252,
      255,
      256
    ],
    "source": "9781394239306"
  },
  {
    "id": 1075,
    "question": "A diagram of a telecommunications room or intermediate distribution frame (IDF) for an office building is typically based on which of the following?",
    "choice_a": "A hand-drawn sketch",
    "choice_b": "A series of photographs",
    "choice_c": "An architect's plan",
    "choice_d": "A 3D model",
    "correct_answer": "C",
    "explanation": "IDF diagrams should be based on an architect's plan whenever possible so that actual lengths and locations of cable runs can be documented. In situations where an architect's plan is not available, a detailed sketch, drawn to scale, can be acceptable. Photographs, models, and reports are impractical for this purpose.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      253,
      252,
      251,
      254,
      257
    ],
    "source": "9781394239306",
    "choice_e": "A site survey report"
  },
  {
    "id": 1076,
    "question": "The documentation for main distribution frames (MDFs) and intermediate distribution frames (IDFs) should incorporate details on which of the following elements? (Choose all that apply.)",
    "choice_a": "Power",
    "choice_b": "Environment",
    "choice_c": "Distances",
    "choice_d": "Costs",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "MDF and IDF documentation should take into account the power sources available at the locations, the HVAC equipment needed to keep the temperature and humidity levels under control, and the distances the cable runs must span. This type of documentation is typically used for installation and troubleshooting purposes, so the costs of components and services are unnecessary and can be covered elsewhere.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      253,
      252,
      271,
      270,
      218
    ],
    "source": "9781394239306"
  },
  {
    "id": 1077,
    "question": "Your department is experiencing frequent delays as users wait for images to be rendered by their outdated graphics software package. As a result, you are planning to submit a service request for an upgrade to a new software product at the monthly meeting of the company's change management team. Which of the following types of information are likely to be included in your service request? (Choose all that apply.)",
    "choice_a": "The possibility of rolling back to the previous software, if necessary",
    "choice_b": "The procedure for installing and configuring the new software",
    "choice_c": "An estimate of the productivity increase realizable with the new software",
    "choice_d": "A list of software and hardware upgrades or modifications needed to run the new software",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D"
    ],
    "explanation": "A change management team typically requires thorough documentation for all requested service changes, specifying exactly what is needed; how the change will affect the current workflow, both to the direct recipients of the change and the rest of the organization; and what ramifications might come from the change.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      238,
      237,
      240,
      251,
      256
    ],
    "source": "9781394239306"
  },
  {
    "id": 1078,
    "question": "The change request for new graphics software that you submitted to your company's change management team has been approved. Now it is time to implement the change. Which of the following administrative tasks will most likely be the change management team's responsibility during the implementation process? (Choose two.)",
    "choice_a": "Authorizing downtime",
    "choice_b": "Notifying users",
    "choice_c": "Designating a maintenance window",
    "choice_d": "Documenting all modifications made",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "The change management team is usually not responsible for tasks directly involved in the implementation of the changes they approve. Therefore, they would not be the ones to notify users exactly when the change will take place or document the procedure afterward. They would, however, be responsible for providing a maintenance window during which the change must occur and authorizing any downtime that would be needed.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      238,
      237,
      268,
      258,
      240
    ],
    "source": "9781394239306"
  },
  {
    "id": 1079,
    "question": "A rack-mounted device that is four units tall will be approximately what height in inches?",
    "choice_a": "1.75",
    "choice_b": "3.5",
    "choice_c": "4",
    "choice_d": "7",
    "correct_answer": "D",
    "explanation": "The standard unit height for IT equipment racks is 1.75 inches, which is the equivalent of one unit. Therefore, four units would be 7 inches.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      252,
      271,
      218,
      270,
      247
    ],
    "source": "9781394239306"
  },
  {
    "id": 1080,
    "question": "Which of the following types of documentation should indicate the complete route of every internal cable run from wall plate to patch panel?",
    "choice_a": "Physical network diagram",
    "choice_b": "Asset management",
    "choice_c": "Logical network diagram",
    "choice_d": "Wiring schematic",
    "correct_answer": "D",
    "explanation": "The main purpose of a wiring schematic\u2014also called a <i>layer 1 network diagram</i>\u2014is to indicate where cables are located in walls and ceilings. A physical network diagram identifies all of the physical devices and how they connect together. Asset management is the identification, documentation, and tracking of all network assets, including computers, routers, switches, software, licenses, warranties, and so on. A logical network diagram contains addresses, firewall configurations, access control lists (ACLs), and other logical elements of the network configuration.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      253,
      254,
      251,
      252,
      257
    ],
    "source": "9781394239306"
  },
  {
    "id": 1081,
    "question": "Which of the following types of network diagram contains the MAC addresses used for local network communication?",
    "choice_a": "Layer 1",
    "choice_b": "Layer 2",
    "choice_c": "Layer 3",
    "choice_d": "Layer 4",
    "correct_answer": "B",
    "explanation": "A layer 2 network diagram depicts the mechanisms by which devices communicate on a local area network. Each device is uniquely identified on the LAN by a media access control (MAC) address associated with its network interface. Layer 2 is associate with LAN communications only. A layer 3 diagram would identify the routers used by LANs to communicate with other networks. A layer 1 diagram specifies the physical characteristics of the network, such as where cables are installed in the facility. Layer 4 of the OSI models defines the Transport layer protocols in use on the network; it generally does not require a diagram.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      254,
      251,
      252,
      94,
      231
    ],
    "source": "9781394239306"
  },
  {
    "id": 1082,
    "question": "Which of the following statements about physical network diagrams and logical network diagrams are true? (Choose two.)",
    "choice_a": "A physical network diagram is created automatically, and a logical network diagram is created manually.",
    "choice_b": "A physical network diagram depicts hardware devices and the connections between them.",
    "choice_c": "A logical network diagram contains all of the information you would need to rebuild your network from scratch.",
    "choice_d": "A logical network diagram typically contains the IP addresses of network devices.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "A physical network diagram identifies all of the physical devices and how they connect together. A logical network diagram contains IP addresses, firewall configurations, access control lists (ACLs), and other logical elements of the network configuration. Both physical and logical network diagrams can be created automatically or manually. It is the physical network diagram that contains the information needed to rebuild the network from scratch.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      251,
      254,
      252,
      257,
      256
    ],
    "source": "9781394239306"
  },
  {
    "id": 1083,
    "question": "What is the width of a standard equipment rack in a datacenter?",
    "choice_a": "12 inches",
    "choice_b": "16 inches",
    "choice_c": "19 inches",
    "choice_d": "24 inches",
    "correct_answer": "C",
    "explanation": "The standard width of an equipment rack in a data center is 19 inches. Network hardware manufacturers use this width when designing rack-mountable components.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      252,
      270,
      271,
      269,
      240
    ],
    "source": "9781394239306"
  },
  {
    "id": 1084,
    "question": "Many network diagrams use Cisco symbols to illustrate the locations of and relationships between network components. Cisco symbols are standardized pictographs that illustrate the basic function of a network component. In a network diagram that uses Cisco symbols, what component does the symbol in the figure represent? <img src=\"/question_assets/Network+/c03uf002.png\"/>",
    "choice_a": "A switch",
    "choice_b": "A hub",
    "choice_c": "A router",
    "choice_d": "A gateway",
    "correct_answer": "A",
    "explanation": "The Cisco symbol shown in the figure is used in network diagrams to represent a switch, as symbolized by the multiple arrows pointing outward. This symbol is not used to represent a hub, a router, or a gateway.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      251,
      254,
      252,
      257,
      256
    ],
    "source": "9781394239306"
  },
  {
    "id": 1085,
    "question": "The precise locations of devices in a datacenter are typically documented in which of the following documents?",
    "choice_a": "Rack diagram",
    "choice_b": "Network map",
    "choice_c": "Wiring schematic",
    "choice_d": "Logical diagram",
    "correct_answer": "A",
    "explanation": "Datacenters typically mount components in racks, 19-inch-wide and approximately 6-foot-tall frameworks in which many networking components are specifically designed to fit. A rack diagram is a depiction of one or more racks, ruled out in standardized 1.752-inch rack units, and showing the exact location of each piece of equipment mounted in the rack. Network maps, wiring schematics, and logical diagrams are documents that define the relationships between components, not their precise locations. A business continuity plan describes the organization's disaster prevention and recovery policies. An audit and assessment report is a document\u2014often prepared by a third party\u2014that summarizes the organization's security posture.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      252,
      254,
      240,
      256,
      238
    ],
    "source": "9781394239306",
    "choice_e": "Business continuity plan",
    "choice_f": "Audit and assessment report"
  },
  {
    "id": 1086,
    "question": "Which of the following statements about network maps is true?",
    "choice_a": "Network maps are typically drawn to scale.",
    "choice_b": "Network maps typically contain more information than network diagrams.",
    "choice_c": "Network maps must be read/write accessible to all personnel working on the network.",
    "choice_d": "Network maps diagram only the locations of cable runs and endpoints.",
    "correct_answer": "B",
    "explanation": "Network diagrams typically specify device types and connections for layers 1, 2, and 3 of the OSI reference model, but network maps can also include IP addresses, link speeds, and other information. Network maps diagram the relationships between devices and provide information about the links that connect them, but they are not drawn to scale and usually do not indicate the exact location of each device. Although universal accessibility would be desirable, there are individuals who should not have access to network maps and other documentation, including temporary employees and computer users not involved in IT work. A network map includes all networking devices, not just cable runs and endpoints.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      251,
      254,
      252,
      259,
      224
    ],
    "source": "9781394239306"
  },
  {
    "id": 1087,
    "question": "Which of the following types of documentation should contain the chemical composition of all cleaning compounds used in a datacenter?",
    "choice_a": "ESD",
    "choice_b": "MSDS",
    "choice_c": "NDA",
    "choice_d": "BYOD",
    "correct_answer": "B",
    "explanation": "A material safety data sheet (MSDS) is a document created by manufacturers of chemical, electrical, and mechanical products, specifying the potential dangers and risks associated with them, particularly in regard to exposure or fire. A properly documented network should have MSDS documents on file for all of the chemical and hardware products used to build and maintain it. MSDSs can be obtained from the manufacturer or the Environmental Protection Agency (EPA). Electrostatic discharges (ESDs), non-disclosure agreements (NDAs), bring your own device (BYOD) policies, and standard operating procedures (SOPs) are not concerned with the chemical composition of cleaning compounds.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      271,
      256,
      251,
      238,
      237
    ],
    "source": "9781394239306",
    "choice_e": "SOP"
  },
  {
    "id": 1088,
    "question": "You are working for a company with numerous branch offices scattered around the country, and you are required to travel to these offices frequently. Each branch office has some means of accessing the network at the company headquarters. Some use Frame Relay, while others use virtual private networks (VPNs). During one trip, you mention to a branch office manager that you intend to connect to the headquarters network that night from your hotel room. The manager warns you that this is against company policy, but you are not so sure. Where in the company documentation should you look to confirm this?",
    "choice_a": "Remote access policies",
    "choice_b": "Service-level agreement",
    "choice_c": "Acceptable use policy",
    "choice_d": "Privileged user agreement",
    "correct_answer": "A",
    "explanation": "Remote access policies specify when and how users are permitted to access the company network from remote locations. A service-level agreement (SLA) is a contract between a provider and a subscriber that specifies the guaranteed availability of the service. Acceptable use policies (AUPs) specify whether and how employees can utilize company-owned hardware and software resources. A privileged user agreement specifies the abilities and limitations of users with respect to the administrative accounts and other privileges they have been granted.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      242,
      237,
      244,
      245,
      238
    ],
    "source": "9781394239306"
  },
  {
    "id": 1089,
    "question": "Which of the following is a document that a company's new hires might want to consult to determine whether they are permitted to install their own personal software on company computers?",
    "choice_a": "SLA",
    "choice_b": "AUP",
    "choice_c": "NDA",
    "choice_d": "BYOD",
    "correct_answer": "B",
    "explanation": "Acceptable use policies (AUPs) specify whether and how employees can utilize company-owned hardware and software resources. AUPs typically specify what personal work employees can perform, what hardware and software they can install, and what levels of privacy they are permitted when using company equipment. A service-level agreement (SLA) is a contract between a provider and a subscriber. A non-disclosure agreement (NDA) specifies what company information employees are permitted to discuss outside the company. A bring your own device (BYOD) policy specifies how employees can connect their personal devices to the company network.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      242,
      245,
      237,
      250,
      259
    ],
    "source": "9781394239306"
  },
  {
    "id": 1090,
    "question": "Many employees have been contacting the IT help desk asking how they can connect their personal smartphones and tablets to the company's wireless network. This has raised issues regarding network security and technical support. You have been asked to draft a policy for the in-house use of personal electronics that addresses these issues. Which of the following describes the document that you will be creating?",
    "choice_a": "SLA",
    "choice_b": "AUP",
    "choice_c": "NDA",
    "choice_d": "BYOD",
    "correct_answer": "D",
    "explanation": "A bring your own device (BYOD) policy specifies the personal electronics that employees are permitted to use on the company network and documents the procedures for connecting and securing them. A service-level agreement (SLA) is a contract between a provider and a subscriber that specifies the percentage of time that the contracted services are available. Acceptable use policies (AUPs) specify whether and how employees can use company-owned hardware and software resources. A non-disclosure agreement (NDA) specifies what company information employees are permitted to discuss outside the company.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      244,
      242,
      250,
      259,
      237
    ],
    "source": "9781394239306"
  },
  {
    "id": 1091,
    "question": "You are going to work for a new company as a software developer, and the human resources (HR) department has notified you that you must sign a document guaranteeing that you will maintain confidentiality about the company's products and programming code in perpetuity. Which of the following documents contains this agreement?",
    "choice_a": "SLA",
    "choice_b": "AUP",
    "choice_c": "NDA",
    "choice_d": "MOU",
    "correct_answer": "C",
    "explanation": "A non-disclosure agreement (NDA) specifies what company information employees are permitted to discuss outside the company. A service-level agreement (SLA) is a contract between a provider and a subscriber that specifies the percentage of time that the contracted services are available. Acceptable use policies (AUPs) specify whether and how employees can utilize company-owned hardware and software resources. A memorandum of understanding (MOU) is a document outlining an agreement between two parties that precedes the signing of a contract. A bring your own device (BYOD) policy specifies the personal electronics that employees are permitted to use on the company network and documents the procedures for connecting and securing them.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      259,
      242,
      244,
      238,
      250
    ],
    "source": "9781394239306",
    "choice_e": "BYOD"
  },
  {
    "id": 1092,
    "question": "You are an IT director, and a fire has broken out on the lower floors of your company's office building. After the personnel are evacuated, the fire department asks you where they can find documentation about all chemicals and equipment used in the company's datacenter, which is threatened by the fire. You direct them to the correct filing cabinet in your office, which contains which of the following document types?",
    "choice_a": "ESD",
    "choice_b": "NDA",
    "choice_c": "BYOD",
    "choice_d": "MSDS",
    "correct_answer": "D",
    "explanation": "Material safety data sheets (MSDSs) are documents, created by manufacturers of chemical, electrical, and mechanical products, that specify the potential risks and dangers associated with them, particularly in regard to flammability and the possibility of toxic outgassing. A properly documented network should have MSDS documents on file for all of the chemical and hardware products used to build and maintain it. MSDSs can be obtained from the manufacturers or the Environmental Protection Agency (EPA). Electrostatic discharges (ESDs), non-disclosure agreements (NDAs), and bring your own device (BYOD) policies are not concerned with the dangers inherent in building contents.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      271,
      240,
      252,
      251,
      237
    ],
    "source": "9781394239306"
  },
  {
    "id": 1093,
    "question": "You have been asked to draft an acceptable use policy (AUP) for new hires at your company to sign that specifies what they can and cannot do when working with the company's computers and network. Which of the following is not one of the provisions typically found in this type of document?",
    "choice_a": "Privacy",
    "choice_b": "Ownership",
    "choice_c": "Illegal use",
    "choice_d": "Upgrades",
    "correct_answer": "D",
    "explanation": "Software and hardware upgrades are typically not part of an AUP, because they are handled by the company's IT personnel. An AUP for a company typically includes a clause indicating that users have no right to privacy for anything they do using the company's computers, including email and data storage. An AUP usually specifies that the company is the sole owner of the computer equipment and any proprietary company information stored on it or available through it. The AUP also prohibits the use of its computers or network for any illegal practices, typically including spamming, hacking, or malware introduction or development.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      242,
      237,
      243,
      245,
      238
    ],
    "source": "9781394239306"
  },
  {
    "id": 1094,
    "question": "You are starting a new job, and the company's human resources (HR) department has asked you to sign an acceptable use policy (AUP) regarding computer and network use. The document includes a privacy clause. Which of the following are specifications you can expect to find in this clause? (Choose all that apply.)",
    "choice_a": "Any emails you send or receive can be monitored by the company at any time.",
    "choice_b": "All files and data that you store on company computers must be accessible to the company for scanning and monitoring.",
    "choice_c": "All work that you perform for the company becomes the sole property of the company, including copyrights and patents.",
    "choice_d": "All hardware, software, and any proprietary data stored on the company's computers remain the property of the company.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Clauses regarding company property, including the copyrights and patents for the work performed for the company, typically do appear in an AUP but not in the privacy clause. This information would be more likely to appear in an ownership clause. The privacy clause commonly explains that the company has the right to access and monitor anything stored on its computers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      242,
      245,
      259,
      238,
      237
    ],
    "source": "9781394239306"
  },
  {
    "id": 1095,
    "question": "Which of the following is most likely to be the last step in a change management procedure?",
    "choice_a": "Documentation",
    "choice_b": "Notification",
    "choice_c": "Approval",
    "choice_d": "Service request",
    "correct_answer": "A",
    "explanation": "After a change is requested, approved, scheduled, performed, and tracked, everyone involved should be notified, and the entire process should be documented for future reference.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      238,
      237,
      234,
      268,
      255
    ],
    "source": "9781394239306",
    "choice_e": "Scheduling",
    "choice_f": "Process tracking"
  },
  {
    "id": 1096,
    "question": "Which of the following terms would apply to the procedure of adding a user's personal smartphone to the network under a bring your own device (BYOD) policy?",
    "choice_a": "Out-of-band",
    "choice_b": "On-boarding",
    "choice_c": "In-band",
    "choice_d": "Off-boarding",
    "correct_answer": "B",
    "explanation": "The process of adding a user's personal device and allowing it to access the company network is called on-boarding. Removing the personal device from the network would be called off-boarding. <i>In-band</i> and <i>out-of-band</i> are terms defining methods for gaining administrative access to a managed network device.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      244,
      242,
      240,
      237,
      238
    ],
    "source": "9781394239306"
  },
  {
    "id": 1097,
    "question": "Which of the following is not likely to be a procedural element of an IT end-of-life asset disposal policy?",
    "choice_a": "Data deletion",
    "choice_b": "Recycling",
    "choice_c": "Data preservation",
    "choice_d": "Inventory",
    "correct_answer": "C",
    "explanation": "An IT end-of-life (EOL) asset disposal policy typically includes procedures to be performed on assets that have reached the end of their system life cycle and that are ready for final processing. This includes the wiping of all data, the completion of inventory records, and the possible recycling of the assets. The policy assumes that all data requiring preservation has already been preserved before the asset is submitted for disposal. Therefore, data preservation procedures are not needed at this phase.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      240,
      237,
      238,
      250,
      279
    ],
    "source": "9781394239306"
  },
  {
    "id": 1098,
    "question": "While negotiating a new contract with a service provider, you have reached a disagreement over the contracted reliability of the service. The provider is willing to guarantee that the service will be available 99 percent of the time, but you have been told to require 99.9 percent. When you finally reach an agreement, the negotiated language will be included in which of the following documents?",
    "choice_a": "SLA",
    "choice_b": "AUP",
    "choice_c": "NDA",
    "choice_d": "BYOD",
    "correct_answer": "A",
    "explanation": "A service-level agreement (SLA) is a contract between a provider and a subscriber that specifies the percentage of time that the contracted services are available. Acceptable use policies (AUPs) specify whether and how employees can utilize company-owned hardware and software resources. A non-disclosure agreement (NDA) specifies what company information employees are permitted to discuss outside the company. A bring your own device (BYOD) policy specifies the personal electronics that employees are permitted to use on the company network and documents the procedures for connecting and securing them.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      258,
      259,
      242,
      244,
      268
    ],
    "source": "9781394239306"
  },
  {
    "id": 1099,
    "question": "Which of the following elements would you typically not expect to find in a service-level agreement (SLA) between an Internet service provider (ISP) and a subscriber?",
    "choice_a": "A definition of the services to be provided by the ISP",
    "choice_b": "A list of specifications for the equipment to be provided by the ISP",
    "choice_c": "The types and schedule for the technical support to be provided by the ISP",
    "choice_d": "The types of applications that the subscriber will use when accessing the ISP's services",
    "correct_answer": "D",
    "explanation": "An ISP provides subscribers with access to the Internet. The applications that the subscriber uses on the Internet are typically not part of the SLA. An SLA does typically specify exactly what services the ISP will supply, what equipment the ISP will provide, and the technical support services the ISP will furnish as part of the agreement.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      258,
      268,
      238,
      237,
      255
    ],
    "source": "9781394239306"
  },
  {
    "id": 1100,
    "question": "You have just completed negotiating an annual contract with a provider to furnish your company with cloud services. As part of the contract, the provider has agreed to guarantee that the services will be available 99.9 percent of the time, around the clock, seven days per week. If the services are unavailable more than 0.1 percent of the time, your company is due a price adjustment. Which of the following terms describes this clause of the contract?",
    "choice_a": "SLA",
    "choice_b": "MTBF",
    "choice_c": "AUP",
    "choice_d": "MTTR",
    "correct_answer": "A",
    "explanation": "A service-level agreement (SLA) is a contract between a provider and a subscriber that specifies the percentage of time that the contracted services are available. Mean time between failure (MTBF) is a hardware specification that estimates how long a particular component can be expected to function. Acceptable use policies (AUPs) specify whether and how employees can utilize company-owned hardware and software resources. Mean time to repair (MTTR) specifies the average time it will take to repair a specific hardware company when it malfunctions.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      258,
      268,
      242,
      238,
      272
    ],
    "source": "9781394239306"
  },
  {
    "id": 1101,
    "question": "The technical support clause of a service-level agreement (SLA) typically includes which of the following elements? (Choose all that apply.)",
    "choice_a": "Whether the provider will provide onsite, telephone, or online support",
    "choice_b": "The time service for responses to support calls, which specifies how quickly the provider must respond to requests for support",
    "choice_c": "The percentage of time that the service is guaranteed to be available",
    "choice_d": "The amount of support that will be provided and the cost of additional support",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "The technical support clause of an SLA typically defines the type of support that the provider will furnish, the time service for support, and the amount of support that is included in the contract, as well as the cost for additional support. An SLA will typically guarantee service ability in the form of a percentage, but this refers to problems at the provider's end and is not a customer technical support matter.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      258,
      268,
      238,
      237,
      272
    ],
    "source": "9781394239306"
  },
  {
    "id": 1102,
    "question": "Which of the following is the criterion most commonly used to filter files for backup jobs?",
    "choice_a": "Filename",
    "choice_b": "File extension",
    "choice_c": "File attributes",
    "choice_d": "File size",
    "correct_answer": "C",
    "explanation": "The archive bit that backup software uses to perform incremental and differential jobs is a file attribute, so this is the most commonly used filter type. It is possible to filter files based on their names, their extensions, and their size, but these are not used as often as the archive file attribute.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      279,
      278,
      277,
      246,
      238
    ],
    "source": "9781394239306"
  },
  {
    "id": 1103,
    "question": "Which of the following backup job types does not reset the archive bits of the files it backs up?",
    "choice_a": "Full",
    "choice_b": "Incremental",
    "choice_c": "Differential",
    "choice_d": "Supplemental",
    "correct_answer": "C",
    "explanation": "Differential backups use the archive bit to determine which target files to back up. However, a differential backup does not reset the archive bit. Full backups do not pay attention to the archive bit, because they back up all of the files. A full backup, however, does clear the archive bit after the job is completed. Incremental backups also use the archive bit to determine which files have changed since the previous backup job. The primary difference between an incremental and a differential job, however, is that incremental backups clear the archive bit so that unchanged files are not backed up. There is no such thing as a supplemental backup job.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      279,
      278,
      277,
      268,
      238
    ],
    "source": "9781394239306"
  },
  {
    "id": 1104,
    "question": "What are the three elements in the grandfather-father-son media rotation system for network backups?",
    "choice_a": "Hard disk drives, optical drives, and magnetic tape drives",
    "choice_b": "Incremental, differential, and full backup jobs",
    "choice_c": "Monthly, weekly, and daily backup jobs",
    "choice_d": "QIC, DAT, and DLT tape drives",
    "correct_answer": "C",
    "explanation": "The generational media rotation system uses the terms <i>grandfather</i>, <i>father</i>, and <i>son</i> to refer to backup jobs that are run monthly, weekly, and daily. The jobs can be full, incremental, or differential, and the terms have nothing to do with whether the backup medium is a hard disk, optical, or any type of tape drive.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      277,
      278,
      268,
      272,
      238
    ],
    "source": "9781394239306"
  },
  {
    "id": 1105,
    "question": "Which of the following is a tool that integrates DHCP and DNS so that each is aware of the changes made by the other?",
    "choice_a": "HOSTS",
    "choice_b": "DHCPv6",
    "choice_c": "IPAM",
    "choice_d": "APIPA",
    "correct_answer": "C",
    "explanation": "IP address management (IPAM) is a system for planning, managing, and monitoring the IP address space for an entire enterprise network. IPAM provides links between the Dynamic Host Configuration Protocol (DHCP) and the Domain Name System (DNS) so that each is aware of the naming and addressing changes made by the other. DHCPv6 is an IPv6 version of the DHCP service, which enables it to allocate IPv6 addresses to network clients. HOSTS is a text-based name resolution method for individual systems that predates DNS. Automatic Private IP Addressing (APIPA) is the mechanism that enables a DHCP client to assign itself an address when no DHCP servers are accessible.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      60,
      58,
      98,
      59
    ],
    "source": "9781394239306"
  },
  {
    "id": 1106,
    "question": "Which of the following storage techniques prevents version skew from occurring during a system backup?",
    "choice_a": "Incrementals",
    "choice_b": "Differentials",
    "choice_c": "Iterations",
    "choice_d": "Snapshots",
    "correct_answer": "D",
    "explanation": "Version skew can occur when a data set changes while a system backup is running. A file written to a directory that has already been backed up will not appear on the backup media, even though the job might still be running. This can result in unprotected files or, worse, data corruption. A snapshot is a read-only copy of a data set taken at a specific moment in time. By creating a snapshot and then backing it up, you can be sure that no data corruption has occurred due to version skew. Incrementals and differentials are types of backup jobs, and iteration is not a specific storage technology.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      279,
      278,
      277,
      272,
      266
    ],
    "source": "9781394239306"
  },
  {
    "id": 1107,
    "question": "How do tape libraries and autoloaders increase the overall storage capacity of a backup solution?",
    "choice_a": "By compressing data before it is stored on the medium",
    "choice_b": "By automatically inserting media into and removing it from a drive",
    "choice_c": "By running a tape drive at half its normal speed",
    "choice_d": "By writing two tracks at once onto a magnetic tape",
    "correct_answer": "B",
    "explanation": "Tape libraries and autoloaders are robotic devices containing one or more removable media drives, such as magnetic tape or optical disk drives. The robotic mechanism inserts and removes media cartridges automatically so that a single backup job can span multiple cartridges without human intervention, increasing the overall capacity of the backup solution.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      278,
      277,
      266,
      272,
      268
    ],
    "source": "9781394239306"
  },
  {
    "id": 1108,
    "question": "Which of the following types of patches are most typically applied to a hardware device?",
    "choice_a": "Firmware updates",
    "choice_b": "Driver updates",
    "choice_c": "Feature changes",
    "choice_d": "Vulnerability patches",
    "correct_answer": "A",
    "explanation": "Firmware is a type of software permanently written to the memory built into a hardware device. A firmware update overrides the read-only nature of this memory to update the software. Driver updates, feature updates, and vulnerability patches are typically applied to software products, such as applications and operating systems.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      246,
      251,
      240,
      238,
      220
    ],
    "source": "9781394239306"
  },
  {
    "id": 1109,
    "question": "Which of the following software releases is a fix designed to address one specific issue?",
    "choice_a": "A patch",
    "choice_b": "An update",
    "choice_c": "An upgrade",
    "choice_d": "A driver",
    "correct_answer": "A",
    "explanation": "A patch is a relatively small update that is designed to address a specific issue, often a security exploit or vulnerability. Patches do not add features or new capabilities; they are fixes that target a specific area of the software. Updates and upgrades are larger packages that might include new features and/or many different fixes. Drivers are the software products that enable an operating system to communicate with hardware devices.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      246,
      240,
      277,
      268,
      255
    ],
    "source": "9781394239306"
  },
  {
    "id": 1110,
    "question": "Unlike individual users, who usually have their operating system patches downloaded and installed automatically, corporate IT departments typically evaluate new patches before deploying them. Which of the following is not a common step in this evaluation process?",
    "choice_a": "Testing",
    "choice_b": "Researching",
    "choice_c": "Rolling back",
    "choice_d": "Backing up",
    "correct_answer": "C",
    "explanation": "Rolling back, the process of uninstalling a patch to revert to the previous version of the software, is not part of the patch evaluation process. The evaluation process for new patches in a corporate environment usually consists of a research stage, in which you examine the need and purpose for the patch; a testing stage, in which you install the patch on a lab machine; and a backup of the production systems to which you will apply the patch.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      238,
      246,
      268,
      277,
      255
    ],
    "source": "9781394239306"
  },
  {
    "id": 1111,
    "question": "Which of the following terms refers to the process of uninstalling a recently released patch to resume using the previous version?",
    "choice_a": "Backslide",
    "choice_b": "Downgrade",
    "choice_c": "Reset",
    "choice_d": "Rollback",
    "correct_answer": "D",
    "explanation": "<i>Rollback</i> is a term used in change management to describe the process of reversing a change that has been made, to restore the original configuration. In the case of patch management, a rollback is the process of uninstalling a recently installed software update. The terms <i>backslide</i>, <i>downgrade</i>, and <i>reset</i> are not used for this procedure. End-of-life is a phase marking the end of a device's marketing, sales, and upgrades. However, the manufacturer might still offer security patches for the product. End-of support (EOS) marks the point at which the manufacturer discontinues all support for the product.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      238,
      246,
      240,
      268,
      237
    ],
    "source": "9781394239306",
    "choice_e": "End-of-life",
    "choice_f": "End-of-support"
  },
  {
    "id": 1112,
    "question": "A new shipment of bare metal workstations has just arrived, and Alice is responsible for preparing them for deployment on the company network. She first installs the Windows operating system on one computer to build a test configuration. Then, she installs some specialized drivers for the hardware in the computers and the Microsoft 365 productivity applications. After configuring the software and performing an extensive round of testing, Alice is satisfied with the performance of the workstation. She plans to install the operating system, drivers, and office software on all of the workstations, but there are other software products that she will have to install later for users in specific departments. Which of the following are appropriate terms for this basic installation? (Choose two.)",
    "choice_a": "Production configuration",
    "choice_b": "Sandbox configuration",
    "choice_c": "Golden configuration",
    "choice_d": "Baseline configuration",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The golden or baseline configuration is one that administrators will apply to all workstations. In Alice's case, this is not a production configuration because there are other software products to be added later. A sandbox configuration is used for testing purposes only.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      235,
      255,
      238,
      240,
      237
    ],
    "source": "9781394239306"
  },
  {
    "id": 1113,
    "question": "An IT department receives a shipment of 20 new computers, and Alice has been assigned the task of preparing them for deployment to end users. The first thing she does is affix a metal tag with a bar code on it to each computer. Which of the following terms best describes the function of this procedure?",
    "choice_a": "Asset tracking",
    "choice_b": "Tamper detection",
    "choice_c": "Device hardening",
    "choice_d": "Port security",
    "correct_answer": "A",
    "explanation": "Bar coding the new computers enables the IT department to record their locations, status, and conditions throughout their life cycle, a process known as asset tracking. Bar codes are not used for tamper detection and device hardening. Port security refers to switches, not computers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      240,
      238,
      224,
      255,
      256
    ],
    "source": "9781394239306"
  },
  {
    "id": 1114,
    "question": "Ralph's company has purchased new computers to replace some of the older workstations currently in use. Ralph has been assigned the task of preparing the old computers for disposal. They will be sold to a local secondhand dealer. In order for the dealer to accept the computers, they must have a functional operating system. Company policy also dictates that the computers be permanently wiped of all applications and data before disposal. Which of the following tasks will Ralph have to perform before the computers are sold? (Choose all that apply.)",
    "choice_a": "Reinstall the operating system.",
    "choice_b": "Uninstall all applications.",
    "choice_c": "Delete all data files.",
    "choice_d": "Run a disk wipe utility.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Deleting files on a hard disk drive leaves them available for retrieval, even though they appear to be gone. A disk wipe utility deletes all of the files on the hard drive and then overwrites the entire disk with zeroes, rendering all files unretrievable. Ralph can then reinstall the operating system to prepare the computer for sale. Performing these two steps eliminates the need to uninstall applications, delete data files manually, or perform a factory reset.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      240,
      242,
      244,
      238,
      237
    ],
    "source": "9781394239306",
    "choice_e": "Perform a factory reset."
  },
  {
    "id": 1115,
    "question": "After starting work as the network administrator of Wingtip Toys, you discover that all of the switches in the company's datacenter have support for remote management, with built-in Simple Network Management Protocol (SNMP) agents in each port. Which of the following tasks must you perform to be able to gather information from the agents on those switches and display it on a central console? (Choose all that apply.)",
    "choice_a": "Install the network management software on a network computer.",
    "choice_b": "Install a management information base (MIB) on each of the switches.",
    "choice_c": "Install an agent on the console computer.",
    "choice_d": "Install an MIB on the console computer.",
    "correct_answer": [
      "A",
      "E"
    ],
    "explanation": "An SNMP-based network management system consists of three components: a management console software product installed on a network computer, agents installed on the devices you want to manage, and MIBs for each of the agents. Because the switches support SNMP management and already have agents, they have MIBs also. Therefore, all you have to do is purchase the network management software and install the console on a network computer.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      226,
      229,
      227,
      225,
      235
    ],
    "source": "9781394239306",
    "choice_e": "Purchase a network management product.",
    "choice_f": "Configure SNMP with authentication credentials."
  },
  {
    "id": 1116,
    "question": "Which of the following technologies provides both real-time monitoring of security events and automated analysis of the event information gathered?",
    "choice_a": "SIEM",
    "choice_b": "SNMP",
    "choice_c": "SEM",
    "choice_d": "SIM",
    "correct_answer": "A",
    "explanation": "Security information and event management (SIEM) is a product that combines two technologies: security event management (SEM) and security information management (SIM). Together, the two provide a combined solution for gathering and analyzing information about a network's security events. Simple Network Management Protocol (SNMP) is a technology that gathers information about managed devices.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      236,
      228,
      232,
      231,
      225
    ],
    "source": "9781394239306"
  },
  {
    "id": 1117,
    "question": "Which versions of the Simple Network Management Protocol (SNMP) use unencrypted community strings as their security protection? (Choose all that apply.)",
    "choice_a": "SNMPv1",
    "choice_b": "SNMPv2",
    "choice_c": "SNMPv2c",
    "choice_d": "SNMPv3",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "SNMP version 1 (SNMPv1), SNMP version 2 (SNMPv2), and SNMP version 2c (SNMPv2c) all rely on unencrypted community strings that are sent with GET requests as a security mechanism. SNMP version 3 (SNMPv3), the one most often seen today, uses fully encrypted transmissions for more advanced security and does not use a community string.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      228,
      227,
      225,
      236,
      232
    ],
    "source": "9781394239306"
  },
  {
    "id": 1118,
    "question": "Which of the following statements about the Simple Network Management Protocol (SNMP) are not true? (Choose all that apply.)",
    "choice_a": "To effectively monitor a network using SNMP, you must be sure that all of the equipment you purchase when designing and building your network supports the protocol.",
    "choice_b": "SNMP is not only the name of a protocol; it is also the name of a network management product.",
    "choice_c": "SNMPv1 and the original SNMPv2 rely on a community string as their only means of security.",
    "choice_d": "Most of the network management products on the market today support SNMPv3.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "SNMP is not the name of a network management product; it is just the name of the protocol that provides a framework for the interaction of the various components in a network management product. SNMPv1 uses a community string, but the original SNMPv2 did not, as it had a newer security system that was not widely adopted. The interim version SNMPv2c retains the community string from version 1 in place of the new version 2 security system. When you see a network interface adapter, switch, router, access point, or other device that purports to be managed or that claims to have network management capabilities, this usually means that the device includes an SNMP agent. Most of today's network management products do support SNMPv3. In addition, many network management products that implement SNMPv3 also include support for the earlier, unprotected versions, such as SNMPv1 and SNMPv2c. SNMPv3 does not perform IP address availability monitoring.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      228,
      226,
      227,
      229,
      225
    ],
    "source": "9781394239306",
    "choice_e": "SNMPv3 is capable of scanning network segments to monitor the availability of their IP addresses."
  },
  {
    "id": 1119,
    "question": "What type of network monitoring utility is shown in the accompanying figure? <img src=\"/question_assets/Network+/c03uf003.png\"/>",
    "choice_a": "Protocol analyzer",
    "choice_b": "System monitor",
    "choice_c": "Performance monitor",
    "choice_d": "Log viewer",
    "correct_answer": "A",
    "explanation": "The utility shown in the figure is Wireshark, a packet capture and protocol analyzer application. The top pane contains a list of captured packets, and the bottom two panes display the parsed contents of the selected packet. System monitors, performance monitors, and log viewers do not display the parsed contents of individual packets.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      230,
      223,
      231,
      227,
      226
    ],
    "source": "9781394239306"
  },
  {
    "id": 1120,
    "question": "Which of the following was created to provide logging services for the Unix sendmail program?",
    "choice_a": "Syslog",
    "choice_b": "Netstat",
    "choice_c": "SNMP",
    "choice_d": "CARP",
    "correct_answer": "A",
    "explanation": "Syslog is a standard that was designed to facilitate the transmission of log entries generated by a device or process, such as the sendmail Simple Mail Transfer Protocol (SMTP) server, across an Internet Protocol (IP) network to a message collector, called a syslog server. Since its inception, syslog has come to support message logging on other platforms, including operating systems, printers, and routers. Netstat is a program that displays status information about a system's network connections; it does not provide logging services. SNMP is a protocol that carries network management information from agents to a central console; it was not created specifically for sendmail. The Cache Array Routing Protocol (CARP) enables proxy servers to exchange information; it does not provide logging services.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      232,
      233,
      236,
      226,
      228
    ],
    "source": "9781394239306"
  },
  {
    "id": 1121,
    "question": "You are the administrator of your company's network. Your company wants to perform a baseline analysis of network-related traffic and statistics. They want to track broadcasts, cyclical redundancy check (CRC) errors, and collisions for all traffic traversing a switched network. In addition, they want to generate alerts and cell phone notifications when anomalies occur and provide historical and daily reports for management. They also want to keep track of software distribution and metering. What type of network software product best meets these needs?",
    "choice_a": "SNMP management",
    "choice_b": "Protocol analyzer",
    "choice_c": "Performance monitor",
    "choice_d": "Network traffic monitor",
    "correct_answer": "A",
    "explanation": "The best solution is to implement Simple Network Management Protocol (SNMP). This includes a management console, agents, and management information bases (MIBs). SNMP allows you to generate alerts, track statistical network information (historical and current), and produce reports for baseline analysis and troubleshooting. Some SNMP products also allow you to track software distribution and metering. Protocol analyzers are best used for troubleshooting problems in real time and are not used for software distribution and metering. A performance monitor is a tool that allows you to track performance statistics for one system at a time and does not include software distribution and metering. There is no such product as a network traffic monitor.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      226,
      227,
      223,
      235,
      229
    ],
    "source": "9781394239306"
  },
  {
    "id": 1122,
    "question": "SIEM products combine the capabilities of which of the following? (Choose all that apply.)",
    "choice_a": "Syslog",
    "choice_b": "SNMP",
    "choice_c": "SEM",
    "choice_d": "SIM",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Security information and event management (SIEM) is a product type that combines two technologies: security event management (SEM) and security information management (SIM). Together, the two provide a combined solution for gathering and analyzing information about a network's security events. Simple Network Management Protocol (SNMP) is a technology that gathers information about managed devices. Syslog is a standard designed to facilitate the transmission of log entries generated by a device or process, such as the sendmail Simple Mail Transfer Protocol (SMTP) server, across an Internet Protocol (IP) network to a message collector, called a syslog server. Neither SNMP nor syslog capabilities is typically included in SIEM products.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      236,
      228,
      232,
      231,
      233
    ],
    "source": "9781394239306"
  },
  {
    "id": 1123,
    "question": "Which of the following statements about web server logs is not true?",
    "choice_a": "To analyze web server activity, you typically use an application that interprets the web server log files.",
    "choice_b": "Web server logs are typically maintained as text files.",
    "choice_c": "Web server logs record the IP addresses of all visiting users.",
    "choice_d": "To interpret web server logs, you use a protocol analyzer.",
    "correct_answer": "D",
    "explanation": "A protocol analyzer provides information about network traffic; it does not interpret web server logs. Most web servers maintain logs that track the Internet Protocol (IP) addresses and other information about all hits and visits. The logs are stored as text files and contain a great deal of information, but in their raw form, they are difficult to interpret. Therefore, it is common practice to use a traffic analysis application that reads the log files and displays their contents in a more user-friendly form, such as tables and graphs.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      225,
      230,
      236,
      231,
      256
    ],
    "source": "9781394239306"
  },
  {
    "id": 1124,
    "question": "Which of the following statements best describes a performance baseline?",
    "choice_a": "A baseline is an estimation of expected performance levels, based on manufacturers' specifications.",
    "choice_b": "A baseline is a record of performance levels captured under actual workload conditions.",
    "choice_c": "A baseline is a record of performance levels captured under simulated workload conditions.",
    "choice_d": "A baseline is a record of performance levels captured before the system is actually in use.",
    "correct_answer": "B",
    "explanation": "A baseline is a record of a system's performance under real-world operating conditions, captured for later comparison as conditions change. The workload during a baseline capture should be genuine, not simulated or estimated.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      235,
      255,
      223,
      221,
      225
    ],
    "source": "9781394239306"
  },
  {
    "id": 1125,
    "question": "When monitoring performance metrics on one of your servers, you notice that the server is utilizing 100 percent of the network bandwidth available to it. What modification could you make to the server that will most likely address the problem?",
    "choice_a": "Add memory to the system.",
    "choice_b": "Install a second network adapter.",
    "choice_c": "Update the network adapter's firmware.",
    "choice_d": "Install a second processor.",
    "correct_answer": "B",
    "explanation": "If a server is using all of its network bandwidth, then the most logical solution is to add more. You can do this by installing a second network adapter and connecting it to a different subnet. The other solutions could conceivably address the problem, but their success is less likely.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      221,
      255,
      260,
      223,
      235
    ],
    "source": "9781394239306"
  },
  {
    "id": 1126,
    "question": "Which of the following indicators is typically not included in an operating system's performance monitoring tool, such as the Windows Performance Monitor or the MacOS Activity Monitor?",
    "choice_a": "Temperature",
    "choice_b": "CPU/processor activity",
    "choice_c": "Memory consumption",
    "choice_d": "Network utilization",
    "correct_answer": "A",
    "explanation": "Performance monitoring utilities typically provide statistics on the central processing unit (CPU), memory, network, and disk usage, but not computer temperature monitoring.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      219,
      220,
      221,
      218,
      223
    ],
    "source": "9781394239306",
    "choice_e": "Storage statistics"
  },
  {
    "id": 1127,
    "question": "Which of the following syslog message severity levels indicates that a system is unusable?",
    "choice_a": "0",
    "choice_b": "1",
    "choice_c": "2",
    "choice_d": "3",
    "correct_answer": "A",
    "explanation": "Every syslog message includes a single-digit severity code. Code 0 is the most severe, indicating an emergency that has rendered the system unusable. Severity code 1 is an alert message, indicating that immediate action is needed. Severity code 2 is a critical condition message, and code 3 is an error condition. Code 4 is a warning message.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      233,
      226,
      223,
      229,
      231
    ],
    "source": "9781394239306",
    "choice_e": "4"
  },
  {
    "id": 1128,
    "question": "Which of the following syslog message severity levels indicates a call for immediate action?",
    "choice_a": "0",
    "choice_b": "1",
    "choice_c": "2",
    "choice_d": "3",
    "correct_answer": "B",
    "explanation": "Every syslog message includes a single-digit severity code. Severity code 1 is an alert message, indicating that immediate action is needed. Code 0 is the most severe, indicating an emergency that has rendered the system unusable. Severity code 2 is a critical condition message, and code 3 is an error condition. Code 4 is a warning message.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      233,
      232,
      234,
      226,
      229
    ],
    "source": "9781394239306",
    "choice_e": "4"
  },
  {
    "id": 1129,
    "question": "Which of the following syslog message severity levels indicates that the message is purely informational?",
    "choice_a": "0",
    "choice_b": "2",
    "choice_c": "4",
    "choice_d": "6",
    "correct_answer": "D",
    "explanation": "Every syslog message includes a single-digit severity code. Code 6 indicates that the message is purely informational. Code 0 is the most severe, indicating an emergency that has rendered the system unusable. Severity code 2 is a critical condition message, and code 4 is a warning message. Code 7 is used strictly for debugging.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      233,
      232,
      226,
      229,
      220
    ],
    "source": "9781394239306",
    "choice_e": "7"
  },
  {
    "id": 1130,
    "question": "A Simple Network Management Protocol (SNMP) console can inform administrators when a managed device requires attention. For this to occur, the agent in the device first has to send a message to the console. What is the term used for a message sent by an SNMP agent to the central console?",
    "choice_a": "Alert",
    "choice_b": "Notification",
    "choice_c": "Ping",
    "choice_d": "Trap",
    "correct_answer": "D",
    "explanation": "Messages that SNMP agents send to consoles when an event needing attention occurs are called traps. <i>Alerts</i> and <i>notifications</i> are terms for the messages that the console sends to administrators. A ping is an Internet Control Message Protocol (ICMP) echo request message sent from one TCP/IP computer to another. A flow describes the transaction between network devices, but it is not an SNMP feature.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      227,
      226,
      228,
      230,
      229
    ],
    "source": "9781394239306",
    "choice_e": "Flow"
  },
  {
    "id": 1131,
    "question": "Which of the following metrics would you typically not find displayed by an interface monitor?",
    "choice_a": "Error rate",
    "choice_b": "Bandwidth utilization",
    "choice_c": "Packet drops",
    "choice_d": "Rollbacks",
    "correct_answer": "D",
    "explanation": "The term <i>rollback</i> refers to the process of uninstalling or downgrading an update patch; it has nothing to do with monitoring a network interface. An interface monitor does typically display the number of transmission errors that occur on an interface, the amount of the available bandwidth that the interface is using, and the number of packets that have been dropped due to errors or discards.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      221,
      226,
      227,
      255,
      223
    ],
    "source": "9781394239306"
  },
  {
    "id": 1132,
    "question": "Which of the following are reasons contributing to the number of packet drops displayed by an interface monitor? (Choose all that apply.)",
    "choice_a": "Resets",
    "choice_b": "Discards",
    "choice_c": "Errors",
    "choice_d": "Overflows",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The packet drops displayed by an interface monitor are caused by errors, such as malformed or unreadable packets, or discards, which are packets that are dropped because they are destined for another interface. Resets and overflows are not reasons for packet drops.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      221,
      226,
      232,
      223,
      255
    ],
    "source": "9781394239306"
  },
  {
    "id": 1133,
    "question": "Which of the following is not a statistic that you would typically find in a server performance baseline?",
    "choice_a": "CPU utilization",
    "choice_b": "Disk transfer rate",
    "choice_c": "Network transmissions speed",
    "choice_d": "OS update history",
    "correct_answer": "D",
    "explanation": "Performance baselines characterize hardware performance, so the OS update history would be of little or no use for future comparisons. A baseline typically consists of CPU, memory, disk, and network performance statistics.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      223,
      219,
      220,
      221,
      235
    ],
    "source": "9781394239306",
    "choice_e": "Memory utilization"
  },
  {
    "id": 1134,
    "question": "Log management typically consists of which of the following tasks? (Choose all that apply.)",
    "choice_a": "Rollback",
    "choice_b": "Utilization",
    "choice_c": "Security",
    "choice_d": "Cycling",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Logs frequently contain sensitive information, so securing them with the appropriate permissions is an essential part of log management. Logs also can grow to overwhelm the storage medium on which they are stored, so cycling is a technique for managing log size by configuring it to delete the oldest record each time a new one is added. Rollback and utilization are not log management tasks.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      234,
      232,
      236,
      233,
      238
    ],
    "source": "9781394239306"
  },
  {
    "id": 1135,
    "question": "Which of the following security information and event management (SIEM) processes performs searches for specific criteria, during specific time frames, in logs located on different computers?",
    "choice_a": "Data aggregation",
    "choice_b": "Forensic analysis",
    "choice_c": "Correlation",
    "choice_d": "Retention",
    "correct_answer": "B",
    "explanation": "In SIEM, forensic analysis is a process of searching logs on multiple computers for specific information based on set criteria and time periods. Data aggregation is a process of consolidating log information from multiple sources. Correlation is the process of linking logged events with common attributes together. Retention is the long-term storage of log data.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      236,
      232,
      231,
      233,
      234
    ],
    "source": "9781394239306"
  },
  {
    "id": 1136,
    "question": "Which of the following terms best describes the security information and event management (SIEM) process of consolidating log information from multiple sources?",
    "choice_a": "Data aggregation",
    "choice_b": "Forensic analysis",
    "choice_c": "Correlation",
    "choice_d": "Retention",
    "correct_answer": "A",
    "explanation": "In SIEM, data aggregation is a process of consolidating log information from multiple sources. Forensic analysis is a process of searching logs on multiple computers for specific information based on set criteria and time periods. Correlation is the process of linking logged events with common attributes together. Retention is the long-term storage of log data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      236,
      232,
      231,
      233,
      238
    ],
    "source": "9781394239306"
  },
  {
    "id": 1137,
    "question": "Which of the following Windows applications would you most likely use to create a baseline of system or network performance?",
    "choice_a": "Performance Monitor",
    "choice_b": "Event Viewer",
    "choice_c": "Syslog",
    "choice_d": "Network Monitor",
    "correct_answer": "A",
    "explanation": "Performance Monitor is a Windows application that can create logs of specific system and network performance statistics over extended periods. Such a log created on a new computer can function as a baseline for future troubleshooting. Event Viewer is a Windows application for displaying system log files; it cannot create a performance baseline. Syslog is a log compilation program originally created for Unix systems; it does not create performance baselines. Network Monitor is a protocol analyzer. Although it can capture a traffic sample that can function as a reference for future troubleshooting efforts, this capability cannot be called a performance baseline.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      223,
      235,
      219,
      220,
      221
    ],
    "source": "9781394239306"
  },
  {
    "id": 1138,
    "question": "Which of the following is the database used by the Simple Network Management Protocol (SNMP) to store information gathered from agents distributed about the network?",
    "choice_a": "Trap",
    "choice_b": "Syslog",
    "choice_c": "MIB",
    "choice_d": "SIEM",
    "correct_answer": "C",
    "explanation": "A management information base (MIB) is the database on an SNMP console where all of the information gathered from the network is stored. A trap is an alert message that SNMP agents send to the network management console. Syslog is a standard for message logging components. Security information and event management (SIEM) is a combination tool that uses information gathered from logs and network devices to provide a real-time analysis of the network's security condition.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      226,
      229,
      227,
      228,
      225
    ],
    "source": "9781394239306"
  },
  {
    "id": 1139,
    "question": "Which of the following are not SNMP components?",
    "choice_a": "MIBs",
    "choice_b": "Traps",
    "choice_c": "OIDs",
    "choice_d": "CRCs",
    "correct_answer": "D",
    "explanation": "Cyclical redundancy checks (CRCs) are faults that occur when data does not arrive at its destination in the same state as when it was sent; they are not Simple Network Management Protocol (SNMP) components. Management information bases (MIBs), traps, and object identifiers (OIDs) are all components of a Simple Network Management Protocol (SNMP) implementation. API integration, such as that using the Representational State Transfer (REST) architecture, can enable clients on the network to access SNMP information through simple web-based requests, rather than giving them direct access to the SNMP back end.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      226,
      227,
      228,
      215,
      230
    ],
    "source": "9781394239306",
    "choice_e": "API integrations"
  },
  {
    "id": 1140,
    "question": "Ralph's company recently switched from a standard telephone system to a Voice over Internet Protocol (VoIP) system. Since then, users have been complaining of service interruptions and problems hearing callers at certain times of the day. After analyzing a network traffic audit and assessment report, Ralph determines that traffic levels on the Internet connection are substantially higher during the first and last hours of the day, the same times when most of the users have experienced problems. Which of the following solutions can provide more reliable VoIP service during peak usage times?",
    "choice_a": "Implement traffic shaping.",
    "choice_b": "Implement load balancing.",
    "choice_c": "Upgrade the local area network (LAN) from Fast Ethernet to Gigabit Ethernet.",
    "choice_d": "Replace the router connecting the LAN to the Internet with a model that supports Simple Network Management Protocol (SNMP).",
    "correct_answer": "A",
    "explanation": "Ralph's traffic analysis led him to the conclusion that traffic shaping, a technique for prioritizing packets by buffering those that are not time sensitive for later transmission, will improve the VoIP performance. Ralph can use this technique to give VoIP packets priority over other types of traffic. Load balancing can conceivably improve the performance of a server, but it cannot help to relieve traffic congestion on the Internet link. The traffic congestion is on the Internet connection, not the LAN, so upgrading to Gigabit Ethernet will not help. SNMP is a protocol used by network management products; it will not relieve the traffic congestion problem.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      260,
      225,
      222,
      255,
      226
    ],
    "source": "9781394239306"
  },
  {
    "id": 1141,
    "question": "Which of the following abbreviations describes a product that combines real-time monitoring of security events and automated analysis of the event information gathered?",
    "choice_a": "SIEM",
    "choice_b": "SNMP",
    "choice_c": "SEIM",
    "choice_d": "SEM/SIM",
    "correct_answer": "A",
    "explanation": "Security information and event management (SIEM) is a product that combines two technologies: security event management (SEM) and security information management (SIM). Together, the two provide a combined solution for gathering and analyzing information about a network's security events. Simple Network Management Protocol (SNMP) is a technology that gathers information about managed devices. SEIM and SEM/SIM are not correct abbreviations for security information and event management.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      236,
      228,
      232,
      231,
      225
    ],
    "source": "9781394239306"
  },
  {
    "id": 1142,
    "question": "Which of the following troubleshooting tools enables you to capture all of the packets transmitted in network traffic to a buffer, analyze the protocols used in the packets, and display the output?",
    "choice_a": "Event Viewer",
    "choice_b": "Performance monitor",
    "choice_c": "Protocol analyzer",
    "choice_d": "Management console",
    "correct_answer": "C",
    "explanation": "A protocol analyzer captures all network traffic, interprets the protocol headers and fields, and displays the output. The Event Viewer displays system, application, and security event logs on a single computer. Performance monitor tracks the values of specific metrics, but it does not capture packets. A management console is a remote monitoring and management device that queries Simple Network Management Protocol (SNMP) agents.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      230,
      223,
      225,
      236,
      226
    ],
    "source": "9781394239306"
  },
  {
    "id": 1143,
    "question": "Which of the following switch features enables administrators to capture traffic generated by the computers connected to the switch?",
    "choice_a": "Port mirroring",
    "choice_b": "Stateful packet inspection",
    "choice_c": "Trunking",
    "choice_d": "Service-dependent filtering",
    "correct_answer": "A",
    "explanation": "Port mirroring is a feature found in some switches that takes the form of a special port that runs in promiscuous mode. This means that the switch copies all incoming traffic to that port, as well as to the dedicated destination ports. By connecting a protocol analyzer to this port, an administrator can access all of the network's traffic. Stateful packet inspection is a firewall feature that enables the device to examine Network and Transport layer header fields, looking for patterns that indicate damaging behaviors, such as IP spoofing, SYN floods, and teardrop attacks. Trunking is a switch feature that enables administrators to create VLANs that span multiple switches. Service-dependent filtering is a firewall feature that blocks traffic based on Transport layer port numbers.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      230,
      226,
      225,
      55,
      229
    ],
    "source": "9781394239306"
  },
  {
    "id": 1144,
    "question": "Which of the following best describes the function of an administrative network monitoring tool that can perform an ad hoc network discovery?",
    "choice_a": "The administrator starts the tool, and it scans the local subnet, displaying a list of the MAC addresses associated with it.",
    "choice_b": "The administrator specifies an IP address, and the tool scans all of the well-known port numbers at that address for active services.",
    "choice_c": "The administrator enters a range of IP addresses, and the tool attempts to perform a traceroute test for each one.",
    "choice_d": "The administrator enters a range of IP addresses, and the tool scans each address to determine if a device is using it.",
    "correct_answer": "D",
    "explanation": "An ad hoc network discovery is a one-time scan of a range of IP addresses to determine whether they are in use. The tool does not scan the port numbers for each address, list the MAC addresses, or perform traceroute tests. While scheduled network discoveries are possible, the term <i>ad hoc</i> refers to a one-time, on-demand procedure.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      224,
      225,
      255,
      221,
      234
    ],
    "source": "9781394239306",
    "choice_e": "The administrator creates a network discovery schedule and identifies the network address of the subnet to be scanned."
  },
  {
    "id": 1145,
    "question": "Which of the following is the primary aim of an organization's security incident response policies?",
    "choice_a": "To know how to respond to a particular incident",
    "choice_b": "To prevent an incident from occurring again",
    "choice_c": "To identify the cause of an incident",
    "choice_d": "To document the procedures leading up to an incident",
    "correct_answer": "B",
    "explanation": "While incident response policies might include the process of responding to an incident and identifying and documenting its cause, the primary function of incident response policies is to ensure that the same incident does not happen again.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      239,
      237,
      238,
      242,
      280
    ],
    "source": "9781394239306"
  },
  {
    "id": 1146,
    "question": "Which of the following tasks is not considered to be part of an IT department's incident response plan?",
    "choice_a": "Performing tabletop exercises to prepare for an incident",
    "choice_b": "Stopping an ongoing incident",
    "choice_c": "Containing the damage caused by an incident",
    "choice_d": "Remediating the damage caused by an incident",
    "correct_answer": [
      "A",
      "E"
    ],
    "explanation": "Tabletop exercises and validation tests can be a useful part of an incident preparedness plan, but they are not part of the incident response. Once a network infrastructure has been partially or completely destroyed, rebuilding it is no longer a matter of incident response; the responsibility passes over to the disaster recovery plan, which requires a different set of policies. Stopping, containing, and remediating an incident are all considered incident response policies.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      239,
      280,
      272,
      238,
      277
    ],
    "source": "9781394239306",
    "choice_e": "Rebuilding an infrastructure destroyed by an incident",
    "choice_f": "Performing validation tests"
  },
  {
    "id": 1147,
    "question": "Which of the following are occurrences that are typically addressed by an IT department's incident response policies? (Choose all that apply.)",
    "choice_a": "Denial-of-service (DoS) attack",
    "choice_b": "Hard disk failure",
    "choice_c": "Electrical fire",
    "choice_d": "Server outage",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "Attacks, hardware failures, and crashes are all events that can be addressed by incident response policies that define what is to be done to analyze and remediate the problem. An electrical fire typically would not be addressed by an IT department's incident response team; it is a job for trained firefighters. Once the fire is out, the company's response falls under the heading of disaster recovery.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      239,
      237,
      238,
      272,
      271
    ],
    "source": "9781394239306"
  },
  {
    "id": 1148,
    "question": "Which of the following Redundant Array of Independent Disks (RAID) levels provides fault tolerance by storing parity information on the disks, in addition to the data?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 5",
    "choice_d": "RAID 10",
    "correct_answer": "C",
    "explanation": "RAID is a technology for storing data on multiple hard disk drives, providing fault tolerance, increased performance, or both. The various RAID levels provide different levels of functionality and have different hardware requirements. RAID 5 combines disk striping with distributed storage of parity information, which provides fault tolerance. The parity information enables the array to rebuild a disk whose data has been lost. RAID 0 uses data striping only (blocks written to each disk in turn), which does not provide any form of fault tolerance. RAID 1 provides fault tolerance through disk mirroring. RAID 10 creates fault-tolerant mirrored stripe sets.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      266,
      267,
      268,
      265,
      269
    ],
    "source": "9781394239306"
  },
  {
    "id": 1149,
    "question": "Installing an electrical generator for your datacenter is an example of which of the following fault tolerance concepts?",
    "choice_a": "Uninterruptible power supply (UPS)",
    "choice_b": "Power redundancy",
    "choice_c": "Dual power supplies",
    "choice_d": "Redundant circuits",
    "correct_answer": "B",
    "explanation": "<i>Power redundancy</i> is a general term describing any fault tolerance mechanism that enables equipment to continue functioning when one source of power fails. A UPS is a device that uses battery power, not a generator. The term <i>dual power supplies</i> refers to the power supply units inside a computer, not a separate generator. The term <i>redundant circuits</i> refers to multiple connections to the building's main power, not to a generator.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      270,
      266,
      267,
      260,
      272
    ],
    "source": "9781394239306"
  },
  {
    "id": 1150,
    "question": "Which of the following RAID levels uses disk striping with distributed parity?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 5",
    "choice_d": "RAID 10",
    "correct_answer": "C",
    "explanation": "Redundant Array of Independent Disks (RAID) is a technology for storing data on multiple hard disk drives, providing fault tolerance, increased performance, or both. The various RAID levels provide different levels of functionality and have different hardware requirements. RAID 5 combines disk striping (blocks written to each disk in turn) with distributed storage of parity information, for fault tolerance. RAID 0 provides data striping only. RAID 1 provides disk mirroring. RAID 10 creates mirrored stripe sets.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      266,
      267,
      276,
      270,
      271
    ],
    "source": "9781394239306"
  },
  {
    "id": 1151,
    "question": "Which of the following is not a fault tolerance mechanism?",
    "choice_a": "Port aggregation",
    "choice_b": "Clustering",
    "choice_c": "MTBF",
    "choice_d": "UPS",
    "correct_answer": "C",
    "explanation": "Mean time between failure (MTBF) is a hardware specification used to predict the approximate lifetime of a component; it does not refer to any type of fault tolerance mechanism. Port aggregation, clustering, and uninterruptible power supplies (UPSs) are all mechanisms that provide fault tolerance in the event of network adapter, server, and power failures, respectively.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      268,
      269,
      267,
      266,
      276
    ],
    "source": "9781394239306"
  },
  {
    "id": 1152,
    "question": "Which of the following is not a type of server load balancing mechanism?",
    "choice_a": "Round-robin DNS",
    "choice_b": "Network address translation",
    "choice_c": "Content switching",
    "choice_d": "Multilayer switching",
    "correct_answer": "B",
    "explanation": "Load balancing is a method of distributing incoming traffic among multiple servers. Network address translation (NAT) is a routing mechanism that enables computers on a private network to share one or more public Internet Protocol (IP) addresses; it is not a load balancing method. Domain Name System (DNS) round-robin, multilayer switching, and content switching are all mechanisms that enable a server cluster to share client traffic.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      260,
      265,
      276,
      225,
      258
    ],
    "source": "9781394239306"
  },
  {
    "id": 1153,
    "question": "Which of the following is an element of high availability systems that enables them to automatically detect problems and react to them?",
    "choice_a": "Backups",
    "choice_b": "Snapshots",
    "choice_c": "Failover",
    "choice_d": "Cold sites",
    "correct_answer": "C",
    "explanation": "Highly available systems often have redundant failover components that enable them to continue operating even after a failure of a router, switch, hard disk, server, or other component. Backups, snapshots, and cold sites can all contribute to a system's high availability, but they do not function automatically.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      276,
      267,
      265,
      260,
      269
    ],
    "source": "9781394239306"
  },
  {
    "id": 1154,
    "question": "Which of the following RAID levels does not provide fault tolerance?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 5",
    "choice_d": "RAID 10",
    "correct_answer": "A",
    "explanation": "Redundant Array of Independent Disks (RAID) is a technology for storing data on multiple hard disk drives, providing fault tolerance, increased performance, or both. The various RAID levels provide different levels of functionality and have different hardware requirements. RAID 0 uses data striping only (blocks written to each disk in turn), which does not provide any form of fault tolerance. RAID 1 provides disk mirroring; RAID 5 combines disk striping with distributed storage of parity information; and RAID 10 creates mirrored stripe sets\u2014these three levels all provide fault tolerance.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      266,
      267,
      276,
      272,
      270
    ],
    "source": "9781394239306"
  },
  {
    "id": 1155,
    "question": "Which of the following disaster recovery mechanisms can be made operational in the least amount of time?",
    "choice_a": "A cold site",
    "choice_b": "A warm site",
    "choice_c": "A hot site",
    "choice_d": "All of the options are the same.",
    "correct_answer": "C",
    "explanation": "Cold, warm, and hot backup sites differ in the hardware and software they have installed. A cold site is just a space at a remote location. The hardware and software must be procured and installed before the network can be restored; therefore, it is the least expensive and takes the most time. A warm site has hardware in place that must be installed and configured. A hot site has all of the necessary hardware already installed, configured, and ready to go in the event of a disaster. A warm site is more expensive than a cold site, and a hot site is the most expensive and takes the least amount of time to be made operational.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      272,
      239,
      278,
      276,
      268
    ],
    "source": "9781394239306"
  },
  {
    "id": 1156,
    "question": "Which of the following datacenter disaster recovery mechanisms is the least expensive to implement?",
    "choice_a": "A cold site",
    "choice_b": "A warm site",
    "choice_c": "A hot site",
    "choice_d": "A cloud site",
    "correct_answer": "D",
    "explanation": "A cloud site is the least expensive to implement. Cold, warm, and hot backup sites differ in the hardware and software they have installed, but they all require the maintenance of a facility for a new datacenter. A cold site is just a space at a remote location. The hardware and software must be procured and installed before the network can be restored. It is the least expensive of the cold, warm, and hot options and takes the most time. A warm site has hardware in place that must be installed and configured. A hot site has all of the necessary hardware already installed, configured, and ready to go in the event of a disaster. A warm site is more expensive than a cold site, and a hot site is the most expensive and takes the least amount of time to be made operational. A cloud site is a virtual facility maintained with a cloud service provider. The cloud site does not require physical space or physical hardware, so it is the least expensive.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      272,
      239,
      278,
      268,
      269
    ],
    "source": "9781394239306"
  },
  {
    "id": 1157,
    "question": "Which of the following terms defines how long it will take to restore a server from backups if a complete system failure occurs?",
    "choice_a": "RPO",
    "choice_b": "RTO",
    "choice_c": "BCP",
    "choice_d": "MIB",
    "correct_answer": "B",
    "explanation": "The recovery time objective (RTO) specifies the amount of time needed to restore a server from the most recent backup if it should fail. This time interval depends on the amount of data involved and the speed of the backup medium. A recovery point objective (RPO) specifies how much data is likely to be lost if a restore from backups should be necessary. This figure is based on the frequency of the backups and the amount of new data generated by the system. <i>Business contingency planning</i> (BCP) is an umbrella term for procedures enacted to keep the organization functioning in the event of a disaster. A management information base (MIB) is a database used by Simple Network Management Protocol (SNMP) systems.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      278,
      272,
      268,
      277,
      238
    ],
    "source": "9781394239306"
  },
  {
    "id": 1158,
    "question": "In a disaster recovery scenario, which of the following terms applies to devices that are not repairable?",
    "choice_a": "MTBF",
    "choice_b": "MTTF",
    "choice_c": "MTTR",
    "choice_d": "MDT",
    "correct_answer": "B",
    "explanation": "Mean time to failure (MTTF) refers to devices that will eventually fail once and then be discarded, rather than repaired. Mean time between failure (MTBF), mean time to repair (MTTR), and mean down time (MDT) all refer to devices that will eventually fail and then be repaired and reused.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      268,
      239,
      272,
      240,
      278
    ],
    "source": "9781394239306"
  },
  {
    "id": 1159,
    "question": "If you have a server with dual power supplies, both of which are connected to a single uninterruptible power supply (UPS), with a building power circuit connected to a backup generator, which of the following failures can the server survive and keep running indefinitely? (Choose all that apply.)",
    "choice_a": "Failure of one server power supply",
    "choice_b": "Failure of the UPS",
    "choice_c": "Failure of the building power circuit",
    "choice_d": "Failure of the building backup generator",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "If one of the server's power supplies fails, the other will continue to function. If the building's backup generator fails, the server will continue to run as long as the building still has outside power. If the UPS fails, the server will go down. If the breaker for the building power circuit trips, the server will run only as long as the UPS battery holds out.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      266,
      270,
      269,
      268,
      260
    ],
    "source": "9781394239306"
  },
  {
    "id": 1160,
    "question": "A network load balancing cluster is made up of multiple computers that function as a single entity. Which of the following terms is used to describe an individual computer in a load balancing cluster?",
    "choice_a": "Node",
    "choice_b": "Host",
    "choice_c": "Server",
    "choice_d": "Box",
    "correct_answer": "B",
    "explanation": "In a network load balancing cluster, each computer is referred to as a <i>host</i>. Other types of clusters use other terms. For example, in a failover cluster, each computer is called a <i>node</i>. The terms <i>server</i> and <i>box</i> are not used in clustering.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      260,
      276,
      265,
      266,
      279
    ],
    "source": "9781394239306"
  },
  {
    "id": 1161,
    "question": "Which of the following networking concepts frequently use virtual Internet Protocol (IP) addresses to provide high availability? (Choose all that apply.)",
    "choice_a": "Clustering",
    "choice_b": "Load balancing",
    "choice_c": "Network address translation (NAT)",
    "choice_d": "Network interface card (NIC) teaming",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "A high availability virtual IP address implementation is when multiple servers are identified by a single address, enabling all of the servers to receive incoming client traffic. In the case of server clustering and network load balancing arrangements, the cluster itself has a unique name and IP address, separate from those of the individual servers. Clients address themselves to the cluster, not to one of the servers in the cluster. NAT is not a high availability technology, and NIC teaming does not use virtual IP addresses.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      260,
      267,
      276,
      265,
      269
    ],
    "source": "9781394239306"
  },
  {
    "id": 1162,
    "question": "Which of the following disaster recovery mechanisms is the least expensive to implement?",
    "choice_a": "A cold site",
    "choice_b": "A warm site",
    "choice_c": "A hot site",
    "choice_d": "All of the options cost the same.",
    "correct_answer": "A",
    "explanation": "Cold, warm, and hot backup sites differ in the hardware and software they have installed. A cold site is just a space at a remote location. The hardware and software must be procured and installed before the network can be restored. It is the least expensive. A warm site has hardware in place that must be installed and configured. A hot site has all of the necessary hardware installed and configured. A warm site is more expensive than a cold site, and a hot site is the most expensive.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      272,
      239,
      278,
      268,
      269
    ],
    "source": "9781394239306"
  },
  {
    "id": 1163,
    "question": "Which of the following can be provided by clustering servers?",
    "choice_a": "Fault tolerance",
    "choice_b": "Load balancing",
    "choice_c": "Failover",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "A cluster is a group of computers configured with the same application that function as a single unit. The cluster can function as a fault tolerance mechanism by failing over from one server to the next, when necessary, or provide load balancing by distributing traffic among the servers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      267,
      276,
      265,
      266,
      268
    ],
    "source": "9781394239306"
  },
  {
    "id": 1164,
    "question": "When you configure NIC teaming on a server with two network adapters in an active-passive configuration, which of the following services is provided?",
    "choice_a": "Load balancing",
    "choice_b": "Fault tolerance",
    "choice_c": "Server clustering",
    "choice_d": "Traffic shaping",
    "correct_answer": "B",
    "explanation": "NIC teaming enables you to combine the functionality of two network interface cards (NICs) in one connection. However, when you configure a NIC team to use an active-passive configuration, one of the network adapters remains idle and functions as a fault tolerance mechanism. If the other NIC should fail, the passive NIC becomes active. In this configuration, NIC teaming does not provide load balancing, server clustering, or traffic shaping.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      276,
      260,
      267,
      258,
      225
    ],
    "source": "9781394239306"
  },
  {
    "id": 1165,
    "question": "Which of the following is not a load balancing mechanism?",
    "choice_a": "NIC teaming",
    "choice_b": "Server clustering",
    "choice_c": "Round-robin DNS",
    "choice_d": "RAID 1",
    "correct_answer": "D",
    "explanation": "Redundant Array of Independent Disks (RAID) level 1 is a fault tolerance mechanism that is also known as disk mirroring. A storage subsystem writes data to two or more disks at the same time so that if a disk fails, the data remains available. Because data is written to the disks at the same time, this RAID level does not provide load balancing. NIC teaming balances a network traffic load among two or more network interface cards (NICs), whereas server clustering and Domain Name System (DNS) round-robin balance a traffic load among multiple servers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      260,
      267,
      266,
      276,
      225
    ],
    "source": "9781394239306"
  },
  {
    "id": 1166,
    "question": "Which of the following best describes the difference between cold, warm, and hot backup sites?",
    "choice_a": "Whether the backup site is owned, borrowed, or rented",
    "choice_b": "The age of the most recent backup stored at the site",
    "choice_c": "The cost of the hardware used at the site",
    "choice_d": "The time needed to get the site up and running",
    "correct_answer": "D",
    "explanation": "Cold, warm, and hot backup sites are disaster recovery mechanisms that enable a network to be activated at a remote location when a catastrophe occurs. The temperature refers to a site\u2019s readiness to assume the role of the network. A cold site is just a space at a remote location. The hardware and software must be procured and installed before the network can be restored. A warm site has hardware in place that must be installed and configured. It takes less time to restore the network than at a cold site, but more than at a hot site. A hot site has all of the necessary hardware installed and configured. The network can go live as soon as the most recent data is restored.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      272,
      268,
      278,
      279,
      269
    ],
    "source": "9781394239306"
  },
  {
    "id": 1167,
    "question": "Which of the following specifications would you most want to examine when comparing hard disk models for your new Redundant Array of Independent Disks (RAID) array?",
    "choice_a": "MTBF",
    "choice_b": "SLA",
    "choice_c": "AUP",
    "choice_d": "MTTR",
    "correct_answer": "A",
    "explanation": "Mean time between failure (MTBF) specifies how long you can expect a device to run before it malfunctions. For a hard disk, this specification indicates the life expectancy of the device. Service-level agreements (SLAs) and acceptable use policies (AUPs) are not specifications associated with hard disk drives. Mean time to repair (MTTR) can conceivably be specified for a hard disk, but hard disk drives in a RAID array are typically replaced, not repaired.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      268,
      240,
      278,
      269,
      277
    ],
    "source": "9781394239306"
  },
  {
    "id": 1168,
    "question": "Which of the following RAID levels provides fault tolerance with the smallest amount of usable disk space?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 5",
    "choice_d": "RAID 10",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Redundant Array of Independent Disks (RAID) is a technology for storing data on multiple hard disk drives, providing fault tolerance, increased performance, or both. The various RAID levels provide different levels of functionality and have different hardware requirements. RAID 1 provides disk mirroring, and RAID 10 creates mirrored stripe sets. Both provide fault tolerance by maintaining two copies of every stored file, for a usable disk space percentage of 50 percent. Some mirroring configurations store more than two copies of each file, for even less usable space. RAID 0 provides data striping only, with no fault tolerance. RAID 5 combines disk striping (blocks written to each disk in turn) with distributed storage of parity information, for fault tolerance with a usable disk space percentage of at least 66 percent.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      266,
      267,
      269,
      270,
      271
    ],
    "source": "9781394239306"
  },
  {
    "id": 1169,
    "question": "Disk mirroring and disk duplexing are both fault tolerance mechanisms for hard disk data storage. Which of the following statements about disk mirroring and disk duplexing is true?",
    "choice_a": "Disk mirroring enables a server to survive the failure of a disk drive.",
    "choice_b": "Disk duplexing enables a server to survive the failure of a disk controller.",
    "choice_c": "Disk mirroring enables a server to survive the failure of a disk drive or a disk controller.",
    "choice_d": "Disk duplexing enables a server to survive the failure of a disk drive or a disk controller.",
    "correct_answer": "D",
    "explanation": "Disk mirroring and disk duplexing both use multiple hard disk drives to store duplicate copies of all data. However, disk duplexing calls for each disk to be connected to a separate controller so that the data remains available if there is a disk failure or a disk controller failure.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      266,
      267,
      260,
      268,
      272
    ],
    "source": "9781394239306"
  },
  {
    "id": 1170,
    "question": "You are installing a new Windows server with two hard disk drives in it, and you want to use RAID to create a fault-tolerant storage system. Which of the following RAID levels can you configure the server to use?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 5",
    "choice_d": "RAID 10",
    "correct_answer": "B",
    "explanation": "Redundant Array of Independent Disks (RAID) is a technology for storing data on multiple hard disk drives, providing fault tolerance, increased performance, or both. The various RAID levels provide different levels of functionality and have different hardware requirements. RAID 1 provides disk mirroring for fault tolerance and requires two or more disk drives. RAID 0 provides data striping only, with no fault tolerance. RAID 5 combines disk striping (blocks written to each disk in turn) with distributed storage of parity information for fault tolerance, but it requires a minimum of three disk drives. RAID 10 creates mirrored stripe sets and requires at least four disk drives.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      266,
      267,
      260,
      265,
      268
    ],
    "source": "9781394239306"
  },
  {
    "id": 1171,
    "question": "Which of the following RAID levels provide fault tolerance without using parity data? (Choose all that apply.)",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 5",
    "choice_d": "RAID 10",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Redundant Array of Independent Disks (RAID) is a technology for storing data on multiple hard disk drives, providing fault tolerance, increased performance, or both. The various RAID levels provide different levels of functionality and have different hardware requirements. RAID 1 and RAID 10 both use disk mirroring to provide fault tolerance, which does not require parity data. RAID 0 uses data striping only (blocks written to each disk in turn), which does not provide any form of fault tolerance. RAID 5 combines disk striping with distributed storage of parity information.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      266,
      267,
      269,
      270,
      271
    ],
    "source": "9781394239306"
  },
  {
    "id": 1172,
    "question": "If you back up your network by performing a full backup every Wednesday at 6:00 p.m. and incremental backups in the evening on the other days of the week, how many jobs would be needed to completely restore a computer with a hard drive that failed on a Monday at noon?",
    "choice_a": "One",
    "choice_b": "Two",
    "choice_c": "Five",
    "choice_d": "Six",
    "correct_answer": "C",
    "explanation": "An incremental backup is a job that backs up all of the files that have changed since the last backup of any kind. Therefore, to restore a system that failed on Monday at noon, you would have to restore the most recent full backup from the previous Wednesday and the incrementals from Thursday, Friday, Saturday, and Sunday.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      277,
      278,
      279,
      268,
      272
    ],
    "source": "9781394239306"
  },
  {
    "id": 1173,
    "question": "For a complete restore of a computer that failed at noon on Tuesday, how many jobs would be needed if you performed full backups to tape at 6:00 a.m. every Wednesday and Saturday and incremental backups to tape at 6:00 a.m. every other day?",
    "choice_a": "One",
    "choice_b": "Two",
    "choice_c": "Three",
    "choice_d": "Four",
    "correct_answer": "D",
    "explanation": "An incremental backup is a job that backs up all of the files that have changed since the last backup of any kind. Therefore, to restore a system that failed on Tuesday at noon, you would have to restore the most recent full backup from the previous Saturday and the incrementals from Sunday, Monday, and Tuesday morning.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      278,
      277,
      272,
      268,
      251
    ],
    "source": "9781394239306"
  },
  {
    "id": 1174,
    "question": "If you back up your network by performing a full backup every Wednesday at 6:00 p.m. and differential backups in the evening on the other six days of the week, how many jobs would be needed to completely restore a computer with a hard drive that failed on a Tuesday at noon?",
    "choice_a": "One",
    "choice_b": "Two",
    "choice_c": "Six",
    "choice_d": "Seven",
    "correct_answer": "B",
    "explanation": "A differential backup is a job that backs up all the files that have changed since the last full backup. Therefore, to restore a system that failed on Tuesday at noon, you would have to restore the most recent full backup from the previous Wednesday and the most recent differential from Monday.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      278,
      279,
      268,
      272,
      238
    ],
    "source": "9781394239306"
  },
  {
    "id": 1175,
    "question": "Why does performing incremental backups to a hard drive, rather than a tape drive, make it possible to restore a server with a single job, rather than multiple jobs?",
    "choice_a": "Because hard drives hold more data than tape drives.",
    "choice_b": "Because hard drives can transfer data faster than tape drives.",
    "choice_c": "Because hard drives are random access devices and tape drives are not.",
    "choice_d": "Because hard drives use a different block size than tape drives.",
    "correct_answer": "C",
    "explanation": "Data is stored on tape drives in a linear fashion. Once you write backup data to a tape, you cannot selectively replace individual files. When you perform a restore job, you might have to restore the most recent full backup, followed by incremental backups, which overwrites some of the full backup files with newer ones. Hard disk drives are random access devices, meaning that individual files can be written to and read from any location on the disk. When you perform incremental backup jobs to a hard disk, the software can restore data using any version of each file that is available. Data capacity, transfer speed, and block size are not relevant.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      278,
      277,
      268,
      258,
      260
    ],
    "source": "9781394239306"
  },
  {
    "id": 1176,
    "question": "Which of the following is not a fault tolerance mechanism?",
    "choice_a": "UPS",
    "choice_b": "RAID 1",
    "choice_c": "SNMP",
    "choice_d": "Clustering",
    "correct_answer": "C",
    "explanation": "Simple Network Monitoring Protocol (SNMP) is a means of tracking the performance and functionality of network components. Software or firmware components called agents are embedded in network devices and communicate with a central monitoring console. SNMP does not provide fault tolerance. An uninterruptible power supply (UPS) is a battery backup device that enables a computer to continue functioning in the event of a power failure. Redundant Array of Independent Disks (RAID) level 1 is a disk mirroring mechanism that provides fault tolerance by maintaining duplicate copies of all stored data. Clustering is a mechanism by which multiple servers function as a single unit, running the same application, so that if a server should fail, the others continue to function.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      226,
      267,
      269,
      276,
      260
    ],
    "source": "9781394239306"
  },
  {
    "id": 1177,
    "question": "Which of the following is a term for a read-only copy of a data set made at a specific moment in time?",
    "choice_a": "Snapshot",
    "choice_b": "Incremental",
    "choice_c": "Hot site",
    "choice_d": "Differential",
    "correct_answer": "A",
    "explanation": "A snapshot is a read-only copy of a data set taken at a specific moment in time. By creating a snapshot and then backing it up, you can be sure that no data corruption has occurred due to version skew. A hot site is an alternative network location in which all hardware and software is installed and ready. Incrementals and differentials are types of backup jobs.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      278,
      277,
      279,
      276,
      271
    ],
    "source": "9781394239306"
  },
  {
    "id": 1178,
    "question": "Which of the following statements about backing up a firewall's state and backing up its configuration are true? (Choose all that apply.)",
    "choice_a": "A backup of a firewall's state contains more data than a backup of its configuration.",
    "choice_b": "A backup of a firewall's configuration contains more data than a backup of its state.",
    "choice_c": "A backup of a firewall's state contains the exact same data as a backup of its configuration.",
    "choice_d": "A backup of a firewall's state includes its configuration.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "A backup of a firewall's state includes its configuration as well as other elements, such as templates and policies. The state therefore contains more data than the configuration.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      279,
      278,
      238,
      255,
      251
    ],
    "source": "9781394239306",
    "choice_e": "A backup of a firewall's configuration includes its state."
  },
  {
    "id": 1179,
    "question": "Redundant servers running in an active-active configuration provide which of the following advantages that the same servers in an active-passive configuration do not? (Choose all that apply.)",
    "choice_a": "Increased performance",
    "choice_b": "Fault tolerance",
    "choice_c": "Data encapsulation",
    "choice_d": "Load balancing",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "In an active-active configuration, servers can balance the incoming client load between them. Because the active servers are all servicing clients, the overall performance of the cluster is increased. Both active-active and active-passive configurations provide fault tolerance. Data encapsulation is not a factor in either configuration.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      276,
      265,
      260,
      268,
      258
    ],
    "source": "9781394239306"
  },
  {
    "id": 1180,
    "question": "To build a network with redundant Internet connections that ensures full fault tolerance, it is necessary to use which of the following?",
    "choice_a": "Different ISPs",
    "choice_b": "Different WAN connections",
    "choice_c": "Different routers",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "Access to the Internet can be interrupted by a failure on the Internet service provider's (ISP's) network, by a failure on the wide area network (WAN) provider's network, or by a router failure on the local network. Building redundancy into all of these elements is the best way to ensure continuous access to the Internet.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      276,
      260,
      268,
      272,
      208
    ],
    "source": "9781394239306"
  },
  {
    "id": 1181,
    "question": "Installing redundant firewalls in a parallel configuration, as shown in the accompanying graphic, provides which of the following benefits? (Choose all that apply.) <img src=\"/question_assets/Network+/c03uf004.png\"/>",
    "choice_a": "Load balancing",
    "choice_b": "Fault tolerance",
    "choice_c": "Added security",
    "choice_d": "Enhanced performance",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "Configuring the router to split incoming packets between the two firewalls provides load balancing and a resulting performance increase. If one firewall should fail, the parallel arrangement enables the other one to take over the processing of all incoming packets, providing fault tolerance. Two firewalls in parallel do not provide additional security.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      276,
      265,
      260,
      55,
      258
    ],
    "source": "9781394239306"
  },
  {
    "id": 1182,
    "question": "In which of the following DNS transactions does the querying system generate a recursive query? (Choose two.)",
    "choice_a": "A DNS client sends the server name www.adatum.com from a URL to its designated DNS server for resolution.",
    "choice_b": "A client's DNS server sends a request to a root domain server to find the authoritative server for the com top-level domain.",
    "choice_c": "A client's DNS server sends a request to the com top-level domain server to find the authoritative server for the adatum.com domain.",
    "choice_d": "A client's DNS server, which has been configured to function as a forwarder, sends the server name www.adatum.com from a URL to its ISP's DNS server for resolution.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "When a client sends a name resolution query to its DNS server, it uses a recursive request so that the server will take on the responsibility for resolving the name. The only other use of recursive requests is in the case of a forwarder, which is configured to pass that responsibility on to another server. All of the other queries issued by the client's server to the various domain authorities are iterative queries.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      58,
      60,
      59,
      56,
      98
    ],
    "source": "9781394239306",
    "choice_e": "A client's DNS server sends a request to the adatum.com domain server to find the IP address associated with the server name www."
  },
  {
    "id": 1183,
    "question": "Which of the following devices would you most likely configure to function as a Dynamic Host Configuration Protocol (DHCP) server?",
    "choice_a": "A wireless router",
    "choice_b": "An unmanaged switch",
    "choice_c": "A hub",
    "choice_d": "A bridge",
    "correct_answer": "A",
    "explanation": "Most wireless routers are designed to provide connecting workstations with IP addresses and other TCP/IP configuration parameters. Switches and bridges are Data link layer devices, and hubs are Physical layer devices, none of which are capable of providing clients with Network layer IP addresses.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      56,
      98,
      226,
      227,
      224
    ],
    "source": "9781394239306"
  },
  {
    "id": 1184,
    "question": "Which of the following protocols are responsible for assigning IP addresses to hosts? (Choose two.)",
    "choice_a": "Dynamic Host Configuration Protocol (DHCP)",
    "choice_b": "Address Resolution Protocol (ARP)",
    "choice_c": "Domain Name System (DNS)",
    "choice_d": "File Transfer Protocol (FTP)",
    "correct_answer": [
      "A",
      "E"
    ],
    "explanation": "DHCP and BOOTP are both designed to allocate IP addresses to hosts. The primary difference between the two is that DHCP is capable of dynamic allocation and BOOTP is not. DNS resolves hostnames into IP addresses, and ARP resolves IP addresses into Data link layer hardware (or MAC) addresses. FTP is designed to transfer files between systems and has no role in IP address allocation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      98,
      58,
      60,
      226
    ],
    "source": "9781394239306",
    "choice_e": "Bootstrap Protocol (BOOTP)"
  },
  {
    "id": 1185,
    "question": "Which of the following Domain Name System (DNS) resource records is used only for reverse name resolution?",
    "choice_a": "MX",
    "choice_b": "CNAME",
    "choice_c": "AAAA",
    "choice_d": "PTR",
    "correct_answer": "D",
    "explanation": "Like A and AAAA records, pointer records (PTRs) contain hostnames and IP addresses, but they are used for reverse name resolution\u2014that is, resolving IP addresses into hostnames. A mail exchange (MX) record specifies the mail server that the domain should use. Canonical name (CNAME) records specify aliases for a given hostname. An AAAA resource record maps a hostname to an IPv6 address for name resolution purposes.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      58,
      59,
      98,
      94,
      95
    ],
    "source": "9781394239306"
  },
  {
    "id": 1186,
    "question": "Which of the following features is supported by DHCP, but not by BOOTP and RARP?",
    "choice_a": "Dynamic address allocation",
    "choice_b": "Relay agents",
    "choice_c": "Manual address allocation",
    "choice_d": "Automatic address allocation",
    "correct_answer": "A",
    "explanation": "Dynamic Host Configuration Protocol (DHCP) can dynamically allocate IP addresses to clients and reclaim them when their leases expire. Bootstrap Protocol (BOOTP) and Reverse Address Resolution Protocol (RARP) can allocate addresses automatically or manually, but they cannot reclaim them. DHCP and BOOTP both support relay agents.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      98,
      60,
      58,
      61
    ],
    "source": "9781394239306"
  },
  {
    "id": 1187,
    "question": "Which of the following message types are exchanged by Dynamic Host Configuration Protocol (DHCP) clients and servers during a successful IP address allocation transaction? (Choose all that apply.)",
    "choice_a": "DHCPDISCOVER",
    "choice_b": "DHCPOFFER",
    "choice_c": "DHCPINFORM",
    "choice_d": "DHCPACK",
    "correct_answer": [
      "A",
      "B",
      "D",
      "E"
    ],
    "explanation": "In a successful DHCP address allocation, the client issues DHCPDISCOVER broadcasts to locate servers, and the servers reply with DHCPOFFER messages containing addresses. Then, the client sends a DHCPREQUEST message to one server accepting an offered address, to which the server replies with a DHCPACK. DHCPNAK messages are only used in unsuccessful transactions, and DHCPRENEW, DHCPRELEASE, and DHCPINFORM messages are not used during the address allocation process.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      61,
      60,
      98,
      226
    ],
    "source": "9781394239306",
    "choice_e": "DHCPREQUEST",
    "choice_f": "DHCPNAK",
    "choice_g": "DHCPRENEW",
    "choice_h": "DHCPRELEASE"
  },
  {
    "id": 1188,
    "question": "Which of the following message types are exchanged by Dynamic Host Configuration Protocol (DHCP) clients and servers during a successful IP address lease renewal transaction? (Choose all that apply.)",
    "choice_a": "DHCPDISCOVER",
    "choice_b": "DHCPOFFER",
    "choice_c": "DHCPINFORM",
    "choice_d": "DHCPACK",
    "correct_answer": [
      "D",
      "E"
    ],
    "explanation": "In a successful DHCP address renewal transaction, the client issues a DHCPDREQUEST message, and the server replies with a DHCPACK. DHCPNAK messages are only used in unsuccessful transactions, and the other message types are not used during the address renewal process.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      56,
      98,
      60,
      61,
      226
    ],
    "source": "9781394239306",
    "choice_e": "DHCPREQUEST",
    "choice_f": "DHCPNAK",
    "choice_g": "DHCPRENEW",
    "choice_h": "DHCPRELEASE"
  },
  {
    "id": 1189,
    "question": "Which of the following is a protocol used to allocate IP address assignments to clients on a network?",
    "choice_a": "ARP",
    "choice_b": "ICMP",
    "choice_c": "DNS",
    "choice_d": "DHCP",
    "correct_answer": "D",
    "explanation": "Dynamic Host Configuration Protocol (DHCP) is a protocol designed to allocate IP addresses to clients. Address Resolution Protocol (ARP), on the other hand, resolves existing IP addresses into Data link layer MAC (or hardware) addresses. Internet Control Message Protocol (ICMP) is a protocol used to perform Network layer tests and exchange error messages. The Domain Name System (DNS) protocol is used to exchange name resolution traffic.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      98,
      60,
      58,
      61
    ],
    "source": "9781394239306"
  },
  {
    "id": 1190,
    "question": "Which of the following best describes what happens when a DNS server receives an iterative name resolution query?",
    "choice_a": "The DNS server responds immediately to the query with the best information it has in its resource records or in its cache, or failing that, with an error message stating that it could not resolve the requested name.",
    "choice_b": "The DNS server attempts to resolve the requested name by checking its own resource records and cache, or failing that, by issuing its own iterative queries to other DNS servers.",
    "choice_c": "The DNS server attempts to resolve the requested name by checking its own resource records and cache, or failing that, by forwarding the name resolution request to another DNS server in a recursive query.",
    "choice_d": "The DNS server responds immediately if it is the authoritative server for the domain in which the requested name is located. Otherwise, it returns an error message stating that it could not resolve the requested name.",
    "correct_answer": "A",
    "explanation": "When a DNS server receives an iterative query, it responds immediately with the best information that it has available, or with an error message. It does not send queries to other servers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      58,
      60,
      56,
      61,
      98
    ],
    "source": "9781394239306"
  },
  {
    "id": 1191,
    "question": "What is the term used to refer to the DNS client mechanism that generates name resolution queries and sends them to DNS servers?",
    "choice_a": "Requestor",
    "choice_b": "Forwarder",
    "choice_c": "Authority",
    "choice_d": "Resolver",
    "correct_answer": "D",
    "explanation": "The client component of the Domain Name System (DNS) is called the resolver. <i>Requestor</i> is a generic term for any system issuing requests, and only DNS servers can be authorities or forwarders.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      58,
      56,
      226,
      231,
      232
    ],
    "source": "9781394239306"
  },
  {
    "id": 1192,
    "question": "Which of the following TCP/IP parameters, configured on an end system, specifies the IP address of a device that performs name resolution services?",
    "choice_a": "IP Address",
    "choice_b": "Subnet Mask",
    "choice_c": "Default Gateway",
    "choice_d": "Preferred DNS Server",
    "correct_answer": "D",
    "explanation": "The Preferred DNS Server parameter contains the address of a server that resolves domain names into IP addresses. The IP address parameter specifies the address of the current computer, not the address of a server. The Subnet Mask parameter differentiates the network bits of the IP address from the host bits. The Default Gateway parameter defines the local router to be used to access other networks.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      58,
      60,
      56,
      98,
      59
    ],
    "source": "9781394239306"
  },
  {
    "id": 1193,
    "question": "Which IP address allocation method is not supported by Dynamic Host Configuration Protocol (DHCP)?",
    "choice_a": "Manual",
    "choice_b": "Dynamic",
    "choice_c": "Stable",
    "choice_d": "Automatic",
    "correct_answer": "C",
    "explanation": "Stable is not a DHCP allocation method. DHCP supports three allocation methods: manual, dynamic, and automatic.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      98,
      60,
      61,
      95
    ],
    "source": "9781394239306"
  },
  {
    "id": 1194,
    "question": "On a Dynamic Host Configuration Protocol (DHCP) server, what is the name of the element you create to specify which IP addresses the server should assign to clients?",
    "choice_a": "Range",
    "choice_b": "Scope",
    "choice_c": "Pool",
    "choice_d": "Subnet",
    "correct_answer": "B",
    "explanation": "On a DHCP server, you create a scope that consists of a beginning and an ending IP address. <i>Range</i>, <i>pool</i>, and <i>subnet</i> are not technical terms for DHCP.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      98,
      60,
      61,
      224
    ],
    "source": "9781394239306"
  },
  {
    "id": 1195,
    "question": "Why is it necessary to use a relay agent to enable a Dynamic Host Configuration Protocol (DHCP) server to assign IP addresses to clients on other networks? (Choose two.)",
    "choice_a": "Because DHCP requires a separate license for each subnet.",
    "choice_b": "Because clients cannot initiate an address assignment by contacting DHCP servers on other networks directly.",
    "choice_c": "Because DHCP must use the Transmission Control Protocol (TCP) to communicate with clients.",
    "choice_d": "Because the DHCP address assignment process relies on broadcast transmissions.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "DHCP clients cannot contact servers on different networks to initiate an address assignment. Clients locate DHCP servers by transmitting broadcast messages, and broadcasts are limited to the local network. Relay agents forward the broadcast messages to other networks, enabling the server to assign IP addresses to clients on other subnets. DHCP does not require special licenses. DHCP uses User Datagram Protocol (UDP) transmissions, not TCP.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      56,
      98,
      232,
      61,
      58
    ],
    "source": "9781394239306"
  },
  {
    "id": 1196,
    "question": "Which of the following Domain Name System (DNS) resource records is used to resolve a hostname into an IPv6 address?",
    "choice_a": "MX",
    "choice_b": "PTR",
    "choice_c": "AAAA",
    "choice_d": "NS",
    "correct_answer": "C",
    "explanation": "An AAAA resource record maps a hostname to an IPv6 address for name resolution purposes. A mail exchange (MX) record specifies the mail server that the domain should use. Pointer records (PTRs) also contain hostnames and IP addresses, but they are used for reverse name resolution\u2014that is, resolving IP addresses into hostnames. Name server (NS) records identify the authoritative name servers used for the current zone.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      58,
      59,
      95,
      98,
      94
    ],
    "source": "9781394239306"
  },
  {
    "id": 1197,
    "question": "Ralph has configured a server called NE6 to function as a web server. He does not want to change the server's existing name, but he wants it to also be accessible to clients using the name <code>www</code>. What Domain Name System (DNS) modification can Ralph make to accomplish this?",
    "choice_a": "Create an additional A resource record.",
    "choice_b": "Create a new CNAME resource record.",
    "choice_c": "Modify the existing A resource record.",
    "choice_d": "Create a new TXT resource record.",
    "correct_answer": "B",
    "explanation": "A canonical name (CNAME) resource record specifies an alternative host name (or alias) for a system already registered in the DNS. By creating a CNAME record specifying the <code>www</code> name, the server can be addressed using either NE6 or www. Creating an additional A resource record will cause the server to be recognized using one name or the other, but not both. Modifying the existing A record will change the hostname. Text (TXT) records associate administrator-supplied text with a zone but perform no other functions. PTR resource records are used only for reverse name resolution.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      58,
      59,
      56,
      226,
      229
    ],
    "source": "9781394239306",
    "choice_e": "Create a new PTR resource record."
  },
  {
    "id": 1198,
    "question": "Which of the following options should you configure on a Dynamic Host Configuration Protocol (DHCP) server to supply clients with a default gateway address?",
    "choice_a": "Router",
    "choice_b": "Time Server",
    "choice_c": "Name Server",
    "choice_d": "LPR Server",
    "correct_answer": "A",
    "explanation": "The Router option specifies the addresses of routers on the local network, including the default gateway router. The Time Server option specifies the addresses of servers that provide time signals to the network. The Name Server option specifies the addresses of up to 10 name resolution servers (other than DNS servers) on the network. The LPR Server option specifies the addresses of line printer servers on the network. The Lease Time option specifies the length of the default address lease.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      98,
      60,
      58,
      61
    ],
    "source": "9781394239306",
    "choice_e": "Lease Time"
  },
  {
    "id": 1199,
    "question": "Dynamic Host Configuration Protocol (DHCP) clients rely on which of the following types of transmissions to locate and initiate contact with DHCP servers on the local network?",
    "choice_a": "Unicast",
    "choice_b": "Broadcast",
    "choice_c": "Multicast",
    "choice_d": "Anycast",
    "correct_answer": "B",
    "explanation": "DHCP clients use broadcasts to transmit DHCPDISCOVER messages on the local network. DHCP servers are then required to respond to the broadcasts. DHCP clients cannot use unicast, multicast, or anycast messages to initiate contact with DHCP servers, because they have no way of learning their addresses.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      56,
      98,
      226,
      231,
      224
    ],
    "source": "9781394239306"
  },
  {
    "id": 1200,
    "question": "Which of the following Domain Name System (DNS) resource record types specifies the IP addresses of the authoritative DNS servers for a particular zone?",
    "choice_a": "NS",
    "choice_b": "PTR",
    "choice_c": "MX",
    "choice_d": "SRV",
    "correct_answer": "A",
    "explanation": "The name server (NS) resource record identifies the authoritative name servers for a particular DNS zone. Pointer records (PTRs) are used to resolve IP addresses into hostnames. Mail exchange (MX) records identify the mail servers for a particular domain. Service records (SRVs) identify the designated servers for a particular application. The start of authority (SOA) record indicates the delegation of a domain's administrative control from its parent domain. A text (TXT) record associates administrator-supplied text with a zone but performs no other function.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      58,
      59,
      60,
      56,
      98
    ],
    "source": "9781394239306",
    "choice_e": "SOA",
    "choice_f": "TXT"
  },
  {
    "id": 1201,
    "question": "Which of the following must you create on a DHCP server if you want it to always assign the same IP address to a particular computer?",
    "choice_a": "Scope",
    "choice_b": "Exclusion",
    "choice_c": "Reservation",
    "choice_d": "Relay",
    "correct_answer": "C",
    "explanation": "On a DHCP server, a reservation is a permanent IP address assignment to a specific MAC address. A scope is a range of IP addresses to be allocated to clients. An exclusion is a range of IP addresses that is to be excluded from a scope. A relay is a component that routes DHCP traffic between networks.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      56,
      98,
      60,
      226,
      237
    ],
    "source": "9781394239306"
  },
  {
    "id": 1202,
    "question": "Which of the following DHCP address allocation methods enables the server to reclaim IP addresses when they are no longer in use by clients?",
    "choice_a": "Automatic",
    "choice_b": "Dynamic",
    "choice_c": "Manual",
    "choice_d": "Static",
    "correct_answer": "B",
    "explanation": "Dynamic allocation enables a Dynamic Host Configuration Protocol (DHCP) server to lease IP addresses to clients for a specific time interval. When the lease period expires, the client can renew it, if it is still using the address. If the address is no longer in use when the lease expires, it is returned to the scope of available leases for reallocation. Automatic allocation permanently assigns an IP address from the scope to a client. <i>Manual</i> and <i>static allocation</i> are two terms that describe the allocation of a specific IP address to a specific client.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      56,
      98,
      60,
      61,
      58
    ],
    "source": "9781394239306"
  },
  {
    "id": 1203,
    "question": "Which of the following technologies enables the IP addresses assigned to clients by a Dynamic Host Configuration Protocol (DHCP) server to be automatically added to the DNS namespace?",
    "choice_a": "Reverse name resolution",
    "choice_b": "Dynamic DNS",
    "choice_c": "Automatic allocation",
    "choice_d": "HOSTS",
    "correct_answer": "B",
    "explanation": "Dynamic DNS (DDNS) is an addition to the DNS standards that eliminates the need for administrators to manually create certain DNS resource records. For example, when a DHCP server allocates an address to a client, DDNS creates a host (A) record containing the hostname of the client and the newly allocated IP address. Reverse name resolution is the process of looking up hostnames based on IP addresses. Automatic allocation is a DHCP process by which IP addresses are permanently assigned to clients. HOSTS is a text-based name resolution method that predates DNS.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      60,
      56,
      58,
      98,
      94
    ],
    "source": "9781394239306"
  },
  {
    "id": 1204,
    "question": "Which of the following is the term used to describe the logical distance of a Network Time Protocol (NTP) server from the time source to which it is synchronized?",
    "choice_a": "Layer",
    "choice_b": "Path",
    "choice_c": "Iteration",
    "choice_d": "Stratum",
    "correct_answer": "D",
    "explanation": "The term <i>stratum</i>, plus an integer, describes the distance in time of an NTP server from its time source in terms of the NTP server hierarchy. Stratum 0 represents an atomic clock or other precision timekeeping device. Stratum 1 represents an NTP server synchronized to within a few milliseconds of its Stratum 0 time source. Stratum 2 is a server synchronized to a Stratum 1 server, and so on. <i>Layer</i>, <i>path</i>, and <i>iteration</i> are not technical terms used by the NTP.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      61,
      56,
      60,
      226,
      228
    ],
    "source": "9781394239306"
  },
  {
    "id": 1205,
    "question": "Which of the following protocols are used to synchronize computer clocks to a time signal provided by a server? (Choose all that apply.)",
    "choice_a": "NTS",
    "choice_b": "HTTPS",
    "choice_c": "NTP",
    "choice_d": "SMTP",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "The Network Time Protocol (NTP) is used to synchronize computer clocks. Time signals can be provided by internal servers or time servers on the Internet. The Precision Time Protocol (PTP) performs a similar function, except that it can achieve greater accuracy than NTP on a local network. Network Time Security (NTS) is a protocol that provides cryptographic security for NTP transactions. The Hypertext Transfer Protocol Secure (HTTPS) is used to exchange web traffic between clients and servers. The Simple Mail Transfer Protocol (SMTP) is used to transmit email traffic between clients and servers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      61,
      59,
      226,
      232,
      230
    ],
    "source": "9781394239306",
    "choice_e": "PTP"
  },
  {
    "id": 1206,
    "question": "Which of the words in the fully qualified domain name (FQDN) <a href=\"http://www.paris.mydomain.org\"><code>www.paris.mydomain.org</code></a> represents the topmost layer in the DNS namespace hierarchy?",
    "choice_a": "www",
    "choice_b": "paris",
    "choice_c": "mydomain",
    "choice_d": "org",
    "correct_answer": "D",
    "explanation": "The topmost layer in the DNS hierarchy is represented by <code>org</code>, which is a top-level domain. <code>mydomain</code> is a second-level domain registered by a particular organization; <code>paris</code> is a subdomain within <code>mydomain</code>; and <code>www</code> is the name of a particular host in the <code>paris.mydomain.org</code> domain.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      58,
      60,
      98,
      94,
      226
    ],
    "source": "9781394239306"
  },
  {
    "id": 1207,
    "question": "Which of the following Dynamic Host Configuration Protocol (DHCP) options prevents the client from transmitting IP datagrams that circulate endlessly around the network?",
    "choice_a": "Interface MTU",
    "choice_b": "Default IP TTL",
    "choice_c": "ARP Cache Timeout",
    "choice_d": "TCP Keepalive Interval",
    "correct_answer": "B",
    "explanation": "The Default IP Time-to-Live (TTL) option specifies the maximum number of seconds or hops allowed to an IP datagram before a router removes it from the network. This prevents datagrams from circulating endlessly. The Interface Maximum Transmission Unit (MTU) option specifies the maximum size of an IP datagram. The Address Resolution Protocol (ARP) Cache Timeout specifies how long entries containing the IP address assigned by the server can remain in the cache maintained by a client's ARP implementation. The Transmission Control Protocol (TCP) Keepalive Interval option specifies the number of seconds that the client should wait before transmitting a keepalive message over a TCP connection.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      98,
      61,
      58,
      60
    ],
    "source": "9781394239306"
  },
  {
    "id": 1208,
    "question": "In designing a network for a client, Ed has decided to use both internal and external DNS servers. Which of the following resources should Ed register with the external DNS server? (Choose two.)",
    "choice_a": "Company database servers",
    "choice_b": "Internet web servers",
    "choice_c": "Incoming email servers",
    "choice_d": "Domain controllers",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The external DNS server should contain records only for the resources that must be accessible from the Internet, such as web servers and public email servers. For security reasons, servers containing sensitive data, such as database servers and domain controllers, should be registered on the internal DNS server.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      60,
      58,
      59,
      241,
      217
    ],
    "source": "9781394239306"
  },
  {
    "id": 1209,
    "question": "Ralph is concerned that the IP address scope of available leases on his DHCP server is nearly exhausted. What happens to DHCP clients when there are no IP addresses left in the scope for assignment?",
    "choice_a": "Clients are assigned a 0.0.0.0 address.",
    "choice_b": "Clients self-assign APIPA addresses.",
    "choice_c": "Client DHCP requests are forwarded to another DHCP server.",
    "choice_d": "Clients are forced to share IP addresses.",
    "correct_answer": "B",
    "explanation": "When there are no IP addresses available for lease in a DHCP scope, Automatic Private IP Addressing (APIPA) takes over, and the system self-assigns an address on the 169.254.0.0/16 network. Clients are not assigned a 0.0.0.0 address, nor are their requests forwarded to another DHCP server. Sharing IP addresses is not possible on a TCP/IP network.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      98,
      94,
      60,
      255
    ],
    "source": "9781394239306"
  },
  {
    "id": 1210,
    "question": "Alice is the administrator of a subnet for which she has been allotted 100 IP addresses. She has installed a DHCP server with a scope containing all 100 available addresses for lease. There are currently 99 clients configured to use the DHCP server, many of which are mobile devices, and Alice fears that systems frequently leaving and rejoining the network might cause the scope of available leases to be exhausted. Which of the following adjustments can help to prevent this from happening?",
    "choice_a": "Increase the lease time for the scope.",
    "choice_b": "Decrease the lease time for the scope.",
    "choice_c": "Install a second DHCP server.",
    "choice_d": "Create a second scope for the subnet.",
    "correct_answer": "B",
    "explanation": "Decreasing the lease time for the scope will cause abandoned IP addresses to be returned to the scope for reallocation more quickly, which would lessen the chances of exhausting the scope. Increasing the lease time will make scope exhaustion more likely. Installing another DHCP server or creating another scope will have no effect, because the limitation is the number of addresses allocated for the subnet.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      60,
      61,
      255,
      238
    ],
    "source": "9781394239306"
  },
  {
    "id": 1211,
    "question": "DHCP clients use broadcast messages to contact a DHCP server on the local subnet. Which of the following are mechanisms by which DHCP broadcast messages can be forwarded to a DHCP server on another subnet when there is none on the local subnet? (Choose all that apply.)",
    "choice_a": "DHCP relay",
    "choice_b": "UDP forwarding",
    "choice_c": "Zone transfer",
    "choice_d": "IP helper",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "DHCP relay, UDP forwarding, and IP helper are all router mechanisms that perform the same task, forwarding broadcast messages on one subnet to a specific IP address on another subnet as a unicast message. This enables DHCP clients to contact DHCP servers on another subnet to obtain IP addresses. Zone transfer is a DNS zone replication mechanism not used by DHCP clients or servers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      98,
      55,
      237,
      214
    ],
    "source": "9781394239306"
  },
  {
    "id": 1212,
    "question": "Which of the following mechanisms enables administrators to maintain current DNS database information on both primary and secondary name servers, for fault tolerance and load balancing purposes?",
    "choice_a": "Multi-master replication",
    "choice_b": "UDP forwarding",
    "choice_c": "Iterative query",
    "choice_d": "Zone transfer",
    "correct_answer": "D",
    "explanation": "A zone transfer is a client/server transaction between two DNS servers in which one server requests a copy of the other server's entire zone database, to update its own. None of the other options are used for DNS database replication. Multi-master replication is a technique that enables two systems to exchange database information as needed to update each other. UDP forwarding is a router mechanism used by DHCP to forward broadcast messages on one subnet to a specific IP address on another subnet. An iterative query is a type of DNS message that transfers responsibility for a name lookup to another server.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      58,
      60,
      276,
      260,
      266
    ],
    "source": "9781394239306"
  },
  {
    "id": 1213,
    "question": "If an authoritative DNS server has a forward zone for a particular domain but no reverse zone, which of the following tasks will the server be unable to perform?",
    "choice_a": "Resolve a DNS name into an IP address",
    "choice_b": "Resolve an IP address into a DNS name",
    "choice_c": "Respond to recursive queries from other DNS servers",
    "choice_d": "Send queries to the DNS root name servers",
    "correct_answer": "B",
    "explanation": "A forward zone uses a hierarchy based on domain names to allow resolution of DNS names into IP addresses. A reverse zone is based on the <code>in.addr-arpa</code> domain and uses a hierarchy based on the individual decimal values in IP addresses. Without the reverse zone, the server will be unable to resolve IP addresses into DNS names. DNS servers can send and respond to queries without a reverse zone.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      58,
      60,
      61,
      59,
      56
    ],
    "source": "9781394239306"
  },
  {
    "id": 1214,
    "question": "The Domain Name System Security Extensions (DNSSEC) are a series of specifications that add cryptographic security to DNS communications. To make this possible, the DNSSEC specifications add some new DNS resource records. Which of the following are resource records created for use with DNSSEC? (Choose all that apply.)",
    "choice_a": "SRV",
    "choice_b": "RRSIG",
    "choice_c": "NS",
    "choice_d": "DNSKEY",
    "correct_answer": [
      "B",
      "D",
      "E"
    ],
    "explanation": "Resource record signature (RRSIG), DNSKEY, and delegation signer (DS) are all resource records created specifically for use with DNSSEC. The SRV, NS, and RP resource records are defined in the original DNS specifications.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      59,
      58,
      228,
      227,
      226
    ],
    "source": "9781394239306",
    "choice_e": "DS",
    "choice_f": "RP"
  },
  {
    "id": 1215,
    "question": "Which of the following are extensions to the original Domain Name System (DNS) that provide security for the data exchanged in DNS transactions? (Choose all that apply.)",
    "choice_a": "DNS over IPsec",
    "choice_b": "DNS over HTTPS (DoH)",
    "choice_c": "DNS over TLS (DoT)",
    "choice_d": "DNS over STP",
    "correct_answer": [
      "B",
      "C",
      "F"
    ],
    "explanation": "To provide security for DNS data, the DNS over HTTPS (DoH) and DNS over TLS (DoT) specifications enable DNS transactions to use secured protocols to exchange messages. DNSSEC provides cryptographic security directly within the DNS messages. Stateless address autoconfiguration (SLAAC) does not provide security to DNS. DNS over IPsec and DNS over STP do not exist.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      59,
      98,
      94,
      56,
      228
    ],
    "source": "9781394239306",
    "choice_e": "SLAAC",
    "choice_f": "DNSSEC"
  },
  {
    "id": 1216,
    "question": "Systems on an IPv6 network can assign IPv6 addresses to themselves using mechanisms such as DHCPv6 and SLAAC. Which of the following statements about the primary difference between these two mechanisms are true? (Choose all that apply.)",
    "choice_a": "DHCPv6 is stateful.",
    "choice_b": "SLAAC is stateful.",
    "choice_c": "DHCPv6 is stateless.",
    "choice_d": "SLAAC is stateless.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "DHCPv6 is stateful, meaning that the IPv6 address assignment are stored on the DHCPv6 server. Stateless address autoconfiguration (SLAAC), as the name implies, is stateless, meaning that the mechanism does not keep track of the addresses it assigns.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      98,
      94,
      56,
      95,
      238
    ],
    "source": "9781394239306"
  },
  {
    "id": 1217,
    "question": "Which of the following technologies enables virtual private network (VPN) clients to connect directly to each other, as well as to the VPN server at the home site?",
    "choice_a": "VPN concentrator",
    "choice_b": "DMVPN",
    "choice_c": "SIP trunk",
    "choice_d": "MPLS",
    "correct_answer": "B",
    "explanation": "VPN typically enables remote clients to connect to a VPN router at a central site, much like the star/hub and spoke topology of a local area network, in which computers are all connected to a central switch. Dynamic multipoint virtual private network (DMVPN) is a technology that creates a mesh topology between the remote VPN sites, enabling the remote sites to connect directly to each other, rather than to the central VPN server. A virtual private network (VPN) concentrator is a type of router that enables multiple client systems to access a network from remote locations. A Session Initiation Protocol (SIP) trunk provides a connection between the private and public domains of a unified communications network. Multiprotocol Label Switching (MPLS) is a data transfer mechanism that assigns labels to individual packets, and then routes the packets based on those labels. Clientless VPN creates an encrypted tunnel to a server using a browser, without the need to install additional client software.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      209,
      208,
      260,
      211,
      210
    ],
    "source": "9781394239306",
    "choice_e": "Clientless VPN"
  },
  {
    "id": 1218,
    "question": "Which of the following virtual private networking protocols is generally considered to be obsolete?",
    "choice_a": "IPsec",
    "choice_b": "L2TP",
    "choice_c": "PPTP",
    "choice_d": "SSL/TLS",
    "correct_answer": "C",
    "explanation": "Point-to-Point Tunneling Protocol (PPTP) is considered to be obsolete for VPN use because of several serious security vulnerabilities that have been found in it. IPsec, Layer 2 Tunneling Protocol (L2TP), and Secure Sockets Layer/Transport Layer Security (SSL/TLS) are all still in use.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      209,
      208,
      214,
      59,
      210
    ],
    "source": "9781394239306"
  },
  {
    "id": 1219,
    "question": "Which of the following virtual private networking (VPN) protocols does not provide encryption within the tunnel?",
    "choice_a": "PPTP",
    "choice_b": "IPsec",
    "choice_c": "L2TP",
    "choice_d": "SSL",
    "correct_answer": "C",
    "explanation": "Layer 2 Tunneling Protocol (L2TP) is used to create the tunnel forming a VPN connection, but it does not encrypt the traffic passing through the tunnel. To do this, it requires a separate protocol that provides encryption, such as IPsec. Although both are now obsolete, Point-to-Point Tunneling Protocol (PPTP) and Secure Sockets Layer (SSL) are both capable of encrypting tunneled traffic.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      209,
      208,
      211,
      214,
      59
    ],
    "source": "9781394239306"
  },
  {
    "id": 1220,
    "question": "Which of the following elements must be identical in both the client and server computers to establish a remote wide area network (WAN) connection? (Choose all that apply.)",
    "choice_a": "The WAN type",
    "choice_b": "The Data link layer protocol",
    "choice_c": "The authentication method",
    "choice_d": "The operating system",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Although the computers do not have to use hardware made by the same manufacturer, both must use the same basic type of WAN connection, such as a leased line or an Internet connection. Both of the computers must also use the same Data link layer protocol, such as PPP, to establish a remote network connection. Most remote network connections use some form of authentication mechanism, even if it is nothing more than the exchange of a username and cleartext password. To establish the remote network connection, both computers must be configured to use the same type of authentication, even if it is no authentication at all. As long as all of the other elements are in place, such as the Physical layer connection and the protocols, there is no need for both of the computers involved in a remote network connection to be running the same operating system.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      208,
      209,
      210,
      213,
      56
    ],
    "source": "9781394239306"
  },
  {
    "id": 1221,
    "question": "Which of the following is not a protocol that is typically used to secure communication between web servers and web browsers?",
    "choice_a": "SSL",
    "choice_b": "TLS",
    "choice_c": "SSH",
    "choice_d": "DTLS",
    "correct_answer": "C",
    "explanation": "Secure Shell (SSH) is a character-based tool that enables users to execute commands on remote computers. It does not provide web server/browser security. Secure Sockets Layer (SSL) is a security protocol that provides encrypted communications between web browsers and servers. Transport Layer Security (TLS) is an updated security protocol that is designed to replace SSL. Datagram Transport Layer Security (DTLS) is a security protocol that provides the same basic functions as TLS, but for User Datagram Protocol (UDP) traffic.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      214,
      209,
      208,
      210,
      228
    ],
    "source": "9781394239306"
  },
  {
    "id": 1222,
    "question": "Which of the following types of virtual private networking (VPN) connection is the best solution for allowing vendors and partners limited access to your corporate network?",
    "choice_a": "Client-to-site",
    "choice_b": "Site-to-site",
    "choice_c": "Client-to-client",
    "choice_d": "Extranet",
    "correct_answer": "D",
    "explanation": "An extranet VPN is designed to provide clients, vendors, and other outside partners with the ability to connect to your corporate network with limited access. A client-to-site VPN is a remote access solution, enabling users to access the corporate network from home or while traveling. A site-to-site VPN enables a branch office to connect to the home office using the Internet rather than a more expensive wide area network (WAN) connection. A client-to-client VPN enables two individual users to establish a protected connection to each other.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      208,
      209,
      211,
      212,
      210
    ],
    "source": "9781394239306"
  },
  {
    "id": 1223,
    "question": "Which of the following protocols is not used for remote control of computers?",
    "choice_a": "RDP",
    "choice_b": "TFTP",
    "choice_c": "SSH",
    "choice_d": "Telnet",
    "correct_answer": "B",
    "explanation": "Trivial File Transfer Protocol (TFTP) is typically used to download boot image files to computers performing a Preboot Execution Environment (PXE) startup. It is not used for remote control. Remote Desktop Protocol (RDP) is used by Remote Desktop Services in Windows to provide clients with graphical control over servers at remote locations. Secure Shell (SSH) and Telnet are both character-based tools that enable users to execute commands on remote computers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      214,
      210,
      213,
      217,
      232
    ],
    "source": "9781394239306"
  },
  {
    "id": 1224,
    "question": "Which of the following services is provided by the Remote Desktop Protocol (RDP)?",
    "choice_a": "Thin client computing",
    "choice_b": "Clientless virtual private networking",
    "choice_c": "Encrypted tunneling",
    "choice_d": "Unauthenticated file transfers",
    "correct_answer": "A",
    "explanation": "RDP is a component of Remote Desktop Services, a Windows mechanism that enables a client program to connect to a server and control it remotely. RDP does not carry actual application data; it just transfers keystrokes, mouse movements, and graphical user interface (GUI) display information. Because the client program does not participate in the application computing on the server, it is known as a thin client. RDP does not provide clientless virtual private networking, encrypted tunneling, or unauthenticated file transfers.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      210,
      212,
      213,
      211,
      209
    ],
    "source": "9781394239306"
  },
  {
    "id": 1225,
    "question": "Which of the following types of virtual private networking (VPN) connection is the best solution for connecting a branch office to a corporate headquarters?",
    "choice_a": "Client-to-site",
    "choice_b": "Site-to-site",
    "choice_c": "Client-to-client",
    "choice_d": "Extranet",
    "correct_answer": "B",
    "explanation": "A site-to-site VPN enables one network to connect to another, enabling users on both networks to access resources on the other one. This is usually a more economical solution for branch office connections than a wide area network (WAN) link. A client-to-site VPN is a remote access solution, enabling users to access the corporate network from home or while traveling. A client-to-client VPN enables two individual users to establish a protected connection to each other. An extranet VPN is designed to provide clients, vendors, and other outside partners with the ability to connect to a corporate network with limited access.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      208,
      209,
      210,
      211,
      212
    ],
    "source": "9781394239306"
  },
  {
    "id": 1226,
    "question": "Ralph is a network administrator for a firm that is allowing employees to telecommute for the first time, and he is responsible for designing a remote access solution that will enable users to access network resources, such as company email and databases, securely. All of the remote users have been issued smartcards and will be connecting using virtual private network (VPN) connections on company-supplied laptop computers running Windows 11 and equipped with card readers. The users will be logging on to the company network using their standard Active Directory Domain Services (AD DS) accounts, so it is important for Ralph to design a solution that provides the maximum protection for their passwords, both inside and outside the office. Which of the following authentication protocols should Ralph configure the remote access servers and the laptop computers to use?",
    "choice_a": "Password Authentication Protocol (PAP)",
    "choice_b": "Challenge Handshake Authentication Protocol (CHAP)",
    "choice_c": "Extensible Authentication Protocol (EAP)",
    "choice_d": "Microsoft Challenge Handshake Authentication Protocol (MS-CHAP v2)",
    "correct_answer": "C",
    "explanation": "EAP is the only authentication protocol included with Windows 11 that supports hardware-based authentication, so this is the only viable option. PAP transmits passwords in cleartext and is therefore not a viable option. Neither is CHAP, because it must store passwords using reversible encryption. MSCHAPv2 provides sufficient password protection but does not support the hardware-based authentication needed for smartcard use.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      209,
      243,
      217,
      210,
      213
    ],
    "source": "9781394239306"
  },
  {
    "id": 1227,
    "question": "Which of the following remote access protocols provides users with full control over the graphical user interface (GUI) on a Windows computer? (Choose two.)",
    "choice_a": "SSH",
    "choice_b": "RDP",
    "choice_c": "VNC",
    "choice_d": "Telnet",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "RDP is a component of Remote Desktop Services, a Windows mechanism that enables a client program to connect to a server and control it remotely. RDP does not carry actual application data; it just transfers keystrokes, mouse movements, and graphic display information. Virtual Network Computing (VNC) is a similar desktop sharing system that is platform independent and open source. Secure Shell (SSH) and Telnet are console-based remote control solutions.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      210,
      213,
      214,
      212,
      211
    ],
    "source": "9781394239306"
  },
  {
    "id": 1228,
    "question": "Ralph has come upon the term <i>virtual desktop</i>, and he is not exactly sure what it means. After performing some Internet searches, he finds multiple definitions. Which of the following is not one of the technologies that uses the term virtual desktop?",
    "choice_a": "A three-dimensional realization of a computer display created using a virtual reality hardware device",
    "choice_b": "A computer display with a virtual operating system desktop that is larger than can be displayed on a monitor",
    "choice_c": "A cloud-based Windows 11 deployment that enables users to access their desktops using any remote device",
    "choice_d": "A hardware device that projects a computer desktop on a screen, rather than displaying it on a monitor",
    "correct_answer": "D",
    "explanation": "The term <i>virtual desktop</i> does not refer to a projection device that can display a computer desktop on a screen. A virtual desktop can be a realization of a computer monitor in a virtual reality environment; a virtualized desktop larger than the monitor, which users can scroll to view all parts of the display; or a cloud-based service provided by Microsoft Azure that provides users with access to their desktops using remote devices.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      210,
      211,
      212,
      213,
      217
    ],
    "source": "9781394239306"
  },
  {
    "id": 1229,
    "question": "Which of the following types of traffic are carried by the Remote Desktop Protocol (RDP)? (Choose all that apply.)",
    "choice_a": "Keystrokes",
    "choice_b": "Mouse movements",
    "choice_c": "Display information",
    "choice_d": "Application data",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "RDP is a component of Remote Desktop Services, a Windows mechanism that enables a client program to connect to a server and control it remotely. RDP does not carry actual application data; it just transfers keystrokes, mouse movements, and graphic display information.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      210,
      212,
      213,
      209,
      208
    ],
    "source": "9781394239306"
  },
  {
    "id": 1230,
    "question": "Which of the following types of traffic are transmitted by Virtual Network Computing (VNC)? (Choose all that apply.)",
    "choice_a": "Keystrokes",
    "choice_b": "Mouse movements",
    "choice_c": "Display information",
    "choice_d": "Application data",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "VNC is a graphical desktop sharing system that uses a protocol called Remote Frame Buffer (RFB) to connect a client to a server and control it remotely. VNC does not transmit actual application data; it just transfers keystrokes, mouse movements, and graphic display information.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      213,
      212,
      210,
      211,
      225
    ],
    "source": "9781394239306"
  },
  {
    "id": 1231,
    "question": "Which of the following types of traffic are carried by Telnet? (Choose two.)",
    "choice_a": "Keystrokes",
    "choice_b": "Mouse movements",
    "choice_c": "Display information",
    "choice_d": "Application data",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Telnet is a console-based remote control protocol and application that is available on virtually all computing platforms. Because it is strictly character based, Telnet clients transmit only keystrokes and receive only character-based display information from the server. They do not carry mouse movements or application data.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      214,
      210,
      212,
      213,
      230
    ],
    "source": "9781394239306"
  },
  {
    "id": 1232,
    "question": "Which of the following describes the primary function of a remote desktop gateway?",
    "choice_a": "Provides multiple users with Remote Desktop client access to one workstation.",
    "choice_b": "Provides a single Remote Desktop client with simultaneous access to multiple workstations.",
    "choice_c": "Enables remote users outside the network to access network workstations.",
    "choice_d": "Enables remote users to access workstations without the need for a Remote Desktop client.",
    "correct_answer": "C",
    "explanation": "Remote Desktop Gateway is a Windows Server role that enables remote users outside the network to establish a Remote Desktop Protocol (RDP) connection without the need for a virtual private network (VPN) connection. The gateway does not provide multiple Remote Desktop client access to one workstation, Remote Desktop client access to multiple workstations, or access to workstations without a Remote Desktop client.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      211,
      210,
      209,
      214,
      217
    ],
    "source": "9781394239306"
  },
  {
    "id": 1233,
    "question": "Which of the following statements about in-band management and out-of-band management are true? (Choose two.)",
    "choice_a": "Out-of-band management tools do not provide access to the remote system's BIOS or UEFI firmware.",
    "choice_b": "Out-of-band management tools enable you to reinstall the operating system on a remote computer.",
    "choice_c": "Secure Shell (SSH), Virtual Network Computing (VNC), and application programming interface (API) connections are in-band management tools.",
    "choice_d": "To perform out-of-band management on a device, it must have an IP address.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Out-of-band management uses a dedicated channel to devices on the network. This means that the device to be managed does not require an IP address. The dedicated channel provides access to the BIOS or UEFI firmware and makes it possible to reinstall the operating system on a remote computer. SSH, VNC, and API connections are not out-of-band management tools.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      217,
      214,
      216,
      210,
      234
    ],
    "source": "9781394239306"
  },
  {
    "id": 1234,
    "question": "Which of the following statements best defines out-of-band management?",
    "choice_a": "Out-of-band management is a method for accessing network devices from a remote location.",
    "choice_b": "Out-of-band management is a method for accessing network devices using a direct cable connection.",
    "choice_c": "Out-of-band management is a method for accessing network devices using a connection to the system other than the production network to which the device is connected.",
    "choice_d": "Out-of-band management is a method for accessing network devices using any tool that operates over the production network to which the device is connected.",
    "correct_answer": "C",
    "explanation": "Out-of-band management refers to the use of an alternative communications channel to a network device. The channel can be a modem connection, a direct cable connection, a wireless or cellular connection, or a dedicated Ethernet connection.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      216,
      214,
      226,
      232,
      231
    ],
    "source": "9781394239306"
  },
  {
    "id": 1235,
    "question": "What four components are required for a computer to establish a remote Transmission Control Protocol/Internet Protocol (TCP/IP) connection? (Choose all that apply.)",
    "choice_a": "A Physical layer connection",
    "choice_b": "Remote Access Service (RAS)",
    "choice_c": "Common protocols",
    "choice_d": "TCP/IP configuration",
    "correct_answer": [
      "A",
      "C",
      "D",
      "F"
    ],
    "explanation": "A computer requires four components to establish a remote connection. First, a Physical layer wide area network (WAN) connection is needed. Second, the two systems must share common protocols from the Data link layer and above. Third, if TCP/IP is being used to establish a remote session, then TCP/IP parameters must be configured on the systems. Fourth, host and remote software are needed. The remote client must have software that enables it to establish a remote session, and the server must have software that enables it to receive and grant remote sessions. Microsoft RAS supports both client and server remote access software; however, this is not a required component since other types of software can be used. PPTP is an obsolete tunneling protocol and is not a required component for establishing a remote session.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      212,
      210,
      209,
      208,
      56
    ],
    "source": "9781394239306",
    "choice_e": "Point-to-Point Tunneling Protocol (PPTP)",
    "choice_f": "Host and remote software"
  },
  {
    "id": 1236,
    "question": "Which of the following statements explains why web browsing over a client-to-site virtual private network (VPN) connection is usually so much slower than browsing locally?",
    "choice_a": "The browser application is running on the VPN server.",
    "choice_b": "The browser is using the remote network's Internet connection.",
    "choice_c": "The VPN tunnel restricts the amount of bandwidth available.",
    "choice_d": "VPN encryption is processor intensive.",
    "correct_answer": "B",
    "explanation": "When users connect to a remote network using VPN, they become a participant on that network, which includes using the remote network's Internet connection. Therefore, when a user opens a browser, the application passes the user's requests through the VPN tunnel to the remote server, which uses the default gateway and Internet connection at the remote site to connect to the desired address. This is inherently slower than connecting the browser directly to the Internet from the client computer.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      209,
      208,
      255,
      235,
      231
    ],
    "source": "9781394239306"
  },
  {
    "id": 1237,
    "question": "In a site-to-site virtual private network (VPN) connection, which of the following combinations of endpoint devices would most likely be involved?",
    "choice_a": "Two workstations",
    "choice_b": "A workstation and a server",
    "choice_c": "A workstation and a VPN concentrator",
    "choice_d": "Two VPN concentrators",
    "correct_answer": "D",
    "explanation": "A site-to-site VPN connection connects two remote local area networks (LANs) together, enabling users on either network to access the other one. The typical configuration would consist of two VPN concentrators, one at each site, functioning as the endpoints of the connection.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      208,
      209,
      210,
      211,
      213
    ],
    "source": "9781394239306"
  },
  {
    "id": 1238,
    "question": "In a client-to-site virtual private network (VPN) connection, which of the following combinations of endpoint devices would most likely be involved?",
    "choice_a": "Two workstations",
    "choice_b": "A workstation and a server",
    "choice_c": "A workstation and a VPN concentrator",
    "choice_d": "Two VPN concentrators",
    "correct_answer": "C",
    "explanation": "A client-to-site VPN connection connects a single workstation to a remote local area network (LAN), enabling the workstation user to access the remote network's resources. The typical configuration would consist of a standalone workstation and a VPN concentrator at the network site functioning as the endpoints of the connection.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      209,
      210,
      211,
      213,
      217
    ],
    "source": "9781394239306"
  },
  {
    "id": 1239,
    "question": "Which of the following are the two most common types of Transport Layer Security/Secure Sockets Layer (TLS/SSL) virtual private network (VPN) connections? (Choose two.)",
    "choice_a": "TLS/SSL client",
    "choice_b": "TLS/SSL portal",
    "choice_c": "TLS/SSL tunnel",
    "choice_d": "TLS/SSL gateway",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The two most common types of TLS/SSL VPN connection are TLS/SSL portals, which provide users with access to selected remote network resources through a standard website, and TLS/SSL tunnels, which require the client web browser to run an active control, typically using a language such as Java. TLS/SSL client and TLS/SSL gateway are not common TLS/SSL VPN connections.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      209,
      210,
      213,
      211,
      212
    ],
    "source": "9781394239306"
  },
  {
    "id": 1240,
    "question": "In a client-to-client virtual private network (VPN) connection, which of the following combinations of endpoint devices would most likely be involved?",
    "choice_a": "Two workstations",
    "choice_b": "A workstation and a server",
    "choice_c": "A workstation and a VPN concentrator",
    "choice_d": "Two VPN concentrators",
    "correct_answer": "A",
    "explanation": "A client-to-client VPN connection connects two individual workstations at different locations, enabling the users on each workstation to access the other one through a secure tunnel. The typical configuration would consist of two workstations, one at each site, functioning as the endpoints of the connection.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      209,
      208,
      210,
      213,
      211
    ],
    "source": "9781394239306"
  },
  {
    "id": 1241,
    "question": "Many managed switches and routers include a console port for administrative access, to which you can connect a laptop and run a terminal program to access the device's interface. Which of the following is the best term for this type of access to the device?",
    "choice_a": "Out-of-band",
    "choice_b": "In-band",
    "choice_c": "Client-to-site",
    "choice_d": "BYOD",
    "correct_answer": "A",
    "explanation": "The term <i>out-of-band</i> is used to describe any type of management access to a device that does not go through the production network. Plugging a laptop into the console port avoids the network, so it is considered to be an example of out-of-band management. In-band management describes an access method that goes through the production network. Client-to-site is a type of VPN connection, and bring your own device (BYOD) is a policy defining whether and how users are permitted to connect their personal devices to the network.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      216,
      217,
      209,
      208,
      244
    ],
    "source": "9781394239306"
  },
  {
    "id": 1242,
    "question": "Which of the following statements about running a site-to-site virtual private network (VPN) connection to join two distant local area networks (LANs) together, rather than using a wide area network (WAN) connection, are generally true? (Choose two.)",
    "choice_a": "The VPN is cheaper.",
    "choice_b": "The VPN is slower.",
    "choice_c": "The VPN is less secure.",
    "choice_d": "The VPN is harder to maintain.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Because the two endpoints of a VPN are connecting to local Internet service providers (ISPs), the ongoing connection costs are typically much less than a long distance WAN connection. However, in most cases, a VPN is slower because it is affected by Internet bandwidth use and other factors. VPN connections are not inherently less secure than WANs, and they are not necessarily more difficult to maintain.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      208,
      221,
      260,
      258,
      272
    ],
    "source": "9781394239306"
  },
  {
    "id": 1243,
    "question": "Which of the following are examples of out-of-band device management? (Choose all that apply.)",
    "choice_a": "Logging on remotely from a network workstation",
    "choice_b": "Plugging a laptop into a console port",
    "choice_c": "Establishing a point-to-point modem connection",
    "choice_d": "Connecting dedicated ports on each device to a separate switch",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Any method of connecting to a router, switch, or other managed device that does not use the production network is considered to be out-of-band management. This includes connecting a computer or terminal directly to the device, using a point-to-point modem connection, or consolidating dedicated ports on all of the devices by connecting them to an isolated switch. Logging on remotely using a workstation on the production network would be considered in-band management, as would API access.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      216,
      214,
      226,
      224,
      228
    ],
    "source": "9781394239306",
    "choice_e": "Accessing a device through its application programming interface (API)"
  },
  {
    "id": 1244,
    "question": "Which of the following was the first TCP/IP terminal emulation program?",
    "choice_a": "Telnet",
    "choice_b": "SSH",
    "choice_c": "Windows Terminal Services",
    "choice_d": "Virtual Network Computing",
    "correct_answer": "A",
    "explanation": "Telnet (TELetype NETwork) was the first TCP/IP terminal emulation program, but it is rarely used today because of its limitations. It is character-based only, and it transmits all data as cleartext, which is insecure. Secure Shell (SSH) addresses the security problem, but it too is character-based. Windows Terminal Services and Virtual Network Computing (VNC) were both created to provide graphical terminal emulation.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      214,
      213,
      210,
      216,
      217
    ],
    "source": "9781394239306"
  },
  {
    "id": 1245,
    "question": "Which of the following techniques do virtual private networks use to secure the data that they transmit over the Internet? (Choose all that apply.)",
    "choice_a": "Tunneling",
    "choice_b": "Socketing",
    "choice_c": "Message integrity",
    "choice_d": "Authentication",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Tunneling is the process of encapsulating a data packet within another packet. The system then encrypts the entire data packet. Message integrity enables the recipient to detect any data tampering. Authentication ensures that only the intended recipient can access the data. There is no applicable technique called socketing.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      208,
      214,
      59,
      95,
      228
    ],
    "source": "9781394239306"
  },
  {
    "id": 1246,
    "question": "Virtual private networks (VPNs) use tunneling, which is the process of encapsulating a data packet within another packet for transmission over a network connection, typically using the Internet. The system encrypts the entire encapsulated data packet for protection. Split tunneling is a variation of this method that provides which of the following advantages? (Choose all that apply.)",
    "choice_a": "Conservation of VPN bandwidth",
    "choice_b": "Access to local network devices while connected to the VPN",
    "choice_c": "Additional data integrity protection",
    "choice_d": "Faster data transmission through multiplexing",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "A basic VPN typically uses full tunneling, in which all of the system's network traffic is encapsulated and encrypted for transmission. Split tunneling is a variation of this method in which only part of the system's traffic uses the VPN connection; the rest is transmitted over the network in the normal manner. Administrators can select which applications and devices use the VPN. Split tunneling can conserve internet bandwidth used by the VPN and provide access to local services without the need for encapsulation. Split tunneling does not provide additional data integrity protection or improved performance through multiplexing.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      209,
      95,
      230,
      222,
      255
    ],
    "source": "9781394239306"
  },
  {
    "id": 1247,
    "question": "SSH was created to be an improvement on the Telnet terminal emulation program. In which of the following ways is it an improvement?",
    "choice_a": "SSH is faster than Telnet.",
    "choice_b": "SSH provides graphical terminal emulation.",
    "choice_c": "SSH encrypts passwords and data.",
    "choice_d": "SSH is less expensive than Telnet.",
    "correct_answer": "C",
    "explanation": "Telnet transmits keystrokes in cleartext, including usernames and passwords. It is therefore insecure. Secure Shell (SSH) improves on the performance of Telnet by encrypting the passwords and other data it transmits over the network. Like Telnet, SSH is free and does not support graphical terminal emulation. SSH is also no faster than Telnet.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      214,
      216,
      217,
      210,
      212
    ],
    "source": "9781394239306"
  },
  {
    "id": 1248,
    "question": "Remote Desktop Protocol (RDP) was created for use with which of the following terminal emulation programs?",
    "choice_a": "Windows Terminal Services",
    "choice_b": "Virtual Network Computing (VNC)",
    "choice_c": "Citrix WinFrame",
    "choice_d": "Telnet",
    "correct_answer": "A",
    "explanation": "RDP is the client/server protocol created for use with Windows Terminal Services, now known as Remote Desktop Services. It is not used with VNC, Citrix products, or Telnet.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      210,
      212,
      213,
      214,
      216
    ],
    "source": "9781394239306"
  },
  {
    "id": 1249,
    "question": "Alice is a new hire in the IT department of a company that, in addition to their existing Ethernet network, has recently installed a storage area network (SAN) using Fibre Channel technology and three hard drive arrays. Alice's supervisor has instructed her to set up a jump box to manage the SAN. Alice has never heard the term <i>jump box</i> before. Which of the following describes what she must do to complete the task?",
    "choice_a": "Connect a dumb terminal to the SAN.",
    "choice_b": "Install a Fibre Channel adapter in a workstation computer and connect it to the SAN.",
    "choice_c": "Install Ethernet and Fibre Channel adapters in a workstation computer and connect it to both the Ethernet network and the SAN.",
    "choice_d": "Install an Ethernet adapter in one of the drive arrays on the SAN.",
    "correct_answer": "C",
    "explanation": "A jump box is a workstation that is connected both to the standard LAN and to the new SAN, enabling administrators to use SAN management tools in a secure environment. To do this, Alice must install two network adapters in the jump box: an Ethernet adapter to connect to the LAN and a Fibre Channel adapter to connect to the SAN. None of the other options would create a jump box.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      217,
      214,
      253,
      251,
      238
    ],
    "source": "9781394239306"
  },
  {
    "id": 1250,
    "question": "Which of the following authentication protocols do Windows networks use for Active Directory Domain Services (AD DS) authentication of internal clients?",
    "choice_a": "RADIUS",
    "choice_b": "WPA2",
    "choice_c": "Kerberos",
    "choice_d": "EAP-TLS",
    "correct_answer": "C",
    "explanation": "Windows networks that use AD DS authenticate clients using the Kerberos protocol, in part because it never transmits passwords over the network, even in encrypted form. RADIUS is an authentication, authorization, and accounting (AAA) service for remote users connecting to a network. Windows does not use it for internal clients. WPA2 is a security protocol used by wireless LAN networks; it is not used for AD DS authentication. EAP-TLS is a remote authentication protocol that AD DS networks do not use for internal clients.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      375,
      374,
      373,
      377,
      371
    ],
    "source": "9781394239306"
  },
  {
    "id": 1251,
    "question": "Which of the following are examples of multifactor authentication? (Choose all that apply.)",
    "choice_a": "A system that uses an external RADIUS server for authentication",
    "choice_b": "A system that requires two passwords for authentication",
    "choice_c": "A system that requires a smartcard and a PIN for authentication",
    "choice_d": "A system that requires a password and a retinal scan for authentication",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "<i>Multifactor authentication</i> (MFA) combines two or more authentication methods and reduces the likelihood that an intruder would be able to successfully impersonate a user during the authentication process. A password and a retinal scan is an example of a multifactor authentication system. A smartcard and a PIN, which is the equivalent of a password, is an example of multifactor authentication because it requires users to supply something they know and something they have. Multifactor authentication refers to the proofs of identity a system requires, not the number of servers used to implement the system. Therefore, the use of a RADIUS server does not make for an example of multifactor authentication. A system that requires two passwords is not an example of multifactor authentication, because an attacker can compromise two passwords as easily as one. A multifactor authentication system requires two different forms of authentication. Time-based authentication is possible, but the time itself is not an authentication factor.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      371,
      372,
      377,
      374,
      403
    ],
    "source": "9781394239306",
    "choice_e": "A system that requires users to appear for authentication at specific times"
  },
  {
    "id": 1252,
    "question": "Which of the following is not one of the mechanisms often used to implement a defense in depth strategy?",
    "choice_a": "Screened subnets",
    "choice_b": "Network segmentation enforcement",
    "choice_c": "Honeypots",
    "choice_d": "Access control vestibules",
    "correct_answer": "E",
    "explanation": "Social engineering is a means for gaining unauthorized access to a network by convincing users to disclose passwords or other sensitive information; it is not part of a defense in depth strategy. Defense in depth can include physical protection, such as access control vestibules; division of resources using network segmentation, separation of duties, or screened subnets; and deceptive lures, such as honeypots.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      389,
      395,
      396,
      401,
      391
    ],
    "source": "9781394239306",
    "choice_e": "Social engineering",
    "choice_f": "Separation of duties"
  },
  {
    "id": 1253,
    "question": "Which of the following protocols can you use to authenticate Windows remote access users with smartcards?",
    "choice_a": "EAP",
    "choice_b": "MS-CHAPv2",
    "choice_c": "CHAP",
    "choice_d": "PAP",
    "correct_answer": "A",
    "explanation": "The Extensible Authentication Protocol (EAP) is the only Windows remote authentication protocol that supports the use of authentication methods other than passwords, such as smartcards. MS-CHAPv2 is a strong remote access authentication protocol, but it supports password authentication only; users cannot use smartcards. The Challenge Handshake Authentication Protocol (CHAP) is a relatively weak authentication protocol that does not support the use of smartcards. The Password Authentication Protocol (PAP) supports only cleartext passwords, not smartcards.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      374,
      397,
      371,
      368,
      392
    ],
    "source": "9781394239306"
  },
  {
    "id": 1254,
    "question": "Which of the following statements best defines multifactor user authentication?",
    "choice_a": "Verification of a user's identity on all of a network's resources using a single sign-on",
    "choice_b": "Verification of a user's identity using two or more types of credentials",
    "choice_c": "Verification of a user's identity on two devices at once",
    "choice_d": "Verification of a user's membership in two or more security groups",
    "correct_answer": "B",
    "explanation": "Multifactor authentication (MFA) combines two or more authentication methods, requiring a user to supply multiple credentials. This reduces the likelihood that an intruder would be able to successfully impersonate a user during the authentication process. The term <i>multifactor</i> does not refer to the number of resources, devices, or groups with which the user is associated.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      371,
      372,
      377,
      374,
      386
    ],
    "source": "9781394239306"
  },
  {
    "id": 1255,
    "question": "Which of the following services are methods of tracking a user's activities on a network? (Choose all that apply.)",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Accounting",
    "choice_d": "Auditing",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Accounting and auditing are both methods of tracking and recording a user's activities on a network, such as when a user logged on and how long they remained connected. Authentication is the confirmation of a user's identity, and authorization defines the type of access granted to authenticated users.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      370,
      374,
      375,
      373,
      376
    ],
    "source": "9781394239306"
  },
  {
    "id": 1256,
    "question": "When a user supplies a password to log on to a server, which of the following actions is the user performing?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Accounting",
    "choice_d": "Auditing",
    "correct_answer": "A",
    "explanation": "Authentication is the process of confirming a user's identity. Passwords are one of the authentication factors commonly used by network devices. Authorization defines the type of access granted to authenticated users. Accounting and auditing are both methods of tracking and recording a user's activities on a network, such as when a user logged on and how long they remained connected.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      370,
      374,
      371,
      377,
      373
    ],
    "source": "9781394239306"
  },
  {
    "id": 1257,
    "question": "When a user swipes a finger across a fingerprint scanner to log on to a laptop computer, which of the following actions is the user performing?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Accounting",
    "choice_d": "Auditing",
    "correct_answer": "A",
    "explanation": "Authentication is the process of confirming a user's identity. Fingerprints and other biometric readers are some of the authentication factors commonly used by network devices. Authorization defines the type of access granted to authenticated users. Accounting and auditing are both methods of tracking and recording a user's activities on a network, such as when a user logged on and how long they remained connected.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      370,
      371,
      377,
      374,
      375
    ],
    "source": "9781394239306"
  },
  {
    "id": 1258,
    "question": "Which of the following security protocols can authenticate users without transmitting their passwords over the network?",
    "choice_a": "Kerberos",
    "choice_b": "802.1X",
    "choice_c": "TKIP",
    "choice_d": "LDAP",
    "correct_answer": "A",
    "explanation": "Kerberos is a security protocol used by Active Directory that employs a system of tickets to authenticate users and other network entities without the need to transmit credentials over the network. IEEE 802.1X does authenticate by transmitting credentials. Temporal Key Integrity Protocol (TKIP) and Lightweight Directory Access Protocol (LDAP) are not authentication protocols.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      375,
      374,
      371,
      377,
      373
    ],
    "source": "9781394239306"
  },
  {
    "id": 1259,
    "question": "Which of the following statements about authentication auditing is not true?",
    "choice_a": "Auditing can disclose attempts to compromise passwords.",
    "choice_b": "Auditing can detect authentications that occur after hours.",
    "choice_c": "Auditing can identify the guess patterns used by password cracking software.",
    "choice_d": "Auditing can record unsuccessful as well as successful authentications.",
    "correct_answer": "C",
    "explanation": "Auditing of authentication activities can record both successful and unsuccessful logon attempts. Large numbers of logon failures can indicate attempts to crack passwords. Auditing tracks the time of authentication attempts, sometimes enabling you to detect off-hours logons that indicate an intrusion. Auditing does not record the passwords specified during authentications, so it cannot identify patterns of unsuccessful guesses.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      370,
      374,
      386,
      378,
      380
    ],
    "source": "9781394239306"
  },
  {
    "id": 1260,
    "question": "When a user swipes a smartcard through a reader to log on to a laptop computer, which of the following actions is the user performing?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Accounting",
    "choice_d": "Auditing",
    "correct_answer": "A",
    "explanation": "Authentication is the process of confirming a user's identity. Smartcards are one of the authentication factors commonly used by network devices. Authorization defines the type of access granted to authenticated users. Accounting and auditing are both methods of tracking and recording a user's activities on a network, such as when a user logged on and how long they remained connected.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      370,
      371,
      377,
      374,
      375
    ],
    "source": "9781394239306"
  },
  {
    "id": 1261,
    "question": "Combining elements like something you know, something you have, and something you are to provide access to a secured network resource is a definition of which of the following types of authentication?",
    "choice_a": "Multifactor",
    "choice_b": "Multisegment",
    "choice_c": "Multimetric",
    "choice_d": "Multifiltered",
    "correct_answer": "A",
    "explanation": "Multifactor authentication combines two or more authentication methods and reduces the likelihood that an intruder would be able to successfully impersonate a user during the authentication process. A password (something you know) and a retinal scan (something you are) is an example of a multifactor authentication system. A smartcard and a PIN, which is the equivalent of a password, is another example of multifactor authentication because it requires users to supply something they know and something they have. <i>Multisegment</i>, <i>multimetric</i>, and <i>multifiltered</i> are not applicable terms in this context.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      371,
      372,
      374,
      377,
      375
    ],
    "source": "9781394239306"
  },
  {
    "id": 1262,
    "question": "HVAC sensors can use the Internet of Things (IoT) to monitor which of the following? (Choose all that apply.)",
    "choice_a": "Temperature",
    "choice_b": "Pressure",
    "choice_c": "Humidity",
    "choice_d": "Printers",
    "correct_answer": [
      "A",
      "B",
      "C",
      "E"
    ],
    "explanation": "HVAC sensors can measure temperatures and humidity in climate-controlled areas, such as datacenters; atmospheric pressure in devices like boilers and compressors; and occupancy, to control conditions based on the presence of people. Printers, cameras, door locks, and other physical access control devices are not part of an HVAC system.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      399,
      363,
      365,
      404,
      400
    ],
    "source": "9781394239306",
    "choice_e": "Occupancy",
    "choice_f": "Cameras",
    "choice_g": "Door locks"
  },
  {
    "id": 1263,
    "question": "Which of the following describes the primary difference between single sign-on (SSO) and same sign-on?",
    "choice_a": "Single sign-on (SSO) enables users to access different resources with one set of credentials, whereas same sign-on requires users to have multiple credential sets.",
    "choice_b": "Single sign-on (SSO) credentials consist of one username and one password, whereas same sign-on credentials consist of one username and multiple passwords.",
    "choice_c": "Single sign-on (SSO) requires the user to supply credentials only once, whereas with same sign-on, the user must supply the credentials repeatedly.",
    "choice_d": "Single sign-on (SSO) requires multifactor authentication, such as a password and a smartcard, whereas same sign-on requires only a password for authentication.",
    "correct_answer": "C",
    "explanation": "Single sign-on (SSO) uses one set of credentials and requires the user to supply them only once to gain access to multiple resources. Same sign-on also uses a single set of credentials, with one password, but the user must perform individual logons for each resource. Neither single sign-on nor same sign-on calls for multifactor authentication.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      373,
      377,
      371,
      372,
      376
    ],
    "source": "9781394239306"
  },
  {
    "id": 1264,
    "question": "Which of the following is the best description of biometrics?",
    "choice_a": "Something you know",
    "choice_b": "Something you have",
    "choice_c": "Something you are",
    "choice_d": "Something you do",
    "correct_answer": "C",
    "explanation": "Biometrics is a type of authentication factor that uses a physical characteristic that uniquely identifies an individual, such as a fingerprint or a retinal pattern. Therefore, biometrics is best described as something you are, as opposed to something you know, something you have, or something you do.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      371,
      377,
      374,
      375,
      392
    ],
    "source": "9781394239306"
  },
  {
    "id": 1265,
    "question": "Which of the following authentication factors is an example of something you have?",
    "choice_a": "A fingerprint",
    "choice_b": "A smartcard",
    "choice_c": "A password",
    "choice_d": "A finger gesture",
    "correct_answer": "B",
    "explanation": "Something you have refers to a physical possession that serves to identify a user, such as a smartcard. This type of authentication is typically used as part of a multifactor authentication procedure because a smartcard or other physical possession can be lost or stolen. A fingerprint would be considered something you are, a password something you know, and a finger gesture something you do.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      371,
      372,
      377,
      374,
      404
    ],
    "source": "9781394239306"
  },
  {
    "id": 1266,
    "question": "Which of the following statements best describes the primary scenario for the use of TACACS+?",
    "choice_a": "TACACS+ was designed to provide authentication, authorization, and accounting services for wireless networks.",
    "choice_b": "TACACS+ was designed to provide authentication, authorization, and accounting services for the Active Directory Domain Services.",
    "choice_c": "TACACS+ was designed to provide authentication, authorization, and accounting services for remote dial-in users.",
    "choice_d": "TACACS+ was designed to provide authentication, authorization, and accounting services for network routers and switches.",
    "correct_answer": "D",
    "explanation": "Terminal Access Controller Access Control System Plus (TACACS+) is a protocol designed to provide AAA services for networks with many routers and switches, enabling administrators to access them with a single set of credentials. It was not designed to provide AAA services for wireless networks, Active Directory, or remote dial-in users.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      374,
      370,
      377,
      376,
      392
    ],
    "source": "9781394239306"
  },
  {
    "id": 1267,
    "question": "Which of the following is not one of the functions provided by TACACS+?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Administration",
    "choice_d": "Accounting",
    "correct_answer": "C",
    "explanation": "Terminal Access Controller Access Control System Plus (TACACS+) is a protocol that was designed to provide AAA services for networks with many routers and switches. AAA stands for authentication, authorization, and accounting, but not administration.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      374,
      370,
      377,
      373,
      372
    ],
    "source": "9781394239306"
  },
  {
    "id": 1268,
    "question": "The new door lock on your company's datacenter door requires you to supply both a PIN and a thumbprint scan. Which of the following authentication factors does the lock use? (Choose all that apply.)",
    "choice_a": "Something you have",
    "choice_b": "Something you know",
    "choice_c": "Something you are",
    "choice_d": "Something you do",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "A PIN, like a password, is something you know, and a thumbprint, or any other biometric factor, is something you are. An example of something you have would be a smartcard, and an example of something you do would be a finger gesture.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      371,
      403,
      377,
      392,
      389
    ],
    "source": "9781394239306"
  },
  {
    "id": 1269,
    "question": "Your new smartphone enables you to configure the lock screen with a picture of your husband, on which you draw eyes, nose, and a mouth with your finger to unlock the phone. This is an example of which of the following authentication factors?",
    "choice_a": "Something you have",
    "choice_b": "Something you know",
    "choice_c": "Something you are",
    "choice_d": "Something you do",
    "correct_answer": "D",
    "explanation": "The act of drawing on the screen with your finger is a gesture, which is an example of something you do. A PIN or a password is something you know; a thumbprint, or any other biometric factor, is something you are; and a smartcard is an example of something you have.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      371,
      377,
      372,
      370,
      373
    ],
    "source": "9781394239306"
  },
  {
    "id": 1270,
    "question": "Which of the following authentication factors is an example of something you do?",
    "choice_a": "A fingerprint",
    "choice_b": "A smartcard",
    "choice_c": "A password",
    "choice_d": "A self-signed certificate",
    "correct_answer": "E",
    "explanation": "Something you do refers to a physical action performed by a user, such as a finger gesture, which helps to confirm their identity. This type of authentication is often used as part of a multifactor authentication procedure because a gesture or other action can be imitated. A fingerprint would be considered something you are, a password something you know, and a smartcard something you have. A self-signed certificate is not an authentication factor because it provides no outside verification of identity.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      371,
      377,
      372,
      368,
      369
    ],
    "source": "9781394239306",
    "choice_e": "A finger gesture"
  },
  {
    "id": 1271,
    "question": "Which of the following authentication factors is an example of something you know?",
    "choice_a": "A fingerprint",
    "choice_b": "A smartcard",
    "choice_c": "A password",
    "choice_d": "A finger gesture",
    "correct_answer": "C",
    "explanation": "Something you know refers to information you supply during the authentication process, such as a password or PIN. This is the most common type of authentication factor because it cannot be lost or stolen unless the user violates security policies. A fingerprint would be considered something you are, a finger gesture something you do, and a smartcard something you have.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      371,
      377,
      374,
      386,
      388
    ],
    "source": "9781394239306"
  },
  {
    "id": 1272,
    "question": "Which of the following authentication factors is an example of something you are?",
    "choice_a": "A fingerprint",
    "choice_b": "A smartcard",
    "choice_c": "A password",
    "choice_d": "A finger gesture",
    "correct_answer": "A",
    "explanation": "Something you are refers to a physical characteristic that uniquely identifies an individual, such as a fingerprint or other form of biometric. This type of authentication is often used as part of a multifactor authentication procedure because a biometric element can conceivably be compromised. A finger gesture would be considered something you do, a password something you know, and a smartcard something you have.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      371,
      377,
      372,
      374,
      375
    ],
    "source": "9781394239306"
  },
  {
    "id": 1273,
    "question": "Which of the following data loss prevention (DLP) terms is used to describe dangers pertaining to data that is being transmitted over a network? (Choose all that apply.)",
    "choice_a": "Data in use",
    "choice_b": "Data at rest",
    "choice_c": "Data in motion",
    "choice_d": "Data in transit",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "<i>Data in motion</i> and <i>data in transit</i> are the terms used to describe network traffic. Data in use describes endpoint actions, and data at rest describes data storage.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      367,
      363,
      382,
      383,
      395
    ],
    "source": "9781394239306"
  },
  {
    "id": 1274,
    "question": "Which of the following data loss prevention (DLP) terms is used to describe dangers pertaining to data while a user is loading it into an application?",
    "choice_a": "Data in use",
    "choice_b": "Data at rest",
    "choice_c": "Data in motion",
    "choice_d": "Data in process",
    "correct_answer": "A",
    "explanation": "<i>Data in use</i> is the DLP term used to describe endpoint access, such as a user loading data into an application. Data at rest describes data storage. <i>Data in motion</i> is the term used to describe network traffic. <i>Data in process</i> is not one of the standard DLP terms.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      367,
      378,
      379,
      395,
      366
    ],
    "source": "9781394239306"
  },
  {
    "id": 1275,
    "question": "Which of the following data loss prevention terms is used to describe potential dangers of data loss or data leakage to unauthorized parties while the data is stored without being used?",
    "choice_a": "Data in motion",
    "choice_b": "Data at rest",
    "choice_c": "Data in use",
    "choice_d": "Data on disk",
    "correct_answer": "B",
    "explanation": "Data at rest describes data that is currently in storage while not in use. <i>Data in motion</i> is the term used to describe network traffic. Data in use describes endpoint actions working with the data, and <i>data on disk</i> is not one of the standard data loss prevention terms.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      367,
      363,
      378,
      379,
      366
    ],
    "source": "9781394239306"
  },
  {
    "id": 1276,
    "question": "Which of the following are not standard terms used in data loss prevention (DLP)? (Choose all that apply.)",
    "choice_a": "Data online",
    "choice_b": "Data at rest",
    "choice_c": "Data in motion",
    "choice_d": "Data in use",
    "correct_answer": [
      "A",
      "E"
    ],
    "explanation": "<i>Data online</i> and <i>data locality</i> are not standard data loss prevention (DLP) terms. <i>Data at rest</i> is a DLP term that describes data that is currently in storage while not in use. <i>Data in motion</i> is the term used to describe network traffic. Data in use describes endpoint actions.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      367,
      379,
      378,
      376,
      395
    ],
    "source": "9781394239306",
    "choice_e": "Data locality"
  },
  {
    "id": 1277,
    "question": "Which of the following are standards that define combined authentication, authorization, and accounting (AAA) services? (Choose two.)",
    "choice_a": "802.1X",
    "choice_b": "RADIUS",
    "choice_c": "TACACS+",
    "choice_d": "LDAP",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Remote Authentication Dial-In User Service (RADIUS) and Terminal Access Controller Access Control System Plus (TACACS+) are both services that provide networks with authentication, authorization, and accounting. 802.1X provides only authentication, and Lightweight Directory Access Protocol (LDAP) provides communication between directory service entities. Security Assertion Markup Language (SAML) is a standard for the exchange of authentication and authorization data, but it does not define a full-featured authentication, authorization, and accounting (AAA) solution.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      374,
      370,
      397,
      373,
      375
    ],
    "source": "9781394239306",
    "choice_e": "SAML"
  },
  {
    "id": 1278,
    "question": "Which of the following is not one of the five functional levels associated with a distributed control system such as supervisory control and data acquisition (SCADA) systems?",
    "choice_a": "Field level",
    "choice_b": "Remote access",
    "choice_c": "Direct control",
    "choice_d": "Plant supervisory",
    "correct_answer": "B",
    "explanation": "The five functional levels in a distributed control system such as SCADA are field level, direct control, plant supervisory, production control, and production scheduling. Remote access is not one of the levels.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      399,
      365,
      363,
      378,
      392
    ],
    "source": "9781394239306",
    "choice_e": "Production control",
    "choice_f": "Production scheduling"
  },
  {
    "id": 1279,
    "question": "Which of the following standards was originally designed to provide authentication, authorization, and accounting services for dial-up network connections?",
    "choice_a": "RADIUS",
    "choice_b": "TACACS+",
    "choice_c": "Kerberos",
    "choice_d": "LDAP",
    "correct_answer": "A",
    "explanation": "Remote Authentication Dial-In User Service (RADIUS) was originally conceived to provide AAA services for Internet service providers (ISPs), which at one time ran networks with hundreds of modems providing dial-up access to subscribers. Terminal Access Controller Access Control System Plus (TACACS+) is a protocol that was designed to provide AAA services for networks with many routers and switches, but not for dial-up connections. Kerberos and Lightweight Directory Access Protocol (LDAP) are not AAA services.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      374,
      370,
      371,
      375,
      377
    ],
    "source": "9781394239306"
  },
  {
    "id": 1280,
    "question": "Which of the following statements about RADIUS and TACACS+ is correct?",
    "choice_a": "By default, RADIUS uses UDP, and TACACS+ uses TCP.",
    "choice_b": "By default, RADIUS uses TCP, and TACACS+ uses UDP.",
    "choice_c": "By default, both RADIUS and TACACS+ use TCP.",
    "choice_d": "By default, both RADIUS and TACACS+ use UDP.",
    "correct_answer": "A",
    "explanation": "RADIUS uses User Datagram Protocol (UDP) ports 1812 and 1813 or 1645 and 1646 for authentication, whereas TACACS+ uses TCP port 49.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      374,
      370,
      397,
      377,
      371
    ],
    "source": "9781394239306"
  },
  {
    "id": 1281,
    "question": "Which of the following standards provides authentication, authorization, and accounting services for network routers and switches?",
    "choice_a": "RADIUS",
    "choice_b": "TACACS+",
    "choice_c": "Kerberos",
    "choice_d": "LDAP",
    "correct_answer": "B",
    "explanation": "Terminal Access Controller Access Control System Plus (TACACS+) is a protocol designed to provide AAA services for networks with many routers and switches, enabling administrators to access them with a single set of credentials. Remote Authentication Dial-In User Service (RADIUS) provides AAA services, but not for routers and switches. Kerberos and Lightweight Directory Access Protocol (LDAP) are not AAA services.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      374,
      370,
      371,
      377,
      392
    ],
    "source": "9781394239306"
  },
  {
    "id": 1282,
    "question": "Which of the following terms refers to the process of determining whether a user is a member of a group that provides access to a particular network resource?",
    "choice_a": "Authentication",
    "choice_b": "Accounting",
    "choice_c": "Authorization",
    "choice_d": "Access control",
    "correct_answer": "C",
    "explanation": "Authorization is the process of determining what resources a user can access on a network. Typically, this is done by assessing the user's group memberships. Authentication is the process of confirming a user's identity. Accounting is the process of tracking a user's network activity. Access control is the creation of permissions that provide users and groups with specific types of access to a resource.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      370,
      377,
      376,
      371,
      397
    ],
    "source": "9781394239306"
  },
  {
    "id": 1283,
    "question": "Which of the following terms refers to the process of confirming a user's identity by checking specific credentials?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Accounting",
    "choice_d": "Access control",
    "correct_answer": "A",
    "explanation": "Authentication is the process of confirming a user's identity by checking credentials, such as passwords, ID cards, or fingerprints. Authorization is the process of determining what resources a user can access on a network. Accounting is the process of tracking a user's network activity. Access control is the creation of permissions that provide users and groups with specific types of access to a resource.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      370,
      377,
      374,
      371,
      373
    ],
    "source": "9781394239306"
  },
  {
    "id": 1284,
    "question": "Which of the following terms refers to the process by which a system tracks a user's network activity?",
    "choice_a": "Authentication",
    "choice_b": "Accounting",
    "choice_c": "Authorization",
    "choice_d": "Access control",
    "correct_answer": "B",
    "explanation": "Accounting is the process of tracking a user's network activity, such as when the user logged on and logged off and what resources the user accessed. Authentication is the process of confirming a user's identity by checking credentials. Authorization is the process of determining what resources a user can access on a network. Access control is the creation of permissions that provide users and groups with specific types of access to a resource.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      370,
      374,
      377,
      371,
      373
    ],
    "source": "9781394239306"
  },
  {
    "id": 1285,
    "question": "Which of the following statements about a public key infrastructure are true? (Choose two.)",
    "choice_a": "Data encrypted with a user's public key can be decrypted with the user's public key.",
    "choice_b": "Data encrypted with a user's public key can be decrypted with the user's private key.",
    "choice_c": "Data encrypted with a user's private key can be decrypted with the user's private key.",
    "choice_d": "Data encrypted with a user's private key can be decrypted with the user's public key.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "In a public key infrastructure (PKI), data encrypted with a user's public key can only be decrypted with the user's private key and data encrypted with a user's private key can only be decrypted with the user's public key. This enables the system to provide both message encryption and nonrepudiation. If data encrypted with a user's public key could be decrypted with that same public key, the system would provide no security at all. If data encrypted with a user's private key could be decrypted with that same private key, the user could only send secure messages to him- or herself.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      368,
      381,
      367,
      366,
      393
    ],
    "source": "9781394239306"
  },
  {
    "id": 1286,
    "question": "Which of the following technologies can maintain an account database that multiple remote access servers can employ to authenticate remote users?",
    "choice_a": "RADIUS",
    "choice_b": "IDS",
    "choice_c": "NGFW",
    "choice_d": "NAS",
    "correct_answer": "A",
    "explanation": "A Remote Authentication Dial-In User Service (RADIUS) server can provide authentication, authorization, and accounting services for remote access servers. Intrusion detection systems (IDSs), next-generation firewalls (NGFWs), and network attached storage (NAS) devices do not provide authentication services.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      374,
      370,
      375,
      377,
      397
    ],
    "source": "9781394239306"
  },
  {
    "id": 1287,
    "question": "Which element of the CIA triad prevents unauthorized modification of protected data?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Availability",
    "choice_d": "None of the above",
    "correct_answer": "B",
    "explanation": "The integrity element of the CIA triad prevents data from being modified by unauthorized users. Confidentiality is protection against unauthorized viewing of data. Availability provides users with access to the data they need.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      366,
      367,
      368,
      370,
      378
    ],
    "source": "9781394239306"
  },
  {
    "id": 1288,
    "question": "Which of the following is an example of local authentication?",
    "choice_a": "A system that uses an external RADIUS server for authentication",
    "choice_b": "A system that uses the Kerberos protocol for authentication",
    "choice_c": "A system that authenticates users without network communication",
    "choice_d": "A system that requires a password and a retinal scan for authentication",
    "correct_answer": "C",
    "explanation": "Systems that use local authentication have user accounts stored on the computer, enabling users to log on without the need for any network communication. Systems that use RADIUS or Kerberos for authentication require network communication. A password and a retinal scan is an example of a multifactor authentication system, which might or might not be local.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      370,
      374,
      375,
      371,
      377
    ],
    "source": "9781394239306"
  },
  {
    "id": 1289,
    "question": "In some cases, network administrators create computers that function as enticing targets for attackers but do not provide access to any legitimately sensitive services or information. Which of the following is the term used to describe this technique?",
    "choice_a": "Screened subnet",
    "choice_b": "Honeypot",
    "choice_c": "Root guard",
    "choice_d": "Spoofing",
    "correct_answer": "B",
    "explanation": "A honeypot is a computer configured to function as bait for attackers, causing them to waste their time penetrating a resource that provides no significant access. A screened subnet (also called a perimeter network, a demilitarized zone, or a DMZ) is the part of a network where administrators locate servers that must be accessible from the Internet. A root guard provides protection to switch ports. Spoofing is an attack technique in which an intruder modifies packets to assume the appearance of another user or computer.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      401,
      396,
      363,
      382,
      388
    ],
    "source": "9781394239306"
  },
  {
    "id": 1290,
    "question": "Honeypots and honeynets belong to which of the following categories of devices?",
    "choice_a": "Mitigation techniques",
    "choice_b": "Network attacks",
    "choice_c": "Switch port protection types",
    "choice_d": "Firewall filters",
    "correct_answer": "A",
    "explanation": "A honeypot or honeynet is a type of deception technology that takes the form of a computer or network configured to function as bait for attackers, causing them to waste their time penetrating a resource that provides no significant access.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      401,
      395,
      363,
      392,
      397
    ],
    "source": "9781394239306"
  },
  {
    "id": 1291,
    "question": "Which of the following best describes the process of penetration testing?",
    "choice_a": "Administrators create computers or networks that are alluring targets for intruders.",
    "choice_b": "Administrators attempt to access the network from outside using hacker tools.",
    "choice_c": "An organization hires an outside consultant to evaluate the security conditions on the network.",
    "choice_d": "An organization hires an outside consultant who attempts to compromise the network's security measures.",
    "correct_answer": "D",
    "explanation": "Penetration testing is a process in which an outside consultant is engaged to attempt an unauthorized access to protected network resources. Testing by an internal administrator familiar with the security barriers would not be a valid test. While having a consultant examine the network's security from within can be useful, this is not a penetration test. Computers or networks that are alluring targets for intruders are called honeypots or honeynets.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      401,
      391,
      363,
      392,
      376
    ],
    "source": "9781394239306"
  },
  {
    "id": 1292,
    "question": "Which of the following statements best describes the difference between an exploit and a vulnerability?",
    "choice_a": "An exploit is a potential weakness in software, and a vulnerability is a potential weakness in hardware.",
    "choice_b": "A vulnerability is a potential weakness in a system, and an exploit is a hardware or software element that is designed to take advantage of a vulnerability.",
    "choice_c": "An exploit is a potential weakness in a system, and a vulnerability is a hardware or software element that is designed to take advantage of a vulnerability.",
    "choice_d": "A vulnerability is a potential weakness in software, and an exploit is a potential weakness in hardware.",
    "correct_answer": "B",
    "explanation": "A vulnerability is a weakness, whether in software or hardware, of which an exploit is designed to take advantage. Neither term is specific to hardware or software.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      365,
      364,
      363,
      387,
      366
    ],
    "source": "9781394239306"
  },
  {
    "id": 1293,
    "question": "Which of the following is the best description of a software product with a zero-day vulnerability?",
    "choice_a": "A product with a vulnerability that has just been addressed by a newly released fix",
    "choice_b": "A product with a vulnerability that has been addressed by a fix that nearly all users have applied",
    "choice_c": "A vulnerability in a newly released product for which no fix has yet been developed",
    "choice_d": "A vulnerability in a product that no attackers have yet discovered or exploited",
    "correct_answer": "C",
    "explanation": "A zero-day vulnerability is a serious software problem with a potential for exploitation in a newly released software product. The vulnerability has not yet been discovered, addressed, or patched by the software's developer, but it has been discovered by potential attackers. A zero-day vulnerability is one that has not yet been patched or fixed.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      364,
      365,
      363,
      387,
      392
    ],
    "source": "9781394239306"
  },
  {
    "id": 1294,
    "question": "As part of her company's new risk management initiative, Alice has been assigned the task of performing a threat assessment for the firm's data resources. For each potential threat she discovers, which of the following elements should Alice estimate? (Choose all that apply.)",
    "choice_a": "Severity",
    "choice_b": "Mitigation",
    "choice_c": "Likelihood",
    "choice_d": "Posture",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "A threat assessment should estimate the potential severity of a threat, such as the damage that the loss of a specific resource can cause to the organization. The assessment should also estimate the likelihood of a particular threat occurring, as the organization will have to devote more attention to the more likely threats. An assessment of the organization's current posture (or status) with regard to a specific threat and the mitigation techniques used to counter it are both elements that come later in the risk management process, after the threat assessment has been completed.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      363,
      381,
      364,
      380,
      379
    ],
    "source": "9781394239306"
  },
  {
    "id": 1295,
    "question": "Alice has been assigned the task of examining her department's order entry procedure to determine whether it meets established cost, quality, and timeliness goals. Which of the following is the best term for this examination?",
    "choice_a": "Vendor assessment",
    "choice_b": "Process assessment",
    "choice_c": "Business assessment",
    "choice_d": "Risk assessment",
    "correct_answer": "B",
    "explanation": "A process assessment is an examination of an existing procedure to determine its compliance with a specific set of goals that can include cost, quality, and timeliness. A vendor assessment is an examination of the organization's relationship with a specific business partner. <i>Business assessment</i> and <i>risk assessment</i> are more general terms that can include process assessments.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      380,
      378,
      395,
      377,
      392
    ],
    "source": "9781394239306"
  },
  {
    "id": 1296,
    "question": "Which of the following standards defines a framework for the authentication process but does not specify the actual authentication mechanism?",
    "choice_a": "WPA",
    "choice_b": "EAP",
    "choice_c": "TKIP",
    "choice_d": "TLS",
    "correct_answer": "B",
    "explanation": "Extensible Authentication Protocol (EAP) is a framework for the encapsulation of authentication messages. EAP is used on wireless networks and point-to-point connections and supports dozens of different authentication methods. Wi-Fi Protected Access (WPA) is a wireless encryption standard. Temporal Key Integrity Protocol (TKIP) is an encryption algorithm. Transport Layer Security (TLS) is an encryption protocol used for Internet communications. Bring your own device (BYOD) is a policy allowing users to connect their personal smartphones or other devices to the company network.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      397,
      374,
      371,
      377,
      381
    ],
    "source": "9781394239306",
    "choice_e": "BYOD"
  },
  {
    "id": 1297,
    "question": "A wireless network is configured to allow clients to authenticate only when the signal strength of their connections exceeds a specified level. Which of the following terms best describes this configuration?",
    "choice_a": "Local authentication",
    "choice_b": "Port security",
    "choice_c": "Geofencing",
    "choice_d": "Motion detection",
    "correct_answer": "C",
    "explanation": "<i>Geofencing</i> is the generic term for a technology that limits access to a network or other resource based on the client's location. In wireless networking, geofencing is intended to prevent unauthorized clients outside the facility from connecting to the network. Local authentication is an application or service that triggers an authentication request to which the user must respond before access is granted. Port security is a method for protecting access to switch ports. Motion detection is a system designed to trigger a notification or alarm when an individual trespasses in a protected area.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      397,
      377,
      400,
      394,
      376
    ],
    "source": "9781394239306"
  },
  {
    "id": 1298,
    "question": "Which of the following best describes a wireless network that uses geofencing as a security mechanism?",
    "choice_a": "A wireless network that allows clients to authenticate only when the signal strength of their connections exceeds a specified level",
    "choice_b": "A wireless network that requires users to log on to a wired system before they can authenticate on a wireless device",
    "choice_c": "A wireless network that requires users to have an Active Directory account located within the local site",
    "choice_d": "A wireless network that requires users to type in the local SSID before they can authenticate",
    "correct_answer": "A",
    "explanation": "Geofencing is a mechanism that is intended to prevent unauthorized clients outside the facility from connecting to the network. The mechanism can take the form of a signal strength or power level requirement, a GPS location requirement, or strategic placement of the antennae for wireless access points. The other options listed are not descriptions of typical geofencing technologies.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      400,
      395,
      385,
      392,
      404
    ],
    "source": "9781394239306"
  },
  {
    "id": 1299,
    "question": "Which of the following elements associates a public and private key pair to the identity of a specific person or computer?",
    "choice_a": "Exploit",
    "choice_b": "Signature",
    "choice_c": "Certificate",
    "choice_d": "Resource record",
    "correct_answer": "C",
    "explanation": "As part of the key management element of a public key infrastructure (PKI), digital certificates are associated with a key pair, consisting of a public key and a private key. The certificate is issued to a person or computer as proof of identity. An exploit is a hardware or software element that is designed to take advantage of a vulnerability. A signature does not associate a person or computer with a key pair. Resource records are associated with the Domain Name System (DNS).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      368,
      381,
      367,
      393,
      377
    ],
    "source": "9781394239306"
  },
  {
    "id": 1300,
    "question": "Which of the following mitigation techniques helps organizations maintain compliance with standards such as HIPAA and FISMA?",
    "choice_a": "File integrity monitoring",
    "choice_b": "Role separation",
    "choice_c": "Deauthentication",
    "choice_d": "Tamper detection",
    "correct_answer": "A",
    "explanation": "File integrity monitoring (FIM) is a process that typically consists of a comparison of files in their current state to a known baseline copy stored elsewhere. The comparison can be direct, or it could involve the calculation of checksums or other types of file hashes. The object of the comparison is to detect changes in documents, both in content and in sensitive areas, such as credentials, privileges, and security settings, which might indicate the presence of a potential or actual security breach. Role separation applies to the deployment of applications on servers. Deauthentication is a type of wireless network attack. <i>Tamper detection</i> is a term used to describe a physical security measure for hardware. Router Advertisement (RA) guard is a feature found on certain switches that prevents the misuse of RA messages to redirect traffic.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      378,
      379,
      366,
      376,
      380
    ],
    "source": "9781394239306",
    "choice_e": "Router Advertisement guard"
  },
  {
    "id": 1301,
    "question": "Which of the following functions cannot be implemented using digital signatures?",
    "choice_a": "Integrity",
    "choice_b": "Nonrepudiation",
    "choice_c": "Segmentation",
    "choice_d": "Authentication",
    "correct_answer": "C",
    "explanation": "Digital signatures can be used for the following functions: authentication, to confirm that data originated from a specific individual; nonrepudiation, to prevent the sender from denying the data's origin; and integrity, to confirm that the data has not been modified in transit. Segmentation is not a function of digital signatures.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      368,
      366,
      370,
      369,
      371
    ],
    "source": "9781394239306"
  },
  {
    "id": 1302,
    "question": "When Ralph digitally signs and encrypts a document with his private key, Alice can decrypt the document only by using Ralph's public key. As long as the private key is accepted to be secure, which of the following statements are true? (Choose all that apply.)",
    "choice_a": "Ralph cannot deny having created the document.",
    "choice_b": "No one has altered the document since Ralph sent it.",
    "choice_c": "No one but Ralph could have created the document.",
    "choice_d": "No one but Alice can decrypt and read the document.",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Because only Ralph possesses the private key, only he could have signed and encrypted it. Although it is possible for someone other than Alice to have decrypted the document while it was in transit, using Ralph's public key, that individual could not have modified it and encrypted it again.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      368,
      367,
      366,
      393,
      383
    ],
    "source": "9781394239306"
  },
  {
    "id": 1303,
    "question": "When Alice encrypts a document with Ralph's public key, Ralph can decrypt the document only by using his private key. As long as the private key is accepted to be secure, which of the following statements are true? (Choose all that apply.)",
    "choice_a": "Alice cannot deny having created the document.",
    "choice_b": "No one has opened the document since Alice sent it.",
    "choice_c": "No one but Alice can have created the document.",
    "choice_d": "No one but Ralph can decrypt and read the document.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Because anyone can obtain Ralph's public key, the document can have been created and encrypted by anyone. However, because only Ralph possesses the private key that can decrypt the document, he can be sure that no one else has opened it while it was in transit.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      368,
      367,
      366,
      383,
      393
    ],
    "source": "9781394239306"
  },
  {
    "id": 1304,
    "question": "Which of the following is the best description of geofencing?",
    "choice_a": "Something you do",
    "choice_b": "Something you know",
    "choice_c": "Something you have",
    "choice_d": "Somewhere you are",
    "correct_answer": "D",
    "explanation": "<i>Geofencing</i> is the generic term for a technology that limits access to a network or other resource based on the client's location. Therefore, it is best described as somewhere you are. A finger gesture would be considered something you do, a password something you know, and a smartcard something you have.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      371,
      377,
      376,
      397,
      398
    ],
    "source": "9781394239306"
  },
  {
    "id": 1305,
    "question": "The Internet of Things (IoT) and the Industrial Internet of Things (IIoT) encompass a huge number of device types ranging from personal electronics to household appliances to medical equipment to industrial control systems (ICS). Many of these devices deal with sensitive information, and many perform critically important tasks. The field of IoT security is still in its infancy; there is no all-encompassing standard defining IoT protection protocols. IoT devices have vastly different security requirements and also vastly different functional capabilities, making it difficult to create a blanket protection mechanism for all of them. Which of the following are potentially viable methods for securing all IoT devices against attack? (Choose two.)",
    "choice_a": "Firewalls",
    "choice_b": "Network access control",
    "choice_c": "Security gateways",
    "choice_d": "Network segmentation",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Because many IoT devices are mobile or located in unprotected areas, a firewall is not a viable protection mechanism for all of them, nor is the practice of placing them on separate network segments. Network security mechanisms such as access control policies and centralized gateways providing authentication and authorization could conceivably be incorporated into a general IoT security standard.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      370,
      374,
      397,
      394,
      392
    ],
    "source": "9781394239306"
  },
  {
    "id": 1306,
    "question": "Which of the following technologies associated with the Internet of Things (IoT) is often used to identify pets using embedded chips?",
    "choice_a": "Z-wave",
    "choice_b": "Bluetooth",
    "choice_c": "NFC",
    "choice_d": "RFID",
    "correct_answer": "D",
    "explanation": "Radio-frequency identification (RFID) uses tags containing data, frequently embedded in pets, which can be read using electromagnetic fields. Z-wave is a short-range wireless technology, frequently used for home automation. Bluetooth is a short-range wireless protocol, frequently used for computer peripherals and personal area networks (PANs). Near-field communication (NFC) provides wireless communication over ranges of 4 cm or less, and it is often used for contactless payment systems.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      399,
      398,
      402,
      392,
      404
    ],
    "source": "9781394239306"
  },
  {
    "id": 1307,
    "question": "Which of the following is typically not an example of the Internet of Things (IoT)?",
    "choice_a": "A key fob that unlocks your car",
    "choice_b": "A smartphone home automation app",
    "choice_c": "A remotely monitored cardiac pacemaker",
    "choice_d": "A seismic early warning system",
    "correct_answer": "A",
    "explanation": "A key fob that unlocks your car is typically a short-range radio or infrared device that does not use the Internet for its communications. Each of the other examples describes a device with an IP address that uses the Internet to communicate with a controller, monitoring station, or other equipment.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      399,
      392,
      397,
      395,
      363
    ],
    "source": "9781394239306",
    "choice_e": "Operational technology that controls industrial equipment"
  },
  {
    "id": 1308,
    "question": "Which of the following are available as Internet of Things (IoT) devices?",
    "choice_a": "Refrigerators",
    "choice_b": "Doorbells",
    "choice_c": "Thermostats",
    "choice_d": "Speakers",
    "correct_answer": "E",
    "explanation": "The IoT consists of devices that are ordinarily passive but which have been made intelligent by configuring them to participate on an IP network. All of the devices listed are available as \u201csmart\u201d devices that enable remote users to interact with them over the Internet.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      399,
      402,
      392,
      397,
      395
    ],
    "source": "9781394239306",
    "choice_e": "All of the above"
  },
  {
    "id": 1309,
    "question": "The terms <i>on-boarding</i> and <i>off-boarding</i> are typically associated with which of the following policies?",
    "choice_a": "Data loss prevention",
    "choice_b": "Incident response",
    "choice_c": "Inventory management",
    "choice_d": "Identity management",
    "correct_answer": "D",
    "explanation": "On-boarding and off-boarding are identity management processes in which users are added or removed from an organization's identity and access management (IAM) system. This grants new users the privileges they need to use the network, modifies their privileges if they change positions, and revokes privileges when they leave the company. On-boarding and off-boarding are not data loss prevention, incident response, inventory management, disaster recovery, or business continuity processes.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      377,
      376,
      375,
      370,
      380
    ],
    "source": "9781394239306",
    "choice_e": "Disaster recovery",
    "choice_f": "Business continuity"
  },
  {
    "id": 1310,
    "question": "The term <i>off-boarding</i> refers to which of the following procedures?",
    "choice_a": "Removing a node from a cluster",
    "choice_b": "Disconnecting all cables from a switch",
    "choice_c": "Revoking a user's network privileges",
    "choice_d": "Retiring old workstations",
    "correct_answer": "C",
    "explanation": "On-boarding and off-boarding are identity management processes in which users are added or removed from an organization's identity and access management (IAM) system. Off-boarding revokes a user's privileges when they leave the company. The term <i>off-boarding</i> does not refer to cluster management, disconnecting a switch, or retiring workstations.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      377,
      376,
      374,
      380,
      397
    ],
    "source": "9781394239306"
  },
  {
    "id": 1311,
    "question": "A server's firewall is configured using a default policy that does not allow any users remote access to the server unless an administrator creates a rule granting them access. Which of the following terms describes this default policy?",
    "choice_a": "Explicit allow",
    "choice_b": "Explicit deny",
    "choice_c": "Implicit allow",
    "choice_d": "Implicit deny",
    "correct_answer": "D",
    "explanation": "An implicit deny is a policy that denies access to a resource by default, without a user-specific rule defining that denial. This type of policy is part of a least privilege authorization philosophy. Creating a new rule denying access is an explicit deny. If anyone were able to access the server remotely by default, that would be an implicit allow. An explicit allow is a rule granting specific users remote access.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      376,
      394,
      395,
      377,
      392
    ],
    "source": "9781394239306"
  },
  {
    "id": 1312,
    "question": "Alice is a consultant working in your office who has been given the SSID and the passphrase for the company's main wireless network, but she is unable to connect with her laptop. Which of the following security measures might be preventing her from connecting?",
    "choice_a": "MAC filtering",
    "choice_b": "Disabling SSID broadcast",
    "choice_c": "Geofencing",
    "choice_d": "Using WPA2",
    "correct_answer": "A",
    "explanation": "MAC filtering takes the form of an access control list (ACL) on the wireless network's access points, listing the MAC addresses of all the devices that are to be permitted to access the network. If the MAC address of Alice's laptop is not included in the ACL, she will be unable to connect to the network. Alice has been given the service set identifier (SSID) of the network, so she should be able to connect, even if the access points are not broadcasting the SSID. Geofencing is intended to prevent users outside the office from accessing the network, so this should not be the problem. Alice has been given the passphrase for the network, so she should be able to configure WPA2 on her laptop. Alice is not using a separate guest network, so this is not preventing her from connecting.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      398,
      397,
      400,
      394,
      395
    ],
    "source": "9781394239306",
    "choice_e": "Guest network isolation"
  },
  {
    "id": 1313,
    "question": "Which of the following is a regulatory standard for the European Union?",
    "choice_a": "Payment Card Industry Data Security Standards (PCI DSS)",
    "choice_b": "Security information and event management (SIEM)",
    "choice_c": "General Data Protection Regulation (GDPR)",
    "choice_d": "Supervisory control and data acquisition (SCADA)",
    "correct_answer": "C",
    "explanation": "General Data Protection Regulation (GDPR) is a European Union (EU) standard defining the protection of information privacy. PCI DSS is a US standard governing the handling of credit cards. SIEM is a combined solution for gathering and analyzing information about a network's security events, and SCADA is an industrial control system architecture; neither is an EU standard.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      378,
      379,
      368,
      392,
      376
    ],
    "source": "9781394239306"
  },
  {
    "id": 1314,
    "question": "Ralph is a network administrator who wants to implement an access control scheme that allocates permissions based on an employee's job requirements. Which of the following is most suited to this type of implementation?",
    "choice_a": "Single sign-on (SSO)",
    "choice_b": "Mandatory access control (MAC)",
    "choice_c": "Confidentiality, integrity, and availability (CIA)",
    "choice_d": "Role-based access control (RBAC)",
    "correct_answer": "D",
    "explanation": "Role-based access control (RBAC) sets permissions based on each individual's job role or title, enabling administrators to create role configurations and apply them to multiple users. Single sign-on (SSO) allows a user to log on once with a single identity and then access multiple systems without the need to reauthenticate. Mandatory access control (MAC) is commonly used in government systems, which grant access to resources based on categorical assignments such as classified, secret, or top secret. Confidentiality, integrity, and availability are the elements that form the CIA triad, which is a common model used for the development of information security policies within an organization.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      376,
      370,
      377,
      374,
      371
    ],
    "source": "9781394239306"
  },
  {
    "id": 1315,
    "question": "A user calls the help desk complaining that he cannot access any of the data on his computer. A message has also appeared on his screen stating that his data has been encrypted and that it will only be decrypted after he pays $768 in digital currency to an unknown address. Which of the following types of attack has the user experienced?",
    "choice_a": "War driving",
    "choice_b": "Ransomware",
    "choice_c": "Denial-of-service",
    "choice_d": "ARP poisoning",
    "correct_answer": "B",
    "explanation": "Ransomware is a type of attack in which a user's access to their data is blocked unless a certain amount of money is paid to the attacker. The blockages can vary from simple screen locks to data encryption. War driving is an attack method that consists of driving around a neighborhood with a computer, scanning for unprotected wireless networks. Denial-of-service is a type of attack that overwhelms a computer with traffic, preventing it from functioning properly. Address Resolution Protocol (ARP) poisoning is the deliberate insertion of fraudulent information into the ARP cache stored on computers and switches.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      387,
      382,
      384,
      363,
      365
    ],
    "source": "9781394239306"
  },
  {
    "id": 1316,
    "question": "Which of the following attack types typically involves modifying network packets while they are in transit? (Choose all that apply.)",
    "choice_a": "Spoofing",
    "choice_b": "On-path",
    "choice_c": "Denial-of-service",
    "choice_d": "Logic bomb",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Spoofing is the process of modifying network packets to make them appear as though they are transmitted by or addressed to someone else. One way of doing this is to modify the MAC address in the packets to one that is approved by the MAC filter. An on-path (or man-in-the-middle) attack is one in which an attacker intercepts network traffic, reads the traffic, and can even modify it before sending it on to the destination. Denial-of-service is a type of attack that overwhelms a computer with traffic, preventing it from functioning properly, whereas a logic bomb is a code insert placed into a legitimate software product that triggers a malicious event when specific conditions are met. Neither of these last two involves modifying network packets.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      383,
      384,
      405,
      398,
      382
    ],
    "source": "9781394239306"
  },
  {
    "id": 1317,
    "question": "Which of the following types of attack involves the modification of a legitimate software product?",
    "choice_a": "Social engineering",
    "choice_b": "War driving",
    "choice_c": "Logic bomb",
    "choice_d": "Evil twin",
    "correct_answer": "C",
    "explanation": "A logic bomb is a code insert placed into a legitimate software product that triggers a malicious event when specific conditions are met. Social engineering is the practice of obtaining sensitive data by manipulating legitimate users, such as by pretending to be someone with a genuine need for that data. War driving is an attack method that consists of driving around a neighborhood with a computer, scanning for unprotected wireless networks. An evil twin is a fraudulent access point on a wireless network that mimics the SSID of a legitimate access point, in the hope of luring in users.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      387,
      365,
      388,
      391,
      363
    ],
    "source": "9781394239306"
  },
  {
    "id": 1318,
    "question": "Which of the following steps can help to prevent war driving attacks from compromising your wireless network? (Choose all that apply.)",
    "choice_a": "Configure your access point to use a longer SSID.",
    "choice_b": "Configure your access point not to broadcast its SSID.",
    "choice_c": "Configure your clients and access point to use WPA3 security.",
    "choice_d": "Configure your clients and access point to use WEP security.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Configuring the access point not to broadcast its SSID will prevent an unsophisticated war driving attacker from seeing the network. Configuring your equipment to use Wi-Fi Protected Access 3 (WPA3) security will make it difficult for a war driver who detects your network to connect to it. The SSID is just an identifier; its length has no effect on security. Wired Equivalent Privacy (WEP) is a security protocol that has been found to have serious weaknesses.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      405,
      392,
      367,
      385,
      397
    ],
    "source": "9781394239306"
  },
  {
    "id": 1319,
    "question": "Which of the following is the name for an attack in which an intruder uses a Bluetooth connection to steal information from a wireless device, such as a smartphone?",
    "choice_a": "Bluedogging",
    "choice_b": "Bluesnarfing",
    "choice_c": "Bluesmurfing",
    "choice_d": "Bluejacking",
    "correct_answer": "B",
    "explanation": "Bluesnarfing is an attack in which an intruder connects to a wireless device using Bluetooth, for the purpose of stealing information. Bluejacking is the process of sending unsolicited messages to a device using Bluetooth. The other options do not exist.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      405,
      385,
      367,
      363,
      364
    ],
    "source": "9781394239306"
  },
  {
    "id": 1320,
    "question": "Which of the following types of denial-of-service (DoS) attack does not involve flooding a server with traffic?",
    "choice_a": "Amplified",
    "choice_b": "Reflective",
    "choice_c": "Distributed",
    "choice_d": "Permanent",
    "correct_answer": "D",
    "explanation": "Although a denial-of-service (DoS) attack typically involves traffic flooding, any attack that prevents a server from functioning can be called a DoS attack. A permanent DoS attack is one in which the attacker actually damages the target system and prevents it from functioning. This can be a physical attack that actually damages the hardware, or the attacker can disable the server by altering its software or configuration settings. Flood-based attacks include the distributed denial-of-service (DDoS) attack, one in which the attacker uses hundreds or thousands of computers, controlled by malware and called bots or zombies, to send traffic to a single server or website, in an attempt to overwhelm it and prevent it from functioning. An amplified DoS attack is one in which the messages sent by the attacker require an extended amount of processing by the target servers, increasing the burden on them more than simpler messages would. A reflective DoS attack is one in which the attacker sends requests containing the target server's IP address to legitimate servers on the Internet, such as DNS servers, causing them to send a flood of responses to the target.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      382,
      405,
      366,
      387,
      363
    ],
    "source": "9781394239306"
  },
  {
    "id": 1321,
    "question": "Which of the following statements best describes the difference between distributed and reflective denial-of-service (DoS) attacks?",
    "choice_a": "A distributed DoS attack uses other computers to flood a target server with traffic, whereas a reflective DoS attack causes a server to flood itself with loopback messages.",
    "choice_b": "A distributed DoS attack uses malware-infected computers to flood a target, whereas a reflective DoS attack takes advantage of other servers' native functions to make them flood a target.",
    "choice_c": "A reflective DoS attack uses malware-infected computers to flood a target, whereas a distributed DoS attack takes advantage of other servers' native functions to make them flood a target.",
    "choice_d": "A distributed DoS attack floods multiple target computers with traffic, whereas a reflective DoS attack only floods a single target.",
    "correct_answer": "B",
    "explanation": "Distributed DoS attacks use hundreds or thousands of computers that have been infected with malware, called bots or zombies, to flood a target server with traffic, in an attempt to overwhelm it and prevent it from functioning. A reflective DoS attack is one in which the attacker sends requests containing the target server's IP address to legitimate servers on the Internet, such as DNS servers, causing them to send a flood of responses to the target. Neither attack type causes a computer to flood itself.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      382,
      405,
      384,
      363,
      366
    ],
    "source": "9781394239306"
  },
  {
    "id": 1322,
    "question": "Which of the following terms refers to a denial-of-service (DoS) attack that places more of a burden on the target server than just the flood of incoming traffic?",
    "choice_a": "Amplified",
    "choice_b": "Reflective",
    "choice_c": "Distributed",
    "choice_d": "Permanent",
    "correct_answer": "A",
    "explanation": "An amplified DoS attack is one in which the messages sent by the attacker require an extended amount of processing by the target servers, increasing the burden on them more than simpler messages would. Reflective and distributed DoS attacks use other computers to flood a target with traffic. A reflective DoS attack is one in which the attacker sends requests containing the target server's IP address to legitimate servers on the Internet, such as DNS servers, causing them to send a flood of responses to the target. A distributed denial-of-service (DDoS) attack is one in which the attacker uses a botnet consisting of hundreds or thousands of computers, controlled by malware and called bots or zombies, to send traffic to a single server or website, in an attempt to overwhelm it and prevent it from functioning. A permanent DoS attack is one in which the attacker actually damages the target system and prevents it from functioning.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      382,
      405,
      363,
      387,
      366
    ],
    "source": "9781394239306"
  },
  {
    "id": 1323,
    "question": "Which of the following types of attack require no additional hardware or software components? (Choose all that apply.)",
    "choice_a": "Brute-force",
    "choice_b": "Social engineering",
    "choice_c": "Denial-of-service",
    "choice_d": "Phishing",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "A brute-force attack is one in which an attacker uses repeated guesses to find a password, an open port, or some other type of sensitive data. A denial-of-service (DoS) attack floods a target server with traffic so that it is unable to function normally. While both of these attack types can be mounted using specialized software, they can also be the work of a lone attacker using nothing more than the tools provided on a standard workstation. Social engineering is the practice of obtaining sensitive data by contacting users and pretending to be someone with a legitimate need for that data. It requires nothing more than a telephone or an email client. <i>Phishing</i> is the term for an attack that uses bogus emails or websites designed to infect users with some type of malware.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      386,
      382,
      388,
      391,
      405
    ],
    "source": "9781394239306"
  },
  {
    "id": 1324,
    "question": "Which of the following attack types are specifically targeted at wireless network clients? (Choose all that apply.)",
    "choice_a": "Logic bomb",
    "choice_b": "Deauthentication",
    "choice_c": "Evil twin",
    "choice_d": "ARP poisoning",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Deauthentication is a type of denial-of-service (DoS) attack in which the attacker targets a wireless client by sending a deauthentication frame that causes the client to be disconnected from the network. The object of the attack is often to compel the client to connect to a rogue access point called an evil twin. An evil twin is a fraudulent access point on a wireless network that mimics the SSID of a legitimate access point, in the hope of luring in users. A logic bomb is a code insert placed into a legitimate software product that triggers a malicious event when specific conditions are met. ARP poisoning is the deliberate insertion of fraudulent information into the ARP cache stored on computers and switches. Neither of these last two is specifically targeted at wireless clients.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      385,
      382,
      405,
      384,
      400
    ],
    "source": "9781394239306"
  },
  {
    "id": 1325,
    "question": "Which of the following is an effective method for preventing sensitive data from being compromised through social engineering?",
    "choice_a": "Implement a program of user education and corporate policies.",
    "choice_b": "Install an antivirus software product on all user workstations.",
    "choice_c": "Install a firewall between the internal network and the Internet.",
    "choice_d": "Use IPsec to encrypt all network traffic.",
    "correct_answer": "A",
    "explanation": "Social engineering is the practice of obtaining sensitive data by contacting users and pretending to be someone with a legitimate need for that data. No software or hardware solution can prevent it; the only way is to educate users of the potential dangers and establish policies that inform users what to do when they experience a social engineering attempt. Social engineering is not a virus or other form of malware, so an antivirus product has no effect against it. Social engineering is not implemented in network traffic, so a firewall cannot filter it. Social engineering is not implemented in network traffic, so IPsec cannot protect it.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      388,
      391,
      392,
      380,
      371
    ],
    "source": "9781394239306"
  },
  {
    "id": 1326,
    "question": "Which of the following terms refer to denial-of-service (DoS) attacks that use other computers to flood a target server with traffic? (Choose all that apply.)",
    "choice_a": "Amplified",
    "choice_b": "Reflective",
    "choice_c": "Distributed",
    "choice_d": "Permanent",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Reflective and distributed DoS attacks use other computers to flood a target with traffic. A reflective DoS attack is one in which the attacker sends requests containing the target server's IP address to legitimate servers on the Internet, such as DNS servers, causing them to send a flood of responses to the target. A distributed denial-of-service (DDoS) attack is one in which the attacker uses hundreds or thousands of computers, controlled by malware and called bots or zombies, to send traffic to a single server or website, in an attempt to overwhelm it and prevent it from functioning. An amplified DoS attack is one in which the messages sent by the attacker require an extended amount of processing by the target servers, increasing the burden on them more than simpler messages would. A permanent DoS attack is one in which the attacker actually damages the target system and prevents it from functioning.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      382,
      405,
      363,
      387,
      366
    ],
    "source": "9781394239306"
  },
  {
    "id": 1327,
    "question": "In which of the following ways is VLAN hopping a potential threat?",
    "choice_a": "VLAN hopping enables an attacker to scramble a switch's patch panel connections.",
    "choice_b": "VLAN hopping enables an attacker to rename the default VLAN on a switch.",
    "choice_c": "VLAN hopping enables an attacker to access different VLANs using 802.1q spoofing.",
    "choice_d": "VLAN hopping enables an attacker to change the native VLAN on a switch.",
    "correct_answer": "C",
    "explanation": "VLAN hopping is a method for sending commands to switches to transfer a port from one VLAN to another. This can enable the attacker to connect their device to a potentially sensitive VLAN. VLAN hopping does not modify the switch's patch panel connections, only its VLAN assignments. It is not possible to rename a switch's default VLAN. VLAN hopping does not enable an attacker to change a switch's native VLAN.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      384,
      405,
      395,
      398,
      392
    ],
    "source": "9781394239306"
  },
  {
    "id": 1328,
    "question": "Which of the following types of attack can be used to enable an intruder to access a wireless network despite the protection provided by MAC filtering?",
    "choice_a": "Spoofing",
    "choice_b": "Brute-force",
    "choice_c": "DNS poisoning",
    "choice_d": "War driving",
    "correct_answer": "A",
    "explanation": "Spoofing is the process of modifying network packets to make them appear as though they are transmitted by or addressed to someone else. One way of doing this is to modify the MAC address in the packets to one that is approved by the MAC filter. Brute-force is the method of repeated guessing, which is impractical with MAC addresses. DNS works with IP addresses, not MAC addresses. War driving is the process of looking for unprotected wireless access points.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      398,
      384,
      405,
      383,
      386
    ],
    "source": "9781394239306"
  },
  {
    "id": 1329,
    "question": "Which of the following terms refers to a type of denial-of-service (DoS) attack that uses multiple computers to bombard a target server with traffic?",
    "choice_a": "Amplified",
    "choice_b": "Reflective",
    "choice_c": "Distributed",
    "choice_d": "Permanent",
    "correct_answer": "C",
    "explanation": "A distributed denial-of-service (DDoS) attack is one in which the attacker uses hundreds or thousands of computers, controlled by malware and called bots or zombies, to send traffic to a single server or website, in an attempt to overwhelm it and prevent it from functioning. An amplified DoS attack is one in which the messages sent by the attacker require an extended amount of processing by the target servers, increasing the burden on them more than simpler messages would. A reflective DoS attack is one in which the attacker sends requests containing the target server's IP address to legitimate servers on the Internet, such as DNS servers, causing them to send a flood of responses to the target. A permanent DoS attack is one in which the attacker actually damages the target system and prevents it from functioning.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      382,
      405,
      387,
      363,
      366
    ],
    "source": "9781394239306"
  },
  {
    "id": 1330,
    "question": "Which of the following terms refers to a type of denial-of-service (DoS) attack that bombards a target server with traffic that requires a large amount of processing?",
    "choice_a": "Amplified",
    "choice_b": "Reflective",
    "choice_c": "Distributed",
    "choice_d": "Permanent",
    "correct_answer": "A",
    "explanation": "An amplified DoS attack is one in which the messages sent by the attacker require an extended amount of processing by the target servers, increasing the burden on them more than simpler messages would. A reflective DoS attack is one in which the attacker sends requests containing the target server's IP address to legitimate servers on the Internet, such as DNS servers, causing them to send a flood of responses to the target. A distributed denial-of-service (DDoS) attack is one in which the attacker uses hundreds or thousands of computers, controlled by malware and called bots or zombies, to send traffic to a single server or website, in an attempt to overwhelm it and prevent it from functioning. A permanent DoS attack is one in which the attacker actually damages the target system and prevents it from functioning.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      382,
      405,
      387,
      363,
      364
    ],
    "source": "9781394239306"
  },
  {
    "id": 1331,
    "question": "Which of the following types of attack are rarely seen anymore because of changes in device design that were specifically designed to prevent them? (Choose all that apply.)",
    "choice_a": "VLAN hopping",
    "choice_b": "Logic bomb",
    "choice_c": "Phishing",
    "choice_d": "Smurf",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Smurf attacks rely on routers to forward broadcast traffic. Routers no longer forward broadcast messages, so smurf attacks have been rendered ineffective. In the same way, VLAN hopping, which is a method for sending commands to switches to transfer a port from one VLAN to another, is rarely seen because switches are now designed to prevent them. A logic bomb is a code insert placed into a legitimate software product that triggers a malicious event when specific conditions are met. <i>Phishing</i> is the term for a bogus email or website designed to infect users with some type of malware. Both of these are still commonly used attack types.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      382,
      405,
      384,
      387,
      392
    ],
    "source": "9781394239306"
  },
  {
    "id": 1332,
    "question": "Which of the following terms refers to a denial-of-service (DoS) attack in which an attacker breaks into a company's datacenter and smashes its servers with a sledgehammer?",
    "choice_a": "Distributed",
    "choice_b": "Amplified",
    "choice_c": "Reflective",
    "choice_d": "Permanent",
    "correct_answer": "D",
    "explanation": "Although denial-of-service (DoS) attacks typically involve traffic flooding, any attack that prevents a server from functioning can be called a DoS attack. A permanent DoS attack is one in which the attacker actually damages the target system and prevents it from functioning. This can be a physical attack that damages the hardware, or the attacker can disable the server by altering its software or configuration settings. A distributed denial-of-service (DDoS) attack is one in which the attacker uses hundreds or thousands of computers, controlled by malware and called bots or zombies, to send traffic to a single server or website, in an attempt to overwhelm it and prevent it from functioning. An amplified DoS attack is one in which the messages sent by the attacker require an extended amount of processing by the target servers, increasing the burden on them more than simpler messages would. A reflective DoS attack is one in which the attacker sends requests containing the target server's IP address to legitimate servers on the Internet, such as DNS servers, causing them to send a flood of responses to the target.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      382,
      405,
      366,
      363,
      389
    ],
    "source": "9781394239306"
  },
  {
    "id": 1333,
    "question": "Which of the following terms refers to a denial-of-service (DoS) attack that involves zombies?",
    "choice_a": "Reflective",
    "choice_b": "Amplified",
    "choice_c": "Distributed",
    "choice_d": "Permanent",
    "correct_answer": "C",
    "explanation": "Distributed DoS attacks use hundreds or thousands of computers that have been infected with malware, called bots or zombies, to flood a target server with traffic, in an attempt to overwhelm it and prevent it from functioning. A reflective DoS attack is one in which the attacker sends requests containing the target server's IP address to legitimate servers on the Internet, such as DNS servers, causing them to send a flood of responses to the target. A reflective attack does not require infected computers; it takes advantage of the servers' native functions. An amplified DoS attack is one in which the messages sent by the attacker require an extended amount of processing by the target servers, increasing the burden on them more than simpler messages would. A permanent DoS attack is one in which the attacker actually damages the target system and prevents it from functioning.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      382,
      405,
      387,
      363,
      384
    ],
    "source": "9781394239306"
  },
  {
    "id": 1334,
    "question": "Which of the following types of attack can cause a user's attempts to connect to an Internet website to be diverted to an attacker's website instead?",
    "choice_a": "Evil twin",
    "choice_b": "ARP poisoning",
    "choice_c": "Spoofing",
    "choice_d": "DNS poisoning",
    "correct_answer": "D",
    "explanation": "DNS poisoning is a type of attack in which an attacker adds fraudulent information into the cache of a DNS server. Then, when a client attempts to resolve the name of a website or other server, the DNS server supplies the incorrect IP address, causing the client to access the attacker's server instead. An evil twin is a rogue wireless access point on a network. ARP poisoning is the deliberate insertion of fraudulent information into the ARP cache stored on computers and switches, which can interfere with the resolution of IP addresses into MAC addresses on a local level. Spoofing is the process of modifying network packets to make them appear as though they are transmitted by or addressed to someone else.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      383,
      405,
      384,
      385,
      363
    ],
    "source": "9781394239306"
  },
  {
    "id": 1335,
    "question": "Which of the following functions can be interfered with by a DNS poisoning attack?",
    "choice_a": "IP address resolution",
    "choice_b": "Name resolution",
    "choice_c": "Password protection",
    "choice_d": "Network switching",
    "correct_answer": "B",
    "explanation": "DNS poisoning is a type of attack in which an attacker adds fraudulent information into the cache of a DNS server. This can interfere with the name resolution process by causing a DNS server to supply the incorrect IP address for a specified name. The process of resolving an IP address into a MAC address can be interfered with by ARP poisoning. DNS has nothing to do with passwords or switching.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      383,
      405,
      384,
      382,
      366
    ],
    "source": "9781394239306"
  },
  {
    "id": 1336,
    "question": "In testing the new application he has designed, Ralph has discovered that it contains a weakness that could enable an attacker to gain full administrative access. Which of the following is another term for this weakness?",
    "choice_a": "Exploit",
    "choice_b": "Mitigation",
    "choice_c": "Vulnerability",
    "choice_d": "Honeypot",
    "correct_answer": "C",
    "explanation": "A vulnerability is a potential weakness in a system that an attacker can use to their advantage. An exploit is a hardware or software element that is designed to take advantage of a vulnerability. A mitigation is a form of defense against attacks on system security. A honeypot is a computer configured to function as bait for attackers, causing them to waste their time penetrating a resource that provides no significant access.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      364,
      365,
      401,
      363,
      366
    ],
    "source": "9781394239306"
  },
  {
    "id": 1337,
    "question": "A senior IT administrator at your company was terminated two weeks ago. Today, Friday, you arrived at the office and found that all of the hosts in the web server farm had had their data deleted. There are no unauthorized entries to the datacenter recorded, but you suspect the terminated administrator is responsible. Which of the following attack types might the administrator have directed at the web server farm?",
    "choice_a": "Social engineering",
    "choice_b": "ARP poisoning",
    "choice_c": "Evil twin",
    "choice_d": "Logic bomb",
    "correct_answer": "D",
    "explanation": "A logic bomb is a code insert placed into a legitimate software product that triggers a malicious event when specific conditions are met. The terminated administrator might have created code designed to trigger the deletions after the administrator's departure from the company. Social engineering is a form of attack in which an innocent user is persuaded by an attacker to provide sensitive information via email or telephone. The Address Resolution Protocol (ARP) is responsible for resolving IP addresses into media access control (MAC) addresses. ARP poisoning is the deliberate insertion of fraudulent information into the ARP cache stored on computers and switches. An evil twin is a fraudulent access point on a wireless network.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      363,
      365,
      388,
      376,
      378
    ],
    "source": "9781394239306"
  },
  {
    "id": 1338,
    "question": "Which of the following attack types can be facilitated by ARP spoofing? (Choose all that apply.)",
    "choice_a": "Evil twin",
    "choice_b": "On-path",
    "choice_c": "Session hijacking",
    "choice_d": "Social engineering",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "ARP spoofing is the deliberate insertion of fraudulent information into the ARP cache stored on computers and switches. This can enable an attacker to intercept traffic intended for another system. In an on-path (man-in-the-middle) attack, the attacker can read the intercepted traffic and even modify it before sending it on to the destination. In a session hijacking attack, the attacker can use the intercepted traffic to obtain authentication information, including passwords. An evil twin is a fraudulent access point on a wireless network. Social engineering is a form of attack in which an innocent user is persuaded by an attacker to provide sensitive information via email or telephone.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      384,
      383,
      388,
      405,
      366
    ],
    "source": "9781394239306"
  },
  {
    "id": 1339,
    "question": "Which of the following statements best describes a type of replay attack?",
    "choice_a": "An intruder reenters a resource previously compromised by another intruder.",
    "choice_b": "An intruder retransmits captured authentication packets to gain access to a secured resource.",
    "choice_c": "An intruder uses the same technique that provided access to other resources to penetrate a new resource.",
    "choice_d": "An intruder accesses a resource that was accidentally left unsecured by an authorized user.",
    "correct_answer": "B",
    "explanation": "A replay attack is one in which an attacker utilizes the information found in previously captured packets to gain access to a secured resource. In many cases, the captured packets contain authentication data. In this way, the attacker can make use of captured passwords, even when they are encrypted and cannot be displayed. The other options all describe valid attack methodologies, but they are not called replay attacks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      383,
      384,
      405,
      386,
      382
    ],
    "source": "9781394239306"
  },
  {
    "id": 1340,
    "question": "Ed receives an email through his personal account, warning him that his checking account has been locked due to excessive activity. To confirm that the activity is fraudulent, the email instructs Ed to click the enclosed hyperlink, log on to his account, and review the list of charges. Ed clicks the link and is taken to a web page that appears to be that of his bank. He then supplies his username and password to log on. Which of the following specific types of attacks is Ed most likely to be experiencing?",
    "choice_a": "Evil twin",
    "choice_b": "Phishing",
    "choice_c": "Logic bomb",
    "choice_d": "Spoofing",
    "correct_answer": "B",
    "explanation": "This is a classic example of a phishing scam. In all likelihood, the link in the email Ed received has taken him not to the real website of his bank, but rather a duplicate created by an attacker. By supplying his logon credentials, he is in effect giving them to the attacker, who can now gain access to his real bank account. An evil twin is a fraudulent access point on a wireless network that mimics the SSID of a legitimate access point, in the hope of luring in users. A logic bomb is a code insert placed into a legitimate software product that triggers a malicious event when specific conditions are met. Spoofing is the process of modifying network packets to make them appear as though they are transmitted by or addressed to someone else.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      388,
      391,
      383,
      385,
      364
    ],
    "source": "9781394239306"
  },
  {
    "id": 1341,
    "question": "Which of the following attack types are specifically directed at wireless networks? (Choose all that apply.)",
    "choice_a": "Evil twin",
    "choice_b": "Phishing",
    "choice_c": "Deauthentication",
    "choice_d": "War driving",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "An evil twin is a fraudulent access point on a wireless network that mimics the SSID of a legitimate access point, in the hope of luring in users. War driving is an attack method that consists of driving around a neighborhood with a computer scanning for unprotected wireless networks. Deauthentication is a type of denial-of-service (DoS) attack in which the attacker targets a wireless client by sending a deauthentication frame that causes the client to be disconnected from the network. Phishing is an attack type that is targeted at all users, not just wireless ones.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      385,
      405,
      382,
      400,
      388
    ],
    "source": "9781394239306"
  },
  {
    "id": 1342,
    "question": "Which of the following are not considered to be denial-of-service (DoS) attacks? (Choose all that apply.)",
    "choice_a": "An intruder breaks into a company's datacenter and smashes their web servers with a sledgehammer.",
    "choice_b": "An attacker uses the ping command with the -t parameter to send a continuous stream of large ICMP packets to a specific server.",
    "choice_c": "An attacker captures the packets transmitted to and from a domain controller to obtain encrypted passwords.",
    "choice_d": "An attacker connects a rogue access point to a company's wireless network, using their SSID in the hope of attracting their users.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Capturing packets and installing rogue access points are not typically characterized as DoS attacks. A denial-of-service (DoS) attack is one designed to prevent a target from fulfilling its function. While ping floods are a common form of server DoS attacks, physically damaging the server hardware also prevents it from performing its function. Therefore, this too is a type of DoS attack. MAC flooding is another type of DoS attack that can overwhelm network switches, leading to a loss of confidentiality, integrity, and availability of network resources.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      382,
      405,
      385,
      404,
      389
    ],
    "source": "9781394239306",
    "choice_e": "An attacker bombards a switch with Ethernet frames in an attempt to replace the legitimate information in its MAC table."
  },
  {
    "id": 1343,
    "question": "In the hacker subculture, which of the following statements best describes a zombie?",
    "choice_a": "A computer that is remotely controllable because it has been infected by malware",
    "choice_b": "A computer that is no longer functioning because it is the target of a denial-of-service (DoS) attack",
    "choice_c": "A user that has fallen victim to a phishing attack",
    "choice_d": "A program that attackers use to penetrate passwords using brute-force attacks",
    "correct_answer": "A",
    "explanation": "A zombie (or bot) is a computer that has been infected by malware\u2014usually some form of Trojan\u2014which an attacker can control remotely, causing the computer to flood a target system with traffic. An attack using multiple zombies is known as a distributed denial-of-service (DDoS) attack. The other options are not examples of zombies.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      382,
      387,
      365,
      405,
      363
    ],
    "source": "9781394239306"
  },
  {
    "id": 1344,
    "question": "Which of the following statements best describes a ransomware attack?",
    "choice_a": "A website is rendered inaccessible by a denial-of-service (DoS) attack until its owner agrees to pay a fee.",
    "choice_b": "A user's access to a specific resource, such as a bank's website, is blocked until the user pays a fee.",
    "choice_c": "A message appears on a user's screen, stating that the system is locked and will only be released on payment of a fee.",
    "choice_d": "An application is supplied with limited usability until the user pays a license fee.",
    "correct_answer": "C",
    "explanation": "Ransomware is a type of attack in which a user's access to their computer or data is blocked unless a certain amount of money is paid to the attacker. The blockages can vary from simple screen locks to complete data encryption.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      387,
      366,
      363,
      364,
      382
    ],
    "source": "9781394239306"
  },
  {
    "id": 1345,
    "question": "Which of the following types of attacks requires no computer equipment?",
    "choice_a": "Denial-of-service",
    "choice_b": "Social engineering",
    "choice_c": "Brute-force",
    "choice_d": "Dictionary",
    "correct_answer": "B",
    "explanation": "Social engineering is the practice of obtaining sensitive data by contacting users and pretending to be someone with a legitimate need for that data. No computer equipment is required, and no software or hardware solution can prevent it; the only way is to warn users of the potential dangers and establish policies that inform users what to do when they experience a social engineering attempt. All of the other answer options require the use of some form of computer equipment to send traffic to or manipulate target systems. Denial-of-service is a type of attack that overwhelms a computer with traffic, preventing it from functioning properly. A brute-force or dictionary attack is one in which an attacker uses repeated guesses to find a password, an open port, or some other type of sensitive data. <i>Phishing</i> is the term for a bogus email or website designed to infect users with some type of malware.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      388,
      391,
      382,
      386,
      390
    ],
    "source": "9781394239306",
    "choice_e": "Phishing"
  },
  {
    "id": 1346,
    "question": "Which of the following best describes a brute-force attack?",
    "choice_a": "An attacker breaking down the door of a datacenter",
    "choice_b": "An attacker cracking a password by trying thousands of guesses",
    "choice_c": "An attacker using zombie computers to flood a server with traffic",
    "choice_d": "An attacker deploying an unauthorized access point on a wireless network",
    "correct_answer": "B",
    "explanation": "A brute-force attack (also called a dictionary attack) is one in which an attacker uses repeated guesses to find a password, an open port, or some other type of sensitive data. Brute-force does not refer to a physical attack. Flooding a server with traffic created by zombies is a distributed denial-of-service (DDoS) attack. Deploying an unauthorized access point is an evil twin attack.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      386,
      382,
      405,
      387,
      383
    ],
    "source": "9781394239306"
  },
  {
    "id": 1347,
    "question": "An intruder has deployed a rogue access point on your company's wireless network and is using it to access traffic generated by users who have accidentally connected to it. Which of the following is the name for this type of attack?",
    "choice_a": "Evil twin",
    "choice_b": "War driving",
    "choice_c": "Social engineering",
    "choice_d": "Spoofing",
    "correct_answer": "A",
    "explanation": "An evil twin is a fraudulent access point on a wireless network, which an intruder can use to obtain passwords and other sensitive information transmitted by users. <i>War driving</i> is the term for seeking out open wireless networks. Social engineering is a form of attack in which an innocent user is persuaded by an attacker to provide sensitive information via email or telephone. Spoofing is the process of modifying network packets to make them appear as though they are transmitted by or addressed to someone else.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      385,
      405,
      388,
      383,
      397
    ],
    "source": "9781394239306"
  },
  {
    "id": 1348,
    "question": "A person identifying herself as Trixie from the IT department telephones a user called Alice and tells her that there is a problem with her network user account that could cause all her data to be lost. Trixie says that to resolve the problem, she must log on using Alice's account and configure an important setting. All she needs to do this is Alice's account password. This call is, of course, an illicit attempt to learn Alice's password. Which of the following terms describes the type of attack that is currently occurring?",
    "choice_a": "On-path",
    "choice_b": "Spoofing",
    "choice_c": "Social engineering",
    "choice_d": "Evil twin",
    "correct_answer": "C",
    "explanation": "<i>Social engineering</i> is the term for a type of attack in which a smooth-talking intruder contacts a user and convinces them to disclose sensitive information, such as account passwords. An on-path (man-in-the-middle) attack is one in which an attacker intercepts network traffic, reads the traffic, and can even modify it before sending it on to the destination. Spoofing is the process of modifying network packets to make them appear as though they are transmitted by or addressed to someone else. An evil twin is a fraudulent access point on a wireless network.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      388,
      383,
      385,
      386,
      390
    ],
    "source": "9781394239306"
  },
  {
    "id": 1349,
    "question": "Regularly applying operating system updates and patches to network computers is an important mitigation procedure for which of the following security problems?",
    "choice_a": "Denial-of-service attacks",
    "choice_b": "Malware",
    "choice_c": "Social engineering",
    "choice_d": "Port security",
    "correct_answer": "B",
    "explanation": "Operating system updates and patches are frequently released to address newly discovered exploits that make computers vulnerable to malware infestation. Applying updates on a regular basis can help to mitigate the impact of malware. Updates and patches typically cannot mitigate DoS attacks, and they have no effect on nontechnical dangers such as social engineering or dangers that apply to switches, such as port security hazards.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      364,
      387,
      365,
      363,
      405
    ],
    "source": "9781394239306"
  },
  {
    "id": 1350,
    "question": "Which of the following is not a form of social engineering?",
    "choice_a": "Piggybacking",
    "choice_b": "Tailgating",
    "choice_c": "Shoulder surfing",
    "choice_d": "Dumpster diving",
    "correct_answer": "E",
    "explanation": "The term <i>social engineering</i> refers to various methods attackers can use to gain access to secured resources by manipulating authorized users, either physically or digitally. An evil twin is a rogue access point deliberately connected to the network for malicious purposes, so it is not a form of social engineering. Piggybacking and tailgating typically refer to the practice of closely following an authorized individual through a physical security barrier, such as a locked door or a guarded entrance. Shoulder surfing is a method of gathering sensitive information by passing behind a user and looking at their monitor. Dumpster diving is the process of looking for valuable network or user information in the trash.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      388,
      385,
      389,
      390,
      391
    ],
    "source": "9781394239306",
    "choice_e": "Evil twin"
  },
  {
    "id": 1351,
    "question": "Which of the following types of attack can best be prevented by implementing a program of employee education and training?",
    "choice_a": "Social engineering",
    "choice_b": "War driving",
    "choice_c": "Logic bomb",
    "choice_d": "Evil twin",
    "correct_answer": "A",
    "explanation": "Social engineering is the practice of obtaining sensitive data by manipulating legitimate users, such as by pretending to be someone with a genuine need for that data. Because it is not a technological vulnerability, the only means of preventing this type of attack is to educate and train users to recognize potential threats. War driving is an attack method that consists of driving around a neighborhood with a computer, scanning for unprotected wireless networks. A logic bomb is a code insert placed into a legitimate software product that triggers a malicious event when specific conditions are met. An evil twin is a fraudulent access point on a wireless network that mimics the SSID of a legitimate access point, in the hope of luring in users.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      388,
      391,
      392,
      385,
      387
    ],
    "source": "9781394239306"
  },
  {
    "id": 1352,
    "question": "A technician in the IT department at your company was terminated today and had to be escorted from the building. Your supervisor has instructed you to disable all of the technician's accounts, change all network device passwords to which the technician had access, and have the datacenter doors rekeyed. Which of the following terms best describes your supervisor's concern in asking you to do these things?",
    "choice_a": "Social engineering",
    "choice_b": "Internal threats",
    "choice_c": "Logic bombs",
    "choice_d": "War driving",
    "correct_answer": "B",
    "explanation": "Your supervisor's concern is that the disgruntled technician might take advantage of his access to devices and facilities to sabotage the network. When an individual takes advantage of information gathered during their employment, it is called an internal (or insider) threat. An external threat is one originating from a non-employee. Social engineering is a form of attack in which an innocent user is persuaded by an attacker to provide sensitive information via email or telephone. A logic bomb is a code insert placed into a legitimate software product that triggers a malicious event when specific conditions are met. War driving is an attack method that consists of driving around a neighborhood with a computer scanning for unprotected wireless networks.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      363,
      376,
      392,
      380,
      389
    ],
    "source": "9781394239306",
    "choice_e": "External threats"
  },
  {
    "id": 1353,
    "question": "Which of the following statements about DHCP snooping is not true?",
    "choice_a": "DHCP snooping detects rogue DHCP servers.",
    "choice_b": "DHCP snooping is implemented in network switches.",
    "choice_c": "DHCP snooping drops DHCP messages arriving over the incorrect port.",
    "choice_d": "DHCP snooping prevents DNS spoofing.",
    "correct_answer": "D",
    "explanation": "DHCP snooping is a feature found in some network switches that prevents rogue DHCP servers from assigning IP addresses to clients. It can also detect when DHCP release or decline messages arrive over a port other than the one on which the DHCP transaction originated. Although DHCP snooping can prevent DHCP clients from being assigned an incorrect IP address, it does not directly prevent DNS spoofing, the poisoning of DNS server caches with erroneous information.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      385,
      383,
      405,
      395,
      384
    ],
    "source": "9781394239306"
  },
  {
    "id": 1354,
    "question": "Which of the following are terms for an area of an enterprise network, separated by firewalls, that contains servers that must be accessible both from the Internet and from the internal network? (Choose all that apply.)",
    "choice_a": "Intranet",
    "choice_b": "Screened subnet",
    "choice_c": "EGP",
    "choice_d": "Stateless network",
    "correct_answer": [
      "B",
      "E",
      "F"
    ],
    "explanation": "Servers that must be accessible both from the trusted internal network and from the untrusted Internet are typically located in an area of the enterprise called a screened subnet, a perimeter network, or a demilitarized zone (DMZ). This area is separated from both the Internet and the internal network by firewalls, which prevents unauthorized Internet users from accessing the internal network. <i>Intranet</i> is another term for the internal network. Exterior Gateway Protocol (EGP) is a type of routing protocol, and stateless is a type of firewall; neither apply to this definition.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      396,
      395,
      394,
      401,
      363
    ],
    "source": "9781394239306",
    "choice_e": "Perimeter network",
    "choice_f": "DMZ"
  },
  {
    "id": 1355,
    "question": "Which of the following terms describes a system that prevents computers from logging on to a network unless they have the latest updates and antimalware software installed?",
    "choice_a": "NAC",
    "choice_b": "LDAP",
    "choice_c": "RADIUS",
    "choice_d": "AES",
    "correct_answer": "A",
    "explanation": "Network access control (NAC) is a mechanism that defines standards of equipment and configuration that systems must meet before they can connect to the network. Lightweight Directory Access Protocol (LDAP) provides communication between directory service entities. RADIUS is an authentication, authorization, and accounting service for remote users connecting to a network. Advanced Encryption Standard (AES) is an encryption protocol used on wireless networks running the Wi-Fi Protected Access 2 or 3 (WPA2 or WPA3) security protocol.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      397,
      370,
      374,
      392,
      364
    ],
    "source": "9781394239306"
  },
  {
    "id": 1356,
    "question": "Which of the following are typical elements of a corporate password policy? (Choose all that apply.)",
    "choice_a": "Minimum password length",
    "choice_b": "Use of special characters",
    "choice_c": "Unique passwords",
    "choice_d": "Frequent password changes",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D"
    ],
    "explanation": "The longer the password, the more difficult it is to guess. Corporate policies typically require passwords of a minimum length. A larger character set also makes a password more difficult to guess, so requiring upper- and lowercase, numeric, and special characters is common. Changing passwords forces the attack process to start over, so policies typically require frequent password changes and prevent users from reusing passwords.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      392,
      380,
      386,
      378,
      377
    ],
    "source": "9781394239306"
  },
  {
    "id": 1357,
    "question": "Alice is implementing a new password policy that requires all users to change their passwords every seven days. What further modification can she make to the password policy to prevent users from thwarting the password change requirement?",
    "choice_a": "Specify a minimum password length.",
    "choice_b": "Require the use of special characters.",
    "choice_c": "Require the creation of unique passwords.",
    "choice_d": "Specify a maximum password change interval.",
    "correct_answer": "C",
    "explanation": "Requiring unique passwords can prevent users from thwarting a password change policy by reusing the same passwords over and over. Password length, password character sets, and password change interval maximums can do nothing to thwart a frequent password change policy.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      377,
      380,
      392,
      371,
      370
    ],
    "source": "9781394239306"
  },
  {
    "id": 1358,
    "question": "Which of the following are settings typically included in an account lockout policy? (Choose all that apply.)",
    "choice_a": "Account lockout duration",
    "choice_b": "Time allowed between attempts",
    "choice_c": "Account lockout threshold",
    "choice_d": "Reset account lockout threshold counter",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Account lockout threshold specifies the number of incorrect logon attempts that are allowed before the account is locked out. Account lockout duration is the amount of time that an account remains locked out. Reset account lockout threshold counter specifies the amount of time before the number of incorrect attempts is reset to zero. Account lockout policies typically do not include a setting that regulates the amount of time allowed between logon attempts.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      392,
      376,
      370,
      371,
      380
    ],
    "source": "9781394239306"
  },
  {
    "id": 1359,
    "question": "How do account lockouts help to prevent intruders from cracking passwords?",
    "choice_a": "By forcing users to select passwords of a minimum length",
    "choice_b": "By preventing users from entering incorrect passwords more than a specified number of times",
    "choice_c": "By preventing users from reusing the same passwords",
    "choice_d": "By requiring an additional authentication method, such as a fingerprint",
    "correct_answer": "B",
    "explanation": "Account lockouts limit the number of incorrect passwords that a user can enter. This prevents intruders from using a brute-force attack to crack the account by trying password after password. After a specified number of incorrect tries, the account is locked for a specified length of time or until an administrator unlocks it.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      386,
      370,
      371,
      392,
      376
    ],
    "source": "9781394239306"
  },
  {
    "id": 1360,
    "question": "Password policies frequently require users to specify complex passwords. Which of the following are characteristics of a complex password?",
    "choice_a": "Passwords that contain mixed upper- and lowercase letters, numbers, and symbols",
    "choice_b": "Passwords that exceed a specific length",
    "choice_c": "Passwords that do not duplicate a specific number of the user's previous passwords",
    "choice_d": "Passwords that do not duplicate the user's account name, birth date, or other personal information",
    "correct_answer": "A",
    "explanation": "Although all of the options are characteristics of a strong password, the definition of a complex password is one that expands the available character set by using a mixture of upper- and lowercase letters, numerals, and symbols. The larger the character set used to create passwords, the more difficult they are to guess.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      392,
      386,
      391,
      380,
      377
    ],
    "source": "9781394239306"
  },
  {
    "id": 1361,
    "question": "Password policies that contain a history requirement typically have which of the following limitations?",
    "choice_a": "Users cannot reuse recent passwords.",
    "choice_b": "Users cannot create passwords containing names of relatives.",
    "choice_c": "Users cannot create passwords containing names of historical figures.",
    "choice_d": "Users cannot create passwords that duplicate those of any other users on the network.",
    "correct_answer": "A",
    "explanation": "A history requirement in a password policy prevents users from specifying any one of their most recently used passwords. Although creating passwords using the names of relatives and historical figures is not recommended, it is not something that is easy to prevent. Each user maintains their own password history; there is no conflict with the passwords of other users.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      392,
      376,
      380,
      378,
      371
    ],
    "source": "9781394239306"
  },
  {
    "id": 1362,
    "question": "Account lockout policies are designed to protect against which of the following types of attack?",
    "choice_a": "Social engineering",
    "choice_b": "Spoofing",
    "choice_c": "Brute-force",
    "choice_d": "On-path",
    "correct_answer": "C",
    "explanation": "A brute-force password attack is one in which the perpetrator tries as many passwords as possible in an effort to guess or deduce the right one. Account lockout policies are intended to prevent this type of attack by limiting the number of incorrect password attempts. Social engineering is the practice of obtaining sensitive data by manipulating legitimate users, such as by pretending to be someone with a genuine need for that data. Spoofing is the process of modifying network packets to make them appear as though they are transmitted by or addressed to someone else. An on-path (or man-in-the-middle) attack is one in which an attacker intercepts network traffic, reads the traffic, and can even modify it before sending it on to the destination. Account lockout policies are not designed to protect against social engineering, spoofing, or on-path attacks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      386,
      370,
      388,
      392,
      363
    ],
    "source": "9781394239306"
  },
  {
    "id": 1363,
    "question": "Which of the following types of password policies are designed to prevent brute-force attacks? (Choose all that apply.)",
    "choice_a": "Password length policies",
    "choice_b": "Account lockout policies",
    "choice_c": "Password history policies",
    "choice_d": "Complex password policies",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "A brute-force password attack is one in which the perpetrator tries as many passwords as possible in an effort to guess or deduce the right one. Password length and complexity policies produce passwords that are harder to guess, making the attack statistically less likely to succeed. Account lockout policies are intended to prevent brute-force attacks by limiting the number of incorrect password attempts. Password history policies do not help to prevent brute-force attacks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      392,
      386,
      380,
      376,
      371
    ],
    "source": "9781394239306"
  },
  {
    "id": 1364,
    "question": "Which of the following is an implementation of network access control (NAC)?",
    "choice_a": "RADIUS",
    "choice_b": "802.1X",
    "choice_c": "LDAP",
    "choice_d": "TACACS+",
    "correct_answer": "B",
    "explanation": "Network access control (NAC) is a set of policies that define security requirements that clients must meet before they are permitted to connect to a network. 802.1X is a basic implementation of NAC. RADIUS and TACACS+ are authentication, authorization, and accounting (AAA) services. They are not NAC implementations themselves, although they can play a part in their deployment. Lightweight Directory Access Protocol (LDAP) provides directory service communications.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      397,
      370,
      374,
      375,
      398
    ],
    "source": "9781394239306"
  },
  {
    "id": 1365,
    "question": "Which of the following is not one of the roles involved in an 802.1X transaction?",
    "choice_a": "Supplicant",
    "choice_b": "Authenticator",
    "choice_c": "Authorizing agent",
    "choice_d": "Authentication server",
    "correct_answer": "C",
    "explanation": "An 802.1X transaction involves three parties: the supplicant, which is the client attempting to connect to the network; the authenticator, which is a switch or access point to which the supplicant is requesting access; and the authentication server, which is typically a RADIUS implementation that verifies the supplicant's identity. There is no party to the transaction called an authorizing agent.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      397,
      374,
      370,
      371,
      377
    ],
    "source": "9781394239306"
  },
  {
    "id": 1366,
    "question": "In an 802.1X transaction, what is the function of the supplicant?",
    "choice_a": "The supplicant is the service that issues certificates to clients attempting to connect to the network.",
    "choice_b": "The supplicant is the service that verifies the credentials of the client attempting to access the network.",
    "choice_c": "The supplicant is the network device to which the client is attempting to connect.",
    "choice_d": "The supplicant is the client user or computer attempting to connect to the network.",
    "correct_answer": "D",
    "explanation": "An 802.1X transaction involves three parties: the supplicant, which is the client attempting to connect to the network; the authenticator, which is a switch or access point to which the supplicant is requesting access; and the authentication server, which is typically a RADIUS implementation that verifies the supplicant's identity. The supplicant is not involved in issuing certificates.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      397,
      374,
      370,
      377,
      371
    ],
    "source": "9781394239306"
  },
  {
    "id": 1367,
    "question": "In an 802.1X transaction, what is the function of the authenticator?",
    "choice_a": "The authenticator is the service that issues certificates to clients attempting to connect to the network.",
    "choice_b": "The authenticator is the service that verifies the credentials of the client attempting to access the network.",
    "choice_c": "The authenticator is the network device to which the client is attempting to connect.",
    "choice_d": "The authenticator is the client user or computer attempting to connect to the network.",
    "correct_answer": "C",
    "explanation": "An 802.1X transaction involves three parties: the supplicant, which is the client attempting to connect to the network; the authenticator, which is a switch or access point to which the supplicant is requesting access; and the authentication server, which is typically a RADIUS implementation that verifies the supplicant's identity. The authenticator is not involved in issuing certificates.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      397,
      374,
      370,
      377,
      371
    ],
    "source": "9781394239306"
  },
  {
    "id": 1368,
    "question": "An 802.1X transaction involves three roles: the supplicant, the authenticator, and the authentication server. Of the three, which role typically takes the form of a RADIUS implementation?",
    "choice_a": "The supplicant",
    "choice_b": "The authenticator",
    "choice_c": "The authentication server",
    "choice_d": "None of the above",
    "correct_answer": "C",
    "explanation": "The authentication server role is typically performed by a Remote Authentication Dial-In User Service (RADIUS) server. In an 802.1X transaction, the supplicant is the client attempting to connect to the network, the authenticator is a switch or access point to which the supplicant is requesting access, and the authentication server verifies the client's identity.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      397,
      374,
      370,
      375,
      377
    ],
    "source": "9781394239306"
  },
  {
    "id": 1369,
    "question": "Which of the following types of servers are typically found in a screened subnet? (Choose all that apply.)",
    "choice_a": "Domain controllers",
    "choice_b": "DHCP servers",
    "choice_c": "Web servers",
    "choice_d": "Email servers",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "A network segment that is separated from the trusted zone (the internal network) by a firewall and exposed to the untrusted zone (the Internet) is called a screened subnet, a demilitarized zone (DMZ), or a perimeter network. Administrators typically use a screened subnet for servers that must be accessible by outside users, such as web and email servers. For security reasons, domain controllers and DHCP servers should be located on internal network segments, which are part of the trusted zone.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      396,
      395,
      392,
      394,
      401
    ],
    "source": "9781394239306"
  },
  {
    "id": 1370,
    "question": "EAP and 802.1X are components that help to provide which of the following areas of wireless network security?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Encryption",
    "choice_d": "Accounting",
    "correct_answer": "A",
    "explanation": "Extensible Authentication Protocol (EAP) and 802.1X are both components of an authentication mechanism used on many wireless networks. EAP and 802.1X do not themselves provide authorization, encryption, or accounting services.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      397,
      370,
      374,
      371,
      377
    ],
    "source": "9781394239306"
  },
  {
    "id": 1371,
    "question": "Which of the following can be described as wireless network hardening techniques? (Choose all that apply.)",
    "choice_a": "Encryption",
    "choice_b": "Authentication",
    "choice_c": "MAC filtering",
    "choice_d": "Social engineering",
    "correct_answer": [
      "A",
      "B",
      "C",
      "E"
    ],
    "explanation": "Encryption, authentication, MAC filtering, and antenna placement are all techniques for hardening a wireless network against attack. Social engineering is a type of attack in which an intruder contacts a user and convinces them to disclose sensitive information, such as account passwords; it is not specifically associated with wireless networks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      398,
      367,
      370,
      400,
      388
    ],
    "source": "9781394239306",
    "choice_e": "Antenna placement"
  },
  {
    "id": 1372,
    "question": "Despite having imposed password policies on his network, compelling users to change their passwords frequently, create passwords of a specific length, and use complex passwords, Ralph has had several reports of account penetrations. The victims of the incidents had all apparently shared a \u201ctip\u201d suggesting that users cycle through the names of their children, nephews, nieces, and other relatives when forced to create new passwords, changing letters to numbers as needed. Which of the following actions can Ralph take to remedy the situation without creating a larger problem?",
    "choice_a": "Distribute a list of common passwords that are insecure, such as those based on names, birth dates, etc.",
    "choice_b": "Modify the password policies to force users to change passwords more frequently.",
    "choice_c": "Assign the users long passwords consisting of random-generated characters and change them often.",
    "choice_d": "Change the password history policy to a value greater than the number of children in any user's family.",
    "correct_answer": "A",
    "explanation": "There are no policies that can prevent users from creating easily guessed passwords. The only action that can help is to educate users of the fact that attackers are frequently able to guess passwords by using information such as familiar names and dates. Forcing more frequent password changes would not compel users to alter their method for choosing passwords, nor would increasing the password history value. Assigning random passwords would address the issue, but user complaints and forgotten passwords would likely create greater problems than it would solve.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      388,
      391,
      386,
      370,
      380
    ],
    "source": "9781394239306"
  },
  {
    "id": 1373,
    "question": "Which of the following devices are likely to have default credentials configured into them that attackers might know? (Choose all that apply.)",
    "choice_a": "Wireless access points",
    "choice_b": "Windows servers",
    "choice_c": "Switches",
    "choice_d": "Routers",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Access points, switches, and routers all require authentication to access their administrative interfaces, and many have a standard username and password configured at the factory. The purchaser can modify the default credentials, but many people fail to do so. Windows servers do not have default credentials assigned; the installer is prompted to specify an Administrator password during the setup process.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      392,
      386,
      388,
      377,
      363
    ],
    "source": "9781394239306"
  },
  {
    "id": 1374,
    "question": "One of the basic principles of network device hardening is to use secure protocols. Which of the following suggestions comply with this principle? (Choose all that apply.)",
    "choice_a": "Use SSH instead of Telnet.",
    "choice_b": "Use WEP instead of WPA2.",
    "choice_c": "Use TKIP instead of AES.",
    "choice_d": "Use HTTPS instead of HTTP.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Secure Shell (SSH) and Telnet are both remote terminal programs, but Telnet passes instructions (including passwords) in cleartext, whereas SSH is encrypted. Hypertext Transfer Protocol Secure (HTTPS) is the encrypted version of HTTP. In both of these cases, the suggested substitute is more secure. However, Temporal Key Integrity Protocol (TKIP) provides less secure encryption than Advanced Encryption Standard (AES), and Wired Equivalent Protocol (WEP) is less secure than Wi-Fi Protected Access 2 (WPA2).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      392,
      393,
      381,
      367,
      366
    ],
    "source": "9781394239306"
  },
  {
    "id": 1375,
    "question": "On which of the following types of devices should you consider disabling unused ports as a security precaution? (Choose all that apply.)",
    "choice_a": "Hubs",
    "choice_b": "Servers",
    "choice_c": "Switches",
    "choice_d": "Wireless access points",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Servers and switches are both devices on which unused ports can be a security hazard, but they use the term <i>port</i> differently. Servers have Application layer ports that permit specific types of service traffic to enter the server. Switches have ports to which administrators can connect computers and other devices. Both can provide attackers with unauthorized access to the device, so port security is an important administrative function. It is not possible to disable hub ports, and the access points used on enterprise networks typically have only a single port.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      393,
      398,
      392,
      394,
      395
    ],
    "source": "9781394239306"
  },
  {
    "id": 1376,
    "question": "For which of the following reasons is disabling the SSID broadcast of a wireless network to prevent unauthorized access a relatively weak method of device hardening?",
    "choice_a": "Attackers have ways of connecting to the network without the SSID.",
    "choice_b": "Attackers can capture packets transmitted over the network and read the SSID from them.",
    "choice_c": "Every access point's SSID is printed on a label on the back of the device.",
    "choice_d": "Attackers have software that can easily guess a network's SSID.",
    "correct_answer": "B",
    "explanation": "Disabling SSID broadcasts is a way of hiding the presence of a wireless network, but if an intruder knows that a network is there, it is a simple matter to capture packets transmitted by the wireless devices and read the SSID from them. It is not possible to connect to a wireless network without the SSID. SSIDs are set by the administrator of the access point; they are not printed on the device's label. SSIDs can be found relatively easily, but guessing them is no easier than guessing a password.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      392,
      385,
      405,
      367,
      397
    ],
    "source": "9781394239306"
  },
  {
    "id": 1377,
    "question": "Which of the following cannot be considered to be a server hardening policy?",
    "choice_a": "Disabling unnecessary services",
    "choice_b": "Leaving the default TCP and UDP ports open",
    "choice_c": "Upgrading firmware",
    "choice_d": "Creating privileged user accounts",
    "correct_answer": "B",
    "explanation": "Open TCP and UDP ports are a security hazard, so disabling unused ports is a standard server hardening technique. Disabling services that are not in use reduces the attack surface of a server. Updating firmware for hardware devices can help to protect them from deliberate attacks. Creating privileged user accounts reduces the chance that privileged accounts will be compromised. Therefore, these are all forms of server hardening.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      392,
      393,
      376,
      395,
      404
    ],
    "source": "9781394239306"
  },
  {
    "id": 1378,
    "question": "Which of the following are valid reasons not to disable unused switch ports? (Choose all that apply.)",
    "choice_a": "The datacenter is secured from unauthorized access.",
    "choice_b": "The unused ports are not patched in to wall jacks.",
    "choice_c": "The unused ports are left open to facilitate the on-boarding of new users.",
    "choice_d": "The switch is configured to use a MAC-based access control list.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "If there is no way for unauthorized people to access the datacenter, then there is no danger of someone plugging a device into a port that is left enabled. If the switch uses an access control list (ACL) that specifies the MAC addresses of systems permitted to connect to it, then there is no need to disable unused ports. However, disabling the ports is probably far easier than creating and maintaining the ACL. Ports that are not patched in can still be compromised at the switch location. Enabling ports is not difficult, so accommodating new users is not a valid reason for leaving them enabled.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      398,
      393,
      394,
      392,
      389
    ],
    "source": "9781394239306"
  },
  {
    "id": 1379,
    "question": "Which of the following Windows password policies includes a provision to prevent users from specifying common passwords?",
    "choice_a": "Maximum password age",
    "choice_b": "Enforce password history",
    "choice_c": "Minimum password length",
    "choice_d": "Passwords must meet complexity requirements",
    "correct_answer": "D",
    "explanation": "The \u201cPasswords must meet complexity requirements\u201d policy includes a provision that new passwords cannot include the user's account name or full name. If the full name is delimited by spaces or punctuation, the individual words cannot appear in the password either. The other options do not prevent the use of common passwords.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      392,
      371,
      386,
      372,
      374
    ],
    "source": "9781394239306"
  },
  {
    "id": 1380,
    "question": "Which of the following is not a method for hardening a wireless access point?",
    "choice_a": "Upgrading firmware",
    "choice_b": "Changing default credentials",
    "choice_c": "Generating new pre-shared keys",
    "choice_d": "Deauthentication",
    "correct_answer": "D",
    "explanation": "Deauthentication is a type of denial-of-service attack in which the attacker targets a wireless client by sending a deauthentication frame that causes the client to be disconnected from the network. Therefore, it is not a method for hardening an access point. Upgrading the device's firmware to apply security fixes, changing the default administrative credentials applied at the factory, and frequent pre-shared key (PSK) changes are all means of hardening the security of an access point.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      392,
      385,
      382,
      405,
      397
    ],
    "source": "9781394239306"
  },
  {
    "id": 1381,
    "question": "Creating a policy instructing users to avoid passwords that use commonly shared information, such as birth dates and the names of children and pets, is an example of which of the following?",
    "choice_a": "Mitigation techniques",
    "choice_b": "Multifactor authentication",
    "choice_c": "Network hardening",
    "choice_d": "Access control",
    "correct_answer": "C",
    "explanation": "<i>Network hardening</i> is term used to describe any method of making the network more difficult for intruders to penetrate. In many cases, network hardening techniques are based on education rather than technology. Compelling users to create passwords that are difficult to guess is one example of this. Mitigation techniques are methods for reducing the severity of an attack. Multifactor authentication calls for the use of two different identity confirmation mechanisms, such as a password and a fingerprint. Access control is a technique for creating a list of approved users or systems.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      392,
      371,
      376,
      370,
      377
    ],
    "source": "9781394239306"
  },
  {
    "id": 1382,
    "question": "Which of the following are the default administrative user accounts found in Windows and Linux operating systems? (Select two.)",
    "choice_a": "Administrator",
    "choice_b": "root",
    "choice_c": "admin",
    "choice_d": "Control",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Administrator is the default administrative user account in Windows, and root is the administrative account in Linux. Control and admin are not privileged user accounts provided with the operating systems.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      392,
      370,
      376,
      377,
      375
    ],
    "source": "9781394239306"
  },
  {
    "id": 1383,
    "question": "Which of the following are network segmentation methods that can prevent intruders from gaining full access to a network? (Choose all that apply.)",
    "choice_a": "ACL",
    "choice_b": "VLAN",
    "choice_c": "NAC",
    "choice_d": "Screened subnet",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Virtual LANs can be used to isolate systems on a separate network segment. A screened subnet, also called a demilitarized zone (DMZ) or a perimeter network, is a network segment accessible from the Internet and separated from the internal network by a firewall. Therefore, the screened subnet lies between the trusted (or private) zone and the untrusted (or public internet) zone. Both of these are methods for isolating systems to prevent security breaches from spreading beyond their bounds. Access control lists (ACLs) and network access control (NAC) are both methods for enhancing network security, but they are not segmentation methods.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      395,
      396,
      400,
      405,
      394
    ],
    "source": "9781394239306"
  },
  {
    "id": 1384,
    "question": "Which of the following types of mitigation techniques is not applicable to servers?",
    "choice_a": "Role separation",
    "choice_b": "Applying ACLs",
    "choice_c": "File integrity monitoring",
    "choice_d": "DHCP snooping",
    "correct_answer": "D",
    "explanation": "DHCP snooping is a feature found in some network switches that prevents rogue DHCP servers from assigning IP addresses to clients. It can also detect when DHCP release or decline messages arrive over a port other than the one on which the DHCP transaction originated. The other options are all techniques that are applicable to servers.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      385,
      398,
      393,
      392,
      394
    ],
    "source": "9781394239306"
  },
  {
    "id": 1385,
    "question": "Which of the following services are provided by access control lists (ACLs)?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Accounting",
    "choice_d": "Auditing",
    "correct_answer": "B",
    "explanation": "Access control lists (ACLs) define the type of access granted to authenticated users. This process is known as authorization. Authentication is the confirmation of a user's identity. Accounting and auditing are both methods of tracking and recording a user's activities on a network.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      370,
      394,
      376,
      377,
      395
    ],
    "source": "9781394239306"
  },
  {
    "id": 1386,
    "question": "Which of the following terms describes the threat mitigation technique of deploying individual applications and services on virtual servers so that no more than one is endangered at any one time, rather than deploying multiple applications on a single server?",
    "choice_a": "Geofencing",
    "choice_b": "Network segmentation",
    "choice_c": "Role separation",
    "choice_d": "VLAN hopping",
    "correct_answer": "C",
    "explanation": "Role separation is the practice of creating a different virtual server for each server role or application. In addition to providing other benefits as well, this forces intruders to mount attacks on multiple servers to disable an entire network. Geofencing is a technique for limiting access to a wireless network. Network segmentation describes the process of creating multiple VLANs or deploying firewalls to isolate part of a network. VLAN hopping is a type of attack in which an intruder sends command messages to a switch to transfer a port from one VLAN to another.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      395,
      384,
      405,
      396,
      400
    ],
    "source": "9781394239306"
  },
  {
    "id": 1387,
    "question": "Role separation is a threat mitigation technique that is applied to which of the following types of network components?",
    "choice_a": "Switches",
    "choice_b": "Servers",
    "choice_c": "Routers",
    "choice_d": "Wireless access points",
    "correct_answer": "B",
    "explanation": "Role separation is the practice of creating a different virtual server for each server role or application. In addition to providing other benefits as well, this forces intruders to mount attacks on multiple servers to disable an entire network. Switches, routers, and access points do not use this technique.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      395,
      376,
      400,
      392,
      363
    ],
    "source": "9781394239306"
  },
  {
    "id": 1388,
    "question": "Dynamic ARP inspection (DAI) is a feature in some network switches that prevents on-path (man in the middle) attacks facilitated by ARP poisoning, the deliberate insertion of fraudulent information into the ARP cache. A switch with DAI inspects incoming ARP packets and rejects those that contain incorrect pairs of IP and MAC addresses. Which of the following is the means by which the switch compiles a table of the correct ARP information for comparison with the incoming packets?",
    "choice_a": "DHCP snooping",
    "choice_b": "Secure SNMP",
    "choice_c": "DNS name resolution",
    "choice_d": "Neighbor Discovery Protocol (NDP)",
    "correct_answer": "A",
    "explanation": "Dynamic Host Configuration Protocol (DHCP) snooping is a process in which the switch examines DHCP traffic to determine the IP addresses that DHCP servers have assigned to specific MAC addresses. DAI detects ARP poisoning attempts by comparing the IP and MAC address pairs in ARP packets with those in the DHCP snooping table it has compiled. The switch then discards packets with address pairs that do not match. Secure SNMP, DNS name resolution, and Neighbor Discovery Protocol (NDP) are not used to implement DAI.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      385,
      384,
      383,
      394,
      395
    ],
    "source": "9781394239306"
  },
  {
    "id": 1389,
    "question": "At which layer of the OSI reference model does DHCP snooping operate?",
    "choice_a": "Physical",
    "choice_b": "Data link",
    "choice_c": "Network",
    "choice_d": "Transport",
    "correct_answer": "B",
    "explanation": "Although DHCP is an Application layer service that uses the UDP Transport layer protocol to assign Network layer IP addresses, DHCP snooping is a Data link layer process in which a network switch examines incoming DHCP traffic to determine whether it originates from an authorized server and is arriving over the correct port.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      385,
      395,
      397,
      394,
      398
    ],
    "source": "9781394239306",
    "choice_e": "Application"
  },
  {
    "id": 1390,
    "question": "Which of the following types of attacks on a network switch can a flood guard help to prevent?",
    "choice_a": "DNS poisoning",
    "choice_b": "War driving",
    "choice_c": "MAC flooding",
    "choice_d": "Evil twin",
    "correct_answer": "C",
    "explanation": "By flooding a switch with packets containing many different false MAC addresses, an attacker can cause the legitimate entries in the switch's MAC table to be aged out of the device and replaced with bogus entries. When the destinations of incoming packets are not found in the table, the switch broadcasts them throughout the network, where they can be more readily captured and compromised. A flood guard is a mechanism that prevents confirmed MAC addresses in the table from being replaced. A flood guard in a switch cannot protect against DNS poisoning, war driving, or evil twin attacks.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      398,
      405,
      384,
      382,
      383
    ],
    "source": "9781394239306"
  },
  {
    "id": 1391,
    "question": "Which of the following protocols is a root guard designed to affect?",
    "choice_a": "EAP",
    "choice_b": "STP",
    "choice_c": "LDAP",
    "choice_d": "ARP",
    "correct_answer": "B",
    "explanation": "A root guard affects the behavior of the Spanning Tree Protocol (STP) by enforcing the selection of root bridge ports on a switched network. Without root guards, there is no way for administrators to enforce the topology of a network with a redundant switching fabric. Root guards do not affect the Extensible Authentication Protocol (EAP), the Lightweight Directory Access Protocol (LDAP), or the Address Resolution Protocol (ARP).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      395,
      397,
      398,
      392,
      393
    ],
    "source": "9781394239306"
  },
  {
    "id": 1392,
    "question": "How does MAC address filtering increase the security of a wireless LAN?",
    "choice_a": "By preventing access points from broadcasting their presence",
    "choice_b": "By allowing traffic sent to or from specific MAC addresses through the Internet firewall",
    "choice_c": "By substituting registered MAC addresses for unregistered ones in network packets",
    "choice_d": "By permitting only devices with specified MAC addresses to connect to an access point",
    "correct_answer": "D",
    "explanation": "MAC address filtering enables administrators to configure an access point to allow only devices with specific addresses to connect; all other traffic is rejected. Access points broadcast their presence using an SSID, not a MAC address. MAC address filtering protects wireless LANs when implemented in an access point, not a firewall. MAC address filtering does not call for the modification of addresses in network packets. MAC filtering does not isolate clients from the network.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      398,
      397,
      405,
      395,
      400
    ],
    "source": "9781394239306",
    "choice_e": "By isolating specific wireless clients from the rest of the network"
  },
  {
    "id": 1393,
    "question": "MAC filtering is an access control method used by which of the following types of hardware devices?",
    "choice_a": "Wireless access points",
    "choice_b": "RADIUS servers",
    "choice_c": "Domain controllers",
    "choice_d": "Smartcards",
    "correct_answer": "A",
    "explanation": "Wireless access points (WAPs) typically include the ability to maintain an access control list, which specifies the MAC addresses of devices that are permitted to connect to the wireless network. The technique is known as MAC address filtering. RADIUS servers, domain controllers, and smartcards typically do not include MAC filtering capabilities.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      398,
      397,
      400,
      395,
      394
    ],
    "source": "9781394239306"
  },
  {
    "id": 1394,
    "question": "Which of the following technologies utilize access control lists to limit access to network resources? (Choose all that apply.)",
    "choice_a": "NTFS",
    "choice_b": "LDAP",
    "choice_c": "WAP",
    "choice_d": "Kerberos",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "NTFS files and folder all have access control lists (ACLs), which contain access control entries (ACEs) that specify the users and groups that can access them and the specific permissions they have been granted. Wireless access points (WAPs) have access control lists that contain the MAC addresses of the devices that are permitted to connect to the wireless network. Lightweight Directory Access Protocol and Kerberos are protocols that provide directory service communication and authentication, respectively. Neither one uses access control lists to limit network access.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      394,
      398,
      395,
      370,
      375
    ],
    "source": "9781394239306"
  },
  {
    "id": 1395,
    "question": "Which of the following is another term for a switching technique called port isolation?",
    "choice_a": "Frame Relay",
    "choice_b": "Private VLAN",
    "choice_c": "Site-to-site VPN",
    "choice_d": "Screened subnet",
    "correct_answer": "B",
    "explanation": "Port isolation, also known as private VLAN, is a feature in some switches that enables administrators to restrict selected ports to a given uplink, essentially creating a separate, secondary VLAN that is isolated from the switch's default, primary VLAN. Screened subnets (also called perimeter networks or DMZs), Frame Relay, and VPNs are not switching techniques.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      395,
      384,
      394,
      398,
      401
    ],
    "source": "9781394239306"
  },
  {
    "id": 1396,
    "question": "Which of the following statements accurately describe the difference between content filtering and URL filtering? (Choose all that apply.)",
    "choice_a": "URL filtering controls outbound traffic, while content filtering controls inbound traffic.",
    "choice_b": "Content filtering requires access to an outside database of objectionable sites, while URL filtering does not.",
    "choice_c": "URL filtering can provide protection against phishing attempts and other types of malware; content filtering cannot.",
    "choice_d": "Content filtering typically requires administrators to filter web content, email traffic, and executable files.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "URL filters examine the web addresses requested by users and prevent any outgoing traffic from being transmitted to them. Content filtering examines inbound traffic, looking for objectionable material, malware, and other potential dangers. Because network users have several avenues for potentially dangerous incoming traffic, a proper content filtering implementation typically screens all of them. It is URL filtering that requires access to an outside database. It is content filtering that provides protection against phishing attempts and other types of malware.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      394,
      395,
      388,
      387,
      382
    ],
    "source": "9781394239306"
  },
  {
    "id": 1397,
    "question": "Which of the following troubleshooting steps involves prioritizing trouble tickets based on the severity of the problem?",
    "choice_a": "Identify symptoms of the problem.",
    "choice_b": "Establish a theory of probable cause.",
    "choice_c": "Test the theory to determine the cause.",
    "choice_d": "Establish a plan of action to resolve the problem and identify potential effects.",
    "correct_answer": "A",
    "explanation": "The first step in troubleshooting is to identify the problem by establishing the symptoms related to the network issue being reported. In this step, problems are typically reported as trouble tickets, which are prioritized based on the severity of the problem. You complete the other steps after the trouble ticket has been prioritized and is being investigated.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      319,
      311,
      322,
      312,
      306
    ],
    "source": "9781394239306",
    "choice_e": "Implement the solution or escalate as necessary.",
    "choice_f": "Verify full system functionality and implement preventive measures, if applicable.",
    "choice_g": "Document findings, actions, outcomes, and lessons learned throughout the process."
  },
  {
    "id": 1398,
    "question": "Which of the following is considered a systemwide error?",
    "choice_a": "A problem with an order entry or customer service call center resource",
    "choice_b": "A problem with a router that affects only one local area network (LAN)",
    "choice_c": "A fatal error that causes a single computer to fail",
    "choice_d": "A problem with an email server that affects all network users",
    "correct_answer": "C",
    "explanation": "A systemwide error is a problem that renders an individual user's system (computer) completely unusable. All the other problems listed would affect more than one system or user.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      306,
      319,
      311,
      322,
      318
    ],
    "source": "9781394239306"
  },
  {
    "id": 1399,
    "question": "Which of the following is a networkwide problem?",
    "choice_a": "A problem with an order entry or customer service call center resource",
    "choice_b": "A fatal error that causes a single computer to fail",
    "choice_c": "A problem with an application server that affects a single local area network (LAN)",
    "choice_d": "A problem with a router that connects an entire network to the Internet",
    "correct_answer": "D",
    "explanation": "Any problem that affects all the users on the network is a networkwide problem and should be given the highest priority. An example of this would be a problem with an Internet router. All other problems listed do not affect the entire network.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      319,
      311,
      322,
      306,
      315
    ],
    "source": "9781394239306"
  },
  {
    "id": 1400,
    "question": "A user reports that she cannot connect to a server on her network. Ed wants to identify the scope of the problem, so he tries to reproduce the problem on the user's computer. The problem still remains. No other users are reporting this problem. What is the next logical step that Ed should perform to identify the affected area?",
    "choice_a": "Verify that the local router is forwarding traffic.",
    "choice_b": "Try performing the same task on another computer attached to the same segment.",
    "choice_c": "Verify that the server is configured properly.",
    "choice_d": "Verify that the switch the client is connected to is functioning.",
    "correct_answer": "B",
    "explanation": "In this scenario, only one user is reporting a problem. Therefore, the likeliest next step is to perform the same task on another computer attached to the same segment. If Ed can perform the task successfully, the problem most likely lies within the user's computer or the connection to the switch. Since no other users are reporting the same problem, the server and switches on the network are probably up and functioning. Checking the router is not necessary since the user and server are on the same network.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      311,
      322,
      318,
      304
    ],
    "source": "9781394239306"
  },
  {
    "id": 1401,
    "question": "Which of the following troubleshooting steps involves asking the user preliminary questions such as, \u201cWhat were you doing when the problem occurred?\u201d",
    "choice_a": "Identify the problem.",
    "choice_b": "Establish a theory of probable cause.",
    "choice_c": "Test the theory to determine the cause.",
    "choice_d": "Establish a plan of action to resolve the problem and identify potential effects.",
    "correct_answer": "A",
    "explanation": "The first step in troubleshooting is to identify the problem by establishing symptoms related to the network problem being reported. In this step, you ask the user many questions to identify and define the symptoms of the problem and prioritize the trouble ticket. Although you might continue to ask the user questions throughout the troubleshooting process, this is typically associated with the first step of the troubleshooting process.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      312,
      322,
      311,
      318,
      319
    ],
    "source": "9781394239306",
    "choice_e": "Implement the solution or escalate as necessary.",
    "choice_f": "Verify full system functionality and implement preventative measures, if applicable.",
    "choice_g": "Document findings, actions, and outcomes."
  },
  {
    "id": 1402,
    "question": "When troubleshooting, you begin by taking steps to identify the problem. Which of the following steps should you perform next?",
    "choice_a": "Implement the solution.",
    "choice_b": "Establish a plan of action.",
    "choice_c": "Establish a theory of probable cause.",
    "choice_d": "Verify full system functionality.",
    "correct_answer": "C",
    "explanation": "After identifying the problem, the next step is to establish a theory for the probable cause of the problem. After that, you can test your theory, establish a plan of action, implement a solution, verify the functionality of the system, and document the entire process.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      311,
      322,
      318,
      304,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1403,
    "question": "In which troubleshooting step do you try to duplicate a network problem to logically and methodically eliminate elements that are not the source of the problem?",
    "choice_a": "Identify the problem.",
    "choice_b": "Establish a theory of probable cause.",
    "choice_c": "Test the theory to determine the cause.",
    "choice_d": "Establish a plan of action to resolve the problem and identify potential effects.",
    "correct_answer": "B",
    "explanation": "The second step in troubleshooting is to attempt to duplicate a problem and develop a theory of its probable cause. As you troubleshoot a problem, you then test your theory to confirm your findings. You complete the other troubleshooting steps after the specific cause has been identified.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      311,
      322,
      304,
      312,
      318
    ],
    "source": "9781394239306",
    "choice_e": "Implement the solution or escalate as necessary.",
    "choice_f": "Verify full system functionality and implement preventative measures, if applicable.",
    "choice_g": "Document findings, actions, and outcomes."
  },
  {
    "id": 1404,
    "question": "Ralph is a first-tier technician working the help desk. After identifying a network problem submitted by multiple users, Ralph comes up with a theory specifying a possible source of the problem and sets about testing his theory. Unfortunately, testing indicates that Ralph's theory is wrong; the source he suspected is not the cause of the problem. Which of the following should not be the next step in Ralph's troubleshooting process?",
    "choice_a": "Reinterview the users to gather more information about the problem.",
    "choice_b": "Escalate the problem to a second-tier technician.",
    "choice_c": "Repeat the process of establishing a theory of probable cause.",
    "choice_d": "Begin replacing components that might contribute to the problem.",
    "correct_answer": "D",
    "explanation": "Replacing components by guesswork could resolve the problem through chance, but it would more likely be a waste of time and hardware. When Ralph's first theory is disproven, the next logical step would be to devise another theory. This could conceivably involve reinterviewing the users or escalating the issue to a senior technician. If the theory had been confirmed, the next step would be to devise a plan of action to resolve the problem.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      322,
      311,
      318,
      312,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1405,
    "question": "Ralph is a first-tier technician working the help desk. A user calls in, saying that when she turned her computer on that morning, nothing appeared on the screen. Which of the following should be Ralph's first question to the user?",
    "choice_a": "What is your computer's IP address?",
    "choice_b": "Have you applied the latest system updates?",
    "choice_c": "Are the computer and monitor plugged in to AC power?",
    "choice_d": "Has anyone else been using your computer?",
    "correct_answer": "C",
    "explanation": "In troubleshooting, one of the first steps in the process of identifying the problem is to question the obvious, such as whether the computer is plugged in or switched on. It would be unlikely that the user would know her computer's IP address or what updates had been installed when the screen is blank. Questioning whether other people have used the computer might come up later, but it will be little help at this stage of the troubleshooting process.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      311,
      322,
      312,
      320,
      303
    ],
    "source": "9781394239306"
  },
  {
    "id": 1406,
    "question": "You have a problem with a server or other network component that prevents many users from working. What type of problem is this?",
    "choice_a": "A networkwide problem",
    "choice_b": "A shared resource problem",
    "choice_c": "A systemwide problem",
    "choice_d": "A user application problem",
    "correct_answer": "B",
    "explanation": "If a problem lies within a specific server or other network component that prevents many users from working, it is a shared resource problem. A problem that lies within resources that provide services to the entire network is a networkwide problem. Systemwide problems put a specific computer out of commission, preventing a user from getting any work done. An application problem is a problem that affects only a single user's access to a device or application.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      306,
      319,
      311,
      318,
      315
    ],
    "source": "9781394239306"
  },
  {
    "id": 1407,
    "question": "A single Windows user suddenly cannot connect to any hosts on the network (local or remote). Alice interviews the user and finds out that he made some changes to his computer's Internet Protocol (IP) configuration properties. What should she do next?",
    "choice_a": "Run the ipconfig command to view the local configuration.",
    "choice_b": "Check the Domain Name System (DNS) server to see if it is resolving IP hostnames.",
    "choice_c": "Check the DHCP server for the local network to see if it is assigning IP addresses.",
    "choice_d": "Verify that the router is functioning.",
    "correct_answer": "A",
    "explanation": "Since only one user is reporting the problem, and he had admitted to making changes to his IP configuration, Alice should probably start by checking the configuration using the <code>ipconfig</code> command. If the router, DNS server, or DHCP server were causing the problem, more than one user would be experiencing difficulties.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      330,
      331,
      306,
      321,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1408,
    "question": "Alice has a network with a Domain Name System (DNS) server, a proxy server, and an Internet router. A user is complaining that she suddenly cannot connect to hosts on her own local area network (LAN) and other internal LANs, and she cannot access hosts on the Internet. What is the most likely problem?",
    "choice_a": "The user's local configuration",
    "choice_b": "The proxy server",
    "choice_c": "The DNS server",
    "choice_d": "The router",
    "correct_answer": "A",
    "explanation": "Since only one user is reporting the problem, the user's computer and its configuration are the likeliest suspect components. A DNS, proxy, or router problem would affect more than one user.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      322,
      312,
      303,
      321
    ],
    "source": "9781394239306"
  },
  {
    "id": 1409,
    "question": "Alice takes a call from a user who is unable to send email to a colleague in one of the company's branch offices. Alice begins by having the user try to send emails to different people at the branch office, to people in the local office, and to people on the Internet. She then checks the user's IP configuration settings, the computer's local LAN communication, and the cable connection to the network. Which of the following approaches is Alice using to troubleshoot the problem?",
    "choice_a": "OSI bottom-to-top",
    "choice_b": "Divide and conquer",
    "choice_c": "OSI top-to-bottom",
    "choice_d": "Question the obvious",
    "correct_answer": "C",
    "explanation": "Alice is using a top-to-bottom approach, based on the OSI reference model. She begins at the top of the model (the Application layer) by checking the system's email capabilities, then proceeds downwards to check the computer's IP configuration (the Network layer), the local network connectivity (the Data link layer), and the computer's cables (the Physical layer). A bottom-to-top approach would begin with the cables. The divide and conquer approach and questioning the obvious would not involve the steps Alice took in the order that she took them.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      318,
      311,
      322,
      312,
      304
    ],
    "source": "9781394239306"
  },
  {
    "id": 1410,
    "question": "Alice is working the help desk when a user calls and reports that she is unable to connect to the Internet. Which of the following steps is the one Alice is least likely to perform first when troubleshooting the problem?",
    "choice_a": "Check the configuration of the router connecting the LAN to the Internet.",
    "choice_b": "Ask the user if she can access resources on the local network.",
    "choice_c": "Check to see if anyone else is experiencing the same problem.",
    "choice_d": "Check the user's job title to see if she is an important person in the company.",
    "correct_answer": "A",
    "explanation": "There are many possible causes for the problem that are more likely than a router configuration error, so this is not something Alice would check first. Asking if the user can access the local network attempts to isolate the problem. If she cannot, the problem could be in her computer; if she can, then the problem lies somewhere in the Internet access infrastructure. If other users are experiencing the problem, then the issue should receive a higher priority, and Alice knows that the problem does not lie in the user's computer. While it might not be the first thing she checks, it is a political reality that higher ranking users often get preferential treatment.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      311,
      312,
      319,
      318,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1411,
    "question": "In the standard troubleshooting methodology, which of the following steps appears last but must actually be practiced throughout the troubleshooting process?",
    "choice_a": "Test the theory to determine the cause.",
    "choice_b": "Document findings, actions, outcomes, and lessons learned throughout the process.",
    "choice_c": "Verify full system functionality and implement preventive measures, if applicable.",
    "choice_d": "Implement the solution or escalate as necessary.",
    "correct_answer": "B",
    "explanation": "Documenting the findings, actions, outcomes, and lessons learned throughout the process is a crucial part of the troubleshooting method that must begin before any other action whatsoever. However, it appears as the last step in the troubleshooting methodology.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      311,
      322,
      319,
      304,
      320
    ],
    "source": "9781394239306",
    "choice_e": "Establish a plan of action to resolve the problem and identify potential effects.",
    "choice_f": "Establish a theory of probable cause.",
    "choice_g": "Identify the problem."
  },
  {
    "id": 1412,
    "question": "Which step of the troubleshooting model involves identifying whether hardware or software has been recently installed or reconfigured?",
    "choice_a": "Identify the problem.",
    "choice_b": "Establish a theory of probable cause.",
    "choice_c": "Establish a plan of action to resolve the problem and identify potential effects.",
    "choice_d": "Test the theory to determine the cause.",
    "correct_answer": "A",
    "explanation": "During the troubleshooting process, the identify the problem step includes determining what has changed recently on the system. This typically involves asking the user whether any new or existing hardware or software has been installed or reconfigured.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      322,
      311,
      312,
      304,
      318
    ],
    "source": "9781394239306",
    "choice_e": "Document findings, actions, outcomes, and lessons learned throughout the process."
  },
  {
    "id": 1413,
    "question": "Which step of the troubleshooting model involves replacing components until a faulty hardware device is identified?",
    "choice_a": "Duplicate the problem, if possible.",
    "choice_b": "Gather information.",
    "choice_c": "Test the theory to determine the cause.",
    "choice_d": "Establish a plan of action to resolve the problem and identify potential effects.",
    "correct_answer": "C",
    "explanation": "After you have established a theory of probable cause, you can try to test the theory by replacing hardware components one by one until you find the faulty device.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      322,
      311,
      318,
      304,
      319
    ],
    "source": "9781394239306",
    "choice_e": "Verify full system functionality and implement preventive measures, if applicable.",
    "choice_f": "Document findings, actions, outcomes, and lessons learned throughout the process."
  },
  {
    "id": 1414,
    "question": "Which of the following are not general troubleshooting steps? (Choose all that apply.)",
    "choice_a": "Identify the problem.",
    "choice_b": "Establish a theory of probable cause.",
    "choice_c": "Test the theory to determine the cause.",
    "choice_d": "Verify that the client's Internet Protocol (IP) configuration is correct.",
    "correct_answer": [
      "D",
      "F"
    ],
    "explanation": "Verifying that a router is functioning and forwarding traffic and verifying that a client's IP configuration is correct are not considered general troubleshooting steps. You might perform these two steps as a subset of general troubleshooting steps.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      311,
      303,
      304,
      313,
      321
    ],
    "source": "9781394239306",
    "choice_e": "Establish a plan of action to resolve the problem and identify potential effects.",
    "choice_f": "Verify that the router is forwarding.",
    "choice_g": "Implement the solution or escalate as necessary.",
    "choice_h": "Verify full system functionality and implement preventive measures, if applicable."
  },
  {
    "id": 1415,
    "question": "Which of the following are reasons for documenting a network problem or incident? (Choose all that apply.)",
    "choice_a": "Documentation makes it easier to escalate calls to senior technicians.",
    "choice_b": "Documentation makes it easier to prioritize administrative tasks.",
    "choice_c": "Documentation makes it easier to prioritize each help call.",
    "choice_d": "Documentation makes it easier to escalate calls to first-tier technicians.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "When a network problem or incident is reported, documentation begins. Proper documentation makes it easier for a first-tier support technician to prioritize and to escalate the call to senior technicians, if necessary.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      311,
      322,
      319,
      312,
      315
    ],
    "source": "9781394239306"
  },
  {
    "id": 1416,
    "question": "Which of the following statements about prioritizing help calls are true? (Choose all that apply.)",
    "choice_a": "Individual desktop problems take precedence over problems with shared resources.",
    "choice_b": "Problems with shared resources take precedence over individual desktop problems.",
    "choice_c": "Departmental problems take precedence over networkwide problems.",
    "choice_d": "Networkwide problems take precedence over departmental problems.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "When establishing priorities, networkwide problems take precedence over departmental problems, and problems with shared resources take precedence over individual desktop problems.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      319,
      311,
      306,
      312,
      304
    ],
    "source": "9781394239306"
  },
  {
    "id": 1417,
    "question": "Which of the following statements about multitiered technical support organizations are true? (Choose all that apply.)",
    "choice_a": "Help calls are typically escalated to second-tier technicians when they involve mission-critical network components such as routers.",
    "choice_b": "First-tier technicians generally handle desktop problems.",
    "choice_c": "Second-tier technicians are generally less experienced than first-tier technicians.",
    "choice_d": "First-tier technicians are generally less experienced than second-tier technicians.",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "First-tier technicians are generally less experienced than second-tier technicians. First-tier technicians are the first point of contact for users. They receive and prioritize help desk calls and escalate problems to second-tier technicians, if necessary. First-tier technicians generally handle individual desktop problems, whereas second-tier technicians troubleshoot mission-critical network components such as routers and switches.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      319,
      311,
      315,
      322,
      306
    ],
    "source": "9781394239306"
  },
  {
    "id": 1418,
    "question": "Ed is a first-tier support technician. He receives the help calls listed here. His job is to assign them priorities based on their severity. Which of the following should be the problem that receives the highest priority?",
    "choice_a": "A problem with an order entry or customer service call center resource that affects an entire department, with multiple local area networks (LANs)",
    "choice_b": "A fatal error that causes a single computer to fail",
    "choice_c": "A problem with a mission-critical backbone router that affects an entire network",
    "choice_d": "A problem with an application server that affects a single LAN",
    "correct_answer": "C",
    "explanation": "A problem that affects the entire network should be given highest priority. This includes a mission-critical backbone router. Problems that affect multiple LANs or an entire department are generally given the next highest priority. An application problem that affects a shared application server on a LAN should be given the next highest priority. A problem with a single user's computer should be given the lowest priority if the other problems have been reported.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      319,
      311,
      322,
      315,
      312
    ],
    "source": "9781394239306"
  },
  {
    "id": 1419,
    "question": "Ed is a first-tier support technician. He receives the help calls listed here. His job is to assign them priorities based on their severity. Which of the following should be the problem that receives the lowest priority?",
    "choice_a": "A problem with an order entry or customer service call center resource that affects an entire department, with multiple local area networks (LANs)",
    "choice_b": "A fatal error that causes a single computer to fail",
    "choice_c": "A problem with a mission-critical backbone router that affects an entire network",
    "choice_d": "A problem with an application server that affects a single LAN",
    "correct_answer": "B",
    "explanation": "A problem that affects the entire network should be given highest priority. This includes a mission-critical backbone router. Problems that affect multiple LANs or an entire department are generally given the next highest priority. An application problem that affects a shared application server on a LAN should be given the next highest priority. A problem with a single user's computer should be given the lowest priority if the other problems have been reported.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      319,
      311,
      322,
      306,
      312
    ],
    "source": "9781394239306"
  },
  {
    "id": 1420,
    "question": "When you troubleshoot a network problem, it is possible to introduce another problem while attempting to fix the original one. In which step of the troubleshooting process should you be aware of the residual effects that changes might have on the network?",
    "choice_a": "Identify the problem.",
    "choice_b": "Establish a theory of probable cause.",
    "choice_c": "Test the theory to determine the cause.",
    "choice_d": "Establish a plan of action to resolve the problem and identify potential effects.",
    "correct_answer": "D",
    "explanation": "After you identify a problem and establish and test a theory of its probable cause, you must create a plan of action to resolve the problem and identify any potential effects (positive or negative) your solution might have. Then, you implement your solution, test the results, and finish documenting the incident.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      311,
      322,
      318,
      312,
      319
    ],
    "source": "9781394239306",
    "choice_e": "Implement the solution or escalate as necessary.",
    "choice_f": "Verify full system functionality an implement preventive measures, if applicable.",
    "choice_g": "Document findings, actions, outcomes, and lessons learned throughout the process."
  },
  {
    "id": 1421,
    "question": "In which troubleshooting step do you create a record of your activities and inform the user of what happened and why?",
    "choice_a": "Identify the problem.",
    "choice_b": "Establish a theory of probable cause.",
    "choice_c": "Test the theory to determine the cause.",
    "choice_d": "Establish a plan of action to resolve the problem and identify potential effects.",
    "correct_answer": "G",
    "explanation": "The last step of the troubleshooting process is to document the solution and explain to the user what happened and why. In reality, documentation should begin when the problem is reported, and the documentation should be updated throughout the troubleshooting process.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      311,
      322,
      312,
      318,
      321
    ],
    "source": "9781394239306",
    "choice_e": "Implement the solution or escalate as necessary.",
    "choice_f": "Verify full system functionality and implement preventive measures, if applicable.",
    "choice_g": "Document findings, actions, outcomes, and lessons learned throughout the process."
  },
  {
    "id": 1422,
    "question": "On Monday morning, Alice arrives at work to find multiple messages from users who are unable to access the accounting department's file server. Which of the following are the best questions for Alice to ask during the beginning stage of the networking troubleshooting process? (Choose two.)",
    "choice_a": "What has changed since the users were last able to access the server?",
    "choice_b": "Are there any software updates that Alice should apply to the server?",
    "choice_c": "Has the server suffered a hard disk failure?",
    "choice_d": "Which users are reporting a problem and where are they located?",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "The first stage of the troubleshooting process calls for Alice to identify the problem by gathering information. Learning about who is reporting the problem and what has changed since the server was last accessible can provide Alice with information that could help her determine whether the problem is located in the users' workstations, somewhere in the network, or in the file server itself. The other options are intended to test a theory about a probable cause, a troubleshooting stage that comes later.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      322,
      311,
      312,
      318,
      319
    ],
    "source": "9781394239306"
  },
  {
    "id": 1423,
    "question": "A user calls Alice at the help desk to report that her mouse has stopped working, she cannot access the Internet, and all of her email has disappeared from her inbox. Which of the following would be the best course of action for Alice to take?",
    "choice_a": "Create a separate trouble ticket for each problem.",
    "choice_b": "Escalate the call to a senior technician.",
    "choice_c": "Have the caller's computer replaced with a new one.",
    "choice_d": "Send a technician to the user's site to address all of the problems.",
    "correct_answer": "A",
    "explanation": "Because the multiple problems seem to be unrelated, Alice should handle them individually by creating a separate trouble ticket for each one and prioritizing each one. None of the problems seem to be severe enough to warrant escalation, nor should it be necessary to replace the computer. While it would be possible to send a technician to address all of the problems at once, it would be more efficient to assign each its own priority and handle it like any other trouble call.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      311,
      319,
      312,
      322,
      304
    ],
    "source": "9781394239306"
  },
  {
    "id": 1424,
    "question": "Alice receives a call in which a user reports that he is unable to send print jobs to the network-attached workgroup printer near his desk. Which of the following tasks should Alice perform first?",
    "choice_a": "Reinstall the printer driver on the user's workstation.",
    "choice_b": "Test network connectivity to the printer using the ping utility.",
    "choice_c": "Examine the switches to which the user's workstation and the printer are connected.",
    "choice_d": "Check to see if there are printer firmware upgrades available.",
    "correct_answer": "B",
    "explanation": "The first phase of the troubleshooting process is gathering information. Learning whether the printer is accessible over the network can help Alice to isolate the location of the problem and develop a theory of probable cause. Installing drivers, checking switches, and upgrading firmware are all part of a later phase in the troubleshooting process: testing a theory to determine the cause of the problem.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      311,
      312,
      318,
      304,
      306
    ],
    "source": "9781394239306"
  },
  {
    "id": 1425,
    "question": "The entire network at Adatum Corp. is unable to access the Internet. All of the users throughout the network are complaining that their browsers are displaying DNS failure messages. The company does not have an in-house network administrator, so they call Ralph at his consulting firm. Which of the following should be the first question that Ralph asks in his attempt to pinpoint the location of the malfunction?",
    "choice_a": "What browser are the users running?",
    "choice_b": "Where is the DNS server located?",
    "choice_c": "What technology is used to provide access to the Internet?",
    "choice_d": "What sites are the users attempting to access?",
    "correct_answer": "B",
    "explanation": "The users' browsers are failing to resolve the host names of the requested web sites into IP addresses, which they must do before they can connect to the web servers. By asking where the company's DNS server is located, Ralph can determine if the problem is the DNS server itself or the router that provides access to the Internet. If the DNS server is located on Adatum's company network, then the DNS server could be failing to resolve the website names. However, the DNS server could be located on the Internet service provider's network, in which case the problem might be in the router that provides access to the ISP's network.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      322,
      311,
      313,
      338,
      321
    ],
    "source": "9781394239306"
  },
  {
    "id": 1426,
    "question": "You are the first responder to an incident of computer crime at your company. The datacenter's security has been penetrated, a server accessed, and sensitive company data stolen. The company's incident response plan lists the specific tasks that you are responsible for performing. Which of the following are likely to be among those tasks? (Choose all that apply.)",
    "choice_a": "Turn off the server.",
    "choice_b": "Secure the area.",
    "choice_c": "Document the scene.",
    "choice_d": "Collect evidence.",
    "correct_answer": [
      "B",
      "C",
      "D",
      "E"
    ],
    "explanation": "While securing the area to prevent contamination of evidence, documenting the scene with photographs or video, collecting any evidence that might be visible, and cooperating with the authorities are tasks that are likely to be in the company's incident response policy. Turning off the server most certainly would not, because this could disturb or delete evidence of the crime.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      304,
      311,
      322,
      348,
      325
    ],
    "source": "9781394239306",
    "choice_e": "Cooperate with the authorities."
  },
  {
    "id": 1427,
    "question": "Which of the following types of unshielded twisted-pair wiring faults cannot be detected by a toner and probe?",
    "choice_a": "Split pairs",
    "choice_b": "Open circuits",
    "choice_c": "Short circuits",
    "choice_d": "Transposed wires",
    "correct_answer": "A",
    "explanation": "A toner and probe is a tester that consists of a main unit that connects to one end of a wire in a UTP cable and a locator that you touch to the other end, enabling you to test each wire. A toner and probe can detect opens and shorts, as well as transposed wires. However, it cannot detect split pairs, because in that fault the pins are properly connected.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      357,
      358,
      323,
      307,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1428,
    "question": "After connecting a toner or tone generator to the green wire at one end of a twisted-pair cable run, Ralph proceeds to the other end of the cable and touches the probe (or locator) to each of the eight pins in turn. The green wire and the green striped wire both produce a tone. What type of wiring fault has Ralph discovered?",
    "choice_a": "Split pair",
    "choice_b": "Far-end crosstalk",
    "choice_c": "Transposed wires",
    "choice_d": "Short circuit",
    "correct_answer": "D",
    "explanation": "The first and most essential test that installers must perform on every cable run is a continuity test, which ensures that each wire on both ends of the cable is connected to the correct pin and only the correct pin. If a pin on one end of a cable run is connected to two or more pins on the other end, the cable has a short circuit.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      357,
      358,
      323,
      309,
      320
    ],
    "source": "9781394239306",
    "choice_e": "Delay skew"
  },
  {
    "id": 1429,
    "question": "Which of the following types of cables is used to connect a terminal to the console port of a router or switch?",
    "choice_a": "Rollover",
    "choice_b": "Straight-through",
    "choice_c": "Crossover",
    "choice_d": "Plenum",
    "correct_answer": "A",
    "explanation": "A rollover cable is a type of null modem cable, usually flat and light blue in color, with the pinouts reversed on either end, to enable a terminal to communicate with a router or switch through the device's dedicated console port. None of the other options are suitable for this purpose. A straight-through cable is the standard network cable used to connect a computer to a switch. A crossover cable is designed to connect two network adapters (in computers or similar devices) to each other directly. A plenum cable is a type of cable intended for use within air spaces that has an outer sheath that does not produce toxic fumes when it burns. A shielded cable is intended to protect signals from electromagnetic interference. A tap is a device used to branch a coaxial cable to two devices.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      308,
      307,
      309,
      320,
      357
    ],
    "source": "9781394239306",
    "choice_e": "Shielded",
    "choice_f": "Tap"
  },
  {
    "id": 1430,
    "question": "Which of the following types of patch cables is used to connect a computer to a wall plate?",
    "choice_a": "Straight-through",
    "choice_b": "Crossover",
    "choice_c": "Rollover",
    "choice_d": "Plenum",
    "correct_answer": "A",
    "explanation": "A straight-through cable is the standard network patch cable used to connect a computer to a wall plate. A crossover cable is designed to connect two network adapters (in computers or similar devices) to each other directly. A rollover cable is used to enable a terminal to communicate with a router or switch through the device's console port. A plenum cable is a type of cable intended for use within air spaces that has an outer sheath that does not produce toxic fumes when it burns.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      308,
      358,
      307,
      323,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1431,
    "question": "A routine test of a newly installed twisted-pair cable run indicates that there is a short circuit on one of the wires. Which of the following procedures might possibly correct the fault?",
    "choice_a": "Use a different pinout on both ends of the cable.",
    "choice_b": "Replace the connectors at both ends of the cable run.",
    "choice_c": "Move the cable away from any potential sources of electromagnetic interference.",
    "choice_d": "Use a higher grade of UTP cable.",
    "correct_answer": "B",
    "explanation": "A short circuit is a wiring fault indicating that a pin at one end of a cable run is connected to two pins at the other end. To correct the problem, you must replace the connector with the faulty wiring. None of the other suggestions are solutions for a wiring fault.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      323,
      358,
      320,
      307,
      309
    ],
    "source": "9781394239306"
  },
  {
    "id": 1432,
    "question": "Which of the following troubleshooting tools is not used to test copper cabling installations?",
    "choice_a": "Cable tester",
    "choice_b": "Multimeter",
    "choice_c": "Toner and probe",
    "choice_d": "Optical power meter",
    "correct_answer": "D",
    "explanation": "An optical power meter measures the signal strength on fiber-optic cables to locate breaks; it cannot be used on copper cables. Multimeters, toners, and cable testers are all devices that work with copper networks.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      358,
      357,
      323,
      361,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1433,
    "question": "Which of the following devices is not one of the tools generally used by a data networking cable installer?",
    "choice_a": "Toner and probe",
    "choice_b": "Cable tester",
    "choice_c": "Butt set",
    "choice_d": "Cable certifier",
    "correct_answer": "C",
    "explanation": "A butt set is a one-piece telephone handset with alligator clips that enables its operator to connect to a telephone line anywhere that the cables are accessible. They are used by telephone cable technicians but generally not by installers of network data cables. The other options are all standard tools used by data networking cable installers.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      357,
      358,
      307,
      309,
      308
    ],
    "source": "9781394239306"
  },
  {
    "id": 1434,
    "question": "Ralph is a new hire for a consulting firm that frequently performs cable installations. He is trying to learn more about the tools needed to install internal cable runs. To that end, which of the following statements about cable crimpers has Ralph found to be true?",
    "choice_a": "Cable installers use a crimper to attach keystone connectors to lengths of bulk cable.",
    "choice_b": "Cable installers use a crimper to attach RJ-45 connectors to lengths of bulk cable.",
    "choice_c": "You need to purchase a separate crimper for each type of cable to which you want to attach connectors.",
    "choice_d": "Making your own patch cables by applying connectors yourself is always more economical than buying prefabricated patch cables.",
    "correct_answer": "B",
    "explanation": "A crimper is a plier-like device that cable installers use to create patch cables by attaching RJ-45 connectors to lengths of bulk cable. Installers use a punchdown tool, not a crimper, to attach a cable end to a keystone connector. It is not always necessary to purchase a crimper for each cable type. Some crimpers are designed for a single cable/connector combination, but many crimpers have replaceable bits, supporting a variety of cables and connectors. Making patch cables yourself can represent a false economy. Buying bulk cable and connectors and making patch cables yourself can conceivably be cheaper than purchasing prefabricated cables. However, when you factor in the time needed to attach the connectors, the learning curve required to attach the connectors correctly, and the failure rate requiring the re-application of connectors, it might be more economical to purchase prefabricated patch cables in quantity instead.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      307,
      309,
      358,
      357,
      323
    ],
    "source": "9781394239306"
  },
  {
    "id": 1435,
    "question": "Which of the following cable faults increases a twisted-pair cable's susceptibility to crosstalk?",
    "choice_a": "Open",
    "choice_b": "Short",
    "choice_c": "Split pair",
    "choice_d": "Transposed pairs",
    "correct_answer": "C",
    "explanation": "A split pair is a connection in which two wires are incorrectly mapped in exactly the same way on both ends of the cable. Each pin on one end of the cable is correctly wired to the corresponding pin at the other end, but the wires inside the cable used to make the connections are incorrect. In a properly wired connection, each twisted pair should contain a signal wire and a ground wire. In a split pair, it is possible to have two signal wires twisted together as a pair. This can generate excessive amounts of crosstalk, corrupting both of the signals involved. Open circuits, shorts, and transposed pairs interfere with cable performance but do not make it more susceptible to crosstalk.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      323,
      309,
      358,
      307,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1436,
    "question": "Alice's company has moved to a building that was prewired for twisted-pair Ethernet. However, since installing the company's Gigabit Ethernet equipment using the existing cable runs, performance has been poor. After performing some packet captures and analyzing the traffic samples, Alice discovers that there are a great many Ethernet frames being retransmitted. Next, she examines the cable runs in the drop ceilings. They do not appear to be overly long, and they do not appear to run near any major sources of electromagnetic interference. Which of the following could be the problem?",
    "choice_a": "Some of the cable runs are using T568A pinouts, and some are using T568B.",
    "choice_b": "The cables only have two wire pairs connected, instead of four.",
    "choice_c": "The existing cable is not rated for use with Gigabit Ethernet.",
    "choice_d": "There are mismatched transceivers at the cable ends with different signal strengths.",
    "correct_answer": "C",
    "explanation": "Of the options provided, the only possible source of the problem is that the cable runs are using a cable type not rated for Gigabit Ethernet. Some older buildings might still have the original Category 5 cable installed, rather than the Category 5e and higher cables now currently in use. Cat 5 can be unsuitable for use with Gigabit Ethernet and can result in the poor performance that Alice is experiencing. A cable installation with runs wired using different pinout standards will not affect performance as long as each run uses the same pinouts at both ends. Gigabit Ethernet will not function at all if only two wire pairs are connected. The transceivers are located in the equipment that Alice company brought from the old location, so they are not mismatched.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      309,
      307,
      323,
      358,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1437,
    "question": "Ed is experiencing poor network performance on some new twisted-pair cable runs. After ruling out all other causes, he tests the cables with a toner and probe and finds no faults. Finally, he examines the cable connectors more closely and finds that, while the pins at one end of the cable are correctly connected to their corresponding pins at the other end, in some cases there are two solid color wires twisted together in a pair. Which of the following types of faults has Ed discovered?",
    "choice_a": "Open circuit",
    "choice_b": "Short circuit",
    "choice_c": "Split pairs",
    "choice_d": "Transposed wires",
    "correct_answer": "C",
    "explanation": "A split pair is a connection in which two wires are incorrectly mapped in exactly the same way on both ends of the cable. In a properly wired connection, each twisted pair should contain a colored signal wire and a striped ground wire. In a split pair, it is possible to have two signal wires twisted together as a pair. This can generate excessive amounts of crosstalk, corrupting both of the signals involved. Because all of the pins are connected properly, a toner and probe cannot detect this fault. An open circuit would manifest as a failure to detect a tone on a wire, indicating that there is either a break in the wire or a bad connection in one or both connectors. A short is when a wire is connected to two or more pins or when the conductors of two or more wires are touching. Transposed pairs is a fault in which both of the wires in a pair are connected to the wrong pins at one end of the cable. All three of these faults are detectable with a toner and probe.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      323,
      358,
      357,
      320,
      322
    ],
    "source": "9781394239306"
  },
  {
    "id": 1438,
    "question": "Which of the following terms describes the progressive weakening of transmitted signals as they travel along a network medium?",
    "choice_a": "Absorption",
    "choice_b": "Latency",
    "choice_c": "Attenuation",
    "choice_d": "Crosstalk",
    "correct_answer": "C",
    "explanation": "Attenuation is the weakening of a signal as it travels long distances, whether on a wired or wireless medium. The longer the transmission distance, the more the signal weakens. Absorption is the tendency of a wireless signal to change as it passes through different materials. Latency is a measurement of the time it takes for a signal to travel from its source to its destination. Crosstalk is a type of interference that occurs on wired networks when a signal bleeds over to an adjacent wire.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      323,
      309,
      310,
      358,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1439,
    "question": "After experiencing some problems with devices connected to the company's fiber-optic network, Alice brings in a contractor to test the fiber-optic cable runs. The contractor detects a significant amount of decibel (dB) loss in some of the cable runs, which could be the source of the problems. Which of the following are possible causes of the decibel loss? (Choose all that apply.)",
    "choice_a": "Electromagnetic interference",
    "choice_b": "Dirty optical cables",
    "choice_c": "Excessive cable length",
    "choice_d": "Signal crosstalk",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Dirt on fiber-optic cable connectors can reduce the strength of the signal resulting in decibel loss. Excessive cable length can result in greater attenuation and weaker signals due to the decibel loss. Electromagnetic interference and signal crosstalk are both factors that can affect copper cable transmissions, but not fiber-optic.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      310,
      309,
      323,
      358,
      361
    ],
    "source": "9781394239306"
  },
  {
    "id": 1440,
    "question": "Which of the following should a troubleshooter look for when a duplex mismatch is suspected on an Ethernet network? (Choose all that apply.)",
    "choice_a": "Collisions",
    "choice_b": "Runt frames",
    "choice_c": "CRC errors",
    "choice_d": "Failed ping tests",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "There should be no collisions at all on a full-duplex network, so collisions indicate that at least one side of the connection is trying to operate in half-duplex mode. Ethernet running over twisted-pair cable, in its original half-duplex mode, detects collisions by looking for data on the transmit and receive pins at the same time. In full-duplex mode, data is supposed to be transmitted and received at the same time. In a duplex mismatch, in which one side of a connection is configured to use full duplex and the other end is configured to use half duplex, the full-duplex communications originating from one side look like collisions to the half-duplex side. The half-duplex adapter transmits a jam signal as a result of each collision, which causes the full duplex side to receive an incomplete or damaged frame, which is perceived as a runt, or a cyclic redundancy check (CRC) error. A runt is a frame that is too small\u2014under 64 bytes. Both sides then start to retransmit frames in a continuing cycle, causing network performance to diminish. Ping tests do not detect a duplex mismatch, because <code>ping</code> only transmits a small amount of data in one direction at a time. The mismatch only becomes apparent when the systems transmit large amounts of data.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      354,
      314,
      313,
      309,
      335
    ],
    "source": "9781394239306"
  },
  {
    "id": 1441,
    "question": "Ed is trying to troubleshoot a problem that has caused a wired network connection to fail completely. Which of the following wired network problems will cause a complete failure of a network connection? (Choose all that apply.)",
    "choice_a": "Bottleneck",
    "choice_b": "Speed mismatch",
    "choice_c": "Duplex mismatch",
    "choice_d": "Transmitter (TX)/receiver (RX) transposed",
    "correct_answer": [
      "B",
      "D",
      "E"
    ],
    "explanation": "A speed mismatch on a wired network only occurs when two devices are configured to use a specific transmission speed and those speeds are different. In that case, network communication stops. For network communication to occur on a twisted-pair network, transmit (TX) pins must be connected to receive (RX) pins. If the connections are transposed (reversed), no communication occurs. If the switch port to which a computer is connected is disabled due to an error state, there will be no network communication. Bottlenecks and duplex mismatches will slow down network communications, but they will not stop them completely.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      320,
      323,
      358,
      313,
      317
    ],
    "source": "9781394239306",
    "choice_e": "Error disabled port"
  },
  {
    "id": 1442,
    "question": "Ed has discovered that some of the twisted-pair cable runs on his newly installed Ethernet network are well over 100 meters long. Which of the following problems is his network likely to experience due to cable segments that are greater than the specified length?",
    "choice_a": "Jitter",
    "choice_b": "Attenuation",
    "choice_c": "Crosstalk",
    "choice_d": "EMI",
    "correct_answer": "B",
    "explanation": "Attenuation is the weakening of a signal as it travels long distances, whether on a wired or wireless medium. The longer the transmission distance, the more the signal weakens. Cable length specifications are designed in part to prevent signals from attenuating to the point at which they are unviable. Jitter, crosstalk, and electromagnetic interference (EMI) are all conditions that can affect the performance of a wired network, but they are not directly related to the length of the cable.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      323,
      309,
      307,
      320,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1443,
    "question": "Ed is trying to troubleshoot a problem with his wired network, and his research has led him to a list of possible network faults. The list is rather old, however, and Ed is wondering if some of the problems are relevant. Which of the following wired network problems no longer occur with modern Gigabit Ethernet switches and network adapters in their default configurations? (Choose all that apply.)",
    "choice_a": "Bottleneck",
    "choice_b": "Speed mismatch",
    "choice_c": "Duplex mismatch",
    "choice_d": "Transmitter (TX)/receiver (RX) transposed",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The Gigabit Ethernet standards call for switches and network adapters to support autonegotiation by default, which enables devices to communicate and select the best network speed and duplex mode available to them both. Therefore, speed mismatches and duplex mismatches no longer occur unless someone modifies the speed or duplex settings to incompatible values on one or both devices.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      313,
      314,
      311,
      322,
      303
    ],
    "source": "9781394239306"
  },
  {
    "id": 1444,
    "question": "Ed has discovered that some of the twisted-pair cables on his newly installed network are running right alongside fluorescent light fixtures in the drop ceiling. Which of the following problems is the network likely to experience due to the cables' proximity to the fixtures?",
    "choice_a": "Jitter",
    "choice_b": "Attenuation",
    "choice_c": "Crosstalk",
    "choice_d": "EMI",
    "correct_answer": "D",
    "explanation": "Fluorescent light fixtures and other devices in an office environment can generate magnetic fields, resulting in electromagnetic interference (EMI). When a copper-based cable runs too near to such a device, the magnetic fields can generate an electric current on the cable that interferes with the signals exchanged by network devices. Jitter, attenuation, and crosstalk are all conditions that can affect the performance of a wired network, but they are not directly related to the cables' proximity to light fixtures.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      309,
      310,
      323,
      320,
      358
    ],
    "source": "9781394239306"
  },
  {
    "id": 1445,
    "question": "Which of the following indicators can you use to determine whether an adapter is connected to a functioning hub or switch?",
    "choice_a": "Speed light-emitting diode (LED)",
    "choice_b": "Collision LED",
    "choice_c": "Link pulse LED",
    "choice_d": "Status LED",
    "correct_answer": "C",
    "explanation": "The link pulse LED indicates the adapter is connected to a functioning hub or switch. The speed LED specifies the data rate of the link. The collision LED lights up when collisions occur. There is no status LED on a network interface adapter.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      303,
      311,
      314,
      320,
      309
    ],
    "source": "9781394239306"
  },
  {
    "id": 1446,
    "question": "Ralph wants to use Power over Ethernet (PoE) to supply power to security cameras located throughout the company's datacenter. The Ethernet network is currently running at Gigabit Ethernet speed, but Ralph is planning to downgrade the camera connections to 100Base-TX because that standard has two wire pairs free for the transmission of power. Which of the following statements about Ralph's plan is true?",
    "choice_a": "Ralph's planning is correct; only 10Base-T and 100Base-TX support PoE.",
    "choice_b": "Ralph's plan will not work because 100Base-TX is not compatible with PoE.",
    "choice_c": "Ralph's plan will work, but it is not necessary to downgrade the connections to 100Base-TX.",
    "choice_d": "Ralph's plan will not work because security cameras would exceed the PoE power budget.",
    "correct_answer": "C",
    "explanation": "The Alternative B PoE variant can use the spare wire pairs in a CAT 5 or better 10Base-T or 100Base-TX cable to supply power to connected devices. The Alternative A and 4PPoE variants cannot use the spare wire pair in this manner; they supply power using the wire pairs that carry data at the same time. For Gigabit Ethernet or faster installations, Alternative B is capable of using the data wire pairs. Security cameras are ideal candidates for PoE without exceeding the power budget.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      356,
      323,
      358,
      308,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1447,
    "question": "Ed is inspecting the cable runs recently installed for some new Gigabit Ethernet systems on his company's network. Looking at the patch panel connections, he notices that they are wired using the T568B pinout standard. However, when he examines the wall plate connections, he sees that they are wired using the T568A standard. What is the best way for Ed to resolve the problem?",
    "choice_a": "Call the contractor and have all of the wall plate connectors rewired using the T568B standard.",
    "choice_b": "Purchase crossover patch cables for all of the connections between the patch panel and the switches.",
    "choice_c": "Configure the switches to not use a crossover circuit for all of the ports connected to the patch panel.",
    "choice_d": "Do nothing. The cable runs will function properly as is.",
    "correct_answer": "D",
    "explanation": "Cable runs are traditionally wired \u201cstraight through,\u201d that is, with the transmit pins at one end wired to the transmit pins at the other end. It is the switch that is supposed to implement the crossover circuit that connects the transmit pins to the receive pins. Cable runs wired using T568A at one end and T568B at the other end create a crossover circuit in the cable run. At one time, this would have been a serious problem, but today's switches automatically configure crossover circuits as needed, so they will adjust themselves to adapt to the cable runs. All of the other options would correct the problem, but doing nothing is certainly the easiest and best option.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      308,
      358,
      309,
      323,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1448,
    "question": "Ralph has two computers that he long ago networked together by plugging one end of an Ethernet cable into each machine. He recently bought an old Ethernet switch at a garage sale and wants to use it to expand his network. The switch has four numbered ports and a fifth port marked with an X. Ralph plugs one computer into port 1 using his existing cable and buys a new cable to plug the other computer into port 4. The two computers cannot communicate, however. Which of the following solutions will not enable his computers to communicate?",
    "choice_a": "Move the port 4 cable to port 2.",
    "choice_b": "Replace the old cable with a second new one.",
    "choice_c": "Plug the computer with the old cable into the X port.",
    "choice_d": "Plug the computer with the new cable into the X port.",
    "correct_answer": "A",
    "explanation": "The problem is unlikely to be a bad switch port or a bad cable, so moving the cable from port 4 to port 2 will not help. The problem is the crossover circuit between the two computers. The two systems were once connected directly together, which means that Ralph was using a crossover cable. The switch also provides a crossover circuit (except in the X port), and old switches often do not autonegotiate crossovers. Therefore, the connection has two crossovers, which is the equivalent of wiring transmit pins to transmit pins, instead of transmit pins to receive pins. All of the other options eliminate one of the crossover circuits, enabling the computers to be wired correctly.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      308,
      358,
      320,
      303,
      313
    ],
    "source": "9781394239306"
  },
  {
    "id": 1449,
    "question": "Ralph is responsible for the network installation in a new building purchased by his company, and he has elected to have Category 6 unshielded twisted-pair cable installed. The company president has asked him if it is possible to run their Gigabit Ethernet network using two of the wire pairs in the cable, while using the other two pairs for telephone connections. Ralph is not sure, so he sets up a lab network using cables with only two pairs connected. When he plugs computers into the switch and turns them on, the LEDs labeled 1000 light up, indicating that a Gigabit Ethernet connection has been established. Ralph gets excited at the thought of how much money he might save the company by using the same cable for both telephone and data. However, while the LED is lit, he cannot seem to connect to another system over his test network. Which of the following describes what he must do to correct the problem?",
    "choice_a": "Ralph must manually configure the network adapters to use Gigabit Ethernet, rather than let them autonegotiate.",
    "choice_b": "Ralph is using the wrong two wire pairs for the Gigabit Ethernet connection. He must rewire the connectors.",
    "choice_c": "Ralph is using the wrong pinout standard on his lab network. He must use T568A.",
    "choice_d": "Ralph must use all four wire pairs for a Gigabit Ethernet connection.",
    "correct_answer": "D",
    "explanation": "The autonegotiation mechanism is not the problem, nor is the pinout standard or Ralph's wire pair selection. The speed autonegotiation mechanism in Gigabit Ethernet uses only two wire pairs, so although the LEDs do light up successfully, a functional Gigabit Ethernet data connection requires all four wire pairs.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      323,
      358,
      308,
      303,
      305
    ],
    "source": "9781394239306"
  },
  {
    "id": 1450,
    "question": "Ralph recently bought an old Ethernet switch and some twisted-pair cables at a garage sale and wants to use them to build a home network. He plugs two computers into the switch using the cables but finds that the computers are unable to communicate. Then he notices that one of the ports in the switch is labeled with an X. He tries plugging one of the computers into the X port, and now they can communicate. Which of the following statements is the most likely explanation for this behavior?",
    "choice_a": "The switch has a bad port.",
    "choice_b": "One of the cables is a crossover cable.",
    "choice_c": "Both of the cables are crossover cables.",
    "choice_d": "The X port provides extra strength to the signals.",
    "correct_answer": "B",
    "explanation": "Older Ethernet switches do not autonegotiate crossovers. Instead, they have an X (or uplink) port that provides a connection without a crossover circuit, so you can connect one switch to another. If both of the cables had been standard straight-through Ethernet cables or if both had been crossover cables, then plugging them into two regular ports should have worked. Because plugging one cable into the X port worked, this means that only one of the cables must be a crossover cable. The problem, therefore, was the cable, not the port. The X port does not provide extra strength to the signals.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      308,
      358,
      320,
      303,
      323
    ],
    "source": "9781394239306"
  },
  {
    "id": 1451,
    "question": "Alice is a consultant who has been hired to move a client's old 20-node coaxial Ethernet network to a new location. She disassembles all of the network cabling and other components and packs them for shipping. At the new site, she sets up all of the computers, plugs a T-connector into each network adapter, and connects the cables, running them from one computer to the next to form the bus. When Alice is finished, she starts the computers and tests their network connectivity. She finds that 12 consecutive computers can communicate with each other, and the other 8 can communicate with each other, but the 12 cannot communicate with the 8. She makes sure that all of the connectors are securely tightened, especially the ones on the 12th computer, but the problem persists. Which of the following is the most likely cause of the difficulty?",
    "choice_a": "Alice has forgotten to terminate the computers at each end of the bus.",
    "choice_b": "One of the connectors on the 12th computer has a bent pin.",
    "choice_c": "Alice has forgotten to ground the network.",
    "choice_d": "The transmit and receive pins are reversed on the 12th computer.",
    "correct_answer": "B",
    "explanation": "A bent pin on one of the twelfth computer's connections would cause a break in the bus, essentially forming two networks that operate independently. The failure to terminate or ground the network would not produce this type of fault. Reversing the transmit and receive pins is not possible on a coaxial connection, due to the architecture of the cable.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      320,
      358,
      305,
      323,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1452,
    "question": "Ed is troubleshooting some network performance problems. After exhausting many other possibilities, he is examining the twisted-pair cable runs in the office's drop ceiling. He finds that some cables have been damaged, apparently by electricians working in that space. In some cases, the cable sheath has been split along its length, and some of the insulation on the wires inside has been scraped off as well. Which of the following types of faults might be caused by this damage? (Choose all that apply.)",
    "choice_a": "Open circuits",
    "choice_b": "Short circuits",
    "choice_c": "Split pairs",
    "choice_d": "Transposed wires",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "An open circuit is caused either by a break in the wire somewhere inside the cable or a bad connection with the pin in one or both connectors. A short is when a wire is connected to two or more pins at one end of the cable or when the conductors of two or more wires are touching inside the cable. In this instance, the damage to the cables could have resulted in either condition. A split pair is a connection in which two wires are incorrectly mapped in exactly the same way on both ends of the cable. Having transposed pairs is a fault in which both of the wires in a pair are connected to the wrong pins at one end of the cable. Both of these faults are the result of incorrect wiring during installation; they are not caused by damaged cables.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      323,
      309,
      358,
      357,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1453,
    "question": "Which of the following types of interference on a twisted-pair network are designed to be prevented by the twists in the wire pairs inside the cable?",
    "choice_a": "Crosstalk",
    "choice_b": "EMI",
    "choice_c": "Attenuation",
    "choice_d": "Latency",
    "correct_answer": "A",
    "explanation": "Crosstalk is a type of interference that occurs on copper-based networks when a signal transmitted on one conductor bleeds over onto another nearby conductor. Twisted-pair cables, which have eight or more conductors compressed together inside one sheath, are particularly susceptible to crosstalk. Twisting each of the separate wire pairs tends to reduce the amount of crosstalk to manageable levels. Twisting the wire pairs does not prevent signals from being affected by electromagnetic interference (EMI) or attenuation. Latency is a measurement of the time it takes for a signal to travel from its source to its destination.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      323,
      309,
      358,
      357,
      322
    ],
    "source": "9781394239306"
  },
  {
    "id": 1454,
    "question": "Ralph has been asked to create some new twisted-pair patch cables that will be used to connect patch panel ports to the network switches. He has been told that the patch panel connectors are all wired using the T568A pinout standard. Which of the following instructions should Ralph use when creating the patch cables?",
    "choice_a": "Use T568A at both ends.",
    "choice_b": "Use T567B at both ends.",
    "choice_c": "Use T568A at one end and T568B at the other end.",
    "choice_d": "Use either standard, as long as both ends are the same.",
    "correct_answer": "D",
    "explanation": "Either the T568A or the T568B pinout standard is acceptable. The patch cables will function properly as long as both ends are wired using the same pinout standard.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      308,
      358,
      323,
      309,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1455,
    "question": "Ed has discovered that, on some of his newly installed twisted-pair cable runs, the installer has stripped away nearly a foot of the cable sheath at each end and has untwisted the wire pairs before attaching them to the connectors. Which of the following problems is the network more likely to experience due to the untwisted wires?",
    "choice_a": "Jitter",
    "choice_b": "Attenuation",
    "choice_c": "Crosstalk",
    "choice_d": "EMI",
    "correct_answer": "C",
    "explanation": "Crosstalk is a type of interference that occurs on copper-based networks when a signal transmitted on one conductor bleeds over onto another nearby conductor. Twisted-pair cables, which have eight or more conductors compressed together inside one sheath, are particularly susceptible to crosstalk. Twisting each of the separate wire pairs tends to reduce the amount of crosstalk to manageable levels. Untwisting the pairs leaves them more susceptible to crosstalk. Jitter, attenuation, and electromagnetic interference (EMI) are all conditions that can affect the performance of a wired network, but they are not directly related to untwisted wire pairs.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      323,
      309,
      358,
      320,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1456,
    "question": "Ed is the administrator of his small company's network. A user calls the help desk and reports that she cannot connect to the network. She has never had any problems connecting before now, and she says that nothing on her computer has changed. Ed goes to the user's location to investigate and notices that the link pulse light-emitting diode (LED) on the switch port for the user's computer is not lit. What should Ed do next to isolate and fix the problem? (Choose all that apply.)",
    "choice_a": "Verify that the cable is securely connected to the switch.",
    "choice_b": "Verify the patch cable is pinned and paired properly.",
    "choice_c": "Replace the existing patch cable with a straight-through cable that is known to be good.",
    "choice_d": "Replace the existing patch cable with a crossover cable that is known to be good.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "In this scenario, the user was previously able to connect to the network. There have been no hardware or software changes to the computer. These factors indicate that there is possibly a Physical layer problem, such as a loose or faulty cable, a suspended or error disabled switch port, or a bad network interface adapter in the computer. Since the user's cable previously worked, there is no need to verify that it is pinned and paired properly, and crossover cables are not used to connect workstations to switches. The first thing Ed should do is verify that all cable connections are secure. If he finds a loose cable and the link pulse LED lights up when he reseats it, then the cable was the problem. If the link pulse LED does not light, Ed should replace the existing cable with a straight-through cable that is known to be good. If the LED lights up, the existing cable was probably faulty. If the LED does not light up, Ed should suspect a faulty network interface adapter or switch port and try moving the cable to a port on the switch that is known to function. If the connection works, the problem is probably a failed switch port. If the connection still does not work, then the fault is probably the network interface adapter in the user's computer.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      303,
      323,
      320,
      358,
      317
    ],
    "source": "9781394239306"
  },
  {
    "id": 1457,
    "question": "Ed is examining some twisted-pair cable runs that were recently installed in his office by an outside contractor. Looking at the connectors, he sees a variety of pinout combinations. Which of the following pinouts must Ed have rewired because they are incorrect? (Choose all that apply.)",
    "choice_a": "White/orange, orange, white/green, blue, white/blue, green, white/brown, brown",
    "choice_b": "White/green, green, white/orange, blue, white/blue, orange, white/brown, brown",
    "choice_c": "White/orange, orange, white/green, green, white/blue, blue, white/brown, brown",
    "choice_d": "White/brown, white/green, white/orange, blue, white/blue, orange, green, brown",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Option A is the T568B pinout, and option B is the T568A pinout. Both of these are correct and can be used. Options C and D are both incorrect and can result in excessive amounts of crosstalk.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      323,
      309,
      358,
      307,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1458,
    "question": "To save the company money and to provide some new hires with Gigabit Ethernet connectivity, Ralph has installed some new Category 5e cable runs, connecting his company's datacenter with a newly rented office at the far end of the building. However, the new users are complaining of intermittent connectivity problems. The company brings in a cabling contractor to investigate, and his diagnosis is attenuation. Which of the following will most likely be a sure solution to the problem?",
    "choice_a": "Repull the runs using Category 6 cable.",
    "choice_b": "Shorten the cable runs.",
    "choice_c": "Configure the hardware to run at a slower speed.",
    "choice_d": "Install high-end network adapters in the workstations.",
    "correct_answer": "B",
    "explanation": "Attenuation is the weakening of the signals as they traverse the network medium. In this case, the problem is most likely the result of cable runs that exceed the 100-meter maximum defined in the Ethernet twisted-pair specification. Therefore, shortening the cable runs will be likely to solve the problem. All of the Ethernet twisted-pair specifications have a 100-meter maximum length, so running the network at a slower speed, installing a higher-grade cable, and installing higher end network adapters might have no effect if the runs are overly long.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      323,
      309,
      358,
      307,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1459,
    "question": "Alice's network has been experiencing intermittent service slowdowns and outages ever since the company moved into their new building. She has tried every troubleshooting procedure she can think of and has not been able to determine the cause. One particular user, hoping to be the squeaky wheel that gets the grease, has taken to calling Alice every time he experiences a problem. One day, as she is working in the datacenter, Alice notices that the user calls her every time she hears an additional humming noise begin. After examining the doors in the hallway, Alice realizes that the racks containing her switches are located right next to the building's elevator machinery room. Which of the following conditions is probably causing the network communication problem?",
    "choice_a": "EMI",
    "choice_b": "NEXT",
    "choice_c": "FEXT",
    "choice_d": "Attenuation",
    "correct_answer": "A",
    "explanation": "Elevator machinery, fluorescent light fixtures, and other electrical devices in an office environment can generate magnetic fields, resulting in electromagnetic interference (EMI). When copper-based data cables are located too near to such a device, the magnetic fields can generate an electric current on the cable that interferes with the signals exchanged by network devices. If the network users experience a problem every time the elevator machinery switches on, EMI is a likely cause of the problem. Near-end crosstalk (NEXT), far-end crosstalk (FEXT), and attenuation can all cause intermittent network communication problems, but they cannot be caused by elevator machinery.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      309,
      323,
      320,
      312,
      315
    ],
    "source": "9781394239306"
  },
  {
    "id": 1460,
    "question": "Ralph is setting up a workstation for the company's new vice president. He has installed the computer in the VP's office and plugged the data cable into the wall plate. Then, back in the datacenter, he uses a patch cable to connect the corresponding port in the patch panel to a port in the network switch. However, the computer is unable to access the network. There are no complaints from other users. Which of the following could be the sources of the problem? (Choose all that apply.)",
    "choice_a": "The DNS server is malfunctioning.",
    "choice_b": "The switch port is administratively down.",
    "choice_c": "The NAT server is not functioning.",
    "choice_d": "The switch is configured to use port security.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "It is common practice on many networks to disable switch ports that are not in use\u2014leaving them in an administratively down state\u2014so that unauthorized individuals cannot plug devices into them. Some networks also use port security, in which switches are configured with access control lists (ACLs) that specify the MAC addresses of devices that are permitted to use them. Either of these could be the source of Ralph's problem. Because there are no other network users reporting problems, malfunctioning services such as NAT and DNS are not likely to be the cause.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      317,
      311,
      320,
      313,
      303
    ],
    "source": "9781394239306"
  },
  {
    "id": 1461,
    "question": "Ralph is setting up a network connection for a new vice president, who is supplying his own laptop under the company's bring your own device (BYOD) policy. He plugs the computer into the wall plate, and the link pulse LED lights up. Then, back in the datacenter, he uses a patch cable to connect the corresponding port in the patch panel to a port in the network switch. Later, the VP calls Ralph to report that data transfers between his laptop and the network servers are extremely slow. Which of the following could explain the problem?",
    "choice_a": "There is a duplex mismatch between the laptop and the network switch.",
    "choice_b": "Ralph used a crossover cable to connect the laptop to the wall plate.",
    "choice_c": "The switch port is disabled.",
    "choice_d": "The network adapter drivers on the laptop are outdated.",
    "correct_answer": "A",
    "explanation": "A duplex mismatch is the most likely of the options. Ethernet running over twisted-pair cable, in its original half-duplex mode, detects collisions by looking for data on the transmit and receive pins at the same time. In full-duplex mode, data is supposed to be transmitted and received at the same time. When one side of a connection is configured to use full duplex and the other end is configured to use half duplex, the full-duplex communications on the one side look like collisions to the half-duplex side. The half-duplex adapter transmits a jam signal as a result of each collision, which causes the full-duplex side to receive an incomplete frame. Both sides then start to retransmit frames in a continuing cycle, causing network performance to diminish drastically. If the problem were a crossover cable or a disabled switch port, the link pulse LED would not light. Outdated drivers would not be likely to slow network performance, and if they did, the slowdown would be minor.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      313,
      314,
      309,
      303,
      322
    ],
    "source": "9781394239306"
  },
  {
    "id": 1462,
    "question": "Ralph recently bought an older 100Base-T Fast Ethernet switch at a garage sale and wants to use it to connect his various computers into a home network. He plugs three computers into the switch and finds that although two of his older computers can communicate with each other, his newest computer cannot connect to the network. Which of the following tasks will most likely resolve the problem?",
    "choice_a": "Configure the switch to run at 100 Mbps.",
    "choice_b": "Configure the switch to run at 1 Gbps.",
    "choice_c": "Configure the computer's network adapter to autonegotiate.",
    "choice_d": "Configure the computer's network adapter to run at 100 Mbps.",
    "correct_answer": "C",
    "explanation": "Ralph's new computer is probably equipped with a network adapter that supports Gigabit Ethernet (1000Base-T). Fast Ethernet and newer network adapters support autonegotiation of the connection speed and duplex state, but most adapters have settings that can control the autonegotiation process. If the computer tries to set a specific speed or state that the switch does not support, the connection will fail, as it has in Ralph's case. Configuring the switch or the network adapter to run at any specific speed will prevent the autonegotiation process from occurring.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      303,
      320,
      305,
      311,
      358
    ],
    "source": "9781394239306"
  },
  {
    "id": 1463,
    "question": "Ralph has installed a new Category 5e cable run himself. He has attached keystone connectors to both ends of the cable, mounted the office-side connector to a wall plate, and mounted the datacenter connector into a patch panel. Then he took a patch cord and connected the patch panel port to an open port in one of the network switches. However, the LED on the switch port does not light. What should Ralph do?",
    "choice_a": "Repull the cable run using Category 6 cable.",
    "choice_b": "Check the cable run for wiring faults.",
    "choice_c": "Make sure the switch port is not disabled.",
    "choice_d": "Plug a computer into the wall plate.",
    "correct_answer": "D",
    "explanation": "For the link pulse LED on the switch port to light up, there must be a completed connection between the switch and a computer at the other end. None of the other options will cause the LED to light.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      303,
      323,
      313,
      308,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1464,
    "question": "A user calls Ed at the help desk to report that his computer is displaying a Duplicate IP Address error message. This puzzles Ed because all of the network workstations should be configured to obtain their IP addresses from DHCP servers. Ed asks the user if he has changed the TCP/IP configuration settings on the computer recently. The user says no. Ed then asks if anybody else uses the workstation. The user says no. However, when Ed runs the <code>ipconfig /all</code> command on the user's workstation, he sees that the DHCP Enabled setting reads No. What should Ed do next?",
    "choice_a": "Accuse the user of changing the TCP/IP settings and then lying about it.",
    "choice_b": "Activate the DHCP client on the workstation and close the trouble ticket.",
    "choice_c": "Begin an investigation into the possibility of a rogue DHCP server on the network.",
    "choice_d": "Change the IP address on the workstation to one that is not already in use.",
    "correct_answer": "B",
    "explanation": "Because Ed knows that the network workstations should be using DHCP to obtain their IP addresses, the best thing to do is to enable the DHCP client and close the ticket rather than configure the system with another static address. There is no indication that there is a rogue DHCP server on the network since the workstation's DHCP client is disabled. This is not the first time that Ed has had a user lie to him, nor will it be the last. He should just let it go and work on addressing the problem.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      330,
      321,
      311,
      312,
      316
    ],
    "source": "9781394239306"
  },
  {
    "id": 1465,
    "question": "Alice is having trouble with a new fiber-optic cable run that has just been installed between two buildings on her company's campus. To confirm that there is a problem with the cables, Alice consults the wiring diagram provided by the cable installer and begins to calculate the optical power loss resulting from cable installation factors such as the type of cable used, the attenuation resulting from the length of the cable runs, and the number and type of splices. Which of the following terms describes the calculations that Alice is performing?",
    "choice_a": "Protocol analysis",
    "choice_b": "Routing loop",
    "choice_c": "Optical link budget",
    "choice_d": "Received signal strength indication",
    "correct_answer": "C",
    "explanation": "Alice's calculations are called an optical link budget. By adding up the various loss factors in decibels (dB), she can determine whether the budget is low, resulting in communication problems over the link. Protocol analysis is an examination of network packet contents. A routing loop is a condition in which packets are circulating endlessly around a network. Received signal strength indication (RSSI) is a wireless networking statistic that does not apply to fiber-optic connections.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      310,
      323,
      309,
      307,
      358
    ],
    "source": "9781394239306"
  },
  {
    "id": 1466,
    "question": "Which of the following Power over Ethernet (PoE) specifications supplies power to devices using the spare wire pair on a 10Base-T or 100Base-TX twisted-pair network?",
    "choice_a": "Alternative A",
    "choice_b": "Alternative B",
    "choice_c": "4PPoE",
    "choice_d": "All of the above",
    "correct_answer": "B",
    "explanation": "The Alternative B PoE variant can use the spare wire pair in a CAT 5 or better 10Base-T or 100Base-TX cable to supply power to connected devices. The Alternative A and 4PPoE variants cannot use the spare wire pair in this manner; they supply power using the wire pairs that carry data at the same time. For Gigabit Ethernet or faster installations, Alternative B is also capable of using the data wire pairs.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      356,
      323,
      358,
      320,
      154
    ],
    "source": "9781394239306"
  },
  {
    "id": 1467,
    "question": "Which of the following network interface occurrences are considered to be malfunctions on a full-duplex Ethernet network? (Choose all that apply.)",
    "choice_a": "Runts",
    "choice_b": "Drops",
    "choice_c": "Giants",
    "choice_d": "Collisions",
    "correct_answer": [
      "A",
      "C",
      "D",
      "E"
    ],
    "explanation": "Runts, giants, collisions, and late collisions are all malfunctions on a full-duplex Ethernet network. Runt frames occur when a network interface generates packets that are smaller than the 64-byte minimum allowable length. Giants occur when frames are larger than the 1,518-byte maximum allowable length. Collisions are normal on a half-duplex network, but on a full-duplex network, collisions are considered to be malfunctions. Late collisions occur when network cables are too long. Drops occur when there are more packets to be transmitted than the network interface can handle.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      354,
      314,
      309,
      323,
      320
    ],
    "source": "9781394239306",
    "choice_e": "Late collisions"
  },
  {
    "id": 1468,
    "question": "Which of the following is the most likely cause of runt and giant frames on an Ethernet network interface?",
    "choice_a": "A network adapter malfunction",
    "choice_b": "A router malfunction",
    "choice_c": "Half-duplex communication",
    "choice_d": "Excessive cable length",
    "correct_answer": "A",
    "explanation": "Runts and giants are typically the result of a network interface adapter malfunction. Runt frames occur on an Ethernet network when a network interface generates packets that are smaller than the 64-byte minimum allowable length. Giants occur when frames are larger than the 1,518-byte maximum allowable length. Ethernet is a local area networking protocol, so routers are not involved in frame communications. Collisions are normal on a half-duplex network, but runts and giants are not. Late collisions occur when network cables are too long.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      354,
      314,
      309,
      320,
      305
    ],
    "source": "9781394239306"
  },
  {
    "id": 1469,
    "question": "Which of the following is the most likely cause of cyclic redundancy check (CRC) errors on an Ethernet network interface?",
    "choice_a": "Half-duplex communication",
    "choice_b": "A network adapter malfunction",
    "choice_c": "Electromagnetic interference",
    "choice_d": "Excessive cable length",
    "correct_answer": "C",
    "explanation": "Electromagnetic interference is the likely cause of CRC errors. A network interface adapter malfunction can cause runts and giant frames. Collisions are normal on a half-duplex network, but CRC errors are not. Late collisions occur when network cables are too long, but they do not cause CRC errors.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      354,
      314,
      309,
      320,
      305
    ],
    "source": "9781394239306"
  },
  {
    "id": 1470,
    "question": "Which of the following is not a type of error typically found in network interface statistics?",
    "choice_a": "Runt",
    "choice_b": "Encapsulation",
    "choice_c": "Giant",
    "choice_d": "CRC",
    "correct_answer": "E",
    "explanation": "Jumbo frames is a feature supported by some Ethernet implementations that enable frames to exceed the 1,500-byte maximum data payload defined in the IEEE 802.3 standard. Runt frames, giant frames, cyclic redundancy check (CRC) errors, and encapsulation errors are all types of errors typically reported in network interface diagnostics.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      314,
      354,
      353,
      313,
      320
    ],
    "source": "9781394239306",
    "choice_e": "Jumbo"
  },
  {
    "id": 1471,
    "question": "At what point in the installation process should patch panel ports and wall plates be labeled?",
    "choice_a": "When the patch panels and wall plates are installed",
    "choice_b": "When a length of cable is cut from the spool",
    "choice_c": "When the cables are attached to the connectors",
    "choice_d": "When the cable runs are tested, immediately after their installation",
    "correct_answer": "C",
    "explanation": "Patch panel ports and wall plates should be labeled when the cable runs are attached to them. Labeling them at any earlier time can result in cable runs being connected incorrectly.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      311,
      322,
      303,
      357,
      323
    ],
    "source": "9781394239306"
  },
  {
    "id": 1472,
    "question": "Alice has been hired by a corporation to design the cabling for their network. The corporation just moved into two different floors of an older building: a retail space on the ground floor and an office space on the 43rd floor. The building has existing Category 5e (CAT 5e) unshielded twisted-pair (UTP) cable. Alice's client wants two separate local area networks (LANs), one on each of the two floors, with a backbone network connecting them. They want a 1 gigabit-per-second (Gbps) data rate for each LAN but plan on migrating to 10 Gbps in the future. The two networks are approximately 200 meters apart. Which of the following solutions best meets the client's needs?",
    "choice_a": "Install Category 6 (CAT 6) or Category 6a (CAT 6a) UTP cable for the LANs. These cables run at 1 Gbps and provide a migration path to 10 Gbps. Use twisted-pair cable for the backbone network.",
    "choice_b": "Use the existing CAT 5e cabling for the LANs, since CAT 5e runs at 1 Gbps. Use thick coaxial cable for the backbone network.",
    "choice_c": "Install CAT 6 or CAT 6a UTP cable for the LANs. These cables run at 1 Gbps and provide a migration path to 10 Gbps. Use multimode fiber-optic cable for the backbone network.",
    "choice_d": "Install CAT 6 or CAT 6a UTP cable for the LANs. These cables run at 1 Gbps and provide a migration path to 10 Gbps. Use the existing CAT 5e cable for the backbone network.",
    "correct_answer": "C",
    "explanation": "Either CAT 6 or CAT 6a UTP cable will provide the currently required 1 Gbps data rate, with a migration path to 10 Gbps in the future. The backbone cabling connecting the two LANs needs to be fiber-optic, since it exceeds the distance limitations of twisted-pair and coaxial cable. CAT 5e cable conceivably runs at 1 Gbps; however, it does not run at 10 Gbps. Shielded cable alone would not guarantee a 1 Gbps data rate and an upgrade path to 10 Gbps.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      307,
      323,
      358,
      320,
      154
    ],
    "source": "9781394239306",
    "choice_e": "Replace the UTP cables with shielded twisted-pair (STP) cables."
  },
  {
    "id": 1473,
    "question": "A maintenance worker, while replacing a light fixture in an office building, accidentally severs a network cable in the drop ceiling. The tenants use a variety of local area network (LAN) technologies throughout the structure, but on that particular floor, there are three separate LANs: a 10-node Thin Ethernet LAN using coaxial cable in a bus topology, a 25-node Gigabit Ethernet LAN using twisted-pair cable in a star/hub and spoke topology, and a 5-node Fiber Distributed Data Interface (FDDI) LAN using multimode fiber-optic cable in a double ring topology. Without knowing which of the LANs the severed cable belongs to, what is the maximum number of computers that could be directly affected by the cable break?",
    "choice_a": "0",
    "choice_b": "1",
    "choice_c": "5",
    "choice_d": "10",
    "correct_answer": "D",
    "explanation": "The Thin Ethernet LAN is the network most endangered by the cable break. If a bus network is severed, all of the workstations on it are affected because the cable segments are no longer terminated at one end. The Gigabit Ethernet network uses a star/hub and spoke topology, which means that only the one computer using the severed cable could be disconnected from the network. An FDDI double ring network can survive a single cable break without any workstations being affected.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      309,
      323,
      310,
      307,
      154
    ],
    "source": "9781394239306",
    "choice_e": "25",
    "choice_f": "40"
  },
  {
    "id": 1474,
    "question": "Which of the following twisted-pair cable types can you use to construct a 10GBase-T network with 100-meter segments? (Choose all that apply.)",
    "choice_a": "CAT 5",
    "choice_b": "CAT 5e",
    "choice_c": "CAT 6",
    "choice_d": "CAT 6a",
    "correct_answer": [
      "D",
      "E",
      "F"
    ],
    "explanation": "Category 6a (CAT 6a) twisted-pair cable is a variant on CAT 6 that enables you to create 10GBase-T networks with segments up to 100 meters long. Category 7 (CAT 7) cable adds shielding both to the individual wire pairs and to the entire cable, for even greater resistance to crosstalk and noise. CAT 7 supports 100-meter 10GBase-T segments as well. CAT 8 cable supports bandwidth up to 2 GHz, making it even more suitable for 10GBase-T networks than CAT 6a (500 MHz) or CAT7 (600 MHz). CAT 5 and CAT 5e are not suitable for use with 10GBase-T. You can use CAT 6 for 10Gbase-T, but it is limited to 55-meter segments.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      307,
      309,
      323,
      358,
      361
    ],
    "source": "9781394239306",
    "choice_e": "CAT 7",
    "choice_f": "CAT 8"
  },
  {
    "id": 1475,
    "question": "Which of the following twisted-pair cable types are rated for 1,000 megabit-per-second (Mbps) Gigabit Ethernet using two wire pairs? (Choose all that apply.)",
    "choice_a": "Category 5 (CAT 5)",
    "choice_b": "Category 5e (CAT 5e)",
    "choice_c": "Category 6 (CAT 6)",
    "choice_d": "Category 6a (CAT 6a)",
    "correct_answer": "E",
    "explanation": "All twisted-pair Gigabit Ethernet implementations require all four wire pairs to achieve 1,000 Mbps transfer rates.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      309,
      308,
      307,
      323,
      358
    ],
    "source": "9781394239306",
    "choice_e": "None of the above"
  },
  {
    "id": 1476,
    "question": "Which of the following twisted-pair cable types support both 10-megabit-per-second (Mbps) and 100 Mbps data rates, using only two pairs? (Choose all that apply.)",
    "choice_a": "Category 5 (CAT 5)",
    "choice_b": "Category 5e (CAT 5e)",
    "choice_c": "Category 6 (CAT 6)",
    "choice_d": "Category 6a (CAT 6a)",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D"
    ],
    "explanation": "CAT 5 cable was the original cable standard intended for transfer rates up to 100 Mbps. CAT 5e, CAT 6, and CAT 6a all support 100 Mbps and are also rated for data rates up to 1,000 Mbps. CAT 6 and CAT 6a can also support 10 Gbps. All of these standards also support the 10 Mbps transfer rate.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      307,
      308,
      309,
      323,
      358
    ],
    "source": "9781394239306"
  },
  {
    "id": 1477,
    "question": "Ed has been hired to install network cabling for a small private company with 15 employees who need to share files and printers. All of the employees are physically located within the same building in two separate office spaces directly adjacent to each other, sharing a common wall and door for access. Both offices have drop ceilings. The client wants a simple Gigabit Ethernet installation that is easy to troubleshoot. In addition, Ed's client wants to keep installation costs to a minimum. Which of the following combinations of topology, cable type, and installation method would best meet the needs of Ed's client?",
    "choice_a": "Star/hub and spoke topology, fiber-optic cabling, and internal installation",
    "choice_b": "Bus topology, coaxial cabling, and external installation",
    "choice_c": "Bus topology, twisted-pair cabling, and internal installation",
    "choice_d": "Star/hub and spoke topology, coaxial cabling, and external installation",
    "correct_answer": "E",
    "explanation": "Because the company has few employees, a single location, and cost restrictions, the best solution is a star/hub and spoke topology with prefabricated twisted-pair cabling and an external installation method. The star/hub and spoke topology uses a central switch. Prefabricated twisted-pair cabling, with the connectors already attached, will keep the cost to a minimum. Since the employees are all located in the same building, with a common wall and a drop ceiling, the external installation method is the best choice. It is not possible to use a bus topology or coaxial cable for Gigabit Ethernet. Ed could use fiber-optic cable in a star/hub and spoke topology for Gigabit Ethernet, but it is more difficult and expensive to install. An internal installation, which uses a combination of bulk cable and prefabricated cables, is more expensive than an external installation and is typically used for larger networks.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      307,
      323,
      358,
      320,
      308
    ],
    "source": "9781394239306",
    "choice_e": "Star/hub and spoke topology, twisted-pair cabling, and external installation"
  },
  {
    "id": 1478,
    "question": "Ed has been hired by a company to upgrade its network infrastructure. The current network is 10 Mbps Ethernet running on Category 5 (CAT 5) twisted-pair cable. There are 100 computers on the network, all of which have 10/100/1000 multispeed network interface adapters. The computers are all connected to hubs. Users are complaining that the network is too slow, and connections are sometimes dropped. Management wants to upgrade to the fastest Ethernet standard possible using the existing cabling, and still keep costs to a minimum. Which of the following implementations should Ed recommend to the client?",
    "choice_a": "Upgrade to 100Base-TX and keep the existing hubs.",
    "choice_b": "Upgrade to 1000Base-T and keep the existing hubs.",
    "choice_c": "Upgrade to 100Base-FX and replace all of the hubs with switches.",
    "choice_d": "Upgrade to 1000Base-T and replace all of the hubs with switches.",
    "correct_answer": "D",
    "explanation": "The best solution in this scenario is to upgrade to 1000Base-T and replace the existing hubs with switches. 1000Base-T provides the fastest transfer speeds supported by the existing cable. Since users are complaining that the network is slow with the existing hubs, it makes sense to replace the shared hub environment with switches that offer dedicated bandwidth on each port. Any solution that does not replace the hubs would not address the users' complaints. 100Base-TX would provide a speed increase, but it runs at ~1/10 the speed of 1000Base-TX. Upgrading to 100Base-FX or 100Base-SX would require the cabling to be replaced with fiber-optic, which would be very expensive.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      154,
      323,
      358,
      315,
      317
    ],
    "source": "9781394239306",
    "choice_e": "Upgrade to 100Base-SX and replace all of the hubs with switches."
  },
  {
    "id": 1479,
    "question": "Ralph has been asked to create some new patch cables that will be used to connect patch panel ports to the network switches. He has been told to use the T568B pinout standard for all of the cable connectors. Ralph gathers the materials and the tools needed to complete the task, but he is not sure about the T568B pinout. Which of the following pinouts must Ralph use when creating the patch cables?",
    "choice_a": "White/orange, orange, white/green, blue, white/blue, green, white/brown, brown",
    "choice_b": "White/green, green, white/orange, blue, white/blue, orange, white/brown, brown",
    "choice_c": "White/orange, orange, white/green, green, white/blue, blue, white/brown, brown",
    "choice_d": "White/brown, white/green, white/orange, blue, white/blue, orange, green, brown",
    "correct_answer": "A",
    "explanation": "Option A is the T568B pinout that Ralph should use when attaching connectors to the cables. Option B is the T568A pinout, which would also work but Ralph has been instructed not to use it. Options C and D are both incorrect and can result in excessive amounts of crosstalk.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      308,
      358,
      323,
      309,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1480,
    "question": "It is Ralph's first day working for a consultancy that does network cable installations. His new boss points to a spool of Category 6 cable, hands Ralph a large plier-like device and a bag of little clear plastic components, and tells him to \u201cget started on fives and tens.\u201d What is Ralph expected to do?",
    "choice_a": "Pull cable runs",
    "choice_b": "Create patch cables",
    "choice_c": "Attach keystone connectors",
    "choice_d": "Install a patch panel",
    "correct_answer": "B",
    "explanation": "The plier-like device is a crimper, which cable installers use to attach RJ-45 connectors, like those in the bag, to lengths of bulk cable. This is the process of creating patch cables, which are used to connect computers to wall plates and patch panels to switches. The boss is telling Ralph to start making patch cables in 5-foot and 10-foot lengths. You do not use a crimper to attach keystone connectors, and the boss has not given Ralph the tools and components needed to pull cable runs or install a patch panel.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      358,
      307,
      308,
      309,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1481,
    "question": "Which of the following devices can you use to connect two multimode fiber-optic Ethernet networks in different buildings 2,000 meters apart using a single-mode fiber-optic cable segment running at the same speed, while maintaining a single collision domain?",
    "choice_a": "Bridge",
    "choice_b": "Switch",
    "choice_c": "Router",
    "choice_d": "Media converter",
    "correct_answer": "D",
    "explanation": "A media converter is a Physical layer device that can connect different types of network media together, as long as they have the same speed and duplex settings. Because the converter simply retransmits the signals, the single-collision domain is maintained. Bridges and switches are Data link layer devices that create multiple-collision domains. Routers are Network layer devices that create separate collision and broadcast domains.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      310,
      315,
      309,
      307,
      358
    ],
    "source": "9781394239306"
  },
  {
    "id": 1482,
    "question": "Alice has recently installed some new computers onto her Gigabit Ethernet network. To ensure the best possible network performance, she has configured the network adapters in the new computers to run at 1 Gbps speed and use full-duplex communication. Once the computers are in service, however, Alice begins getting reports of extremely poor network performance on those machines. She tries running some ping tests and does not see any problem. She calls in a consultant to perform a packet analysis and the consultant detects large numbers of packet collisions, late collisions, cyclic redundancy check (CRC) errors, lost packets, and runt frames. Which of the following could conceivably be the problem?",
    "choice_a": "Duplex mismatch",
    "choice_b": "Transmitter (TX)/receiver (RX) transposed",
    "choice_c": "Incorrect cable type",
    "choice_d": "Damaged cables",
    "correct_answer": "A",
    "explanation": "There should be no collisions at all on a full-duplex network, so the problem is clearly related to the duplexing of the communications. Ethernet running over twisted-pair cable, in its original half-duplex mode, detects collisions by looking for data on the transmit and receive pins at the same time. In full-duplex mode, data is supposed to be transmitted and received at the same time. When one side of a connection is configured to use full duplex, as Alice's new computers are, and the other end is configured to use half duplex (as the switches must be), the full-duplex communications on the one side look like collisions to the half-duplex side. The half-duplex adapter transmits a jam signal as a result of each collision, which causes the full-duplex side to receive an incomplete frame. Both sides then start to retransmit frames in a continuing cycle, causing network performance to diminish drastically. The ping tests do not detect a problem because <code>ping</code> only transmits a small amount of data in one direction at a time. The other options would likely cause the ping tests to fail as well. The solution to the problem is to configure all of the devices to autonegotiate their speed and duplex modes.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      314,
      309,
      324,
      154,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1483,
    "question": "Ed is trying to troubleshoot a problem that has caused a wired network connection to slow down noticeably. Which of the following wired network problems will cause a drastic slowdown of a network connection, without causing it to fail completely? (Choose all that apply.)",
    "choice_a": "Bottleneck",
    "choice_b": "Speed mismatch",
    "choice_c": "Duplex mismatch",
    "choice_d": "Transmitter (TX)/receiver (RX) transposed",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "A bottleneck is a component involved in a network connection that is not functioning correctly, causing a traffic slowdown that affects the entire network. A duplex mismatch occurs when one side of a connection is configured to use full duplex and the other end is configured to use half duplex. When this occurs, the full-duplex communications on the one side look like collisions to the half-duplex side. The half-duplex adapter transmits a jam signal as a result of each collision, which causes the full-duplex side to receive an incomplete frame. Both sides then start to retransmit frames in a continuing cycle, causing network performance to diminish drastically. A speed mismatch or a transmitter (TX)/receiver (RX) transposition will stop network communication completely.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      314,
      313,
      320,
      323,
      309
    ],
    "source": "9781394239306"
  },
  {
    "id": 1484,
    "question": "A user calls Alice at the help desk to report that he cannot access the Internet. He can access systems on the local network, however. Alice examines the routing table on the user's workstation and sees the following. Which of the following statements explains why the user cannot access the Internet? <img src=\"/question_assets/Network+/pt_c5_88.png\"/>",
    "choice_a": "The routing table contains a loopback address.",
    "choice_b": "The routing table does not specify a default gateway address.",
    "choice_c": "The routing table does not specify a DNS server address.",
    "choice_d": "The routing table contains two different routes to the 224.0.0.0 network.",
    "correct_answer": "B",
    "explanation": "To access the Internet, the workstation's routing table must include a default gateway entry, which would have a Network Destination value of 0.0.0.0. A workstation's routing table does not specify the address of a DNS server. The loopback and 224.0.0.0 multicast addresses are normal routing table entries.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      344,
      343,
      345,
      351,
      362
    ],
    "source": "9781394239306"
  },
  {
    "id": 1485,
    "question": "Ed is implementing a web server farm on his company's network and has created a screened subnet (or perimeter network) on which the web servers will be located. The screened subnet is using the network IP address 192.168.99.0/24. He has also installed a router connecting the screened subnet to the internal network, which uses the 192.168.3.0/24 network address. The IP addresses of the router's interfaces are 192.168.3.100 and 192.168.99.1. Ed needs to access the web servers from his Windows workstation on the internal network, but right now, he cannot do so. Because he needs to have a different router specified as his default gateway, Ed decides to add a route for the screened subnet to his computer's routing table. Which of the following commands will create a routing table entry that enables Ed to access the screened subnet?",
    "choice_a": "route add 192.168.3.0 MASK 255.255.255.0 192.168.3.100",
    "choice_b": "route add 192.168.99.1 MASK 255.255.255.0 192.168.3.0",
    "choice_c": "route add 192.168.3.100 MASK 255.255.255.0 192.168.99.0",
    "choice_d": "route add 192.168.99.0 MASK 255.255.255.0 192.168.3.100",
    "correct_answer": "D",
    "explanation": "The correct syntax for the Windows <code>route add</code> command is to specify the destination network address, followed by the subnet mask for the destination network, followed by the address of the router interface on the local network that provides access to the destination network. The other options do not specify the correct addresses in the syntax.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      344,
      343,
      345,
      362,
      331
    ],
    "source": "9781394239306"
  },
  {
    "id": 1486,
    "question": "Alice has recently created a new screened subnet (or perimeter network) for the company's web server cluster, along with a router to connect it to the internal network. When she is finished, she sends Ralph an email instructing him to run the following command on his Windows workstation so that he can access the servers on the screened subnet. What function does the IP address 192.168.87.226 perform in this command? <img src=\"/question_assets/Network+/pt_c5_90.png\"/>",
    "choice_a": "192.168.87.226 is the address of Ralph's workstation.",
    "choice_b": "192.168.87.226 is the network address of the perimeter network.",
    "choice_c": "192.168.87.226 is the address of one of the router's interfaces.",
    "choice_d": "192.168.87.226 is the address of the web server cluster.",
    "correct_answer": "C",
    "explanation": "The correct syntax for the Windows <code>route add</code> command is to specify the destination network address, followed by the subnet mask for the destination network, followed by the address of the router interface on the local network that provides access to the destination network. Therefore, 192.168.87.226 is the address of the router interface on the internal network, where Ralph's workstation is located.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      344,
      343,
      345,
      330,
      331
    ],
    "source": "9781394239306"
  },
  {
    "id": 1487,
    "question": "When you run a port scanner on a server, which of the following is the result?",
    "choice_a": "A list of processes running on the system",
    "choice_b": "A list of open ports through which the system can be accessed",
    "choice_c": "A list of protocols used by the system for network communication",
    "choice_d": "A list of IP addresses used on the network",
    "correct_answer": "B",
    "explanation": "A port scanner examines a system for open endpoints, accessible using the TCP or UDP protocols, which intruders can conceivably use to gain access to the system from the network.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      325,
      342,
      328,
      348,
      176
    ],
    "source": "9781394239306"
  },
  {
    "id": 1488,
    "question": "A port scanner examines a system for network vulnerabilities at which layer of the Open Systems Interconnection (OSI) model?",
    "choice_a": "Application",
    "choice_b": "Transport",
    "choice_c": "Network",
    "choice_d": "Data link",
    "correct_answer": "B",
    "explanation": "A port is a numbered service endpoint identifying an application running on a TCP/IP system. A port scanner examines a system for open endpoints, accessible using the TCP or UDP protocols at the Transport layer, which intruders can conceivably use to gain access to the system from the network.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      325,
      342,
      348,
      346,
      328
    ],
    "source": "9781394239306"
  },
  {
    "id": 1489,
    "question": "Which of the following best describes the primary function of a port scanner?",
    "choice_a": "A port scanner examines a computer's hardware and compiles a list of the physical ports in the system.",
    "choice_b": "A port scanner examines a computer for TCP and UDP endpoints that are accessible from the network.",
    "choice_c": "A port scanner examines a specified range of IP addresses on a network, to determine whether they are in use.",
    "choice_d": "A port scanner accepts a computer name as input and scans the network for the IP address associated with that name.",
    "correct_answer": "B",
    "explanation": "The ports that a port scanner examines are the system endpoints identified by port numbers in TCP and UDP protocol headers. An open port provides network access to an application running on the computer, which can conceivably be exploited by an intruder.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      325,
      342,
      328,
      324,
      348
    ],
    "source": "9781394239306"
  },
  {
    "id": 1490,
    "question": "Ed is working the help desk at a local computer store, and he receives a call from a customer trying to set up a home network using Windows 11 and wired Ethernet equipment. The customer reports that, from her computer, she can see the two other computers in the house, but she cannot access the Internet. Ed asks her to run the <code>ipconfig /all</code> command and read the results to him. She says that her IP address is 172.16.41.2, her subnet mask is 255.255.255.0, and her default gateway is 172.16.43.1. Which of the following is most likely the cause of the customer's problem?",
    "choice_a": "The customer's network cable is unplugged.",
    "choice_b": "The customer has an incorrect subnet mask.",
    "choice_c": "The customer has an incorrect default gateway address.",
    "choice_d": "The computer's DNS record contains the wrong information.",
    "correct_answer": "C",
    "explanation": "Because the customer can access the other two computers in the house, Ed knows that her IP address and subnet mask are properly configured, that the network cable is plugged in and functional, and that a switching loop is not preventing access to the Internet. Ed also knows that the computer's DNS record does not play a role in outgoing connections. The problem is most likely in the default gateway because the gateway address the customer specified is on another network, 172.16.43.0, rather than on her own network, 172.16.41.0.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      343,
      331,
      313,
      311,
      321
    ],
    "source": "9781394239306",
    "choice_e": "The computer is inhibited by a switching loop."
  },
  {
    "id": 1491,
    "question": "Ralph has a wired home network with three Windows computers, a switch, and a cable modem/router that provides access to the Internet. All three computers are able to access the Internet, but none of them can access filesystem shares on the others. Which of the following is the most likely cause of the problem on the three network computers?",
    "choice_a": "Incorrect IP addresses",
    "choice_b": "Incorrect subnet mask",
    "choice_c": "Incorrect default gateway address",
    "choice_d": "Incorrect access control list (ACL) settings",
    "correct_answer": "D",
    "explanation": "The problem is most likely incorrect ACL settings. Because the computers are all able to access the Internet, their TCP/IP settings, including their IP addresses, subnet mask, and default gateway address, must be correct. However, if the users do not have the correct permissions in the access control lists (ACLs) of the filesystem shares, they will not be able to access the shares over the network.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      312,
      311,
      322,
      313,
      304
    ],
    "source": "9781394239306"
  },
  {
    "id": 1492,
    "question": "Which of the following IP address assignments indicates that a computer has been unable to communicate with a DHCP server?",
    "choice_a": "127.0.0.1",
    "choice_b": "255.255.255.0",
    "choice_c": "240.15.167.251",
    "choice_d": "169.254.199.22",
    "correct_answer": "D",
    "explanation": "The address 169.254.199.22 is from the 169.254.0.0/16 network address assigned to Automatic Private IP Addressing (APIPA), a standard for the assignment of IP addresses to Dynamic Host Configuration Protocol (DHCP) clients when they cannot obtain an address from a DHCP server. 127.0.0.1 is the standard IPv4 loopback address. 240.15.167.251 is from the 240.0.0.0 network address, which is reserved for experimental use. Neither of these are ever assigned by DHCP. 255.255.255.0 is not an IP address at all; it is a subnet mask.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      330,
      331,
      321,
      313,
      316
    ],
    "source": "9781394239306"
  },
  {
    "id": 1493,
    "question": "A user reports to Ralph that he cannot access the Internet, although he is able to connect to computers on the local network. Ralph runs <code>ipconfig /all</code> on the user's workstation and examines the output. Which of the following is the most likely explanation for the user's problem, based on these <code>ipconfig</code> results? <img src=\"/question_assets/Network+/pt_c5_97.png\"/>",
    "choice_a": "The Subnet Mask setting is incorrect.",
    "choice_b": "The Default Gateway setting is incorrect.",
    "choice_c": "The DNS Servers setting is located on another network.",
    "choice_d": "DHCP is not enabled.",
    "correct_answer": "B",
    "explanation": "The Default Gateway setting should contain the address of a router on the local network that provides access to other networks, such as the Internet. In this case, therefore, the Default Gateway address should be on the 192.168.4.0 network, but it contains an address on the 192.168.6.0 network, which is not local. Therefore, the user can only access systems on the 192.168.4.0 network. The Subnet Mask setting must be correct, or the user would not be able to access any other systems. Unlike the default gateway, the DNS server does not have to be on the local network, so the address shown can be correct. DHCP is not necessary to access the Internet.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      330,
      331,
      344,
      311,
      335
    ],
    "source": "9781394239306"
  },
  {
    "id": 1494,
    "question": "Ralph is troubleshooting a workstation that cannot access the network. The workstation is plugged into a wall plate that should provide it with access to a DHCP-equipped network using the 192.168.4.0/24 network address. No one else on that network is reporting a problem. Ralph checks that the patch cable is properly plugged into the workstation and the wall plate, which they are, and then runs <code>ipconfig /all</code> on the user's workstation and examines the output. Which of the following could be the explanation for the user's problem, based on these <code>ipconfig</code> results? <img src=\"/question_assets/Network+/pt_c5_98.png\"/>",
    "choice_a": "The Subnet Mask setting is incorrect.",
    "choice_b": "The Default Gateway address is missing.",
    "choice_c": "The DHCPv4 scope is exhausted.",
    "choice_d": "The DNS server addresses are incorrect.",
    "correct_answer": "C",
    "explanation": "The 169.254.203.42 address assigned to the workstation is from the 169.254.0.0/16 network address assigned to Automatic Private IP Addressing (APIPA), a standard for the assignment of IP addresses to DHCP clients when they cannot obtain an address from a DHCP server. Since no one else is experiencing a problem, the DHCP server is presumably functioning. The Subnet Mask value is correct for an APIPA address, and APIPA does not provide Default Gateway or DNS server addresses. Therefore, an exhausted DHCP scope is the only one of the explanations provided that could be the cause of the problem.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      330,
      321,
      316,
      311,
      303
    ],
    "source": "9781394239306"
  },
  {
    "id": 1495,
    "question": "Ralph is troubleshooting a workstation that cannot access the network. The workstation is plugged into a wall plate that should provide it with access to a DHCP-equipped network using the 192.168.32.0/20 network address. Ralph checks that the patch cable is properly plugged into the workstation and the wall plate, which they are, and then runs <code>ipconfig /all</code> on the user's workstation and examines the output. Which of the following could be the explanation for the user's problem, based on these <code>ipconfig</code> results? <img src=\"/question_assets/Network+/pt_c5_99.png\"/>",
    "choice_a": "The IPv4 Address setting is incorrect.",
    "choice_b": "The Subnet Mask setting is incorrect.",
    "choice_c": "The Default Gateway setting is incorrect.",
    "choice_d": "The DNS Servers setting is located on another network.",
    "correct_answer": "B",
    "explanation": "For a computer connected to the 192.168.32.0/20 network, the Subnet Mask value should be 255.255.240.0, not 255.255.255.0, as shown in the <code>ipconfig /all</code> output. The IPv4 Address, Default Gateway, and DNS Servers settings are appropriate for the network. The workstation apparently has DHCP disabled, so it has not retrieved appropriate IP address settings from the DHCP server.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      330,
      321,
      344,
      311,
      303
    ],
    "source": "9781394239306"
  },
  {
    "id": 1496,
    "question": "Ralph is troubleshooting a workstation that cannot access the network. The workstation is plugged into a wall plate that should provide it with access to a DHCP-equipped network using the 192.168.4.0/24 network address. Ralph checks that the patch cable is properly plugged into the workstation and the wall plate, which they are, and then runs <code>ipconfig /all</code> on the user's workstation and examines the output. Which of the following could be the explanation for the user's problem, based on these <code>ipconfig</code> results? <img src=\"/question_assets/Network+/pt_c5_100.png\"/>",
    "choice_a": "The workstation could not connect to a DHCP server.",
    "choice_b": "There is a rogue DHCP server on the network.",
    "choice_c": "The workstation is not configured to use DHCP.",
    "choice_d": "The IP address assigned by the DHCP server has expired.",
    "correct_answer": "B",
    "explanation": "The DHCP client on the workstation is enabled, but the IP address assigned to the workstation is not from the 192.168.4.0/24 network. The assigned address is not an APIPA address, nor is it expired, so the only conclusion is that there is a rogue DHCP server on the network assigning addresses from a wholly different subnet.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      316,
      321,
      311,
      303,
      306
    ],
    "source": "9781394239306"
  },
  {
    "id": 1497,
    "question": "You have three virtual LANs (VLAN2, VLAN3, and VLAN4), with each implemented on three switches. A single router provides routing among the VLANs. All of the VLAN2 users connected to one particular switch are complaining that they cannot access resources on other hosts within their own VLAN or on VLAN3 and VLAN4. Before today, they could connect to local and remote resources with no problem. What is the likeliest cause of the service interruption?",
    "choice_a": "The router is malfunctioning and not routing among the VLANs.",
    "choice_b": "VLAN2 is misconfigured.",
    "choice_c": "The switch to which the VLAN2 users are connected is not functioning.",
    "choice_d": "VLAN3 and VLAN4 are misconfigured.",
    "correct_answer": "C",
    "explanation": "In this scenario, some, but not all, users on VLAN2 cannot connect to local and remote resources. Since users connected to other switches within the same VLAN and on other VLANs are not reporting any problems, the router is not the issue. This also excludes a VLAN2 configuration problem because this would affect the VLAN2 users on all of the switches. VLAN3 and VLAN4 users can communicate through the router, so they are also not the problem. The likeliest problem is the common component, which is the switch to which the VLAN2 users experiencing the outage are connected.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      322,
      313,
      317,
      303
    ],
    "source": "9781394239306"
  },
  {
    "id": 1498,
    "question": "Alice is supporting a network that consists of four internal local area networks (LANs) with 50 users each. Each internal LAN uses twisted-pair Gigabit Ethernet links that connect the users to a switch. Each of the four switches connects to a backbone router. All of the routers connect to the same backbone network, which has a single additional router to connect the company's network to the Internet, using a T-1 link. Users on one of the internal LANs are complaining that, when they came in this morning, they could not access the Internet or the other internal LANs, although they could access local resources with no problems. Which network component is the likeliest source of the problem in this scenario?",
    "choice_a": "The router connecting the problem LAN to the backbone",
    "choice_b": "The Internet router",
    "choice_c": "The switch on the problem LAN",
    "choice_d": "The cable on the backbone network",
    "correct_answer": "A",
    "explanation": "In this scenario, only users on one LAN are experiencing problems connecting to the Internet and other internal LANs. This isolates the problem to a component within that LAN only. Since users can connect successfully to local resources, the problem does not lie within the individual computers, the switch that connects the users to the network, or the backbone network cable. The likeliest problem is in the router connecting the problem LAN to the backbone network. Since users on the other internal LANs are not reporting problems connecting to the Internet, the problem most likely does not involve the Internet router.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      318,
      322,
      306,
      319,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1499,
    "question": "Ed is implementing a web server farm on his company's network and has installed a router to create a screened subnet (or perimeter network) on which the web servers will be located. However, Ed now cannot access the web servers from his workstation on the internal network. Which of the following tasks will Ed have to complete before he can access the perimeter network from the internal network? (Choose all that apply.)",
    "choice_a": "Change IP addresses.",
    "choice_b": "Change default gateway addresses.",
    "choice_c": "Update the DNS records.",
    "choice_d": "Change MAC addresses.",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Ed will first have to change IP addresses. This is because the computers on the other side of the router, on the screened subnet, must use an IP network address that is different from the internal network's address. Next, Ed will have to change the default gateway address setting on the internal network computers to the address of the router so that traffic can be directed to the screened subnet. Finally, Ed will have to update the resource records on the DNS server to reflect the IP address changes. MAC addresses are hard-coded into network interface adapters and are not easily changed.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      331,
      313,
      344,
      338,
      340
    ],
    "source": "9781394239306"
  },
  {
    "id": 1500,
    "question": "Ralph has a wired home network with three Windows computers, a switch, and a cable modem/router that provides access to the Internet. One of the computers is able to connect to the other two, but it cannot connect to the Internet. Which of the following configuration parameters on the malfunctioning computer will Ralph most likely have to change to resolve this problem?",
    "choice_a": "IP address",
    "choice_b": "Subnet mask",
    "choice_c": "Default gateway",
    "choice_d": "MAC address",
    "correct_answer": "C",
    "explanation": "The problem is most likely the default gateway address, which directs all traffic intended for the Internet to the cable modem/router. If that address is incorrect, the traffic will never reach the router or the Internet. Because the computer can access the other two systems on the local network, the IP address and subnet mask are not the problem. It is not necessary (and not always possible) to change the MAC address on a Windows workstation.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      343,
      331,
      313,
      330,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1501,
    "question": "Ralph is a network administrator attempting to use his workstation to remote into a web server called WebServ1 on a screened subnet (perimeter network). However, the remote desktop client software is unable to establish a connection to the server. Ralph can see all of the computers on his local network and on the screened subnet. He tries using the <code>ping</code> utility to test WebServ1's TCP/IP functionality, and the ping test is successful. Ralph then calls his colleague Ed and has him try to connect to WebServ1 using the same remote access tool. Ed connects successfully. Which of the following could be the cause of the problem Ralph is experiencing?",
    "choice_a": "Name resolution failure",
    "choice_b": "Unresponsive service on the web server",
    "choice_c": "Blocked TCP/UDP ports on the web server",
    "choice_d": "Incorrect firewall settings on Ralph's workstation",
    "correct_answer": "D",
    "explanation": "Because Ed can connect to WebServ1 successfully, the problem is not an unresponsive service or blocked ports on the server. The problem is not a name resolution failure because Ralph can successfully ping WebServ1 by name. Therefore, of the options listed, the only possible problem must be that the firewall on Ralph's workstation is not configured to allow the remote desktop client's traffic out.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      322,
      311,
      316,
      326,
      303
    ],
    "source": "9781394239306"
  },
  {
    "id": 1502,
    "question": "Alice is supporting a network that consists of four internal local area networks (LANs) with 50 users each. Each internal LAN uses twisted-pair Gigabit Ethernet links that connect the users to a switch. Each of the four switches connects to a backbone router. All of the routers connect to the same backbone network, which has a single additional router to connect the company's network to the Internet. Users on all of the internal LANs are complaining that, when they came in this morning, they could not access the Internet, although they could access resources on all of the LANs with no problems. Which network component is the likeliest source of the problem in this scenario?",
    "choice_a": "The router connecting the problem LAN to the backbone",
    "choice_b": "The Internet router",
    "choice_c": "The switch on the problem LAN",
    "choice_d": "The cable on the backbone network",
    "correct_answer": "B",
    "explanation": "In this scenario, all of the internal users are experiencing problems connecting to the Internet, so the router that provides access to the Internet is the suspected component. Since users can connect to resources on the internal LANs, the problem probably is not in any of the routers connecting the LANs to the backbone or the backbone cable itself. This also eliminates the probability that the switches on the LANs are the problem.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      322,
      311,
      319,
      306,
      312
    ],
    "source": "9781394239306"
  },
  {
    "id": 1503,
    "question": "A user calls the company's IT help desk to report that she has received an error message on her Windows workstation. The error states that her computer has an IP address that is duplicated on the network. Ralph is concerned that there might be a configuration problem with the DHCP servers on the network. He suspects that there are DHCP servers configured with scopes that overlap, resulting in two DHCP servers assigning the same IP addresses to different clients. He is worried that they are about to receive a flood of calls reporting the same problem. Alice reassures Ralph, telling him that it cannot be a DHCP problem, and that there must be two computers that are manually configured with the same IP address. How does Alice know this?",
    "choice_a": "Because Windows computers check the routing table before accepting an IP address from a DHCP server",
    "choice_b": "Because DHCP servers use DNS queries to check for duplicate IP addresses",
    "choice_c": "Because DHCP clients use ARP broadcasts to check for duplicate IP addresses",
    "choice_d": "Because it is only possible to have one DHCP server on a given subnet",
    "correct_answer": "C",
    "explanation": "When a Dynamic Host Configuration Protocol (DHCP) client is offered an IP address by a DHCP server, the client broadcasts Address Resolution Protocol (ARP) requests using that address before accepting it. If another computer on the local network is using the offered address, the computer responds to the ARP request and the DHCP client declines the address. The DHCP server then offers another address. DNS queries and routing table checks are not reliable means of checking for duplicate IP addresses. It is possible to have two DHCP servers on the same local network, but they must be configured with scopes that do not overlap.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      336,
      337,
      316,
      324,
      330
    ],
    "source": "9781394239306"
  },
  {
    "id": 1504,
    "question": "A user calls Alice at the IT help desk and reports that she is having intermittent problems accessing both local servers and Internet websites. Which of the following potential problems can Alice rule out immediately?",
    "choice_a": "Duplicate MAC addresses",
    "choice_b": "Duplicate IP addresses",
    "choice_c": "Malfunctioning router",
    "choice_d": "Malfunctioning DNS server",
    "correct_answer": "B",
    "explanation": "Operating systems detect duplicate IP addresses immediately and display error messages or notifications on the computers involved. Therefore, the user with the problem would have been informed immediately if another system were using her IP address. All of the other options are possible causes of the problem that are more difficult to troubleshoot.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      337,
      336,
      312,
      311,
      306
    ],
    "source": "9781394239306"
  },
  {
    "id": 1505,
    "question": "While working in her company's datacenter, Alice notices that the LEDs on most of the network switch ports are green, but there are several that are orange. Alice asks several people why this is so and receives several different answers. Which one of the following answers is correct?",
    "choice_a": "The orange LEDs indicate that no device is connected to the switch port.",
    "choice_b": "The orange LEDs indicate that the connected device is experiencing an excessive number of collisions.",
    "choice_c": "The orange LEDs indicate that the device is connected to the switch at a relatively slow speed.",
    "choice_d": "The orange LEDs indicate that the connected devices are other switches, rather than workstations.",
    "correct_answer": "C",
    "explanation": "Green LEDs indicate the device is running at the full speed supported by the switch, whereas orange LEDs indicate that the device is running at a reduced speed. If no device is connected, the LED does not illuminate at all. The LED does not indicate the occurrence of collisions or the type of device connected to the port.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      303,
      320,
      358,
      354,
      317
    ],
    "source": "9781394239306"
  },
  {
    "id": 1506,
    "question": "Ralph is a network administrator for a company with several branch offices, each of which has a Windows domain controller. There have been problems lately with the domain controllers synchronizing their data, and Ralph suspects that the problem is related to the Network Time Protocol (NTP) settings on the servers. Examining the server logs on the various domain controllers, he sees multiple errors saying, \u201cServer NTP service not synchronized.\u201d All of the other server functions are running normally. Which of the following could be the cause of the problem Ralph is experiencing?",
    "choice_a": "Name resolution failure",
    "choice_b": "Unresponsive database service on the servers",
    "choice_c": "Incorrect TCP/IP settings on the servers",
    "choice_d": "Incorrect firewall settings on the servers",
    "correct_answer": "D",
    "explanation": "On all of the servers, NTP uses the well-known User Datagram Protocol (UDP) port 123 for its communications with a Coordinated Universal Time (UTC) server. If a server's firewall is blocking that port, it cannot synchronize its clock time. If the domain controllers have clocks that are not synchronized, their data synchronization processes can be affected. The problem is not a name resolution failure, an unresponsive database service, or incorrect TCP/IP settings because other server functions are not affected.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      316,
      322,
      311,
      319,
      303
    ],
    "source": "9781394239306"
  },
  {
    "id": 1507,
    "question": "Alice's company is opening a new branch office, and Alice is responsible for building the domain controller for that office. She installs a new Windows server and configures it as a domain controller, and then ships it to the new office site. However, once it arrives and is connected to the home office network, the new domain controller fails to synchronize with the existing ones at the home office. Which of the following could be the cause of the problem?",
    "choice_a": "Incorrect time",
    "choice_b": "Server hardware failure",
    "choice_c": "Duplicate IP addresses",
    "choice_d": "Incorrect default gateway address",
    "correct_answer": "A",
    "explanation": "If the time on the domain controller at the new office is more than 5 minutes off the time held by domain controller at the home office, then the new domain controller will not synchronize. Duplicate IP addresses or an incorrect default gateway address would prevent the new domain controller from connecting to the home office network. A server hardware failure would manifest as an outage far more serious than a domain controller synchronization issue.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      316,
      311,
      322,
      305,
      303
    ],
    "source": "9781394239306"
  },
  {
    "id": 1508,
    "question": "Alice is troubleshooting a problem that some users are having connecting to an application server on the local network. While testing connectivity using the <code>ping</code> tool, she discovers that she can ping the server successfully using its computer name, but pinging the computer's fully qualified domain name (FQDN) fails. Which of the following is most likely the source of the problem?",
    "choice_a": "DNS",
    "choice_b": "DHCP",
    "choice_c": "EMI",
    "choice_d": "ACL",
    "correct_answer": "A",
    "explanation": "Only DNS servers perform FQDN resolutions, so that is likely to be the source of the problem. It is possible to ping a device on the local network using its computer name without the use of DNS. Electromagnetic interference (EMI) would inhibit all network communication, and access control lists have no effect on ping tests.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      338,
      340,
      321,
      303,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1509,
    "question": "Ralph has begun to receive calls from users reporting that they cannot access the local network or the Internet. Ralph checks their computers and discovers that all of the users with a problem have IP addresses in the 169.254.0.0/16 network, which is not the address used on Ralph's network. Which of the following might be the cause of the problem?",
    "choice_a": "The users have tried to modify their IP configuration settings.",
    "choice_b": "There is a rogue DHCP server somewhere on the network.",
    "choice_c": "The IP address leases assigned by the DHCP server have expired.",
    "choice_d": "The users' workstations have been infected by a form of malware.",
    "correct_answer": "C",
    "explanation": "The 169.254.0.0/16 network is used by Automatic Private IP Addressing (APIPA), a standard that provides DHCP clients with an IP address when they cannot contact a DHCP server. Unknown to Ralph, the DHCP server on his network has been down for over a week, and the users' IP address leases have begun to expire. This causes them to revert to APIPA addresses. Multiple users changing their IP addresses would not result in them all using the same network address. A rogue DHCP would not be likely to deploy APIPA addresses to clients. Malware infections that modify IP addresses are rare.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      330,
      321,
      316,
      313,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1510,
    "question": "Ralph is working with a multifunction router that provides Internet access and that also has a switch module with four Ethernet ports, all of which are assigned to the default VLAN1. Ralph can plug a laptop into one of the router's ports and access the Internet with no problems. Ralph now needs to connect the router to his company network, so that the wireless access points on the network can provide users with Internet access through the router's connection. However, when Ralph plugs an Ethernet port on the router into a switch port on the company network in VLAN4, the switch starts generating \u201cNative VLAN mismatch detected\u201d errors every minute. Which of the following steps should be part of the solution Ralph implements to stop the error messages? (Choose all that apply.)",
    "choice_a": "Create a VLAN1 on the company network switch.",
    "choice_b": "Create a VLAN4 on the Internet router's switch module.",
    "choice_c": "Configure the network switch port connected to the router to use VLAN1.",
    "choice_d": "Configure the router port connected to the network switch to use VLAN4.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "The solution should call for Ralph to create a VLAN on the Internet router that matches the VLAN the network switch port is using. Therefore, he should create a VLAN4 on the router and assign a port to it, which will be the port Ralph uses to connect the router to the network switch. There is no need to create a VLAN1 on the network switch because all switches have a default VLAN called VLAN1. Modifying the VLAN assignments on the network switch is not a good idea, because it might interfere with the existing VLAN strategy in place.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      355,
      313,
      311,
      322,
      303
    ],
    "source": "9781394239306"
  },
  {
    "id": 1511,
    "question": "Ralph is working with a multifunction router that provides Internet access and that also has a switch module containing four Ethernet ports, all of which are assigned to VLAN2. Ralph can plug a laptop into one of the router's ports and access the Internet with no problems. Ralph now needs to connect the router to his company network, so that the wireless access points on the network can provide users with Internet access through the router's connection. However, when Ralph plugs an Ethernet port on the router into a switch port on the company network in VLAN4, the switch starts generating \u201cNative VLAN mismatch detected\u201d errors every minute. To correct the problem, Ralph attempts to create a VLAN4 on the Internet access router, but he receives a \u201cFeature not licensed\u201d error. Which of the following actions can Ralph take to resolve the problem? (Choose all that apply.)",
    "choice_a": "Purchase a feature upgrade for the Internet access router.",
    "choice_b": "Create a VLAN2 on the switch.",
    "choice_c": "Configure the Internet access router to use VLAN1.",
    "choice_d": "Configure the switch to use VLAN1.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Ralph could purchase a license upgrade for the Internet access router enabling him to create a VLAN4. However, the simpler and less expensive solution would be to create a VLAN2 on the network switch. As long as both ends of the cable are plugged into ports using the same VLAN, the router should be able to service the network. Configuring the devices to use the default VLAN1 might interfere with the existing VLAN strategy.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      355,
      313,
      154,
      349,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1512,
    "question": "Clients of Ralph's company are calling to complain that, when they try to access the company's website, they see an error message stating that the website has an untrusted security certificate. They are afraid that they are connecting to an unprotected site or that the site has been taken over by hackers. What must Ralph do to address this problem?",
    "choice_a": "Obtain a security certificate from a trusted third-party company.",
    "choice_b": "Configure the web servers to generate a self-signed certificate.",
    "choice_c": "Install a certification authority on one of the network servers.",
    "choice_d": "Explain to the clients that it is safe to bypass the error message and proceed to the website.",
    "correct_answer": "A",
    "explanation": "For the website's security certificate to be trusted, it must be signed by a source that both parties in the transaction trust. Many security firms are in the business of providing certificates to companies that have confirmed their identities. This is what Ralph must do to prevent the error message from appearing to the company's clients. Creating a self-signed certificate or installing a certification authority in-house is not sufficient and is probably already the cause of the problem. Users are not likely to be convinced that everything is all right just because Ralph says so.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      316,
      312,
      311,
      322,
      305
    ],
    "source": "9781394239306"
  },
  {
    "id": 1513,
    "question": "Alice is working the IT help desk at her company, which has 500 inside salespeople who start work at 9:00 AM. The users are running Windows 11 and obtaining their IP address configuration settings from DHCP servers. Every morning, Alice receives many trouble calls from users who are experiencing extremely slow performance after they first turn on their computers. Their performance gradually improves within an hour. Which of the following is the most likely cause of the slowdown?",
    "choice_a": "Broadcast storm",
    "choice_b": "Network loop",
    "choice_c": "Rogue DHCP server",
    "choice_d": "Switching loop",
    "correct_answer": "A",
    "explanation": "The most likely cause for the slowdown is a broadcast storm. DHCP relies on broadcast messages to assign IP addresses to users, so 500 users all turning on their computers at the same time in the morning can generate an abnormally high number of broadcast packets. This can degrade network performance until all of the users have completed their DHCP address assignments. Network loops, switching loops, and asymmetric routing can degrade network performance, but the degradation would not be limited to the early morning hours. A rogue DHCP server can cause problems but not the one described here.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      154,
      315,
      316,
      321,
      324
    ],
    "source": "9781394239306",
    "choice_e": "Asymmetric routing"
  },
  {
    "id": 1514,
    "question": "Which of the following TCP/IP parameters, configured on an end system, specifies the Internet Protocol (IP) address of a router on the local network that provides access to other networks?",
    "choice_a": "IPv6 Address",
    "choice_b": "Default Gateway",
    "choice_c": "DNS Servers",
    "choice_d": "Subnet Mask",
    "correct_answer": "B",
    "explanation": "The Default Gateway parameter specifies the address of the local router that the end system should use to access other networks. The IPv6 Address parameter is the 128-bit address the end system uses on IP version 6 networks. The DNS Servers parameter contains the addresses of servers used to resolve names into IP addresses. The Subnet Mask parameter specifies the sizes of the network and host identifiers in an IPv4 address.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      331,
      330,
      313,
      343,
      336
    ],
    "source": "9781394239306"
  },
  {
    "id": 1515,
    "question": "Which of the following network devices do not employ access control lists (ACLs) to restrict access?",
    "choice_a": "Routers",
    "choice_b": "Hubs",
    "choice_c": "Switches",
    "choice_d": "Wireless access points (WAPs)",
    "correct_answer": "B",
    "explanation": "ACLs restrict access to network devices by filtering usernames, MAC addresses, IP addresses, or other criteria. Routers, switches, and WAPs all use ACLs to control access to them. Hubs are purely Physical layer devices that relay electrical or optical signals; they have no way of controlling access to them.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      317,
      353,
      315,
      154,
      323
    ],
    "source": "9781394239306"
  },
  {
    "id": 1516,
    "question": "Which of the following features help to protect network switches from attacks related to the Spanning Tree Protocol (STP)? (Choose all that apply.)",
    "choice_a": "BPDU guard",
    "choice_b": "Root guard",
    "choice_c": "DHCP snooping",
    "choice_d": "Geofencing",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Bridge protocol data units (BPDUs) are messages that switches running the STP exchange to learn about the available paths through a switched network and the states of other switches. Switches should receive BPDUs only through ports that are connected to other switches. BPDU guard is a feature that prevents BPDU messages from arriving through ports with other roles, such as those connected to computers, thus preventing an attacker from manipulating the STP topology. A root guard affects the behavior of the STP by enforcing the selection of root bridge ports on a switched network. Without root guards, there is no way for administrators to enforce the topology of a network with a redundant switching fabric. DHCP snooping is a feature found in some switches that prevents rogue DHCP servers from assigning IP addresses to clients. Geofencing is a wireless networking technique for limiting access to a network. Neither is related to the STP.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      315,
      154,
      317,
      350,
      355
    ],
    "source": "9781394239306"
  },
  {
    "id": 1517,
    "question": "Delays in the transmission of data packets over a network can result in temporary service interruptions, dropouts, or even data loss. Which of the following terms is used to describe these delays?",
    "choice_a": "Crosstalk",
    "choice_b": "Electromagnetic interference (EMI)",
    "choice_c": "Jitter",
    "choice_d": "Attenuation",
    "correct_answer": "C",
    "explanation": "Jitter is defined as delays in the transmission of individual network packets. For audio or video transmissions, jitter can result in dropped words or frames. For data file transmissions, jitter can require the retransmission of packets.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      324,
      309,
      322,
      311,
      348
    ],
    "source": "9781394239306"
  },
  {
    "id": 1518,
    "question": "Ralph has purchased an IEEE 802.11ac wireless access point, which he plans to use to build a home network with his two computers, both of which have 802.11ax network adapters, and a television, which has an 802.11n adapter that can only run on the 2.4 GHz band. When he connects the devices to the access point, he finds that the two computers communicate properly, but the TV does not. What can Ralph do to enable all of his devices to connect using the new access point?",
    "choice_a": "Nothing. The television can never connect to the new access point.",
    "choice_b": "Configure the access point to run on the 2.4 GHz band.",
    "choice_c": "Configure the computers to run on the 2.4 GHz band.",
    "choice_d": "Move the television closer to the access point.",
    "correct_answer": "A",
    "explanation": "The 802.11ac standard calls for the use of the 5 GHz frequency band only, which means that it will never be able to connect to 2.4 GHz devices like the television. It is not possible to configure the access point to run on the 2.4 GHZ band, and configuring the computers to use that band will prevent them from connecting to the access point. The distance between the devices has no bearing on the connections in this instance.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      360
    ],
    "source": "9781394239306"
  },
  {
    "id": 1519,
    "question": "Ralph is setting up a wireless network using the 2.4 GHz frequency band. Which of the following channels should he use to avoid channel overlap? (Choose all that apply.)",
    "choice_a": "1",
    "choice_b": "4",
    "choice_c": "6",
    "choice_d": "8",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "The 2.4 GHz band used by wireless LANs (WLANs) consists of channels that are 20 (or 22) MHz wide. However, the channels are only 5 MHz apart, so there is channel overlap that can result in interference. Channels 1, 6, and 11 are the only channels that are far enough apart from each other to avoid any overlap with the adjacent channels. Channels 4 and 8 are susceptible to overlap.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      310,
      360,
      321,
      323,
      315
    ],
    "source": "9781394239306",
    "choice_e": "11"
  },
  {
    "id": 1520,
    "question": "Ralph is adding new workstations to his wireless network, which uses an access point that is configured to use WPA3 encryption. However, after configuring the wireless network adapter on the first workstation, Ralph finds that it is not connecting to the network. The access point is listed on the Available Networks display, and there are no error messages or indications of a problem, just a failure to connect. Which of the following is most likely to be the problem?",
    "choice_a": "Incorrect passphrase",
    "choice_b": "Channel overlap",
    "choice_c": "Incorrect SSID",
    "choice_d": "Incorrect antenna placement",
    "correct_answer": "A",
    "explanation": "Specifying the wrong passphrase for the encryption protocol is the most common cause of a failure to connect to the network with no indication of an error. Incorrect antenna placement and channel overlap could result in a weak signal or no signal, either of which would be indicated in the Available Networks list. An incorrect SSID is not likely to be the error, as long as Ralph selected the access point from the list.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      311,
      322,
      312,
      310,
      303
    ],
    "source": "9781394239306"
  },
  {
    "id": 1521,
    "question": "Ralph is adding new workstations to his wireless network, which uses a single access point that is configured to use WPA3 encryption. However, after installing the wireless network adapter on the first workstation, Ralph finds that he cannot see the wireless access point on the Available Networks display. Which of the following could be the problem? (Choose all that apply.)",
    "choice_a": "Incorrect passphrase",
    "choice_b": "Channel overlap",
    "choice_c": "Incorrect SSID",
    "choice_d": "Incorrect antenna polarization",
    "correct_answer": [
      "B",
      "D",
      "E"
    ],
    "explanation": "Interference resulting from channel overlap, signal degradation due to incorrect antenna polarization, and signal loss due to antenna cable attenuation could render the workstation unable to make contact with the access point. An incorrect WPA3 passphrase would not be the problem, unless Ralph had already seen the access point and attempted to connect to it. An incorrect SSID would be the problem only if Ralph had already attempted to manually enter an SSID. The network has only a single access point, so there is no chance of roaming misconfiguration causing the problem.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      310,
      360,
      322,
      311,
      320
    ],
    "source": "9781394239306",
    "choice_e": "Antenna cable attenuation",
    "choice_f": "Roaming misconfiguration"
  },
  {
    "id": 1522,
    "question": "Ralph is the administrator of a small company's wireless network. He has recently discovered evidence that users outside of the company's office space have been accessing its wireless network. The office is located in a narrow space against the building's outside wall. Ralph is concerned that the network's wireless access point is extending coverage outside the building. Speaking with a consultant friend of his, Ralph is advised to install a different type of antenna on his access point. Which of the following antenna types would most likely help Ralph to alleviate the problem?",
    "choice_a": "Dipole",
    "choice_b": "Yagi",
    "choice_c": "Patch",
    "choice_d": "Unidirectional",
    "correct_answer": "C",
    "explanation": "A patch antenna is a flat device that transmits signals in a half-spherical pattern. By placing the antenna against the building's outer wall, Ralph can provide coverage inside the building and minimize coverage extending to the outside. A dipole antenna is another name for the omnidirectional antenna usually provided with an access point. A unidirectional antenna directs signals in a straight line, which would not provide the coverage Ralph needs. A Yagi antenna is a type of unidirectional antenna.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      360,
      310,
      320,
      322,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1523,
    "question": "Trixie has recently moved to a new office in her company's building, down the hall from her old one. Since the move, she has only been able to access the wireless network with her laptop intermittently. She never had a problem in her previous location. Which of the following could possibly be the cause of her problem? (Choose all that apply.)",
    "choice_a": "Trixie's new office is farther from the access point than her old one.",
    "choice_b": "Her laptop is connecting to the wrong SSID.",
    "choice_c": "The access point is using an omnidirectional antenna.",
    "choice_d": "There are too many walls between Trixie's new office and the access point.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Greater distance from the access point or interference from intervening walls can both cause a weakening of wireless signals, resulting in the insufficient wireless coverage and intermittent connectivity that Trixie is experiencing. An incorrect SSID would prevent Trixie's laptop from ever connecting to the network. An omnidirectional antenna generates signals in every direction, which would not account for Trixie's problem.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      310,
      360,
      312,
      311,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1524,
    "question": "Alice is a new hire at Adatum Corp., and when she asks about wireless network access for her laptop, she is given an SSID and a WPA3 passphrase. Later, in the lunchroom when she tries to connect her laptop to the network, she cannot see the SSID she was given in the Available Networks list, although she can see other networks. What should Alice do next to try to resolve the problem?",
    "choice_a": "Type in the WPA3 passphrase.",
    "choice_b": "Type in the SSID manually.",
    "choice_c": "Move closer to the wireless access point.",
    "choice_d": "Move away from the microwave in the lunchroom.",
    "correct_answer": "B",
    "explanation": "It is possible that the wireless access point has been configured not to broadcast the network's SSID as a security measure, so Alice should first attempt to access it by typing in the SSID manually. She would not be able to type in the WPA3 passphrase until she is connecting to the SSID. Moving the laptop closer to the access point or away from possible sources of electromagnetic interference might be solutions to the problem, but they should not be the first thing Alice tries.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      310,
      311,
      322,
      303,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1525,
    "question": "Alice is a new hire at Adatum Corp., and when she asks about wireless network access for her laptop, she is given an SSID and a passphrase. She is also told that she must add the SSID manually. Later, she types in the SSID she was given, and the computer prompts her to select a security type. Not knowing which option to choose, she selects 802.1X because it sounds as though it should be the most secure. However, this option does not enable her to enter her passphrase, so she selects another option, WEP, and is able to type in the passphrase. However, her laptop says she \u201cCan't connect to this network.\u201d Which of the following is the most likely cause of Alice's problem?",
    "choice_a": "Overcapacity",
    "choice_b": "Distance limitations",
    "choice_c": "Frequency mismatch",
    "choice_d": "Encryption protocol mismatch",
    "correct_answer": "D",
    "explanation": "The most likely cause of Alice's problem is that she has selected an incorrect encryption protocol. Wired Equivalent Privacy (WEP) is still provided as an option on many wireless devices, but it has long since been found to be insecure and is almost never used. Alice should try selecting the other security types that enable her to enter her passphrase, such as Wi-Fi Protected Access 3 (WPA3). Although the other options are possible causes of the problem, encryption protocol mismatch is the most likely cause.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      310,
      321,
      322,
      311,
      303
    ],
    "source": "9781394239306"
  },
  {
    "id": 1526,
    "question": "Ralph purchases some 802.11ac wireless network adapters for desktop computers at a yard sale, which he intends to use to upgrade his outdated 802.11g home network. He installs one of the adapters in a computer and attempts to connect it to the network, but he cannot see his SSID. He tries a different adapter, thinking the first one might be broken, but that one does not work either. What can Ralph do to resolve the problem and connect the computer to his network?",
    "choice_a": "Move the computer closer to the access point.",
    "choice_b": "Configure the access point to use the 5 GHz frequency.",
    "choice_c": "Manually enter the SSID in the computer's client software.",
    "choice_d": "Nothing. 802.11ac equipment cannot connect to an 802.11g network.",
    "correct_answer": "D",
    "explanation": "Wireless LAN equipment built to the 802.11ac standard can only use the 5 GHz frequency. However, an 802.11g access point can only use the 2.4 GHz frequency. Therefore, the network adapters cannot connect to Ralph's access point. Moving the devices closer together or manually entering the SSID will have no effect on the connections.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      310,
      322,
      311,
      305,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1527,
    "question": "Ralph is responsible for building a new wireless LAN for his company that consists of an 802.11n 2x2:2 access point and laptop computers with a variety of network adapters. Some of the laptops support 802.11n, most support 802.11ac, and a few older models still have 802.11g adapters. The new wireless LAN will be located in a large office building with many other wireless networks, and Ralph is having trouble finding a channel on the 2.4 GHz band that is not congested with traffic. Scanning the 5 GHz band, he finds relatively little traffic, so he reconfigures the access point to use a 5 GHz channel. The result is that some of the laptops are able to connect to the network, whereas others are not. What is the most likely reason for the connection failures, and what must Ralph do to enable all of the laptops to connect to the wireless network?",
    "choice_a": "The 5 GHz band does not support automatic channel selection. Ralph must configure each laptop to use the same channel as the access point in order for all the laptops to connect successfully.",
    "choice_b": "The 802.11ac and 802.11g standards do not support communication using the 5 GHz band. Ralph must configure the access point to support 2.4 GHz in order for all the laptops to connect successfully.",
    "choice_c": "The 5 GHz band does not support MIMO communications, so the 802.11n laptops are unable to connect to the network. Ralph must replace the access point with an 802.11ax unit in order for all the laptops to connect successfully.",
    "choice_d": "The 802.11g standard does not support communication using the 5 GHz band. Ralph must replace the network adapters in those laptops with newer models in order for them to connect successfully.",
    "correct_answer": "B",
    "explanation": "The 802.11g standard does not support 5 GHz communications. Replacing the 802.11g adapters with those of a newer standard, such as 802.11n, 802.11ac, or 802.11ax, is the only way to connect these devices to the 5 GHz network. The 5 GHz band does support automatic channel selection, so there is no need to configure the channel on each laptop manually. The 802.11ac standard supports only the 5 GHz band, so configuring the access point to use 2.4 GHz will prevent these devices from connecting. The 5 GHz band does support MIMO, and the 802.11n laptops should be able to connect.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      310,
      360,
      322,
      311,
      305
    ],
    "source": "9781394239306"
  },
  {
    "id": 1528,
    "question": "Alice is the administrator of a wireless network that has client computers in a number of small offices, all located on the same floor of an office building built in the mid-twentieth century. The network has an IEEE 802.11n access point located at the approximate center of the floor. Workstations in most of the rooms connect to the network using the 2.4 GHz band at 72 Mbps, but the computers in one particular room run much more slowly and rarely connect at that speed. Which of the following might be the cause of the problem?",
    "choice_a": "The computers in the problematic room are configured to use a different wireless encryption protocol than the access point.",
    "choice_b": "The computers in the problematic room are experiencing an SSID mismatch.",
    "choice_c": "The network adapters in the problematic computers support IEEE 802.11ac, not 802.11n.",
    "choice_d": "The RSSI of the problematic computers might be low, due to excessive distance from the access point.",
    "correct_answer": "D",
    "explanation": "As wireless computers move farther away from the access point, their signals attenuate (weaken), their received signal strength indicators (RSSI) go down, and the maximum speed of their connections drops. If the computers were using a different encryption protocol than the access point, there would be no connection at all, not a diminished connection speed. An SSID mismatch would cause the computers to connect to a different network, not necessarily connect at a slower speed. If the computers had 802.11ac adapters, they would fail to connect to the access point at all because 802.11ac requires the use of the 5 GHz frequency band, and the 802.11n network uses 2.4 GHz.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      360,
      310,
      322,
      311,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1529,
    "question": "Which of the following is not a potential solution for an IEEE 802.11n wireless computer that has intermittent problems connecting to an IEEE 802.11n access point?",
    "choice_a": "Install a higher gain antenna on the access point.",
    "choice_b": "Replace the access point with a model that supports 802.11ax.",
    "choice_c": "Move the computer closer to the access point.",
    "choice_d": "Change the channel used by the access point.",
    "correct_answer": "B",
    "explanation": "Replacing the access point with an 802.11ax model is not likely to have any effect at all unless you upgrade the computer's network adapter as well. Installing a higher gain antenna on the access point can improve its range, enabling the computer to connect more readily. Moving the computer closer to the access point can strengthen the signal and raise its received signal strength indicator (RSSI), enabling it to connect more reliably. Changing the channel on the access point to a lesser used one can enable the computer to connect more easily.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      310,
      360,
      322,
      311,
      303
    ],
    "source": "9781394239306"
  },
  {
    "id": 1530,
    "question": "Ed has installed a separate 802.11n wireless network for guest users working in his company's offices. The guest network is unsecured, and Ed has recently become aware that people outside the building are able to access it. It is not possible to move the access point, and it must run at maximum power to reach the entire building. Which of the following is the most convenient way to prevent users outside the building from accessing the guest network while leaving it available to users inside the building?",
    "choice_a": "Change the passphrase daily.",
    "choice_b": "Switch the network frequency.",
    "choice_c": "Disable SSID broadcasting.",
    "choice_d": "Implement MAC filtering.",
    "correct_answer": "C",
    "explanation": "Disabling SSID broadcasts will not defeat dedicated attackers, but it can prevent casual intruders from accessing the network. MAC filtering would require Ed to configure the access point with the MAC addresses of all devices that will access the network, which would be impractical in this case. The network is unsecured, so there is no passphrase to change, and a frequency change will have no effect on the problem.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      360,
      317,
      325,
      320,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1531,
    "question": "Alice is trying to provide users in a warehouse with wireless network connectivity for their tablets. The warehouse is a huge concrete structure with many internal cinderblock walls. Which of the following types of signal interference are inhibiting Alice's efforts?",
    "choice_a": "Refraction",
    "choice_b": "Reflection",
    "choice_c": "Diffraction",
    "choice_d": "Absorption",
    "correct_answer": "D",
    "explanation": "Absorption is a type of interference that occurs when radio signals have to pass through barriers made of dense materials, such as concrete or cinderblock walls. The density of the material's molecular structure causes the radio signals to be partially converted to heat, which weakens them. Reflection is when signals bounce off of certain surfaces, such as metal. Refraction is when signals bend as they pass through certain barriers, such as glass or water. Diffraction is when signals have to pass around barriers to reach a particular destination. All of these phenomena can weaken the radio signals used in wireless networking, but absorption is the primary problem for Alice in this case.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      360,
      310,
      312,
      322,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1532,
    "question": "Ralph is having trouble providing satisfactory wireless network performance to some executive offices at the far end of the building. The wireless access point is based on the 802.11n standard. The offices have heavy doors and insulated walls for sound dampening, and the occupants typically leave their doors closed during work hours. Which of the following actions can Ralph take to provide the users in these offices with better wireless network performance?",
    "choice_a": "Install an additional access point nearer to the offices.",
    "choice_b": "Modify the access point to use higher number channels.",
    "choice_c": "Upgrade the access point to a model based on the 802.11ax standard.",
    "choice_d": "Configure the access point to disable SSID broadcasting.",
    "correct_answer": "A",
    "explanation": "The closer the users are to the access point, the stronger the signals will be. Installing an additional access point nearer to the executive offices will likely enable the signals to pass through the barriers more efficiently. The channel used by the access point, the standard on which the access point is based, and the broadcasting of SSID signals have no effect on the strength of the signals reaching the executive offices and will not resolve Ralph's problem.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      360,
      310,
      322,
      311,
      312
    ],
    "source": "9781394239306"
  },
  {
    "id": 1533,
    "question": "Ralph is having trouble providing satisfactory wireless network performance to some executive offices at the far end of the building. The offices have heavy doors and insulated walls for sound dampening, and the occupants typically leave their doors closed during work hours. Which of the following types of radio signal interference is Ralph trying to overcome?",
    "choice_a": "Reflection",
    "choice_b": "Refraction",
    "choice_c": "Diffraction",
    "choice_d": "Absorption",
    "correct_answer": "D",
    "explanation": "Absorption is a type of interference that occurs when radio signals have to pass through barriers made of dense materials, such as walls and doors. In this case, the construction of the barriers has made them more formidable. Reflection is when signals bounce off of certain surfaces, such as metal. Refraction is when signals bend as they pass through certain barriers, such as glass or water. Diffraction is when signals have to pass around barriers to reach a particular destination. All of these phenomena can weaken the radio signals used in wireless networking, but absorption is the primary problem for Ralph in this case.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      310,
      360,
      322,
      311,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1534,
    "question": "Ralph is having trouble providing satisfactory wireless network performance to a row of glass-walled conference rooms at the far end of the building. The doors to the conference rooms are also made of glass and are always closed when meetings are in progress. Which of the following types of radio signal interference are likely to be the main issues that Ralph is trying to overcome? (Choose all that apply.)",
    "choice_a": "Reflection",
    "choice_b": "Refraction",
    "choice_c": "Diffraction",
    "choice_d": "Attenuation",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Attenuation is the tendency of signals to weaken as they travel through a network medium. In the case of a wireless network, the medium is the air, and the farther away a wireless device is from the access point, the weaker the signal will be. Refraction is when signals bend as they pass through certain types of barriers, such as the glass walls of conference rooms. The bending changes the direction of the signals, possibly causing them to weaken in the process. Reflection is when signals bounce off of certain surfaces, such as metal. Diffraction is when signals have to pass around barriers to reach a particular destination. All of these phenomena can weaken the radio signals used in wireless networking, but attenuation and refraction are likely to be the primary problems for Ralph in this case.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      360,
      310,
      309,
      323,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1535,
    "question": "Alice receives a call from a user who cannot connect to the company's 802.11n wireless network with a laptop that has an 802.11ac network adapter. Other users running 802.11n and 802.11g devices in the same area are able to connect to the network without difficulty. Which of the following are tasks that Alice can perform to resolve the problem? (Choose all that apply.)",
    "choice_a": "Replace the access point with one that supports the 802.11ac standard.",
    "choice_b": "Change the channel used by the wireless access point.",
    "choice_c": "Replace the wireless network adapter in the user's laptop.",
    "choice_d": "Move the user closer to the wireless access point.",
    "correct_answer": "C",
    "explanation": "The network is supporting 802.11n and 802.11g devices, so it must be running on the 2.4 GHz band. The 802.11ac standard is fundamentally incompatible with the network because it only runs on the 5 GHz band. Therefore, the only viable solution is to install a network adapter in the laptop that supports 2.4 GHz. Installing an 802.11ac access point would prevent the 2.4 GHz devices from connecting. Changing channels on the access point and moving the user will have no effect on the problem.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      312,
      311,
      322,
      305,
      360
    ],
    "source": "9781394239306"
  },
  {
    "id": 1536,
    "question": "Several accounting consultants are working in Ed's office for the first time, and they are unable to connect to the 802.11ax wireless network with their laptops. They are selecting the correct SSID from the Available Networks list, but they cannot connect, and there are no error messages of any kind. Which of the following tasks should Ed perform to try to resolve the problem?",
    "choice_a": "Check the network adapters in the laptops for channel overlap.",
    "choice_b": "Change the frequency used by the wireless access point from 2.4 GHz to 5 GHz.",
    "choice_c": "Examine the area where the consultants are working for possible sources of signal interference.",
    "choice_d": "Make sure that the consultants' laptops are configured to use the correct wireless security protocol.",
    "correct_answer": "D",
    "explanation": "The use of an incorrect wireless security protocol is a well-known source of errorless connection failures, so checking this will most likely enable Ed to locate the source of the problem. Channel overlap is a problem that Ed would check and resolve at the access point, not the users' workstations. While it is possible to change the frequency on an 802.11ax access point, this would likely interfere with the connectivity of the other network devices. Although signal interference could conceivably be the cause for a connection failure, the users can see the network, so this is probably not the problem.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      310,
      322,
      312,
      313,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1537,
    "question": "Ed has installed a separate 802.11n wireless network for guest users working in his company's offices. The guest network uses no security protocol, and Ed has recently become aware that people outside the building are able to access it. Which of the following steps can Ed take to prevent users outside the building from accessing the guest network, while leaving it available to users inside the building? (Choose all that apply.)",
    "choice_a": "Move the wireless access point to the center of the building.",
    "choice_b": "Lower the power level of the wireless access point.",
    "choice_c": "Implement MAC filtering.",
    "choice_d": "Install a captive portal.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Moving the access point to the center of the building will keep as much of its operational range inside the structure as possible. If the signals still reach outside the building, Ed can reduce the power level of the access point until the network is only accessible inside. MAC filtering would require Ed to configure the access point with the MAC addresses of all devices that will access the network, which would be impractical in this case. Installing a captive portal would not block outside users unless Ed configures the portal to require user authentication, which defeats the purpose of the guest network.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      360,
      317,
      311,
      322,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1538,
    "question": "Alice receives a call from a user who cannot connect to the company's 802.11ax wireless network with a laptop that has an 802.11n network adapter. Other users working in the same area are able to connect to the network without difficulty. Which of the following steps should Alice take first to try to resolve the problem? (Choose all that apply.)",
    "choice_a": "Change the channel used by the wireless access point.",
    "choice_b": "Check whether the user is connecting to the correct SSID.",
    "choice_c": "Check whether the wireless adapter in the user's laptop is enabled.",
    "choice_d": "Provide the user with an 802.11ax wireless network adapter.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The first steps Alice should take are the simplest ones: make sure that the wireless interface in the user's laptop is turned on and that she is attempting to connect to the correct SSID for the company network. Changing the channel would not be necessary unless other users in the area are also having problems due to interference. The 802.11n wireless networking standard is compatible with 802.11ax, so it should not be necessary to provide the user with a new network adapter.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      303,
      311,
      312,
      310,
      322
    ],
    "source": "9781394239306"
  },
  {
    "id": 1539,
    "question": "Users on Ed's 802.11n wireless network are dropping their connections intermittently. Which of the following might help to resolve these client dissociation issues?",
    "choice_a": "Restart the wireless access point.",
    "choice_b": "Change the network's SSID.",
    "choice_c": "Change the channel the devices are using.",
    "choice_d": "Change the wireless security protocol.",
    "correct_answer": "C",
    "explanation": "If the users are losing their connections due to interference from other types of devices, changing the channel alters the frequency the network uses and can enable it to avoid the interference. The other options are not likely to affect any condition that would cause clients to dissociate.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      310,
      360,
      311,
      312,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1540,
    "question": "Several accounting consultants are working in Ed's office for the first time, and they are unable to connect to the 802.11n wireless network with their laptops. Which of the following tasks should Ed perform first to try to resolve the problem? (Choose two.)",
    "choice_a": "Check the network adapters in the laptops for channel overlap.",
    "choice_b": "Make sure that the consultants are attempting to connect to the correct SSID.",
    "choice_c": "Examine the area where the consultants are working for possible sources of signal interference.",
    "choice_d": "Make sure that the consultants' laptops are configured to use the correct wireless encryption protocol.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Of the options provided, the ones most likely to be causing the problem are the use of an incorrect SSID or encryption protocol. Although signal interference could possibly be a cause, it is more likely that the new users have devices that are incorrectly configured for Ed's network. Channel overlap is a problem that Ed would check and resolve at the access point, not the users' workstations.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      311,
      312,
      313,
      321,
      310
    ],
    "source": "9781394239306"
  },
  {
    "id": 1541,
    "question": "Ralph is deploying an 802.11n wireless network for a client that calls for the best possible security without deploying additional servers. When setting up the wireless access point, Ralph disables SSID broadcasts, selects Wi-Fi Protected Access Pre-shared Keys (WPA-PSK), and configures MAC address filtering. Which of the following statements about the security of this arrangement is true?",
    "choice_a": "The configuration is as secure as Ralph can make it with the specified equipment.",
    "choice_b": "Ralph should not disable SSID broadcasts, because this prevents users from connecting to the network.",
    "choice_c": "Ralph should not use MAC address filtering, because it exposes MAC addresses to possible attacks.",
    "choice_d": "Ralph should use Wi-Fi Protected Access 2 (WPA2) instead of WPA, because it is more resistant to certain types of attacks.",
    "correct_answer": "D",
    "explanation": "WPA has been found to be vulnerable, and WPA2 increases security by replacing the Temporal Key Integrity Protocol (TKIP) with the Advanced Encryption System (AES), so Ralph should use WPA2 instead of WPA. Suppressing SSID broadcasts does not prevent users from connecting to the network, and MAC filtering strengthens security without exposing MAC addresses to undue risk.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      316,
      310,
      317,
      353,
      336
    ],
    "source": "9781394239306"
  },
  {
    "id": 1542,
    "question": "Which of the following is a power measurement of a specific transmitter and antenna combination, as used in a wireless access point?",
    "choice_a": "RSSI",
    "choice_b": "EIRP",
    "choice_c": "SSID",
    "choice_d": "MIMO",
    "correct_answer": "B",
    "explanation": "Effective isotropic radiated power (EIRP) is a measurement of the signal strength generated by an access point (or other radio transceiver) with a particular antenna. Received signal strength indicator (RSSI) is a measurement of the strength of the signal received by a device from an access point. Service set identifier (SSID) is a designation assigned to a specific wireless network, which appears in the Available Networks list of a Wi-Fi client. Multiple input, multiple output (MIMO) is a technology used by some IEEE wireless networking standards to increase throughput capacity by using multiple antennas.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      360,
      310,
      327,
      354,
      356
    ],
    "source": "9781394239306"
  },
  {
    "id": 1543,
    "question": "Alice has been asked to update an accounts receivable spreadsheet with information about the day's incoming payments, a task she has never performed before. After locating and opening the spreadsheet on the network server, she types in her new information, but when she attempts to save the changes, she receives an error message that directs her to save the file on her local drive instead of the network server. Which of the following is the probable cause of the problem?",
    "choice_a": "Blocked TCP/UDP ports",
    "choice_b": "Incorrect filesystem ACL settings",
    "choice_c": "Incorrect firewall settings",
    "choice_d": "An untrusted SSL certificate",
    "correct_answer": "B",
    "explanation": "Because Alice is able to access the server and open the spreadsheet file, the problem is not related to blocked ports, firewall settings, or an untrusted certificate. The problem is most likely that though she has the necessary filesystem access control list (ACL) permissions to open and read the file, she does not have the permissions needed to modify it.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      312,
      311,
      322,
      305,
      306
    ],
    "source": "9781394239306"
  },
  {
    "id": 1544,
    "question": "Which of the following terms best describes a connectivity problem on wired networks that is caused by individual packets that are delayed due to network congestion, different routing, or queuing problems?",
    "choice_a": "Latency",
    "choice_b": "Attenuation",
    "choice_c": "Jitter",
    "choice_d": "Bottleneck",
    "correct_answer": "C",
    "explanation": "When individual packets in a data stream are delayed, the resulting connectivity problem is called jitter. Although this condition might not cause problems for asynchronous applications, real-time communications, such as Voice over Internet Protocol (VoIP) or streaming video, can suffer interruptions, from which the phenomenon gets its name. Latency describes a generalized delay in network transmissions, not individual packet delays. Attenuation is the weakening of a signal as it travels through a network medium. A bottleneck is a condition in which all traffic is delayed, due to a faulty or inadequate component.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      324,
      329,
      309,
      323,
      335
    ],
    "source": "9781394239306"
  },
  {
    "id": 1545,
    "question": "Which of the following network applications are most likely to be obviously affected by the wired network connectivity problem known as jitter? (Choose all that apply.)",
    "choice_a": "Email",
    "choice_b": "VoIP",
    "choice_c": "Streaming video",
    "choice_d": "Instant messaging",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Jitter is a connectivity problem on wired networks that is caused by individual packets that are delayed due to network congestion, different routing, or queuing problems. When individual packets in a data stream are delayed, the resulting connectivity problem is called jitter. While this condition might not cause problems for asynchronous applications, such as email and instant messaging, real-time communications, such as Voice over Internet Protocol (VoIP) or streaming video, can suffer intermittent interruptions, from which the phenomenon gets its name.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      315,
      318,
      322,
      324,
      154
    ],
    "source": "9781394239306"
  },
  {
    "id": 1546,
    "question": "Ralph is experiencing long access point association times and generally poor performance on his home 802.11n wireless network. Ralph lives in a large apartment complex, and when he runs a Wi-Fi analyzer, he sees many other nearby networks using the often-recommended channels 1, 6, and 11 on the 2.4 GHz frequency. Using the 5 GHz frequency is not an option for Ralph's equipment. What should Ralph do to improve his network performance?",
    "choice_a": "Configure his equipment to use channel 2.",
    "choice_b": "Configure his equipment to use channel 5.",
    "choice_c": "Configure his equipment to use channel 9.",
    "choice_d": "Configure his equipment to use channel 10.",
    "correct_answer": "C",
    "explanation": "The 2.4 GHz band used by wireless LANs (WLANs) consists of channels that are 20 (or 22) MHz wide. However, the channels are only 5 MHz apart, so there is channel overlap that can result in interference, possibly causing long AP association times and degraded performance. Channels 1, 6, and 11 are the only channels that are far enough apart from each other to avoid any overlap with the adjacent channels. This is why they are often recommended. However, in Ralph's case, these channels are too crowded with other networks. Therefore, Ralph should use a channel that is as far as possible from the crowded ones. Channels 2, 5, and 10 are all immediately adjacent to a crowded channel, but channel 9 is at least two channels away from the nearest crowded channel. Therefore, Ralph should configure his equipment to use channel 9.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      360,
      310,
      304,
      322,
      303
    ],
    "source": "9781394239306"
  },
  {
    "id": 1547,
    "question": "Ralph is a new hire working on a network that uses CAT 6 unshielded twisted-pair cable, which was installed several years ago. Over time, some of the paper labels that the original cable installers used to identify the wall plates and patch panel connectors have worn away or fallen off. As a result, Ralph has quite a few cable runs that he is unable to identify. After checking with his supervisor, Ralph discovers that the company has no cable testing equipment and is unwilling to hire a consultant just to identify cable runs. What is the most inexpensive tool Ralph can use to associate unlabeled wall plates with the correct patch panel ports?",
    "choice_a": "A visual fault locator",
    "choice_b": "A cable tester",
    "choice_c": "A toner and probe",
    "choice_d": "A protocol analyzer",
    "correct_answer": "C",
    "explanation": "A toner and probe is by far the most inexpensive solution for testing both ends of cable runs. A cable tester could do the job, but it is much more expensive. A visual fault locator is a tool for testing fiber-optic cables, and a protocol analyzer looks at packet contents.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      357,
      358,
      361,
      323,
      309
    ],
    "source": "9781394239306"
  },
  {
    "id": 1548,
    "question": "Which of the following tools might you use when connecting internal twisted-pair cable runs to the keystone connectors that snap into wall plates? (Choose all that apply.)",
    "choice_a": "A crimper",
    "choice_b": "A punchdown tool",
    "choice_c": "A pigtail splicer",
    "choice_d": "A wire stripper",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "The punchdown tool is critical to this operation. In one motion, the tool strips the insulation off of the wire, presses it down into the connector, and cuts off the excess at the end. A wire stripper simplifies the task of preparing the cable for the connection process. A crimper is used only for attaching connectors to patch cables. Pigtail splicers and fusion splicers are used only on fiber-optic networks.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      358,
      357,
      307,
      308,
      323
    ],
    "source": "9781394239306",
    "choice_e": "A fusion splicer"
  },
  {
    "id": 1549,
    "question": "Which of the following tools can you use to test for signal degradation in a fiber-optic cable?",
    "choice_a": "An optical power meter",
    "choice_b": "A toner and probe",
    "choice_c": "A protocol analyzer",
    "choice_d": "A visual fault locator",
    "correct_answer": "A",
    "explanation": "An optical power meter measures the signal strength on fiber-optic cables to locate breaks and measure signal degradation as part of an optical loss test set (OLTS); it can only be used on fiber-optic cables. Toner and probe tools are used in copper-based cabling installations, not fiber-optic cabling. A protocol analyzer is a tool that captures network packets for the purpose of analyzing their contents. A visual fault locator is a laser light source used to locate breaks in fiber-optic cables, not signal degradation.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      358,
      361,
      323,
      320,
      324
    ],
    "source": "9781394239306"
  },
  {
    "id": 1550,
    "question": "Which of the following troubleshooting tools can test cabling for length, attenuation, near-end crosstalk (NEXT), equal level far-end crosstalk (ELFEXT), propagation delay, delay skew, and return loss?",
    "choice_a": "Toner and probe",
    "choice_b": "Cable certifier",
    "choice_c": "Optical power meter",
    "choice_d": "Spectrum analyzer",
    "correct_answer": "B",
    "explanation": "You can use a cable certifier to identify a variety of cable performance characteristics, typically including cabling lengths, signal attenuation, crosstalk, propagation delay, delay skew, and return loss. The other tools listed are dedicated to a single testing modality and do not test for crosstalk.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      358,
      309,
      323,
      361,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1551,
    "question": "Which of the following statements about cable certifiers are true? (Choose all that apply.)",
    "choice_a": "A cable certifier eliminates the need for testing tools like toners and probes.",
    "choice_b": "Cable certifiers are the most inexpensive cable testing solution.",
    "choice_c": "Cable certifiers must be reconfigured whenever a new cable specification is standardized.",
    "choice_d": "Cable certifiers can only test copper-based cables.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Cable certifiers can detect all of the faults that toners and probes can detect, and they can do a great deal more, such as specify whether a cable run meets the performance specifications defined in a cable standard. When testing a new cable type, the specifications defined in the cable standard must be added to the device. Cable certifiers are far more expensive than most other cable testing solutions. Cable certifiers are available that support various cable media, including copper and fiber-optic.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      358,
      357,
      361,
      323,
      309
    ],
    "source": "9781394239306"
  },
  {
    "id": 1552,
    "question": "Which of the following tools can you use to create your own twisted-pair patch cables? (Choose all that apply.)",
    "choice_a": "Punchdown tool",
    "choice_b": "Crimper",
    "choice_c": "Pliers",
    "choice_d": "Wire stripper",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "A crimper is a device used for attaching connectors to patch cables. A wire stripper, while not essential to the process, can simplify the task of preparing the cable. A punchdown tool is used for attaching keystone connectors to cable ends, for use in wall plates and patch panels. A standard set of pliers is not used in the process of attaching connectors.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      358,
      307,
      323,
      320,
      305
    ],
    "source": "9781394239306"
  },
  {
    "id": 1553,
    "question": "Which of the following cable installation tools is likely to be the most expensive?",
    "choice_a": "A crimper",
    "choice_b": "A cable certifier",
    "choice_c": "A punchdown tool",
    "choice_d": "A toner and probe",
    "correct_answer": "B",
    "explanation": "A cable certifier is a complex electronic device that can perform a battery of tests on a cable run, confirm that the cable conforms to the required wiring standards, and maintains records of the testing procedure. Cable certifiers are by far the most expensive of the devices listed. Crimpers and punchdown tools are relatively simple and inexpensive mechanical devices that cable installers use to connect bulk cable to connectors. A toner and probe is an electronic device for cable testing, but it is still relatively simple.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      358,
      357,
      309,
      323,
      305
    ],
    "source": "9781394239306"
  },
  {
    "id": 1554,
    "question": "What is the function of the tool shown in the following figure? <img src=\"/question_assets/Network+/c05uf001.png\"/> <p></p>",
    "choice_a": "When you place the tool at one end of a wire, it generates a tone that can be detected at the other end.",
    "choice_b": "To connect a bulk cable to a keystone connector, you use the tool to punch each wire down into the correct receptacle on the connector.",
    "choice_c": "By touching the end of the tool to a copper cable, you can detect and measure the electrical current flowing through it.",
    "choice_d": "By connecting the tool to the end of a fiber-optic cable, you can measure the length of the cable run.",
    "correct_answer": "B",
    "explanation": "The device shown in the figure is a punchdown tool, used to connect unshielded twisted-pair cable ends to the keystone connectors used in modular wall plates and patch panels. After lining up the individual wires in the cable with the connector, you use the tool to press each wire into its slot. The tool also cuts the wire sheath to make an electrical contact and trims the end of the wire. This tool is not capable of performing any of the tasks described in the other options.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      357,
      358,
      320,
      307,
      323
    ],
    "source": "9781394239306"
  },
  {
    "id": 1555,
    "question": "What is the function of the tool shown in the following figure? <img src=\"/question_assets/Network+/c05uf002.png\"/>",
    "choice_a": "When you place the tool at one end of a wire, it generates a tone that can be detected at the other end.",
    "choice_b": "To connect a bulk cable to a keystone connector, you use the tool to punch each wire down into the correct receptacle on the connector.",
    "choice_c": "By touching the end of the tool to a copper cable, you can detect and measure the electrical current flowing through it.",
    "choice_d": "By connecting the tool to the end of a fiber-optic cable, you can measure the length of the cable run.",
    "correct_answer": "A",
    "explanation": "The device shown in the figure is a toner and probe, used to test unshielded twisted-pair wiring and detect certain basic wiring faults. This tool is not capable of performing any of the tasks described in the other options.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      357,
      358,
      323,
      322,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1556,
    "question": "What is the function of the tool shown in the following figure? <img src=\"/question_assets/Network+/c05uf003.png\"/>",
    "choice_a": "When you place the tool at one end of a wire, it generates a tone that can be detected at the other end.",
    "choice_b": "To attach a bulk cable end to an RJ-45 connector, you use the tool to squeeze the connector closed, forcing the wire ends to contact the connector's pins.",
    "choice_c": "By touching the end of the tool to a copper cable, you can detect and measure the electrical current flowing through it.",
    "choice_d": "By connecting the clips to pins in a punchdown block, you can access telephone circuits in order to test them or place telephone calls.",
    "correct_answer": "B",
    "explanation": "The device shown in the figure is a crimper, which is used to create patch cables by attaching connectors to both ends of a relatively short length of bulk cable. This tool is not capable of performing any of the tasks described in the other options.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      357,
      308,
      320,
      305,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1557,
    "question": "Ralph is testing a twisted-pair cable run using a toner and probe. When he applies the toner to one particular wire at one end of the cable, he fails to detect a tone at the other end. Which of the following faults has Ralph discovered?",
    "choice_a": "Open",
    "choice_b": "Short",
    "choice_c": "Split pair",
    "choice_d": "Crosstalk",
    "correct_answer": "A",
    "explanation": "The failure to detect a tone on a wire indicates that there is either a break in the wire somewhere inside the cable or a bad connection with the pin in one or both connectors. This condition is called an open circuit. A short is when a wire is connected to two or more pins at one end of the cable. A split pair is a connection in which two wires are incorrectly mapped in exactly the same way on both ends of the cable. Crosstalk is a type of interference caused by signals on one wire bleeding over to other wires.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      357,
      358,
      323,
      309,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1558,
    "question": "Ralph is testing a twisted-pair cable run using a toner and probe. When he applies the toner to a particular pin at one end of the cable, he detects a tone on two pins at the other end. Which of the following faults has Ralph discovered?",
    "choice_a": "Open",
    "choice_b": "Short",
    "choice_c": "Split pair",
    "choice_d": "Crosstalk",
    "correct_answer": "B",
    "explanation": "A short is when a wire is connected to two or more pins at one end of the cable or when the conductors of two or more wires are touching inside the cable. This would cause a tone applied to a single pin at one end to be heard on multiple pins at the other end. An open circuit would manifest as a failure to detect a tone on a wire, indicating that there is either a break in the wire somewhere inside the cable or a bad connection with the pin in one or both connectors. A split pair is a connection in which two wires are incorrectly mapped in exactly the same way on both ends of the cable. Crosstalk is a type of interference caused by signals on one wire bleeding over to other wires.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      357,
      358,
      323,
      309,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1559,
    "question": "Ralph is using a toner and probe to test some newly installed twisted-pair cable runs on his network. Which of the following cable faults will he be unable to detect?",
    "choice_a": "Open",
    "choice_b": "Short",
    "choice_c": "Split pair",
    "choice_d": "Transposed pairs",
    "correct_answer": "C",
    "explanation": "A split pair is a connection in which two wires are incorrectly mapped in exactly the same way on both ends of the cable. Each pin on one end of the cable is correctly wired to the corresponding pin at the other end, but the wires inside the cable used to make the connections are incorrect. In a properly wired connection, each twisted pair should contain a signal wire and a ground wire. In a split pair, it is possible to have two signal wires twisted together as a pair. This can generate excessive amounts of crosstalk, corrupting both of the signals involved. Because all of the pins are connected properly, a toner and probe cannot detect this fault. An open circuit would manifest as a failure to detect a tone on a wire, indicating that there is either a break in the wire somewhere inside the cable or a bad connection with the pin in one or both connectors. A short is when a wire is connected to two or more pins at one end of the cable or when the conductors of two or more wires are touching inside the cable. Transposed pairs is a fault in which both of the wires in a pair are connected to the wrong pins at one end of the cable. All three of these faults are detectable with a toner and probe.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      357,
      323,
      358,
      309,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1560,
    "question": "Alice has been told by a consultant that the newly installed twisted-pair cable runs on her network might have split pairs. Which of the following cable testing tools can she use to detect split pairs?",
    "choice_a": "Toner and probe",
    "choice_b": "Visual fault locator",
    "choice_c": "Multimeter",
    "choice_d": "Cable certifier",
    "correct_answer": "D",
    "explanation": "A split pair is a connection in which two wires are incorrectly mapped in exactly the same way on both ends of the cable. Each pin on one end of the cable is correctly wired to the corresponding pin at the other end, but the wires inside the cable used to make the connections are incorrect. In a properly wired connection, each twisted pair should contain a signal wire and a ground wire. In a split pair, it is possible to have two signal wires twisted together as a pair. This can generate excessive amounts of crosstalk, corrupting both of the signals involved. Because all of the pins are connected properly, a toner and probe cannot detect this fault, and neither can a multimeter. A visual fault locator is a laser light source used to locate breaks in fiber-optic cables. However, a cable certifier is a highly sophisticated electronic device that can detect all types of cable faults, including split pairs, as well as measure cable performance characteristics.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      358,
      323,
      357,
      361,
      309
    ],
    "source": "9781394239306"
  },
  {
    "id": 1561,
    "question": "Ralph is testing some newly installed twisted-pair cable runs on his network, and he has found one run that appears to have a cable break. However, the connectors at both ends are correctly installed, so the break must be somewhere inside the cable itself, which is nearly 100 meters long. Which of the following tools can Ralph use to determine the location of the cable break? (Choose all that apply.)",
    "choice_a": "Toner and probe",
    "choice_b": "Multimeter",
    "choice_c": "Visual fault locator",
    "choice_d": "Cable certifier",
    "correct_answer": "D",
    "explanation": "A time-domain reflectometer (TDR) is a device that determines the length of a cable by transmitting a signal at one end and measuring how long it takes for a reflection of the signal to return from the other end. Using this information and the cable's nominal velocity of propagation (NVP)\u2014a specification supplied by the cable manufacturer\u2014the device can calculate the length of a cable run. In a cable with a break in its length, a TDR calculates the length of the cable up to the break. <p>Cable certifiers typically have time-domain reflectometry capabilities integrated into the unit, which determines the location of a break by transmitting a signal at one end and measuring how long it takes for a reflection of the signal to return from the break. A toner and probe or a multimeter cannot locate a cable break. A visual fault locator is a laser light source used to locate cable breaks, but only in fiber-optic cables.</p>",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      358,
      357,
      361,
      309,
      323
    ],
    "source": "9781394239306"
  },
  {
    "id": 1562,
    "question": "Ralph's company has engaged a firm of wiring contractors to install some new fiber-optic cable runs. Before the cables are connected to any devices, Ralph wants to confirm that they have been installed to proper specifications. He brings in a contractor from another firm to test the cable runs. To test each cable run, the contractor connects a light source to one end of the cable and a measuring device to the other end. Which of the following is the correct name for this testing device?",
    "choice_a": "Optical power meter",
    "choice_b": "OLTS",
    "choice_c": "Spectrum analyzer",
    "choice_d": "Multimeter",
    "correct_answer": "B",
    "explanation": "An optical loss test set (OLTS) is the term for the combination of an optical light source and an optical power meter. The optical power meter by itself cannot be used to test the cable runs when there are no devices connected to them. A spectrum analyzer is a device for measuring the amplitudes and frequencies of wireless signals. A multimeter is a device for measuring the electric current on a copper cable.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      310,
      361,
      358,
      323,
      309
    ],
    "source": "9781394239306"
  },
  {
    "id": 1563,
    "question": "Ralph is attempting to access a Domain Name System (DNS) server located on the other side of a router, but his attempt fails with an error stating that the destination port UDP 53 is unreachable. His first step in troubleshooting the problem is to try using the <code>nslookup</code> utility to access that specific DNS server. This too fails. Next, he uses the <code>ping</code> utility with the DNS server's IP address. The ping test is successful, indicating that the server is up and running. Which of the following are possible causes of the problem? (Choose all that apply.)",
    "choice_a": "The router connecting the networks is not running DNS and will not forward this type of datagram.",
    "choice_b": "The DNS process on the remote server is not running.",
    "choice_c": "The TCP/IP host configuration on the computer is improperly configured.",
    "choice_d": "The TCP/IP host configuration on the DNS server computer is improperly configured.",
    "correct_answer": [
      "B",
      "E"
    ],
    "explanation": "One possible cause of the problem is that the DNS process on the remote server is corrupted or not running. Another possible cause is that there is a firewall blocking access to the server's UDP port 53. Both of these would render the port unreachable. The TCP/IP client on the server is operating, as verified by the <code>ping</code> utility. This means that the IP host configurations on Ralph's computer and on the DNS server are both functioning. The router does not need to be running DNS to forward datagrams.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      338,
      335,
      321,
      334,
      311
    ],
    "source": "9781394239306",
    "choice_e": "There is a firewall blocking the DNS server's UDP 53 port."
  },
  {
    "id": 1564,
    "question": "Which of the following Windows tools uses ICMP messages and manipulates IPv4 time-to-live (TTL) values to illustrate the route packets take through an internetwork?",
    "choice_a": "ping",
    "choice_b": "netstat",
    "choice_c": "route",
    "choice_d": "tracert",
    "correct_answer": "D",
    "explanation": "The Windows <code>tracert</code> tool transmits a series of ICMP messages with incrementing time-to-live (TTL) values, which identify each router on the path the packets take through the network. <code>Ping</code> uses ICMP, but it does not manipulate TTL values. <code>Netstat</code>, <code>route</code>, and <code>nslookup</code> do not use ICMP messages, nor do they manipulate TTL values when performing their normal functions.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      329,
      335,
      362,
      347,
      348
    ],
    "source": "9781394239306",
    "choice_e": "nslookup"
  },
  {
    "id": 1565,
    "question": "Users are having trouble connecting to Internet hosts. Alice suspects that there is a problem with the Domain Name System (DNS) server, and she wants to verify this. Which of the following steps can she take to determine whether the DNS server is resolving Internet hostnames?",
    "choice_a": "Issue the ipconfig command from a local workstation.",
    "choice_b": "Try to connect to a host using the IP address instead of the hostname.",
    "choice_c": "Ping the DNS server to see if it is functioning.",
    "choice_d": "Use the tracert command to test the functionality of the DNS server.",
    "correct_answer": "B",
    "explanation": "If Alice suspects that a DNS server is not resolving hostnames, she should try connecting to a remote host using the IP address instead of the name. If she can connect, she knows that all internal local area network (LAN) components and the Internet gateway are functioning, and the remote host is functioning. The problem most likely lies within the DNS server itself. If Alice cannot connect to a remote host using the IP address, the problem is not the DNS server. She would need to do more testing to isolate the problem device and the affected area. <code>Ipconfig</code> is a workstation command that enables you to verify the local IP configuration; it is not used to test a DNS server's functionality. Using the <code>ping</code> command will only tell you whether the computer hosting the DNS service is functioning at the Network layer of the Open Systems Interconnection (OSI) model; it will not test the DNS service functionality. The <code>tracert</code> (or <code>traceroute</code>) command is used to identify the hop-by-hop path taken to reach a destination; it does not allow you to test functionality above the Network layer of the OSI model.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      338,
      339,
      318,
      322,
      331
    ],
    "source": "9781394239306"
  },
  {
    "id": 1566,
    "question": "Which of the following utilities can you use to view resource record information on a particular DNS server? (Choose two.)",
    "choice_a": "netstat",
    "choice_b": "nslookup",
    "choice_c": "nbtstat",
    "choice_d": "arp",
    "correct_answer": [
      "B",
      "E"
    ],
    "explanation": "<code>Nslookup</code> and <code>dig</code> are both command-line utilities that you can direct to a specific DNS server and then generate queries that display resource record information the program retrieves from the server. <code>Netstat</code> displays information about networking protocols, whereas <code>nbtstat</code> displays information derived from the system's NetBIOS over TCP/IP implementation. <code>Arp</code> is a tool that you can use to display and manage a system's ARP table entries. <code>Netstat</code>, <code>nbtstat</code>, and <code>arp</code> are not able to display resource record information.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      338,
      339,
      337,
      336,
      362
    ],
    "source": "9781394239306",
    "choice_e": "dig"
  },
  {
    "id": 1567,
    "question": "Which of the following Windows command-line utilities produced the output shown here? <img src=\"/question_assets/Network+/pt_c5_171.png\"/>",
    "choice_a": "ping",
    "choice_b": "tracert",
    "choice_c": "netstat",
    "choice_d": "arp",
    "correct_answer": "D",
    "explanation": "Running the <code>arp</code> utility with the <code>-a</code> parameter on a Windows system displays the contents of the Address Resolution Protocol (ARP) cache. The cache contains records of the IP addresses on the network that <code>arp</code> has resolved into MAC addresses. The <code>ping</code>, <code>tracert</code>, <code>netstat</code>, and <code>hostname</code> utilities are not capable of producing this output.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      337,
      336,
      335,
      347,
      331
    ],
    "source": "9781394239306",
    "choice_e": "hostname"
  },
  {
    "id": 1568,
    "question": "Which of the following Windows command-line utilities produced the output shown here? <img src=\"/question_assets/Network+/pt_c5_172.png\"/>",
    "choice_a": "ping",
    "choice_b": "tracert",
    "choice_c": "netstat",
    "choice_d": "arp",
    "correct_answer": "B",
    "explanation": "The Windows <code>tracert</code> utility functions by transmitting a series of Internet Control Message Protocol (ICMP) Echo Request messages to a specified destination with incrementing time-to-live (TTL) values. Each successive message reaches one hop farther on the route to the destination before timing out. Therefore, the <code>tracert</code> display lists the names and addresses of the routers that packets must traverse to reach the destination. The <code>ping</code>, <code>netstat</code>, <code>arp</code>, and <code>hostname</code> utilities are not capable of producing this output.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      341,
      335,
      362,
      347,
      311
    ],
    "source": "9781394239306",
    "choice_e": "hostname"
  },
  {
    "id": 1569,
    "question": "Which of the following Windows command-line utilities produced the output shown here? <img src=\"/question_assets/Network+/pt_c5_173.png\"/>",
    "choice_a": "ping",
    "choice_b": "tracert",
    "choice_c": "netstat",
    "choice_d": "arp",
    "correct_answer": "A",
    "explanation": "The Windows <code>ping</code> utility functions by transmitting a series of Internet Control Message Protocol (ICMP) Echo Request messages to a specified destination. The destination system responds with ICMP Echo Reply messages that are listed in the output display. The <code>tracert</code>, <code>netstat</code>, <code>arp</code>, and <code>hostname</code> utilities are not capable of producing this output.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      335,
      329,
      346,
      337,
      341
    ],
    "source": "9781394239306",
    "choice_e": "hostname"
  },
  {
    "id": 1570,
    "question": "Which of the following Windows command-line utilities produced the output shown here? <img src=\"/question_assets/Network+/pt_c5_174.png\"/>",
    "choice_a": "ping",
    "choice_b": "tracert",
    "choice_c": "netstat",
    "choice_d": "arp",
    "correct_answer": "C",
    "explanation": "Running the Windows <code>netstat</code> utility with no parameters generates a list of the workstation's active connections. The <code>ping</code>, <code>tracert</code>, <code>arp</code>, and <code>hostname</code> utilities are not capable of producing this output.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      346,
      347,
      335,
      337,
      362
    ],
    "source": "9781394239306",
    "choice_e": "hostname"
  },
  {
    "id": 1571,
    "question": "Which of the following command-line utilities is capable of performing the same basic function as <code>traceroute</code> or <code>tracert</code>?",
    "choice_a": "ping",
    "choice_b": "pathping",
    "choice_c": "netstat",
    "choice_d": "route",
    "correct_answer": "B",
    "explanation": "Like <code>traceroute</code> and <code>tracert</code>, <code>pathping</code> is capable of generating a list of the routers that packets pass through on the way to a specific destination system. <code>Pathping</code> also displays the percentage of lost packets for each hop, which <code>traceroute</code> and <code>tracert</code> cannot do. The <code>ping</code>, <code>netstat</code>, and <code>route</code> utilities are not capable of displaying route traces.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      329,
      362,
      335,
      347,
      348
    ],
    "source": "9781394239306"
  },
  {
    "id": 1572,
    "question": "Which TCP/IP utility should you use to most easily identify a malfunctioning router on your network?",
    "choice_a": "ifconfig",
    "choice_b": "ping",
    "choice_c": "traceroute",
    "choice_d": "netstat",
    "correct_answer": "C",
    "explanation": "The <code>traceroute</code> (or <code>tracert</code>) utility can locate a malfunctioning router by using an Echo Request messages with incrementing TTL values. <code>Ifconfig</code> is a network configuration utility for Unix and Linux systems; <code>ping</code> can test connectivity to another TCP/IP system, but it cannot locate a malfunctioning router; and <code>netstat</code> displays information about network connections and traffic but cannot locate a malfunctioning router.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      329,
      335,
      346,
      330,
      331
    ],
    "source": "9781394239306"
  },
  {
    "id": 1573,
    "question": "Which of the following protocols does the <code>ping</code> program never use to carry its messages?",
    "choice_a": "Ethernet",
    "choice_b": "ICMP",
    "choice_c": "IP",
    "choice_d": "UDP",
    "correct_answer": "E",
    "explanation": "All Windows ping transactions use ICMP messages. ICMP messages are encapsulated directly within IP datagrams; they do not use Transport layer protocols, such as UDP and TCP. Ping transactions to destinations on the local network are encapsulated within Ethernet frames. On Unix and Linux, <code>ping</code> uses UDP, which is also encapsulated in IP datagrams.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      335,
      329,
      341,
      336,
      346
    ],
    "source": "9781394239306",
    "choice_e": "TCP"
  },
  {
    "id": 1574,
    "question": "Which of the following commands displays the routing table on the local computer?",
    "choice_a": "arp \u2013r",
    "choice_b": "netstat \u2013r",
    "choice_c": "ifconfig \u2013r",
    "choice_d": "telnet \u2013r",
    "correct_answer": "B",
    "explanation": "The <code>netstat</code> utility can display the routing table, along with other types of network traffic and port information. The <code>arp</code> utility is for adding addresses to the ARP cache; it cannot display the routing table. The <code>ifconfig</code> command displays TCP/IP configuration information on Unix and Linux systems; it cannot display the routing table. <code>Telnet</code> is a terminal emulation program; it cannot display the routing table. <code>Show route</code> is a router console command that does nothing on the local computer.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      347,
      362,
      343,
      331,
      337
    ],
    "source": "9781394239306",
    "choice_e": "show route"
  },
  {
    "id": 1575,
    "question": "Which of the following command lines will produce the output shown in the figure? <img src=\"/question_assets/Network+/c05uf004.png\"/>",
    "choice_a": "ping 10.0.0.1 -t",
    "choice_b": "ping 10.0.0.1 -n 2048",
    "choice_c": "ping 10.0.0.1 -l 2048 -n 11",
    "choice_d": "ping 10.0.0.1 -l 2048 -t",
    "correct_answer": "C",
    "explanation": "Running <code>ping</code> with the <code>-l</code> parameter enables you to specify the size of the messages sent to the target\u2014in this case, 2,048 bytes. The <code>-n</code> parameter enables you to specify the number of messages the <code>ping</code> tool should transmit\u2014in this case, 11. Combining these two parameters generates the output in the figure. The <code>-t</code> parameter causes the <code>ping</code> tool to transmit messages until manually halted.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      335,
      341,
      330,
      329,
      311
    ],
    "source": "9781394239306",
    "choice_e": "ping 10.0.0.1 -n 2048 -t 11"
  },
  {
    "id": 1576,
    "question": "Which of the following commands enables you to view the ARP table stored in memory?",
    "choice_a": "arp -c",
    "choice_b": "arp -d",
    "choice_c": "arp -a",
    "choice_d": "arp -s",
    "correct_answer": "C",
    "explanation": "The <code>arp -a</code> command displays the entries in the ARP table stored in its cache. The <code>arp -d</code> command is for deleting entries, and the <code>arp -s</code> command is for adding entries. The <code>arp -c</code> command is not a valid option.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      337,
      336,
      330,
      362,
      347
    ],
    "source": "9781394239306"
  },
  {
    "id": 1577,
    "question": "Which of the following command-line utilities enables you to generate Domain Name System (DNS) request messages?",
    "choice_a": "ifconfig",
    "choice_b": "nslookup",
    "choice_c": "nbtstat",
    "choice_d": "netstat",
    "correct_answer": "B",
    "explanation": "The <code>nslookup</code> tool enables you to generate DNS request messages from the command line and send them to a specific DNS server. The other options listed are not DNS utilities.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      338,
      339,
      362,
      331,
      321
    ],
    "source": "9781394239306",
    "choice_e": "iperf"
  },
  {
    "id": 1578,
    "question": "Which of the following command-line utilities enables you to view the Internet Protocol (IP) configuration on a Unix or Linux host?",
    "choice_a": "ifconfig",
    "choice_b": "nslookup",
    "choice_c": "ipconfig",
    "choice_d": "netstat",
    "correct_answer": "A",
    "explanation": "On a Unix or Linux host, the <code>ifconfig</code> command displays the system's current IP configuration settings and parameters. <code>Ipconfig</code> is a Windows command-line utility that performs the same basic function. The other options are command-line utilities that do not display IP configuration information.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      331,
      332,
      333,
      330,
      362
    ],
    "source": "9781394239306",
    "choice_e": "iperf"
  },
  {
    "id": 1579,
    "question": "Which of the following parameters causes the <code>ping</code> tool to transmit messages continually until manually halted?",
    "choice_a": "-n",
    "choice_b": "-t",
    "choice_c": "-i",
    "choice_d": "-a",
    "correct_answer": "B",
    "explanation": "Running the <code>ping</code> tool with the <code>-t</code> parameter causes it to send messages to the target continuously until it is manually stopped. The <code>-n</code> parameter specifies the number of messages the <code>ping</code> tool should transmit. The <code>-i</code> parameter specifies the time-to-live (TTL) value of the messages <code>ping</code> transmits. The <code>-a</code> parameter resolves the IP address specified as the target to a hostname.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      335,
      341,
      329,
      311,
      322
    ],
    "source": "9781394239306"
  },
  {
    "id": 1580,
    "question": "Which of the following Windows commands enables you to delete the entire ARP cache?",
    "choice_a": "arp -c *",
    "choice_b": "arp -d *",
    "choice_c": "arp -a",
    "choice_d": "show arp -d *",
    "correct_answer": "B",
    "explanation": "The <code>arp -d</code> command is for deleting cache entries, and by running it with the asterisk wildcard, the command deletes all of the entries in the cache. The <code>arp -a</code> command displays the entries in the ARP table stored in its cache, and the <code>arp -s</code> command is for adding entries. The <code>arp -c *</code> command is not a valid option. <code>Show arp</code> is a console command used on switches, not in Windows.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      337,
      336,
      330,
      362,
      347
    ],
    "source": "9781394239306",
    "choice_e": "arp -s"
  },
  {
    "id": 1581,
    "question": "Ralph has been advised to check his Linux web servers for open ports that attackers might be able to use to penetrate the servers' security. Which of the following utilities can Ralph use to do this?",
    "choice_a": "tcpdump",
    "choice_b": "dig",
    "choice_c": "iptables",
    "choice_d": "nmap",
    "correct_answer": "D",
    "explanation": "The <code>nmap</code> utility is capable of scanning a system for open ports that might be a security hazard. The <code>tcpdump</code>, <code>dig</code>, <code>iptables</code>, and <code>iperf</code> utilities cannot do this.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      342,
      328,
      325,
      348,
      346
    ],
    "source": "9781394239306",
    "choice_e": "iperf"
  },
  {
    "id": 1582,
    "question": "While performing a protocol analysis, Alice notes that there are many ICMP packets in her captured traffic samples. She attributes these to her frequent use of TCP/IP troubleshooting tools. Which of the following utilities are used to test Network layer characteristics of a host using Internet Control Message Protocol (ICMP) messages? (Choose all that apply.)",
    "choice_a": "ipconfig",
    "choice_b": "netstat",
    "choice_c": "ping",
    "choice_d": "tracert",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "<code>Ping</code> and <code>tracert</code> are both utilities that test Network layer characteristics using ICMP messages. <code>Ping</code> tests the Network layer functionality of the host, and <code>traceroute</code> displays the path to the host through the internetwork. <code>Ipconfig</code> and <code>netstat</code> do not use ICMP messages.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      335,
      329,
      324,
      331,
      346
    ],
    "source": "9781394239306"
  },
  {
    "id": 1583,
    "question": "Which of the following parameters enables you to specify the time-to-live (TTL) value of the messages the <code>ping</code> tool transmits?",
    "choice_a": "-n",
    "choice_b": "-t",
    "choice_c": "-i",
    "choice_d": "-a",
    "correct_answer": "C",
    "explanation": "Running the <code>ping</code> tool with the <code>-i</code> parameter specifies the time-to-live (TTL) value of the messages ping transmits. The <code>-t</code> parameter causes the <code>ping</code> tool to send messages to the target continuously until it is manually stopped. The <code>-n</code> parameter specifies the number of messages the <code>ping</code> tool should transmit. The <code>-a</code> parameter resolves an IP address specified as the target to a hostname.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      335,
      329,
      341,
      331,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1584,
    "question": "Ralph is the network administrator of his company's network. He has had three users call the help desk to report that they are having problems connecting to the local application server. Comparing their stories, Ralph suspects that their Transmission Control Protocol (TCP) connections are being dropped. The users are not having problems connecting to any other hosts on the network. To troubleshoot this problem, Ralph decides to use a protocol analyzer. He wants to store and view only the traffic relating to the hosts and server that are having problems. How can Ralph do this?",
    "choice_a": "Configure a display filter.",
    "choice_b": "Configure a capture filter.",
    "choice_c": "Set a trap on the analyzer.",
    "choice_d": "Configure both a capture and display filter.",
    "correct_answer": "B",
    "explanation": "Ralph wants to store and view only the traffic relating to the hosts that are experiencing problems. The best way to do this is to set a capture filter. Capture filters determine what is stored in the buffer. Display filters only determine what is displayed from the contents of the buffer. You do not set a trap on an analyzer\u2014you set traps on Simple Network Management Protocol (SNMP) agents. Also, there is no need to configure both a capture filter and a display filter. If you set a capture filter that blocks all other traffic from entering the buffer, the display filter would be redundant.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      324,
      327,
      311,
      312,
      322
    ],
    "source": "9781394239306"
  },
  {
    "id": 1585,
    "question": "Ralph is the administrator of his company's network. All of the users on the network are reporting that they are having difficulty connecting to a particular application server that is located on a screened subnet (perimeter network) on the other side of a router. The users are not having trouble connecting to local hosts. Which of the following troubleshooting tools can Ralph use to verify the Network layer functionality of the application server and the router? (Choose all that apply.)",
    "choice_a": "ping",
    "choice_b": "route",
    "choice_c": "arp",
    "choice_d": "traceroute",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Ralph can use the <code>ping</code> and <code>traceroute</code> tools to verify the Network layer functionality of the application server and the router. The <code>ping</code> tool tests the Network layer through the exchange of Internet Control Message Protocol (ICMP) Echo and Echo Reply messages. The <code>traceroute</code> tool can verify that there is a functioning path between the users' workstations and the application server. The <code>route</code> tool is used to administer the routing table on the local machine. The <code>arp</code> tool is used to view a computer's Internet Protocol to Media Access Control (IP to MAC) address resolution table stored in memory.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      335,
      362,
      337,
      311,
      322
    ],
    "source": "9781394239306"
  },
  {
    "id": 1586,
    "question": "Which of the following tools run only on Unix or Linux systems? (Choose all that apply.)",
    "choice_a": "tcpdump",
    "choice_b": "dig",
    "choice_c": "iptables",
    "choice_d": "ifconfig",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D"
    ],
    "explanation": "Of the utilities listed, <code>tcpdump</code>, <code>dig</code>, <code>iptables</code>, and <code>ifconfig</code> are all tools that run on Unix/Linux systems only. The <code>route</code> utility runs on both Unix/Linux and Windows. <code>Show</code> is a console command that runs on switches and routers with a syntax such as <code>show interface</code>, <code>show vlan</code>, or <code>show power</code>.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      334,
      332,
      339,
      343,
      347
    ],
    "source": "9781394239306",
    "choice_e": "route",
    "choice_f": "show"
  },
  {
    "id": 1587,
    "question": "Which of the following Windows command-line utilities produced the output shown here? <img src=\"/question_assets/Network+/pt_c5_191.png\"/>",
    "choice_a": "nslookup",
    "choice_b": "pathping",
    "choice_c": "netstat",
    "choice_d": "route",
    "correct_answer": "A",
    "explanation": "<code>Nslookup</code> is a command-line utility that generates DNS resource record requests and sends them to a specific DNS server. The output shown here specifies first the name and address of the DNS server to which the request was sent and then the response to the request, containing the name to be resolved and the IP addresses contained in the server's resource record for that name. The <code>pathping</code>, <code>netstat</code>, and <code>route</code> utilities cannot perform DNS queries.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      338,
      339,
      362,
      346,
      336
    ],
    "source": "9781394239306"
  },
  {
    "id": 1588,
    "question": "Which of the following parameters enables you to specify the number of messages the <code>ping</code> tool transmits?",
    "choice_a": "-n",
    "choice_b": "-t",
    "choice_c": "-i",
    "choice_d": "-a",
    "correct_answer": "A",
    "explanation": "Running the <code>ping</code> tool with the <code>-n</code> parameter specifies the number of messages the <code>ping</code> tool should transmit with each execution. The <code>-t</code> parameter causes the <code>ping</code> tool to send messages to the target continuously until manually stopped. The <code>-i</code> parameter specifies the time-to-live (TTL) value of the messages <code>ping</code> transmits. The <code>-a</code> parameter resolves an IP address specified as the target to a hostname.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      335,
      329,
      341,
      337,
      338
    ],
    "source": "9781394239306"
  },
  {
    "id": 1589,
    "question": "Which of the following command-line utilities can run on both Windows and Unix/Linux systems? (Choose all that apply.)",
    "choice_a": "ping",
    "choice_b": "traceroute",
    "choice_c": "ifconfig",
    "choice_d": "iptables",
    "correct_answer": [
      "A",
      "E"
    ],
    "explanation": "The <code>ping</code> and <code>nslookup</code> utilities can both run on Windows or Unix/Linux systems. The <code>traceroute</code> command runs only on Unix/Linux, although there is a Windows version called <code>tracert</code>. The <code>ifconfig</code> and <code>iptables</code> commands exist only on Unix and Linux systems.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      335,
      338,
      339,
      331,
      333
    ],
    "source": "9781394239306",
    "choice_e": "nslookup"
  },
  {
    "id": 1590,
    "question": "Which of the following command-line utilities can only run on Unix and Linux systems?",
    "choice_a": "ping",
    "choice_b": "ipconfig",
    "choice_c": "tracert",
    "choice_d": "ifconfig",
    "correct_answer": "D",
    "explanation": "The <code>ifconfig</code> command runs only on Unix and Linux systems. The ping and <code>netstat</code> utilities run on both Windows and Unix/Linux systems. The <code>ipconfig</code> and <code>tracert</code> commands run only on Windows, although there is a Unix/Linux version of <code>tracert</code> called <code>traceroute</code>.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      332,
      331,
      330,
      335,
      347
    ],
    "source": "9781394239306",
    "choice_e": "netstat"
  },
  {
    "id": 1591,
    "question": "Which of the following command-line utilities can only run on Windows systems?",
    "choice_a": "ping",
    "choice_b": "ipconfig",
    "choice_c": "traceroute",
    "choice_d": "ifconfig",
    "correct_answer": "B",
    "explanation": "The <code>ipconfig</code> command runs only on Windows, although there is a similar Unix/Linux-only command called <code>ifconfig</code>. The <code>ping</code> and <code>netstat</code> utilities run on both Windows and Unix/Linux systems. The <code>traceroute</code> utility runs only on Unix/Linux systems, although there is a Windows version called <code>tracert</code>.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      331,
      330,
      332,
      362,
      335
    ],
    "source": "9781394239306",
    "choice_e": "netstat"
  },
  {
    "id": 1592,
    "question": "Ralph is working on his company's perimeter network, which has five web servers running Linux, a Cisco router, a CSU/DSU providing a leased line connection, and a Windows-based firewall. While trying to troubleshoot a network communications failure, Ralph types the following command on one of the systems: <code>traceroute</code> <a href=\"http://www.adatum.com\"><code>adatum.com</code></a>. Which of the following systems might Ralph be working on? (Choose all that apply.)",
    "choice_a": "The Windows-based firewall",
    "choice_b": "The Cisco router",
    "choice_c": "The CSU/DSU console",
    "choice_d": "One of the Linux web servers",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Both Linux and the Cisco IOS operating systems have the <code>traceroute</code> utility. Windows has a version of the utility, but it is called <code>tracert</code>. The CSU/DSU cannot run a <code>traceroute</code> command.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      335,
      332,
      333,
      351,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1593,
    "question": "Which of the following <code>netstat</code> commands can tell you how many IPv6 packets have been received on a particular Windows workstation?",
    "choice_a": "netstat -a",
    "choice_b": "netstat -s",
    "choice_c": "netstat -e",
    "choice_d": "netstat -r",
    "correct_answer": "B",
    "explanation": "The <code>netstat -s</code> command displays packet counts and other traffic statistics for the IPv6, IPv4, ICMP, TCP, and UDP protocols. The <code>netstat -a</code> command displays all of a workstation's current connections and ports on which it is listening. The <code>netstat -e</code> command displays Ethernet statistics, such as the number of bytes and packets sent and received. The <code>netstat -r</code> command displays the computer's routing table.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      347,
      348,
      346,
      331,
      362
    ],
    "source": "9781394239306"
  },
  {
    "id": 1594,
    "question": "Which of the following commands can Ralph use to display the number of bytes that a Windows workstation has transmitted?",
    "choice_a": "netstat",
    "choice_b": "tcpdump",
    "choice_c": "ipconfig",
    "choice_d": "iptables",
    "correct_answer": "A",
    "explanation": "Running <code>netstat</code> with the <code>-e</code> parameter on a Windows workstation displays Ethernet statistics, including the number of bytes and packets the workstation has sent and received. The <code>ipconfig</code> command displays TCP/IP configuration data; it does not display network traffic statistics. The <code>tcpdump</code> and <code>iptables</code> commands both run only on Unix and Linux workstations. <code>Show mac-address-table</code> is a console command used on switches, not Windows workstations.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      347,
      330,
      331,
      324,
      311
    ],
    "source": "9781394239306",
    "choice_e": "show mac-address-table"
  },
  {
    "id": 1595,
    "question": "Ralph is working on his company's screened subnet (perimeter network), which has five web servers running Linux, a Cisco router, a CSU/DSU providing a leased line connection, and a Windows-based firewall. While trying to troubleshoot a network communications failure, Ralph types the following command on one of the systems: <code>ping 192.168.1.76</code>. Which of the following systems might Ralph be working on? (Choose all that apply.)",
    "choice_a": "The Windows-based firewall",
    "choice_b": "The Cisco router",
    "choice_c": "The CSU/DSU console",
    "choice_d": "One of the Linux web servers",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "Windows, Linux, and the Cisco IOS operating systems all include the <code>ping</code> utility. The CSU/DSU cannot run a <code>ping</code> command.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      335,
      311,
      322,
      303,
      305
    ],
    "source": "9781394239306"
  },
  {
    "id": 1596,
    "question": "While troubleshooting a Windows server, Alice runs the following command: <code>ping 127.0.0.1</code>. The command completes successfully. What has Alice proven by doing this?",
    "choice_a": "That the computer's network adapter is functioning properly",
    "choice_b": "That the computer's TCP/IP networking stack is loaded and functioning",
    "choice_c": "That the computer's IP address is correct for the network",
    "choice_d": "Nothing at all",
    "correct_answer": "B",
    "explanation": "The IP address 127.0.0.1 is a dedicated loopback address that directs outgoing IP traffic directly into the incoming IP traffic buffer. A successful ping test using that address indicates that the computer's TCP/IP stack is functioning properly, but the traffic never reaches the network adapter or the network, so the test does not confirm that the adapter is functioning or that the computer has a correct IP address for the network.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      335,
      331,
      311,
      303,
      322
    ],
    "source": "9781394239306"
  },
  {
    "id": 1597,
    "question": "Ed suspects that his workstation is experiencing TCP/IP communication problems. Which of the following commands can he use to confirm that the computer's TCP/IP stack is loaded and functioning? (Choose all that apply.)",
    "choice_a": "ping loopback",
    "choice_b": "ping localhost",
    "choice_c": "ping 127.0.0.1",
    "choice_d": "ping 127.0.0.0",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The IP address 127.0.0.1 is a dedicated loopback address that directs outgoing IP traffic directly into the incoming IP traffic buffer. The hostname localhost resolves to the 127.0.0.1 address on every TCP/IP system. Ed can therefore ping either the hostname or the IP address to test that his TCP/IP stack is functional. Loopback is not a hostname for the loopback address, and 127.0.0.0 is a network address, not a host address, so it will not work in this situation.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      335,
      331,
      340,
      330,
      303
    ],
    "source": "9781394239306"
  },
  {
    "id": 1598,
    "question": "Ralph is the administrator of his company's network. He has a Dynamic Host Configuration Protocol (DHCP) server configured to supply Internet Protocol (IP) addresses and configuration information to all of the Windows computers on the network. One of the Windows users reports that she cannot connect to the network. Which of the following commands can Ralph run on her computer to verify the status of the computer's IP settings and configuration parameters?",
    "choice_a": "ifconfig",
    "choice_b": "ipconfig",
    "choice_c": "msinfo32",
    "choice_d": "tracert",
    "correct_answer": "B",
    "explanation": "<code>Ipconfig</code> is a Windows command that displays a computer's current IP address and TCP/IP configuration settings, including whether the computer has obtained its address from a DHCP server. The <code>ifconfig</code> command displays the same information for Unix and Linux systems. <code>Msinfo32</code> is a Windows program that generates a graphical display of the computer's hardware and software configuration, but not its IP address and TCP/IP settings. The <code>tracert</code> command in Windows displays the path that packets take through the internetwork to reach a specified destination, but it does not display DHCP information.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      330,
      331,
      321,
      335,
      338
    ],
    "source": "9781394239306"
  },
  {
    "id": 1599,
    "question": "Which of the following are the three main categories of information that you can display by running the <code>netstat</code> command on a Windows computer?",
    "choice_a": "Connection state",
    "choice_b": "Active connections",
    "choice_c": "Routing table",
    "choice_d": "Interface statistics",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "When you run the <code>netstat</code> command without any switch options, it displays the computer's active connections. Running <code>netstat -e</code> displays the computer's interface statistics. Running <code>netstat -r</code> displays the routing table. There is no <code>netstat</code> switch that displays the computer's connection state.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      347,
      346,
      348,
      343,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1600,
    "question": "Which of the following <code>route</code> commands displays the contents of a Windows computer's IPv6 routing table only?",
    "choice_a": "route print",
    "choice_b": "route print -6",
    "choice_c": "route list -6",
    "choice_d": "route list",
    "correct_answer": "B",
    "explanation": "The <code>route print</code> command displays both the IPv4 and IPv6 routing tables. To display only the IPv6 routing table, you add the <code>-6</code> parameter to the <code>route print</code> command. <code>Route list</code> and <code>route list -6</code> are not valid commands.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      343,
      362,
      347,
      330,
      344
    ],
    "source": "9781394239306"
  },
  {
    "id": 1601,
    "question": "Which of the following Windows command-line utilities produced the output shown here? <img src=\"/question_assets/Network+/pt_c5_205.png\"/>",
    "choice_a": "ping",
    "choice_b": "tracert",
    "choice_c": "netstat",
    "choice_d": "arp",
    "correct_answer": "C",
    "explanation": "Running the Windows <code>netstat</code> command with the <code>-e</code> parameter displays Ethernet statistics, including the number of bytes and packets that have been transmitted and received. The <code>ping</code>, <code>tracert</code>, and <code>arp</code> utilities are not capable of producing this output.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      347,
      346,
      348,
      335,
      337
    ],
    "source": "9781394239306"
  },
  {
    "id": 1602,
    "question": "Which of the following Linux commands generated the output shown in the figure? <img src=\"/question_assets/Network+/c05uf005.png\"/>",
    "choice_a": "arp -a",
    "choice_b": "arp -e",
    "choice_c": "arp -d",
    "choice_d": "arp -s",
    "correct_answer": "B",
    "explanation": "Running the <code>arp -e</code> command on a Linux system displays the contents of the ARP cache in the format shown here. The <code>arp -a</code> command displays the cache using an alternative format. The <code>arp -d</code> command is for deleting cache entries, and the <code>arp -s</code> command is for creating cache entries.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      337,
      336,
      335,
      331,
      347
    ],
    "source": "9781394239306"
  },
  {
    "id": 1603,
    "question": "Which of the following Windows commands enables you to create a new entry in the ARP cache?",
    "choice_a": "arp -N",
    "choice_b": "arp -d",
    "choice_c": "arp -a",
    "choice_d": "arp -s",
    "correct_answer": "D",
    "explanation": "The <code>arp -s</code> command enables you to create a cache record specifying the MAC address and its associated IP address. The <code>arp -N</code> command enables you to display the ARP cache entries for a specified network interface. The <code>arp -d</code> command is for deleting cache entries. The <code>arp -a</code> command displays the entries in the ARP table stored in its cache.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      337,
      336,
      335,
      362,
      347
    ],
    "source": "9781394239306"
  },
  {
    "id": 1604,
    "question": "Which of the following Unix/Linux tools is a packet analyzer?",
    "choice_a": "iptables",
    "choice_b": "nmap",
    "choice_c": "tcpdump",
    "choice_d": "pathping",
    "correct_answer": "C",
    "explanation": "The <code>tcpdump</code> utility is a command-line tool that captures network packets and displays their contents. The <code>iptables</code>, <code>nmap</code>, and <code>pathping</code> utilities cannot capture and analyze packets. <code>Iptables</code> manages Unix/Linux kernel firewall rules; <code>nmap</code> is a port scanner; and <code>pathping</code> is a Windows <code>route</code> tracing tool.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      324,
      176,
      359,
      362,
      342
    ],
    "source": "9781394239306"
  },
  {
    "id": 1605,
    "question": "Which of the following tools can administrators use to monitor network bandwidth and traffic patterns?",
    "choice_a": "Protocol analyzer",
    "choice_b": "Bandwidth speed tester",
    "choice_c": "NetFlow analyzer",
    "choice_d": "IP scanner",
    "correct_answer": "C",
    "explanation": "A NetFlow analyzer is a tool that can collect network traffic data and analyze how bandwidth is being used and who is using it. A protocol analyzer is also a tool that captures network packets, but for the purpose of analyzing their contents. A bandwidth speed tester measures a networks Internet access speed. An IP scanner lists the IP addresses that are in use on a network. A cable tester measures the properties of the network medium, but not the traffic passing over it.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      327,
      324,
      359,
      328,
      358
    ],
    "source": "9781394239306",
    "choice_e": "Cable tester"
  },
  {
    "id": 1606,
    "question": "Based on the output shown here, what is the average response time of the destination system? <img src=\"/question_assets/Network+/pt_c5_210.png\"/>",
    "choice_a": "109.5 ms",
    "choice_b": "104.33 ms",
    "choice_c": "106 ms",
    "choice_d": "99.66 ms",
    "correct_answer": "B",
    "explanation": "The destination system is the last one listed in the trace. By averaging the response times of 99, 106, and 108 ms, you can calculate the average response time: 104.33 ms.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      341,
      335,
      311,
      322,
      348
    ],
    "source": "9781394239306"
  },
  {
    "id": 1607,
    "question": "Which of the following Linux commands produced the output shown in the figure? <img src=\"/question_assets/Network+/c05uf006.png\"/>",
    "choice_a": "netstat -ns microsoft.com",
    "choice_b": "dig microsoft.com ns",
    "choice_c": "nslookup microsoft.com",
    "choice_d": "route -s microsoft.com",
    "correct_answer": "B",
    "explanation": "The <code>dig</code> utility in Linux can display the authoritative DNS servers for a particular domain when you specify the domain name and the ns (name server) parameter. The <code>netstat</code>, <code>nslookup</code>, and <code>route</code> commands cannot generate this particular output.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      339,
      338,
      362,
      346,
      331
    ],
    "source": "9781394239306"
  },
  {
    "id": 1608,
    "question": "Which of the following protocols does the <code>traceroute</code> utility on Unix and Linux systems use to test TCP/IP connectivity?",
    "choice_a": "ICMP",
    "choice_b": "HTTPS",
    "choice_c": "TCP",
    "choice_d": "UDP",
    "correct_answer": "D",
    "explanation": "On Unix and Linux systems, the <code>traceroute</code> utility tests TCP/IP connectivity by transmitting User Datagram Protocol (UDP) messages. This is unlike the <code>tracert</code> utility on Windows systems, which uses Internet Control Message Protocol (ICMP) messages. Neither version uses the Transmission Control Protocol (TCP), the Hypertext Transfer Protocol Secure (HTTPS), or the Link Layer Discovery Protocol (LLDP).",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      335,
      331,
      338,
      339,
      324
    ],
    "source": "9781394239306",
    "choice_e": "LLDP"
  },
  {
    "id": 1609,
    "question": "Ed has configured his workstation to use IPsec encryption for network communications. Which of the following tools can he use to verify that his network traffic is encrypted?",
    "choice_a": "Multimeter",
    "choice_b": "Packet sniffer",
    "choice_c": "Port scanner",
    "choice_d": "Protocol analyzer",
    "correct_answer": "D",
    "explanation": "A protocol analyzer is a tool that enables a user to view the contents of packets captured from a network. In Ed's case, if IPsec is properly implemented, he should be able to see that the data in packets captured from his workstation is encrypted. A packet sniffer is a tool that captures packets for the purpose of traffic analysis but cannot view their contents. In practice, however, packet sniffer and protocol analyzer capabilities are usually integrated into a single tool. A port scanner examines a system, looking for open TCP and UDP ports, and a multimeter is a tool that reads voltages on electrical circuits. An IP scanner queries the network for the IP addresses currently in use and gathers information about the devices using them. None of these tools can examine packet contents.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      324,
      176,
      359,
      328,
      348
    ],
    "source": "9781394239306",
    "choice_e": "IP scanner"
  },
  {
    "id": 1610,
    "question": "Which of the following statements describes the difference between a packet sniffer and a protocol analyzer?",
    "choice_a": "A packet sniffer captures network traffic, and a protocol analyzer examines packet contents.",
    "choice_b": "A protocol analyzer captures network traffic, and a packet sniffer examines packet contents.",
    "choice_c": "A packet sniffer only captures the local workstation's traffic, whereas a protocol analyzer can capture all the traffic on the network.",
    "choice_d": "There is no difference. Packet sniffers and protocol analyzers perform the same functions.",
    "correct_answer": "A",
    "explanation": "A packet sniffer is a tool that captures packets for the purpose of traffic analysis but cannot display their contents. A protocol analyzer is a tool that enables a user to view the contents of packets captured from a network. In practice, however, packet sniffer and protocol analyzer capabilities are often integrated into a single tool. Both tools can function in promiscuous mode to capture packets from an entire network.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      324,
      176,
      327,
      325,
      359
    ],
    "source": "9781394239306"
  },
  {
    "id": 1611,
    "question": "Ed has recently discovered a rogue DHCP server on his network. After disabling the server, he now needs to terminate all of the rogue IP address leases currently held by Windows DHCP clients on the network and have them request new leases from the authorized DHCP server. Which of the following commands must he use on each Windows client to do this? (Choose all that apply.)",
    "choice_a": "ipconfig /dump",
    "choice_b": "ipconfig /renew",
    "choice_c": "ipconfig /lease",
    "choice_d": "ipconfig /discard",
    "correct_answer": [
      "B",
      "E"
    ],
    "explanation": "The <code>ipconfig /release</code> command terminates the current DHCP address lease. Then, the <code>ipconfig /renew</code> command causes the client to begin the process of negotiating a new lease, this time with an authorized DHCP server. <code>Dump</code>, <code>lease</code>, and <code>discard</code> are not valid <code>ipconfig</code> parameters.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      330,
      321,
      316,
      311,
      324
    ],
    "source": "9781394239306",
    "choice_e": "ipconfig /release"
  },
  {
    "id": 1612,
    "question": "Which of the following processes scans multiple computers on a network for a particular open TCP or UDP port?",
    "choice_a": "Port scanning",
    "choice_b": "War driving",
    "choice_c": "Port sweeping",
    "choice_d": "Bluejacking",
    "correct_answer": "C",
    "explanation": "Port scanning identifies port states on a single computer, such as open ports, whereas port sweeping scans multiple computers for a single open port. War driving and bluejacking are methods of attacking wireless networks.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      325,
      328,
      342,
      347,
      346
    ],
    "source": "9781394239306"
  },
  {
    "id": 1613,
    "question": "Which of the following statements about protocol analyzers is not true?",
    "choice_a": "To troubleshoot using a protocol analyzer, you must be familiar with the OSI model and the protocols that operate at each of its layers.",
    "choice_b": "Protocol analyzers can be a network security risk.",
    "choice_c": "Some network monitoring products are both analyzers and sniffers.",
    "choice_d": "All Windows operating systems include a protocol analyzer.",
    "correct_answer": "D",
    "explanation": "Microsoft Windows operating systems do not include a protocol analyzer. A protocol analyzer, such as Microsoft Network Monitor 3, enables administrators to capture network frames, display their contents, and analyze the network data they contain, including the header fields created by the protocols at the various OSI model layers. Administrators can use a protocol analyzer to troubleshoot network conditions and communications between systems. However, in order to interpret the exchanges between the computers on the network, you must be familiar with the protocols and how they operate. Protocol analyzers are useful tools in the hands of experienced network administrators, but they can also be used for malicious purposes, such as displaying unencrypted passwords and other confidential information in the captured packets. The difference between analyzers and sniffers is that analyzers read the internal contents of the packets they capture, parse the individual data units, and display information about each of the protocols involved in the creation of the packet, whereas sniffers look for trends and patterns in the network traffic without examining the contents of each packet.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      324,
      327,
      359,
      176,
      325
    ],
    "source": "9781394239306"
  },
  {
    "id": 1614,
    "question": "Which of the following utilities can be classified as port scanners? (Choose all that apply.)",
    "choice_a": "nmap",
    "choice_b": "Nessus",
    "choice_c": "Network Monitor",
    "choice_d": "Performance Monitor",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "<code>Nmap</code> is a command-line utility that scans a range of IP addresses, runs a series of scripts against each device it finds, and displays a list of the open ports it finds on each one. Nessus is similar to <code>nmap</code> in that it also scans a range of IP addresses to find open ports, but it then proceeds to mount attacks against those ports, to ascertain their vulnerability. Network Monitor is a packet sniffer and protocol analyzer, which is a program that captures network traffic samples and analyzes them. It is not a port scanner. Performance Monitor is a program that displays statistics for specific system and network performance criteria. It is not a port scanner.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      325,
      342,
      328,
      324,
      348
    ],
    "source": "9781394239306"
  },
  {
    "id": 1615,
    "question": "Which Unix/Linux performance monitoring tool, shown in the figure, enables you to display information about processes that are currently running on a system? <img src=\"/question_assets/Network+/c05uf007.png\"/>",
    "choice_a": "monitor",
    "choice_b": "top",
    "choice_c": "netstat",
    "choice_d": "cpustat",
    "correct_answer": "B",
    "explanation": "The <code>top</code> utility displays performance information about the currently running processes on a Unix/Linux system. <code>Netstat</code> is a tool that enables you to view active network connections and TCP/IP traffic statistics; it does not measure system performance. There are no Unix/Linux tools called <code>monitor</code> or <code>cpustat</code>.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      346,
      347,
      331,
      332,
      333
    ],
    "source": "9781394239306"
  },
  {
    "id": 1616,
    "question": "You have finished capturing traffic with a protocol analyzer. The analyzer reports that 2,000 frames have been seen, but only 1,500 frames have been accepted. What does this mean?",
    "choice_a": "2,000 frames have passed the display filter, but only 1,500 meet the criteria for display.",
    "choice_b": "Only 1,500 frames have passed the capture filter and are currently being held in the buffer.",
    "choice_c": "You lost 500 frames and need to start over\u2014something is obviously wrong.",
    "choice_d": "500 frames were damaged and never made it into the buffer.",
    "correct_answer": "B",
    "explanation": "Protocol analyzers report the total number of frames seen compared to the number of frames that were accepted. If a capture filter is in place, there will be a discrepancy between these two values. Only frames that meet the capture criteria will be accepted by the analyzer and placed in the buffer for later display. Protocol analyzers place good and bad frames into the buffer as long as they meet the capture criteria. If only good frames were placed in the buffer, there would be no way to identify problems.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      324,
      176,
      322,
      320,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1617,
    "question": "Programs such as FTP and Telnet are widely criticized because they transmit all data as cleartext, including usernames and passwords. Which of the following types of tools might unscrupulous individuals use to read those passwords?",
    "choice_a": "Packet sniffer",
    "choice_b": "Terminal emulator",
    "choice_c": "Protocol analyzer",
    "choice_d": "Vulnerability scanner",
    "correct_answer": "C",
    "explanation": "A protocol analyzer is capable of looking at the data inside packets, which in the case of packets generated by Telnet and FTP, can contain passwords in cleartext. Packet sniffers analyze traffic patterns, vulnerability scanners search for open ports, Trivial File Transfer Protocol (TFTP) servers transfer boot files to DHCP client workstations, and network taps monitor and copy network traffic. None of these can actually parse and display the data inside the packets. Telnet is itself a terminal emulator and does not display packet contents.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      324,
      327,
      325,
      176,
      326
    ],
    "source": "9781394239306",
    "choice_e": "TFTP server",
    "choice_f": "Network tap"
  },
  {
    "id": 1618,
    "question": "Which of the following best states the potential security threat inherent in running a protocol analyzer?",
    "choice_a": "A protocol analyzer can display the application data in packets captured from the network.",
    "choice_b": "A protocol analyzer can display the IP addresses of the systems on the network.",
    "choice_c": "A protocol analyzer can decrypt protected information in packets captured from the network.",
    "choice_d": "A protocol analyzer can detect open ports on network systems and launch attacks against them.",
    "correct_answer": "A",
    "explanation": "Protocol analyzers capture packets from the network and interpret their contents, which includes displaying the Application layer payload, which can include confidential information. Protocol analyzers can display the IP addresses of systems on the network, but this is not as great a security threat. Protocol analyzers cannot decrypt the protected information they find in captured packets. Vulnerability scanners detect open ports and launch attacks against them; protocol analyzers do not do this.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      324,
      176,
      328,
      325,
      348
    ],
    "source": "9781394239306"
  },
  {
    "id": 1619,
    "question": "Which of the following tools do not provide vulnerability scanning capabilities?",
    "choice_a": "Nessus",
    "choice_b": "Spectrum analyzer",
    "choice_c": "nmap",
    "choice_d": "Visual fault locator",
    "correct_answer": "B",
    "explanation": "A spectrum analyzer is a device for measuring the amplitudes and frequencies of wireless signals. A visual fault locator is a tool for testing fiber-optic cables. Neither of these have vulnerability scanning capabilities. Nessus and <code>nmap</code> are tools that include vulnerability scanning but that have other capabilities as well.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      325,
      342,
      328,
      361,
      358
    ],
    "source": "9781394239306"
  },
  {
    "id": 1620,
    "question": "Which of the following is a function typically classified as vulnerability scanning?",
    "choice_a": "Network mapping",
    "choice_b": "Remediation",
    "choice_c": "Penetration testing",
    "choice_d": "Port scanning",
    "correct_answer": "D",
    "explanation": "Port scanning, the process of looking for open TCP and UDP ports that are exploitable by attackers, is one of the many functions that qualify as a type of vulnerability scanning. Network mapping, the remediation of vulnerabilities, and penetration testing, which is the process of deliberately performing a planned attack, are not considered vulnerability scanning techniques.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      325,
      328,
      342,
      348,
      176
    ],
    "source": "9781394239306"
  },
  {
    "id": 1621,
    "question": "Alice is attempting to troubleshoot a communication problem between two hosts on the same network. She decides to use a protocol analyzer to capture traffic on the network. After finishing the capture, Alice notices that there are over 15,000 frames in the protocol analyzer's capture buffer. She is having a difficult time identifying the frames that relate to the problem because there are so many in the buffer. She wants to eliminate the extraneous frames from her view, enabling her to view only the frames transmitted by these two hosts. What does Alice have to do to accomplish this?",
    "choice_a": "Configure a display filter.",
    "choice_b": "Configure a capture filter.",
    "choice_c": "Delete the extraneous frames from the buffer.",
    "choice_d": "Configure a capture and display filter.",
    "correct_answer": "A",
    "explanation": "Once the frames are in the buffer, Alice can configure a display filter to block the unwanted frames from view. This does not delete them from the buffer. Since the capture was already performed, there is no need to restart the capture. Configuring a capture filter will not meet the requirements, because the filter will eliminate the other frames completely from the buffer. It is not possible to delete specific frames from an analyzer buffer.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      324,
      322,
      311,
      176,
      359
    ],
    "source": "9781394239306"
  },
  {
    "id": 1622,
    "question": "Alice is examining a captured sample of network traffic to create a network performance baseline for future reference. She notices that the sample contains a flood of multicast traffic, but she does not know why. After some investigation, she learns that there is video traffic on the network being transmitted as multicasts, but it is only intended for a particular group of users, not for everyone. However, since the multicast traffic is flooding the network, all of the hosts must process the packets, possibly resulting in performance degradation or even denial of service. Which of the following can Alice use to prevent the traffic from being processed by the unintended hosts?",
    "choice_a": "Asymmetric routing",
    "choice_b": "Flow control",
    "choice_c": "Multipathing",
    "choice_d": "IGMP snooping",
    "correct_answer": "D",
    "explanation": "Internet Group Management Protocol (IGMP) snooping is a switching technique that prevents network hosts from receiving multicast packets when they are not members of the multicast group. The multicast traffic will still appear on the network, but only the members of the multicast group will process the packets. Asymmetric routing and multipathing all affect the route that the packets take through the network, and flow control only affects the speed at which transmitting systems send packets. None of these can control which hosts process the incoming packets.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      176,
      324,
      154,
      315,
      327
    ],
    "source": "9781394239306"
  },
  {
    "id": 1623,
    "question": "A user, Ed, is reporting what appear to be intermittent traffic interruptions on his workstation. Sometimes he receives responses to his server requests, and sometimes not. It does not seem to be an Internet issue, because the problem also occurs with local server requests. While troubleshooting the problem, Ralph performs a series of packet captures and analyzes the network traffic. He discovers that all of the request messages generated by Ed's workstation have responses on the network, but in some cases, the responses are going to a workstation other than Ed's. Which of the following conditions could be causing this to happen?",
    "choice_a": "Duplicate IP addresses",
    "choice_b": "Blocked TCP/UDP ports",
    "choice_c": "Duplicate MAC addresses",
    "choice_d": "Incorrect host firewall settings",
    "correct_answer": "C",
    "explanation": "If someone on the network is spoofing the MAC address of Ed's workstation, the MAC address table in the switch handing the network traffic might be continually changing as packets from each computer reach the switch. This could cause some of the response packets to be forwarded to Ed's workstation and some to the spoofer's workstation. Duplicate IP addresses would not cause this problem, because they would be detected by the operating system. Blocked ports, incorrect firewall settings, or a flood of multicast transmissions could prevent Ed from receiving responses, but they would not be sent to another workstation.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      154,
      336,
      317,
      324,
      353
    ],
    "source": "9781394239306",
    "choice_e": "Multicast flood"
  },
  {
    "id": 1624,
    "question": "Ralph is a network administrator who has had a Windows user report difficulties accessing certain other computers on the network. Ralph determines that the user is only experiencing problems when trying to connect to a system on the far side of a router. Therefore, Ralph decides to inspect the routing table on the user's computer. Which of the following tools can he use to do this? (Choose all that apply.)",
    "choice_a": "nbtstat",
    "choice_b": "route",
    "choice_c": "nslookup",
    "choice_d": "netstat",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "The <code>route</code> print tool displays the contents of the routing table on a Windows computer. So does the <code>netstat -r</code> command. The <code>nbtstat</code> and <code>nslookup</code> tools cannot display the routing table.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      347,
      343,
      362,
      311,
      335
    ],
    "source": "9781394239306"
  },
  {
    "id": 1625,
    "question": "A user calls Alice at the help desk to report that he cannot access the Internet. He can access systems on the local network, however. Alice examines the routing table on the user's workstation and sees the following. Which of the following commands must Alice run to correct the user's problem? <img src=\"/question_assets/Network+/pt_c5_229.png\"/>",
    "choice_a": "route add 0.0.0.0 MASK 0.0.0.0 192.168.2.37 METRIC 25 IF 192.168.2.99",
    "choice_b": "route add 0.0.0.0 MASK 255.255.255.0 192.168.2.99 METRIC 25 IF 192.168.2.37",
    "choice_c": "route add 192.168.2.0 MASK 255.255.255.0 192.168.2.99 METRIC 25 IF 192.168.2.37",
    "choice_d": "route add 0.0.0.0 MASK 0.0.0.0 192.168.2.99 METRIC 25 IF 192.168.2.37",
    "correct_answer": "D",
    "explanation": "To access the Internet, the workstation's routing table must include a default gateway entry. To create a default gateway entry in the routing table, you use the <code>route add</code> command with a Network Destination value of 0.0.0.0, a <code>MASK</code> value of 0.0.0.0, and the address of a router on the local network (in this case, 192.168.2.99). The entry must also have a <code>METRIC</code> value that is lower than the other entries in the table so that it will be used first.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      344,
      345,
      343,
      362,
      330
    ],
    "source": "9781394239306"
  },
  {
    "id": 1626,
    "question": "Which of the following Application layer protocols includes a program that enables a user to log on to a network device and execute commands on the remote system using a command-line interface? (Choose all that apply.)",
    "choice_a": "Telnet",
    "choice_b": "File Transfer Protocol (FTP)",
    "choice_c": "Simple Network Management Protocol (SNMP)",
    "choice_d": "Domain Name System (DNS)",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Both Telnet and FTP are protocols that include command-line client applications, with Telnet providing terminal emulation and FTP file transfer functionality. SNMP and DNS are both Application layer protocols, but neither one includes a program. Nslookup has a command-line interface, but it executes commands on the local system, not a remote one.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      362,
      326,
      338,
      339,
      335
    ],
    "source": "9781394239306",
    "choice_e": "Nslookup"
  },
  {
    "id": 1627,
    "question": "Which of the following utilities can display the number of packets sent and received for a specific network interface on a Unix, Linux, macOS, or Windows computer?",
    "choice_a": "top",
    "choice_b": "ifconfig",
    "choice_c": "netstat",
    "choice_d": "nbtstat",
    "correct_answer": "C",
    "explanation": "The <code>netstat</code> utility can display the incoming and outgoing packets for a specific network interface, as well as other statistics, depending on the operating system. <code>Top</code> and <code>ifconfig</code> are Unix/Linux utilities, and <code>nbtstat</code> is a Windows tool.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      347,
      348,
      331,
      330,
      337
    ],
    "source": "9781394239306"
  },
  {
    "id": 1628,
    "question": "Which of the following is a feature included in some routers that collects and analyzes network traffic data sent or received through a network interface?",
    "choice_a": "netmon",
    "choice_b": "NetFlow",
    "choice_c": "netstat",
    "choice_d": "nbtstat",
    "correct_answer": "B",
    "explanation": "NetFlow is a network traffic monitoring feature first introduced in Cisco routers in 1996. <code>Netmon</code>, <code>netstat</code>, and <code>nbtstat</code> are all operating system utilities, not router features.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      327,
      176,
      359,
      324,
      351
    ],
    "source": "9781394239306"
  },
  {
    "id": 1629,
    "question": "Which of the following tools do cable installers use to add connectors such as RJ-45 and RJ-11 to twisted-pair cabling?",
    "choice_a": "A crimper",
    "choice_b": "A splicer",
    "choice_c": "A pigtail",
    "choice_d": "A patch",
    "correct_answer": "A",
    "explanation": "A crimper or crimping tool is a jawed device that has a set of dies in it. Installers use a crimper to squeeze the two halves of an RJ-45 or RJ-11 connector together, with the wires inside securing the connector to the cable. Installers use a splicing tool to splice two cable segments together. There is no tool called a pigtail or a patch.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      358,
      307,
      309,
      323,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1630,
    "question": "Which of the following commands displays the routing table entries on a router?",
    "choice_a": "route print",
    "choice_b": "show route",
    "choice_c": "netstat -r",
    "choice_d": "nbtstat -t",
    "correct_answer": "B",
    "explanation": "The router interface uses the <code>show</code> command to display various types of configuration data. The <code>show route</code> command displays the contents of the router's routing table. None of the other options are router interface commands.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      351,
      349,
      347,
      362,
      331
    ],
    "source": "9781394239306"
  },
  {
    "id": 1631,
    "question": "Which of the following are the layers in the standard three-tier datacenter architecture? (Choose all that apply.)",
    "choice_a": "Core",
    "choice_b": "Intermediate",
    "choice_c": "Distribution",
    "choice_d": "Access",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "The three-tier hierarchical architecture for datacenters consists of core, distribution, and access layers. The access layer in a datacenter contains servers; the distribution layer contains redundant switch connections; and the core layer provides high-speed transport between the switches. There is no intermediate layer in the architecture.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      355,
      352,
      154,
      317,
      349
    ],
    "source": "9781394239306"
  },
  {
    "id": 1632,
    "question": "You are a new hire at Adatum Corp., and this is your first day on the job. You are setting up your workstation, but you are unsure whether you are permitted to install your favorite software on the company's computer. The human resources server has a large library of employee documents. Which of the following documents should you consult to determine whether personal software is allowed?",
    "choice_a": "SLA",
    "choice_b": "AUP",
    "choice_c": "NDA",
    "choice_d": "BYOD",
    "correct_answer": "B",
    "explanation": "An acceptable use policy (AUP) specifies whether and how employees can use company-owned hardware and software resources. AUPs typically specify what personal work employees can perform while on the job, what hardware and software they can install, and what levels of privacy they are permitted when using company equipment. This is the document that will most likely include the information you seek. A service-level agreement (SLA) is a contract between a provider and a subscriber. A nondisclosure agreement (NDA) specifies what company information employees are permitted to discuss outside the company. A bring your own device (BYOD) policy specifies how employees can connect their personal devices to the company network.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      380,
      378,
      377,
      400,
      392
    ],
    "source": "9781394239306"
  },
  {
    "id": 1633,
    "question": "You are working the help desk when a user calls and reports that she is unable to connect to the Internet. Which of the following steps would you be least likely to perform first when troubleshooting the problem?",
    "choice_a": "Check the configuration of the router connecting the LAN to the Internet.",
    "choice_b": "Ask the user if she can access resources on the local network.",
    "choice_c": "Check to see if anyone else is experiencing the same problem.",
    "choice_d": "Check the user's job title to see if she is an important person in the company.",
    "correct_answer": "A",
    "explanation": "There are many possible causes for the problem that are more likely than a router configuration error, so this is not something you should check first. Asking if the user can access the local network attempts to isolate the problem. If she cannot, the problem could be in her computer; if she can, then the problem lies somewhere in the Internet access infrastructure. If other users are experiencing the problem, then the issue should receive a higher priority, and you will know for sure that the problem does not lie in the user's computer. While the user's job title might not be the first thing you check, it is a political reality that higher ranking users get preferential treatment.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      119,
      121,
      127,
      68,
      126
    ],
    "source": "9781394239306"
  },
  {
    "id": 1634,
    "question": "Which of the following is not a means of preventing unauthorized individuals from entering a sensitive location, such as a datacenter?",
    "choice_a": "Key fobs",
    "choice_b": "Motion detection",
    "choice_c": "Biometric scans",
    "choice_d": "Identification badges",
    "correct_answer": "B",
    "explanation": "Biometric scans, identification badges, and key fobs are all mechanisms that are designed to distinguish authorized from unauthorized personnel. Motion detection cannot make this distinction and is therefore not a means of preventing unauthorized access.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      202,
      205,
      195,
      300,
      282
    ],
    "source": "9781394239306"
  },
  {
    "id": 1635,
    "question": "You are an IT consultant who has been contracted to install new computers on a client's Gigabit Ethernet network. You want the performance of the new computers to be as good as it can be, so you configure their network adapters to run at the full speed of 1 Gbps and to use full-duplex communication. You test the computers after installing them, and they function well. However, once the computers are in service, you begin getting complaints from the client of extremely poor network performance on the new machines. You return to the site that evening and run some ping tests, but you do not detect any problem. You call in a colleague to perform a protocol analysis, and she detects large numbers of packet collisions, late collisions, cyclical redundancy check (CRC) errors, and runt frames. Which of the following could be the cause of the problem?",
    "choice_a": "Damaged cables",
    "choice_b": "Transmitter (TX)/receiver (RX) transposed",
    "choice_c": "Duplex mismatch",
    "choice_d": "Incorrect cable type",
    "correct_answer": "C",
    "explanation": "The problem is most likely the result of a duplex mismatch. There should be no collisions at all on a full-duplex network, so the problem is clearly related to the duplexing of the communications. A twisted-pair Ethernet adapter, running in its original half-duplex mode, detects collisions by looking for data on both the transmit and receive pins at the same time. In full-duplex mode, however, data is supposed to be transmitted and received at the same time. When one side of a connection is configured to use full duplex, as the new computers are, and the other end is configured to use half duplex (as the network switches must be), the full-duplex communications on the one side look like collisions to the half-duplex side. The half-duplex adapter transmits a jam signal as a result of each collision, which causes the full-duplex side to receive an incomplete frame. Both sides then start to retransmit frames in a continuing cycle, causing network performance to diminish alarmingly. The ping tests do not detect a problem because ping transmits only a small amount of data in one direction at a time. All of the other options would likely cause the ping tests to fail. The solution to the problem is to configure the new computers to autonegotiate their speed and duplex modes.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      150,
      151,
      71,
      53,
      70
    ],
    "source": "9781394239306"
  },
  {
    "id": 1636,
    "question": "Which of the following is a wireless topology that does not require the use of an access point?",
    "choice_a": "Star",
    "choice_b": "Ad hoc",
    "choice_c": "Bus",
    "choice_d": "Infrastructure",
    "correct_answer": "B",
    "explanation": "An ad hoc topology (also known as an independent basic service set) is one in which wireless computers communicate directly with one another without the need for an access point. A wireless access point is a device with a wireless transceiver that also connects to a standard cabled network. Wireless computers communicate with the access point, which forwards their transmissions over the network cable. This is called an infrastructure topology. Star and bus topologies are not used by wireless networks; they require the computers to be physically connected to the network cable.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      400,
      397,
      395,
      385,
      401
    ],
    "source": "9781394239306"
  },
  {
    "id": 1637,
    "question": "You want to create a network in which computers from different departments are assigned to separate virtual local area networks (VLANs). You also want to be able to forward traffic between the VLANs so that each computer is capable of accessing any other computer. Which of the following will enable you to perform all these functions with a single device?",
    "choice_a": "Load balancer",
    "choice_b": "Virtual router",
    "choice_c": "Multilayer switch",
    "choice_d": "Broadband router",
    "correct_answer": "C",
    "explanation": "A multilayer switch is a network connectivity device that functions at both layer 2 and layer 3 of the Open Systems Interconnection (OSI) model. At layer 2, the Data link layer, the device functions like a normal switch, providing an individual collision domain to each connected node and enabling you to create multiple VLANs. At layer 3, the Network layer, the device also provides routing capabilities by forwarding packets between the VLANs. Virtual routers, load balancers, and broadband routers are strictly layer 3 devices that can route traffic but cannot create VLANs.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      395,
      397,
      394,
      400,
      396
    ],
    "source": "9781394239306"
  },
  {
    "id": 1638,
    "question": "Which of the following are standard terms used in data loss prevention to describe specific data states? (Choose all that apply.)",
    "choice_a": "Data online",
    "choice_b": "Data at rest",
    "choice_c": "Data in transit",
    "choice_d": "Data in use",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "<i>Data at rest</i> is a data loss prevention (DLP) term that describes data that is currently in storage while not in use. <i>Data in transit</i> is the term used to describe network traffic. <i>Data in use</i> describes endpoint actions. Data online is not one of the standard data loss prevention terms.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      324,
      328,
      330,
      338,
      343
    ],
    "source": "9781394239306"
  },
  {
    "id": 1639,
    "question": "Advanced Encryption Standard (AES) is an encryption algorithm that was introduced in the Wi-Fi Protected Access 2 (WPA2) security protocol to replace another algorithm that was found to be easily penetrated. Which of the following encryption algorithms did AES replace?",
    "choice_a": "AES",
    "choice_b": "WEP",
    "choice_c": "WPA",
    "choice_d": "TKIP",
    "correct_answer": "D",
    "explanation": "Wi-Fi Protected Access (WPA) is the wireless security protocol that was designed to replace the increasingly vulnerable Wired Equivalent Privacy (WEP) protocol. WPA added an encryption algorithm called Temporal Key Integrity Protocol (TKIP) that was more difficult to penetrate. Over time, however, TKIP too became vulnerable, and WPA2 was introduced, which replaced TKIP with the Advanced Encryption Standard algorithm (AES).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      381,
      367,
      385,
      405,
      382
    ],
    "source": "9781394239306"
  },
  {
    "id": 1640,
    "question": "You have been asked by your supervisor in the IT department to test some newly installed cable runs. She hands you the tool shown in the following figure. What is the function of the tool and how do you use it? <img src=\"/question_assets/Network+/c06uf001.png\"/>",
    "choice_a": "When you place the tool at one end of a wire, it generates a tone that can be detected at the other end.",
    "choice_b": "When you touch the end of the tool to a copper cable, you can detect and measure the electrical current flowing through it.",
    "choice_c": "When you connect the tool to the end of a fiber-optic cable, you can measure the length of the cable run.",
    "choice_d": "When you attach the tool to the end of a twisted-pair cable, it tests for crosstalk and other performance characteristics.",
    "correct_answer": "A",
    "explanation": "The device shown in the figure is a toner and probe, which you can use to test twisted-pair wiring and detect certain basic wiring faults. By connecting the toner to each wire in turn and touching the probe to the other end, you can determine whether each wire is attached to the appropriate pin in the connector. This tool is not capable of performing any of the tasks described in the other options.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      27,
      32,
      26,
      35,
      33
    ],
    "source": "9781394239306"
  },
  {
    "id": 1641,
    "question": "A multifactor authentication (MFA) system consists of at least two different identifying criteria, typically falling into two of the following categories: something you have, something you do, something you know, and something you are. Which of the following authentication factors is an example of something you have?",
    "choice_a": "A password",
    "choice_b": "A fingerprint",
    "choice_c": "A smartcard",
    "choice_d": "A finger gesture",
    "correct_answer": "C",
    "explanation": "The term <i>something you have</i> refers to a physical possession that identifies a user, such as a smartcard. This type of authentication is nearly always used as part of a multifactor authentication (MFA) procedure because it is possible for a smartcard or other physical possession to be lost or stolen. A fingerprint would be considered something you are, a password something you know, and a finger gesture something you do.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      206,
      65,
      192,
      168,
      161
    ],
    "source": "9781394239306"
  },
  {
    "id": 1642,
    "question": "Which of the following is a port number used for Structured Query Language (SQL) communications?",
    "choice_a": "1433",
    "choice_b": "3389",
    "choice_c": "443",
    "choice_d": "5060",
    "correct_answer": "A",
    "explanation": "Port number 1433 is used by SQL Server. The port number 3389 is used by the Remote Desktop Protocol (RDP), 443 by Hypertext Transfer Protocol Secure (HTTPS), and 5060 by the Session Initiation Protocol (SIP), none of which are involved in SQL communications.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      227,
      226,
      58,
      214,
      230
    ],
    "source": "9781394239306"
  },
  {
    "id": 1643,
    "question": "At a clearance sale, you purchase some 802.11ac wireless network adapter cards for desktop computers at a very low price. Your plan is to use them to expand your 2.4 GHz 802.11n home network. After installing one of the adapters in a computer, you attempt to connect to the network, but you cannot see the SSID in the list of available networks. You try installing a different adapter, thinking the first one might be broken, but the second one does not work either. What can you do to resolve the problem and connect the computer to your network?",
    "choice_a": "Configure the network adapters to use the 2.4 GHz frequency.",
    "choice_b": "Move the computer closer to the access point.",
    "choice_c": "Manually enter the SSID in the computer's wireless network client software.",
    "choice_d": "Nothing. 802.11ac equipment cannot connect to a 2.4 GHz 802.11n network.",
    "correct_answer": "D",
    "explanation": "Wireless LAN equipment built to the 802.11ac standard can only use the 5 GHz frequency band. However, the 802.11n access point is configured to use only the 2.4 GHz frequency band. Therefore, the network adapters cannot be made to connect to your access point.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      185,
      184,
      188,
      186,
      196
    ],
    "source": "9781394239306"
  },
  {
    "id": 1644,
    "question": "Which of the following mechanisms for the recovery from a disaster in a datacenter is the most expensive to implement?",
    "choice_a": "A hot site",
    "choice_b": "A warm site",
    "choice_c": "A cold site",
    "choice_d": "A cloud site",
    "correct_answer": "A",
    "explanation": "A hot site is the most expensive to implement because it has all of the necessary hardware already installed, configured, and ready to go in the event of a disaster. A warm site has hardware in place, but it is not yet installed and configured, which makes it less expensive than a hot site. A cold site is just a space at a remote location. The hardware and software must be procured and installed before the network can be restored. Therefore, it is the least expensive of the hardware-based options and takes the most time. A cloud site is a virtual facility maintained with a cloud service provider. The cloud site does not require physical space or physical hardware, so it is the least expensive.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      378,
      379,
      366,
      381,
      377
    ],
    "source": "9781394239306"
  },
  {
    "id": 1645,
    "question": "You are setting up an 802.11n wireless network using the 2.4 GHz frequency band. You plan to install three wireless access points. Which of the following channels should you use for your access points to avoid channel overlap that can result in interference? (Choose all that apply.)",
    "choice_a": "1",
    "choice_b": "4",
    "choice_c": "6",
    "choice_d": "8",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "The 2.4 GHz band used by wireless LANs (WLANs) consists of channels that are 20 (or 22) MHz wide. However, the channels are only 5 MHz apart, so it is possible for channel overlap to occur between the access points, which can result in interference. Channels 1, 6, and 11 are the only channels that are far enough apart from each other to avoid any overlap with the adjacent channels. Channels 4 and 8 are susceptible to overlap.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      360,
      310,
      322,
      311,
      323
    ],
    "source": "9781394239306",
    "choice_e": "11"
  },
  {
    "id": 1646,
    "question": "Your supervisor has asked you to increase the security of the servers on your network. Which of the following procedures can be considered to be server hardening techniques? (Choose all that apply.)",
    "choice_a": "Installing additional memory",
    "choice_b": "Disabling unnecessary services",
    "choice_c": "Creating privileged user accounts",
    "choice_d": "Disabling unused TCP and UDP ports",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Disabling services and ports that are not in use is a server hardening technique that reduces the attack surface of a server. Creating privileged user accounts that are only used for tasks that require those privileges reduces the chance that the administrative accounts will be compromised. Therefore, these are all forms of server hardening. Installing additional memory, while a benefit in other ways, is not considered to be server hardening technique.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      300,
      203,
      78,
      101,
      288
    ],
    "source": "9781394239306"
  },
  {
    "id": 1647,
    "question": "You are working the IT help desk when a user calls to report that he cannot access the Internet, although he is able to connect to computers on the local network. At the user's workstation, you run the <code>ipconfig /all</code> command and examine the output. Which of the options is the most likely explanation for the user's problem, based on the following <code>ipconfig</code> results? <img src=\"/question_assets/Network+/pt_c6_17.png\"/>",
    "choice_a": "DHCP is not enabled.",
    "choice_b": "The Subnet Mask setting is incorrect.",
    "choice_c": "The Default Gateway setting is incorrect.",
    "choice_d": "The DNS Servers setting is located on another network.",
    "correct_answer": "C",
    "explanation": "The Default Gateway setting should contain the address of a router on the workstation's local network that provides access to other networks, such as the Internet. In this case, therefore, the Default Gateway address should be on the 192.168.23.0 network, but it contains an address on the 192.168.216.0 network, which is not local. So, the user can only access systems on the 192.168.23.0/24 network. The Subnet Mask setting must be correct; otherwise, the user would not be able to access any other systems. Unlike the default gateway, the DNS server does not have to be on the workstation's local network, so the address shown can be correct. DHCP does not have to be enabled for the computer to access the Internet; the computer could have a manually configured static address.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      385,
      397,
      394,
      395,
      400
    ],
    "source": "9781394239306"
  },
  {
    "id": 1648,
    "question": "Which of the following are typical examples of the Internet of Things (IoT)? (Choose all that apply.)",
    "choice_a": "A television remote control",
    "choice_b": "A key fob that unlocks your car",
    "choice_c": "A smartphone app for your home thermostat",
    "choice_d": "A remotely monitored cardiac pacemaker",
    "correct_answer": [
      "C",
      "D",
      "E"
    ],
    "explanation": "A smartphone app that can adjust your thermostat, a remotely monitored cardiac pacemaker, and a camera-equipped refrigerator are all examples of IoT devices because they all have IP addresses and use the Internet to communicate with a controller or monitoring station. Key fobs that unlock cars and TV remote controls are typically short-range radio or infrared devices that do not use the Internet for their communications.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      175,
      181,
      71,
      129
    ],
    "source": "9781394239306",
    "choice_e": "A refrigerator with an internal camera"
  },
  {
    "id": 1649,
    "question": "A Remote Authentication Dial-In User Service (RADIUS) server takes which of the following roles in an 802.1X transaction?",
    "choice_a": "The authenticator",
    "choice_b": "The authentication server",
    "choice_c": "The supplicant",
    "choice_d": "The accountant",
    "correct_answer": "B",
    "explanation": "In most cases, it is a Remote Authentication Dial-In User Service (RADIUS) server that performs the authentication server role in an 802.1X transaction by verifying the identity of the client. The authenticator is a switch or access point to which the supplicant is requesting access, and the supplicant is the client attempting to connect to the network. There is no accountant role in an 802.1X transaction.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      397,
      374,
      370,
      377,
      375
    ],
    "source": "9781394239306"
  },
  {
    "id": 1650,
    "question": "You are installing an Internet access router for your company's new branch office. The router has a switch module containing four Ethernet ports, all of which are assigned to the default VLAN1. When you plug a laptop into one of the Ethernet ports, you can access the Internet with no difficulties. You now need to connect the router to the company network so that the wireless access points on the network can provide users with Internet access through the router. However, when you plug the router into a network switch port that is assigned to VLAN4, the switch starts generating \u201cNative VLAN mismatch detected\u201d errors once every minute. Which of the following steps should be part of the solution you implement to stop the error messages from appearing? (Choose all that apply.)",
    "choice_a": "Create a VLAN1 on the network switch.",
    "choice_b": "Configure the network switch port connected to the router to use VLAN1.",
    "choice_c": "Create a VLAN4 on the router's switch module.",
    "choice_d": "Configure the router port connected to the network switch to use VLAN4.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The solution requires you to create a VLAN on the ADSL router that matches the VLAN the network switch port is using. Therefore, you should create a VLAN4 on the router's switch module and assign an Ethernet port to it, which will be the port you use to connect the ADSL router to the network switch. There is no need to create a VLAN1 on the network switch, because all switches already have a default VLAN called VLAN1. Modifying the VLAN assignments on the network switch is not a good idea, because it might interfere with the existing VLAN strategy in place.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      101,
      37,
      11,
      17,
      40
    ],
    "source": "9781394239306"
  },
  {
    "id": 1651,
    "question": "Which of the following cannot function as a preventative mitigation for the problem of tailgating? (Choose all that apply.)",
    "choice_a": "Security cameras",
    "choice_b": "Badge readers",
    "choice_c": "Access control vestibules",
    "choice_d": "Motion detectors",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Tailgating refers to the practice of closely following an authorized individual through a physical security barrier, such as a locked door. Security cameras can successfully prevent tailgating by identifying individuals attempting to gain unauthorized access to a protected facility, and access control vestibules (or mantraps) prevent tailgating by admitting only one entrant at a time. Badge readers are the security mechanisms that tailgating is intended to defeat, and motion detectors cannot distinguish authorized from unauthorized entrants.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      316,
      317,
      325,
      328,
      334
    ],
    "source": "9781394239306"
  },
  {
    "id": 1652,
    "question": "You have just created a new virtual machine (VM) using remote controls provided by a cloud service provider on the Internet. You then install an operating system on the virtual machine and configure it to function as a web server. Which of the following cloud architectures are you using when you do this? (Choose all that apply.)",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "Public cloud",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Infrastructure as a service (IaaS) provides consumers with processing, storage, and networking resources that they can use to install and run operating systems and other software of their choice. In the public cloud model, one organization functions as the provider, and another organization\u2014in this case, you\u2014consumes the services of the provider. Platform as a service (PaaS) provides consumers with the ability to install applications of their choice on a server furnished by the provider. Software as a service (SaaS) provides consumers with access to a specific application running on the provider's servers, but the consumers have no control over the operating system, the servers, or the underlying resources. In a private cloud, the same organization that uses the cloud services is also the sole owner of the infrastructure that provides those services. A hybrid cloud is a combination of public and private infrastructure so that the consumer organization is only a partial owner of the infrastructure.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      284,
      283,
      301,
      281,
      282
    ],
    "source": "9781394239306",
    "choice_e": "Private cloud",
    "choice_f": "Hybrid cloud"
  },
  {
    "id": 1653,
    "question": "It is your first day working for a consultant who does network cable installations. Your new boss hands you a spool of Category 6 cable, a bag of little clear plastic components, and the tool shown in the following figure. He then tells you to \u201cget started on fives and tens.\u201d What is your new boss expecting you to do? <img src=\"/question_assets/Network+/c06uf002.png\"/>",
    "choice_a": "Pull cable runs.",
    "choice_b": "Attach keystone connectors.",
    "choice_c": "Install a patch panel.",
    "choice_d": "Create patch cables.",
    "correct_answer": "D",
    "explanation": "The plier-like device is a crimper, which cable installers use to attach RJ-45 connectors, like those in the bag, to lengths of bulk cable. This is the process of creating patch cables, which are used to connect computers to wall plates and patch panel ports to switches. Your boss is telling you to start making patch cables in 5- and 10-foot lengths. You do not use a crimper to attach keystone connectors, and the boss has not given you the tools and components needed to pull cable runs or install a patch panel.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      26,
      33,
      35,
      45,
      44
    ],
    "source": "9781394239306"
  },
  {
    "id": 1654,
    "question": "Which of the following well-known ports do you use to configure outgoing mail on a POP3 email client?",
    "choice_a": "110",
    "choice_b": "25",
    "choice_c": "143",
    "choice_d": "80",
    "correct_answer": "B",
    "explanation": "The default port for the Post Office Protocol 3 (POP3) is 110, but that is used for incoming mail. Outgoing mail uses the Simple Mail Transfer Protocol (SMTP), which uses the well-known port number 25 by default. Port number 143 is the default port for the Internet Message Access Protocol (IMAP), a different email mailbox protocol that clients never use with POP3. Port number 80 is the default port for the Hypertext Transfer Protocol (HTTP), which is not used by email clients.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      78,
      77,
      82,
      81,
      23
    ],
    "source": "9781394239306"
  },
  {
    "id": 1655,
    "question": "You are a consultant who has been hired to extend a network by a client that is still running thin Ethernet. You have brought a spool of RG-58 coaxial cable. Which of the following types of cable connectors will you have to bring with you to add thin Ethernet network segments?",
    "choice_a": "ST",
    "choice_b": "BNC",
    "choice_c": "MPO",
    "choice_d": "RJ45",
    "correct_answer": "B",
    "explanation": "The cable connector used for thin Ethernet segments is called a Bayonet Neill-Concelman (BNC) connector. Straight Tip (ST) and Multi-fiber Push-On (MPO) connectors are for fiber-optic cables. RJ-45 is a type of connector used with twisted-pair cabling for data networks. RJ-11 is a connector type used with twisted-pair cabling for telecommunications networks.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      405
    ],
    "source": "9781394239306",
    "choice_e": "RJ11"
  },
  {
    "id": 1656,
    "question": "Which of the following types of cable is never used to connect a workstation to an Ethernet network?",
    "choice_a": "Rollover",
    "choice_b": "Straight-through",
    "choice_c": "Crossover",
    "choice_d": "Plenum",
    "correct_answer": "A",
    "explanation": "A rollover cable is a type of null modem cable, usually flat and light blue in color, with the pinouts reversed on either end, to enable a terminal to communicate with a router or switch through the device's dedicated console port. It cannot connect a workstation to the network. A straight-through cable is the standard network cable used to connect a workstation or other device to an Ethernet network. A crossover cable is designed to connect network adapters to each other directly, creating a two-node network. A plenum cable is a type of cable intended for use within air spaces that has an outer sheath that does not produce toxic fumes when it burns. A shielded cable is intended to protect signals from electromagnetic interference. Both plenum and shielded cables can connect a workstation to a network.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      51,
      53,
      54,
      150,
      162
    ],
    "source": "9781394239306",
    "choice_e": "Shielded"
  },
  {
    "id": 1657,
    "question": "Which of the following protocols does IPsec use to provide data origin authentication by digitally signing packets before transmitting them over the network?",
    "choice_a": "AH",
    "choice_b": "SSL",
    "choice_c": "ESP",
    "choice_d": "RDP",
    "correct_answer": "A",
    "explanation": "Authentication Header (AH) is a protocol in the TCP/IP suite that provides digital integrity services, in the form of a digital signature, which ensures that an incoming packet actually originated from its stated source. Encapsulating Security Protocol (ESP) provides encryption services for IPsec. Secure Sockets Layer (SSL) is a security protocol that provides encrypted communications between web browsers and servers. Remote Desktop Protocol (RDP) is a component of Remote Desktop Services, a Windows mechanism that enables a client program to connect to a server and control it remotely.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      80,
      97,
      81,
      23,
      82
    ],
    "source": "9781394239306"
  },
  {
    "id": 1658,
    "question": "You have constructed a network on which all of the computers are connected to a single switch. You then create virtual local area networks (VLANs) on the switch, corresponding to the company's departments, and add the switch port for each user workstation and department server to the appropriate VLAN. Later, users report that while they can access their departmental servers and the workstations of other users in the same department, they cannot communicate with any of the other departments. What is the problem, and what must you do to correct it?",
    "choice_a": "There is a faulty VLAN configuration on the switch. You must re-create all of the VLANs and configure each VLAN for routing.",
    "choice_b": "VLANs are limited to Data link layer communication only. To enable communication between the VLANs, you must install a router or a layer 3 switch on the network and configure it to route traffic between the VLANs.",
    "choice_c": "The VLANs are using different Data link layer protocols. You must configure the VLANs to use the same Data link layer protocol in order for them to communicate with each other.",
    "choice_d": "One of the VLANs is configured to filter all of the other VLAN traffic for security purposes. You must change the filter on this one VLAN.",
    "correct_answer": "B",
    "explanation": "VLANs are virtual layer 2 (Data link layer) LANs defined within switches. As with physical LANs, only devices in the same VLAN can communicate with each other until a layer 3 device, such as a router or a layer 3 switch, is added to the network. Re-creating and reconfiguring the VLANs will not correct the problem. Traffic filters are usually implemented on routers, not switches. Once a router is in place, VLANs do not have to use the same data link protocol to communicate with each other.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      101,
      22,
      285,
      37,
      81
    ],
    "source": "9781394239306"
  },
  {
    "id": 1659,
    "question": "The TCP/IP term <i>socket</i> consists of which of the following elements? (Choose all that apply.)",
    "choice_a": "Port number",
    "choice_b": "MAC address",
    "choice_c": "IP address",
    "choice_d": "Subnet mask",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "The term for an IPv4 address and port number in combination, which identifies an application running on a specific host, is <i>socket</i>. A media access control (MAC) address is an address hard-coded into a network adapter; it is not a TCP/IP element. A subnet mask is not needed to identify a host or an application running on it.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      214,
      227,
      231,
      226,
      229
    ],
    "source": "9781394239306"
  },
  {
    "id": 1660,
    "question": "You are installing a cable modem to provide your home network with access to the Internet through your cable television provider. The cable modem is a multifunction device that the cable company says provides everything you need for a home network. Which of the following network functions does a home cable modem typically provide? (Choose all that apply.)",
    "choice_a": "DHCP server",
    "choice_b": "Wireless access point",
    "choice_c": "Broadband router",
    "choice_d": "Ethernet switch",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D"
    ],
    "explanation": "A cable modem must function as a broadband router to provide access to the cable provider's network. Many cable modems are also wireless access points, enabling users to construct a LAN without a cable installation. Many cable modems have switched Ethernet ports for connections to wired devices, such as printers and computers. Most cable modems use DHCP to assign IP addresses to devices on the home network. Cable modems for home use typically do not function as proxy servers or Remote Authentication Dial-In User Service (RADIUS) servers, which are devices generally used on large networks.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      58,
      226,
      251,
      254
    ],
    "source": "9781394239306",
    "choice_e": "Proxy server",
    "choice_f": "RADIUS server"
  },
  {
    "id": 1661,
    "question": "Which of the following Domain Name System (DNS) resource records is not used for forward name resolution?",
    "choice_a": "PTR",
    "choice_b": "CNAME",
    "choice_c": "AAAA",
    "choice_d": "MX",
    "correct_answer": "A",
    "explanation": "Like A and AAAA records, which are used for forward name resolution, pointer (PTR) records contain hostnames and IP addresses. However, PTR records are used only for reverse name resolution\u2014that is, resolving IP addresses into hostnames. A mail exchange (MX) record specifies the mail server that the domain should use. Canonical name (CNAME) records specify aliases for a given hostname. An AAAA resource record maps a hostname to an IPv6 address for name resolution purposes. All of these records except PTR are used for forward name resolution.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      58,
      98,
      56,
      95,
      94
    ],
    "source": "9781394239306"
  },
  {
    "id": 1662,
    "question": "Which of the following are tasks that can be performed by a protocol analyzer that could provide potential intruders with information about the network? (Choose all that apply.)",
    "choice_a": "A protocol analyzer can decrypt protected information in packets captured from the network.",
    "choice_b": "A protocol analyzer can detect open ports on network systems and launch attacks against them.",
    "choice_c": "A protocol analyzer can display the IP addresses of the systems on the network.",
    "choice_d": "A protocol analyzer can display the application data in packets captured from the network.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Protocol analyzers capture packets from the network and interpret their contents, which can include displaying the Application layer payload. Depending on the application, the payload can conceivably include confidential information, such as passwords. Protocol analyzers also display the IP addresses of the systems involved in packet transmissions. Although this in itself might not be a great security threat, intruders might use the IP address information to launch other types of attacks. Protocol analyzers cannot decrypt the protected information they find in captured packets. Vulnerability scanners detect open ports and launch attacks against them; protocol analyzers do not do this.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      324,
      325,
      328,
      327,
      348
    ],
    "source": "9781394239306"
  },
  {
    "id": 1663,
    "question": "Which of the following services are provided by a RADIUS server? (Choose all that apply.)",
    "choice_a": "Attenuation",
    "choice_b": "Authentication",
    "choice_c": "Assistance",
    "choice_d": "Authorization",
    "correct_answer": [
      "B",
      "D",
      "E"
    ],
    "explanation": "A Remote Authentication Dial-In User Service (RADIUS) server, also known as an AAA server, provides centralized authentication, authorization, and accounting for other network services. Attenuation and assistance are not functions provided by RADIUS or AAA servers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      203,
      205,
      299,
      300,
      5
    ],
    "source": "9781394239306",
    "choice_e": "Accounting"
  },
  {
    "id": 1664,
    "question": "Some users are having a problem connecting to an application server on their local network. You go to their department and start to troubleshoot the problem by testing connectivity using the <code>ping</code> tool at one of the user workstations. You discover that you can ping the server successfully using its computer name, but pinging the computer's fully qualified domain name (FQDN) fails. As a result of these tests, which of the following can you determine is the most likely source of the problem?",
    "choice_a": "EMI",
    "choice_b": "DHCP",
    "choice_c": "DNS",
    "choice_d": "ACL",
    "correct_answer": "C",
    "explanation": "Only Domain Name System (DNS) servers perform FQDN resolutions, so that is likely to be the source of the problem. It is possible to successfully ping a device on the local network using its computer name without the use of DNS. Dynamic Host Configuration Protocol (DHCP) cannot be the problem; if it were, you would not be able to ping the server at all. Electromagnetic interference (EMI) would inhibit all network communication, and access control lists (ACLs) are an authorization mechanism that has no effect on ping tests.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      76,
      36,
      112,
      72,
      83
    ],
    "source": "9781394239306"
  },
  {
    "id": 1665,
    "question": "You have been given the job of devising a plan to provide a 500-node private internetwork with access to the Internet. The primary objective of the project is to provide all of the network users with access to web and email services while keeping the client computers safe from unauthorized Internet users. There are two secondary objectives for the project: one is to provide a means of monitoring and regulating the users' Internet activities, and the other is to avoid having to manually configure IP addresses on each one of the client computers. You submit a proposal that calls for the use of private IP addresses on the client computers and a series of proxy servers with public, registered IP addresses, which are connected to the Internet. Which of the following statements about your proposed Internet access solution is true?",
    "choice_a": "The proposal satisfies the primary objective and both of the secondary objectives.",
    "choice_b": "The proposal satisfies the primary objective and one of the secondary objectives.",
    "choice_c": "The proposal satisfies the primary objective but neither of the secondary objectives.",
    "choice_d": "The proposal fails to satisfy either the primary or secondary objective.",
    "correct_answer": "B",
    "explanation": "Proxy servers provide network users with access to Internet services, and the unregistered IP addresses on the client computers protect them from unauthorized access by users on the Internet, which satisfies the primary objective. The proxy servers also make it possible for network administrators to monitor and regulate users' access to the Internet, which satisfies one of the two secondary objectives. However, proxy servers are not capable of assigning IP addresses to the client computers, and the proposal makes no mention of a Dynamic Host Configuration Protocol (DHCP) server or any another automatic TCP/IP configuration mechanism. Therefore, the proposal does not satisfy the other secondary objective.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      117,
      287,
      79,
      114
    ],
    "source": "9781394239306"
  },
  {
    "id": 1666,
    "question": "Which of the following cloud service models provides the consumer with the least amount of control over the cloud resources?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "IaaS, PaaS, and SaaS all provide the same degree of control.",
    "correct_answer": "C",
    "explanation": "Software as a service (SaaS) provides the least amount of control. Consumers receive access to a specific application running on the provider's servers, but they have no control over the operating system, the servers, or the underlying resources. The infrastructure as a service (IaaS) model provides the consumers with the most control, as the provider furnishes processing, storage, and networking resources that the consumer can use as needed. Platform as a service (PaaS) provides consumers with the ability to install applications of their choice on a server furnished by the provider, but they have only limited control over the server and no control over the underlying resources.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      316,
      334,
      317,
      327,
      325
    ],
    "source": "9781394239306"
  },
  {
    "id": 1667,
    "question": "The jumbo frame capability is associated with which networking protocol?",
    "choice_a": "Ethernet",
    "choice_b": "Internet Protocol (IP)",
    "choice_c": "Point-to-Point Protocol (PPP)",
    "choice_d": "Transmission Control Protocol (TCP)",
    "correct_answer": "A",
    "explanation": "Ethernet uses jumbo frames at the Data link layer to transfer large amounts of data more efficiently. Ethernet typically restricts frame size to 1,500 bytes, but jumbo frames enable Ethernet systems to create frames up to 9,000 bytes. PPP does not support the use of jumbo frames. Frames are protocol data units (PDUs) associated only with the Data link layer, so they do not apply to IP and TCP, which operate at the Network and Transport layers, respectively.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      395,
      397,
      398,
      393,
      394
    ],
    "source": "9781394239306"
  },
  {
    "id": 1668,
    "question": "You are working your company's IT help desk, where you are required to follow a specific troubleshooting protocol when handling calls from users. In which of the following troubleshooting steps would you create a trouble ticket?",
    "choice_a": "Establish a theory of probable cause.",
    "choice_b": "Verify full system functionality and implement preventive measures, if applicable.",
    "choice_c": "Identify the problem.",
    "choice_d": "Test the theory to determine the cause.",
    "correct_answer": "C",
    "explanation": "The first step in the troubleshooting methodology involves identifying the problem by questioning the user and creating a trouble ticket. You complete the other steps in the troubleshooting methodology after the trouble ticket has been created and prioritized.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      127,
      51,
      121,
      126,
      125
    ],
    "source": "9781394239306",
    "choice_e": "Document findings, actions, and outcomes.",
    "choice_f": "Implement the solution or escalate as necessary.",
    "choice_g": "Establish a plan of action to resolve the problem and identify potential effects."
  },
  {
    "id": 1669,
    "question": "You are working your company's help desk when a user calls to report that he cannot access any of the data on his computer. He says that a message has appeared on his screen stating that all of his data has been encrypted by the FBI and that it will be decrypted only after he pays $768 in Bitcoin to an unknown address. The user wants to know if he is responsible for making the payment. Which of the following types of attacks has the user experienced?",
    "choice_a": "Denial-of-service",
    "choice_b": "Social engineering",
    "choice_c": "Ransomware",
    "choice_d": "ARP poisoning",
    "correct_answer": "C",
    "explanation": "The user has experienced a ransomware attack. Ransomware is a type of attack in which a user's access to his or her data is blocked unless a certain amount of money is paid to the attacker. The blockages can vary from simple screen locks to data encryption. Denial-of-service is a type of attack that overwhelms a computer with traffic, preventing it from functioning properly. Social engineering refers to various methods attackers can use to gain access to secured resources by manipulating authorized users, either physically or digitally. ARP poisoning is the deliberate insertion of fraudulent information into the ARP cache stored on computers and switches.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      312,
      304,
      321,
      311,
      322
    ],
    "source": "9781394239306"
  },
  {
    "id": 1670,
    "question": "Which of the following are switch features that help to prevent intruders from manipulating the Spanning Tree Protocol (STP)?",
    "choice_a": "Geofencing",
    "choice_b": "Root guard",
    "choice_c": "DHCP snooping",
    "choice_d": "BPDU guard",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "BPDU guard and root guard are both mechanisms that protect the Spanning Tree Protocol against infiltration by attackers. Bridge protocol data units (BPDUs) are messages that switches running the Spanning Tree Protocol (STP) exchange to learn about the available paths through a switched network. Switches should receive BPDUs only through ports connected to other switches. BPDU guard is a feature that prevents BPDU messages from arriving through ports connected to end systems, such as computers. A root guard affects the behavior of the STP by enforcing the selection of root bridge ports on a switched network. Without root guards, there is no way for administrators to enforce the topology of a network with a redundant switching fabric. Geofencing is a wireless technology that uses radio frequency identification (RFID) or GPS coordinates to define a geographic perimeter for a network. DHCP snooping is a security feature that prevents unauthorized DHCP servers from accessing the network.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      171,
      157,
      159,
      172,
      169
    ],
    "source": "9781394239306"
  },
  {
    "id": 1671,
    "question": "Network cable runs generally connect office endpoints, such as wall plates, to a central cabling nexus, which is typically where the runs are joined to a backbone network that links them together. Which of the following are terms for such nexuses where network cabling connections are found? (Choose all that apply.)",
    "choice_a": "RDP",
    "choice_b": "IDF",
    "choice_c": "MDF",
    "choice_d": "MTBF",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "A large enterprise network will\u2014at minimum\u2014have demarcation points for telephone services and a connection to an Internet service provider's network. In many cases, these services enter the building in the same equipment room that houses the backbone switch, which enables all the devices on the network to access those resources. This room is then called the main distribution frame (MDF). An intermediate distribution frame (IDF) is a place where localized telecommunications equipment, such as the interface between the horizontal cabling and the backbone, is located. For example, an enterprise network housed in a single building might have its MDF in the basement and an IDF on each floor. Mean time between failures (MTBF) and Remote Desktop Protocol (RDP) are not network cabling locations.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      71,
      150,
      162,
      187,
      64
    ],
    "source": "9781394239306"
  },
  {
    "id": 1672,
    "question": "Your supervisor has asked you to call the cabling contractor your company uses and make an appointment to install some new twisted-pair cable runs. In addition to asking how many cable runs you need pulled, the contractor asks you if you need plenum or PVC. Under which of the following conditions might the local building code require that a data network use plenum cable?",
    "choice_a": "When cable runs exceed the maximum length specified by the Physical layer specification",
    "choice_b": "When cables must run through air ducts",
    "choice_c": "When cables run near devices that generate electromagnetic interference (EMI)",
    "choice_d": "When multiple cables run through the same conduit",
    "correct_answer": "B",
    "explanation": "A plenum space is an area of a building that provides air circulation as part of its ventilation system, such as a heating or air-conditioning duct. Plenum cables have a sheath made of a fire-retardant material that does not outgas toxic fumes when it burns. When network cables are installed in plenum spaces, many local building codes require that installers use plenum-rated cables conforming to specific standards. Plenum cables provide no benefit when installed near other cables, or EMI sources, or when they exceed specified lengths.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      378,
      379,
      392,
      399,
      404
    ],
    "source": "9781394239306"
  },
  {
    "id": 1673,
    "question": "Which of the following is not a term for the process of combining the bandwidth of two or more network adapters to increase the overall speed of the connection and provide fault tolerance?",
    "choice_a": "Port aggregation",
    "choice_b": "Link aggregation",
    "choice_c": "Bonding",
    "choice_d": "Clustering",
    "correct_answer": "D",
    "explanation": "Clustering refers to the combination of multiple servers\u2014not network adapters\u2014into a single unit to enhance performance and provide fault tolerance. Bonding, link aggregation, port aggregation, and NIC teaming are all terms for the same basic technology, in which the bandwidth of multiple network adapter connections is joined to speed up transmissions. The technology also enables the network communication to continue if one of the adapters fails or is disconnected.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      260,
      276,
      267,
      265,
      268
    ],
    "source": "9781394239306",
    "choice_e": "NIC teaming"
  },
  {
    "id": 1674,
    "question": "You have been asked by the director of the IT department to review the security status of the network device administration procedures currently in use. You know that network device hardening has as one of its first principles the use of secure protocols over insecure ones. Which of the following suggestions are examples of this principle that you should suggest to the director? (Choose all that apply.)",
    "choice_a": "Use WEP instead of WPA2.",
    "choice_b": "Use TKIP instead of AES.",
    "choice_c": "Use HTTPS instead of HTTP.",
    "choice_d": "Use SSH instead of Telnet.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Secure Shell (SSH) and Telnet are both remote terminal programs, but Telnet clients pass instructions (including passwords) to the target server in cleartext, whereas SSH uses encrypted transmissions. In the same way, Hypertext Transfer Protocol Secure (HTTPS) is the encrypted version of HTTP. In both of these cases, the substitute is more secure and should be suggested to the director. However, Temporal Key Integrity Protocol (TKIP) provides encryption that is less secure than Advanced Encryption Standard (AES), and Wired Equivalent Protocol (WEP) is less secure than Wi-Fi Protected Access 2 (WPA2).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      74,
      73,
      80,
      286,
      203
    ],
    "source": "9781394239306"
  },
  {
    "id": 1675,
    "question": "The Simple Network Management Protocol (SNMP) works by processing information gathered from agents installed or embedded in network devices and displaying the information on a central console. Which of the following is the term used for the database in which SNMP agents store information about their properties?",
    "choice_a": "MIB",
    "choice_b": "Trap",
    "choice_c": "Syslog",
    "choice_d": "SIEM",
    "correct_answer": "A",
    "explanation": "A management information base (MIB) is the database on an SNMP agent in which information about the properties of the managed device is stored. The other three options do not perform this function. A trap is an alert message that SNMP agents send to the network management console when an exceptional event occurs. Syslog is a standard for message logging components. Security information and event management (SIEM) is a combination tool that uses information gathered from logs and network devices to provide a real-time analysis of the network's security condition.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      374,
      397,
      395,
      392,
      401
    ],
    "source": "9781394239306"
  },
  {
    "id": 1676,
    "question": "When a web browser connects to a web server using an address with the https:// prefix, the connection is secured using Transmission Control Protocol (TCP) and an encryption protocol. Which of the following protocols are typically used to secure communication between web servers and web browsers? (Choose all that apply.)",
    "choice_a": "TLS",
    "choice_b": "SSH",
    "choice_c": "DTLS",
    "choice_d": "SSL",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Secure Sockets Layer (SSL) is a now-deprecated security protocol that formerly provided encrypted communications between web browsers and servers. Transport Layer Security (TLS) is an updated security protocol that is designed to replace SSL. Datagram Transport Layer Security (DTLS) is a security protocol that provides the same basic functions as TLS but for User Datagram Protocol traffic instead of TCP. Secure Shell (SSH) is a character-based tool that enables users to execute commands on remote computers; it does not provide web server/browser security.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      72,
      73,
      205,
      18
    ],
    "source": "9781394239306"
  },
  {
    "id": 1677,
    "question": "A screened subnet is a segment that is exposed to the Internet and separated from the internal network by a firewall. Administrators typically use a screened subnet for servers that must be accessible to outside users, such as web and email servers. Which of the following is another term for a screened subnet?",
    "choice_a": "PEAP",
    "choice_b": "DMZ",
    "choice_c": "VLAN",
    "choice_d": "TKIP",
    "correct_answer": "B",
    "explanation": "Another term for a screened subnet is a DMZ, or demilitarized zone. They are also known as perimeter networks. A virtual LAN (VLAN) is a logical network segment created within a switch. Protected Extensible Authentication Protocol (PEAP) is an authentication protocol, and Temporal Key Integrity Protocol (TKIP) is an encryption algorithm. These three options are not terms for a screened subnet.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      248,
      160,
      66,
      53,
      71
    ],
    "source": "9781394239306"
  },
  {
    "id": 1678,
    "question": "Which of the following types of traffic is not exchanged by Remote Desktop clients and servers using the Remote Desktop Protocol (RDP)?",
    "choice_a": "Keystrokes",
    "choice_b": "Mouse movements",
    "choice_c": "Display information",
    "choice_d": "Application data",
    "correct_answer": "D",
    "explanation": "RDP is a component of Remote Desktop Services, a Windows mechanism that enables a client program to connect to a server and control it remotely. RDP does not carry actual application data; it just transfers keystrokes, mouse movements, and graphic display information.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      74,
      78,
      72,
      14,
      3
    ],
    "source": "9781394239306"
  },
  {
    "id": 1679,
    "question": "You have been engaged to design a wireless LAN for a site you have never seen. For that reason, you want the LAN to be able to support both the 2.4 GHz and 5 GHz frequencies. Which of the following IEEE 802.11 wireless LAN standards should you look for when you are shopping for equipment that supports both frequencies? (Choose all that apply.)",
    "choice_a": "802.11g",
    "choice_b": "802.11n",
    "choice_c": "802.11ac",
    "choice_d": "802.11ax",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Of the options shown, only the 802.11n and 802.11ax standards define wireless LAN devices that can support both the 2.4 GHz and 5 GHz frequencies. The 802.11ac standard supports only 5 GHz, and the 802.11g standard supports only 2.4 GHz.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      185,
      186,
      207,
      188,
      197
    ],
    "source": "9781394239306"
  },
  {
    "id": 1680,
    "question": "Which of the following statements about multitenancy in a public cloud datacenter is not true?",
    "choice_a": "Multitenancy presents a potential security risk because other tenants are using the same hardware.",
    "choice_b": "Multitenancy separates tenants by assigning each one its own virtual machine.",
    "choice_c": "Multitenancy reduces the cost of utilities and other overhead.",
    "choice_d": "Multitenancy introduces the possibility of competition for bandwidth with other tenants.",
    "correct_answer": "B",
    "explanation": "Multitenancy does not call for tenants to have individual virtual machines. Multitenancy is a software architecture in which multiple tenants share a single instance of an application running in the cloud. Because tenants share a single application, there is a chance that data could be compromised. Because a single application instance is running in the cloud, the operational overhead is reduced compared to the use of individual virtual machines. Tenants share a finite amount of bandwidth, so the possibility exists for competition to occur, such as when one tenant is the target of a denial-of-service attack.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      366,
      382,
      367,
      363,
      376
    ],
    "source": "9781394239306"
  },
  {
    "id": 1681,
    "question": "Which of the following specifies the name of a network using multiple APs to support a single SSID?",
    "choice_a": "BSS",
    "choice_b": "ESS",
    "choice_c": "SSID",
    "choice_d": "BSSID",
    "correct_answer": "E",
    "explanation": "On a wireless network, an extended service set identifier (ESSID) is used to identify a configuration in which there is a single SSID using multiple access points. A basic service set (BSS) refers to the wireless network itself, consisting of a single AP and a number of clients. An extended service set (ESS) consists of two or more BSSs, using multiple APs. The service set identifier (SSID) is the name that you use when connecting to a wireless network. The basic service set identifier (BSSID) is the MAC address of the access point associated with a BSS.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      310,
      360,
      317,
      355,
      352
    ],
    "source": "9781394239306",
    "choice_e": "ESSID"
  },
  {
    "id": 1682,
    "question": "When starting her new position as a network administrator, Alice was given two user accounts. One account is intended for standard user activities, and the other account has the additional permissions needed for Alice to perform administrative tasks. This is an example of which of the following security concepts?",
    "choice_a": "Zero day",
    "choice_b": "Least privilege",
    "choice_c": "Defense in depth",
    "choice_d": "Multifactor authentication",
    "correct_answer": "B",
    "explanation": "Least privilege is the practice of only providing users with the permissions they need to perform their designated tasks and no more. For her standard activities, Alice is given an account that does not have administrative permissions, because she does not need those permissions to perform standard tasks. The administrative account has the additional permissions needed for Alice to perform administrative tasks. The intention is for Alice to use that account only for those administrative tasks. Zero day is a type of vulnerability; multifactor authentication (or MFA) calls for users to supply two identifying factors; defense in depth refers to the use of multiple security mechanisms to provide additional protection. None of these other three options refers to the use of multiple user accounts.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      242,
      237,
      245,
      250,
      244
    ],
    "source": "9781394239306"
  },
  {
    "id": 1683,
    "question": "You are in the process of troubleshooting a user's computer that is malfunctioning. Which step of the troubleshooting model involves replacing computer components until you have identified a faulty hardware device?",
    "choice_a": "Establish a plan of action to resolve the problem.",
    "choice_b": "Duplicate the problem.",
    "choice_c": "Gather information.",
    "choice_d": "Verify full system functionality.",
    "correct_answer": "E",
    "explanation": "After you have established a theory of probable cause, you can try to test the theory by replacing hardware components one by one until you find the faulty device. All of the other options are steps that come either earlier or later in the troubleshooting process.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      322,
      311,
      318,
      305,
      320
    ],
    "source": "9781394239306",
    "choice_e": "Test the theory to determine the cause.",
    "choice_f": "Document findings, actions, and outcomes.",
    "choice_g": "Establish a theory of probable cause."
  },
  {
    "id": 1684,
    "question": "Which of the following could be an indication that there is a rogue DHCP server on your network?",
    "choice_a": "A user's workstation has an IP address from another subnet.",
    "choice_b": "A user can access local resources from his workstation but not Internet resources.",
    "choice_c": "The DHCP Enabled setting on a user's workstation is set to No.",
    "choice_d": "The user's workstation has an IP address on the 169.254.0.0/16 subnet.",
    "correct_answer": "A",
    "explanation": "While it is not definitive evidence, an IP address assignment from the wrong subnet could be an indication that there is a rogue (unauthorized and unknown) Dynamic Host Configuration Protocol (DHCP) server on the network. A workstation with an IP address from the wrong subnet cannot access any network resources, local or Internet. The DHCP Enabled setting would be Yes if a workstation had gotten its IP address from a rogue DHCP server. An address on the 169.254.0.0/16 subnet indicates that the workstation was unable to obtain an IP address from any DHCP server.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      60,
      224,
      255,
      226
    ],
    "source": "9781394239306"
  },
  {
    "id": 1685,
    "question": "Which of the following network interface occurrences is considered to be malfunctions on a full-duplex Ethernet network but not on a half-duplex Ethernet network?",
    "choice_a": "Runts",
    "choice_b": "Late collisions",
    "choice_c": "Giants",
    "choice_d": "Collisions",
    "correct_answer": "D",
    "explanation": "All of these occurrences are malfunctions on a full-duplex Ethernet network, but collisions are normal and expected on a half-duplex network. Runt frames occur when a network interface generates packets that are smaller than the 64-byte minimum allowable length. Giants occur when frames are larger than the 1,518-byte maximum allowable length. Late collisions occur when network cables are too long, and frames collide after leaving the sending system.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      39,
      38,
      37,
      40,
      44
    ],
    "source": "9781394239306"
  },
  {
    "id": 1686,
    "question": "A protocol analyzer is a tool that captures packets from a network and examines their contents. Which of the following Unix/Linux tools is a protocol analyzer?",
    "choice_a": "nmap",
    "choice_b": "tcpdump",
    "choice_c": "pathping",
    "choice_d": "iptables",
    "correct_answer": "B",
    "explanation": "The Unix/Linux <code>tcpdump</code> utility is a protocol analyzer. It is a command-line tool that captures network packets and displays their contents. The <code>iptables</code>, <code>nmap</code>, and <code>pathping</code> utilities cannot capture and analyze packets. <code>Iptables</code> manages Unix/Linux kernel firewall rules, <code>nmap</code> is a port scanner, and <code>pathping</code> is a Windows route tracing tool.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      393,
      394,
      395,
      383,
      382
    ],
    "source": "9781394239306"
  },
  {
    "id": 1687,
    "question": "A storage area network (SAN) typically takes the form of a dedicated network used to provide servers with access to hard disk arrays and other storage devices. Which of the following statements about the differences between a SAN and network attached storage (NAS) are true? (Choose all that apply.)",
    "choice_a": "NAS devices typically provide a filesystem, while SAN devices do not.",
    "choice_b": "NAS provides file-level storage access, whereas a SAN provides block-level storage access.",
    "choice_c": "NAS devices typically contain integrated iSCSI targets.",
    "choice_d": "SAN devices have an operating system, whereas NAS devices do not.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "NAS devices are self-contained file servers that connect directly to a standard IP network. A NAS device provides file-level access to its storage devices, and it includes an operating system and a filesystem. NAS devices are typically not iSCSI targets. SANs provide block-level storage and typically function as iSCSI targets, but they do not include an operating system or filesystem.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      395,
      396,
      401,
      399,
      400
    ],
    "source": "9781394239306"
  },
  {
    "id": 1688,
    "question": "Your supervisor has just informed you that the CIO has hired an outside consultant to perform penetration testing on the company network. Which of the following best describes what you can expect the consultant to do?",
    "choice_a": "Evaluate the security conditions on the network.",
    "choice_b": "Create computers or networks that are alluring targets for intruders.",
    "choice_c": "Attempt to compromise the network's security measures.",
    "choice_d": "Implement a new companywide security protocol.",
    "correct_answer": "C",
    "explanation": "Penetration testing is a type of network security evaluation in which a client engages an outside consultant who attempts to penetrate the network's security and gain access to protected network resources without authorization. Testing by an internal administrator familiar with the security barriers would not be a valid test. Although having a consultant examine the network's security from within can be useful, it is not a penetration test. Computers or networks that are alluring targets for intruders are called honeypots or honeynets. Implementation of a new security protocol can only come after the current security situation has been evaluated.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      299,
      300,
      203,
      290,
      285
    ],
    "source": "9781394239306"
  },
  {
    "id": 1689,
    "question": "Your company is a contractor for the government that regularly works with highly sensitive defense data. To prevent this data from being compromised, the company's datacenter has various special security measures installed. All of the servers have crimped metal tags holding the cases closed. All of the hardware racks are locked in clear-fronted cabinets. All of the cable runs are installed in transparent conduits. These are all examples of which of the following types of physical security measure?",
    "choice_a": "Asset tracking",
    "choice_b": "Geofencing",
    "choice_c": "Tamper detection",
    "choice_d": "Port security",
    "correct_answer": "C",
    "explanation": "All of the mechanisms listed are designed to make any attempts to tamper with or physically compromise the hardware devices immediately evident. Therefore, these mechanisms are various forms of tamper detection. Asset tracking is for locating and identifying hardware. Geofencing is a wireless networking technique for limiting access to a network. Port security refers to protection of network switch ports.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      404,
      403,
      402,
      389,
      390
    ],
    "source": "9781394239306"
  },
  {
    "id": 1690,
    "question": "Which of the following tools are only usable on fiber-optic networks? (Choose all that apply.)",
    "choice_a": "Visual fault locator",
    "choice_b": "Optical power meter",
    "choice_c": "Protocol analyzer",
    "choice_d": "Toner and probe",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "A visual fault locator is a laser light source used to locate breaks in fiber-optic cables. An optical power meter measures the signal strength on fiber-optic cables to locate breaks and measure signal degradation as part of an optical loss test set (OLTS). These two tools can only be used on fiber-optic cables. A protocol analyzer is a tool that captures network packets for the purpose of analyzing their contents. It can function on a network of any cable type. Toner and probe tools are used in copper-based cabling installations, not fiber-optic cabling.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      29,
      112,
      32,
      25
    ],
    "source": "9781394239306"
  },
  {
    "id": 1691,
    "question": "Which of the following mechanisms use tunneling to establish secured links between TCP/IP systems? (Choose all that apply.)",
    "choice_a": "VPNs",
    "choice_b": "IPsec",
    "choice_c": "GRE",
    "choice_d": "NAT",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Virtual private networks (VPNs), IPsec, and Generic Routing Encapsulation (GRE) are all mechanisms that encapsulate packets in an encrypted form within another protocol to secure their contents. Network address translation (NAT) enables workstations on private networks to access the Internet by substituting a public IP address in packets generated with private addresses. NAT does not use tunneling.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      148,
      187,
      192,
      54,
      128
    ],
    "source": "9781394239306"
  },
  {
    "id": 1692,
    "question": "Your supervisor has given you a Class C network IP address and has asked you to create a network with 8 subnets and 30 hosts per subnet. Which of the following subnet masks will you have to use?",
    "choice_a": "255.255.255.128",
    "choice_b": "255.255.255.192",
    "choice_c": "255.255.255.224",
    "choice_d": "255.255.255.240",
    "correct_answer": "C",
    "explanation": "To create a network with 8 subnets and 30 hosts per subnet, you must allocate 3 of the 8 bits in the last octet for use as a subnet identifier. This results in a binary value of 11100000 for the last octet in the subnet mask, which converts to a decimal value of 224. Therefore, the correct subnet mask value is 255.255.255.224. Values for the last octet that are lower than 224 would not enable you to create 8 subnets. Values higher than 224 would not enable you to create 30 host addresses.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      344,
      331,
      332,
      343,
      333
    ],
    "source": "9781394239306",
    "choice_e": "255.255.255.248",
    "choice_f": "255.255.255.252"
  },
  {
    "id": 1693,
    "question": "You are a consultant working at a client site. The client has supplied you with the SSID and the passphrase for the company's wireless network so that you can connect to it with your laptop. However, you are unable to establish a connection. Which of the following security measures might be preventing you from connecting your laptop to the network?",
    "choice_a": "Geofencing",
    "choice_b": "MAC filtering",
    "choice_c": "Using WPA3",
    "choice_d": "Disabling SSID broadcasts",
    "correct_answer": "B",
    "explanation": "MAC filtering takes the form of an access control list (ACL) on the wireless network's access points, listing the MAC addresses of all the devices that are permitted to access the network. If the MAC address of your laptop is not included in the ACL, you will be unable to connect to the network. Geofencing is intended to prevent users outside the office from accessing the network. You are inside, so this should not be the problem. You have been given the passphrase for the network, so you should be able to configure the WPA3 protocol on your laptop. You have been given the SSID of the network, so you should be able to connect by manually entering it, even if the access points are not broadcasting the SSID.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      42,
      203,
      205,
      22,
      36
    ],
    "source": "9781394239306"
  },
  {
    "id": 1694,
    "question": "You have just finished installing a new Category 6 cable run for the first time. After attaching keystone connectors to both ends of the cable, you mount the office-side connector to a wall plate and mount the datacenter connector into a patch panel. Then you take a patch cable and connect the patch panel port to an open port in one of the network switches. However, the link pulse LED on the switch port does not light as it is supposed to. What should you do next?",
    "choice_a": "Repull the cable run using Category 6a cable.",
    "choice_b": "Check the cable run for wiring faults.",
    "choice_c": "Make sure the switch port is not disabled.",
    "choice_d": "Plug a computer into the wall plate.",
    "correct_answer": "D",
    "explanation": "In order for the link pulse LED on the switch port to light up, there must be an active connection between the switch and a functioning network device at the other end. Plugging a running computer into the wall plate will enable the Ethernet adapters at both end of the connection to communicate, causing the LED to light. None of the other options will cause the LED to light.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      26,
      27,
      33,
      44,
      22
    ],
    "source": "9781394239306"
  },
  {
    "id": 1695,
    "question": "Devices on a TCP/IP network typically use the Address Resolution Protocol (ARP) to locate specific destinations on the local network by resolving IP addresses into MAC addresses (also known as hardware addresses). At which layer of the Open Systems Interconnection (OSI) model do these MAC addresses operate?",
    "choice_a": "Physical",
    "choice_b": "Data link",
    "choice_c": "Network",
    "choice_d": "Transport",
    "correct_answer": "B",
    "explanation": "The Ethernet (or IEEE 802.3) protocol at the Data link layer uses MAC addresses to identify computers on the local network. Media access control (MAC) addresses are coded into the firmware of physical network interface adapters by the manufacturer. The Physical layer deals with signals and is not involved in addressing. The IP protocol at the Network layer has its own addressing system. The Transport layer protocols are not involved in addressing.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      398,
      384,
      397,
      395,
      393
    ],
    "source": "9781394239306"
  },
  {
    "id": 1696,
    "question": "Which of the following Network layer protocols includes a field that limits the number of times a packet can be routed on a network? (Choose all that apply.)",
    "choice_a": "ICMP",
    "choice_b": "IGMP",
    "choice_c": "IPv4",
    "choice_d": "IPv6",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The Internet Protocol (IP) in both of its versions (IPv4 and IPv6) includes a Time to Live (TTL) field in its message header that specifies how many times a packet can be routed. Each router processing the packet reduces the TTL value by one until it reaches zero, after which it is discarded. The Internet Control Message Protocol (ICMP) and the Internet Group Management Protocol (IGMP) do not have TTL fields.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      383,
      384,
      385,
      394,
      395
    ],
    "source": "9781394239306"
  },
  {
    "id": 1697,
    "question": "ARP poisoning is the deliberate insertion of fraudulent information into the ARP cache stored on computers and switches. Which of the following types of attack can be facilitated by ARP poisoning? (Choose all that apply.)",
    "choice_a": "Social engineering",
    "choice_b": "On-path",
    "choice_c": "Evil twin",
    "choice_d": "Session hijacking",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "By inserting modified entries into a device's ARP cache, an attacker can cause traffic to be diverted from the correct destination to a system controlled by the attacker. This can enable the attacker to intercept traffic intended for another destination. In an on-path attack (also known as a man-in-the-middle attack), the attacker can read the intercepted traffic and even modify it before sending it on to the correct destination. In a session hijacking attack, the attacker can use the intercepted traffic to obtain authentication information, including passwords. Neither of the other two options is facilitated by ARP poisoning. An evil twin is a fraudulent access point on a wireless network. Social engineering is a form of attack in which an innocent user is persuaded by an attacker to provide sensitive information via email or telephone.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      36,
      37,
      112,
      147,
      40
    ],
    "source": "9781394239306"
  },
  {
    "id": 1698,
    "question": "Recently, your network has been the target of numerous attack attempts. To gather information about the attackers, you have created a server that is designed to function as an enticing target but that does not provide access to any legitimately sensitive services or information. Which of the following is the term used to describe this technique?",
    "choice_a": "Spoofing",
    "choice_b": "DMZ",
    "choice_c": "Root guard",
    "choice_d": "Honeypot",
    "correct_answer": "D",
    "explanation": "A honeypot is a computer configured to function as bait for attackers, causing them to waste their time penetrating a resource that provides no significant access. This is also a technique that enables the target to gather information about the attackers. A demilitarized zone (DMZ), also known as a screened subnet or perimeter network, is a network segment on which administrators locate servers that must be accessible from the Internet but that are separated from the internal network by a firewall. A root guard provides protection to switch ports. Spoofing is an attack technique in which an intruder modifies packets to assume the appearance of another user or computer.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      300,
      285,
      10,
      17,
      101
    ],
    "source": "9781394239306"
  },
  {
    "id": 1699,
    "question": "You are a consultant working on a new client's network. The network has been in place for decades, and you have been given a diagram supplied by the original installer. The diagram says that the network computers are connected to a device called a multiport bridge. Which of the following devices can also be described as a multiport bridge?",
    "choice_a": "Repeater",
    "choice_b": "Hub",
    "choice_c": "Switch",
    "choice_d": "Router",
    "correct_answer": "C",
    "explanation": "A switch is a type of bridge that receives data through any one of its multiple ports and then retransmits the data out through the one port connected to the data's designated recipient. A repeater is a Physical layer device that regenerates incoming signals and retransmits them. A hub is a type of repeater that receives data through any one of its multiple ports and retransmits the data out through all of its other ports. Bridges and switches are Data link layer devices, and routers are Network layer devices.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      317,
      154,
      320,
      358,
      352
    ],
    "source": "9781394239306"
  },
  {
    "id": 1700,
    "question": "When you run a port scanner on a server, which of the following is the result?",
    "choice_a": "A list of the servers currently running user processes",
    "choice_b": "A list of the computer's hardware ports that are currently in use",
    "choice_c": "A list specifying the numbers of packets transmitted and received by each network adapter on the system",
    "choice_d": "A list of open ports through which the system can be accessed",
    "correct_answer": "D",
    "explanation": "A port scanner examines a system for open ports or endpoints that are accessible from the network using the TCP or UDP protocol, which intruders can conceivably exploit to gain access to the system. Port scanners do not list user processes, hardware ports, numbers of packets, or IP addresses.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      364,
      365,
      363,
      395,
      394
    ],
    "source": "9781394239306",
    "choice_e": "A list of the IP addresses used by all the devices on the local network"
  },
  {
    "id": 1701,
    "question": "Your company has a seven-node failover cluster hosting databases on SQL Server. Each server has three network interface adapters installed in it. Two are standard Gigabit Ethernet adapters that provide the nodes with access to each other and clients with access to the cluster. One is a Fibre Channel adapter that provides the cluster nodes with access to a dedicated network that also hosts a large hard disk array. Which of the following terms describe the networks to which the cluster nodes are connected? (Choose all that apply.)",
    "choice_a": "SAN",
    "choice_b": "WAN",
    "choice_c": "MAN",
    "choice_d": "LAN",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "A storage area network (SAN) is a network that is dedicated to carrying traffic between servers and storage devices. SANs can use specialized network protocols, such as Fibre Channel in this case, or standard Gigabit Ethernet. A local area network (LAN) is a connected group of computers, usually inside a single room or building. In this case, the cluster has one LAN connecting the nodes together and another providing other users with access to the cluster. A wide area network (WAN) is a network that connects devices or networks at different geographic locations. A metropolitan area network (MAN) is a type of WAN that connects devices within a limited geographic area. The cluster is not connected to a WAN or MAN.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      262,
      66,
      264,
      54,
      71
    ],
    "source": "9781394239306"
  },
  {
    "id": 1702,
    "question": "A Windows user calls you at the help desk and reports that he cannot connect to any hosts on either the local or a remote network. This is the only report of its kind you have received today. You question the user about the problem and eventually learn that he has made some changes to his workstation's Internet Protocol (IP) settings. What should you do next?",
    "choice_a": "Check the switches in the datacenter to see if they have logged any error messages.",
    "choice_b": "Verify that the routers on the network are functioning.",
    "choice_c": "Run the ipconfig command on the user's workstation to view its configuration.",
    "choice_d": "Check the network's Domain Name System (DNS) server to see if it is resolving IP hostnames.",
    "correct_answer": "C",
    "explanation": "Since only one user is reporting the problem and he has admitted to making changes to his IP configuration, you should start by checking the workstation configuration using the <code>ipconfig</code> command. If the routers, the switches, or the DNS server were causing the problem, more than one user would be affected, and there would be additional users calling the help desk.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      119,
      128,
      127,
      126,
      121
    ],
    "source": "9781394239306"
  },
  {
    "id": 1703,
    "question": "You are a network administrator attempting to use your workstation on the internal network to remotely control a web server called WebServ1 on a screened subnet. However, the remote desktop client software is unable to establish a connection to the server. You can see all the computers on your local network and on the screened subnet. You try using the <code>ping</code> utility to test the TCP/IP functionality of WebServ1, and the ping test is successful. You then call your colleague on the same internal network and have her try to connect to WebServ1 using the same remote access tool. She connects to WebServ1 successfully. Which of the following could be the cause of the problem you are experiencing?",
    "choice_a": "Blocked TCP/UDP ports on the web server",
    "choice_b": "Name resolution failure",
    "choice_c": "Incorrect firewall settings on your workstation",
    "choice_d": "Unresponsive service on the web server",
    "correct_answer": "C",
    "explanation": "Because your colleague can connect to WebServ1 successfully, the problem is not an unresponsive service or blocked ports on the server. The problem is not a name resolution failure, because you can successfully ping WebServ1 by name. Therefore, of the options listed, the only possible problem must be that the firewall on your workstation is configured to block the remote desktop client's traffic.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      248,
      121,
      119,
      127,
      54
    ],
    "source": "9781394239306"
  },
  {
    "id": 1704,
    "question": "The toolkit you were given when you began work for an IT consulting company contained the tool shown in the following figure. What is the function of this tool? <img src=\"/question_assets/Network+/c06uf003.png\"/>",
    "choice_a": "When you touch the end of the tool to a copper cable, you can detect and measure the electrical current flowing through it.",
    "choice_b": "When you place the tool at one end of a wire, it generates a tone that can be detected at the other end.",
    "choice_c": "To connect a bulk cable to a keystone connector, you use the tool to punch each wire down into the correct receptacle on the connector.",
    "choice_d": "When you connect the tool to the end of a fiber-optic cable, you can measure the length of the cable run.",
    "correct_answer": "C",
    "explanation": "The device shown in the figure is a punchdown tool, which you use to connect unshielded twisted-pair cable ends to the keystone connectors used in modular wall plates and patch panels. After lining up the individual wires in the cable with the connector, you use the tool to press each wire into its slot. The tool also cuts the wire sheath to make an electrical contact and trims the end of the wire. This tool is not capable of performing any of the tasks described in the other options.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      27,
      26,
      32,
      35,
      33
    ],
    "source": "9781394239306"
  },
  {
    "id": 1705,
    "question": "You are designing a new wireless network based on the IEEE 802.11n standard. The equipment you have selected supports both the 2.4 GHz and 5 GHz frequencies, and you are undecided about which one to use. Which of the following are possible reasons why the 5 GHz frequency tends to perform better than the 2.4 GHz frequency on a wireless LAN? (Choose all that apply.)",
    "choice_a": "The 5 GHz frequency has more channels than the 2.4 GHz frequency.",
    "choice_b": "The 5 GHz frequency conflicts with fewer common household devices than the 2.4 GHz frequency.",
    "choice_c": "The 5 GHz frequency transmits at faster speeds than the 2.4 GHz frequency.",
    "choice_d": "The 5 GHz frequency supports longer ranges than the 2.4 GHz frequency.",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "The 5 GHz frequency has 23 channels available in the United States, whereas the 2.4 GHz frequency has only 11. Many household devices, such as cordless telephones, use the 2.4 GHz frequency band, but relatively few devices use the 5 GHz band. Higher frequencies typically support faster transmission speeds because with all other conditions equal, they can carry more data in the same amount of time. The 5 GHz frequency typically has a shorter range than 2.4 GHz because it is less able to penetrate barriers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      180,
      31,
      22,
      195,
      40
    ],
    "source": "9781394239306"
  },
  {
    "id": 1706,
    "question": "A rack-mounted device that is six units tall will be approximately what height in inches?",
    "choice_a": "1.75",
    "choice_b": "3.5",
    "choice_c": "7",
    "choice_d": "10.5",
    "correct_answer": "D",
    "explanation": "The standard unit height for IT equipment racks is 1.75 inches, which is the equivalent of one unit. Therefore, six units would be 10.5 inches.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      352,
      358,
      357,
      305,
      320
    ],
    "source": "9781394239306"
  },
  {
    "id": 1707,
    "question": "Which of the following server applications uses two well-known port numbers, one for control traffic and one for data traffic?",
    "choice_a": "FTP",
    "choice_b": "SNMP",
    "choice_c": "NTP",
    "choice_d": "HTTP",
    "correct_answer": "A",
    "explanation": "The File Transfer Protocol (FTP) uses two port numbers. It uses the first, port 21, for a control connection that remains open during the entire client-server session. The second port, 20, is for a data connection that opens only when the protocol is actually transferring a file between the client and the server. Simple Network Management Protocol (SNMP), Network Time Protocol (NTP), and Hypertext Transfer Protocol (HTTP) all use a single port on the server.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      78,
      73,
      83,
      18,
      77
    ],
    "source": "9781394239306"
  },
  {
    "id": 1708,
    "question": "You are configuring the computers on a new network, and you have been given the network address 10.26.0.0/13. Which of the following subnet mask values must you use when configuring the computers?",
    "choice_a": "255.248.0.0",
    "choice_b": "255.252.0.0",
    "choice_c": "255.254.0.0",
    "choice_d": "255.255.248.0",
    "correct_answer": "A",
    "explanation": "The 13-bit prefix indicated in the network address will result in a mask with 13 ones followed by 19 zeroes. Broken into 8-bit blocks, the binary mask value is as follows: <p>11111111 11111000 00000000 00000000</p><p>Converted into decimal values, this results in a subnet mask value of 255.248.0.0.</p>",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      330,
      344,
      343,
      333,
      340
    ],
    "source": "9781394239306",
    "choice_e": "255.255.252.0",
    "choice_f": "255.255.254.0"
  },
  {
    "id": 1709,
    "question": "You are testing a twisted-pair cable run using a toner and probe. When you apply the toner to each of the first seven wires at one end of the cable, you successfully detect a tone on the corresponding pin at the other end. However, when you connect the toner to the eighth wire, you fail to detect a tone at the other end. Which of the following fault types have you discovered?",
    "choice_a": "Short circuit",
    "choice_b": "Open circuit",
    "choice_c": "Split pair",
    "choice_d": "Crosstalk",
    "correct_answer": "B",
    "explanation": "The failure to detect a tone on the eighth wire indicates that there is either a break in the wire somewhere inside the cable or a bad pin connection in one or both connectors. This type of fault is called an open circuit. None of the other three options are faults that manifest as described. A short circuit is when a wire is connected to two or more pins at one end of the cable. A split pair is a connection in which two wires are incorrectly mapped in exactly the same way on both ends of the cable. Crosstalk is a type of interference caused by signals on one wire bleeding over to other wires.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      52,
      70,
      71,
      53,
      150
    ],
    "source": "9781394239306"
  },
  {
    "id": 1710,
    "question": "Which of the following functions are defined as occurring at the Session layer of the Open Systems Interconnection (OSI) model? (Choose all that apply.)",
    "choice_a": "Data encryption",
    "choice_b": "Dialog control",
    "choice_c": "Datagram routing",
    "choice_d": "Dialog separation",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "The Session layer is responsible for creating and maintaining a dialog between end systems. This dialog can be a two-way alternate dialog that requires end systems to take turns transmitting, or it can be a two-way simultaneous dialog in which either end system can transmit at will. The Session layer functions are called dialog control and dialog separation. Data encryption is performed at the Presentation layer, and datagram routing occurs at the Network layer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      17,
      81,
      82,
      19
    ],
    "source": "9781394239306"
  },
  {
    "id": 1711,
    "question": "You are working your company's IT help desk, and you have had several calls from users who are reporting problems with their Voice over IP (VoIP) and streaming video connections. In each case, the audio or video connection experiences frequent dropouts in sound or video, causing frustrating interruptions. Which of the following terms describes a connectivity problem on a wired network that could cause these symptoms?",
    "choice_a": "Jitter",
    "choice_b": "Latency",
    "choice_c": "Bottleneck",
    "choice_d": "Attenuation",
    "correct_answer": "A",
    "explanation": "When individual packets in a data stream are delayed, due to network congestion, different routing, or queuing problems, the resulting connectivity problem is called jitter. While this condition might not cause problems for asynchronous applications, real-time communications, such as VoIP or streaming video, can suffer interruptions from which the phenomenon gets its name. Latency describes a generalized delay in network transmissions, not individual packet delays. Attenuation is the weakening of a signal as it travels through a network medium. A bottleneck is a condition in which all traffic is delayed, due to a faulty or inadequate component. None of these three options would account for the problems reported by the users.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      111,
      47,
      37,
      82,
      21
    ],
    "source": "9781394239306"
  },
  {
    "id": 1712,
    "question": "You are a consultant with a client who wants to have you install a wireless network with the highest throughput currently available. What is the fastest speed achievable by a wireless LAN using the currently ratified IEEE 802.11 standards?",
    "choice_a": "54 Mbps",
    "choice_b": "600 Mbps",
    "choice_c": "6.9 Gbps",
    "choice_d": "9.6 Gbps",
    "correct_answer": "D",
    "explanation": "The 802.11ax standard defines a wireless LAN running at speeds of up to 9.6 gigabits per second (Gbps). The 802.11ac standard supports speeds of up to 6.9 Gbps. None of the other ratified 802.11 standards define networks running at speeds beyond the 600 Mbps of 802.11n.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      185,
      186,
      207,
      188,
      198
    ],
    "source": "9781394239306"
  },
  {
    "id": 1713,
    "question": "A private network uses unregistered IP addresses that are not accessible from the Internet. In order for computers on the private network to access Internet servers, there must be a device that substitutes registered IP addresses for the unregistered ones. Which of the following devices are capable of performing this kind of IP address substitution? (Choose all that apply.)",
    "choice_a": "RADIUS server",
    "choice_b": "NAT router",
    "choice_c": "UTM appliance",
    "choice_d": "Proxy server",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Network address translation (NAT) is a Network layer service, typically integrated into a router, that converts the private IP addresses in all of a client's Internet transmissions to a registered IP address. Therefore, NAT works for all applications. A proxy server is an Application layer device that performs the same type of conversion but only for specific applications. A Remote Authentication Dial-In User Service (RADIUS) server can provide authentication, authorization, and accounting services for remote access servers, but it does not convert IP addresses. A unified threat management (UTM) appliance typically performs virtual private network (VPN), firewall, and antivirus functions. It does not convert IP addresses.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      116,
      117,
      18,
      79,
      86
    ],
    "source": "9781394239306"
  },
  {
    "id": 1714,
    "question": "A user calls you at the technical support desk in the computer store where you work. He is installing a home network and is having trouble configuring the IP addresses for his computers. He starts reading off a list of the network addresses he has tried to use. Which of the following are valid IPv4 network addresses that the user can conceivably use to configure his computers? (Choose all that apply.)",
    "choice_a": "1.1.1.0",
    "choice_b": "9.34.0.0",
    "choice_c": "103.256.77.0",
    "choice_d": "229.6.87.0",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "1.1.1.0 and 9.34.0.0 are both valid IPv4 network addresses. IPv4 addresses with first byte values from 224 to 239 are Class D addresses, which are reserved for use as multicast addresses. Therefore, the user cannot use 229.6.87.0 for his network. 103.256.77.0 is an invalid address because the value 256 cannot be represented by an 8-bit binary value.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      54,
      119,
      121,
      129,
      130
    ],
    "source": "9781394239306"
  },
  {
    "id": 1715,
    "question": "Which of the following terms refers to a routing protocol that relies on hop counts to measure the efficiency of routes through an internetwork?",
    "choice_a": "Link state protocol",
    "choice_b": "Distance vector protocol",
    "choice_c": "Edge gateway protocol",
    "choice_d": "Interior gateway protocol",
    "correct_answer": "B",
    "explanation": "Distance vector protocols rely on hop counts\u2014that is, the number of routers between a source and a destination\u2014to evaluate the efficiency of routes. Link state protocols use a different type of calculation, usually based on Dijkstra's algorithm. The terms <i>interior gateway protocol</i> and <i>edge gateway protocol</i> do not refer to the method of calculating routing efficiency.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      137,
      131,
      142,
      138,
      141
    ],
    "source": "9781394239306"
  },
  {
    "id": 1716,
    "question": "You have been hired by a client to connect two local area networks that are in different buildings 500 meters apart. The cable type you use must support Gigabit Ethernet data rates of 1,000 megabits per second (Mbps) and provide a high level of resistance to electromagnetic interference (EMI). Which of the following cable types can you choose to meet the client's needs? (Choose all that apply.)",
    "choice_a": "Single-mode fiber-optic cable",
    "choice_b": "Thin coaxial cable",
    "choice_c": "Multimode fiber-optic cable",
    "choice_d": "Shielded twisted-pair (STP) cable",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Any type of fiber-optic cable will satisfy the client's requirements. Fiber-optic cable supports the required 1,000 Mbps data rate and can connect networks that are 500 meters apart. Fiber-optic cable is also immune to EMI. Although both multimode and single-mode fiber would meet the corporation's general needs, multimode is substantially less expensive than single-mode fiber. Twisted-pair wiring (STP or UTP) can meet the data rate requirement, but it does not support connections longer than 100 meters. Thin coaxial cable does not support the data rate or distances longer than 185 meters.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      46,
      31,
      26,
      45
    ],
    "source": "9781394239306",
    "choice_e": "Unshielded twisted-pair (UTP) cable"
  },
  {
    "id": 1717,
    "question": "You receive a call at the IT help desk from a user who has recently moved to a new office in the company building, down the hall from her old one. Since the move, she has only been able to access the company's wireless network with her laptop intermittently. The network is based on 802.11n equipment, and it is using the 2.4 GHz frequency and the WPA3 security protocol. The user never had a problem in her previous office location. Which of the following could not possibly be the cause of her problem? (Choose all that apply.)",
    "choice_a": "The user's laptop is connecting to the wrong SSID.",
    "choice_b": "The user's laptop is configured to use the 5 GHz frequency.",
    "choice_c": "The user's new office is farther from the access point than her old one.",
    "choice_d": "There are more intervening walls between the user's new office and the access point.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "An incorrect frequency, SSID, or WPA3 passphrase would prevent the user's laptop from ever connecting to the network, so these cannot be the cause of the problem. Greater distance from the access point or interference from intervening walls can both cause a weakening of wireless signals, which can result in the intermittent connectivity that the user is experiencing.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      193,
      196,
      206,
      188,
      197
    ],
    "source": "9781394239306",
    "choice_e": "The user's laptop is configured with the wrong WPA3 passphrase."
  },
  {
    "id": 1718,
    "question": "Which of the following statements about static routing are not true? (Choose all that apply.)",
    "choice_a": "Static routes are automatically added to the routing table by routing protocols when a new network path becomes available.",
    "choice_b": "Static routes are manually configured routes that administrators must add, modify, or delete when a change in the network occurs.",
    "choice_c": "Static routes are a recommended solution for large internetworks with redundant paths to each destination network.",
    "choice_d": "Static routes are a recommended solution for small internetworks with a single path to each destination network.",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "Static routes are not automatically added to the routing table by routing protocols and do not automatically adapt to changes in the network. Therefore, they are not recommended for large internetworks with redundant paths between networks. Administrators must manually add, modify, or delete static routes when a change in a network occurs. For this reason, static routes are recommended only for use in small networks without multiple paths to each destination.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      135,
      134,
      21,
      4,
      101
    ],
    "source": "9781394239306",
    "choice_e": "Static routes adapt to changes in the network infrastructure automatically."
  },
  {
    "id": 1719,
    "question": "Which layer of the Open Systems Interconnection (OSI) model has its own logical addressing system and is responsible for routing packets from one network to another?",
    "choice_a": "Physical",
    "choice_b": "Data link",
    "choice_c": "Network",
    "choice_d": "Transport",
    "correct_answer": "C",
    "explanation": "Network layer protocols specify logical addresses, such as IP addresses, for end system communication. They also use those addresses to route packets to destinations on other networks. The Physical layer defines standards for physical and mechanical characteristics of a network. The Data link layer uses media access control (MAC) or hardware addresses, not logical addresses. The Transport layer uses port numbers, not logical addresses. Session layer protocols create and maintain a dialog between end systems. Presentation layer protocols are responsible for the formatting, translation, and presentation of information. The Application layer provides an entry point for applications to access the protocol stack and prepare information for transmission across a network.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      21,
      17,
      79,
      22,
      83
    ],
    "source": "9781394239306",
    "choice_e": "Session",
    "choice_f": "Presentation",
    "choice_g": "Application"
  },
  {
    "id": 1720,
    "question": "Several marketing consultants are working in your office for the first time, and they have approached you because they are unable to connect to the company's 802.11ac wireless network with their laptops. They are selecting the correct SSID from the Available Networks list, but they still cannot connect, and there are no error messages of any kind. Which of the following tasks should you perform first to try to resolve the problem?",
    "choice_a": "Examine the area where the consultants are working for possible sources of signal interference.",
    "choice_b": "Change the frequency used by the wireless access point from 5 GHz to 2.4 GHz.",
    "choice_c": "Make sure that the consultants' laptops are configured to use the correct wireless security protocol.",
    "choice_d": "Check the network adapters in the laptops for channel overlap.",
    "correct_answer": "C",
    "explanation": "The use of an incorrect wireless security protocol is a well-known source of errorless connection failures, so checking this will most likely enable you to discover the source of the problem. Channel overlap is a problem that you would check and resolve at the access point, not at the users' workstations. It is not possible to change the frequency on the access point, because the 802.11ac standard only supports the 5 GHz frequency. Although signal interference could conceivably be the cause for a connection failure, the users can see the network's SSID, so this is not likely to be the problem.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      196,
      204,
      206,
      188,
      193
    ],
    "source": "9781394239306"
  },
  {
    "id": 1721,
    "question": "You are researching the various types of storage area network (SAN) technologies currently available before making a purchasing recommendation to your IT director. Which of the following are genuine advantages of iSCSI over Fibre Channel? (Choose all that apply.)",
    "choice_a": "iSCSI can share the same network as standard local area network (LAN) traffic, whereas Fibre Channel cannot.",
    "choice_b": "iSCSI is routable, whereas Fibre Channel is not.",
    "choice_c": "iSCSI is less expensive to implement than Fibre Channel.",
    "choice_d": "iSCSI includes its own internal flow control mechanism, whereas Fibre Channel does not.",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "iSCSI does not include its own flow control mechanism, so option D is incorrect. It runs over a TCP connection, which is the protocol responsible for flow control. Fibre Channel requires a dedicated network using fiber-optic cable. iSCSI traffic can coexist with standard LAN traffic on a single network, although some type of quality of service (QoS) mechanism is frequently recommended. Because it runs on any IP network, iSCSI traffic is routable, and it is far less expensive to implement than Fibre Channel.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      16,
      19,
      6,
      28,
      72
    ],
    "source": "9781394239306"
  },
  {
    "id": 1722,
    "question": "In which of the following DNS transactions does the querying system generate an iterative query? (Choose all that apply.)",
    "choice_a": "A DNS client extracts the server name www.adatum.com from a URL and sends it to its designated DNS server for resolution.",
    "choice_b": "A client's DNS server sends a name resolution request to a root domain server to discover the authoritative server for the com top-level domain.",
    "choice_c": "A client's DNS server sends a name resolution request to the com top-level domain server to find the authoritative server for the adatum.com domain.",
    "choice_d": "A client's DNS server, which has been configured to function as a forwarder, sends the server name www.adatum.com from a URL to its ISP's DNS server for resolution.",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "The client's DNS server uses iterative queries when sending name resolution requests to root domain servers and to the authoritative servers for the com and <code>adatum.com</code> domains. In an iterative query, the server replies immediately with the best information it possesses, and the transaction ends. When a client sends a name resolution query to its DNS server, it uses a recursive request so that the server will assume the responsibility for resolving the name. The only other use of recursive requests is in the case of a forwarder, which is configured to pass that responsibility on to another DNS server.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      375,
      382,
      383,
      405,
      394
    ],
    "source": "9781394239306",
    "choice_e": "A client's DNS server sends a name resolution request to the adatum.com domain server to discover the IP address associated with the server name www."
  },
  {
    "id": 1723,
    "question": "A user approaches you as you are passing through his department and reports that he cannot access the Internet. After questioning him, you determine that he can access systems on the local network. You examine the routing table on the user's Windows workstation, and you see the problem. Which of the following commands must you run to correct the user's problem, based on the routing table display shown here? <img src=\"/question_assets/Network+/pt_c6_93.png\"/>",
    "choice_a": "route add 192.168.2.0 MASK 0.0.0.0 192.168.2.37 METRIC 25 IF 192.168.2.99",
    "choice_b": "route add 0.0.0.0 MASK 255.255.255.0 192.168.2.99 METRIC 25 IF 192.168.2.37",
    "choice_c": "route add 192.168.2.0 MASK 255.255.255.0 192.168.2.99 METRIC 25 IF 192.168.2.37",
    "choice_d": "route add 0.0.0.0 MASK 0.0.0.0 192.168.2.99 METRIC 25 IF 192.168.2.37",
    "correct_answer": "D",
    "explanation": "To access the Internet, the workstation's routing table must include a default gateway entry. The default gateway is a router on the local network that provides access to other networks, such as the Internet. To manually create a default gateway entry in the routing table, you use the <code>route add</code> command with a Network Destination value of 0.0.0.0, a MASK value of 0.0.0.0, and the address of a router on the local network (in this case 192.168.2.99). The entry must also have a METRIC value that is lower than the other entries in the table so that it will be used first.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      58,
      98,
      255,
      237,
      238
    ],
    "source": "9781394239306"
  },
  {
    "id": 1724,
    "question": "You are heading out to do a cabling job for a client who has coaxial and twisted-pair Ethernet networks at their facility. You want to bring connectors and cables to prepare for any eventuality. Which of the following connector types are typically associated with Ethernet networks? (Choose all that apply.)",
    "choice_a": "N-type",
    "choice_b": "BNC",
    "choice_c": "F-type",
    "choice_d": "RJ-45",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "Thin Ethernet networks use Bayonet Neill-Concelman (BNC) connectors. Thick Ethernet networks use N-type connectors. All unshielded twisted-pair (UTP) Ethernet networks use RJ-45 connectors. You will not need F-type or DB-9 connectors. F-type connectors are used with coaxial cable but are typically used for cable television installations. DB-9 connectors are commonly used for serial communications ports.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      404,
      403,
      392,
      393,
      395
    ],
    "source": "9781394239306",
    "choice_e": "DB-9"
  },
  {
    "id": 1725,
    "question": "When geofencing is used as part of a multifactor authentication system, which of the following best describes geofencing's role?",
    "choice_a": "Somewhere you are",
    "choice_b": "Something you do",
    "choice_c": "Something you have",
    "choice_d": "Something you know",
    "correct_answer": "A",
    "explanation": "Geofencing is the generic term for a technology that limits access to a network or other resource based on the client's location. Therefore, it is best described as somewhere you are. A finger gesture would be considered something you do, a password something you know, and a smartcard something you have.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      299,
      203,
      205,
      300,
      296
    ],
    "source": "9781394239306"
  },
  {
    "id": 1726,
    "question": "Some organizations maintain alternative sites that they can use as datacenters should a disaster render the main datacenter unusable. Which of the following types of disaster recovery site can be made operational in the shortest amount of time?",
    "choice_a": "A hot site",
    "choice_b": "A warm site",
    "choice_c": "A cold site",
    "choice_d": "All of the site types require the same amount of preparation time.",
    "correct_answer": "A",
    "explanation": "Hot, warm, and cold backup sites differ in the hardware and software they have installed. A cold site is just a space at a remote location. The hardware and software must be procured and installed before the network can be restored. Therefore, it is the least expensive and takes the most time. A warm site has hardware in place, but it still must be installed and configured. A hot site has all of the necessary hardware already installed and configured. A warm site is more expensive than a cold site, and a hot site is the most expensive of all and takes the shortest amount of time to be made operational.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      272,
      239,
      268,
      278,
      269
    ],
    "source": "9781394239306"
  },
  {
    "id": 1727,
    "question": "Which of the following types of virtual private network (VPN) connection is the best solution for connecting a home user to a corporate network?",
    "choice_a": "Host-to-site",
    "choice_b": "Site-to-site",
    "choice_c": "Host-to-host",
    "choice_d": "Extranet",
    "correct_answer": "A",
    "explanation": "A host-to-site VPN is a remote access solution, enabling users to access the corporate network from home or while traveling. A site-to-site VPN enables one network to connect to another, enabling users on both networks to access resources on the other one. This is usually a more economical solution for branch office connections than a wide area network (WAN) link. A host-to-host VPN enables two individual users to establish a protected connection to each other. An extranet VPN is designed to provide clients, vendors, and other outside partners with the ability to connect to your corporate network with limited access.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      377,
      367,
      368,
      373,
      396
    ],
    "source": "9781394239306"
  },
  {
    "id": 1728,
    "question": "Which of the following are valid reasons why the leaf and spine datacenter topology is superior to the standard three-tier topology?",
    "choice_a": "The leaf and spine topology is less expensive to implement than the three-tier topology.",
    "choice_b": "In a leaf and spine topology, all data flows require the same number of hops.",
    "choice_c": "The leaf and spine arrangement uses a full mesh switching topology.",
    "choice_d": "The leaf and spine topology uses software-defined networking to direct traffic, rather than blocking ports using the Spanning Tree Protocol.",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "The leaf and spine topology uses a full mesh topology in its two layers of switches. This is more expensive than the three-tier topology, but it reduces latency by requiring the same number of hops in the path between any two routers. The use of software defined networking provides adaptive path determination without the use of the Spanning Tree Protocol (STP) for layer 2 port blocking.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      395,
      384,
      393,
      394,
      401
    ],
    "source": "9781394239306"
  },
  {
    "id": 1729,
    "question": "A baseline is a performance measurement for a device or system, taken under normal operating conditions, which you can use later to quantify any changes that might have taken place. Which of the following Windows applications would you most likely use to create a baseline of system or network performance?",
    "choice_a": "Syslog",
    "choice_b": "Event Viewer",
    "choice_c": "Network Monitor",
    "choice_d": "Performance Monitor",
    "correct_answer": "D",
    "explanation": "Performance Monitor is a Windows application that can create logs of specific system and network performance statistics over extended periods of time. Such a log created on a new computer can function as a baseline for future troubleshooting. Event Viewer is a Windows application for displaying system log files; it cannot create a performance baseline. Syslog is a log compilation program originally created for Unix systems; it does not create performance baselines. Network Monitor is a protocol analyzer. Although it can capture a traffic sample that can function as a reference for future troubleshooting efforts, this cannot be called a performance baseline.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      124,
      133,
      130,
      67
    ],
    "source": "9781394239306"
  },
  {
    "id": 1730,
    "question": "In most cases, a denial-of-service (DoS) attack refers to a deliberate attempt to overwhelm a server with incoming traffic. However, this is not always the case. Which of the following types of DoS attacks does not involve flooding a server with traffic?",
    "choice_a": "Amplified",
    "choice_b": "Distributed",
    "choice_c": "Permanent",
    "choice_d": "Reflective",
    "correct_answer": "C",
    "explanation": "Although a DoS attack typically involves traffic flooding, any attack that prevents a server from functioning can be called a DoS attack. A permanent DoS attack is one in which the attacker actually damages the target system and prevents it from functioning. This can be a physical attack that actually damages the server hardware, or the attacker can disable the server by altering its software or configuration settings. Flood-based attacks include the distributed denial-of-service (DDoS) attack, in which the attacker uses hundreds or thousands of computers, controlled by malware and called bots or zombies, to send traffic to a single server or website in an attempt to overwhelm it and prevent it from functioning. An amplified DoS attack is one in which the messages sent by the attacker require an extended amount of processing by the target servers, increasing the burden on them more than simpler messages would. A reflective DoS attack is one in which the attacker sends requests containing the target server's IP address to legitimate servers on the Internet, such as DNS servers, causing them to send a flood of responses that overwhelm the target.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      241,
      238,
      260,
      268,
      255
    ],
    "source": "9781394239306"
  },
  {
    "id": 1731,
    "question": "Which of the following definitions best describes the function of a firewall?",
    "choice_a": "A device that connects two networks forwarding traffic between them as needed",
    "choice_b": "A device located between two networks that enables administrators to restrict incoming and outgoing traffic",
    "choice_c": "A device that caches Internet data for subsequent use by internal network clients",
    "choice_d": "A device that enables Internet network clients with private IP addresses to access the Internet",
    "correct_answer": "B",
    "explanation": "A firewall is a network device\u2014either hardware or software\u2014that functions as a filter that can prevent dangerous traffic originating on one network from passing through to another network. A device that connects two networks together and forwards traffic between them is a router, not a firewall. A device that caches Internet data is a proxy server or caching engine, not a firewall. A device that enables Internet network clients with private IP addresses to access the Internet is a description of a network address translation (NAT) router or a proxy server, not a firewall.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      174,
      54,
      62,
      66,
      71
    ],
    "source": "9781394239306"
  },
  {
    "id": 1732,
    "question": "Review the following figure. Each of the switches has three ports connected to computers and one port for switch-to-switch connections. All of the computer ports and links are configured for half-duplex communication. The switch-to-switch links are configured for full-duplex communication. Which of the following statements about the switched network is true? <img src=\"/question_assets/Network+/c07uf001.png\"/>",
    "choice_a": "There is one collision domain for this network.",
    "choice_b": "There are three collision domains, one for each switch-to-switch connection.",
    "choice_c": "There are nine collision domains, one for each half-duplex connection.",
    "choice_d": "There are twelve collision domains, one for each switch connection.",
    "correct_answer": "C",
    "explanation": "All half-duplex port connections on a switch represent a different collision domain. Therefore, each of the nine connected computers forms its own collision domain. Full-duplex connections are not subject to collisions, so they do not define separate collision domains.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      37,
      39,
      38,
      101,
      17
    ],
    "source": "9781394239306"
  },
  {
    "id": 1733,
    "question": "Which of the following network devices can provide authentication services for multiple remote access servers using the device's own account database?",
    "choice_a": "NAS",
    "choice_b": "IDS",
    "choice_c": "NGFW",
    "choice_d": "RADIUS",
    "correct_answer": "D",
    "explanation": "A Remote Authentication Dial-In User Service (RADIUS) server can provide authentication, authorization, and accounting services for remote access servers. Network attached storage (NAS) devices, intrusion detection systems (IDSs), and next-generation firewalls (NGFWs) do not provide this type of authentication service.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      203,
      205,
      286,
      80,
      74
    ],
    "source": "9781394239306"
  },
  {
    "id": 1734,
    "question": "You are designing the network for your company's new branch office, and you need a device on which administrators can create virtual local area networks (VLANs) and that will forward traffic between them. Which of the following devices can do this?",
    "choice_a": "Virtual router",
    "choice_b": "Multilayer switch",
    "choice_c": "Broadband router",
    "choice_d": "Load balancer",
    "correct_answer": "B",
    "explanation": "A multilayer switch is a network connectivity device that functions at both the Data link layer (layer 2) and the Network layer (layer 3) of the Open Systems Interconnection (OSI) reference model. At layer 2, the device functions like a normal switch, creating an individual collision domain for each connected node and enabling administrators to create multiple VLANs. At layer 3, the device also provides routing capabilities by forwarding packets between the VLANs. Virtual routers, broadband routers, and load balancers are strictly layer 3 devices that can route traffic but cannot create VLANs.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      17,
      22,
      21,
      2,
      37
    ],
    "source": "9781394239306"
  },
  {
    "id": 1735,
    "question": "You are setting up a new network for which you have been given the IPv4 network address 10.61.0.0/19. You want to calculate the number of hosts you can create on each subnet. How many bits are allocated to the host identifier in an IPv4 address on this network?",
    "choice_a": "5",
    "choice_b": "8",
    "choice_c": "13",
    "choice_d": "21",
    "correct_answer": "C",
    "explanation": "The value after the slash in a classless inter-domain routing (CIDR) address specifies the number of bits in the network identifier. An IPv4 address has 32 bits, so if 19 bits are allocated to the network identifier, 13 bits are left for the host identifier.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      103,
      102,
      114,
      101,
      84
    ],
    "source": "9781394239306"
  },
  {
    "id": 1736,
    "question": "The protocols that are responsible for the delivery of data packets to their final destinations on an internetwork operate at which layer of the Open Systems Interconnection (OSI) reference model?",
    "choice_a": "Application",
    "choice_b": "Session",
    "choice_c": "Transport",
    "choice_d": "Network",
    "correct_answer": "D",
    "explanation": "On a TCP/IP network, the Internet Protocol (IP) at the Network layer is the protocol responsible for the delivery of data to its final destination, using IP addresses that can be routed through an internetwork. Data link layer protocols are only concerned with communication between devices on a local area network (LAN) or between two points connected by a wide area network (WAN). The Transport, Session, and Application layers are not involved in the actual delivery of data over the internetwork.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      21,
      17,
      79,
      22,
      81
    ],
    "source": "9781394239306",
    "choice_e": "Data link"
  },
  {
    "id": 1737,
    "question": "Originally, storage area networks (SANs) were dedicated solely to storage-based traffic. A local area network (LAN) was also required for other types of traffic. Today, however, it is possible for SAN and LAN traffic to coexist on a single network medium. Which of the following SAN protocols are capable of sharing a network medium with standard LAN traffic? (Choose all that apply.)",
    "choice_a": "Fibre Channel",
    "choice_b": "InfiniBand",
    "choice_c": "iSCSI",
    "choice_d": "FCoE",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The iSCSI protocol runs on a standard IP network, and the Fibre Channel over Ethernet (FCoE) variant runs on a standard Ethernet network. Both of these protocols can share a network with LAN traffic, although the use of a quality of service (QoS) mechanism is usually recommended to prioritize traffic. The original Fibre Channel implementation and InfiniBand both require a dedicated network medium that does not support LAN traffic.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      16,
      6,
      2,
      40,
      298
    ],
    "source": "9781394239306"
  },
  {
    "id": 1738,
    "question": "Which of the following Application layer protocols do not include a program that enables a user to log on to a remote network device and execute commands using a character-based interface? (Choose all that apply.)",
    "choice_a": "Telnet",
    "choice_b": "Simple Mail Transfer Protocol (SMTP)",
    "choice_c": "File Transfer Protocol (FTP)",
    "choice_d": "Domain Name System (DNS)",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "SMTP and DNS are both Application layer protocols, but neither one includes a character-based program. Both Telnet and FTP are protocols that include command-line client applications, with Telnet providing terminal emulation and FTP file transfer functionality.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      214,
      212,
      210,
      213,
      232
    ],
    "source": "9781394239306"
  },
  {
    "id": 1739,
    "question": "Which of the following statements about switches are true? (Choose all that apply.)",
    "choice_a": "Switches provide internal crossover circuits and use uplink ports to form a hierarchical star/hub and spoke topology.",
    "choice_b": "Switches are Data link layer devices that connect network devices in a star/hub and spoke topology.",
    "choice_c": "Switches amplify and repeat signals received through one port out all other ports regardless of the destination.",
    "choice_d": "Switches use IP addresses to identify the devices connected to specific ports.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Switches are Data link layer devices that amplify and repeat incoming signals only through the port to which the data is destined, not through all ports. Switches typically provide an internal crossover circuit connection, and uplink ports are sometimes used to extend the distance of a star/hub and spoke network, forming a hierarchical star. Switches are used to physically connect end systems to a star/hub and spoke topology. Switches use MAC addresses, not IP addresses, to identify the devices connected to specific ports.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      178,
      153,
      53,
      71,
      66
    ],
    "source": "9781394239306"
  },
  {
    "id": 1740,
    "question": "You are planning an automated operating system deployment for 100 new Windows workstations your company has received. You intend to configure the workstations to boot using Preboot Execution Environment (PXE), during which time the system will obtain an IP address from a Dynamic Host Configuration Protocol (DHCP) server and then download a boot image file from a Trivial File Transfer Protocol (TFTP) server. Which of the following well-known ports must you open on the firewall separating the workstations from the servers? (Choose all that apply.)",
    "choice_a": "64",
    "choice_b": "65",
    "choice_c": "66",
    "choice_d": "67",
    "correct_answer": [
      "D",
      "E",
      "F"
    ],
    "explanation": "DHCP servers use well-known port numbers 67 and 68. TFTP uses port number 69. Neither protocol uses port 64, 65, or 66.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      78,
      75,
      73,
      77,
      83
    ],
    "source": "9781394239306",
    "choice_e": "68",
    "choice_f": "69"
  },
  {
    "id": 1741,
    "question": "Your department is experiencing frequent delays as users wait for images to render using their outdated graphics software package. As a result, you submitted a change request for a new software product at the monthly meeting of the company's change management team. Now that the change request has been approved, it is time to implement the change. Which of the following administrative tasks will most likely be the change management team's responsibility during the implementation process? (Choose all that apply.)",
    "choice_a": "Notifying users",
    "choice_b": "Documenting all modifications made",
    "choice_c": "Authorizing downtime",
    "choice_d": "Designating a maintenance window",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The change management team is usually not responsible for tasks directly involved in the implementation of the changes they approve. Therefore, they would not be the ones to notify users exactly when the change will take place or document the procedure afterward. They would, however, be responsible for providing a maintenance window, during which the change must occur, and authorizing any downtime that would be needed.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      291,
      302,
      292,
      281,
      296
    ],
    "source": "9781394239306"
  },
  {
    "id": 1742,
    "question": "You are installing a new server that is equipped with two power supplies. The server's firmware enables you to set the mode in which the power supplies will be used. In which of the following modes must the dual power supplies be running in order for the system to be fault tolerant?",
    "choice_a": "Individual mode",
    "choice_b": "Combined mode",
    "choice_c": "Redundant mode",
    "choice_d": "Hot backup mode",
    "correct_answer": "C",
    "explanation": "A server with dual power supplies can run in one of two modes: redundant or combined. In redundant mode, each of the power supplies is capable of providing 100 percent of the power needed by the server. Therefore, the server can continue to run if one power supply fails, making it fault tolerant. In combined mode, both power supplies are needed to provide the server's needs, so a failure of one power supply will bring the server down. Individual mode and hot backup mode are not terms used for this purpose.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      399
    ],
    "source": "9781394239306"
  },
  {
    "id": 1743,
    "question": "The Domain Name System (DNS) defines a hierarchical name space, in which locations are reflected in fully qualified domain names (FQDNs). Which of the words in the FQDN <a href=\"http://www.paris.mydomain.org\"><code>www.paris.mydomain.org</code></a> represents the bottommost layer in the DNS namespace's domain hierarchy?",
    "choice_a": "www",
    "choice_b": "paris",
    "choice_c": "mydomain",
    "choice_d": "org",
    "correct_answer": "B",
    "explanation": "The word <code>paris</code> is the name of the bottommost domain in the given FQDN. <code>Paris</code> is a subdomain within <code>mydomain</code>, and <code>mydomain</code> is a second-level domain registered by a particular organization. The topmost layer in the DNS hierarchy is represented by <code>org</code>, which is a top-level domain. In this FQDN, <code>www</code> is not the name of a domain; it is the name of a particular host in the <a href=\"http://paris.mydomain.org\"><code>paris.mydomain.org</code></a> domain.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      383,
      405
    ],
    "source": "9781394239306"
  },
  {
    "id": 1744,
    "question": "The term <i>datagram</i> is typically used by protocols offering connectionless delivery service. Which of the following protocols use the term <i>datagram</i> to describe the data transfer unit it creates? (Choose all that apply.)",
    "choice_a": "TCP",
    "choice_b": "IP",
    "choice_c": "UDP",
    "choice_d": "Ethernet",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The two main connectionless protocols in the TCP/IP suite are the Internet Protocol (IP) and the User Datagram Protocol (UDP), both of which use the term <i>datagram</i> for their protocol data units. Ethernet uses the term <i>frame</i>, and Transmission Control Protocol (TCP) uses the term <i>segment</i>.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      121,
      119,
      54,
      71
    ],
    "source": "9781394239306"
  },
  {
    "id": 1745,
    "question": "Which element of the CIA triad prevents unauthorized viewing of protected data?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Availability",
    "choice_d": "None of the above",
    "correct_answer": "A",
    "explanation": "The confidentiality element of the CIA triad prevents data from being viewed by unauthorized users. Integrity is protection against unauthorized modification of data. Availability provides users with access to the data they need.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      317,
      334,
      325,
      348,
      326
    ],
    "source": "9781394239306"
  },
  {
    "id": 1746,
    "question": "You have just received notification of a new software release for an application you are running on your servers. The release is intended to address a newly discovered security vulnerability. Which of the following is the correct term for a software release containing a fix designed to address one specific issue?",
    "choice_a": "An upgrade",
    "choice_b": "A patch",
    "choice_c": "A service pack",
    "choice_d": "An update",
    "correct_answer": "B",
    "explanation": "A patch is a relatively small update that is designed to address a specific issue, often a security exploit or vulnerability. Patches do not add features or new capabilities; they are fixes targeted at a specific area of the operating system. Updates, upgrades, and service packs are larger packages that might include new features and/or many different fixes.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      5
    ],
    "source": "9781394239306"
  },
  {
    "id": 1747,
    "question": "Twisted-pair cables consist of multiple pairs of wires within a sheath, with each pair of wires twisted together separately. Which of the following statements best explain the reason for the twists in twisted-pair cabling? (Choose all that apply.)",
    "choice_a": "The twists help to prevent crosstalk in adjacent wire pairs.",
    "choice_b": "The twists make it easier for installers to attach connectors to the cable ends.",
    "choice_c": "The twists extend the cable's bend radius allowance, making it easier to install.",
    "choice_d": "The twists limit the effects of electromagnetic interference (EMI) on the signals carried over the cable.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "The twisted wire pairs inside twisted-pair cable prevent the signals on the different wires from interfering with each other (which is called crosstalk). The twists also provide resistance to outside electromagnetic interference (EMI). The twists have no effect on collisions. The twists do nothing to facilitate the attachment of connectors. Twists have nothing to do with the bend radius allowance for the cable.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      222,
      218,
      255,
      231,
      226
    ],
    "source": "9781394239306",
    "choice_e": "The twists help to prevent data collisions from occurring."
  },
  {
    "id": 1748,
    "question": "The figure shown here lists the processes currently running on a Linux workstation. Which of the following performance monitoring tools, provided in Linux and Unix operating systems, enables you to display information about processes that are currently running on a system? <img src=\"/question_assets/Network+/c07uf002.png\"/>",
    "choice_a": "netstat",
    "choice_b": "dig",
    "choice_c": "perfmon",
    "choice_d": "top",
    "correct_answer": "D",
    "explanation": "The <code>top</code> utility displays performance information about the currently running processes on a Unix/Linux system. The other options are tools that do not display running processes. <code>Netstat</code> is a tool that enables you to view active network connections and TCP/IP traffic statistics; it does not measure system performance. The <code>dig</code> tool generates Domain Name System (DNS) queries. <code>Perfmon</code> is a Windows performance monitoring tool; there is no Unix/Linux tool by that name.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      112,
      3,
      72,
      18,
      82
    ],
    "source": "9781394239306"
  },
  {
    "id": 1749,
    "question": "You are contracting with a provider to obtain email services for the clients on your network, using their existing email servers in the public cloud. You do not need anything from the provider other than email. Which of the following service models will you be using?",
    "choice_a": "PaaS",
    "choice_b": "SaaS",
    "choice_c": "IaaS",
    "choice_d": "All of the above",
    "correct_answer": "B",
    "explanation": "The software as a service (SaaS) model provides consumers with access to a specific application, such as email, running on the provider's servers. Infrastructure as a service (IaaS) provides the consumers with processing, storage, and networking resources that they can use to install and run operating systems and other software of their choice. Platform as a service (PaaS) provides consumers with the ability to install applications of their choice on a server installed by the provider.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      284,
      301,
      302,
      288,
      282
    ],
    "source": "9781394239306"
  },
  {
    "id": 1750,
    "question": "Security information and event management (SIEM) is a combination tool that uses information gathered from logs and network devices to provide a real-time analysis of the network's security condition. Which of the following SIEM processes performs searches for specific criteria, during specific time frames, in logs located on different computers?",
    "choice_a": "Data aggregation",
    "choice_b": "Correlation",
    "choice_c": "Retention",
    "choice_d": "Forensic analysis",
    "correct_answer": "D",
    "explanation": "In SIEM, forensic analysis is a process of searching logs on multiple computers for specific information based on set criteria and time periods. The other three options specify other SIEM functions. Data aggregation is a process of consolidating log information from multiple sources. Correlation is the process of linking logged events with common attributes together. Retention is the long-term storage of log data.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      201,
      206,
      197,
      65,
      169
    ],
    "source": "9781394239306"
  },
  {
    "id": 1751,
    "question": "When you start a Dynamic Host Configuration Protocol (DHCP) client, it transmits DHCPDISCOVER messages to locate and initiate contact with DHCP servers. Which of the following types of transmissions does the client use for this purpose?",
    "choice_a": "Broadcast",
    "choice_b": "Unicast",
    "choice_c": "Multicast",
    "choice_d": "Anycast",
    "correct_answer": "A",
    "explanation": "DHCP clients use broadcasts to transmit DHCPDISCOVER messages on the local network. DHCP servers are then required to respond to the broadcasts. DHCP clients cannot use unicast, multicast, or anycast messages to initiate contact with DHCP servers, because the clients have no way of learning the addresses of the DHCP servers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      75,
      88,
      36,
      101,
      147
    ],
    "source": "9781394239306"
  },
  {
    "id": 1752,
    "question": "Which of the following technologies enables virtual private network (VPN) users to establish a connection using only a web browser?",
    "choice_a": "VPN concentrator",
    "choice_b": "DMVPN",
    "choice_c": "SIP trunk",
    "choice_d": "MPLS",
    "correct_answer": "E",
    "explanation": "VPN typically enables remote users to connect to a VPN router at a central site, much like the star/hub and spoke topology of a local area network, in which computers are all connected to a central switch. A clientless VPN creates an encrypted tunnel to a server using a browser, without the need to install additional client software. Dynamic multipoint virtual private network (DMVPN) is a technology that creates a mesh topology between the remote VPN sites, enabling the remote sites to connect directly to each other, rather than to the central VPN server. A virtual private network (VPN) concentrator is a type of router that enables multiple client systems to access a network from remote locations. A Session Initiation Protocol (SIP) trunk provides a connection between the private and public domains of a unified communications network. Multiprotocol Label Switching (MPLS) is a data transfer mechanism that assigns labels to individual packets, and then routes the packets based on those labels.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      209,
      208,
      211,
      210,
      212
    ],
    "source": "9781394239306",
    "choice_e": "Clientless VPN"
  },
  {
    "id": 1753,
    "question": "You are installing a wireless network in a site that has many 2.4 GHz wireless telephones. Which of the following wireless networking technologies can you use that will never experience interference from the telephones? (Choose all that apply.)",
    "choice_a": "IEEE 802.11b",
    "choice_b": "IEEE 802.11g",
    "choice_c": "IEEE 802.11ac",
    "choice_d": "IEEE 802.11a",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "IEEE 802.11b, 802.11g, and 802.11n networks all can use the 2.4 GHz frequency band for their transmissions, which can experience interference from a wireless telephone using the same frequency. IEEE 802.11a and IEEE 802.11ac, however, use the 5 GHz band, which will not experience interference from a 2.4 GHz phone.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      405,
      385,
      397,
      374,
      400
    ],
    "source": "9781394239306",
    "choice_e": "IEEE 802.11n"
  },
  {
    "id": 1754,
    "question": "Which of the following is another term for a switch?",
    "choice_a": "Multicast hub",
    "choice_b": "Multiport repeater",
    "choice_c": "Multiport bridge",
    "choice_d": "Multihomed router",
    "correct_answer": "C",
    "explanation": "A switch is a Data link layer device that essentially performs the function of a bridge for each device connected to one of its ports. Therefore, it can be described as a multiport bridge. Multiport repeater is another term for a hub, and multihomed router is a redundancy, as all routers are by definition multihomed\u2014that is, connected to multiple networks. There is no such device as a multicast hub.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      224,
      251,
      255,
      257,
      279
    ],
    "source": "9781394239306"
  },
  {
    "id": 1755,
    "question": "You are working at a client site with a managed router that includes a console port for administrative access, which you can use to connect a laptop and run a terminal program to access the device's interface. Which of the following is the best term for this type of access to the device?",
    "choice_a": "Client-to-site",
    "choice_b": "In-band",
    "choice_c": "BYOD",
    "choice_d": "Out-of-band",
    "correct_answer": "D",
    "explanation": "The term <i>out-of-band</i> describes any type of management access to a device that does not go through the production network. Plugging a laptop into the console port avoids the network, so it is considered to be an example of out-of-band management. In-band management describes an access method that does go through the production network. Client-to-site is a type of VPN connection, and bring your own device (BYOD) is a policy defining whether and how users are permitted to connect their personal devices to the network.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      392,
      377,
      370,
      393,
      404
    ],
    "source": "9781394239306"
  },
  {
    "id": 1756,
    "question": "Which of the following describes the primary difference between single sign-on (SSO) and same sign-on?",
    "choice_a": "Single sign-on (SSO) credentials consist of one username and one password, whereas same sign-on credentials consist of one username and multiple passwords.",
    "choice_b": "Single sign-on (SSO) requires the user to supply credentials only once, whereas with same sign-on, the user must supply the credentials repeatedly.",
    "choice_c": "Single sign-on (SSO) requires multifactor authentication, such as a password and a smartcard, whereas same sign-on requires only a password for authentication.",
    "choice_d": "Single sign-on (SSO) enables users to access different resources with one set of credentials, whereas same sign-on requires users to have multiple credential sets.",
    "correct_answer": "B",
    "explanation": "Single sign-on (SSO) uses one set of credentials and requires the user to supply them only once to gain access to multiple resources. Same sign-on also uses a single set of credentials, with one password, but the user must perform individual logons for each resource. Neither single sign-on nor same sign-on calls for multifactor authentication.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      373,
      377,
      371,
      372,
      376
    ],
    "source": "9781394239306"
  },
  {
    "id": 1757,
    "question": "You have a laptop that requires you to hold your finger on a scanner pad before you can use it. A device equipped with a fingerprint scanner that is part of a multifactor authentication mechanism is using which of the following types of technology?",
    "choice_a": "Tamper detection",
    "choice_b": "Biometrics",
    "choice_c": "Hand geometry",
    "choice_d": "Pattern recognition",
    "correct_answer": "B",
    "explanation": "The technology that uses human physical characteristics to authenticate users is called biometrics. Biometric devices can identify users based on fingerprints, retinal patterns, voice prints, and other characteristics.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      325,
      328,
      317,
      342,
      334
    ],
    "source": "9781394239306"
  },
  {
    "id": 1758,
    "question": "You have been asked to locate the computers on a network that the previous consultant has configured with incorrect IPv6 addresses. Which of the following are not correctly formatted IPv6 addresses? (Choose all that apply.)",
    "choice_a": "fe00::c955:c944:acdd:3fcb",
    "choice_b": "fe00::b491:cf79:p493:23ff",
    "choice_c": "2001:0:44ef68:23eb:99fe:72bec6:ea5f",
    "choice_d": "2001:0:49e6:39ff:8cf5:6812:ef56",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Option B contains a <i>p</i>, which is a nonhexadecimal digit. Option C contains blocks larger than 16 bits. Option D contains only seven 16-bit blocks (and no double colon) instead of the eight required for a 128-bit IPv6 address. The address fe00::c955:c944:acdd:3fcb in Option A is correctly formatted for IPv6, with the double colon replacing three blocks of zeroes. Uncompressed, the address would appear as follows: fe00:0000:0000:0000:c955:c944:acdd:3fcb.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      405,
      401,
      398,
      395,
      384
    ],
    "source": "9781394239306"
  },
  {
    "id": 1759,
    "question": "During a physical security evaluation by an outside contractor, you are asked whether your company uses a fail open or fail closed policy for the datacenter. You do not know what the contractor means. Which of the following physical security mechanisms can either fail close or fail open?",
    "choice_a": "Door locks",
    "choice_b": "Motion detectors",
    "choice_c": "Honeypots",
    "choice_d": "Video cameras",
    "correct_answer": "A",
    "explanation": "The terms <i>fail close</i> and <i>fail open</i> refer to the default position of an electric or electronic door lock when there is a power failure. Physical security is often a trade-off with safety, and in the event that an emergency occurs that results in a power outage, whether secured doors are permanently locked or left permanently open is a critical factor. The terms <i>fail closed</i> and <i>fail open</i> do not apply to motion detectors or video cameras. A honeypot is a computer, application, or website configured to lure potential attackers; it is not a physical security mechanism.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      175,
      174,
      179,
      51
    ],
    "source": "9781394239306"
  },
  {
    "id": 1760,
    "question": "A disgruntled senior associate in the IT department at your company was terminated today and had to be escorted from the building. The IT director has instructed you to disable all of the former employee's accounts, change all network device passwords to which the employee had access, and have the datacenter door locks rekeyed. Which of the following terms best describes the director's concern in asking you to do these things?",
    "choice_a": "Logic bombs",
    "choice_b": "Internal threats",
    "choice_c": "Rogue devices",
    "choice_d": "Social engineering",
    "correct_answer": "B",
    "explanation": "The IT director's concern is that the disgruntled senior associate might take advantage of his access to devices and facilities to sabotage the network. When an individual takes advantage of information gathered during their employment, it is called an internal (or insider) threat. An external threat is one originating from a non-employee. Social engineering is a form of attack in which an innocent user is persuaded by an attacker to provide sensitive information via email or telephone. A logic bomb is a code insert placed into a legitimate software product that triggers a malicious event when specific conditions are met. Rogue devices are unauthorized components, such as wireless access points or DHCP servers, planted on a network with nefarious intent.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      363,
      376,
      388,
      403,
      392
    ],
    "source": "9781394239306",
    "choice_e": "External threats"
  },
  {
    "id": 1761,
    "question": "Ralph is troubleshooting a Windows server, and while doing so he runs the following command: <code>ping 127.0.0.1</code>. The command completes successfully. What has Ralph proven by doing this?",
    "choice_a": "That the computer's network adapter is functioning properly",
    "choice_b": "That the computer's IP address is correct for the network",
    "choice_c": "That the computer's TCP/IP networking stack is loaded and functioning properly",
    "choice_d": "Nothing at all",
    "correct_answer": "C",
    "explanation": "The IP address 127.0.0.1 is a dedicated loopback address that directs outgoing IP traffic directly into the incoming IP traffic buffer. A successful ping test using that address indicates that the computer's TCP/IP stack is functioning properly, but the traffic never reaches the network adapter or the network, so the test does not confirm that the adapter is functioning or that the computer has a correct IP address for the network.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      111,
      112,
      79,
      84,
      99
    ],
    "source": "9781394239306"
  },
  {
    "id": 1762,
    "question": "Which of the following are not examples of multifactor authentication (MFA)? (Choose all that apply.)",
    "choice_a": "A system that requires a smartcard and a PIN for authentication",
    "choice_b": "A system that uses an external RADIUS server for authentication",
    "choice_c": "A system that requires two passwords for authentication",
    "choice_d": "A system that requires a password and a retinal scan for authentication",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Multifactor authentication (MFA) combines two or more authentication methods and reduces the likelihood that an intruder would be able to successfully impersonate a user during the authentication process. A password and a retinal scan is an example of a multifactor authentication system. A smartcard and a PIN, which is the equivalent of a password, is an example of multifactor authentication because it requires users to supply something they know and something they have. Multifactor authentication refers to the proofs of identity a system requires, not the number of servers used to implement the system. Therefore, the use of a RADIUS server does not make for an example of multifactor authentication. A system that requires two passwords is not an example of multifactor authentication, because an attacker can compromise two passwords as easily as one. A multifactor authentication system requires two different forms of authentication.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      53
    ],
    "source": "9781394239306"
  },
  {
    "id": 1763,
    "question": "A user calls Ed at the help desk to report that he cannot access the Internet. He can access systems on the local network, however. Ed examines the routing table on the user's workstation and sees the following. Which of the following statements explains why the user cannot access the Internet? <img src=\"/question_assets/Network+/pt_c7_33.png\"/>",
    "choice_a": "The routing table does not specify a loopback address.",
    "choice_b": "The routing table does not specify a DNS server address.",
    "choice_c": "The routing table does not specify a default gateway address.",
    "choice_d": "The routing table contains two different routes to the 224.0.0.0 network.",
    "correct_answer": "C",
    "explanation": "To access the Internet, the workstation's routing table must include a default gateway entry, which would have a Network Destination value of 0.0.0.0. A workstation's routing table does not have to specify the address of a DNS server. The loopback (127.0.0.1) and multicast (224.0.0.0) addresses are normal routing table entries that do not affect Internet access.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      119,
      121,
      128,
      124,
      129
    ],
    "source": "9781394239306"
  },
  {
    "id": 1764,
    "question": "Which of the following statements about single-mode fiber-optic cable are true? (Choose all that apply.)",
    "choice_a": "Multimode cables use an LED light source, while single-mode cables use a laser.",
    "choice_b": "Multimode cables can span longer distances than single-mode cables.",
    "choice_c": "Multimode cables have a smaller core filament than single-mode cables.",
    "choice_d": "Multimode cables have a smaller bend radius than single-mode, making them easier to install.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Multimode cables use an LED light source and have a smaller bend radius than single-mode cables. Single-mode cables have a smaller core filament and can span longer distances than multimode cables. Fiber-optic cables are not conductors of electricity, so they do not require a ground.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      28,
      46,
      29,
      25,
      26
    ],
    "source": "9781394239306",
    "choice_e": "Multimode fiber-optic cables require a ground, whereas single-mode cables do not."
  },
  {
    "id": 1765,
    "question": "A user swipes a smartcard through the reader connected to a laptop and then types a password to log on to the system. Which of the following actions is the user performing?",
    "choice_a": "Auditing",
    "choice_b": "Accounting",
    "choice_c": "Authorization",
    "choice_d": "Authentication",
    "correct_answer": "D",
    "explanation": "Authentication is the process of confirming a user's identity. Smartcards and passwords are two of the authentication factors commonly used by network devices. Authorization defines the type of access granted to authenticated users. Accounting and auditing are both methods of tracking and recording a user's activities on a network, such as when a user logged on and how long they remained connected.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      119,
      121,
      153,
      161,
      162
    ],
    "source": "9781394239306"
  },
  {
    "id": 1766,
    "question": "Which of the following cabling topologies have never been used by standard Ethernet networks? (Choose all that apply.)",
    "choice_a": "Bus",
    "choice_b": "Ring",
    "choice_c": "Star/hub and spoke",
    "choice_d": "Mesh",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Ethernet has never used a ring or mesh topology. The first Ethernet networks used a Physical layer implementation commonly known as Thick Ethernet or 10Base5. The network used coaxial cable in a bus topology. Later Ethernet standards use twisted-pair or fiber-optic cables in a star/hub and spoke topology.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      70,
      52,
      150,
      71,
      166
    ],
    "source": "9781394239306"
  },
  {
    "id": 1767,
    "question": "Pulling into your company parking lot at lunchtime, you notice a person without a company parking sticker on his car working at a laptop. You have seen this more than once, and you begin to suspect that unauthorized users are connecting to the company's wireless access point and gaining access to the network. Which of the following are steps you can take to prevent this from happening in the future? (Choose all that apply.)",
    "choice_a": "Use RADIUS for authentication.",
    "choice_b": "Place the access point in a screened subnet.",
    "choice_c": "Disable SSID broadcasting.",
    "choice_d": "Implement MAC address filtering.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Disabling SSID broadcasting prevents a wireless network from appearing to clients. The clients must specify the SSID to which they want to connect. MAC address filtering is a form of access control list (ACL) that is maintained in the access point and that contains the addresses of devices that are to be permitted to access the network. Both of these mechanisms make it more difficult for unauthorized devices to connect to the access point. The other two options will not help to prevent unauthorized access. Remote Authentication Dial-In User Service (RADIUS) is a server that can provide authentication, authorization, and accounting services for remote access servers. Relocating the access point to a screened subnet (or perimeter network) will not resolve the problem.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      206,
      196,
      169,
      200,
      188
    ],
    "source": "9781394239306"
  },
  {
    "id": 1768,
    "question": "Which of the following is a fault tolerance mechanism for the default gateway on a specific TCP/IP LAN?",
    "choice_a": "Open Shortest Path First (OSPF)",
    "choice_b": "First Hop Redundancy Protocol (FHRP)",
    "choice_c": "Spanning Tree Protocol (STP)",
    "choice_d": "Network address translation (NAT)",
    "correct_answer": "B",
    "explanation": "First Hop Redundancy Protocol (FHRP) is a fault tolerance mechanism that enables other routers on a LAN to use the IP address of the network's designated default gateway router in the event that the default router should fail. The other three options do not provide default gateway fault tolerance. Open Shortest Path First (OSPF) is a routing protocol. Spanning Tree Protocol (STP) protects the network against switching loops. Network address translation (NAT) is a routing technology that enables hosts with private IP addresses to access the Internet using a shared public IP address.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      264,
      145,
      274,
      275,
      119
    ],
    "source": "9781394239306"
  },
  {
    "id": 1769,
    "question": "Multiprotocol switches are devices that perform functions associated with two different layers of the Open Systems Interconnection (OSI) reference model. Which of the following layers are often associated with network switching? (Choose all that apply.)",
    "choice_a": "Application",
    "choice_b": "Presentation",
    "choice_c": "Session",
    "choice_d": "Transport",
    "correct_answer": [
      "E",
      "F"
    ],
    "explanation": "The primary function of a network switch is to process packets based on their media access control (MAC) addresses, which makes it a Data link layer device. However, multiprotocol switches are devices that can also perform routing functions based on IP addresses, which operate at the Network layer. Switches are not typically associated directly with the other layers of the OSI model.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      395,
      398,
      394,
      397,
      396
    ],
    "source": "9781394239306",
    "choice_e": "Network",
    "choice_f": "Data link",
    "choice_g": "Physical"
  },
  {
    "id": 1770,
    "question": "You are attempting to connect your new laptop to your company's wireless network. The wireless access point on the network has an SSID that is not broadcasted and uses WPA3 for security. Which of the following describes what you must do to connect your laptop to the network?",
    "choice_a": "Select the SSID from a list and allow the client to automatically detect the security protocol.",
    "choice_b": "Type the SSID manually and then select WPA3 from the security protocol options provided.",
    "choice_c": "Type the SSID manually and allow the client to automatically detect the security protocol.",
    "choice_d": "Select the SSID from a list and then select WPA3 from the security protocol options provided.",
    "correct_answer": "B",
    "explanation": "An SSID that is not being broadcasted does not appear in the list of available networks, so you must type it in manually. Security protocols are also not detectable, so you must select the WPA3 protocol from the list of options provided on the laptop.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      203,
      205,
      17,
      18,
      1
    ],
    "source": "9781394239306"
  },
  {
    "id": 1771,
    "question": "Carrier Sense Multiple Access with Collision Avoidance (CSMA/CA) is a media access control mechanism designed to prevent two systems using the same network medium from transmitting at the same time. Which of the following IEEE standards calls for the use of CSMA/CA?",
    "choice_a": "802.3",
    "choice_b": "802.1X",
    "choice_c": "802.11ac",
    "choice_d": "All of the above",
    "correct_answer": "C",
    "explanation": "The IEEE 802.11ac standard, like all of the wireless LAN standards in the 802.11 working group, uses CSMA/CA for media access control. The 802.1X standard defines an authentication mechanism and does not require a media access control mechanism. The IEEE 802.3 (Ethernet) standard uses a different mechanism for media access control: Carrier Sense Multiple Access with Collision Detection (CSMA/CD).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      398,
      397,
      394,
      395,
      392
    ],
    "source": "9781394239306"
  },
  {
    "id": 1772,
    "question": "A large enterprise network will\u2014at a minimum\u2014have demarcation points for telephone services and a connection to an Internet service provider's network. In many cases, these services will enter the building in the same equipment room that houses the backbone switch. Which of the following is the term used to describe this wiring nexus?",
    "choice_a": "MTBF",
    "choice_b": "IDF",
    "choice_c": "RDP",
    "choice_d": "MDF",
    "correct_answer": "D",
    "explanation": "The place containing the demarcation points and the backbone switch is called the main distribution frame (MDF). An intermediate distribution frame (IDF) is the location of localized telecommunications equipment such as the interface between the horizontal cabling and the backbone. Mean time between failures (MTBF) and Remote Desktop Protocol (RDP) are not network wiring locations.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      35,
      12,
      15,
      32,
      33
    ],
    "source": "9781394239306"
  },
  {
    "id": 1773,
    "question": "You have configured your company's wireless network to enable a client to authenticate only when the signal strength of their connection exceeds a specified level. Which of the following terms best describes the security mechanism provided by this configuration?",
    "choice_a": "Geofencing",
    "choice_b": "Local authentication",
    "choice_c": "Motion detection",
    "choice_d": "Port security",
    "correct_answer": "A",
    "explanation": "Geofencing is the generic term for a technology that limits access to a network or other resource based on the client's location. In wireless networking, geofencing is intended to prevent unauthorized clients outside the facility from connecting to the network. By allowing only users with strong signals to connect, you help to prevent access to outside users. Local authentication is an application or service that triggers an authentication request to which the user must respond before access is granted. Port security is a method for protecting access to switch ports. Motion detection is a system designed to trigger a notification or alarm when an individual trespasses in a protected area. None of these other options are related to signal strength.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      193,
      200,
      196,
      206,
      188
    ],
    "source": "9781394239306"
  },
  {
    "id": 1774,
    "question": "Social engineering has become an increasingly serious problem on your company network. Which of the following is an effective method for preventing sensitive data from being compromised through social engineering?",
    "choice_a": "Install a firewall between the internal network and the Internet.",
    "choice_b": "Install an antivirus software product on all user workstations.",
    "choice_c": "Implement a program of user education and corporate policies.",
    "choice_d": "Use IPsec to encrypt all network traffic.",
    "correct_answer": "C",
    "explanation": "Social engineering is the practice of obtaining sensitive data by contacting users and pretending to be someone with a legitimate need for that data. No software or hardware solution can prevent it; the only way is to educate users of the potential dangers and establish policies that inform users what to do when they experience a social engineering attempt. Social engineering is not a virus or other form of malware, so an antivirus product has no effect against it. Social engineering is not implemented in network traffic, so a firewall cannot filter it and IPsec cannot protect against it.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      202,
      18,
      300,
      281,
      282
    ],
    "source": "9781394239306"
  },
  {
    "id": 1775,
    "question": "You have been given a Class B network IP address with which to configure the new network you are designing. Which of the following is the default subnet mask you should use for an IPv4 Class B network?",
    "choice_a": "255.255.255.255",
    "choice_b": "255.255.255.0",
    "choice_c": "255.255.0.0",
    "choice_d": "255.0.0.0",
    "correct_answer": "C",
    "explanation": "A Class B address uses the first two octets as the network identifier, which yields a binary subnet mask of 11111111 11111111 00000000 00000000. In decimal form, the subnet mask is 255.255.0.0. The 255.0.0.0 mask is for Class A addresses, and the 255.255.255.0 mask is for Class C addresses. 255.255.255.255 is the broadcast address for the current network.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      58,
      98,
      255,
      255
    ],
    "source": "9781394239306"
  },
  {
    "id": 1776,
    "question": "Alice's company has just started working with sensitive government data. To enhance the security of the datacenter, she has implemented some additional security measures. All the servers now have crimped metal tags holding the cases closed. All the hardware racks are locked in clear-fronted cabinets. All the cable runs are installed in transparent conduits. These are all examples of which of the following physical security measures?",
    "choice_a": "Geofencing",
    "choice_b": "Tamper detection",
    "choice_c": "Port security",
    "choice_d": "Asset tracking",
    "correct_answer": "B",
    "explanation": "All the mechanisms that Alice has implemented are designed to make any attempts to tamper with or physically compromise the network hardware devices immediately evident. Therefore, this is a form of tamper detection. Asset tracking is for locating and identifying specific hardware components. Geofencing is a wireless networking technique for limiting access to a network based on signal strength. Port security refers to the protection of network switch ports from unauthorized access.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      404,
      403,
      402,
      392,
      389
    ],
    "source": "9781394239306"
  },
  {
    "id": 1777,
    "question": "You have just installed a web server for your company that is configured to host a public Internet site using the registered domain name <a href=\"http://www.adatum.com\">adatum.com</a>. The server's hostname in the Domain Name System (DNS) is <code>www</code>. The web server also has an administrative site, which you want to be able to access remotely. You have configured the administrative site to be encrypted and to use the port number 12354. Which of the following URLs must you use to access the administrative website from the Internet?",
    "choice_a": "www.adatum.com:12354",
    "choice_b": "www.adatum.com",
    "choice_c": "www.adatum.com:80",
    "choice_d": "www.adatum.com:12354",
    "correct_answer": "A",
    "explanation": "Because the administrative site is encrypted, you must use the HTTPS:// prefix to access it. Because the administrative site uses the nondefault port number 12354, you must append that number to the server name after a colon.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      368,
      369,
      367,
      393,
      375
    ],
    "source": "9781394239306"
  },
  {
    "id": 1778,
    "question": "To prevent outside users from accessing your wireless network, you configure the access point not to broadcast the network's SSID. However, you later discover that outsiders are still accessing the network. For which of the following reasons is disabling SSID broadcasts a relatively weak method of device hardening?",
    "choice_a": "Every access point's SSID is printed on a label on the back of the device.",
    "choice_b": "Attackers have software that can easily guess a network's SSID.",
    "choice_c": "Attackers can capture packets transmitted over the network and read the SSID from them.",
    "choice_d": "Attackers have ways of connecting to the network without the SSID.",
    "correct_answer": "C",
    "explanation": "Disabling SSID broadcasts is a way of hiding the presence of a wireless network, but if an intruder knows that a network is there, it is a relatively simple matter to capture packets transmitted by the wireless devices and read the SSID from them. The other options do not explain the weakness of suppressing SSID broadcasts. It is not possible to connect to a wireless network without the SSID. SSIDs are set by the administrator of the access point; they are not printed on the device's label. SSIDs can be discovered relatively easily, but guessing them is no easier than guessing a password.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      392,
      405,
      385,
      364,
      367
    ],
    "source": "9781394239306"
  },
  {
    "id": 1779,
    "question": "You are installing a web server farm in your corporate headquarters that will be used to host websites for the corporation's subsidiaries, which are located all around the world. In which of the following cloud models does a single organization function as both the provider and the consumer of all cloud services?",
    "choice_a": "Private cloud",
    "choice_b": "Public cloud",
    "choice_c": "Ad hoc cloud",
    "choice_d": "Hybrid cloud",
    "correct_answer": "A",
    "explanation": "In a private cloud, the same organization that uses the cloud services is also the sole owner of the infrastructure that provides those services. In the public cloud model, one organization functions as the provider, and another organization consumes the services of the provider. A hybrid cloud is a combination of public and private infrastructure so that the consumer organization is only a partial owner of the infrastructure. There is no such thing as an ad hoc cloud model.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      373,
      369,
      375,
      370,
      381
    ],
    "source": "9781394239306"
  },
  {
    "id": 1780,
    "question": "Your supervisor has recently begun using the terms <i>on-boarding</i> and <i>off-boarding</i>, with which you are unfamiliar. With which of the following types of policies are these terms typically associated?",
    "choice_a": "Incident response",
    "choice_b": "Identity management",
    "choice_c": "Inventory management",
    "choice_d": "Data loss prevention",
    "correct_answer": "B",
    "explanation": "On-boarding and off-boarding are identity management processes in which users are added or removed from an organization's identity and access management (IAM) system. This grants new users the privileges they need to use the network, modifies their privileges if they change positions, and revokes privileges when they leave the company. On-boarding and off-boarding are not data loss prevention, incident response, or inventory management processes.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      291,
      302,
      295,
      296,
      281
    ],
    "source": "9781394239306"
  },
  {
    "id": 1781,
    "question": "Virtual private networks (VPNs) use a data transmission technique called tunneling, which encapsulates a data packet within another packet for transmission over a network connection, typically using the Internet. The system also encrypts the entire encapsulated data packet for protection. Split tunneling is a variation of this method that provides which of the following advantages? (Choose all that apply.)",
    "choice_a": "Additional data integrity protection",
    "choice_b": "Access to local network devices while connected to the VPN",
    "choice_c": "Faster data transmission through multiplexing",
    "choice_d": "Conservation of VPN bandwidth",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "A standard VPN typically uses full tunneling, in which all of the system's network traffic is encapsulated and encrypted for transmission. Split tunneling is a variation of this method in which only part of the system's traffic uses the VPN connection; the rest is transmitted over the network in the normal manner. Administrators can select which applications and devices use the VPN. Split tunneling can conserve the Internet bandwidth used by the VPN and provide access to local network services without the need for encapsulation. Split tunneling does not provide additional data integrity protection or improved performance through multiplexing.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      63,
      148,
      165,
      262,
      68
    ],
    "source": "9781394239306"
  },
  {
    "id": 1782,
    "question": "Your supervisor wants you to disable all of the ports on the network's switches that are not in use. You tell her that this is not necessary; she wants to know why you think so. Which of the following are valid reasons not to disable unused switch ports? (Choose all that apply.)",
    "choice_a": "The unused ports are not patched into wall jacks.",
    "choice_b": "The datacenter is already secured from unauthorized access.",
    "choice_c": "The switch is configured to use a MAC-based access control list.",
    "choice_d": "Leaving some ports enabled facilitates the on-boarding of new users.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "If there is no way for unauthorized people to access the datacenter, then there is no danger of someone plugging a device into a port that is left enabled. If the switch uses an access control list (ACL) that specifies the MAC addresses of systems permitted to connect to it, then there is no need to disable unused ports, because any unknown devices plugged into open ports will not be granted access to the network. The other two options are not valid reasons. Ports that are not patched in can still be compromised at the switch location. Enabling ports is not difficult for authorized administrators, so accommodating new users is not a valid reason for leaving the ports enabled.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      317,
      304,
      328,
      320,
      315
    ],
    "source": "9781394239306"
  },
  {
    "id": 1783,
    "question": "Which of the following are security mechanisms that fall into the category of deception technologies?",
    "choice_a": "Honeypots and honeynets",
    "choice_b": "Root guards",
    "choice_c": "Screened subnets",
    "choice_d": "Geofencing",
    "correct_answer": "A",
    "explanation": "A honeypot or honeynet is a computer or network configured to function as deceptive bait for potential attackers, causing them to waste their time and effort penetrating a resource that provides no significant access or advantage. The other three options are not deception technologies. A root guard provides protection to switch ports by affecting the behavior of the Spanning Tree Protocol (STP) to enforce the selection of root bridge ports on a switched network. A screened subnet (also called a perimeter network) is the part of a network where administrators locate servers that must be accessible from the Internet, such as email and web servers. Geofencing is a security mechanism that prevents unauthorized clients outside the facility from connecting to the network.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      325,
      328,
      348,
      317,
      327
    ],
    "source": "9781394239306"
  },
  {
    "id": 1784,
    "question": "Which of the following network devices can employ access control lists (ACLs) to restrict access? (Choose all that apply.)",
    "choice_a": "Routers",
    "choice_b": "Servers",
    "choice_c": "Switches",
    "choice_d": "Hubs",
    "correct_answer": [
      "A",
      "B",
      "C",
      "E"
    ],
    "explanation": "ACLs restrict access to network devices by filtering user names, MAC addresses, IP addresses, or other criteria. Routers, servers, switches, and wireless access points all can use ACLs to control access to them. Hubs are purely Physical layer devices that relay electrical or optical signals. They have no access control mechanisms.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      2,
      22,
      285,
      3,
      13
    ],
    "source": "9781394239306",
    "choice_e": "Wireless access points"
  },
  {
    "id": 1785,
    "question": "Which of the following terms is not associated with Data link layer communications?",
    "choice_a": "Administrative distance",
    "choice_b": "Spanning Tree Protocol",
    "choice_c": "Maximum transmission unit",
    "choice_d": "Jumbo frames",
    "correct_answer": "A",
    "explanation": "Administrative distance is a Network layer value that enables routers to select the most reliable routing protocol to use when multiple protocols supply routes to the same destination. The other three options are all associated with the Data link layer. Ethernet uses jumbo frames at the Data link layer to transfer large amounts of data more efficiently. The maximum transmission unit (MTU) value of a Data link layer frame specifies its maximum size. Switches use the Spanning Tree Protocol (STP) at the Data link layer to prevent redundant switches from causing traffic loops on the network. Ethernet typically restricts the size of Data link layer frames to 1,500 bytes, but jumbo frames enable Ethernet systems to create frames up to 9,000 bytes.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      21,
      43,
      22,
      81,
      135
    ],
    "source": "9781394239306"
  },
  {
    "id": 1786,
    "question": "Which of the following statements about DHCP snooping are true? (Choose all that apply.)",
    "choice_a": "DHCP snooping is implemented in network switches.",
    "choice_b": "DHCP snooping prevents DNS cache poisoning.",
    "choice_c": "DHCP snooping detects rogue DHCP servers.",
    "choice_d": "DHCP snooping drops DHCP messages arriving over the incorrect port.",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "DHCP snooping is a feature found in some network switches that prevents rogue DHCP servers from assigning IP addresses to clients. It can also detect when DHCP release or decline messages arrive over a port other than the one on which the DHCP transaction originated. Although DHCP snooping can prevent DHCP clients from being assigned an incorrect IP address, it does not directly prevent the poisoning of DNS server caches with erroneous information.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      316,
      317,
      324,
      321,
      313
    ],
    "source": "9781394239306"
  },
  {
    "id": 1787,
    "question": "A user reports that she cannot connect to a server on her network. You want to identify the scope of the problem, so you try to reproduce the problem on the user's computer. The problem persists. No other users are reporting the same problem. What is the next logical step that you should perform to identify the affected area?",
    "choice_a": "Examine the server's configuration for the correct settings.",
    "choice_b": "Verify that the local router is forwarding traffic.",
    "choice_c": "Confirm that the switch the client is connected to is functioning.",
    "choice_d": "Perform the same task on another computer connected to the same segment.",
    "correct_answer": "D",
    "explanation": "In this scenario, only one user is reporting a problem. Therefore, the likeliest next step is to perform the same task on another computer attached to the same segment. If you can perform the task successfully, the problem most likely lies within the user's computer or the connection to the switch. Since no other users are reporting the same problem, the server and switches on the network are probably up and functioning. Checking the router is not necessary, because the user and server are on the same network.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      376,
      370,
      374,
      397,
      398
    ],
    "source": "9781394239306"
  },
  {
    "id": 1788,
    "question": "On a wireless network, which of the following best describes an example of a captive portal?",
    "choice_a": "A web page stating that the data on a user's computer has been locked and will only be unlocked after payment of a fee",
    "choice_b": "A dedicated switch port used to connect to other switches",
    "choice_c": "A web page with which a user must interact before being granted access to a wireless network",
    "choice_d": "A series of two doors with an intervening airlock through which people must pass before they can enter a secured space",
    "correct_answer": "C",
    "explanation": "A captive portal is a web page displayed to a user attempting to access a public wireless network. The user typically must supply identification, submit credentials, provide payment, or accept an end-user agreement before access is granted. A captive portal does not refer to a switch port, a secured entryway to a room, or a type of extortionate computer attack.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      310,
      360,
      317,
      326,
      327
    ],
    "source": "9781394239306"
  },
  {
    "id": 1789,
    "question": "In the standard troubleshooting methodology, you begin by taking steps to identify the problem. After you have done this, which of the following steps should you perform next?",
    "choice_a": "Verify full system functionality.",
    "choice_b": "Establish a theory of probable cause.",
    "choice_c": "Establish a plan of action.",
    "choice_d": "Implement the solution.",
    "correct_answer": "B",
    "explanation": "After identifying the problem, the next step is to establish a theory for the probable cause of the problem. After that, you can test your theory, establish a plan of action, implement a solution, verify the functionality of the system, and document the entire process.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      322,
      311,
      318,
      312,
      304
    ],
    "source": "9781394239306"
  },
  {
    "id": 1790,
    "question": "The secured version of the Hypertext Transfer Protocol (HTTPS) uses a different well-known port from the unsecured version (HTTP). Which of the following ports are used by HTTP and HTTPS by default? (Choose all that apply.)",
    "choice_a": "25",
    "choice_b": "80",
    "choice_c": "110",
    "choice_d": "443",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "The well-known port for HTTPS is 443. The port for unsecured HTTP is 80. Neither of the other options are ports used by HTTP or HTTPS by default. Port 25 is used for the Simple Mail Transfer Protocol (SMTP), and port 110 is used for the Post Office Protocol (POP3).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      129,
      126,
      54,
      71
    ],
    "source": "9781394239306"
  },
  {
    "id": 1791,
    "question": "Which of the following are criteria typically used by load balancers to direct incoming traffic to one server out of a group of servers? (Choose all that apply.)",
    "choice_a": "Fastest response time",
    "choice_b": "Fastest processor",
    "choice_c": "Lightest load",
    "choice_d": "The next in an even rotation",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "A load balancing router typically works by processing incoming traffic based on rules set by an administrator. The rules can distribute traffic among a group of servers using various criteria, such as each server's current load or response time or which server is next in a given rotation. Load balancers generally do not use the hardware configuration of the servers to direct traffic, as this is a factor that does not change over time.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      396,
      394,
      382,
      401,
      399
    ],
    "source": "9781394239306"
  },
  {
    "id": 1792,
    "question": "You are responsible for a network that has a Domain Name System (DNS) server, a proxy server, and an Internet router. A user is reporting that she cannot connect to hosts on her own local area network (LAN) or other internal LANs, and she also cannot access hosts on the Internet. No one else has reported a problem. What is the most likely location of the issue preventing the user's access to the network?",
    "choice_a": "The router",
    "choice_b": "The DNS server",
    "choice_c": "The proxy server",
    "choice_d": "The user's computer configuration",
    "correct_answer": "D",
    "explanation": "Since only one user is reporting difficulty, the problem is most likely to be in the user's computer and its configuration. A DNS server, proxy server, or router problem would affect more than one user.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      128,
      54,
      68,
      126
    ],
    "source": "9781394239306"
  },
  {
    "id": 1793,
    "question": "Virtual LAN (VLAN) hopping is a type of attack directed at network switches. Which of the following best describes how VLAN hopping is a potential threat?",
    "choice_a": "VLAN hopping enables an attacker to access different VLANs using 802.1q spoofing.",
    "choice_b": "VLAN hopping enables an attacker to scramble a switch's patch panel connections.",
    "choice_c": "VLAN hopping enables an attacker to change the native VLAN on a switch.",
    "choice_d": "VLAN hopping enables an attacker to rename the default VLAN on a switch.",
    "correct_answer": "A",
    "explanation": "VLAN hopping is a method for sending false commands to switches to transfer a port from one VLAN to another. This can enable the attacker to connect his or her device to a potentially sensitive VLAN. VLAN hopping does not modify the switch's patch panel connections, only its VLAN assignments. It is not possible to rename a switch's default VLAN. VLAN hopping does not enable an attacker to change a switch's native VLAN.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      2,
      17,
      101,
      10,
      44
    ],
    "source": "9781394239306"
  },
  {
    "id": 1794,
    "question": "You are a first-tier support technician working the IT help desk at your company. In your first hour of duty, you receive four trouble calls. Your job is to prioritize the calls based on their severity. Which of the following should be the problem that receives the lowest priority?",
    "choice_a": "A fatal error that causes a single computer to fail",
    "choice_b": "A problem with a mission-critical backbone router that affects an entire network",
    "choice_c": "A problem with an application server that affects a single LAN",
    "choice_d": "A problem with an order entry or customer service call center resource that affects an entire department, with multiple local area networks (LANs)",
    "correct_answer": "A",
    "explanation": "A problem that affects the entire network should be given highest priority. This includes the issue with the mission-critical backbone router. Problems that affect multiple LANs or an entire department are generally given the next highest priority. A problem that affects a shared application server on a LAN should be given the next highest priority. Barring other seniority factors, a problem with a single user's computer should be given the lowest priority, compared to the other problems that have been reported.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      71,
      68,
      54,
      155,
      119
    ],
    "source": "9781394239306"
  },
  {
    "id": 1795,
    "question": "You are attempting to access a Domain Name System (DNS) server located on the other side of a router, but your attempt fails with an error stating that the destination port UDP 53 is unreachable. Your first step in troubleshooting the problem is to try using the <code>nslookup</code> utility to access that specific DNS server. This attempt also fails. Next, you use the <code>ping</code> utility with the DNS server's IP address. The ping test is successful, indicating that the server is up and running. Which of the following are possible causes of the problem? (Choose all that apply.)",
    "choice_a": "The TCP/IP host settings on your computer are improperly configured.",
    "choice_b": "The router connecting the networks is not running DNS and will not forward this type of datagram.",
    "choice_c": "There is a firewall blocking the DNS server's UDP port 53.",
    "choice_d": "The DNS process on the remote server is not running.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "One possible cause of the problem is that the DNS process on the remote server is corrupted or not running. Another possible cause is that there is a firewall blocking access to the DNS server's UDP port 53. Both of these would render the port unreachable. The TCP/IP client on the server is operating, as verified by the <code>ping</code> utility. This means that the IP host settings on your computer and on the DNS server are both configured properly and functioning. A router does not need to be running DNS to forward datagrams.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      127,
      119,
      68,
      121,
      125
    ],
    "source": "9781394239306",
    "choice_e": "The TCP/IP host settings on the DNS server are improperly configured."
  },
  {
    "id": 1796,
    "question": "Which of the following types of switch performs a cyclical redundancy check (CRC) on an entire frame's contents prior to forwarding it out a port leading to the destination system?",
    "choice_a": "Packet filtering",
    "choice_b": "Cut-through",
    "choice_c": "Source route",
    "choice_d": "Store-and-forward",
    "correct_answer": "D",
    "explanation": "Store-and-forward switches take in the entire frame and verify its contents by performing a CRC calculation before forwarding it. Cut-through switches are faster because they look at only the first 6 bytes (the destination media access control, or MAC, address) when forwarding a frame; they do not perform a CRC on the entire frame. Source route is a bridging technique in which the source host, not the switch, determines the path a frame will take through a network to reach a destination. Packet filtering is a technique used by firewalls. Neither of these is a type of switch.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      69,
      150,
      153,
      178,
      122
    ],
    "source": "9781394239306"
  },
  {
    "id": 1797,
    "question": "Which of the following attack types does not specifically target wireless network clients?",
    "choice_a": "Logic bomb",
    "choice_b": "Deauthentication",
    "choice_c": "Evil twin",
    "choice_d": "Rogue AP",
    "correct_answer": "A",
    "explanation": "A logic bomb is a code insert placed into a legitimate software product that triggers a malicious event when specific conditions are met. Therefore, it can affect both wired and wireless clients. The other options are all attacks directed at wireless networks. Deauthentication is a type of denial-of-service attack in which the attacker targets a wireless client by sending a deauthentication frame that causes the client to be disconnected from the network. The object of the attack is often to compel the client to connect to a rogue access point called an evil twin. An evil twin is a fraudulent access point on a wireless network that mimics the SSID of a legitimate access point, in the hope of luring in users. A rogue AP is a wireless access point that has been connected to a network by an intruder in the hope of luring users into connecting to it.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      316,
      310,
      321,
      348,
      322
    ],
    "source": "9781394239306"
  },
  {
    "id": 1798,
    "question": "You are having trouble installing a wireless LAN using IEEE 802.11n equipment in a new office complex. The wireless devices have trouble connecting to the access point, and when they do, they achieve only low speeds. When you use a Wi-Fi analyzer to scan the 2.4 GHz frequency band, you see literally dozens of other networks in the area, spread across all of the available channels. Which of the following tasks should you perform to enable your wireless devices to connect to the network reliably and at their best possible speeds?",
    "choice_a": "Configure the access point to suppress SSID broadcasts.",
    "choice_b": "Configure all of the wireless network devices to use the 5 GHz band.",
    "choice_c": "Upgrade all of the network devices to the latest firmware.",
    "choice_d": "Configure all of the network devices to use WPA3 encryption with AES.",
    "correct_answer": "B",
    "explanation": "Configuring the devices to use the 5 GHz band will provide many more channels to choose from and will avoid the interference from the surrounding 2.4 GHz networks. The other options will not resolve the problem. The type of encryption that a wireless network uses has no bearing on the ability of the devices to avoid the interference generated by surrounding networks. Suppressing SSID broadcasts will not help the devices to connect to the network. Upgrading the firmware on the devices is not likely to have any effect on the connection problems when they are the result of interference from other networks.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      180,
      205,
      203,
      37,
      40
    ],
    "source": "9781394239306"
  },
  {
    "id": 1799,
    "question": "Which Windows command-line utility produced the output shown here? <img src=\"/question_assets/Network+/pt_c7_69.png\"/>",
    "choice_a": "arp",
    "choice_b": "ping",
    "choice_c": "tracert",
    "choice_d": "netstat",
    "correct_answer": "A",
    "explanation": "Running the <code>arp</code> utility with the <code>-a</code> parameter on a Windows system displays the contents of the Address Resolution Protocol (ARP) cache, as shown here. The cache contains records of the IP addresses on the network that ARP has resolved into MAC addresses. The <code>ping</code>, <code>tracert</code>, and <code>netstat</code> utilities are not capable of producing this output.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      227,
      226,
      230,
      58,
      214
    ],
    "source": "9781394239306"
  },
  {
    "id": 1800,
    "question": "Your boss is working in the crawlspace under the floor of the datacenter, and he asks you to hand him the pliers. You hand him the tool shown in the following figure, and he throws it back at you. What is the real function of the tool shown in the figure? <img src=\"/question_assets/Network+/c07uf003.png\"/>",
    "choice_a": "When you connect the tool to pins in a punchdown block, you can access telephone circuits in order to test them or place telephone calls.",
    "choice_b": "When you attach the tool to one end of a wire, it generates a tone that can be detected at the other end.",
    "choice_c": "To attach a bulk cable end to an RJ-45 connector, you use the tool to squeeze the connector closed, forcing the wire ends to contact the connector's pins.",
    "choice_d": "When you attach the tool to a copper cable, you can detect and measure the electrical current flowing through it.",
    "correct_answer": "C",
    "explanation": "The device shown in the figure is a crimper, which is used to create patch cables by attaching connectors to both ends of a relatively short length of bulk cable. This tool is not capable of placing telephone calls, generating a tone on a wire, or measuring electric current.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      357,
      320,
      308,
      322,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1801,
    "question": "You are starting work for a contractor who performs telecommunications cable installations. One of the tools in the kit you have been given is unfamiliar to you. What is the name of the tool shown in the following figure? <img src=\"/question_assets/Network+/c07uf004.png\"/>",
    "choice_a": "Crimper",
    "choice_b": "Punchdown tool",
    "choice_c": "Butt set",
    "choice_d": "Toner and probe",
    "correct_answer": "B",
    "explanation": "The device shown in the figure is a punchdown tool, used to connect unshielded twisted-pair cable ends to the keystone connectors used in modular wall plates and patch panels. After lining up the individual wires in the cable with the connector, you use the tool to press each wire into its slot. The tool also cuts the wire sheath to make an electrical contact and trims the end of the wire. The tool shown is not a crimper, a butt set, or a toner and probe.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      52,
      53,
      71,
      151,
      68
    ],
    "source": "9781394239306"
  },
  {
    "id": 1802,
    "question": "You are seeking to upgrade your company's IEEE 802.11g access point to one that provides faster transmission speeds for your newer workstations. Which of the following wireless networking standards is capable of supporting speeds faster than the 54 Mbps of 802.11g but is still backward compatible with your existing IEEE 802.11g workstations?",
    "choice_a": "IEEE 802.11",
    "choice_b": "Bluetooth",
    "choice_c": "IEEE 802.11ac",
    "choice_d": "IEEE 802.11a",
    "correct_answer": "E",
    "explanation": "IEEE 802.11n supports transmission speeds up to 600 Mbps, and it is backward compatible with 802.11g equipment. IEEE 802.11ac is faster than 802.11g, but it is not backward compatible with 802.11g, because it can only use the 5 GHz band. Bluetooth is not compatible with any of the IEEE 802.11 standards. IEEE 802.11 and 802.11a cannot exceed the speed of 802.11n. 802.11a is also limited to the 5 GHz band and is not backward compatible with 802.11g.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      310,
      360,
      305,
      303,
      320
    ],
    "source": "9781394239306",
    "choice_e": "IEEE 802.11n"
  },
  {
    "id": 1803,
    "question": "You are working on your company's screened subnet (also known as a perimeter network), which has five Linux web servers, a Cisco router, a CSU/DSU providing a leased line connection, and a Windows-based firewall on it. While trying to troubleshoot a network communications failure, you type the following command on one of the systems: <code>traceroute</code> <a href=\"http://www.adatum.com\"><code>adatum.com</code></a>. Which of the following systems might you be working on? (Choose all that apply.)",
    "choice_a": "The Cisco router",
    "choice_b": "One of the Linux web servers",
    "choice_c": "The CSU/DSU console",
    "choice_d": "The Windows-based firewall",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Both Linux and the Cisco IOS operating systems include the <code>traceroute</code> utility. Windows has its own version of the utility, but it is called <code>tracert</code>. The CSU/DSU cannot run a <code>traceroute</code> command.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      55,
      216,
      257,
      234,
      255
    ],
    "source": "9781394239306"
  },
  {
    "id": 1804,
    "question": "Which of the following are network topologies used by IEEE 802.11 wireless local area networks (WLANs)? (Choose all that apply.)",
    "choice_a": "Bus",
    "choice_b": "Spine and leaf",
    "choice_c": "Ad hoc",
    "choice_d": "Star/hub and spoke",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "WLANs can use the ad hoc topology, in which devices communicate directly with each other, or the infrastructure topology, in which the wireless devices connect to an access point. The bus and star/hub and spoke topologies are used by wired networks only. Spine and leaf is a datacenter topology used for switches.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      190,
      187,
      186,
      207,
      57
    ],
    "source": "9781394239306",
    "choice_e": "Infrastructure"
  },
  {
    "id": 1805,
    "question": "Which version of the Simple Network Management Protocol (SNMP) uses as its security mechanism two separate unencrypted community strings?",
    "choice_a": "SNMPv1",
    "choice_b": "SNMPv2",
    "choice_c": "SNMPv2c",
    "choice_d": "SNMPv3",
    "correct_answer": "C",
    "explanation": "SNMP version 1 (SNMPv1), SNMP version 2 (SNMPv2), and SNMP version 2c (SNMPv2c) all rely on unencrypted community strings that are sent with GET requests as a security mechanism. However, SNMPv2c uses two separate community strings, one for read-write and one for read-only access. SNMP version 3 (SNMPv3) uses fully encrypted transmissions for more advanced security and does not use a community string.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      203,
      74,
      73,
      17,
      80
    ],
    "source": "9781394239306"
  },
  {
    "id": 1806,
    "question": "You are working the help desk at a local computer store, and you receive a call from a customer trying to set up a home network using computers running Windows 11 and wired Ethernet equipment. The customer reports that she cannot access the other two computers in the house from her workstation, nor can she access the Internet. You ask her to run the <code>ipconfig /all</code> command and read the results to you. She says that her IP address is 192.168.0.2, her subnet mask is 255.255.255.0, and her default gateway is 192.168.0.1. Which of the following is the most likely cause of the customer's problem?",
    "choice_a": "The customer's network address cannot include a zero.",
    "choice_b": "The customer has an incorrect subnet mask.",
    "choice_c": "The customer's network cable is damaged or unplugged.",
    "choice_d": "The customer has an incorrect default gateway address.",
    "correct_answer": "C",
    "explanation": "The customer's IP address, subnet mask, and default gateway values are appropriate for her home network. There is nothing wrong with having a zero in the network address. Therefore, of the options presented, the only logical choice is that the workstation's network cable is damaged or unplugged.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      303,
      330,
      313,
      320,
      311
    ],
    "source": "9781394239306"
  },
  {
    "id": 1807,
    "question": "Some networks are designed with a switching fabric that contains redundant paths for fault tolerance purposes. However, in this type of design it is possible for packets to circulate endlessly around the network, which is called a switching loop. Which of the following protocols prevents network switching loops from occurring by shutting down redundant links until they are needed?",
    "choice_a": "NAT",
    "choice_b": "RIP",
    "choice_c": "VLAN",
    "choice_d": "STP",
    "correct_answer": "D",
    "explanation": "The Spanning Tree Protocol (STP) prevents packets from endlessly looping from switch to switch due to redundant links. Creating redundant links is a good preventive measure against switch failure, but packets transmitted over multiple links can circulate from switch to switch infinitely. STP creates a database of switching links and shuts down the redundant ones until they are needed. None of the other three protocols listed can perform this function. Network address translation (NAT) is a routing method that enables private networks to share registered IP addresses. Routing Information Protocol (RIP) propagates routing table information to other routers. A virtual local area network (VLAN) is an organizational tool that operates within switches by creating multiple broadcast domains.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      154,
      315,
      317,
      353,
      176
    ],
    "source": "9781394239306"
  },
  {
    "id": 1808,
    "question": "You are responsible for an internetwork that consists of four internal local area networks (LANs) with 50 users each. Each internal LAN uses twisted-pair Gigabit Ethernet links that connect the users to a switch. Each of the four switches is connected to a separate router. All four routers connect to the same backbone network, which has a single additional router to connect the company's network to the Internet using a T-1 wide area network (WAN) link. Today, users on one of the four internal LANs are reporting that when they came in this morning, they could not access the Internet or resources on the other three internal LANs. However, they could access resources on their own LAN with no problems. Which network component is the likeliest source of the problem in this scenario?",
    "choice_a": "The switch on the problem LAN",
    "choice_b": "The Internet router",
    "choice_c": "The router connecting the problem LAN to the backbone",
    "choice_d": "The cable on the backbone network",
    "correct_answer": "C",
    "explanation": "In this scenario, only the users on one LAN are experiencing problems connecting to the Internet and the other internal LANs. This isolates the problem to a component within that LAN only. Since users can connect successfully to local resources, the problem does not lie within the individual computers, the switch that connects the users to the network, or the backbone network cable. Therefore, the likeliest problem is in the router connecting the problem LAN to the backbone network. Since users on the other internal LANs are not reporting problems connecting to the Internet, the problem most likely does not involve the Internet router.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      255,
      226,
      231,
      234,
      238
    ],
    "source": "9781394239306"
  },
  {
    "id": 1809,
    "question": "You are negotiating an agreement with a provider for your company's email service. You have been told to require a 99.99 percent guaranteed rate of service reliability, but the provider is only willing to guarantee 99 percent. Eventually, you and the provider agree on a compromise of 99.9 percent. Which of the following documents will include the negotiated language on this particular point?",
    "choice_a": "AUP",
    "choice_b": "SLA",
    "choice_c": "BYOD",
    "choice_d": "NDA",
    "correct_answer": "B",
    "explanation": "The agreed upon 99.9 percent guaranteed availability will be part of a service-level agreement (SLA), which is a contract between a provider and a subscriber that specifies the percentage of time that the contracted services are available. None of the other three options contain the guaranteed reliability language. Acceptable use policies (AUP) specify whether and how employees can use company-owned hardware and software resources. A nondisclosure agreement (NDA) specifies what company information employees are permitted to discuss outside the company. A bring your own device (BYOD) policy specifies the personal electronics that employees are permitted to use on the company network and documents the procedures for connecting and securing them.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      65,
      192,
      206,
      168,
      165
    ],
    "source": "9781394239306"
  },
  {
    "id": 1810,
    "question": "Which of the following networking devices can split a single network into multiple collision domains while maintaining a single broadcast domain? (Choose all that apply.)",
    "choice_a": "Switch",
    "choice_b": "Bridge",
    "choice_c": "Router",
    "choice_d": "Firewall",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "A switch creates a separate collision domain for each port. A bridge can split a single network into two collision domains because it forwards only the packets that are destined for the other side of the bridge. Both bridges and switches forward all broadcast packets, so they maintain a single broadcast domain for the entire network. A firewall does not affect the collision and broadcast domain configuration of the network. A router creates two collision domains, but it does not forward broadcasts, so it creates two broadcast domains as well.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      53,
      71,
      66,
      69,
      155
    ],
    "source": "9781394239306"
  },
  {
    "id": 1811,
    "question": "You have just finished installing a web server farm on your company's network, along with a router to create a screened subnet (perimeter network) on which the web servers are located. However, you now cannot access the web servers from your workstation on the internal network. Which of the following is not one of the tasks you will have to complete before you can access the screened subnet from the internal network?",
    "choice_a": "Change MAC addresses.",
    "choice_b": "Change IP addresses.",
    "choice_c": "Update the DNS records.",
    "choice_d": "Change default gateway addresses.",
    "correct_answer": "A",
    "explanation": "MAC addresses are hard-coded into network interface adapters and are not easily changeable. There is also no need to change them for this purpose. First, you will have to change IP addresses of the web servers. This is because the computers on the other side of the router, on the screened subnet, must use an IP network address that is different from the internal network's address. Next, you will have to change the default gateway address setting on the internal network computers to the address of the router on the internal network so that traffic can be forwarded to the screened subnet. Finally, you will have to update the resource records on your DNS server to reflect the IP address changes.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      114,
      113,
      36,
      42,
      116
    ],
    "source": "9781394239306"
  },
  {
    "id": 1812,
    "question": "You are testing a twisted-pair cable run using a toner and probe. When you apply the toner to a particular pin at one end of the cable, you detect a tone on two pins at the other end. Which of the following faults have you discovered?",
    "choice_a": "Split pair",
    "choice_b": "Open",
    "choice_c": "Short",
    "choice_d": "Crosstalk",
    "correct_answer": "C",
    "explanation": "A short is when a wire is connected to two or more pins at one end of the cable or when the conductors of two or more wires are touching inside the cable. This would cause a tone applied to a single pin at one end to be heard on multiple pins at the other end. The other three options would not cause this to occur. An open circuit would manifest as a failure to detect a tone on a wire, indicating that there is either a break in the wire somewhere inside the cable or a bad connection with the pin in one or both connectors. A split pair is a connection in which two wires are incorrectly mapped in exactly the same way on both ends of the cable. Crosstalk is a type of interference caused by signals on one wire bleeding over to other wires.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      52,
      53,
      150,
      71,
      152
    ],
    "source": "9781394239306"
  },
  {
    "id": 1813,
    "question": "Your network has been experiencing intermittent service slowdowns and outages ever since the company moved into their new building. You have tried every troubleshooting modality you can think of, but you have not been able to determine the cause. One particular user, perhaps hoping to be the squeaky wheel that gets the grease, has taken to calling you every time he experiences a problem. One day, as you are working in the datacenter, you notice that the user calls every time you hear an additional humming noise. After examining the doors in the hallway, you realize that the racks containing the network switches are located right next to the elevator machinery room. Which of the following conditions is probably causing this intermittent network communication problem?",
    "choice_a": "Bottleneck",
    "choice_b": "EMI",
    "choice_c": "Latency",
    "choice_d": "Crosstalk",
    "correct_answer": "B",
    "explanation": "Elevator machinery, fluorescent light fixtures, and other electrical devices in an office environment can generate magnetic fields, resulting in electromagnetic interference (EMI). When copper-based cables are located too near to such a device, the magnetic fields can generate an electric current on the cable that interferes with the signals exchanged by network devices. If the network users experience a problem every time the elevator machinery switches on, EMI is a likely cause of the problem. Crosstalk and attenuation can both cause intermittent network communication problems, but they cannot be caused by elevator machinery. Latency describes a generalized delay in network transmissions, not intermittent packet delays.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      193,
      65,
      51,
      70,
      136
    ],
    "source": "9781394239306"
  },
  {
    "id": 1814,
    "question": "Ralph is installing a pair of redundant servers and must choose whether to run them in an active-active or active-passive configuration. Running the servers in an active-active configuration provides which of the following advantages that the same servers in an active-passive configuration do not? (Choose all that apply.)",
    "choice_a": "Fault tolerance",
    "choice_b": "Load balancing",
    "choice_c": "Data encapsulation",
    "choice_d": "Increased performance",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "In an active-active configuration, servers can balance the incoming client load between them. Because the active servers are all servicing clients, the overall performance of the cluster is increased. Both active-active and active-passive configurations provide fault tolerance. Data encapsulation is not a factor in either configuration.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      281,
      282,
      296,
      101,
      20
    ],
    "source": "9781394239306"
  },
  {
    "id": 1815,
    "question": "You are starting work at a new company, and on your first day you ask about wireless access for your laptop. You are given an SSID and a WPA3 passphrase. Later, in the lunchroom, when you try to connect your laptop to the network, you cannot see the SSID you were given in the list of available networks, although you can see other networks. What should you do first to try to resolve the problem?",
    "choice_a": "Move closer to the wireless access point.",
    "choice_b": "Move away from the microwave in the lunchroom.",
    "choice_c": "Type in the WPA3 passphrase.",
    "choice_d": "Type the SSID in manually.",
    "correct_answer": "D",
    "explanation": "It is possible that the wireless access point has been configured not to broadcast the network's SSID as a security measure, so you should first attempt to access it by typing the SSID in manually. You cannot type in the WPA3 passphrase until you are in the process of connecting to the SSID. Moving the laptop closer to the access point or away from possible sources of electromagnetic interference might be solutions to the problem, but they should not be the first things you try in this case.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      205,
      203,
      17,
      36,
      83
    ],
    "source": "9781394239306"
  },
  {
    "id": 1816,
    "question": "You are responsible for a wireless LAN that consists of an 802.11n 2x2 access point and laptop computers with a variety of network adapters. Some of the laptops support 802.11n, and a few older models have 802.11g adapters. The wireless LAN is located in a large office building with many other wireless networks, and you are having trouble finding a channel on the 2.4 GHz band that is not congested with traffic. Scanning the 5 GHz band, you find relatively little traffic, so you reconfigure the access point to use a 5 GHz channel. The result is that some of the laptops are able to connect to the network, whereas others are not. What is the most likely reason for the connection failures, and what must you do to enable all the laptops to connect to the wireless network?",
    "choice_a": "The 802.11g standard does not support communication using the 5 GHz band. You must replace the network adapters in those laptops with newer models for them to connect successfully.",
    "choice_b": "The 5 GHz band does not support automatic channel selection. You must configure each laptop to use the same channel as the access point for all the laptops to connect successfully.",
    "choice_c": "The 5 GHz band does not support MIMO communications, so the 802.11n laptops are unable to connect to the network. You must replace the access point with an 802.11g unit for all the laptops to connect successfully.",
    "choice_d": "The 802.11g standard does not support communication using the 5 GHz band. You must configure the access point to support 2.4 GHz for all the laptops to connect successfully.",
    "correct_answer": "D",
    "explanation": "The 802.11g standard does not support 5 GHz communications, only the 2.4 GHz band. Configuring the access point to support 2.4 GHz is the only way for the 802.11g computers to connect to the network. The 5 GHz band does support automatic channel selection, so there is no need to configure the channel on each laptop manually. The 5 GHz band does support MIMO, and the 802.11n laptops should be able to connect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      183,
      184,
      185,
      188,
      196
    ],
    "source": "9781394239306"
  },
  {
    "id": 1817,
    "question": "In the Domain Name System (DNS), a zone is a contiguous area of the DNS namespace for which authority is delegated to one or more DNS servers. Which of the following DNS resource record types specifies the IP addresses of the authoritative DNS servers for a particular zone?",
    "choice_a": "PTR",
    "choice_b": "SRV",
    "choice_c": "MX",
    "choice_d": "NS",
    "correct_answer": "D",
    "explanation": "The name server (NS) resource record identifies the authoritative servers for a particular DNS zone. Pointer (PTR) resource records are used to resolve IP addresses into hostnames. Mail exchange (MX) records identify the mail servers for a particular domain. Service locator (SRV) records identify the designated servers for a particular application. None of these other options identify the authoritative servers for a zone.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      76,
      78,
      36,
      72,
      1
    ],
    "source": "9781394239306"
  },
  {
    "id": 1818,
    "question": "You are experiencing poor performance on your home 802.11n wireless network. You live in a large apartment complex, and when you run a Wi-Fi analyzer, you see many other nearby networks using the often-recommended channels 1, 6, and 11 on the 2.4 GHz frequency. Using the 5 GHz frequency is not an option for your equipment. What should you do to improve the network's performance?",
    "choice_a": "Configure your equipment to use channel 10.",
    "choice_b": "Configure your equipment to use channel 9.",
    "choice_c": "Configure your equipment to use channel 5.",
    "choice_d": "Configure your equipment to use channel 2.",
    "correct_answer": "B",
    "explanation": "The 2.4 GHz band used by wireless LANs (WLANs) consists of channels that are 20 (or 22) MHz wide. However, the channels are only 5 MHz apart, so there is channel overlap that can result in interference. Channels 1, 6, and 11 are the only channels that are far enough apart from each other to avoid any overlap with the adjacent channels. This is why they are often recommended. However, in this scenario, these channels are too crowded with other networks. So, you should use a channel that is as far as possible from the crowded ones. Channels 2, 5, and 10 are all immediately adjacent to a crowded channel, but channel 9 is at least two channels away from the nearest crowded channel. Therefore, you should configure your equipment to use channel 9.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      180,
      24,
      37,
      40,
      11
    ],
    "source": "9781394239306"
  },
  {
    "id": 1819,
    "question": "Your company's office building is having a fire inspection, and you are the only person on duty in the datacenter. The inspector from the fire department is reviewing the company's asset inventory and asks you where they can find documentation about all chemicals and equipment used in the company's datacenter. You lead the inspector to the director's office, but you are not sure what the documents he needs are called. Which of the following document types contains this information?",
    "choice_a": "MSDS",
    "choice_b": "ESD",
    "choice_c": "NDA",
    "choice_d": "BYOD",
    "correct_answer": "A",
    "explanation": "Material safety data sheets (MSDSs) are documents created by manufacturers of chemical, electrical, and mechanical products that specify the potential risks and dangers associated with them, particularly in regard to flammability and the possibility of toxic outgassing. A properly documented network should have MSDS documents on file for all of the chemical and hardware products used to build and maintain it. MSDSs can be obtained from manufacturers or the Environmental Protection Agency (EPA). Electrostatic discharges (ESDs), nondisclosure agreements (NDAs), and bring your own device (BYOD) policies are not concerned with the dangers inherent in building contents.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      322,
      311,
      307,
      320,
      325
    ],
    "source": "9781394239306"
  },
  {
    "id": 1820,
    "question": "Which of the following Power over Ethernet (PoE) specifications supplies power to devices using the spare wire pair on a 100Base-TX twisted-pair network?",
    "choice_a": "Alternative A",
    "choice_b": "4PPoE",
    "choice_c": "Alternative B",
    "choice_d": "All of the above",
    "correct_answer": "C",
    "explanation": "The Alternative B PoE variant can use the spare wire pair in a 100Base-TX cable to supply power to connected devices. The Alternative A and 4PPoE variants cannot use the spare wire pair in this manner; they supply power using the wire pairs that carry data at the same time. For Gigabit Ethernet or faster installations, Alternative B is also capable of using the data wire pairs.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      356,
      323,
      358,
      320,
      154
    ],
    "source": "9781394239306"
  },
  {
    "id": 1821,
    "question": "Which of the following statements about the differences between storage area networks (SANs) and network attached storage (NAS) are not true? (Choose all that apply.)",
    "choice_a": "NAS devices typically provide a filesystem, whereas SAN devices do not.",
    "choice_b": "NAS devices typically contain integrated iSCSI targets.",
    "choice_c": "NAS provides file-level storage access, whereas SAN provides block-level storage access.",
    "choice_d": "SAN devices have an operating system, whereas NAS devices do not.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "A storage area network (SAN) is a separate network dedicated to shared storage devices, while NAS devices are self-contained file servers that connect directly to a standard IP network NAS devices are typically not iSCSI targets. A NAS device provides file-level access to its storage devices and includes an operating system and a filesystem. SAN devices typically do not have operating systems.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      266
    ],
    "source": "9781394239306"
  },
  {
    "id": 1822,
    "question": "You are deploying an 802.11n wireless network for a client who is asking for the best possible security you can provide without deploying additional servers. When setting up the wireless access point, you disable SSID broadcasts, select Wi-Fi Protected Access Preshared Keys (WPA-PSK), and configure MAC address filtering. Which of the following statements about the security of this arrangement is true?",
    "choice_a": "You should not disable SSID broadcasts, because this prevents users from connecting to the network.",
    "choice_b": "The configuration is as secure as you can make it with the specified equipment.",
    "choice_c": "You should use Wi-Fi Protected Access 3 (WPA3) instead of WPA, since it is more resistant to certain types of attacks.",
    "choice_d": "You should not use MAC address filtering, because it exposes MAC addresses to possible attacks.",
    "correct_answer": "C",
    "explanation": "WPA has been found to be vulnerable, and WPA3 was designed to address those vulnerabilities, so you should use WPA3 instead of WPA. Suppressing SSID broadcasts does not prevent users from connecting to the network, and MAC filtering strengthens security without exposing MAC addresses to undue risk.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      180,
      205,
      203,
      36,
      42
    ],
    "source": "9781394239306"
  },
  {
    "id": 1823,
    "question": "Which of the following connector types are used with fiber-optic cables? (Choose all that apply.)",
    "choice_a": "DB-9",
    "choice_b": "SC",
    "choice_c": "BNC",
    "choice_d": "ST",
    "correct_answer": [
      "B",
      "D",
      "E"
    ],
    "explanation": "Subscriber Connector (SC), Multi-fiber Push On (MPO), and Straight Tip (ST) are all types of fiber-optic connectors. DB-9 is a D-shell connector used for serial ports. Bayonet Neill-Concelman (BNC) is a type of connector used with coaxial cable. RJ-11 is used with twisted-pair cable for telephone connections.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      216,
      254,
      253,
      251,
      240
    ],
    "source": "9781394239306",
    "choice_e": "MPO",
    "choice_f": "RJ-11"
  },
  {
    "id": 1824,
    "question": "You are designing an Ethernet network for your company's newest branch office. Your current task is to decide which Ethernet specification to use for the network, a decision that you know will determine what type of cabling you need to purchase and the topology with which the cable will be installed. Which layers of the Open Systems Interconnection (OSI) reference model apply to the cabling and topology elements of a network?",
    "choice_a": "The Application and Transport layers",
    "choice_b": "The Transport and Network layers",
    "choice_c": "The Network and Data link layers",
    "choice_d": "The Data link and Physical layers",
    "correct_answer": "D",
    "explanation": "The Physical layer defines the mechanical and electrical characteristics of the cables used to build a network. The Data link layer defines specific network (LAN or WAN) topologies and their characteristics. The Physical layer specification you will implement is dependent on the Data link layer protocol you select. The Network, Transport, and Application layers are not concerned with cables and topologies.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      17,
      44,
      7,
      11
    ],
    "source": "9781394239306"
  },
  {
    "id": 1825,
    "question": "You are troubleshooting a workstation that cannot access the network. The workstation is plugged into a wall plate that should provide it with access to a DHCP-equipped network using the 192.168.4.0/24 network address. No one else on that network is reporting a problem. You check that the patch cable is properly plugged into the workstation and the wall plate, which it is, and then run <code>ipconfig /all</code> on the workstation and examine the output. Which of the following could be the explanation for the workstation's problem, based on the following <code>ipconfig</code> results? <img src=\"/question_assets/Network+/pt_c7_96.png\"/>",
    "choice_a": "The DNS server addresses are incorrect.",
    "choice_b": "The Default Gateway address is missing.",
    "choice_c": "The Subnet Mask value is incorrect.",
    "choice_d": "The DHCP scope is exhausted.",
    "correct_answer": "D",
    "explanation": "The 169.254.203.42 address assigned to the workstation is from the 169.254.0.0/16 network address assigned to Automatic Private IP Addressing (APIPA), a standard for the assignment of IP addresses to DHCP clients when they cannot obtain an address from a DHCP server. The workstation's DHCP client is activated, and since no one else is experiencing a problem, you can assume that the DHCP server is functioning. The Subnet Mask value is correct for an APIPA address, and APIPA does not provide Default Gateway or DNS server addresses. Therefore, an exhausted DHCP scope is the only one of the explanations provided that could be the cause of the problem.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      75,
      113,
      114,
      103,
      111
    ],
    "source": "9781394239306"
  },
  {
    "id": 1826,
    "question": "A user calls you at the IT help desk and reports that she is having intermittent problems accessing both local servers and Internet websites. Which of the following potential problems can you rule out immediately?",
    "choice_a": "Malfunctioning DNS server",
    "choice_b": "Duplicate MAC addresses",
    "choice_c": "Duplicate IP addresses",
    "choice_d": "Malfunctioning router",
    "correct_answer": "C",
    "explanation": "Operating systems detect duplicate IP addresses immediately and display error messages or notifications on the computers involved. Therefore, the user with the problem would have been informed immediately if another system were using her IP address. All of the other options are possible causes of the problem that are more difficult to troubleshoot.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      79,
      111,
      114,
      84,
      36
    ],
    "source": "9781394239306"
  },
  {
    "id": 1827,
    "question": "You have recently discovered a rogue DHCP server on your network. After disabling the rogue server, you now need to terminate all of the rogue IP address leases currently held by DHCP clients on the network and then have them request new leases from the authorized DHCP server. Which of the following commands must you run on each client to do this? (Choose all that apply.)",
    "choice_a": "ipconfig /dump",
    "choice_b": "ipconfig /lease",
    "choice_c": "ipconfig /release",
    "choice_d": "ipconfig /renew",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The <code>ipconfig /release</code> command terminates the current DHCP address lease. Then, the <code>ipconfig /renew</code> command causes the client to begin the process of negotiating a new lease, this time with the authorized DHCP server. <code>Dump</code>, <code>lease</code>, and <code>discard</code> are not valid <code>ipconfig</code> parameters.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      75,
      113,
      111,
      36,
      83
    ],
    "source": "9781394239306",
    "choice_e": "ipconfig /discard"
  },
  {
    "id": 1828,
    "question": "Ralph is reading an article about datacenter design, and he is puzzled by references to east-west and north-south traffic. Which of the following statements best describes the difference between east-west and north-south traffic in a datacenter?",
    "choice_a": "East-west is switch-to-switch traffic, while north-south is switch-to-router traffic.",
    "choice_b": "East-west describes traffic between devices at the same layer of the Open Systems Interconnection (OSI) reference model, while north-south describes traffic between OSI model layers.",
    "choice_c": "East-west traffic stays within the datacenter, while north-south traffic does not.",
    "choice_d": "East-west is backbone traffic among switches and routers, while north-south is traffic to end systems, such as servers.",
    "correct_answer": "C",
    "explanation": "East-west traffic describes traffic flow within the datacenter, while north-south is traffic between devices inside the datacenter and outside devices. The terms <i>east-west</i> and <i>north-south</i> do not pertain to the OSI model layers or to the specific devices used.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      14,
      295,
      298,
      2,
      10
    ],
    "source": "9781394239306"
  },
  {
    "id": 1829,
    "question": "Which of the following Windows command-line utilities produced the output shown here? <img src=\"/question_assets/Network+/pt_c7_100.png\"/>",
    "choice_a": "arp",
    "choice_b": "ping",
    "choice_c": "tracert",
    "choice_d": "netstat",
    "correct_answer": "D",
    "explanation": "Running the Windows <code>netstat</code> utility with no parameters generates a list of the workstation's active connections, as shown here. The <code>arp</code>, <code>ping</code>, <code>tracert</code>, and <code>hostname</code> utilities are not capable of producing this output.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      112,
      1,
      82,
      72,
      40
    ],
    "source": "9781394239306",
    "choice_e": "hostname"
  }
];
